import { capitalize, slugify } from "Utils/text"

const constants = {};
const displayLookup = {};
const colorLookup = {};
const colorNameLookup = {};

export function getDisplay(name, value, options = null) {
  const { capitalize: capitalizeParam = true, slugify: slugifyParam = false } = options || {};
  if (value == null) return null;
  const label = displayLookup[`${name}.${JSON.stringify(value)}`] || value;
  if (process.env.NODE_ENV === 'development' && !label) {
    throw new Error(`Invalid constant display lookup: ${name} with value: ${value}`);
  }
  let result = Array.isArray(label) ? window.django.pgettext(...label) : window.django.gettext(label);
  if (result && capitalizeParam) {
    result = capitalize(result);
  }
  if (result && slugifyParam) {
    result = slugify(result);
  }
  return result;
}

export function getConstantName(name, value, full=false) {
  if (value == null) return null;
  const def = constants[name];
  if (!def) {
    if (process.env.NODE_ENV === 'development') {
      throw new Error(`Invalid constant lookup: ${name}`);
    }
    return null
  }
  const constantName = Object.entries(def).find(([key, val]) => val.value === value)?.[0];
  if (!constantName) {
    if (process.env.NODE_ENV === 'development') {
      throw new Error(`Invalid constant lookup: ${name}`);
    }
    return null
  }
  if (full) {
    return [name, constantName].join('_');
  }
  return constantName;
}

export function getColor(name, value) {
  if (value == null) return null;
  return colorLookup[`${name}.${JSON.stringify(value)}`];
}
export function getColorName(name, value) {
  if (value == null) return null;
  const colorName = colorNameLookup[`${name}.${JSON.stringify(value)}`];
  if (process.env.NODE_ENV === 'development' && !colorName) {
    throw new Error(`Invalid constant display lookup: ${name} with value: ${value}`);
  }
  return colorName;
}
export function getColorPaletteName(name, value) {
  if (value == null) return null;
  const colorName = colorNameLookup[`${name}.${JSON.stringify(value)}`];
  if (process.env.NODE_ENV === 'development' && !colorName) {
    throw new Error(`Invalid constant display lookup: ${name} with value: ${value}`);
  }
  return {
    RED: 'error',
    BLUE: 'info',
    GREEN: 'success',
    GREY: 'neutral',
    YELLOW: 'warning',
  }[colorName];
}

export function parseConstant(name, rawValue) {
  const def = constants[name];
  if (process.env.NODE_ENV === 'development' && !def) {
    throw new Error(`Invalid constant lookup: ${name}`);
  }
  return Object.values(def || {}).find(x => x.value == rawValue)?.value;
}

export function getOptions(name, options = null) {
  const {
    only = null,
    exclude = null,
    optionValue = 'id',
    optionDisplay = 'name',
    optionColor = 'color',
    capitalize: capitalizeParam = true,
    sort = false,
  } = options || {};

  const def = constants[name];
  if (process.env.NODE_ENV === 'development' && !def) {
    throw new Error(`Invalid constant options lookup: ${name}`);
  }
  if (!def) return [];
  return Object.values(def).filter(
    (valueDef) => (
      (!only || (typeof only === "function" ? only(valueDef.value) : only.includes(valueDef.value)))
      && (!exclude || !(typeof exclude === "function" ? exclude(valueDef.value) : exclude.includes(valueDef.value)))
    ),
  ).map(
    (valueDef) => ({
      [optionValue]: valueDef.value,
      [optionDisplay]: getDisplay(name, valueDef.value, { capitalize: capitalizeParam }),
      [optionColor]: getColor(name, valueDef.value),
    }),
  ).sort((a, b) => {
    if (sort) {
      return a[optionDisplay].localeCompare(b[optionDisplay]);
    }
    return 0;
  });
}

export function getValues(name, options = null) {
  const {
    only = null,
  } = options || {};
  const def = constants[name];
  if (process.env.NODE_ENV === 'development' && !def) {
    throw new Error(`Invalid constant options lookup: ${name}`);
  }
  if (!def) return [];
  return Object.values(def).filter(
    (valueDef) => !only || only.includes(valueDef.value),
  ).map(
    ({ value }) => value
  )
}

export default constants;

// --- AUTO GENERATED BY constants.py ---

constants.ABC_CLASS = {
  A: { color: "#66bb6a", label: null, value: "A" },
  B: { color: "#ffb74d", label: null, value: "B" },
  C: { color: "#e57373", label: null, value: "C" }
};
constants.ABC_CLASS_A = "A";
colorLookup['ABC_CLASS."A"'] = "#66bb6a";
colorNameLookup['ABC_CLASS."A"'] = "GREEN";
constants.ABC_CLASS_B = "B";
colorLookup['ABC_CLASS."B"'] = "#ffb74d";
colorNameLookup['ABC_CLASS."B"'] = "YELLOW";
constants.ABC_CLASS_C = "C";
colorLookup['ABC_CLASS."C"'] = "#e57373";
colorNameLookup['ABC_CLASS."C"'] = "RED";

constants.ABC_XYZ_CLASS = {
  AX: { color: "#66bb6a", label: null, value: "AX" },
  AY: { color: "#ffb74d", label: null, value: "AY" },
  AZ: { color: "#e57373", label: null, value: "AZ" },
  BX: { color: "#ffb74d", label: null, value: "BX" },
  BY: { color: "#ffb74d", label: null, value: "BY" },
  BZ: { color: "#e57373", label: null, value: "BZ" },
  CX: { color: "#e57373", label: null, value: "CX" },
  CY: { color: "#e57373", label: null, value: "CY" },
  CZ: { color: "#e57373", label: null, value: "CZ" }
};
constants.ABC_XYZ_CLASS_AX = "AX";
colorLookup['ABC_XYZ_CLASS."AX"'] = "#66bb6a";
colorNameLookup['ABC_XYZ_CLASS."AX"'] = "GREEN";
constants.ABC_XYZ_CLASS_AY = "AY";
colorLookup['ABC_XYZ_CLASS."AY"'] = "#ffb74d";
colorNameLookup['ABC_XYZ_CLASS."AY"'] = "YELLOW";
constants.ABC_XYZ_CLASS_AZ = "AZ";
colorLookup['ABC_XYZ_CLASS."AZ"'] = "#e57373";
colorNameLookup['ABC_XYZ_CLASS."AZ"'] = "RED";
constants.ABC_XYZ_CLASS_BX = "BX";
colorLookup['ABC_XYZ_CLASS."BX"'] = "#ffb74d";
colorNameLookup['ABC_XYZ_CLASS."BX"'] = "YELLOW";
constants.ABC_XYZ_CLASS_BY = "BY";
colorLookup['ABC_XYZ_CLASS."BY"'] = "#ffb74d";
colorNameLookup['ABC_XYZ_CLASS."BY"'] = "YELLOW";
constants.ABC_XYZ_CLASS_BZ = "BZ";
colorLookup['ABC_XYZ_CLASS."BZ"'] = "#e57373";
colorNameLookup['ABC_XYZ_CLASS."BZ"'] = "RED";
constants.ABC_XYZ_CLASS_CX = "CX";
colorLookup['ABC_XYZ_CLASS."CX"'] = "#e57373";
colorNameLookup['ABC_XYZ_CLASS."CX"'] = "RED";
constants.ABC_XYZ_CLASS_CY = "CY";
colorLookup['ABC_XYZ_CLASS."CY"'] = "#e57373";
colorNameLookup['ABC_XYZ_CLASS."CY"'] = "RED";
constants.ABC_XYZ_CLASS_CZ = "CZ";
colorLookup['ABC_XYZ_CLASS."CZ"'] = "#e57373";
colorNameLookup['ABC_XYZ_CLASS."CZ"'] = "RED";

constants.AI_TYPE = {
  OPENAI: { color: null, label: "OpenAI", value: "openai" },
  GEMINI: { color: null, label: "Gemini", value: "gemini" }
};
constants.AI_TYPE_OPENAI = "openai";
displayLookup['AI_TYPE."openai"'] = "OpenAI";
constants.AI_TYPE_GEMINI = "gemini";
displayLookup['AI_TYPE."gemini"'] = "Gemini";

constants.AUTOMATISM_FILE_SHARE_FORMAT = {
  XLSX: { color: null, label: true, value: "xlsx" },
  CSV: { color: null, label: true, value: "csv" },
  JSON: { color: null, label: true, value: "json" }
};
constants.AUTOMATISM_FILE_SHARE_FORMAT_XLSX = "xlsx";
displayLookup['AUTOMATISM_FILE_SHARE_FORMAT."xlsx"'] = "xlsx";
constants.AUTOMATISM_FILE_SHARE_FORMAT_CSV = "csv";
displayLookup['AUTOMATISM_FILE_SHARE_FORMAT."csv"'] = "csv";
constants.AUTOMATISM_FILE_SHARE_FORMAT_JSON = "json";
displayLookup['AUTOMATISM_FILE_SHARE_FORMAT."json"'] = "json";

constants.AUTOMATISM_TRIGGER_TYPE = {
  ORDER_EVENT_CREATED: { color: null, label: "order event", value: 1 },
  RESOURCE_EVENT_CREATED: { color: null, label: "resource event", value: 2 },
  TASK_CREATED_OR_UPDATED: { color: null, label: true, value: 3 }
};
constants.AUTOMATISM_TRIGGER_TYPE_ORDER_EVENT_CREATED = 1;
displayLookup['AUTOMATISM_TRIGGER_TYPE.1'] = "order event";
constants.AUTOMATISM_TRIGGER_TYPE_RESOURCE_EVENT_CREATED = 2;
displayLookup['AUTOMATISM_TRIGGER_TYPE.2'] = "resource event";
constants.AUTOMATISM_TRIGGER_TYPE_TASK_CREATED_OR_UPDATED = 3;
displayLookup['AUTOMATISM_TRIGGER_TYPE.3'] = "task created or updated";

constants.AUTOMATISM_TYPE = {
  TRIGGER: { color: null, label: true, value: 1 },
  PERIODIC: { color: null, label: true, value: 2 },
  WEBHOOK: { color: null, label: true, value: 3 },
  MANUAL: { color: null, label: true, value: 4 }
};
constants.AUTOMATISM_TYPE_TRIGGER = 1;
displayLookup['AUTOMATISM_TYPE.1'] = "trigger";
constants.AUTOMATISM_TYPE_PERIODIC = 2;
displayLookup['AUTOMATISM_TYPE.2'] = "periodic";
constants.AUTOMATISM_TYPE_WEBHOOK = 3;
displayLookup['AUTOMATISM_TYPE.3'] = "webhook";
constants.AUTOMATISM_TYPE_MANUAL = 4;
displayLookup['AUTOMATISM_TYPE.4'] = "manual";

constants.BALANCE_BASE_ITEM_TYPE = {
  ORDER: { color: null, label: [true], value: 1 },
  OUTBOUND_INVOICE: { color: null, label: [true], value: 2 },
  INBOUND_INVOICE: { color: null, label: [true], value: 3 },
  SHIPMENT: { color: null, label: [true], value: 4 }
};
constants.BALANCE_BASE_ITEM_TYPE_ORDER = 1;
displayLookup['BALANCE_BASE_ITEM_TYPE.1'] = ["balance base item type", "order"];
constants.BALANCE_BASE_ITEM_TYPE_OUTBOUND_INVOICE = 2;
displayLookup['BALANCE_BASE_ITEM_TYPE.2'] = ["balance base item type", "outbound invoice"];
constants.BALANCE_BASE_ITEM_TYPE_INBOUND_INVOICE = 3;
displayLookup['BALANCE_BASE_ITEM_TYPE.3'] = ["balance base item type", "inbound invoice"];
constants.BALANCE_BASE_ITEM_TYPE_SHIPMENT = 4;
displayLookup['BALANCE_BASE_ITEM_TYPE.4'] = ["balance base item type", "shipment"];

constants.BALANCE_STATUS = {
  PAYABLE: { color: "#e57373", label: ["balance status", "payable"], value: -1 },
  SETTLED: { color: "#64b5f6", label: ["balance status", "settled"], value: 0 },
  RECEIVABLE: { color: "#66bb6a", label: ["balance status", "receivable"], value: 1 }
};
constants.BALANCE_STATUS_PAYABLE = -1;
displayLookup['BALANCE_STATUS.-1'] = ["balance status", "payable"];
colorLookup['BALANCE_STATUS.-1'] = "#e57373";
colorNameLookup['BALANCE_STATUS.-1'] = "RED";
constants.BALANCE_STATUS_SETTLED = 0;
displayLookup['BALANCE_STATUS.0'] = ["balance status", "settled"];
colorLookup['BALANCE_STATUS.0'] = "#64b5f6";
colorNameLookup['BALANCE_STATUS.0'] = "BLUE";
constants.BALANCE_STATUS_RECEIVABLE = 1;
displayLookup['BALANCE_STATUS.1'] = ["balance status", "receivable"];
colorLookup['BALANCE_STATUS.1'] = "#66bb6a";
colorNameLookup['BALANCE_STATUS.1'] = "GREEN";

constants.BANK_ACCOUNT_TYPE = {
  ERSTE: { color: null, label: [true], value: 1 },
  K_AND_H: { color: null, label: [true], value: 2 },
  PAYPAL: { color: null, label: [true], value: 3 },
  OTP: { color: null, label: [true], value: 4 },
  CIB: { color: null, label: [true], value: 5 },
  UNI_CREDIT: { color: null, label: [true], value: 6 },
  BUDAPEST_BANK: { color: null, label: [true], value: 7 },
  MAGNETBANK: { color: null, label: [true], value: 8 },
  GRANIT_BANK: { color: null, label: [true], value: 9 },
  AKCENTACZ: { color: null, label: [true], value: 10 },
  BARION: { color: null, label: [true], value: 11 },
  RAIFFEISEN_BANK: { color: null, label: [true], value: 12 },
  COMMERZBANK: { color: null, label: [true], value: 13 },
  MKB_BANK: { color: null, label: [true], value: 14 },
  MBH_BANK: { color: null, label: [true], value: 15 },
  BINX: { color: null, label: [true], value: 16 },
  CIB_BUSINESS: { color: null, label: [true], value: 17 },
  ERSTE_BUSINESS: { color: null, label: [true], value: 18 },
  OBERBANK: { color: null, label: [true], value: 19 },
  REVOLUT: { color: null, label: [true], value: 21 },
  WISE: { color: null, label: [true], value: 22 },
  CSOB_BANKA_SK: { color: null, label: [true], value: 23 },
  FIO_BANKA_SK: { color: null, label: [true], value: 24 },
  SLOVENSKÁ_SPORITELNA: { color: null, label: [true], value: 25 },
  TATRA_BANKA: { color: null, label: [true], value: 26 },
  UNICREDIT_SLOVAKIA: { color: null, label: [true], value: 27 },
  VUB_BANKA: { color: null, label: [true], value: 28 },
  BANCA_TRANSILVANIA: { color: null, label: [true], value: 29 },
  BCR_RO: { color: null, label: [true], value: 30 },
  BRD_RO: { color: null, label: [true], value: 31 },
  CEC_RO: { color: null, label: [true], value: 32 },
  ING_RO: { color: null, label: [true], value: 33 },
  RAIFFEISEN_RO: { color: null, label: [true], value: 34 },
  UNI_CREDIT_RO: { color: null, label: [true], value: 35 },
  CZECH_SAVINGS_BANK: { color: null, label: [true], value: 36 },
  FIO_BANKA_CZ: { color: null, label: [true], value: 37 },
  UNI_CREDIT_CZ: { color: null, label: [true], value: 38 },
  OTHER: { color: null, label: [true], value: 1000 }
};
constants.BANK_ACCOUNT_TYPE_ERSTE = 1;
displayLookup['BANK_ACCOUNT_TYPE.1'] = ["bank account type", "erste"];
constants.BANK_ACCOUNT_TYPE_K_AND_H = 2;
displayLookup['BANK_ACCOUNT_TYPE.2'] = ["bank account type", "k and h"];
constants.BANK_ACCOUNT_TYPE_PAYPAL = 3;
displayLookup['BANK_ACCOUNT_TYPE.3'] = ["bank account type", "paypal"];
constants.BANK_ACCOUNT_TYPE_OTP = 4;
displayLookup['BANK_ACCOUNT_TYPE.4'] = ["bank account type", "otp"];
constants.BANK_ACCOUNT_TYPE_CIB = 5;
displayLookup['BANK_ACCOUNT_TYPE.5'] = ["bank account type", "cib"];
constants.BANK_ACCOUNT_TYPE_UNI_CREDIT = 6;
displayLookup['BANK_ACCOUNT_TYPE.6'] = ["bank account type", "uni credit"];
constants.BANK_ACCOUNT_TYPE_BUDAPEST_BANK = 7;
displayLookup['BANK_ACCOUNT_TYPE.7'] = ["bank account type", "budapest bank"];
constants.BANK_ACCOUNT_TYPE_MAGNETBANK = 8;
displayLookup['BANK_ACCOUNT_TYPE.8'] = ["bank account type", "magnetbank"];
constants.BANK_ACCOUNT_TYPE_GRANIT_BANK = 9;
displayLookup['BANK_ACCOUNT_TYPE.9'] = ["bank account type", "granit bank"];
constants.BANK_ACCOUNT_TYPE_AKCENTACZ = 10;
displayLookup['BANK_ACCOUNT_TYPE.10'] = ["bank account type", "akcentacz"];
constants.BANK_ACCOUNT_TYPE_BARION = 11;
displayLookup['BANK_ACCOUNT_TYPE.11'] = ["bank account type", "barion"];
constants.BANK_ACCOUNT_TYPE_RAIFFEISEN_BANK = 12;
displayLookup['BANK_ACCOUNT_TYPE.12'] = ["bank account type", "raiffeisen bank"];
constants.BANK_ACCOUNT_TYPE_COMMERZBANK = 13;
displayLookup['BANK_ACCOUNT_TYPE.13'] = ["bank account type", "commerzbank"];
constants.BANK_ACCOUNT_TYPE_MKB_BANK = 14;
displayLookup['BANK_ACCOUNT_TYPE.14'] = ["bank account type", "mkb bank"];
constants.BANK_ACCOUNT_TYPE_MBH_BANK = 15;
displayLookup['BANK_ACCOUNT_TYPE.15'] = ["bank account type", "mbh bank"];
constants.BANK_ACCOUNT_TYPE_BINX = 16;
displayLookup['BANK_ACCOUNT_TYPE.16'] = ["bank account type", "binx"];
constants.BANK_ACCOUNT_TYPE_CIB_BUSINESS = 17;
displayLookup['BANK_ACCOUNT_TYPE.17'] = ["bank account type", "cib business"];
constants.BANK_ACCOUNT_TYPE_ERSTE_BUSINESS = 18;
displayLookup['BANK_ACCOUNT_TYPE.18'] = ["bank account type", "erste business"];
constants.BANK_ACCOUNT_TYPE_OBERBANK = 19;
displayLookup['BANK_ACCOUNT_TYPE.19'] = ["bank account type", "oberbank"];
constants.BANK_ACCOUNT_TYPE_REVOLUT = 21;
displayLookup['BANK_ACCOUNT_TYPE.21'] = ["bank account type", "revolut"];
constants.BANK_ACCOUNT_TYPE_WISE = 22;
displayLookup['BANK_ACCOUNT_TYPE.22'] = ["bank account type", "wise"];
constants.BANK_ACCOUNT_TYPE_CSOB_BANKA_SK = 23;
displayLookup['BANK_ACCOUNT_TYPE.23'] = ["bank account type", "csob banka sk"];
constants.BANK_ACCOUNT_TYPE_FIO_BANKA_SK = 24;
displayLookup['BANK_ACCOUNT_TYPE.24'] = ["bank account type", "fio banka sk"];
constants.BANK_ACCOUNT_TYPE_SLOVENSKÁ_SPORITELNA = 25;
displayLookup['BANK_ACCOUNT_TYPE.25'] = ["bank account type", "slovensk\u00e1 sporitelna"];
constants.BANK_ACCOUNT_TYPE_TATRA_BANKA = 26;
displayLookup['BANK_ACCOUNT_TYPE.26'] = ["bank account type", "tatra banka"];
constants.BANK_ACCOUNT_TYPE_UNICREDIT_SLOVAKIA = 27;
displayLookup['BANK_ACCOUNT_TYPE.27'] = ["bank account type", "unicredit slovakia"];
constants.BANK_ACCOUNT_TYPE_VUB_BANKA = 28;
displayLookup['BANK_ACCOUNT_TYPE.28'] = ["bank account type", "vub banka"];
constants.BANK_ACCOUNT_TYPE_BANCA_TRANSILVANIA = 29;
displayLookup['BANK_ACCOUNT_TYPE.29'] = ["bank account type", "banca transilvania"];
constants.BANK_ACCOUNT_TYPE_BCR_RO = 30;
displayLookup['BANK_ACCOUNT_TYPE.30'] = ["bank account type", "bcr ro"];
constants.BANK_ACCOUNT_TYPE_BRD_RO = 31;
displayLookup['BANK_ACCOUNT_TYPE.31'] = ["bank account type", "brd ro"];
constants.BANK_ACCOUNT_TYPE_CEC_RO = 32;
displayLookup['BANK_ACCOUNT_TYPE.32'] = ["bank account type", "cec ro"];
constants.BANK_ACCOUNT_TYPE_ING_RO = 33;
displayLookup['BANK_ACCOUNT_TYPE.33'] = ["bank account type", "ing ro"];
constants.BANK_ACCOUNT_TYPE_RAIFFEISEN_RO = 34;
displayLookup['BANK_ACCOUNT_TYPE.34'] = ["bank account type", "raiffeisen ro"];
constants.BANK_ACCOUNT_TYPE_UNI_CREDIT_RO = 35;
displayLookup['BANK_ACCOUNT_TYPE.35'] = ["bank account type", "uni credit ro"];
constants.BANK_ACCOUNT_TYPE_CZECH_SAVINGS_BANK = 36;
displayLookup['BANK_ACCOUNT_TYPE.36'] = ["bank account type", "czech savings bank"];
constants.BANK_ACCOUNT_TYPE_FIO_BANKA_CZ = 37;
displayLookup['BANK_ACCOUNT_TYPE.37'] = ["bank account type", "fio banka cz"];
constants.BANK_ACCOUNT_TYPE_UNI_CREDIT_CZ = 38;
displayLookup['BANK_ACCOUNT_TYPE.38'] = ["bank account type", "uni credit cz"];
constants.BANK_ACCOUNT_TYPE_OTHER = 1000;
displayLookup['BANK_ACCOUNT_TYPE.1000'] = ["bank account type", "other"];

constants.BANK_INTEGRATION_TYPE = {
  AGGREG8: { color: null, label: true, value: 1 }
};
constants.BANK_INTEGRATION_TYPE_AGGREG8 = 1;
displayLookup['BANK_INTEGRATION_TYPE.1'] = "aggreg8";

constants.BASE_OF_MIN_OPT_QUANTITY_CALCULATION = {
  GLOBAL: { color: null, label: true, value: 1 },
  CALCULATED_WAREHOUSES: { color: null, label: true, value: 2 }
};
constants.BASE_OF_MIN_OPT_QUANTITY_CALCULATION_GLOBAL = 1;
displayLookup['BASE_OF_MIN_OPT_QUANTITY_CALCULATION.1'] = "global";
constants.BASE_OF_MIN_OPT_QUANTITY_CALCULATION_CALCULATED_WAREHOUSES = 2;
displayLookup['BASE_OF_MIN_OPT_QUANTITY_CALCULATION.2'] = "calculated warehouses";

constants.BASE_OF_STOCK_QUANTITY_CALCULATION = {
  AVAILABLE: { color: null, label: true, value: 1 },
  AVAILABLE_INCOMING: { color: null, label: "available + incoming", value: 2 },
  AVAILABLE_INCOMING_OPEN_PO: { color: null, label: "available + incoming + open po", value: 3 }
};
constants.BASE_OF_STOCK_QUANTITY_CALCULATION_AVAILABLE = 1;
displayLookup['BASE_OF_STOCK_QUANTITY_CALCULATION.1'] = "available";
constants.BASE_OF_STOCK_QUANTITY_CALCULATION_AVAILABLE_INCOMING = 2;
displayLookup['BASE_OF_STOCK_QUANTITY_CALCULATION.2'] = "available + incoming";
constants.BASE_OF_STOCK_QUANTITY_CALCULATION_AVAILABLE_INCOMING_OPEN_PO = 3;
displayLookup['BASE_OF_STOCK_QUANTITY_CALCULATION.3'] = "available + incoming + open po";

constants.BASE_OF_SUPPLIER_RECOMMENDATION = {
  DEFAULT: { color: null, label: "default supplier", value: 1 },
  CHEAPEST: { color: null, label: "cheapest supplier", value: 2 },
  FASTEST: { color: null, label: "fastest supplier", value: 3 },
  AVAILABLE_STOCK: { color: null, label: true, value: 4 }
};
constants.BASE_OF_SUPPLIER_RECOMMENDATION_DEFAULT = 1;
displayLookup['BASE_OF_SUPPLIER_RECOMMENDATION.1'] = "default supplier";
constants.BASE_OF_SUPPLIER_RECOMMENDATION_CHEAPEST = 2;
displayLookup['BASE_OF_SUPPLIER_RECOMMENDATION.2'] = "cheapest supplier";
constants.BASE_OF_SUPPLIER_RECOMMENDATION_FASTEST = 3;
displayLookup['BASE_OF_SUPPLIER_RECOMMENDATION.3'] = "fastest supplier";
constants.BASE_OF_SUPPLIER_RECOMMENDATION_AVAILABLE_STOCK = 4;
displayLookup['BASE_OF_SUPPLIER_RECOMMENDATION.4'] = "available stock";

constants.BUILD_STATUS = {
  PENDING: { color: "#e5e5e5", label: [true], value: 1 },
  PREPARING: { color: "#ffb74d", label: [true], value: 2 },
  WAITING_FOR_REVIEW: { color: "#64b5f6", label: [true], value: 3 },
  ACCEPTED: { color: "#162256", label: [true], value: 4 },
  BUILDING: { color: "#ffb74d", label: [true], value: 5 },
  COMPLETED: { color: "#66bb6a", label: [true], value: 6 },
  ROLLBACK_REQUESTED: { color: "#e5e5e5", label: [true], value: 300 },
  ROLLBACK_STARTED: { color: "#ffb74d", label: [true], value: 301 },
  ROLLBACK_COMPLETED: { color: "#a9a9a9", label: [true], value: 302 },
  CANCELLED: { color: "#e57373", label: [true], value: 400 },
  FAILED: { color: "#e57373", label: [true], value: 500 },
  ROLLBACK_FAILED: { color: "#e57373", label: [true], value: 501 }
};
constants.BUILD_STATUS_PENDING = 1;
displayLookup['BUILD_STATUS.1'] = ["build status", "pending"];
colorLookup['BUILD_STATUS.1'] = "#e5e5e5";
colorNameLookup['BUILD_STATUS.1'] = "GREY";
constants.BUILD_STATUS_PREPARING = 2;
displayLookup['BUILD_STATUS.2'] = ["build status", "preparing"];
colorLookup['BUILD_STATUS.2'] = "#ffb74d";
colorNameLookup['BUILD_STATUS.2'] = "YELLOW";
constants.BUILD_STATUS_WAITING_FOR_REVIEW = 3;
displayLookup['BUILD_STATUS.3'] = ["build status", "waiting for review"];
colorLookup['BUILD_STATUS.3'] = "#64b5f6";
colorNameLookup['BUILD_STATUS.3'] = "BLUE";
constants.BUILD_STATUS_ACCEPTED = 4;
displayLookup['BUILD_STATUS.4'] = ["build status", "accepted"];
colorLookup['BUILD_STATUS.4'] = "#162256";
colorNameLookup['BUILD_STATUS.4'] = "DARK_BLUE";
constants.BUILD_STATUS_BUILDING = 5;
displayLookup['BUILD_STATUS.5'] = ["build status", "building"];
colorLookup['BUILD_STATUS.5'] = "#ffb74d";
colorNameLookup['BUILD_STATUS.5'] = "YELLOW";
constants.BUILD_STATUS_COMPLETED = 6;
displayLookup['BUILD_STATUS.6'] = ["build status", "completed"];
colorLookup['BUILD_STATUS.6'] = "#66bb6a";
colorNameLookup['BUILD_STATUS.6'] = "GREEN";
constants.BUILD_STATUS_ROLLBACK_REQUESTED = 300;
displayLookup['BUILD_STATUS.300'] = ["build status", "rollback requested"];
colorLookup['BUILD_STATUS.300'] = "#e5e5e5";
colorNameLookup['BUILD_STATUS.300'] = "GREY";
constants.BUILD_STATUS_ROLLBACK_STARTED = 301;
displayLookup['BUILD_STATUS.301'] = ["build status", "rollback started"];
colorLookup['BUILD_STATUS.301'] = "#ffb74d";
colorNameLookup['BUILD_STATUS.301'] = "YELLOW";
constants.BUILD_STATUS_ROLLBACK_COMPLETED = 302;
displayLookup['BUILD_STATUS.302'] = ["build status", "rollback completed"];
colorLookup['BUILD_STATUS.302'] = "#a9a9a9";
colorNameLookup['BUILD_STATUS.302'] = "DARK_GREY";
constants.BUILD_STATUS_CANCELLED = 400;
displayLookup['BUILD_STATUS.400'] = ["build status", "cancelled"];
colorLookup['BUILD_STATUS.400'] = "#e57373";
colorNameLookup['BUILD_STATUS.400'] = "RED";
constants.BUILD_STATUS_FAILED = 500;
displayLookup['BUILD_STATUS.500'] = ["build status", "failed"];
colorLookup['BUILD_STATUS.500'] = "#e57373";
colorNameLookup['BUILD_STATUS.500'] = "RED";
constants.BUILD_STATUS_ROLLBACK_FAILED = 501;
displayLookup['BUILD_STATUS.501'] = ["build status", "rollback failed"];
colorLookup['BUILD_STATUS.501'] = "#e57373";
colorNameLookup['BUILD_STATUS.501'] = "RED";

constants.BUILD_VERSION_KIND = {
  HOTFIX: { color: null, label: [true], value: "hotfix" },
  PATCH: { color: null, label: [true], value: "patch" },
  MINOR: { color: null, label: [true], value: "minor" },
  MAJOR: { color: null, label: [true], value: "major" },
  OTHER: { color: null, label: [true], value: "other" }
};
constants.BUILD_VERSION_KIND_HOTFIX = "hotfix";
displayLookup['BUILD_VERSION_KIND."hotfix"'] = ["build version kind", "hotfix"];
constants.BUILD_VERSION_KIND_PATCH = "patch";
displayLookup['BUILD_VERSION_KIND."patch"'] = ["build version kind", "patch"];
constants.BUILD_VERSION_KIND_MINOR = "minor";
displayLookup['BUILD_VERSION_KIND."minor"'] = ["build version kind", "minor"];
constants.BUILD_VERSION_KIND_MAJOR = "major";
displayLookup['BUILD_VERSION_KIND."major"'] = ["build version kind", "major"];
constants.BUILD_VERSION_KIND_OTHER = "other";
displayLookup['BUILD_VERSION_KIND."other"'] = ["build version kind", "other"];

constants.BUILD_VERSION_SUFFIX = {
  RC: { color: null, label: [true], value: "rc" },
  STABLE: { color: null, label: [true], value: "stable" },
  OTHER: { color: null, label: [true], value: "other" }
};
constants.BUILD_VERSION_SUFFIX_RC = "rc";
displayLookup['BUILD_VERSION_SUFFIX."rc"'] = ["build version suffix", "rc"];
constants.BUILD_VERSION_SUFFIX_STABLE = "stable";
displayLookup['BUILD_VERSION_SUFFIX."stable"'] = ["build version suffix", "stable"];
constants.BUILD_VERSION_SUFFIX_OTHER = "other";
displayLookup['BUILD_VERSION_SUFFIX."other"'] = ["build version suffix", "other"];

constants.CASHFLOW_CATEGORY = {
  REVENUE: { color: "#66bb6a", label: ["cashflow category", "revenue"], value: 1 },
  VAT_REVENUE: { color: "#66bb6a", label: ["cashflow category", "vat revenue"], value: 2 },
  OTHER_REVENUE: { color: "#66bb6a", label: ["cashflow category", "other revenue"], value: 3 },
  UNCATEGORIZED_REVENUE: { color: "#66bb6a", label: ["cashflow category", "uncategorized revenue"], value: 4 },
  VAT_EXPENSE: { color: "#e57373", label: ["cashflow category", "vat expense"], value: 5 },
  VARIABLE_COST: { color: "#e57373", label: ["cashflow category", "variable cost"], value: 6 },
  FIXED_COST: { color: "#e57373", label: ["cashflow category", "fixed cost"], value: 7 },
  STOCK_INVESTMENT: { color: "#e57373", label: ["cashflow category", "stock investment"], value: 8 },
  FIXED_INVESTMENT: { color: "#e57373", label: ["cashflow category", "fixed investment"], value: 9 },
  TAX: { color: "#e57373", label: ["cashflow category", "tax"], value: 10 },
  OTHER_COST: { color: "#e57373", label: ["cashflow category", "other cost"], value: 11 },
  UNCATEGORIZED_EXPENSE: { color: "#e57373", label: ["cashflow category", "uncategorized expense"], value: 12 },
  TRANSFER: { color: "#f57c00", label: ["cashflow category", "transfer"], value: 100 }
};
constants.CASHFLOW_CATEGORY_REVENUE = 1;
displayLookup['CASHFLOW_CATEGORY.1'] = ["cashflow category", "revenue"];
colorLookup['CASHFLOW_CATEGORY.1'] = "#66bb6a";
colorNameLookup['CASHFLOW_CATEGORY.1'] = "GREEN";
constants.CASHFLOW_CATEGORY_VAT_REVENUE = 2;
displayLookup['CASHFLOW_CATEGORY.2'] = ["cashflow category", "vat revenue"];
colorLookup['CASHFLOW_CATEGORY.2'] = "#66bb6a";
colorNameLookup['CASHFLOW_CATEGORY.2'] = "GREEN";
constants.CASHFLOW_CATEGORY_OTHER_REVENUE = 3;
displayLookup['CASHFLOW_CATEGORY.3'] = ["cashflow category", "other revenue"];
colorLookup['CASHFLOW_CATEGORY.3'] = "#66bb6a";
colorNameLookup['CASHFLOW_CATEGORY.3'] = "GREEN";
constants.CASHFLOW_CATEGORY_UNCATEGORIZED_REVENUE = 4;
displayLookup['CASHFLOW_CATEGORY.4'] = ["cashflow category", "uncategorized revenue"];
colorLookup['CASHFLOW_CATEGORY.4'] = "#66bb6a";
colorNameLookup['CASHFLOW_CATEGORY.4'] = "GREEN";
constants.CASHFLOW_CATEGORY_VAT_EXPENSE = 5;
displayLookup['CASHFLOW_CATEGORY.5'] = ["cashflow category", "vat expense"];
colorLookup['CASHFLOW_CATEGORY.5'] = "#e57373";
colorNameLookup['CASHFLOW_CATEGORY.5'] = "RED";
constants.CASHFLOW_CATEGORY_VARIABLE_COST = 6;
displayLookup['CASHFLOW_CATEGORY.6'] = ["cashflow category", "variable cost"];
colorLookup['CASHFLOW_CATEGORY.6'] = "#e57373";
colorNameLookup['CASHFLOW_CATEGORY.6'] = "RED";
constants.CASHFLOW_CATEGORY_FIXED_COST = 7;
displayLookup['CASHFLOW_CATEGORY.7'] = ["cashflow category", "fixed cost"];
colorLookup['CASHFLOW_CATEGORY.7'] = "#e57373";
colorNameLookup['CASHFLOW_CATEGORY.7'] = "RED";
constants.CASHFLOW_CATEGORY_STOCK_INVESTMENT = 8;
displayLookup['CASHFLOW_CATEGORY.8'] = ["cashflow category", "stock investment"];
colorLookup['CASHFLOW_CATEGORY.8'] = "#e57373";
colorNameLookup['CASHFLOW_CATEGORY.8'] = "RED";
constants.CASHFLOW_CATEGORY_FIXED_INVESTMENT = 9;
displayLookup['CASHFLOW_CATEGORY.9'] = ["cashflow category", "fixed investment"];
colorLookup['CASHFLOW_CATEGORY.9'] = "#e57373";
colorNameLookup['CASHFLOW_CATEGORY.9'] = "RED";
constants.CASHFLOW_CATEGORY_TAX = 10;
displayLookup['CASHFLOW_CATEGORY.10'] = ["cashflow category", "tax"];
colorLookup['CASHFLOW_CATEGORY.10'] = "#e57373";
colorNameLookup['CASHFLOW_CATEGORY.10'] = "RED";
constants.CASHFLOW_CATEGORY_OTHER_COST = 11;
displayLookup['CASHFLOW_CATEGORY.11'] = ["cashflow category", "other cost"];
colorLookup['CASHFLOW_CATEGORY.11'] = "#e57373";
colorNameLookup['CASHFLOW_CATEGORY.11'] = "RED";
constants.CASHFLOW_CATEGORY_UNCATEGORIZED_EXPENSE = 12;
displayLookup['CASHFLOW_CATEGORY.12'] = ["cashflow category", "uncategorized expense"];
colorLookup['CASHFLOW_CATEGORY.12'] = "#e57373";
colorNameLookup['CASHFLOW_CATEGORY.12'] = "RED";
constants.CASHFLOW_CATEGORY_TRANSFER = 100;
displayLookup['CASHFLOW_CATEGORY.100'] = ["cashflow category", "transfer"];
colorLookup['CASHFLOW_CATEGORY.100'] = "#f57c00";
colorNameLookup['CASHFLOW_CATEGORY.100'] = "ORANGE";

constants.CASH_REGISTER_INVOICE_TYPE = {
  MANUAL: { color: null, label: true, value: 0 },
  NORMAL: { color: null, label: "invoice", value: 1 },
  RECEIPT: { color: null, label: true, value: 2 }
};
constants.CASH_REGISTER_INVOICE_TYPE_MANUAL = 0;
displayLookup['CASH_REGISTER_INVOICE_TYPE.0'] = "manual";
constants.CASH_REGISTER_INVOICE_TYPE_NORMAL = 1;
displayLookup['CASH_REGISTER_INVOICE_TYPE.1'] = "invoice";
constants.CASH_REGISTER_INVOICE_TYPE_RECEIPT = 2;
displayLookup['CASH_REGISTER_INVOICE_TYPE.2'] = "receipt";

constants.CASH_REGISTER_TYPE = {
  SIMPLIFIED: { color: null, label: true, value: -1 },
  VIRTUAL: { color: null, label: true, value: 1 },
  ANDYPOS: { color: null, label: true, value: 100 }
};
constants.CASH_REGISTER_TYPE_SIMPLIFIED = -1;
displayLookup['CASH_REGISTER_TYPE.-1'] = "simplified";
constants.CASH_REGISTER_TYPE_VIRTUAL = 1;
displayLookup['CASH_REGISTER_TYPE.1'] = "virtual";
constants.CASH_REGISTER_TYPE_ANDYPOS = 100;
displayLookup['CASH_REGISTER_TYPE.100'] = "andypos";

constants.CATEGORY_LEVEL = {
  LEVEL_1: { color: null, label: true, value: 1 },
  LEVEL_2: { color: null, label: true, value: 2 },
  LEVEL_3: { color: null, label: true, value: 3 },
  LEVEL_4: { color: null, label: true, value: 4 },
  LEVEL_5: { color: null, label: true, value: 5 },
  LEVEL_6: { color: null, label: true, value: 6 },
  LEVEL_7: { color: null, label: true, value: 7 },
  LEVEL_8: { color: null, label: true, value: 8 },
  LEVEL_9: { color: null, label: true, value: 9 },
  LEVEL_10: { color: null, label: true, value: 10 }
};
constants.CATEGORY_LEVEL_LEVEL_1 = 1;
displayLookup['CATEGORY_LEVEL.1'] = "level 1";
constants.CATEGORY_LEVEL_LEVEL_2 = 2;
displayLookup['CATEGORY_LEVEL.2'] = "level 2";
constants.CATEGORY_LEVEL_LEVEL_3 = 3;
displayLookup['CATEGORY_LEVEL.3'] = "level 3";
constants.CATEGORY_LEVEL_LEVEL_4 = 4;
displayLookup['CATEGORY_LEVEL.4'] = "level 4";
constants.CATEGORY_LEVEL_LEVEL_5 = 5;
displayLookup['CATEGORY_LEVEL.5'] = "level 5";
constants.CATEGORY_LEVEL_LEVEL_6 = 6;
displayLookup['CATEGORY_LEVEL.6'] = "level 6";
constants.CATEGORY_LEVEL_LEVEL_7 = 7;
displayLookup['CATEGORY_LEVEL.7'] = "level 7";
constants.CATEGORY_LEVEL_LEVEL_8 = 8;
displayLookup['CATEGORY_LEVEL.8'] = "level 8";
constants.CATEGORY_LEVEL_LEVEL_9 = 9;
displayLookup['CATEGORY_LEVEL.9'] = "level 9";
constants.CATEGORY_LEVEL_LEVEL_10 = 10;
displayLookup['CATEGORY_LEVEL.10'] = "level 10";

constants.CHANGE_CUSTOMER_PRICE_OPTION = {
  RAISE_ERROR: { color: null, label: true, value: 1 },
  KEEP_ORIGINAL_PRICES: { color: null, label: true, value: 2 },
  RELOAD_FROM_PRICE_LISTS: { color: null, label: true, value: 3 }
};
constants.CHANGE_CUSTOMER_PRICE_OPTION_RAISE_ERROR = 1;
displayLookup['CHANGE_CUSTOMER_PRICE_OPTION.1'] = "raise error";
constants.CHANGE_CUSTOMER_PRICE_OPTION_KEEP_ORIGINAL_PRICES = 2;
displayLookup['CHANGE_CUSTOMER_PRICE_OPTION.2'] = "keep original prices";
constants.CHANGE_CUSTOMER_PRICE_OPTION_RELOAD_FROM_PRICE_LISTS = 3;
displayLookup['CHANGE_CUSTOMER_PRICE_OPTION.3'] = "reload from price lists";

constants.COLOR_CONSTANT = {
  RED: { color: "#e57373", label: [true], value: 1 },
  BLUE: { color: "#64b5f6", label: [true], value: 2 },
  DARK_BLUE: { color: "#162256", label: [true], value: 3 },
  GREEN: { color: "#66bb6a", label: [true], value: 4 },
  DARK_GREEN: { color: "#106d3b", label: [true], value: 5 },
  GREY: { color: "#e5e5e5", label: [true], value: 6 },
  YELLOW: { color: "#ffb74d", label: [true], value: 7 },
  ORANGE: { color: "#f57c00", label: [true], value: 8 },
  LIGHT_YELLOW: { color: "#fff74d", label: [true], value: 9 },
  WHITE: { color: "#ffffff", label: [true], value: 10 },
  DARK_GREY: { color: "#a9a9a9", label: [true], value: 11 }
};
constants.COLOR_CONSTANT_RED = 1;
displayLookup['COLOR_CONSTANT.1'] = ["color constant", "red"];
colorLookup['COLOR_CONSTANT.1'] = "#e57373";
colorNameLookup['COLOR_CONSTANT.1'] = "RED";
constants.COLOR_CONSTANT_BLUE = 2;
displayLookup['COLOR_CONSTANT.2'] = ["color constant", "blue"];
colorLookup['COLOR_CONSTANT.2'] = "#64b5f6";
colorNameLookup['COLOR_CONSTANT.2'] = "BLUE";
constants.COLOR_CONSTANT_DARK_BLUE = 3;
displayLookup['COLOR_CONSTANT.3'] = ["color constant", "dark blue"];
colorLookup['COLOR_CONSTANT.3'] = "#162256";
colorNameLookup['COLOR_CONSTANT.3'] = "DARK_BLUE";
constants.COLOR_CONSTANT_GREEN = 4;
displayLookup['COLOR_CONSTANT.4'] = ["color constant", "green"];
colorLookup['COLOR_CONSTANT.4'] = "#66bb6a";
colorNameLookup['COLOR_CONSTANT.4'] = "GREEN";
constants.COLOR_CONSTANT_DARK_GREEN = 5;
displayLookup['COLOR_CONSTANT.5'] = ["color constant", "dark green"];
colorLookup['COLOR_CONSTANT.5'] = "#106d3b";
colorNameLookup['COLOR_CONSTANT.5'] = "DARK_GREEN";
constants.COLOR_CONSTANT_GREY = 6;
displayLookup['COLOR_CONSTANT.6'] = ["color constant", "grey"];
colorLookup['COLOR_CONSTANT.6'] = "#e5e5e5";
colorNameLookup['COLOR_CONSTANT.6'] = "GREY";
constants.COLOR_CONSTANT_YELLOW = 7;
displayLookup['COLOR_CONSTANT.7'] = ["color constant", "yellow"];
colorLookup['COLOR_CONSTANT.7'] = "#ffb74d";
colorNameLookup['COLOR_CONSTANT.7'] = "YELLOW";
constants.COLOR_CONSTANT_ORANGE = 8;
displayLookup['COLOR_CONSTANT.8'] = ["color constant", "orange"];
colorLookup['COLOR_CONSTANT.8'] = "#f57c00";
colorNameLookup['COLOR_CONSTANT.8'] = "ORANGE";
constants.COLOR_CONSTANT_LIGHT_YELLOW = 9;
displayLookup['COLOR_CONSTANT.9'] = ["color constant", "light yellow"];
colorLookup['COLOR_CONSTANT.9'] = "#fff74d";
colorNameLookup['COLOR_CONSTANT.9'] = "LIGHT_YELLOW";
constants.COLOR_CONSTANT_WHITE = 10;
displayLookup['COLOR_CONSTANT.10'] = ["color constant", "white"];
colorLookup['COLOR_CONSTANT.10'] = "#ffffff";
colorNameLookup['COLOR_CONSTANT.10'] = "WHITE";
constants.COLOR_CONSTANT_DARK_GREY = 11;
displayLookup['COLOR_CONSTANT.11'] = ["color constant", "dark grey"];
colorLookup['COLOR_CONSTANT.11'] = "#a9a9a9";
colorNameLookup['COLOR_CONSTANT.11'] = "DARK_GREY";

constants.COST_ALLOCATION_METHOD = {
  SHIPMENT_ITEM: { color: null, label: ["cost allocation method", "shipment item"], value: -1 },
  TOTAL_COUNT: { color: null, label: ["cost allocation method", "total count"], value: 1 },
  TOTAL_NET_PRICE: { color: null, label: ["cost allocation method", "total net price"], value: 2 },
  TOTAL_QUANTITY: { color: null, label: ["cost allocation method", "total quantity"], value: 3 },
  TOTAL_WEIGHT: { color: null, label: ["cost allocation method", "total weight"], value: 4 },
  TOTAL_VOLUME: { color: null, label: ["cost allocation method", "total volume"], value: 5 },
  TOTAL_MARGIN: { color: null, label: ["cost allocation method", "total margin"], value: 6 }
};
constants.COST_ALLOCATION_METHOD_SHIPMENT_ITEM = -1;
displayLookup['COST_ALLOCATION_METHOD.-1'] = ["cost allocation method", "shipment item"];
constants.COST_ALLOCATION_METHOD_TOTAL_COUNT = 1;
displayLookup['COST_ALLOCATION_METHOD.1'] = ["cost allocation method", "total count"];
constants.COST_ALLOCATION_METHOD_TOTAL_NET_PRICE = 2;
displayLookup['COST_ALLOCATION_METHOD.2'] = ["cost allocation method", "total net price"];
constants.COST_ALLOCATION_METHOD_TOTAL_QUANTITY = 3;
displayLookup['COST_ALLOCATION_METHOD.3'] = ["cost allocation method", "total quantity"];
constants.COST_ALLOCATION_METHOD_TOTAL_WEIGHT = 4;
displayLookup['COST_ALLOCATION_METHOD.4'] = ["cost allocation method", "total weight"];
constants.COST_ALLOCATION_METHOD_TOTAL_VOLUME = 5;
displayLookup['COST_ALLOCATION_METHOD.5'] = ["cost allocation method", "total volume"];
constants.COST_ALLOCATION_METHOD_TOTAL_MARGIN = 6;
displayLookup['COST_ALLOCATION_METHOD.6'] = ["cost allocation method", "total margin"];

constants.COST_ALLOCATION_TARGET = {
  ORDER: { color: null, label: ["cost allocation target", "order"], value: "order" },
  SALES_CHANNEL: { color: null, label: ["cost allocation target", "sales channel"], value: "saleschannel" },
  WAREHOUSE: { color: null, label: ["cost allocation target", "warehouse"], value: "warehouse" },
  SHIPMENT: { color: null, label: ["cost allocation target", "shipment"], value: "shipment" }
};
constants.COST_ALLOCATION_TARGET_ORDER = "order";
displayLookup['COST_ALLOCATION_TARGET."order"'] = ["cost allocation target", "order"];
constants.COST_ALLOCATION_TARGET_SALES_CHANNEL = "saleschannel";
displayLookup['COST_ALLOCATION_TARGET."saleschannel"'] = ["cost allocation target", "sales channel"];
constants.COST_ALLOCATION_TARGET_WAREHOUSE = "warehouse";
displayLookup['COST_ALLOCATION_TARGET."warehouse"'] = ["cost allocation target", "warehouse"];
constants.COST_ALLOCATION_TARGET_SHIPMENT = "shipment";
displayLookup['COST_ALLOCATION_TARGET."shipment"'] = ["cost allocation target", "shipment"];

constants.COURIER = {
  CUSTOM: { color: "#66bb6a", label: true, value: -1 },
  GLS: { color: "#64b5f6", label: true, value: 1 },
  SPRINTER: { color: "#e57373", label: true, value: 2 },
  PACKETA: { color: "#e57373", label: true, value: 3 },
  MPL: { color: "#66bb6a", label: true, value: 4 },
  PARCEL_24H: { color: "#66bb6a", label: "24H", value: 5 },
  FOXPOST: { color: "#e57373", label: true, value: 6 },
  DPD: { color: "#e57373", label: true, value: 7 },
  EXPRESS_ONE: { color: "#ffb74d", label: "ExpressOne", value: 8 },
  PACTIC: { color: "#106d3b", label: true, value: 9 },
  EMAG: { color: "#64b5f6", label: true, value: 10 },
  SAMEDAY: { color: "#64b5f6", label: "Emag/Sameday", value: 11 },
  KUMI: { color: "#f57c00", label: true, value: 12 },
  KOVA_TRANS: { color: "#64b5f6", label: true, value: 13 },
  PANNONXP: { color: "#f57c00", label: "Pannon XP", value: 14 },
  GLS_OPENNETWORK: { color: "#64b5f6", label: "GLS OpenNetwork", value: 15 }
};
constants.COURIER_CUSTOM = -1;
displayLookup['COURIER.-1'] = "custom";
colorLookup['COURIER.-1'] = "#66bb6a";
colorNameLookup['COURIER.-1'] = "GREEN";
constants.COURIER_GLS = 1;
displayLookup['COURIER.1'] = "gls";
colorLookup['COURIER.1'] = "#64b5f6";
colorNameLookup['COURIER.1'] = "BLUE";
constants.COURIER_SPRINTER = 2;
displayLookup['COURIER.2'] = "sprinter";
colorLookup['COURIER.2'] = "#e57373";
colorNameLookup['COURIER.2'] = "RED";
constants.COURIER_PACKETA = 3;
displayLookup['COURIER.3'] = "packeta";
colorLookup['COURIER.3'] = "#e57373";
colorNameLookup['COURIER.3'] = "RED";
constants.COURIER_MPL = 4;
displayLookup['COURIER.4'] = "mpl";
colorLookup['COURIER.4'] = "#66bb6a";
colorNameLookup['COURIER.4'] = "GREEN";
constants.COURIER_PARCEL_24H = 5;
displayLookup['COURIER.5'] = "24H";
colorLookup['COURIER.5'] = "#66bb6a";
colorNameLookup['COURIER.5'] = "GREEN";
constants.COURIER_FOXPOST = 6;
displayLookup['COURIER.6'] = "foxpost";
colorLookup['COURIER.6'] = "#e57373";
colorNameLookup['COURIER.6'] = "RED";
constants.COURIER_DPD = 7;
displayLookup['COURIER.7'] = "dpd";
colorLookup['COURIER.7'] = "#e57373";
colorNameLookup['COURIER.7'] = "RED";
constants.COURIER_EXPRESS_ONE = 8;
displayLookup['COURIER.8'] = "ExpressOne";
colorLookup['COURIER.8'] = "#ffb74d";
colorNameLookup['COURIER.8'] = "YELLOW";
constants.COURIER_PACTIC = 9;
displayLookup['COURIER.9'] = "pactic";
colorLookup['COURIER.9'] = "#106d3b";
colorNameLookup['COURIER.9'] = "DARK_GREEN";
constants.COURIER_EMAG = 10;
displayLookup['COURIER.10'] = "emag";
colorLookup['COURIER.10'] = "#64b5f6";
colorNameLookup['COURIER.10'] = "BLUE";
constants.COURIER_SAMEDAY = 11;
displayLookup['COURIER.11'] = "Emag/Sameday";
colorLookup['COURIER.11'] = "#64b5f6";
colorNameLookup['COURIER.11'] = "BLUE";
constants.COURIER_KUMI = 12;
displayLookup['COURIER.12'] = "kumi";
colorLookup['COURIER.12'] = "#f57c00";
colorNameLookup['COURIER.12'] = "ORANGE";
constants.COURIER_KOVA_TRANS = 13;
displayLookup['COURIER.13'] = "kova trans";
colorLookup['COURIER.13'] = "#64b5f6";
colorNameLookup['COURIER.13'] = "BLUE";
constants.COURIER_PANNONXP = 14;
displayLookup['COURIER.14'] = "Pannon XP";
colorLookup['COURIER.14'] = "#f57c00";
colorNameLookup['COURIER.14'] = "ORANGE";
constants.COURIER_GLS_OPENNETWORK = 15;
displayLookup['COURIER.15'] = "GLS OpenNetwork";
colorLookup['COURIER.15'] = "#64b5f6";
colorNameLookup['COURIER.15'] = "BLUE";

constants.CREATE_TASK_FROM_VIEW_CONFIG_CONTENT_OBJECT_MODE = {
  STANDALONE: { color: null, label: [true], value: 1 },
  VIEW_CONFIG: { color: null, label: [true], value: 2 },
  EVERY_OBJECT: { color: null, label: [true], value: 3 }
};
constants.CREATE_TASK_FROM_VIEW_CONFIG_CONTENT_OBJECT_MODE_STANDALONE = 1;
displayLookup['CREATE_TASK_FROM_VIEW_CONFIG_CONTENT_OBJECT_MODE.1'] = ["create task from view config content object mode", "standalone"];
constants.CREATE_TASK_FROM_VIEW_CONFIG_CONTENT_OBJECT_MODE_VIEW_CONFIG = 2;
displayLookup['CREATE_TASK_FROM_VIEW_CONFIG_CONTENT_OBJECT_MODE.2'] = ["create task from view config content object mode", "view config"];
constants.CREATE_TASK_FROM_VIEW_CONFIG_CONTENT_OBJECT_MODE_EVERY_OBJECT = 3;
displayLookup['CREATE_TASK_FROM_VIEW_CONFIG_CONTENT_OBJECT_MODE.3'] = ["create task from view config content object mode", "every object"];

constants.CREATE_TASK_FROM_VIEW_CONFIG_CREATE_MODE = {
  ALWAYS: { color: null, label: [true], value: 1 },
  FINISHED: { color: null, label: [true], value: 2 },
  NOT_EXISTS: { color: null, label: [true], value: 3 }
};
constants.CREATE_TASK_FROM_VIEW_CONFIG_CREATE_MODE_ALWAYS = 1;
displayLookup['CREATE_TASK_FROM_VIEW_CONFIG_CREATE_MODE.1'] = ["create task from view config create mode", "always"];
constants.CREATE_TASK_FROM_VIEW_CONFIG_CREATE_MODE_FINISHED = 2;
displayLookup['CREATE_TASK_FROM_VIEW_CONFIG_CREATE_MODE.2'] = ["create task from view config create mode", "finished"];
constants.CREATE_TASK_FROM_VIEW_CONFIG_CREATE_MODE_NOT_EXISTS = 3;
displayLookup['CREATE_TASK_FROM_VIEW_CONFIG_CREATE_MODE.3'] = ["create task from view config create mode", "not exists"];

constants.CSV_EXPORT_MODE = {
  LOCAL: { color: null, label: true, value: 1 },
  SUPPLIER: { color: null, label: true, value: 2 }
};
constants.CSV_EXPORT_MODE_LOCAL = 1;
displayLookup['CSV_EXPORT_MODE.1'] = "local";
constants.CSV_EXPORT_MODE_SUPPLIER = 2;
displayLookup['CSV_EXPORT_MODE.2'] = "supplier";

constants.CUSTOMER_IMPORT_MODE = {
  APPEND: { color: null, label: true, value: 1 },
  OVERWRITE: { color: null, label: true, value: 2 }
};
constants.CUSTOMER_IMPORT_MODE_APPEND = 1;
displayLookup['CUSTOMER_IMPORT_MODE.1'] = "append";
constants.CUSTOMER_IMPORT_MODE_OVERWRITE = 2;
displayLookup['CUSTOMER_IMPORT_MODE.2'] = "overwrite";

constants.CUSTOMER_RECENCY_CLASS = {
  LOST: { color: null, label: true, value: 1 },
  IN_DANGER: { color: null, label: true, value: 2 },
  HIBERNATING: { color: null, label: true, value: 3 },
  ACTIVE: { color: null, label: true, value: 4 }
};
constants.CUSTOMER_RECENCY_CLASS_LOST = 1;
displayLookup['CUSTOMER_RECENCY_CLASS.1'] = "lost";
constants.CUSTOMER_RECENCY_CLASS_IN_DANGER = 2;
displayLookup['CUSTOMER_RECENCY_CLASS.2'] = "in danger";
constants.CUSTOMER_RECENCY_CLASS_HIBERNATING = 3;
displayLookup['CUSTOMER_RECENCY_CLASS.3'] = "hibernating";
constants.CUSTOMER_RECENCY_CLASS_ACTIVE = 4;
displayLookup['CUSTOMER_RECENCY_CLASS.4'] = "active";

constants.CUSTOMER_TYPE = {
  PERSON: { color: null, label: "Person", value: 1 },
  COMPANY: { color: null, label: "Company", value: 2 }
};
constants.CUSTOMER_TYPE_PERSON = 1;
displayLookup['CUSTOMER_TYPE.1'] = "Person";
constants.CUSTOMER_TYPE_COMPANY = 2;
displayLookup['CUSTOMER_TYPE.2'] = "Company";

constants.CUSTOM_FIELD_CONFIG_CONTENT_TYPE = {
  ORDER_ITEM: { color: null, label: true, value: 1 },
  ORDER: { color: null, label: true, value: 2 }
};
constants.CUSTOM_FIELD_CONFIG_CONTENT_TYPE_ORDER_ITEM = 1;
displayLookup['CUSTOM_FIELD_CONFIG_CONTENT_TYPE.1'] = "order item";
constants.CUSTOM_FIELD_CONFIG_CONTENT_TYPE_ORDER = 2;
displayLookup['CUSTOM_FIELD_CONFIG_CONTENT_TYPE.2'] = "order";

constants.CUSTOM_FIELD_CONFIG_FIELD_TYPE = {
  TEXT: { color: null, label: true, value: 1 },
  ENUM: { color: null, label: true, value: 2 }
};
constants.CUSTOM_FIELD_CONFIG_FIELD_TYPE_TEXT = 1;
displayLookup['CUSTOM_FIELD_CONFIG_FIELD_TYPE.1'] = "text";
constants.CUSTOM_FIELD_CONFIG_FIELD_TYPE_ENUM = 2;
displayLookup['CUSTOM_FIELD_CONFIG_FIELD_TYPE.2'] = "enum";

constants.CUSTOM_FIELD_CONFIG_FORM_POSITION_OPTION = {
  ITEM_NOTE: { color: null, label: "note", value: 1 },
  ITEM_COLUMN: { color: null, label: "column", value: 2 },
  FORM_TOP: { color: null, label: "top", value: 3 },
  FORM_BOTTOM: { color: null, label: "bottom", value: 4 },
  FORM_SIDEBAR: { color: null, label: "sidebar", value: 5 }
};
constants.CUSTOM_FIELD_CONFIG_FORM_POSITION_OPTION_ITEM_NOTE = 1;
displayLookup['CUSTOM_FIELD_CONFIG_FORM_POSITION_OPTION.1'] = "note";
constants.CUSTOM_FIELD_CONFIG_FORM_POSITION_OPTION_ITEM_COLUMN = 2;
displayLookup['CUSTOM_FIELD_CONFIG_FORM_POSITION_OPTION.2'] = "column";
constants.CUSTOM_FIELD_CONFIG_FORM_POSITION_OPTION_FORM_TOP = 3;
displayLookup['CUSTOM_FIELD_CONFIG_FORM_POSITION_OPTION.3'] = "top";
constants.CUSTOM_FIELD_CONFIG_FORM_POSITION_OPTION_FORM_BOTTOM = 4;
displayLookup['CUSTOM_FIELD_CONFIG_FORM_POSITION_OPTION.4'] = "bottom";
constants.CUSTOM_FIELD_CONFIG_FORM_POSITION_OPTION_FORM_SIDEBAR = 5;
displayLookup['CUSTOM_FIELD_CONFIG_FORM_POSITION_OPTION.5'] = "sidebar";

constants.DATE_PERIOD = {
  TODAY: { color: null, label: [true], value: "today" },
  THIS_WEEK: { color: null, label: [true], value: "this_week" },
  THIS_MONTH: { color: null, label: [true], value: "this_month" },
  THIS_YEAR: { color: null, label: [true], value: "this_year" },
  LAST_7_DAYS: { color: null, label: [true], value: "last_7_days" },
  LAST_14_DAYS: { color: null, label: [true], value: "last_14_days" },
  LAST_30_DAYS: { color: null, label: [true], value: "last_30_days" },
  LAST_90_DAYS: { color: null, label: [true], value: "last_90_days" },
  LAST_180_DAYS: { color: null, label: [true], value: "last_180_days" },
  LAST_365_DAYS: { color: null, label: [true], value: "last_365_days" },
  SECOND_LAST_7_DAYS: { color: null, label: [true], value: "second_last_7_days" },
  SECOND_LAST_14_DAYS: { color: null, label: [true], value: "second_last_14_days" },
  SECOND_LAST_30_DAYS: { color: null, label: [true], value: "second_last_30_days" },
  SECOND_LAST_90_DAYS: { color: null, label: [true], value: "second_last_90_days" },
  SECOND_LAST_180_DAYS: { color: null, label: [true], value: "second_last_180_days" },
  SECOND_LAST_365_DAYS: { color: null, label: [true], value: "second_last_365_days" },
  Q1: { color: null, label: [true], value: "q1" },
  Q2: { color: null, label: [true], value: "q2" },
  Q3: { color: null, label: [true], value: "q3" },
  Q4: { color: null, label: [true], value: "q4" },
  LAST_YEAR_Q1: { color: null, label: [true], value: "last_year_q1" },
  LAST_YEAR_Q2: { color: null, label: [true], value: "last_year_q2" },
  LAST_YEAR_Q3: { color: null, label: [true], value: "last_year_q3" },
  LAST_YEAR_Q4: { color: null, label: [true], value: "last_year_q4" },
  JAN: { color: null, label: [true], value: "jan" },
  FEB: { color: null, label: [true], value: "feb" },
  MAR: { color: null, label: [true], value: "mar" },
  APR: { color: null, label: [true], value: "apr" },
  MAY: { color: null, label: [true], value: "may" },
  JUN: { color: null, label: [true], value: "jun" },
  JUL: { color: null, label: [true], value: "jul" },
  AUG: { color: null, label: [true], value: "aug" },
  SEP: { color: null, label: [true], value: "sep" },
  OCT: { color: null, label: [true], value: "oct" },
  NOV: { color: null, label: [true], value: "nov" },
  DEC: { color: null, label: [true], value: "dec" },
  LAST_YEAR_JAN: { color: null, label: [true], value: "last_year_jan" },
  LAST_YEAR_FEB: { color: null, label: [true], value: "last_year_feb" },
  LAST_YEAR_MAR: { color: null, label: [true], value: "last_year_mar" },
  LAST_YEAR_APR: { color: null, label: [true], value: "last_year_apr" },
  LAST_YEAR_MAY: { color: null, label: [true], value: "last_year_may" },
  LAST_YEAR_JUN: { color: null, label: [true], value: "last_year_jun" },
  LAST_YEAR_JUL: { color: null, label: [true], value: "last_year_jul" },
  LAST_YEAR_AUG: { color: null, label: [true], value: "last_year_aug" },
  LAST_YEAR_SEP: { color: null, label: [true], value: "last_year_sep" },
  LAST_YEAR_OCT: { color: null, label: [true], value: "last_year_oct" },
  LAST_YEAR_NOV: { color: null, label: [true], value: "last_year_nov" },
  LAST_YEAR_DEC: { color: null, label: [true], value: "last_year_dec" },
  YESTERDAY: { color: null, label: [true], value: "yesterday" },
  PREVIOUS_WEEKDAY: { color: null, label: [true], value: "previous_weekday" },
  PREVIOUS_WEEK: { color: null, label: [true], value: "previous_week" },
  PREVIOUS_MONTH: { color: null, label: [true], value: "previous_month" },
  PREVIOUS_YEAR: { color: null, label: [true], value: "previous_year" },
  PREVIOUS_N_MONTH_1: { color: null, label: [true], value: "previous_n_month_1" },
  PREVIOUS_N_MONTH_2: { color: null, label: [true], value: "previous_n_month_2" },
  PREVIOUS_N_MONTH_3: { color: null, label: [true], value: "previous_n_month_3" },
  PREVIOUS_N_MONTH_4: { color: null, label: [true], value: "previous_n_month_4" },
  PREVIOUS_N_MONTH_5: { color: null, label: [true], value: "previous_n_month_5" },
  PREVIOUS_N_MONTH_6: { color: null, label: [true], value: "previous_n_month_6" },
  PREVIOUS_N_MONTH_7: { color: null, label: [true], value: "previous_n_month_7" },
  PREVIOUS_N_MONTH_8: { color: null, label: [true], value: "previous_n_month_8" },
  PREVIOUS_N_MONTH_9: { color: null, label: [true], value: "previous_n_month_9" },
  PREVIOUS_N_MONTH_10: { color: null, label: [true], value: "previous_n_month_10" },
  PREVIOUS_N_MONTH_11: { color: null, label: [true], value: "previous_n_month_11" },
  PREVIOUS_N_MONTH_12: { color: null, label: [true], value: "previous_n_month_12" },
  PREVIOUS_YEAR_LAST_7_DAYS: { color: null, label: [true], value: "previous_year_last_7_days" },
  PREVIOUS_YEAR_LAST_14_DAYS: { color: null, label: [true], value: "previous_year_last_14_days" },
  PREVIOUS_YEAR_LAST_30_DAYS: { color: null, label: [true], value: "previous_year_last_30_days" },
  PREVIOUS_YEAR_LAST_90_DAYS: { color: null, label: [true], value: "previous_year_last_90_days" },
  PREVIOUS_YEAR_LAST_180_DAYS: { color: null, label: [true], value: "previous_year_last_180_days" },
  PREVIOUS_YEAR_NEXT_7_DAYS: { color: null, label: [true], value: "previous_year_next_7_days" },
  PREVIOUS_YEAR_NEXT_14_DAYS: { color: null, label: [true], value: "previous_year_next_14_days" },
  PREVIOUS_YEAR_NEXT_30_DAYS: { color: null, label: [true], value: "previous_year_next_30_days" },
  PREVIOUS_YEAR_NEXT_90_DAYS: { color: null, label: [true], value: "previous_year_next_90_days" },
  PREVIOUS_YEAR_NEXT_180_DAYS: { color: null, label: [true], value: "previous_year_next_180_days" },
  TOMORROW: { color: null, label: [true], value: "tomorrow" },
  NEXT_WEEKDAY: { color: null, label: [true], value: "next_weekday" },
  NEXT_WEEK: { color: null, label: [true], value: "next_week" },
  NEXT_MONTH: { color: null, label: [true], value: "next_month" },
  NEXT_YEAR: { color: null, label: [true], value: "next_year" },
  NEXT_7_DAYS: { color: null, label: [true], value: "next_7_days" },
  NEXT_14_DAYS: { color: null, label: [true], value: "next_14_days" },
  NEXT_30_DAYS: { color: null, label: [true], value: "next_30_days" },
  NEXT_90_DAYS: { color: null, label: [true], value: "next_90_days" },
  NEXT_180_DAYS: { color: null, label: [true], value: "next_180_days" },
  NEXT_365_DAYS: { color: null, label: [true], value: "next_365_days" },
  YEAR_TO_DATE: { color: null, label: [true], value: "year_to_date" },
  MONTH_TO_DATE: { color: null, label: [true], value: "month_to_date" },
  LAST_YEAR_TO_DATE: { color: null, label: [true], value: "last_year_to_date" },
  LAST_YEAR_MONTH_TO_DATE: { color: null, label: [true], value: "last_year_month_to_date" },
  FROM_BEGINNING: { color: null, label: [true], value: "from_beginning" }
};
constants.DATE_PERIOD_TODAY = "today";
displayLookup['DATE_PERIOD."today"'] = ["date period", "today"];
constants.DATE_PERIOD_THIS_WEEK = "this_week";
displayLookup['DATE_PERIOD."this_week"'] = ["date period", "this week"];
constants.DATE_PERIOD_THIS_MONTH = "this_month";
displayLookup['DATE_PERIOD."this_month"'] = ["date period", "this month"];
constants.DATE_PERIOD_THIS_YEAR = "this_year";
displayLookup['DATE_PERIOD."this_year"'] = ["date period", "this year"];
constants.DATE_PERIOD_LAST_7_DAYS = "last_7_days";
displayLookup['DATE_PERIOD."last_7_days"'] = ["date period", "last 7 days"];
constants.DATE_PERIOD_LAST_14_DAYS = "last_14_days";
displayLookup['DATE_PERIOD."last_14_days"'] = ["date period", "last 14 days"];
constants.DATE_PERIOD_LAST_30_DAYS = "last_30_days";
displayLookup['DATE_PERIOD."last_30_days"'] = ["date period", "last 30 days"];
constants.DATE_PERIOD_LAST_90_DAYS = "last_90_days";
displayLookup['DATE_PERIOD."last_90_days"'] = ["date period", "last 90 days"];
constants.DATE_PERIOD_LAST_180_DAYS = "last_180_days";
displayLookup['DATE_PERIOD."last_180_days"'] = ["date period", "last 180 days"];
constants.DATE_PERIOD_LAST_365_DAYS = "last_365_days";
displayLookup['DATE_PERIOD."last_365_days"'] = ["date period", "last 365 days"];
constants.DATE_PERIOD_SECOND_LAST_7_DAYS = "second_last_7_days";
displayLookup['DATE_PERIOD."second_last_7_days"'] = ["date period", "second last 7 days"];
constants.DATE_PERIOD_SECOND_LAST_14_DAYS = "second_last_14_days";
displayLookup['DATE_PERIOD."second_last_14_days"'] = ["date period", "second last 14 days"];
constants.DATE_PERIOD_SECOND_LAST_30_DAYS = "second_last_30_days";
displayLookup['DATE_PERIOD."second_last_30_days"'] = ["date period", "second last 30 days"];
constants.DATE_PERIOD_SECOND_LAST_90_DAYS = "second_last_90_days";
displayLookup['DATE_PERIOD."second_last_90_days"'] = ["date period", "second last 90 days"];
constants.DATE_PERIOD_SECOND_LAST_180_DAYS = "second_last_180_days";
displayLookup['DATE_PERIOD."second_last_180_days"'] = ["date period", "second last 180 days"];
constants.DATE_PERIOD_SECOND_LAST_365_DAYS = "second_last_365_days";
displayLookup['DATE_PERIOD."second_last_365_days"'] = ["date period", "second last 365 days"];
constants.DATE_PERIOD_Q1 = "q1";
displayLookup['DATE_PERIOD."q1"'] = ["date period", "q1"];
constants.DATE_PERIOD_Q2 = "q2";
displayLookup['DATE_PERIOD."q2"'] = ["date period", "q2"];
constants.DATE_PERIOD_Q3 = "q3";
displayLookup['DATE_PERIOD."q3"'] = ["date period", "q3"];
constants.DATE_PERIOD_Q4 = "q4";
displayLookup['DATE_PERIOD."q4"'] = ["date period", "q4"];
constants.DATE_PERIOD_LAST_YEAR_Q1 = "last_year_q1";
displayLookup['DATE_PERIOD."last_year_q1"'] = ["date period", "last year q1"];
constants.DATE_PERIOD_LAST_YEAR_Q2 = "last_year_q2";
displayLookup['DATE_PERIOD."last_year_q2"'] = ["date period", "last year q2"];
constants.DATE_PERIOD_LAST_YEAR_Q3 = "last_year_q3";
displayLookup['DATE_PERIOD."last_year_q3"'] = ["date period", "last year q3"];
constants.DATE_PERIOD_LAST_YEAR_Q4 = "last_year_q4";
displayLookup['DATE_PERIOD."last_year_q4"'] = ["date period", "last year q4"];
constants.DATE_PERIOD_JAN = "jan";
displayLookup['DATE_PERIOD."jan"'] = ["date period", "jan"];
constants.DATE_PERIOD_FEB = "feb";
displayLookup['DATE_PERIOD."feb"'] = ["date period", "feb"];
constants.DATE_PERIOD_MAR = "mar";
displayLookup['DATE_PERIOD."mar"'] = ["date period", "mar"];
constants.DATE_PERIOD_APR = "apr";
displayLookup['DATE_PERIOD."apr"'] = ["date period", "apr"];
constants.DATE_PERIOD_MAY = "may";
displayLookup['DATE_PERIOD."may"'] = ["date period", "may"];
constants.DATE_PERIOD_JUN = "jun";
displayLookup['DATE_PERIOD."jun"'] = ["date period", "jun"];
constants.DATE_PERIOD_JUL = "jul";
displayLookup['DATE_PERIOD."jul"'] = ["date period", "jul"];
constants.DATE_PERIOD_AUG = "aug";
displayLookup['DATE_PERIOD."aug"'] = ["date period", "aug"];
constants.DATE_PERIOD_SEP = "sep";
displayLookup['DATE_PERIOD."sep"'] = ["date period", "sep"];
constants.DATE_PERIOD_OCT = "oct";
displayLookup['DATE_PERIOD."oct"'] = ["date period", "oct"];
constants.DATE_PERIOD_NOV = "nov";
displayLookup['DATE_PERIOD."nov"'] = ["date period", "nov"];
constants.DATE_PERIOD_DEC = "dec";
displayLookup['DATE_PERIOD."dec"'] = ["date period", "dec"];
constants.DATE_PERIOD_LAST_YEAR_JAN = "last_year_jan";
displayLookup['DATE_PERIOD."last_year_jan"'] = ["date period", "last year jan"];
constants.DATE_PERIOD_LAST_YEAR_FEB = "last_year_feb";
displayLookup['DATE_PERIOD."last_year_feb"'] = ["date period", "last year feb"];
constants.DATE_PERIOD_LAST_YEAR_MAR = "last_year_mar";
displayLookup['DATE_PERIOD."last_year_mar"'] = ["date period", "last year mar"];
constants.DATE_PERIOD_LAST_YEAR_APR = "last_year_apr";
displayLookup['DATE_PERIOD."last_year_apr"'] = ["date period", "last year apr"];
constants.DATE_PERIOD_LAST_YEAR_MAY = "last_year_may";
displayLookup['DATE_PERIOD."last_year_may"'] = ["date period", "last year may"];
constants.DATE_PERIOD_LAST_YEAR_JUN = "last_year_jun";
displayLookup['DATE_PERIOD."last_year_jun"'] = ["date period", "last year jun"];
constants.DATE_PERIOD_LAST_YEAR_JUL = "last_year_jul";
displayLookup['DATE_PERIOD."last_year_jul"'] = ["date period", "last year jul"];
constants.DATE_PERIOD_LAST_YEAR_AUG = "last_year_aug";
displayLookup['DATE_PERIOD."last_year_aug"'] = ["date period", "last year aug"];
constants.DATE_PERIOD_LAST_YEAR_SEP = "last_year_sep";
displayLookup['DATE_PERIOD."last_year_sep"'] = ["date period", "last year sep"];
constants.DATE_PERIOD_LAST_YEAR_OCT = "last_year_oct";
displayLookup['DATE_PERIOD."last_year_oct"'] = ["date period", "last year oct"];
constants.DATE_PERIOD_LAST_YEAR_NOV = "last_year_nov";
displayLookup['DATE_PERIOD."last_year_nov"'] = ["date period", "last year nov"];
constants.DATE_PERIOD_LAST_YEAR_DEC = "last_year_dec";
displayLookup['DATE_PERIOD."last_year_dec"'] = ["date period", "last year dec"];
constants.DATE_PERIOD_YESTERDAY = "yesterday";
displayLookup['DATE_PERIOD."yesterday"'] = ["date period", "yesterday"];
constants.DATE_PERIOD_PREVIOUS_WEEKDAY = "previous_weekday";
displayLookup['DATE_PERIOD."previous_weekday"'] = ["date period", "previous weekday"];
constants.DATE_PERIOD_PREVIOUS_WEEK = "previous_week";
displayLookup['DATE_PERIOD."previous_week"'] = ["date period", "previous week"];
constants.DATE_PERIOD_PREVIOUS_MONTH = "previous_month";
displayLookup['DATE_PERIOD."previous_month"'] = ["date period", "previous month"];
constants.DATE_PERIOD_PREVIOUS_YEAR = "previous_year";
displayLookup['DATE_PERIOD."previous_year"'] = ["date period", "previous year"];
constants.DATE_PERIOD_PREVIOUS_N_MONTH_1 = "previous_n_month_1";
displayLookup['DATE_PERIOD."previous_n_month_1"'] = ["date period", "previous n month 1"];
constants.DATE_PERIOD_PREVIOUS_N_MONTH_2 = "previous_n_month_2";
displayLookup['DATE_PERIOD."previous_n_month_2"'] = ["date period", "previous n month 2"];
constants.DATE_PERIOD_PREVIOUS_N_MONTH_3 = "previous_n_month_3";
displayLookup['DATE_PERIOD."previous_n_month_3"'] = ["date period", "previous n month 3"];
constants.DATE_PERIOD_PREVIOUS_N_MONTH_4 = "previous_n_month_4";
displayLookup['DATE_PERIOD."previous_n_month_4"'] = ["date period", "previous n month 4"];
constants.DATE_PERIOD_PREVIOUS_N_MONTH_5 = "previous_n_month_5";
displayLookup['DATE_PERIOD."previous_n_month_5"'] = ["date period", "previous n month 5"];
constants.DATE_PERIOD_PREVIOUS_N_MONTH_6 = "previous_n_month_6";
displayLookup['DATE_PERIOD."previous_n_month_6"'] = ["date period", "previous n month 6"];
constants.DATE_PERIOD_PREVIOUS_N_MONTH_7 = "previous_n_month_7";
displayLookup['DATE_PERIOD."previous_n_month_7"'] = ["date period", "previous n month 7"];
constants.DATE_PERIOD_PREVIOUS_N_MONTH_8 = "previous_n_month_8";
displayLookup['DATE_PERIOD."previous_n_month_8"'] = ["date period", "previous n month 8"];
constants.DATE_PERIOD_PREVIOUS_N_MONTH_9 = "previous_n_month_9";
displayLookup['DATE_PERIOD."previous_n_month_9"'] = ["date period", "previous n month 9"];
constants.DATE_PERIOD_PREVIOUS_N_MONTH_10 = "previous_n_month_10";
displayLookup['DATE_PERIOD."previous_n_month_10"'] = ["date period", "previous n month 10"];
constants.DATE_PERIOD_PREVIOUS_N_MONTH_11 = "previous_n_month_11";
displayLookup['DATE_PERIOD."previous_n_month_11"'] = ["date period", "previous n month 11"];
constants.DATE_PERIOD_PREVIOUS_N_MONTH_12 = "previous_n_month_12";
displayLookup['DATE_PERIOD."previous_n_month_12"'] = ["date period", "previous n month 12"];
constants.DATE_PERIOD_PREVIOUS_YEAR_LAST_7_DAYS = "previous_year_last_7_days";
displayLookup['DATE_PERIOD."previous_year_last_7_days"'] = ["date period", "previous year last 7 days"];
constants.DATE_PERIOD_PREVIOUS_YEAR_LAST_14_DAYS = "previous_year_last_14_days";
displayLookup['DATE_PERIOD."previous_year_last_14_days"'] = ["date period", "previous year last 14 days"];
constants.DATE_PERIOD_PREVIOUS_YEAR_LAST_30_DAYS = "previous_year_last_30_days";
displayLookup['DATE_PERIOD."previous_year_last_30_days"'] = ["date period", "previous year last 30 days"];
constants.DATE_PERIOD_PREVIOUS_YEAR_LAST_90_DAYS = "previous_year_last_90_days";
displayLookup['DATE_PERIOD."previous_year_last_90_days"'] = ["date period", "previous year last 90 days"];
constants.DATE_PERIOD_PREVIOUS_YEAR_LAST_180_DAYS = "previous_year_last_180_days";
displayLookup['DATE_PERIOD."previous_year_last_180_days"'] = ["date period", "previous year last 180 days"];
constants.DATE_PERIOD_PREVIOUS_YEAR_NEXT_7_DAYS = "previous_year_next_7_days";
displayLookup['DATE_PERIOD."previous_year_next_7_days"'] = ["date period", "previous year next 7 days"];
constants.DATE_PERIOD_PREVIOUS_YEAR_NEXT_14_DAYS = "previous_year_next_14_days";
displayLookup['DATE_PERIOD."previous_year_next_14_days"'] = ["date period", "previous year next 14 days"];
constants.DATE_PERIOD_PREVIOUS_YEAR_NEXT_30_DAYS = "previous_year_next_30_days";
displayLookup['DATE_PERIOD."previous_year_next_30_days"'] = ["date period", "previous year next 30 days"];
constants.DATE_PERIOD_PREVIOUS_YEAR_NEXT_90_DAYS = "previous_year_next_90_days";
displayLookup['DATE_PERIOD."previous_year_next_90_days"'] = ["date period", "previous year next 90 days"];
constants.DATE_PERIOD_PREVIOUS_YEAR_NEXT_180_DAYS = "previous_year_next_180_days";
displayLookup['DATE_PERIOD."previous_year_next_180_days"'] = ["date period", "previous year next 180 days"];
constants.DATE_PERIOD_TOMORROW = "tomorrow";
displayLookup['DATE_PERIOD."tomorrow"'] = ["date period", "tomorrow"];
constants.DATE_PERIOD_NEXT_WEEKDAY = "next_weekday";
displayLookup['DATE_PERIOD."next_weekday"'] = ["date period", "next weekday"];
constants.DATE_PERIOD_NEXT_WEEK = "next_week";
displayLookup['DATE_PERIOD."next_week"'] = ["date period", "next week"];
constants.DATE_PERIOD_NEXT_MONTH = "next_month";
displayLookup['DATE_PERIOD."next_month"'] = ["date period", "next month"];
constants.DATE_PERIOD_NEXT_YEAR = "next_year";
displayLookup['DATE_PERIOD."next_year"'] = ["date period", "next year"];
constants.DATE_PERIOD_NEXT_7_DAYS = "next_7_days";
displayLookup['DATE_PERIOD."next_7_days"'] = ["date period", "next 7 days"];
constants.DATE_PERIOD_NEXT_14_DAYS = "next_14_days";
displayLookup['DATE_PERIOD."next_14_days"'] = ["date period", "next 14 days"];
constants.DATE_PERIOD_NEXT_30_DAYS = "next_30_days";
displayLookup['DATE_PERIOD."next_30_days"'] = ["date period", "next 30 days"];
constants.DATE_PERIOD_NEXT_90_DAYS = "next_90_days";
displayLookup['DATE_PERIOD."next_90_days"'] = ["date period", "next 90 days"];
constants.DATE_PERIOD_NEXT_180_DAYS = "next_180_days";
displayLookup['DATE_PERIOD."next_180_days"'] = ["date period", "next 180 days"];
constants.DATE_PERIOD_NEXT_365_DAYS = "next_365_days";
displayLookup['DATE_PERIOD."next_365_days"'] = ["date period", "next 365 days"];
constants.DATE_PERIOD_YEAR_TO_DATE = "year_to_date";
displayLookup['DATE_PERIOD."year_to_date"'] = ["date period", "year to date"];
constants.DATE_PERIOD_MONTH_TO_DATE = "month_to_date";
displayLookup['DATE_PERIOD."month_to_date"'] = ["date period", "month to date"];
constants.DATE_PERIOD_LAST_YEAR_TO_DATE = "last_year_to_date";
displayLookup['DATE_PERIOD."last_year_to_date"'] = ["date period", "last year to date"];
constants.DATE_PERIOD_LAST_YEAR_MONTH_TO_DATE = "last_year_month_to_date";
displayLookup['DATE_PERIOD."last_year_month_to_date"'] = ["date period", "last year month to date"];
constants.DATE_PERIOD_FROM_BEGINNING = "from_beginning";
displayLookup['DATE_PERIOD."from_beginning"'] = ["date period", "from beginning"];

constants.DEPLOY_STATUS = {
  PENDING: { color: "#e5e5e5", label: [true], value: 1 },
  DEPLOY_STARTED: { color: "#ffb74d", label: [true], value: 2 },
  DEPLOYING: { color: "#ffb74d", label: [true], value: 3 },
  UPGRADING: { color: "#ffb74d", label: [true], value: 4 },
  AVAILABLE: { color: "#66bb6a", label: [true], value: 5 },
  DELETED: { color: "#e57373", label: [true], value: 300 },
  CANCELLED: { color: "#e57373", label: [true], value: 400 },
  FAILED: { color: "#e57373", label: [true], value: 500 }
};
constants.DEPLOY_STATUS_PENDING = 1;
displayLookup['DEPLOY_STATUS.1'] = ["deploy status", "pending"];
colorLookup['DEPLOY_STATUS.1'] = "#e5e5e5";
colorNameLookup['DEPLOY_STATUS.1'] = "GREY";
constants.DEPLOY_STATUS_DEPLOY_STARTED = 2;
displayLookup['DEPLOY_STATUS.2'] = ["deploy status", "deploy started"];
colorLookup['DEPLOY_STATUS.2'] = "#ffb74d";
colorNameLookup['DEPLOY_STATUS.2'] = "YELLOW";
constants.DEPLOY_STATUS_DEPLOYING = 3;
displayLookup['DEPLOY_STATUS.3'] = ["deploy status", "deploying"];
colorLookup['DEPLOY_STATUS.3'] = "#ffb74d";
colorNameLookup['DEPLOY_STATUS.3'] = "YELLOW";
constants.DEPLOY_STATUS_UPGRADING = 4;
displayLookup['DEPLOY_STATUS.4'] = ["deploy status", "upgrading"];
colorLookup['DEPLOY_STATUS.4'] = "#ffb74d";
colorNameLookup['DEPLOY_STATUS.4'] = "YELLOW";
constants.DEPLOY_STATUS_AVAILABLE = 5;
displayLookup['DEPLOY_STATUS.5'] = ["deploy status", "available"];
colorLookup['DEPLOY_STATUS.5'] = "#66bb6a";
colorNameLookup['DEPLOY_STATUS.5'] = "GREEN";
constants.DEPLOY_STATUS_DELETED = 300;
displayLookup['DEPLOY_STATUS.300'] = ["deploy status", "deleted"];
colorLookup['DEPLOY_STATUS.300'] = "#e57373";
colorNameLookup['DEPLOY_STATUS.300'] = "RED";
constants.DEPLOY_STATUS_CANCELLED = 400;
displayLookup['DEPLOY_STATUS.400'] = ["deploy status", "cancelled"];
colorLookup['DEPLOY_STATUS.400'] = "#e57373";
colorNameLookup['DEPLOY_STATUS.400'] = "RED";
constants.DEPLOY_STATUS_FAILED = 500;
displayLookup['DEPLOY_STATUS.500'] = ["deploy status", "failed"];
colorLookup['DEPLOY_STATUS.500'] = "#e57373";
colorNameLookup['DEPLOY_STATUS.500'] = "RED";

constants.DISCOUNT_TYPE = {
  PRICE: { color: null, label: ["discount type", "price"], value: 1 },
  PERCENT: { color: null, label: ["discount type", "percent"], value: 2 }
};
constants.DISCOUNT_TYPE_PRICE = 1;
displayLookup['DISCOUNT_TYPE.1'] = ["discount type", "price"];
constants.DISCOUNT_TYPE_PERCENT = 2;
displayLookup['DISCOUNT_TYPE.2'] = ["discount type", "percent"];

constants.DPD_PARCEL_TYPE = {
  CLASSIC: { color: null, label: true, value: "D" },
  PARCEL_SHOP: { color: null, label: true, value: "PS" }
};
constants.DPD_PARCEL_TYPE_CLASSIC = "D";
displayLookup['DPD_PARCEL_TYPE."D"'] = "classic";
constants.DPD_PARCEL_TYPE_PARCEL_SHOP = "PS";
displayLookup['DPD_PARCEL_TYPE."PS"'] = "parcel shop";

constants.DYNAMIC_DATE_RANGE_GRANULARITY = {
  DAY: { color: null, label: true, value: "day" },
  WEEK: { color: null, label: true, value: "week" },
  MONTH: { color: null, label: true, value: "month" },
  QUARTER: { color: null, label: true, value: "quarter" },
  YEAR: { color: null, label: true, value: "year" }
};
constants.DYNAMIC_DATE_RANGE_GRANULARITY_DAY = "day";
displayLookup['DYNAMIC_DATE_RANGE_GRANULARITY."day"'] = "day";
constants.DYNAMIC_DATE_RANGE_GRANULARITY_WEEK = "week";
displayLookup['DYNAMIC_DATE_RANGE_GRANULARITY."week"'] = "week";
constants.DYNAMIC_DATE_RANGE_GRANULARITY_MONTH = "month";
displayLookup['DYNAMIC_DATE_RANGE_GRANULARITY."month"'] = "month";
constants.DYNAMIC_DATE_RANGE_GRANULARITY_QUARTER = "quarter";
displayLookup['DYNAMIC_DATE_RANGE_GRANULARITY."quarter"'] = "quarter";
constants.DYNAMIC_DATE_RANGE_GRANULARITY_YEAR = "year";
displayLookup['DYNAMIC_DATE_RANGE_GRANULARITY."year"'] = "year";

constants.EDI_STATUS = {
  SUCCESS: { color: null, label: true, value: 1 },
  FAILED: { color: null, label: true, value: 2 }
};
constants.EDI_STATUS_SUCCESS = 1;
displayLookup['EDI_STATUS.1'] = "success";
constants.EDI_STATUS_FAILED = 2;
displayLookup['EDI_STATUS.2'] = "failed";

constants.EXPENSE_FILING_STATUS = {
  NOT_REQUIRED: { color: "#e57373", label: "Not to be filed", value: 1 },
  NOT_FILED: { color: "#ffb74d", label: "To be filed", value: 10 },
  FILED: { color: "#64b5f6", label: true, value: 100 },
  UNKNOWN: { color: "#e57373", label: true, value: 1000 }
};
constants.EXPENSE_FILING_STATUS_NOT_REQUIRED = 1;
displayLookup['EXPENSE_FILING_STATUS.1'] = "Not to be filed";
colorLookup['EXPENSE_FILING_STATUS.1'] = "#e57373";
colorNameLookup['EXPENSE_FILING_STATUS.1'] = "RED";
constants.EXPENSE_FILING_STATUS_NOT_FILED = 10;
displayLookup['EXPENSE_FILING_STATUS.10'] = "To be filed";
colorLookup['EXPENSE_FILING_STATUS.10'] = "#ffb74d";
colorNameLookup['EXPENSE_FILING_STATUS.10'] = "YELLOW";
constants.EXPENSE_FILING_STATUS_FILED = 100;
displayLookup['EXPENSE_FILING_STATUS.100'] = "filed";
colorLookup['EXPENSE_FILING_STATUS.100'] = "#64b5f6";
colorNameLookup['EXPENSE_FILING_STATUS.100'] = "BLUE";
constants.EXPENSE_FILING_STATUS_UNKNOWN = 1000;
displayLookup['EXPENSE_FILING_STATUS.1000'] = "unknown";
colorLookup['EXPENSE_FILING_STATUS.1000'] = "#e57373";
colorNameLookup['EXPENSE_FILING_STATUS.1000'] = "RED";

constants.EXPRESSION_TYPE = {
  SQL_FORMULA: { color: null, label: true, value: 1 },
  CONDITION: { color: null, label: true, value: 2 },
  ACTION: { color: null, label: true, value: 3 },
  QUERY: { color: null, label: true, value: 4 },
  PYTHON_FORMULA: { color: null, label: true, value: 5 }
};
constants.EXPRESSION_TYPE_SQL_FORMULA = 1;
displayLookup['EXPRESSION_TYPE.1'] = "sql formula";
constants.EXPRESSION_TYPE_CONDITION = 2;
displayLookup['EXPRESSION_TYPE.2'] = "condition";
constants.EXPRESSION_TYPE_ACTION = 3;
displayLookup['EXPRESSION_TYPE.3'] = "action";
constants.EXPRESSION_TYPE_QUERY = 4;
displayLookup['EXPRESSION_TYPE.4'] = "query";
constants.EXPRESSION_TYPE_PYTHON_FORMULA = 5;
displayLookup['EXPRESSION_TYPE.5'] = "python formula";

constants.EXPRESS_ONE_EXTRA_SERVICE = {
  INSURANCE: { color: null, label: true, value: "INSURANCE" },
  ITEMIZED: { color: null, label: true, value: "ITEMIZED" },
  SMS_NOTIFICATION: { color: null, label: true, value: "SMS_NOTIFICATION" },
  EMAIL_NOTIFICATION: { color: null, label: true, value: "EMAIL_NOTIFICATION" },
  DOCUMENTS_MANAGEMENT: { color: null, label: true, value: "DOCUMENTS_MANAGEMENT" },
  RETURN: { color: null, label: true, value: "return" }
};
constants.EXPRESS_ONE_EXTRA_SERVICE_INSURANCE = "INSURANCE";
displayLookup['EXPRESS_ONE_EXTRA_SERVICE."INSURANCE"'] = "insurance";
constants.EXPRESS_ONE_EXTRA_SERVICE_ITEMIZED = "ITEMIZED";
displayLookup['EXPRESS_ONE_EXTRA_SERVICE."ITEMIZED"'] = "itemized";
constants.EXPRESS_ONE_EXTRA_SERVICE_SMS_NOTIFICATION = "SMS_NOTIFICATION";
displayLookup['EXPRESS_ONE_EXTRA_SERVICE."SMS_NOTIFICATION"'] = "sms notification";
constants.EXPRESS_ONE_EXTRA_SERVICE_EMAIL_NOTIFICATION = "EMAIL_NOTIFICATION";
displayLookup['EXPRESS_ONE_EXTRA_SERVICE."EMAIL_NOTIFICATION"'] = "email notification";
constants.EXPRESS_ONE_EXTRA_SERVICE_DOCUMENTS_MANAGEMENT = "DOCUMENTS_MANAGEMENT";
displayLookup['EXPRESS_ONE_EXTRA_SERVICE."DOCUMENTS_MANAGEMENT"'] = "documents management";
constants.EXPRESS_ONE_EXTRA_SERVICE_RETURN = "return";
displayLookup['EXPRESS_ONE_EXTRA_SERVICE."return"'] = "return";

constants.EXPRESS_ONE_PARCEL_TYPE = {
  PACKET: { color: null, label: true, value: "0" },
  PALLET: { color: null, label: true, value: "1" }
};
constants.EXPRESS_ONE_PARCEL_TYPE_PACKET = "0";
displayLookup['EXPRESS_ONE_PARCEL_TYPE."0"'] = "packet";
constants.EXPRESS_ONE_PARCEL_TYPE_PALLET = "1";
displayLookup['EXPRESS_ONE_PARCEL_TYPE."1"'] = "pallet";

constants.EXPRESS_ONE_SERVICE_TYPE = {
  X24H: { color: null, label: "Standard delivery next working day", value: "24H" },
  X12H: { color: null, label: "Express delivery until 12:00", value: "12H" },
  EXP: { color: null, label: "ExpressOne Export", value: "EXP" },
  D2S: { color: null, label: "Delivery to tofShop", value: "D2S" },
  EST: { color: null, label: "Delivery at night", value: "EST" },
  X08H: { color: null, label: "Express delivery until 8:00", value: "08H" },
  X10H: { color: null, label: "Express delivery until 10:00", value: "10H" },
  ARU: { color: null, label: "Express pickup next working day", value: "ARU" },
  AR3: { color: null, label: "Express pickup third party pays", value: "AR3" }
};
constants.EXPRESS_ONE_SERVICE_TYPE_X24H = "24H";
displayLookup['EXPRESS_ONE_SERVICE_TYPE."24H"'] = "Standard delivery next working day";
constants.EXPRESS_ONE_SERVICE_TYPE_X12H = "12H";
displayLookup['EXPRESS_ONE_SERVICE_TYPE."12H"'] = "Express delivery until 12:00";
constants.EXPRESS_ONE_SERVICE_TYPE_EXP = "EXP";
displayLookup['EXPRESS_ONE_SERVICE_TYPE."EXP"'] = "ExpressOne Export";
constants.EXPRESS_ONE_SERVICE_TYPE_D2S = "D2S";
displayLookup['EXPRESS_ONE_SERVICE_TYPE."D2S"'] = "Delivery to tofShop";
constants.EXPRESS_ONE_SERVICE_TYPE_EST = "EST";
displayLookup['EXPRESS_ONE_SERVICE_TYPE."EST"'] = "Delivery at night";
constants.EXPRESS_ONE_SERVICE_TYPE_X08H = "08H";
displayLookup['EXPRESS_ONE_SERVICE_TYPE."08H"'] = "Express delivery until 8:00";
constants.EXPRESS_ONE_SERVICE_TYPE_X10H = "10H";
displayLookup['EXPRESS_ONE_SERVICE_TYPE."10H"'] = "Express delivery until 10:00";
constants.EXPRESS_ONE_SERVICE_TYPE_ARU = "ARU";
displayLookup['EXPRESS_ONE_SERVICE_TYPE."ARU"'] = "Express pickup next working day";
constants.EXPRESS_ONE_SERVICE_TYPE_AR3 = "AR3";
displayLookup['EXPRESS_ONE_SERVICE_TYPE."AR3"'] = "Express pickup third party pays";

constants.EXPRESS_ONE_STICKER_SIZE = {
  A4: { color: null, label: true, value: "A4" },
  X100_X_150: { color: null, label: "10x15cm", value: "100x150" }
};
constants.EXPRESS_ONE_STICKER_SIZE_A4 = "A4";
displayLookup['EXPRESS_ONE_STICKER_SIZE."A4"'] = "a4";
constants.EXPRESS_ONE_STICKER_SIZE_X100_X_150 = "100x150";
displayLookup['EXPRESS_ONE_STICKER_SIZE."100x150"'] = "10x15cm";

constants.FINANCIAL_CATEGORY_AUDIT_SUGGESTION_ACTION = {
  CREATE: { color: null, label: true, value: "create" },
  UPDATE: { color: null, label: true, value: "update" },
  MERGE_DELETE: { color: null, label: true, value: "merge_delete" }
};
constants.FINANCIAL_CATEGORY_AUDIT_SUGGESTION_ACTION_CREATE = "create";
displayLookup['FINANCIAL_CATEGORY_AUDIT_SUGGESTION_ACTION."create"'] = "create";
constants.FINANCIAL_CATEGORY_AUDIT_SUGGESTION_ACTION_UPDATE = "update";
displayLookup['FINANCIAL_CATEGORY_AUDIT_SUGGESTION_ACTION."update"'] = "update";
constants.FINANCIAL_CATEGORY_AUDIT_SUGGESTION_ACTION_MERGE_DELETE = "merge_delete";
displayLookup['FINANCIAL_CATEGORY_AUDIT_SUGGESTION_ACTION."merge_delete"'] = "merge delete";

constants.FINANCIAL_CATEGORY_AUDIT_SUGGESTION_STATUS = {
  PENDING: { color: "#ffb74d", label: true, value: 1 },
  APPLIED: { color: "#66bb6a", label: true, value: 2 },
  DECLINED: { color: "#e5e5e5", label: true, value: 3 }
};
constants.FINANCIAL_CATEGORY_AUDIT_SUGGESTION_STATUS_PENDING = 1;
displayLookup['FINANCIAL_CATEGORY_AUDIT_SUGGESTION_STATUS.1'] = "pending";
colorLookup['FINANCIAL_CATEGORY_AUDIT_SUGGESTION_STATUS.1'] = "#ffb74d";
colorNameLookup['FINANCIAL_CATEGORY_AUDIT_SUGGESTION_STATUS.1'] = "YELLOW";
constants.FINANCIAL_CATEGORY_AUDIT_SUGGESTION_STATUS_APPLIED = 2;
displayLookup['FINANCIAL_CATEGORY_AUDIT_SUGGESTION_STATUS.2'] = "applied";
colorLookup['FINANCIAL_CATEGORY_AUDIT_SUGGESTION_STATUS.2'] = "#66bb6a";
colorNameLookup['FINANCIAL_CATEGORY_AUDIT_SUGGESTION_STATUS.2'] = "GREEN";
constants.FINANCIAL_CATEGORY_AUDIT_SUGGESTION_STATUS_DECLINED = 3;
displayLookup['FINANCIAL_CATEGORY_AUDIT_SUGGESTION_STATUS.3'] = "declined";
colorLookup['FINANCIAL_CATEGORY_AUDIT_SUGGESTION_STATUS.3'] = "#e5e5e5";
colorNameLookup['FINANCIAL_CATEGORY_AUDIT_SUGGESTION_STATUS.3'] = "GREY";

constants.FORMULA_IMPORT_MODE = {
  APPEND: { color: null, label: true, value: 1 },
  OVERWRITE: { color: null, label: true, value: 2 }
};
constants.FORMULA_IMPORT_MODE_APPEND = 1;
displayLookup['FORMULA_IMPORT_MODE.1'] = "append";
constants.FORMULA_IMPORT_MODE_OVERWRITE = 2;
displayLookup['FORMULA_IMPORT_MODE.2'] = "overwrite";

constants.FORMULA_ROUNDING_METHOD = {
  NATURAL: { color: null, label: true, value: 1 },
  FLOOR: { color: null, label: true, value: 2 },
  CEIL: { color: null, label: true, value: 3 }
};
constants.FORMULA_ROUNDING_METHOD_NATURAL = 1;
displayLookup['FORMULA_ROUNDING_METHOD.1'] = "natural";
constants.FORMULA_ROUNDING_METHOD_FLOOR = 2;
displayLookup['FORMULA_ROUNDING_METHOD.2'] = "floor";
constants.FORMULA_ROUNDING_METHOD_CEIL = 3;
displayLookup['FORMULA_ROUNDING_METHOD.3'] = "ceil";

constants.FORMULA_ROUNDING_TARGET = {
  NET: { color: null, label: true, value: 1 },
  GROSS: { color: null, label: true, value: 2 }
};
constants.FORMULA_ROUNDING_TARGET_NET = 1;
displayLookup['FORMULA_ROUNDING_TARGET.1'] = "net";
constants.FORMULA_ROUNDING_TARGET_GROSS = 2;
displayLookup['FORMULA_ROUNDING_TARGET.2'] = "gross";

constants.FORMULA_TYPE = {
  PRICE_LIST: { color: null, label: true, value: 1 },
  ORDER: { color: null, label: true, value: 2 },
  PURCHASE_ORDER: { color: null, label: true, value: 3 },
  EXCHANGE_RATE: { color: null, label: true, value: 4 },
  STOCK_QUANTITY: { color: null, label: true, value: 5 },
  ROW_COLOR: { color: null, label: true, value: 6 }
};
constants.FORMULA_TYPE_PRICE_LIST = 1;
displayLookup['FORMULA_TYPE.1'] = "price list";
constants.FORMULA_TYPE_ORDER = 2;
displayLookup['FORMULA_TYPE.2'] = "order";
constants.FORMULA_TYPE_PURCHASE_ORDER = 3;
displayLookup['FORMULA_TYPE.3'] = "purchase order";
constants.FORMULA_TYPE_EXCHANGE_RATE = 4;
displayLookup['FORMULA_TYPE.4'] = "exchange rate";
constants.FORMULA_TYPE_STOCK_QUANTITY = 5;
displayLookup['FORMULA_TYPE.5'] = "stock quantity";
constants.FORMULA_TYPE_ROW_COLOR = 6;
displayLookup['FORMULA_TYPE.6'] = "row color";

constants.FOXPOST_PARCEL_SIZE = {
  EXTRA_SMALL: { color: null, label: true, value: "XS" },
  SMALL: { color: null, label: true, value: "S" },
  MEDIUM: { color: null, label: true, value: "M" },
  LARGE: { color: null, label: true, value: "L" },
  EXTRA_LARGE: { color: null, label: true, value: "XL" }
};
constants.FOXPOST_PARCEL_SIZE_EXTRA_SMALL = "XS";
displayLookup['FOXPOST_PARCEL_SIZE."XS"'] = "extra small";
constants.FOXPOST_PARCEL_SIZE_SMALL = "S";
displayLookup['FOXPOST_PARCEL_SIZE."S"'] = "small";
constants.FOXPOST_PARCEL_SIZE_MEDIUM = "M";
displayLookup['FOXPOST_PARCEL_SIZE."M"'] = "medium";
constants.FOXPOST_PARCEL_SIZE_LARGE = "L";
displayLookup['FOXPOST_PARCEL_SIZE."L"'] = "large";
constants.FOXPOST_PARCEL_SIZE_EXTRA_LARGE = "XL";
displayLookup['FOXPOST_PARCEL_SIZE."XL"'] = "extra large";

constants.FOXPOST_PARTNER_TYPE = {
  B2B: { color: null, label: true, value: "B2B" },
  B2C: { color: null, label: true, value: "B2C" },
  C2B: { color: null, label: true, value: "C2B" },
  C2C: { color: null, label: true, value: "C2C" }
};
constants.FOXPOST_PARTNER_TYPE_B2B = "B2B";
displayLookup['FOXPOST_PARTNER_TYPE."B2B"'] = "b2b";
constants.FOXPOST_PARTNER_TYPE_B2C = "B2C";
displayLookup['FOXPOST_PARTNER_TYPE."B2C"'] = "b2c";
constants.FOXPOST_PARTNER_TYPE_C2B = "C2B";
displayLookup['FOXPOST_PARTNER_TYPE."C2B"'] = "c2b";
constants.FOXPOST_PARTNER_TYPE_C2C = "C2C";
displayLookup['FOXPOST_PARTNER_TYPE."C2C"'] = "c2c";

constants.FOXPOST_SEND_TYPE = {
  HOME_DELIVERY: { color: null, label: true, value: "HD" },
  PARCEL_POINT: { color: null, label: true, value: "APM" }
};
constants.FOXPOST_SEND_TYPE_HOME_DELIVERY = "HD";
displayLookup['FOXPOST_SEND_TYPE."HD"'] = "home delivery";
constants.FOXPOST_SEND_TYPE_PARCEL_POINT = "APM";
displayLookup['FOXPOST_SEND_TYPE."APM"'] = "parcel point";

constants.FOXPOST_STICKER_SIZE = {
  A5: { color: null, label: true, value: "a5" },
  A6: { color: null, label: true, value: "a6" },
  A7: { color: null, label: true, value: "a7" },
  _85X85: { color: null, label: "85X85", value: "_85x85" }
};
constants.FOXPOST_STICKER_SIZE_A5 = "a5";
displayLookup['FOXPOST_STICKER_SIZE."a5"'] = "a5";
constants.FOXPOST_STICKER_SIZE_A6 = "a6";
displayLookup['FOXPOST_STICKER_SIZE."a6"'] = "a6";
constants.FOXPOST_STICKER_SIZE_A7 = "a7";
displayLookup['FOXPOST_STICKER_SIZE."a7"'] = "a7";
constants.FOXPOST_STICKER_SIZE__85X85 = "_85x85";
displayLookup['FOXPOST_STICKER_SIZE."_85x85"'] = "85X85";

constants.FTP_PROTOCOL = {
  FTP: { color: null, label: [true], value: 1 },
  SFTP: { color: null, label: [true], value: 2 },
  FTPS: { color: null, label: [true], value: 3 }
};
constants.FTP_PROTOCOL_FTP = 1;
displayLookup['FTP_PROTOCOL.1'] = ["ftp protocol", "ftp"];
constants.FTP_PROTOCOL_SFTP = 2;
displayLookup['FTP_PROTOCOL.2'] = ["ftp protocol", "sftp"];
constants.FTP_PROTOCOL_FTPS = 3;
displayLookup['FTP_PROTOCOL.3'] = ["ftp protocol", "ftps"];

constants.GLS_CONTENT_TYPE = {
  COD: { color: null, label: true, value: 1 },
  INVOICE: { color: null, label: true, value: 100 }
};
constants.GLS_CONTENT_TYPE_COD = 1;
displayLookup['GLS_CONTENT_TYPE.1'] = "cod";
constants.GLS_CONTENT_TYPE_INVOICE = 100;
displayLookup['GLS_CONTENT_TYPE.100'] = "invoice";

constants.GLS_COUNTRY = {
  HUNGARY: { color: null, label: true, value: "hu" },
  CROATIA: { color: null, label: true, value: "hr" },
  CZECHIA: { color: null, label: true, value: "cz" },
  ROMANIA: { color: null, label: true, value: "ro" },
  SLOVENIA: { color: null, label: true, value: "si" },
  SLOVAKIA: { color: null, label: true, value: "sk" }
};
constants.GLS_COUNTRY_HUNGARY = "hu";
displayLookup['GLS_COUNTRY."hu"'] = "hungary";
constants.GLS_COUNTRY_CROATIA = "hr";
displayLookup['GLS_COUNTRY."hr"'] = "croatia";
constants.GLS_COUNTRY_CZECHIA = "cz";
displayLookup['GLS_COUNTRY."cz"'] = "czechia";
constants.GLS_COUNTRY_ROMANIA = "ro";
displayLookup['GLS_COUNTRY."ro"'] = "romania";
constants.GLS_COUNTRY_SLOVENIA = "si";
displayLookup['GLS_COUNTRY."si"'] = "slovenia";
constants.GLS_COUNTRY_SLOVAKIA = "sk";
displayLookup['GLS_COUNTRY."sk"'] = "slovakia";

constants.GLS_EXTRA_SERVICE = {
  FLEX_DELIVERY: { color: null, label: "FlexDeliveryService", value: "FDS" },
  CONTACT: { color: null, label: "ContactService", value: "CS1" },
  PRE_ADVICE: { color: null, label: "PreAdviceService", value: "SM2" },
  SMS: { color: null, label: "SMSService", value: "SM1" },
  ADDRESSEE_ONLY: { color: null, label: "AddresseeOnly", value: "AOS" },
  DOCUMENT_RETURN_SERVICE: { color: null, label: "DocumentReturnService", value: "SZL" },
  HAZARDOUS_GOODS: { color: null, label: "HazardousGoodsService", value: "ADR" },
  DECLARED_VALUE_INSURANCE: { color: null, label: "DeclaredValueInsuranceService", value: "INS" },
  GUARANTEED_24: { color: null, label: "Guaranteed24Service", value: "24H" },
  DAY_DEFINITE: { color: null, label: "DayDefiniteService", value: "DDS" },
  SCHEDULED_DELIVERY: { color: null, label: "ScheduledDeliveryService", value: "SDS" },
  SATURDAY: { color: null, label: "SaturdayService", value: "SAT" },
  EXPRESS_DELIVERY_SERVICE: { color: null, label: "ExpressDeliveryService", value: "T12" },
  EXCHANGE_SERVICE: { color: null, label: "ExchangeService", value: "XS" },
  USED_MACHINE_SERVICE: { color: null, label: "UsedMachineService", value: "USM" }
};
constants.GLS_EXTRA_SERVICE_FLEX_DELIVERY = "FDS";
displayLookup['GLS_EXTRA_SERVICE."FDS"'] = "FlexDeliveryService";
constants.GLS_EXTRA_SERVICE_CONTACT = "CS1";
displayLookup['GLS_EXTRA_SERVICE."CS1"'] = "ContactService";
constants.GLS_EXTRA_SERVICE_PRE_ADVICE = "SM2";
displayLookup['GLS_EXTRA_SERVICE."SM2"'] = "PreAdviceService";
constants.GLS_EXTRA_SERVICE_SMS = "SM1";
displayLookup['GLS_EXTRA_SERVICE."SM1"'] = "SMSService";
constants.GLS_EXTRA_SERVICE_ADDRESSEE_ONLY = "AOS";
displayLookup['GLS_EXTRA_SERVICE."AOS"'] = "AddresseeOnly";
constants.GLS_EXTRA_SERVICE_DOCUMENT_RETURN_SERVICE = "SZL";
displayLookup['GLS_EXTRA_SERVICE."SZL"'] = "DocumentReturnService";
constants.GLS_EXTRA_SERVICE_HAZARDOUS_GOODS = "ADR";
displayLookup['GLS_EXTRA_SERVICE."ADR"'] = "HazardousGoodsService";
constants.GLS_EXTRA_SERVICE_DECLARED_VALUE_INSURANCE = "INS";
displayLookup['GLS_EXTRA_SERVICE."INS"'] = "DeclaredValueInsuranceService";
constants.GLS_EXTRA_SERVICE_GUARANTEED_24 = "24H";
displayLookup['GLS_EXTRA_SERVICE."24H"'] = "Guaranteed24Service";
constants.GLS_EXTRA_SERVICE_DAY_DEFINITE = "DDS";
displayLookup['GLS_EXTRA_SERVICE."DDS"'] = "DayDefiniteService";
constants.GLS_EXTRA_SERVICE_SCHEDULED_DELIVERY = "SDS";
displayLookup['GLS_EXTRA_SERVICE."SDS"'] = "ScheduledDeliveryService";
constants.GLS_EXTRA_SERVICE_SATURDAY = "SAT";
displayLookup['GLS_EXTRA_SERVICE."SAT"'] = "SaturdayService";
constants.GLS_EXTRA_SERVICE_EXPRESS_DELIVERY_SERVICE = "T12";
displayLookup['GLS_EXTRA_SERVICE."T12"'] = "ExpressDeliveryService";
constants.GLS_EXTRA_SERVICE_EXCHANGE_SERVICE = "XS";
displayLookup['GLS_EXTRA_SERVICE."XS"'] = "ExchangeService";
constants.GLS_EXTRA_SERVICE_USED_MACHINE_SERVICE = "USM";
displayLookup['GLS_EXTRA_SERVICE."USM"'] = "UsedMachineService";

constants.GLS_HAZARDOUS_AMOUNT_UNIT = {
  KG: { color: null, label: true, value: 1 },
  G: { color: null, label: true, value: 2 },
  L: { color: null, label: true, value: 3 },
  ML: { color: null, label: true, value: 4 },
  PCS: { color: null, label: true, value: 5 },
  BLOCK: { color: null, label: true, value: 6 },
  ROLL: { color: null, label: true, value: 7 },
  MG: { color: null, label: true, value: 8 },
  SHEET: { color: null, label: true, value: 9 }
};
constants.GLS_HAZARDOUS_AMOUNT_UNIT_KG = 1;
displayLookup['GLS_HAZARDOUS_AMOUNT_UNIT.1'] = "kg";
constants.GLS_HAZARDOUS_AMOUNT_UNIT_G = 2;
displayLookup['GLS_HAZARDOUS_AMOUNT_UNIT.2'] = "g";
constants.GLS_HAZARDOUS_AMOUNT_UNIT_L = 3;
displayLookup['GLS_HAZARDOUS_AMOUNT_UNIT.3'] = "l";
constants.GLS_HAZARDOUS_AMOUNT_UNIT_ML = 4;
displayLookup['GLS_HAZARDOUS_AMOUNT_UNIT.4'] = "ml";
constants.GLS_HAZARDOUS_AMOUNT_UNIT_PCS = 5;
displayLookup['GLS_HAZARDOUS_AMOUNT_UNIT.5'] = "pcs";
constants.GLS_HAZARDOUS_AMOUNT_UNIT_BLOCK = 6;
displayLookup['GLS_HAZARDOUS_AMOUNT_UNIT.6'] = "block";
constants.GLS_HAZARDOUS_AMOUNT_UNIT_ROLL = 7;
displayLookup['GLS_HAZARDOUS_AMOUNT_UNIT.7'] = "roll";
constants.GLS_HAZARDOUS_AMOUNT_UNIT_MG = 8;
displayLookup['GLS_HAZARDOUS_AMOUNT_UNIT.8'] = "mg";
constants.GLS_HAZARDOUS_AMOUNT_UNIT_SHEET = 9;
displayLookup['GLS_HAZARDOUS_AMOUNT_UNIT.9'] = "sheet";

constants.GLS_HAZARDOUS_ITEM_TYPE = {
  EQ: { color: null, label: true, value: 1 },
  LQ: { color: null, label: true, value: 2 }
};
constants.GLS_HAZARDOUS_ITEM_TYPE_EQ = 1;
displayLookup['GLS_HAZARDOUS_ITEM_TYPE.1'] = "eq";
constants.GLS_HAZARDOUS_ITEM_TYPE_LQ = 2;
displayLookup['GLS_HAZARDOUS_ITEM_TYPE.2'] = "lq";

constants.GLS_OPEN_NETWORK_RESERVATION_STATUS = {
  RESERVED: { color: "#64b5f6", label: true, value: 10 },
  CANCELLED: { color: "#e57373", label: true, value: 20 },
  DEPOSITED: { color: "#ffb74d", label: true, value: 30 },
  EXPIRED: { color: "#e57373", label: true, value: 40 },
  EXPIRED_INBOX: { color: "#e57373", label: "expired inbox", value: 41 },
  REFUSED: { color: "#e57373", label: true, value: 50 },
  RETURNED: { color: "#e57373", label: true, value: 60 },
  DELIVERED: { color: "#66bb6a", label: true, value: 70 }
};
constants.GLS_OPEN_NETWORK_RESERVATION_STATUS_RESERVED = 10;
displayLookup['GLS_OPEN_NETWORK_RESERVATION_STATUS.10'] = "reserved";
colorLookup['GLS_OPEN_NETWORK_RESERVATION_STATUS.10'] = "#64b5f6";
colorNameLookup['GLS_OPEN_NETWORK_RESERVATION_STATUS.10'] = "BLUE";
constants.GLS_OPEN_NETWORK_RESERVATION_STATUS_CANCELLED = 20;
displayLookup['GLS_OPEN_NETWORK_RESERVATION_STATUS.20'] = "cancelled";
colorLookup['GLS_OPEN_NETWORK_RESERVATION_STATUS.20'] = "#e57373";
colorNameLookup['GLS_OPEN_NETWORK_RESERVATION_STATUS.20'] = "RED";
constants.GLS_OPEN_NETWORK_RESERVATION_STATUS_DEPOSITED = 30;
displayLookup['GLS_OPEN_NETWORK_RESERVATION_STATUS.30'] = "deposited";
colorLookup['GLS_OPEN_NETWORK_RESERVATION_STATUS.30'] = "#ffb74d";
colorNameLookup['GLS_OPEN_NETWORK_RESERVATION_STATUS.30'] = "YELLOW";
constants.GLS_OPEN_NETWORK_RESERVATION_STATUS_EXPIRED = 40;
displayLookup['GLS_OPEN_NETWORK_RESERVATION_STATUS.40'] = "expired";
colorLookup['GLS_OPEN_NETWORK_RESERVATION_STATUS.40'] = "#e57373";
colorNameLookup['GLS_OPEN_NETWORK_RESERVATION_STATUS.40'] = "RED";
constants.GLS_OPEN_NETWORK_RESERVATION_STATUS_EXPIRED_INBOX = 41;
displayLookup['GLS_OPEN_NETWORK_RESERVATION_STATUS.41'] = "expired inbox";
colorLookup['GLS_OPEN_NETWORK_RESERVATION_STATUS.41'] = "#e57373";
colorNameLookup['GLS_OPEN_NETWORK_RESERVATION_STATUS.41'] = "RED";
constants.GLS_OPEN_NETWORK_RESERVATION_STATUS_REFUSED = 50;
displayLookup['GLS_OPEN_NETWORK_RESERVATION_STATUS.50'] = "refused";
colorLookup['GLS_OPEN_NETWORK_RESERVATION_STATUS.50'] = "#e57373";
colorNameLookup['GLS_OPEN_NETWORK_RESERVATION_STATUS.50'] = "RED";
constants.GLS_OPEN_NETWORK_RESERVATION_STATUS_RETURNED = 60;
displayLookup['GLS_OPEN_NETWORK_RESERVATION_STATUS.60'] = "returned";
colorLookup['GLS_OPEN_NETWORK_RESERVATION_STATUS.60'] = "#e57373";
colorNameLookup['GLS_OPEN_NETWORK_RESERVATION_STATUS.60'] = "RED";
constants.GLS_OPEN_NETWORK_RESERVATION_STATUS_DELIVERED = 70;
displayLookup['GLS_OPEN_NETWORK_RESERVATION_STATUS.70'] = "delivered";
colorLookup['GLS_OPEN_NETWORK_RESERVATION_STATUS.70'] = "#66bb6a";
colorNameLookup['GLS_OPEN_NETWORK_RESERVATION_STATUS.70'] = "GREEN";

constants.GLS_SERVICE_TYPE = {
  FLEX_DELIVERY: { color: null, label: "FlexDelivery", value: "FDS" },
  PICK_AND_RETURN: { color: null, label: "Pick&Return", value: "PRS" },
  PICK_AND_SHIP: { color: null, label: "Pick&Ship", value: "PSS" },
  EXCHANGE: { color: null, label: true, value: "XS" },
  SHOP_DELIVERY: { color: null, label: "ShopDelivery", value: "PSD" },
  XXL: { color: null, label: true, value: "XXL" }
};
constants.GLS_SERVICE_TYPE_FLEX_DELIVERY = "FDS";
displayLookup['GLS_SERVICE_TYPE."FDS"'] = "FlexDelivery";
constants.GLS_SERVICE_TYPE_PICK_AND_RETURN = "PRS";
displayLookup['GLS_SERVICE_TYPE."PRS"'] = "Pick&Return";
constants.GLS_SERVICE_TYPE_PICK_AND_SHIP = "PSS";
displayLookup['GLS_SERVICE_TYPE."PSS"'] = "Pick&Ship";
constants.GLS_SERVICE_TYPE_EXCHANGE = "XS";
displayLookup['GLS_SERVICE_TYPE."XS"'] = "exchange";
constants.GLS_SERVICE_TYPE_SHOP_DELIVERY = "PSD";
displayLookup['GLS_SERVICE_TYPE."PSD"'] = "ShopDelivery";
constants.GLS_SERVICE_TYPE_XXL = "XXL";
displayLookup['GLS_SERVICE_TYPE."XXL"'] = "xxl";

constants.GLS_TRACKING_STATUS = {
  DELIVERED: { color: null, label: true, value: "5" },
  REFUSED: { color: null, label: true, value: "17" },
  PARCEL_TIMEOUT: { color: null, label: true, value: "57" },
  BACK_TO_THE_SHIPPER: { color: null, label: true, value: "23" },
  SIGNED: { color: null, label: true, value: "92" }
};
constants.GLS_TRACKING_STATUS_DELIVERED = "5";
displayLookup['GLS_TRACKING_STATUS."5"'] = "delivered";
constants.GLS_TRACKING_STATUS_REFUSED = "17";
displayLookup['GLS_TRACKING_STATUS."17"'] = "refused";
constants.GLS_TRACKING_STATUS_PARCEL_TIMEOUT = "57";
displayLookup['GLS_TRACKING_STATUS."57"'] = "parcel timeout";
constants.GLS_TRACKING_STATUS_BACK_TO_THE_SHIPPER = "23";
displayLookup['GLS_TRACKING_STATUS."23"'] = "back to the shipper";
constants.GLS_TRACKING_STATUS_SIGNED = "92";
displayLookup['GLS_TRACKING_STATUS."92"'] = "signed";

constants.GLS_USM_RETURN_ADDRESS_TYPE = {
  ADDRESS: { color: null, label: true, value: "address" },
  GLS_DEPOT: { color: null, label: "GLS depot", value: "gls_depot" }
};
constants.GLS_USM_RETURN_ADDRESS_TYPE_ADDRESS = "address";
displayLookup['GLS_USM_RETURN_ADDRESS_TYPE."address"'] = "address";
constants.GLS_USM_RETURN_ADDRESS_TYPE_GLS_DEPOT = "gls_depot";
displayLookup['GLS_USM_RETURN_ADDRESS_TYPE."gls_depot"'] = "GLS depot";

constants.GLS_XXL_PACKAGE_TYPE = {
  COLLI: { color: null, label: ["gls xxl package type", "colli"], value: 1 },
  BOX: { color: null, label: ["gls xxl package type", "box"], value: 2 },
  ROLL: { color: null, label: ["gls xxl package type", "roll"], value: 3 },
  CAN: { color: null, label: ["gls xxl package type", "can"], value: 4 },
  CASE: { color: null, label: ["gls xxl package type", "case"], value: 5 },
  REEL: { color: null, label: ["gls xxl package type", "reel"], value: 6 },
  SACK: { color: null, label: ["gls xxl package type", "sack"], value: 7 }
};
constants.GLS_XXL_PACKAGE_TYPE_COLLI = 1;
displayLookup['GLS_XXL_PACKAGE_TYPE.1'] = ["gls xxl package type", "colli"];
constants.GLS_XXL_PACKAGE_TYPE_BOX = 2;
displayLookup['GLS_XXL_PACKAGE_TYPE.2'] = ["gls xxl package type", "box"];
constants.GLS_XXL_PACKAGE_TYPE_ROLL = 3;
displayLookup['GLS_XXL_PACKAGE_TYPE.3'] = ["gls xxl package type", "roll"];
constants.GLS_XXL_PACKAGE_TYPE_CAN = 4;
displayLookup['GLS_XXL_PACKAGE_TYPE.4'] = ["gls xxl package type", "can"];
constants.GLS_XXL_PACKAGE_TYPE_CASE = 5;
displayLookup['GLS_XXL_PACKAGE_TYPE.5'] = ["gls xxl package type", "case"];
constants.GLS_XXL_PACKAGE_TYPE_REEL = 6;
displayLookup['GLS_XXL_PACKAGE_TYPE.6'] = ["gls xxl package type", "reel"];
constants.GLS_XXL_PACKAGE_TYPE_SACK = 7;
displayLookup['GLS_XXL_PACKAGE_TYPE.7'] = ["gls xxl package type", "sack"];

constants.HEALTH_CHECK_SEVERITY = {
  LOW: { color: null, label: true, value: 1 },
  MEDIUM: { color: null, label: true, value: 2 },
  HIGH: { color: null, label: true, value: 3 }
};
constants.HEALTH_CHECK_SEVERITY_LOW = 1;
displayLookup['HEALTH_CHECK_SEVERITY.1'] = "low";
constants.HEALTH_CHECK_SEVERITY_MEDIUM = 2;
displayLookup['HEALTH_CHECK_SEVERITY.2'] = "medium";
constants.HEALTH_CHECK_SEVERITY_HIGH = 3;
displayLookup['HEALTH_CHECK_SEVERITY.3'] = "high";

constants.HOUR_SELECT = {
  H_00: { color: null, label: "0", value: 0 },
  H_01: { color: null, label: "1", value: 1 },
  H_02: { color: null, label: "2", value: 2 },
  H_03: { color: null, label: "3", value: 3 },
  H_04: { color: null, label: "4", value: 4 },
  H_05: { color: null, label: "5", value: 5 },
  H_06: { color: null, label: "6", value: 6 },
  H_07: { color: null, label: "7", value: 7 },
  H_08: { color: null, label: "8", value: 8 },
  H_09: { color: null, label: "9", value: 9 },
  H_10: { color: null, label: "10", value: 10 },
  H_11: { color: null, label: "11", value: 11 },
  H_12: { color: null, label: "12", value: 12 },
  H_13: { color: null, label: "13", value: 13 },
  H_14: { color: null, label: "14", value: 14 },
  H_15: { color: null, label: "15", value: 15 },
  H_16: { color: null, label: "16", value: 16 },
  H_17: { color: null, label: "17", value: 17 },
  H_18: { color: null, label: "18", value: 18 },
  H_19: { color: null, label: "19", value: 19 },
  H_20: { color: null, label: "20", value: 20 },
  H_21: { color: null, label: "21", value: 21 },
  H_22: { color: null, label: "22", value: 22 },
  H_23: { color: null, label: "23", value: 23 }
};
constants.HOUR_SELECT_H_00 = 0;
displayLookup['HOUR_SELECT.0'] = "0";
constants.HOUR_SELECT_H_01 = 1;
displayLookup['HOUR_SELECT.1'] = "1";
constants.HOUR_SELECT_H_02 = 2;
displayLookup['HOUR_SELECT.2'] = "2";
constants.HOUR_SELECT_H_03 = 3;
displayLookup['HOUR_SELECT.3'] = "3";
constants.HOUR_SELECT_H_04 = 4;
displayLookup['HOUR_SELECT.4'] = "4";
constants.HOUR_SELECT_H_05 = 5;
displayLookup['HOUR_SELECT.5'] = "5";
constants.HOUR_SELECT_H_06 = 6;
displayLookup['HOUR_SELECT.6'] = "6";
constants.HOUR_SELECT_H_07 = 7;
displayLookup['HOUR_SELECT.7'] = "7";
constants.HOUR_SELECT_H_08 = 8;
displayLookup['HOUR_SELECT.8'] = "8";
constants.HOUR_SELECT_H_09 = 9;
displayLookup['HOUR_SELECT.9'] = "9";
constants.HOUR_SELECT_H_10 = 10;
displayLookup['HOUR_SELECT.10'] = "10";
constants.HOUR_SELECT_H_11 = 11;
displayLookup['HOUR_SELECT.11'] = "11";
constants.HOUR_SELECT_H_12 = 12;
displayLookup['HOUR_SELECT.12'] = "12";
constants.HOUR_SELECT_H_13 = 13;
displayLookup['HOUR_SELECT.13'] = "13";
constants.HOUR_SELECT_H_14 = 14;
displayLookup['HOUR_SELECT.14'] = "14";
constants.HOUR_SELECT_H_15 = 15;
displayLookup['HOUR_SELECT.15'] = "15";
constants.HOUR_SELECT_H_16 = 16;
displayLookup['HOUR_SELECT.16'] = "16";
constants.HOUR_SELECT_H_17 = 17;
displayLookup['HOUR_SELECT.17'] = "17";
constants.HOUR_SELECT_H_18 = 18;
displayLookup['HOUR_SELECT.18'] = "18";
constants.HOUR_SELECT_H_19 = 19;
displayLookup['HOUR_SELECT.19'] = "19";
constants.HOUR_SELECT_H_20 = 20;
displayLookup['HOUR_SELECT.20'] = "20";
constants.HOUR_SELECT_H_21 = 21;
displayLookup['HOUR_SELECT.21'] = "21";
constants.HOUR_SELECT_H_22 = 22;
displayLookup['HOUR_SELECT.22'] = "22";
constants.HOUR_SELECT_H_23 = 23;
displayLookup['HOUR_SELECT.23'] = "23";

constants.INBOUND_LOT_EXPIRATION_CHECK_MODE = {
  DISABLED: { color: null, label: "no check", value: 1 },
  PARTNER: { color: null, label: "partner based", value: 2 },
  GLOBAL: { color: null, label: "global", value: 3 }
};
constants.INBOUND_LOT_EXPIRATION_CHECK_MODE_DISABLED = 1;
displayLookup['INBOUND_LOT_EXPIRATION_CHECK_MODE.1'] = "no check";
constants.INBOUND_LOT_EXPIRATION_CHECK_MODE_PARTNER = 2;
displayLookup['INBOUND_LOT_EXPIRATION_CHECK_MODE.2'] = "partner based";
constants.INBOUND_LOT_EXPIRATION_CHECK_MODE_GLOBAL = 3;
displayLookup['INBOUND_LOT_EXPIRATION_CHECK_MODE.3'] = "global";

constants.INTRASTAT_NATURE_OF_TRANSACTION = {
  X11: { color: null, label: "K\u00f6zvetlen \u00e9rt\u00e9kes\u00edt\u00e9s/v\u00e9tel (kiv\u00e9ve mag\u00e1nfogyaszt\u00f3k)", value: 11 },
  X12: { color: null, label: "Mag\u00e1nfogyaszt\u00f3kkal folytatott/mag\u00e1nfogyaszt\u00f3k k\u00f6z\u00f6tti k\u00f6zvetlen ad\u00e1sv\u00e9tel", value: 12 },
  X13: { color: null, label: "(KIVEZETVE) Bartelforgalom", value: 13 },
  X14: { color: null, label: "(KIVEZETVE) P\u00e9nz\u00fcgyi l\u00edzing", value: 14 },
  X16: { color: null, label: "(KIVEZETVE) T\u00e1rgyi apport", value: 16 },
  X17: { color: null, label: "Reexport", value: 17 },
  X19: { color: null, label: "(KIVEZETVE) Egy\u00e9b", value: 19 },
  X21: { color: null, label: "\u00c1ru visszak\u00fcld\u00e9se", value: 21 },
  X22: { color: null, label: "Visszak\u00fcld\u00f6tt \u00e1ru cser\u00e9je", value: 22 },
  X23: { color: null, label: "Vissza nem k\u00fcld\u00f6tt \u00e1ru cser\u00e9je (pl. garancia c\u00edm\u00e9n)", value: 23 },
  X29: { color: null, label: "(KIVEZETVE) Egy\u00e9b", value: 29 },
  X30: { color: null, label: "(KIVEZETVE) Tulajdonosv\u00e1lt\u00e1ssal j\u00e1r\u00f3, de fizet\u00e9s vagy ellenszolg\u00e1ltat\u00e1s n\u00e9lk\u00fcli \u00fcgyletek", value: 30 },
  X31: { color: null, label: "Rakt\u00e1rba/rakt\u00e1rb\u00f3l t\u00f6rt\u00e9n\u0151 sz\u00e1ll\u00edt\u00e1s (kiv\u00e9ve a vev\u0151i \u00e9s konszign\u00e1ci\u00f3s k\u00e9szletet", value: 31 },
  X32: { color: null, label: "J\u00f3v\u00e1hagy\u00e1s vagy kipr\u00f3b\u00e1l\u00e1s ut\u00e1ni \u00e9rt\u00e9kes\u00edt\u00e9s c\u00e9lj\u00e1b\u00f3l t\u00f6rt\u00e9n\u0151 sz\u00e1ll\u00edt\u00e1s (bele\u00e9rtve a vev\u0151i \u00e9s konszign\u00e1ci\u00f3s k\u00e9szletet is) ", value: 32 },
  X33: { color: null, label: "P\u00e9nz\u00fcgyi l\u00edzing", value: 33 },
  X34: { color: null, label: "P\u00e9nz\u00fcgyi ellent\u00e9telez\u00e9s n\u00e9lk\u00fcli, tulajdon\u00e1truh\u00e1z\u00e1ssal j\u00e1r\u00f3 \u00fcgyletek", value: 34 },
  X41: { color: null, label: "B\u00e9rmunk\u00e1ra sz\u00e1ll\u00edtott term\u00e9kek / Az eredeti export\u00e1l\u00f3 tag\u00e1llamba/orsz\u00e1gba v\u00e1rhat\u00f3an visszat\u00e9r\u0151 term\u00e9k", value: 41 },
  X42: { color: null, label: "B\u00e9rmunk\u00e1ra sz\u00e1ll\u00edtott term\u00e9kek / Az eredeti export\u00e1l\u00f3 tag\u00e1llamba/orsz\u00e1gba v\u00e1rhat\u00f3an vissza nem t\u00e9r\u0151 term\u00e9k", value: 42 },
  X51: { color: null, label: "B\u00e9rmunk\u00e1ra ut\u00e1n sz\u00e1ll\u00edtott k\u00e9szterm\u00e9kek / Az eredeti export\u00e1l\u00f3 tag\u00e1llamba-orsz\u00e1gba visszat\u00e9r\u0151 term\u00e9k", value: 51 },
  X52: { color: null, label: "B\u00e9rmunk\u00e1ra ut\u00e1n sz\u00e1ll\u00edtott k\u00e9szterm\u00e9kek / Az eredeti export\u00e1l\u00f3 tag\u00e1llamba-orsz\u00e1gba vissza nem t\u00e9r\u0151 term\u00e9k", value: 52 },
  X59: { color: null, label: "B\u00e9rmunk\u00e1ra ut\u00e1n sz\u00e1ll\u00edtott k\u00e9szterm\u00e9kek / Visszasz\u00e1ll\u00edtott marad\u00e9k, hullad\u00e9k mell\u00e9kterm\u00e9k visszasz\u00e1ll\u00edt\u00e1s", value: 59 },
  X70: { color: null, label: "K\u00f6z\u00f6s v\u00e9delmi programok vagy egy\u00e9b k\u00f6z\u00f6s korm\u00e1nyk\u00f6zi gy\u00e1rt\u00e1si program \u00fcgyletei", value: 70 },
  X80: { color: null, label: "\u00c9p\u00edt\u0151anyagok \u00e9s felszerel\u00e9sek sz\u00e1ll\u00edt\u00e1sa", value: 80 },
  X81: { color: null, label: "(KIVEZETVE) \u00c9p\u00edt\u0151anyagok \u00e9s felszerel\u00e9sek sz\u00e1ll\u00edt\u00e1sa", value: 81 },
  X82: { color: null, label: "(KIVEZETVE) \u00c9p\u00edt\u0151anyagok \u00e9s felszerel\u00e9sek sz\u00e1ll\u00edt\u00e1sa", value: 82 },
  X91: { color: null, label: "Egy\u00e9b \u00fcgyletek, 24 h\u00f3napn\u00e1l hosszabb b\u00e9rlet, k\u00f6lcs\u00f6n \u00e9s operat\u00edv l\u00edzing", value: 91 },
  X92: { color: null, label: "(KIVEZETVE) Egy\u00e9b \u00fcgyletek, Indirekt kereskedelem", value: 92 },
  X99: { color: null, label: "Egy\u00e9b \u00fcgyletek,", value: 99 }
};
constants.INTRASTAT_NATURE_OF_TRANSACTION_X11 = 11;
displayLookup['INTRASTAT_NATURE_OF_TRANSACTION.11'] = "K\u00f6zvetlen \u00e9rt\u00e9kes\u00edt\u00e9s/v\u00e9tel (kiv\u00e9ve mag\u00e1nfogyaszt\u00f3k)";
constants.INTRASTAT_NATURE_OF_TRANSACTION_X12 = 12;
displayLookup['INTRASTAT_NATURE_OF_TRANSACTION.12'] = "Mag\u00e1nfogyaszt\u00f3kkal folytatott/mag\u00e1nfogyaszt\u00f3k k\u00f6z\u00f6tti k\u00f6zvetlen ad\u00e1sv\u00e9tel";
constants.INTRASTAT_NATURE_OF_TRANSACTION_X13 = 13;
displayLookup['INTRASTAT_NATURE_OF_TRANSACTION.13'] = "(KIVEZETVE) Bartelforgalom";
constants.INTRASTAT_NATURE_OF_TRANSACTION_X14 = 14;
displayLookup['INTRASTAT_NATURE_OF_TRANSACTION.14'] = "(KIVEZETVE) P\u00e9nz\u00fcgyi l\u00edzing";
constants.INTRASTAT_NATURE_OF_TRANSACTION_X16 = 16;
displayLookup['INTRASTAT_NATURE_OF_TRANSACTION.16'] = "(KIVEZETVE) T\u00e1rgyi apport";
constants.INTRASTAT_NATURE_OF_TRANSACTION_X17 = 17;
displayLookup['INTRASTAT_NATURE_OF_TRANSACTION.17'] = "Reexport";
constants.INTRASTAT_NATURE_OF_TRANSACTION_X19 = 19;
displayLookup['INTRASTAT_NATURE_OF_TRANSACTION.19'] = "(KIVEZETVE) Egy\u00e9b";
constants.INTRASTAT_NATURE_OF_TRANSACTION_X21 = 21;
displayLookup['INTRASTAT_NATURE_OF_TRANSACTION.21'] = "\u00c1ru visszak\u00fcld\u00e9se";
constants.INTRASTAT_NATURE_OF_TRANSACTION_X22 = 22;
displayLookup['INTRASTAT_NATURE_OF_TRANSACTION.22'] = "Visszak\u00fcld\u00f6tt \u00e1ru cser\u00e9je";
constants.INTRASTAT_NATURE_OF_TRANSACTION_X23 = 23;
displayLookup['INTRASTAT_NATURE_OF_TRANSACTION.23'] = "Vissza nem k\u00fcld\u00f6tt \u00e1ru cser\u00e9je (pl. garancia c\u00edm\u00e9n)";
constants.INTRASTAT_NATURE_OF_TRANSACTION_X29 = 29;
displayLookup['INTRASTAT_NATURE_OF_TRANSACTION.29'] = "(KIVEZETVE) Egy\u00e9b";
constants.INTRASTAT_NATURE_OF_TRANSACTION_X30 = 30;
displayLookup['INTRASTAT_NATURE_OF_TRANSACTION.30'] = "(KIVEZETVE) Tulajdonosv\u00e1lt\u00e1ssal j\u00e1r\u00f3, de fizet\u00e9s vagy ellenszolg\u00e1ltat\u00e1s n\u00e9lk\u00fcli \u00fcgyletek";
constants.INTRASTAT_NATURE_OF_TRANSACTION_X31 = 31;
displayLookup['INTRASTAT_NATURE_OF_TRANSACTION.31'] = "Rakt\u00e1rba/rakt\u00e1rb\u00f3l t\u00f6rt\u00e9n\u0151 sz\u00e1ll\u00edt\u00e1s (kiv\u00e9ve a vev\u0151i \u00e9s konszign\u00e1ci\u00f3s k\u00e9szletet";
constants.INTRASTAT_NATURE_OF_TRANSACTION_X32 = 32;
displayLookup['INTRASTAT_NATURE_OF_TRANSACTION.32'] = "J\u00f3v\u00e1hagy\u00e1s vagy kipr\u00f3b\u00e1l\u00e1s ut\u00e1ni \u00e9rt\u00e9kes\u00edt\u00e9s c\u00e9lj\u00e1b\u00f3l t\u00f6rt\u00e9n\u0151 sz\u00e1ll\u00edt\u00e1s (bele\u00e9rtve a vev\u0151i \u00e9s konszign\u00e1ci\u00f3s k\u00e9szletet is) ";
constants.INTRASTAT_NATURE_OF_TRANSACTION_X33 = 33;
displayLookup['INTRASTAT_NATURE_OF_TRANSACTION.33'] = "P\u00e9nz\u00fcgyi l\u00edzing";
constants.INTRASTAT_NATURE_OF_TRANSACTION_X34 = 34;
displayLookup['INTRASTAT_NATURE_OF_TRANSACTION.34'] = "P\u00e9nz\u00fcgyi ellent\u00e9telez\u00e9s n\u00e9lk\u00fcli, tulajdon\u00e1truh\u00e1z\u00e1ssal j\u00e1r\u00f3 \u00fcgyletek";
constants.INTRASTAT_NATURE_OF_TRANSACTION_X41 = 41;
displayLookup['INTRASTAT_NATURE_OF_TRANSACTION.41'] = "B\u00e9rmunk\u00e1ra sz\u00e1ll\u00edtott term\u00e9kek / Az eredeti export\u00e1l\u00f3 tag\u00e1llamba/orsz\u00e1gba v\u00e1rhat\u00f3an visszat\u00e9r\u0151 term\u00e9k";
constants.INTRASTAT_NATURE_OF_TRANSACTION_X42 = 42;
displayLookup['INTRASTAT_NATURE_OF_TRANSACTION.42'] = "B\u00e9rmunk\u00e1ra sz\u00e1ll\u00edtott term\u00e9kek / Az eredeti export\u00e1l\u00f3 tag\u00e1llamba/orsz\u00e1gba v\u00e1rhat\u00f3an vissza nem t\u00e9r\u0151 term\u00e9k";
constants.INTRASTAT_NATURE_OF_TRANSACTION_X51 = 51;
displayLookup['INTRASTAT_NATURE_OF_TRANSACTION.51'] = "B\u00e9rmunk\u00e1ra ut\u00e1n sz\u00e1ll\u00edtott k\u00e9szterm\u00e9kek / Az eredeti export\u00e1l\u00f3 tag\u00e1llamba-orsz\u00e1gba visszat\u00e9r\u0151 term\u00e9k";
constants.INTRASTAT_NATURE_OF_TRANSACTION_X52 = 52;
displayLookup['INTRASTAT_NATURE_OF_TRANSACTION.52'] = "B\u00e9rmunk\u00e1ra ut\u00e1n sz\u00e1ll\u00edtott k\u00e9szterm\u00e9kek / Az eredeti export\u00e1l\u00f3 tag\u00e1llamba-orsz\u00e1gba vissza nem t\u00e9r\u0151 term\u00e9k";
constants.INTRASTAT_NATURE_OF_TRANSACTION_X59 = 59;
displayLookup['INTRASTAT_NATURE_OF_TRANSACTION.59'] = "B\u00e9rmunk\u00e1ra ut\u00e1n sz\u00e1ll\u00edtott k\u00e9szterm\u00e9kek / Visszasz\u00e1ll\u00edtott marad\u00e9k, hullad\u00e9k mell\u00e9kterm\u00e9k visszasz\u00e1ll\u00edt\u00e1s";
constants.INTRASTAT_NATURE_OF_TRANSACTION_X70 = 70;
displayLookup['INTRASTAT_NATURE_OF_TRANSACTION.70'] = "K\u00f6z\u00f6s v\u00e9delmi programok vagy egy\u00e9b k\u00f6z\u00f6s korm\u00e1nyk\u00f6zi gy\u00e1rt\u00e1si program \u00fcgyletei";
constants.INTRASTAT_NATURE_OF_TRANSACTION_X80 = 80;
displayLookup['INTRASTAT_NATURE_OF_TRANSACTION.80'] = "\u00c9p\u00edt\u0151anyagok \u00e9s felszerel\u00e9sek sz\u00e1ll\u00edt\u00e1sa";
constants.INTRASTAT_NATURE_OF_TRANSACTION_X81 = 81;
displayLookup['INTRASTAT_NATURE_OF_TRANSACTION.81'] = "(KIVEZETVE) \u00c9p\u00edt\u0151anyagok \u00e9s felszerel\u00e9sek sz\u00e1ll\u00edt\u00e1sa";
constants.INTRASTAT_NATURE_OF_TRANSACTION_X82 = 82;
displayLookup['INTRASTAT_NATURE_OF_TRANSACTION.82'] = "(KIVEZETVE) \u00c9p\u00edt\u0151anyagok \u00e9s felszerel\u00e9sek sz\u00e1ll\u00edt\u00e1sa";
constants.INTRASTAT_NATURE_OF_TRANSACTION_X91 = 91;
displayLookup['INTRASTAT_NATURE_OF_TRANSACTION.91'] = "Egy\u00e9b \u00fcgyletek, 24 h\u00f3napn\u00e1l hosszabb b\u00e9rlet, k\u00f6lcs\u00f6n \u00e9s operat\u00edv l\u00edzing";
constants.INTRASTAT_NATURE_OF_TRANSACTION_X92 = 92;
displayLookup['INTRASTAT_NATURE_OF_TRANSACTION.92'] = "(KIVEZETVE) Egy\u00e9b \u00fcgyletek, Indirekt kereskedelem";
constants.INTRASTAT_NATURE_OF_TRANSACTION_X99 = 99;
displayLookup['INTRASTAT_NATURE_OF_TRANSACTION.99'] = "Egy\u00e9b \u00fcgyletek,";

constants.INTRASTAT_TYPE = {
  OSAP_2010: { color: null, label: "osap 2010", value: 2010 },
  OSAP_2012: { color: null, label: "osap 2012", value: 2012 }
};
constants.INTRASTAT_TYPE_OSAP_2010 = 2010;
displayLookup['INTRASTAT_TYPE.2010'] = "osap 2010";
constants.INTRASTAT_TYPE_OSAP_2012 = 2012;
displayLookup['INTRASTAT_TYPE.2012'] = "osap 2012";

constants.INVENTORY_COUNT_PRODUCT_ITEM_COUNT_STATUS = {
  MISSING: { color: null, label: true, value: 1 },
  DONE: { color: null, label: true, value: 50 }
};
constants.INVENTORY_COUNT_PRODUCT_ITEM_COUNT_STATUS_MISSING = 1;
displayLookup['INVENTORY_COUNT_PRODUCT_ITEM_COUNT_STATUS.1'] = "missing";
constants.INVENTORY_COUNT_PRODUCT_ITEM_COUNT_STATUS_DONE = 50;
displayLookup['INVENTORY_COUNT_PRODUCT_ITEM_COUNT_STATUS.50'] = "done";

constants.INVENTORY_COUNT_PRODUCT_NUMBER_CHECK_MODE = {
  DISABLED: { color: null, label: true, value: 1 },
  ENABLED: { color: null, label: true, value: 2 }
};
constants.INVENTORY_COUNT_PRODUCT_NUMBER_CHECK_MODE_DISABLED = 1;
displayLookup['INVENTORY_COUNT_PRODUCT_NUMBER_CHECK_MODE.1'] = "disabled";
constants.INVENTORY_COUNT_PRODUCT_NUMBER_CHECK_MODE_ENABLED = 2;
displayLookup['INVENTORY_COUNT_PRODUCT_NUMBER_CHECK_MODE.2'] = "enabled";

constants.INVENTORY_COUNT_PRODUCT_STATUS = {
  WAITING: { color: "#64b5f6", label: true, value: 1 },
  SHORTAGE: { color: "#e57373", label: true, value: 50 },
  DONE: { color: "#66bb6a", label: "match", value: 100 },
  OVERCOUNTED: { color: "#f57c00", label: true, value: 150 },
  CANCELLED: { color: "#e5e5e5", label: true, value: 1000 }
};
constants.INVENTORY_COUNT_PRODUCT_STATUS_WAITING = 1;
displayLookup['INVENTORY_COUNT_PRODUCT_STATUS.1'] = "waiting";
colorLookup['INVENTORY_COUNT_PRODUCT_STATUS.1'] = "#64b5f6";
colorNameLookup['INVENTORY_COUNT_PRODUCT_STATUS.1'] = "BLUE";
constants.INVENTORY_COUNT_PRODUCT_STATUS_SHORTAGE = 50;
displayLookup['INVENTORY_COUNT_PRODUCT_STATUS.50'] = "shortage";
colorLookup['INVENTORY_COUNT_PRODUCT_STATUS.50'] = "#e57373";
colorNameLookup['INVENTORY_COUNT_PRODUCT_STATUS.50'] = "RED";
constants.INVENTORY_COUNT_PRODUCT_STATUS_DONE = 100;
displayLookup['INVENTORY_COUNT_PRODUCT_STATUS.100'] = "match";
colorLookup['INVENTORY_COUNT_PRODUCT_STATUS.100'] = "#66bb6a";
colorNameLookup['INVENTORY_COUNT_PRODUCT_STATUS.100'] = "GREEN";
constants.INVENTORY_COUNT_PRODUCT_STATUS_OVERCOUNTED = 150;
displayLookup['INVENTORY_COUNT_PRODUCT_STATUS.150'] = "overcounted";
colorLookup['INVENTORY_COUNT_PRODUCT_STATUS.150'] = "#f57c00";
colorNameLookup['INVENTORY_COUNT_PRODUCT_STATUS.150'] = "ORANGE";
constants.INVENTORY_COUNT_PRODUCT_STATUS_CANCELLED = 1000;
displayLookup['INVENTORY_COUNT_PRODUCT_STATUS.1000'] = "cancelled";
colorLookup['INVENTORY_COUNT_PRODUCT_STATUS.1000'] = "#e5e5e5";
colorNameLookup['INVENTORY_COUNT_PRODUCT_STATUS.1000'] = "GREY";

constants.INVENTORY_COUNT_STATUS = {
  DRAFT: { color: "#64b5f6", label: true, value: 1 },
  READY: { color: "#64b5f6", label: true, value: 50 },
  IN_PROGRESS: { color: "#ffb74d", label: true, value: 100 },
  PROCESSING: { color: "#ffb74d", label: true, value: 150 },
  COMPLETED: { color: "#66bb6a", label: true, value: 200 },
  CANCELLED: { color: "#e57373", label: true, value: 1000 }
};
constants.INVENTORY_COUNT_STATUS_DRAFT = 1;
displayLookup['INVENTORY_COUNT_STATUS.1'] = "draft";
colorLookup['INVENTORY_COUNT_STATUS.1'] = "#64b5f6";
colorNameLookup['INVENTORY_COUNT_STATUS.1'] = "BLUE";
constants.INVENTORY_COUNT_STATUS_READY = 50;
displayLookup['INVENTORY_COUNT_STATUS.50'] = "ready";
colorLookup['INVENTORY_COUNT_STATUS.50'] = "#64b5f6";
colorNameLookup['INVENTORY_COUNT_STATUS.50'] = "BLUE";
constants.INVENTORY_COUNT_STATUS_IN_PROGRESS = 100;
displayLookup['INVENTORY_COUNT_STATUS.100'] = "in progress";
colorLookup['INVENTORY_COUNT_STATUS.100'] = "#ffb74d";
colorNameLookup['INVENTORY_COUNT_STATUS.100'] = "YELLOW";
constants.INVENTORY_COUNT_STATUS_PROCESSING = 150;
displayLookup['INVENTORY_COUNT_STATUS.150'] = "processing";
colorLookup['INVENTORY_COUNT_STATUS.150'] = "#ffb74d";
colorNameLookup['INVENTORY_COUNT_STATUS.150'] = "YELLOW";
constants.INVENTORY_COUNT_STATUS_COMPLETED = 200;
displayLookup['INVENTORY_COUNT_STATUS.200'] = "completed";
colorLookup['INVENTORY_COUNT_STATUS.200'] = "#66bb6a";
colorNameLookup['INVENTORY_COUNT_STATUS.200'] = "GREEN";
constants.INVENTORY_COUNT_STATUS_CANCELLED = 1000;
displayLookup['INVENTORY_COUNT_STATUS.1000'] = "cancelled";
colorLookup['INVENTORY_COUNT_STATUS.1000'] = "#e57373";
colorNameLookup['INVENTORY_COUNT_STATUS.1000'] = "RED";

constants.INVENTORY_COUNT_STOCK_CORRECTION_MODE = {
  QUANTITY: { color: null, label: true, value: 1 },
  DIFFERENCE: { color: null, label: true, value: 2 }
};
constants.INVENTORY_COUNT_STOCK_CORRECTION_MODE_QUANTITY = 1;
displayLookup['INVENTORY_COUNT_STOCK_CORRECTION_MODE.1'] = "quantity";
constants.INVENTORY_COUNT_STOCK_CORRECTION_MODE_DIFFERENCE = 2;
displayLookup['INVENTORY_COUNT_STOCK_CORRECTION_MODE.2'] = "difference";

constants.INVENTORY_COUNT_TYPE = {
  FULL: { color: null, label: true, value: 1 },
  PARTIAL: { color: null, label: true, value: 2 }
};
constants.INVENTORY_COUNT_TYPE_FULL = 1;
displayLookup['INVENTORY_COUNT_TYPE.1'] = "full";
constants.INVENTORY_COUNT_TYPE_PARTIAL = 2;
displayLookup['INVENTORY_COUNT_TYPE.2'] = "partial";

constants.INVOICE_COMPLETENESS_TAG = {
  READY: { color: null, label: "Ready", value: "ready" },
  MISSING_BUYER_DATA: { color: null, label: "Missing buyer data", value: "missing_buyer_data" },
  MISSING_SELLER_DATA: { color: null, label: "Missing seller data", value: "missing_seller_data" },
  MISSING_ITEM_DATA: { color: null, label: "Missing item data", value: "missing_item_data" },
  MISSING_MAIN_DATA: { color: null, label: "Missing main data", value: "missing_main_data" },
  PRICE_MISMATCH: { color: null, label: "Price mismatch", value: "price_mismatch" },
  NO_SHIPMENT: { color: null, label: "No shipment connection", value: "no_shipment" },
  INVALID_EXCHANGE_RATE: { color: null, label: "Invalid exchange rate", value: "invalid_exchange_rate" }
};
constants.INVOICE_COMPLETENESS_TAG_READY = "ready";
displayLookup['INVOICE_COMPLETENESS_TAG."ready"'] = "Ready";
constants.INVOICE_COMPLETENESS_TAG_MISSING_BUYER_DATA = "missing_buyer_data";
displayLookup['INVOICE_COMPLETENESS_TAG."missing_buyer_data"'] = "Missing buyer data";
constants.INVOICE_COMPLETENESS_TAG_MISSING_SELLER_DATA = "missing_seller_data";
displayLookup['INVOICE_COMPLETENESS_TAG."missing_seller_data"'] = "Missing seller data";
constants.INVOICE_COMPLETENESS_TAG_MISSING_ITEM_DATA = "missing_item_data";
displayLookup['INVOICE_COMPLETENESS_TAG."missing_item_data"'] = "Missing item data";
constants.INVOICE_COMPLETENESS_TAG_MISSING_MAIN_DATA = "missing_main_data";
displayLookup['INVOICE_COMPLETENESS_TAG."missing_main_data"'] = "Missing main data";
constants.INVOICE_COMPLETENESS_TAG_PRICE_MISMATCH = "price_mismatch";
displayLookup['INVOICE_COMPLETENESS_TAG."price_mismatch"'] = "Price mismatch";
constants.INVOICE_COMPLETENESS_TAG_NO_SHIPMENT = "no_shipment";
displayLookup['INVOICE_COMPLETENESS_TAG."no_shipment"'] = "No shipment connection";
constants.INVOICE_COMPLETENESS_TAG_INVALID_EXCHANGE_RATE = "invalid_exchange_rate";
displayLookup['INVOICE_COMPLETENESS_TAG."invalid_exchange_rate"'] = "Invalid exchange rate";

constants.INVOICE_CONNECTION_TYPE = {
  SHOW: { color: null, label: true, value: 1 },
  MERGED: { color: null, label: true, value: 2 },
  CORRECTION: { color: null, label: true, value: 3 },
  REVERSE: { color: null, label: true, value: 4 },
  DUPLICATE: { color: null, label: true, value: 5 }
};
constants.INVOICE_CONNECTION_TYPE_SHOW = 1;
displayLookup['INVOICE_CONNECTION_TYPE.1'] = "show";
constants.INVOICE_CONNECTION_TYPE_MERGED = 2;
displayLookup['INVOICE_CONNECTION_TYPE.2'] = "merged";
constants.INVOICE_CONNECTION_TYPE_CORRECTION = 3;
displayLookup['INVOICE_CONNECTION_TYPE.3'] = "correction";
constants.INVOICE_CONNECTION_TYPE_REVERSE = 4;
displayLookup['INVOICE_CONNECTION_TYPE.4'] = "reverse";
constants.INVOICE_CONNECTION_TYPE_DUPLICATE = 5;
displayLookup['INVOICE_CONNECTION_TYPE.5'] = "duplicate";

constants.INVOICE_DIRECTION = {
  INBOUND: { color: null, label: ["invoice direction", "incoming"], value: 1 },
  OUTBOUND: { color: null, label: ["invoice direction", "outgoing"], value: -1 }
};
constants.INVOICE_DIRECTION_INBOUND = 1;
displayLookup['INVOICE_DIRECTION.1'] = ["invoice direction", "incoming"];
constants.INVOICE_DIRECTION_OUTBOUND = -1;
displayLookup['INVOICE_DIRECTION.-1'] = ["invoice direction", "outgoing"];

constants.INVOICE_FILING_STATUS = {
  UNASSIGNED: { color: null, label: true, value: 1 },
  WAITING_FOR_APPROVAL: { color: null, label: true, value: 10 },
  APPROVED: { color: null, label: true, value: 100 }
};
constants.INVOICE_FILING_STATUS_UNASSIGNED = 1;
displayLookup['INVOICE_FILING_STATUS.1'] = "unassigned";
constants.INVOICE_FILING_STATUS_WAITING_FOR_APPROVAL = 10;
displayLookup['INVOICE_FILING_STATUS.10'] = "waiting for approval";
constants.INVOICE_FILING_STATUS_APPROVED = 100;
displayLookup['INVOICE_FILING_STATUS.100'] = "approved";

constants.INVOICE_ITEMS_SORT = {
  CREATED_TIMESTAMP: { color: null, label: true, value: 1 },
  NAME: { color: null, label: true, value: 2 },
  SKU: { color: null, label: true, value: 3 }
};
constants.INVOICE_ITEMS_SORT_CREATED_TIMESTAMP = 1;
displayLookup['INVOICE_ITEMS_SORT.1'] = "created timestamp";
constants.INVOICE_ITEMS_SORT_NAME = 2;
displayLookup['INVOICE_ITEMS_SORT.2'] = "name";
constants.INVOICE_ITEMS_SORT_SKU = 3;
displayLookup['INVOICE_ITEMS_SORT.3'] = "sku";

constants.INVOICE_LANGUAGE = {
  INHERIT_FROM_COUNTRY_CODE: { color: null, label: true, value: 1 },
  HU: { color: null, label: "Hungarian", value: 2 },
  EN: { color: null, label: "English", value: 3 },
  DE: { color: null, label: "Deutsch", value: 4 },
  IT: { color: null, label: "Italian", value: 5 },
  RO: { color: null, label: "Romanian", value: 6 },
  SK: { color: null, label: "Slovak", value: 7 },
  HR: { color: null, label: "Croatian", value: 8 },
  FR: { color: null, label: "French", value: 9 },
  ES: { color: null, label: "Spanish", value: 10 },
  CZ: { color: null, label: "Czech", value: 11 },
  PL: { color: null, label: "Polish", value: 12 }
};
constants.INVOICE_LANGUAGE_INHERIT_FROM_COUNTRY_CODE = 1;
displayLookup['INVOICE_LANGUAGE.1'] = "inherit from country code";
constants.INVOICE_LANGUAGE_HU = 2;
displayLookup['INVOICE_LANGUAGE.2'] = "Hungarian";
constants.INVOICE_LANGUAGE_EN = 3;
displayLookup['INVOICE_LANGUAGE.3'] = "English";
constants.INVOICE_LANGUAGE_DE = 4;
displayLookup['INVOICE_LANGUAGE.4'] = "Deutsch";
constants.INVOICE_LANGUAGE_IT = 5;
displayLookup['INVOICE_LANGUAGE.5'] = "Italian";
constants.INVOICE_LANGUAGE_RO = 6;
displayLookup['INVOICE_LANGUAGE.6'] = "Romanian";
constants.INVOICE_LANGUAGE_SK = 7;
displayLookup['INVOICE_LANGUAGE.7'] = "Slovak";
constants.INVOICE_LANGUAGE_HR = 8;
displayLookup['INVOICE_LANGUAGE.8'] = "Croatian";
constants.INVOICE_LANGUAGE_FR = 9;
displayLookup['INVOICE_LANGUAGE.9'] = "French";
constants.INVOICE_LANGUAGE_ES = 10;
displayLookup['INVOICE_LANGUAGE.10'] = "Spanish";
constants.INVOICE_LANGUAGE_CZ = 11;
displayLookup['INVOICE_LANGUAGE.11'] = "Czech";
constants.INVOICE_LANGUAGE_PL = 12;
displayLookup['INVOICE_LANGUAGE.12'] = "Polish";

constants.INVOICE_PROCESSING_STATUS = {
  NOT_PROCESSED: { color: null, label: [true], value: 0 },
  PENDING: { color: null, label: [true], value: 1 },
  PROCESSING: { color: null, label: [true], value: 2 },
  COMPLETED: { color: null, label: [true], value: 3 },
  FAILED: { color: null, label: [true], value: 4 }
};
constants.INVOICE_PROCESSING_STATUS_NOT_PROCESSED = 0;
displayLookup['INVOICE_PROCESSING_STATUS.0'] = ["invoice processing status", "not processed"];
constants.INVOICE_PROCESSING_STATUS_PENDING = 1;
displayLookup['INVOICE_PROCESSING_STATUS.1'] = ["invoice processing status", "pending"];
constants.INVOICE_PROCESSING_STATUS_PROCESSING = 2;
displayLookup['INVOICE_PROCESSING_STATUS.2'] = ["invoice processing status", "processing"];
constants.INVOICE_PROCESSING_STATUS_COMPLETED = 3;
displayLookup['INVOICE_PROCESSING_STATUS.3'] = ["invoice processing status", "completed"];
constants.INVOICE_PROCESSING_STATUS_FAILED = 4;
displayLookup['INVOICE_PROCESSING_STATUS.4'] = ["invoice processing status", "failed"];

constants.INVOICE_SOURCE = {
  MANUAL: { color: null, label: ["invoice source", "manual"], value: 1 },
  NAV: { color: null, label: ["invoice source", "nav"], value: 2 },
  SZAMLAZZHU: { color: null, label: ["invoice source", "szamlazz.hu"], value: 3 },
  OCR: { color: null, label: ["invoice source", "ocr"], value: 4 },
  IMPORT: { color: null, label: ["invoice source", "import"], value: 5 },
  EDI: { color: null, label: ["invoice source", "edi"], value: 6 },
  ORDER: { color: null, label: ["invoice source", "order"], value: 7 },
  POS: { color: null, label: ["invoice source", "pos"], value: 8 }
};
constants.INVOICE_SOURCE_MANUAL = 1;
displayLookup['INVOICE_SOURCE.1'] = ["invoice source", "manual"];
constants.INVOICE_SOURCE_NAV = 2;
displayLookup['INVOICE_SOURCE.2'] = ["invoice source", "nav"];
constants.INVOICE_SOURCE_SZAMLAZZHU = 3;
displayLookup['INVOICE_SOURCE.3'] = ["invoice source", "szamlazz.hu"];
constants.INVOICE_SOURCE_OCR = 4;
displayLookup['INVOICE_SOURCE.4'] = ["invoice source", "ocr"];
constants.INVOICE_SOURCE_IMPORT = 5;
displayLookup['INVOICE_SOURCE.5'] = ["invoice source", "import"];
constants.INVOICE_SOURCE_EDI = 6;
displayLookup['INVOICE_SOURCE.6'] = ["invoice source", "edi"];
constants.INVOICE_SOURCE_ORDER = 7;
displayLookup['INVOICE_SOURCE.7'] = ["invoice source", "order"];
constants.INVOICE_SOURCE_POS = 8;
displayLookup['INVOICE_SOURCE.8'] = ["invoice source", "pos"];

constants.INVOICE_STATUS = {
  DRAFT: { color: null, label: true, value: 1 },
  CHECK_REQUIRED: { color: null, label: true, value: 2 },
  CONFIRMED: { color: null, label: true, value: 3 },
  COMPLETED: { color: null, label: true, value: 4 },
  SYNC_REQUIRED: { color: null, label: true, value: 11 },
  SYNC_STARTED: { color: null, label: true, value: 12 },
  SYNC_FAILED: { color: null, label: true, value: 13 },
  SYNC_COMPLETED: { color: null, label: true, value: 14 },
  TO_CONFIRM: { color: "#e57373", label: true, value: 50 },
  APPROVED: { color: "#64b5f6", label: true, value: 51 },
  CANCELLED: { color: "#e5e5e5", label: true, value: 52 },
  PROCESSED: { color: "#66bb6a", label: true, value: 53 },
  V1: { color: null, label: true, value: 100 }
};
constants.INVOICE_STATUS_DRAFT = 1;
displayLookup['INVOICE_STATUS.1'] = "draft";
constants.INVOICE_STATUS_CHECK_REQUIRED = 2;
displayLookup['INVOICE_STATUS.2'] = "check required";
constants.INVOICE_STATUS_CONFIRMED = 3;
displayLookup['INVOICE_STATUS.3'] = "confirmed";
constants.INVOICE_STATUS_COMPLETED = 4;
displayLookup['INVOICE_STATUS.4'] = "completed";
constants.INVOICE_STATUS_SYNC_REQUIRED = 11;
displayLookup['INVOICE_STATUS.11'] = "sync required";
constants.INVOICE_STATUS_SYNC_STARTED = 12;
displayLookup['INVOICE_STATUS.12'] = "sync started";
constants.INVOICE_STATUS_SYNC_FAILED = 13;
displayLookup['INVOICE_STATUS.13'] = "sync failed";
constants.INVOICE_STATUS_SYNC_COMPLETED = 14;
displayLookup['INVOICE_STATUS.14'] = "sync completed";
constants.INVOICE_STATUS_TO_CONFIRM = 50;
displayLookup['INVOICE_STATUS.50'] = "to confirm";
colorLookup['INVOICE_STATUS.50'] = "#e57373";
colorNameLookup['INVOICE_STATUS.50'] = "RED";
constants.INVOICE_STATUS_APPROVED = 51;
displayLookup['INVOICE_STATUS.51'] = "approved";
colorLookup['INVOICE_STATUS.51'] = "#64b5f6";
colorNameLookup['INVOICE_STATUS.51'] = "BLUE";
constants.INVOICE_STATUS_CANCELLED = 52;
displayLookup['INVOICE_STATUS.52'] = "cancelled";
colorLookup['INVOICE_STATUS.52'] = "#e5e5e5";
colorNameLookup['INVOICE_STATUS.52'] = "GREY";
constants.INVOICE_STATUS_PROCESSED = 53;
displayLookup['INVOICE_STATUS.53'] = "processed";
colorLookup['INVOICE_STATUS.53'] = "#66bb6a";
colorNameLookup['INVOICE_STATUS.53'] = "GREEN";
constants.INVOICE_STATUS_V1 = 100;
displayLookup['INVOICE_STATUS.100'] = "v1";

constants.INVOICE_TYPE = {
  INBOUND_STANDARD: { color: "#66bb6a", label: "standard", value: 1 },
  INBOUND_PROFORMA: { color: "#f57c00", label: "proforma", value: 2 },
  INBOUND_PREPAYMENT: { color: "#e5e5e5", label: "prepayment", value: 3 },
  INBOUND_FINAL: { color: "#f57c00", label: "final", value: 4 },
  INBOUND_REVERSE: { color: "#e57373", label: "reverse", value: 5 },
  INBOUND_CORRECTING: { color: "#f57c00", label: "correcting", value: 6 },
  INBOUND_SIMPLIFIED: { color: "#64b5f6", label: "simplified", value: 21 },
  OUTBOUND_PROFORMA: { color: "#f57c00", label: "proforma", value: 101 },
  OUTBOUND_PREPAYMENT: { color: "#66bb6a", label: "prepayment", value: 102 },
  OUTBOUND_PROFORMA_2: { color: "#f57c00", label: "2nd proforma", value: 103 },
  OUTBOUND_STANDARD: { color: "#66bb6a", label: "standard", value: 104 },
  OUTBOUND_CORRECTING: { color: "#e57373", label: "correcting", value: 105 },
  OUTBOUND_REVERSE: { color: "#e57373", label: "reverse", value: 106 },
  OUTBOUND_PREPAYMENT_REVERSE: { color: "#e57373", label: "prepayment reverse", value: 107 },
  OUTBOUND_CORRECTING_REVERSE: { color: "#e57373", label: "correcting reverse", value: 108 },
  OUTBOUND_RECEIPT: { color: "#64b5f6", label: "receipt", value: 111 },
  OUTBOUND_RECEIPT_REVERSE: { color: "#e57373", label: "receipt reverse", value: 112 }
};
constants.INVOICE_TYPE_INBOUND_STANDARD = 1;
displayLookup['INVOICE_TYPE.1'] = "standard";
colorLookup['INVOICE_TYPE.1'] = "#66bb6a";
colorNameLookup['INVOICE_TYPE.1'] = "GREEN";
constants.INVOICE_TYPE_INBOUND_PROFORMA = 2;
displayLookup['INVOICE_TYPE.2'] = "proforma";
colorLookup['INVOICE_TYPE.2'] = "#f57c00";
colorNameLookup['INVOICE_TYPE.2'] = "ORANGE";
constants.INVOICE_TYPE_INBOUND_PREPAYMENT = 3;
displayLookup['INVOICE_TYPE.3'] = "prepayment";
colorLookup['INVOICE_TYPE.3'] = "#e5e5e5";
colorNameLookup['INVOICE_TYPE.3'] = "GREY";
constants.INVOICE_TYPE_INBOUND_FINAL = 4;
displayLookup['INVOICE_TYPE.4'] = "final";
colorLookup['INVOICE_TYPE.4'] = "#f57c00";
colorNameLookup['INVOICE_TYPE.4'] = "ORANGE";
constants.INVOICE_TYPE_INBOUND_REVERSE = 5;
displayLookup['INVOICE_TYPE.5'] = "reverse";
colorLookup['INVOICE_TYPE.5'] = "#e57373";
colorNameLookup['INVOICE_TYPE.5'] = "RED";
constants.INVOICE_TYPE_INBOUND_CORRECTING = 6;
displayLookup['INVOICE_TYPE.6'] = "correcting";
colorLookup['INVOICE_TYPE.6'] = "#f57c00";
colorNameLookup['INVOICE_TYPE.6'] = "ORANGE";
constants.INVOICE_TYPE_INBOUND_SIMPLIFIED = 21;
displayLookup['INVOICE_TYPE.21'] = "simplified";
colorLookup['INVOICE_TYPE.21'] = "#64b5f6";
colorNameLookup['INVOICE_TYPE.21'] = "BLUE";
constants.INVOICE_TYPE_OUTBOUND_PROFORMA = 101;
displayLookup['INVOICE_TYPE.101'] = "proforma";
colorLookup['INVOICE_TYPE.101'] = "#f57c00";
colorNameLookup['INVOICE_TYPE.101'] = "ORANGE";
constants.INVOICE_TYPE_OUTBOUND_PREPAYMENT = 102;
displayLookup['INVOICE_TYPE.102'] = "prepayment";
colorLookup['INVOICE_TYPE.102'] = "#66bb6a";
colorNameLookup['INVOICE_TYPE.102'] = "GREEN";
constants.INVOICE_TYPE_OUTBOUND_PROFORMA_2 = 103;
displayLookup['INVOICE_TYPE.103'] = "2nd proforma";
colorLookup['INVOICE_TYPE.103'] = "#f57c00";
colorNameLookup['INVOICE_TYPE.103'] = "ORANGE";
constants.INVOICE_TYPE_OUTBOUND_STANDARD = 104;
displayLookup['INVOICE_TYPE.104'] = "standard";
colorLookup['INVOICE_TYPE.104'] = "#66bb6a";
colorNameLookup['INVOICE_TYPE.104'] = "GREEN";
constants.INVOICE_TYPE_OUTBOUND_CORRECTING = 105;
displayLookup['INVOICE_TYPE.105'] = "correcting";
colorLookup['INVOICE_TYPE.105'] = "#e57373";
colorNameLookup['INVOICE_TYPE.105'] = "RED";
constants.INVOICE_TYPE_OUTBOUND_REVERSE = 106;
displayLookup['INVOICE_TYPE.106'] = "reverse";
colorLookup['INVOICE_TYPE.106'] = "#e57373";
colorNameLookup['INVOICE_TYPE.106'] = "RED";
constants.INVOICE_TYPE_OUTBOUND_PREPAYMENT_REVERSE = 107;
displayLookup['INVOICE_TYPE.107'] = "prepayment reverse";
colorLookup['INVOICE_TYPE.107'] = "#e57373";
colorNameLookup['INVOICE_TYPE.107'] = "RED";
constants.INVOICE_TYPE_OUTBOUND_CORRECTING_REVERSE = 108;
displayLookup['INVOICE_TYPE.108'] = "correcting reverse";
colorLookup['INVOICE_TYPE.108'] = "#e57373";
colorNameLookup['INVOICE_TYPE.108'] = "RED";
constants.INVOICE_TYPE_OUTBOUND_RECEIPT = 111;
displayLookup['INVOICE_TYPE.111'] = "receipt";
colorLookup['INVOICE_TYPE.111'] = "#64b5f6";
colorNameLookup['INVOICE_TYPE.111'] = "BLUE";
constants.INVOICE_TYPE_OUTBOUND_RECEIPT_REVERSE = 112;
displayLookup['INVOICE_TYPE.112'] = "receipt reverse";
colorLookup['INVOICE_TYPE.112'] = "#e57373";
colorNameLookup['INVOICE_TYPE.112'] = "RED";

constants.INVOICING_ACCOUNT_TYPE = {
  SZAMLAZZHU: { color: null, label: ["invoicing account type", "szamlazz.hu"], value: 1 },
  SUPERFAKTURA: { color: null, label: ["invoicing account type", "superfaktura"], value: 2 },
  VIRTUAL: { color: null, label: ["invoicing account type", "virtual"], value: 3 }
};
constants.INVOICING_ACCOUNT_TYPE_SZAMLAZZHU = 1;
displayLookup['INVOICING_ACCOUNT_TYPE.1'] = ["invoicing account type", "szamlazz.hu"];
constants.INVOICING_ACCOUNT_TYPE_SUPERFAKTURA = 2;
displayLookup['INVOICING_ACCOUNT_TYPE.2'] = ["invoicing account type", "superfaktura"];
constants.INVOICING_ACCOUNT_TYPE_VIRTUAL = 3;
displayLookup['INVOICING_ACCOUNT_TYPE.3'] = ["invoicing account type", "virtual"];

constants.KOVA_TRANS_MESSAGE_TYPE = {
  IN_WAREHOUSE: { color: null, label: null, value: 1 },
  DELIVERED: { color: null, label: null, value: 2 },
  CANCELLED: { color: null, label: null, value: 3 },
  COD: { color: null, label: null, value: 4 }
};
constants.KOVA_TRANS_MESSAGE_TYPE_IN_WAREHOUSE = 1;
constants.KOVA_TRANS_MESSAGE_TYPE_DELIVERED = 2;
constants.KOVA_TRANS_MESSAGE_TYPE_CANCELLED = 3;
constants.KOVA_TRANS_MESSAGE_TYPE_COD = 4;

constants.KOVA_TRANS_ORDER_TYPE = {
  DELIVERY: { color: null, label: true, value: "Delivery" },
  PICKUP: { color: null, label: true, value: "Pickup" }
};
constants.KOVA_TRANS_ORDER_TYPE_DELIVERY = "Delivery";
displayLookup['KOVA_TRANS_ORDER_TYPE."Delivery"'] = "delivery";
constants.KOVA_TRANS_ORDER_TYPE_PICKUP = "Pickup";
displayLookup['KOVA_TRANS_ORDER_TYPE."Pickup"'] = "pickup";

constants.KUMI_EXTRA_SERVICE = {
  FRAGILE: { color: null, label: true, value: "fragile" },
  RETURN_RECEIPT: { color: null, label: true, value: "return_receipt" },
  DOCUMENT_RECYCLING: { color: null, label: true, value: "document_recycling" },
  PACKAGING_REQUIRED: { color: null, label: true, value: "packaging_required" },
  HAND_OF_RECIPIENT: { color: null, label: true, value: "hand_of_recipient" },
  OVERSIZED_PACKAGE_200: { color: null, label: "oversized 200", value: "tm1" },
  OVERSIZED_PACKAGE_250: { color: null, label: "oversized 250", value: "tm2" },
  OVERSIZED_PACKAGE_300: { color: null, label: "oversized 300", value: "tm3" },
  OVERSIZED_PACKAGE_340: { color: null, label: "oversized 340", value: "tm4" },
  OVERSIZED_PACKAGE_380: { color: null, label: "oversized 380", value: "tm5" },
  OVERSIZED_PACKAGE_3_X_100: { color: null, label: "oversized 3x100", value: "tm6" },
  COURIER_BAG: { color: null, label: true, value: "currier_bag" },
  UNPACKING: { color: null, label: true, value: "unpacking" },
  ITEMIZED: { color: null, label: true, value: "itemized" },
  EXTRA_COURIER: { color: null, label: true, value: "extracurrier" },
  USED_PRODUCT: { color: null, label: true, value: "usedproduct" },
  LARGE_STORE: { color: null, label: true, value: "large_store" },
  SATURDAY_SHIPPING: { color: null, label: true, value: "saturday_shipping" }
};
constants.KUMI_EXTRA_SERVICE_FRAGILE = "fragile";
displayLookup['KUMI_EXTRA_SERVICE."fragile"'] = "fragile";
constants.KUMI_EXTRA_SERVICE_RETURN_RECEIPT = "return_receipt";
displayLookup['KUMI_EXTRA_SERVICE."return_receipt"'] = "return receipt";
constants.KUMI_EXTRA_SERVICE_DOCUMENT_RECYCLING = "document_recycling";
displayLookup['KUMI_EXTRA_SERVICE."document_recycling"'] = "document recycling";
constants.KUMI_EXTRA_SERVICE_PACKAGING_REQUIRED = "packaging_required";
displayLookup['KUMI_EXTRA_SERVICE."packaging_required"'] = "packaging required";
constants.KUMI_EXTRA_SERVICE_HAND_OF_RECIPIENT = "hand_of_recipient";
displayLookup['KUMI_EXTRA_SERVICE."hand_of_recipient"'] = "hand of recipient";
constants.KUMI_EXTRA_SERVICE_OVERSIZED_PACKAGE_200 = "tm1";
displayLookup['KUMI_EXTRA_SERVICE."tm1"'] = "oversized 200";
constants.KUMI_EXTRA_SERVICE_OVERSIZED_PACKAGE_250 = "tm2";
displayLookup['KUMI_EXTRA_SERVICE."tm2"'] = "oversized 250";
constants.KUMI_EXTRA_SERVICE_OVERSIZED_PACKAGE_300 = "tm3";
displayLookup['KUMI_EXTRA_SERVICE."tm3"'] = "oversized 300";
constants.KUMI_EXTRA_SERVICE_OVERSIZED_PACKAGE_340 = "tm4";
displayLookup['KUMI_EXTRA_SERVICE."tm4"'] = "oversized 340";
constants.KUMI_EXTRA_SERVICE_OVERSIZED_PACKAGE_380 = "tm5";
displayLookup['KUMI_EXTRA_SERVICE."tm5"'] = "oversized 380";
constants.KUMI_EXTRA_SERVICE_OVERSIZED_PACKAGE_3_X_100 = "tm6";
displayLookup['KUMI_EXTRA_SERVICE."tm6"'] = "oversized 3x100";
constants.KUMI_EXTRA_SERVICE_COURIER_BAG = "currier_bag";
displayLookup['KUMI_EXTRA_SERVICE."currier_bag"'] = "courier bag";
constants.KUMI_EXTRA_SERVICE_UNPACKING = "unpacking";
displayLookup['KUMI_EXTRA_SERVICE."unpacking"'] = "unpacking";
constants.KUMI_EXTRA_SERVICE_ITEMIZED = "itemized";
displayLookup['KUMI_EXTRA_SERVICE."itemized"'] = "itemized";
constants.KUMI_EXTRA_SERVICE_EXTRA_COURIER = "extracurrier";
displayLookup['KUMI_EXTRA_SERVICE."extracurrier"'] = "extra courier";
constants.KUMI_EXTRA_SERVICE_USED_PRODUCT = "usedproduct";
displayLookup['KUMI_EXTRA_SERVICE."usedproduct"'] = "used product";
constants.KUMI_EXTRA_SERVICE_LARGE_STORE = "large_store";
displayLookup['KUMI_EXTRA_SERVICE."large_store"'] = "large store";
constants.KUMI_EXTRA_SERVICE_SATURDAY_SHIPPING = "saturday_shipping";
displayLookup['KUMI_EXTRA_SERVICE."saturday_shipping"'] = "saturday shipping";

constants.KUMI_PACKAGE_TYPE = {
  DELIVERY: { color: null, label: true, value: 3 },
  RETURN: { color: null, label: true, value: 4 },
  REPLACEMENT: { color: null, label: true, value: 5 }
};
constants.KUMI_PACKAGE_TYPE_DELIVERY = 3;
displayLookup['KUMI_PACKAGE_TYPE.3'] = "delivery";
constants.KUMI_PACKAGE_TYPE_RETURN = 4;
displayLookup['KUMI_PACKAGE_TYPE.4'] = "return";
constants.KUMI_PACKAGE_TYPE_REPLACEMENT = 5;
displayLookup['KUMI_PACKAGE_TYPE.5'] = "replacement";

constants.KUMI_STICKER_SIZE = {
  A4: { color: null, label: true, value: "4" },
  ZEBRA: { color: null, label: true, value: "1" },
  X85_X_85: { color: null, label: true, value: "85x85" },
  X105_X_148: { color: null, label: true, value: "105x148" }
};
constants.KUMI_STICKER_SIZE_A4 = "4";
displayLookup['KUMI_STICKER_SIZE."4"'] = "a4";
constants.KUMI_STICKER_SIZE_ZEBRA = "1";
displayLookup['KUMI_STICKER_SIZE."1"'] = "zebra";
constants.KUMI_STICKER_SIZE_X85_X_85 = "85x85";
displayLookup['KUMI_STICKER_SIZE."85x85"'] = "x85 x 85";
constants.KUMI_STICKER_SIZE_X105_X_148 = "105x148";
displayLookup['KUMI_STICKER_SIZE."105x148"'] = "x105 x 148";

constants.LOGIN_ATTEMPT_ERROR = {
  INVALID_USERNAME: { color: null, label: [true], value: "invalid_username" },
  INVALID_PASSWORD: { color: null, label: [true], value: "invalid_password" },
  INVALID_PASSCODE: { color: null, label: [true], value: "invalid_passcode" },
  INACTIVE_USER: { color: null, label: [true], value: "inactive_user" },
  INACTIVE_ORGANIZATION: { color: null, label: [true], value: "inactive_organization" },
  NO_ORGANIZATION: { color: null, label: [true], value: "no_organization" },
  BLOCKED: { color: null, label: [true], value: "blocked" }
};
constants.LOGIN_ATTEMPT_ERROR_INVALID_USERNAME = "invalid_username";
displayLookup['LOGIN_ATTEMPT_ERROR."invalid_username"'] = ["login attempt error", "invalid username"];
constants.LOGIN_ATTEMPT_ERROR_INVALID_PASSWORD = "invalid_password";
displayLookup['LOGIN_ATTEMPT_ERROR."invalid_password"'] = ["login attempt error", "invalid password"];
constants.LOGIN_ATTEMPT_ERROR_INVALID_PASSCODE = "invalid_passcode";
displayLookup['LOGIN_ATTEMPT_ERROR."invalid_passcode"'] = ["login attempt error", "invalid passcode"];
constants.LOGIN_ATTEMPT_ERROR_INACTIVE_USER = "inactive_user";
displayLookup['LOGIN_ATTEMPT_ERROR."inactive_user"'] = ["login attempt error", "inactive user"];
constants.LOGIN_ATTEMPT_ERROR_INACTIVE_ORGANIZATION = "inactive_organization";
displayLookup['LOGIN_ATTEMPT_ERROR."inactive_organization"'] = ["login attempt error", "inactive organization"];
constants.LOGIN_ATTEMPT_ERROR_NO_ORGANIZATION = "no_organization";
displayLookup['LOGIN_ATTEMPT_ERROR."no_organization"'] = ["login attempt error", "no organization"];
constants.LOGIN_ATTEMPT_ERROR_BLOCKED = "blocked";
displayLookup['LOGIN_ATTEMPT_ERROR."blocked"'] = ["login attempt error", "blocked"];

constants.MAGENTO_PRODUCT_STATUS = {
  DISABLED: { color: null, label: "disabled", value: "0" },
  ENABLED: { color: null, label: true, value: "1" },
  DISABLED_2: { color: null, label: "disabled (2)", value: "2" }
};
constants.MAGENTO_PRODUCT_STATUS_DISABLED = "0";
displayLookup['MAGENTO_PRODUCT_STATUS."0"'] = "disabled";
constants.MAGENTO_PRODUCT_STATUS_ENABLED = "1";
displayLookup['MAGENTO_PRODUCT_STATUS."1"'] = "enabled";
constants.MAGENTO_PRODUCT_STATUS_DISABLED_2 = "2";
displayLookup['MAGENTO_PRODUCT_STATUS."2"'] = "disabled (2)";

constants.MAGENTO_PRODUCT_VISIBILITY = {
  NOT_VISIBLE_INDIVIDUALLY: { color: null, label: true, value: "1" },
  CATALOG: { color: null, label: true, value: "2" },
  SEARCH: { color: null, label: true, value: "3" },
  CATALOG_AND_SEARCH: { color: null, label: true, value: "4" }
};
constants.MAGENTO_PRODUCT_VISIBILITY_NOT_VISIBLE_INDIVIDUALLY = "1";
displayLookup['MAGENTO_PRODUCT_VISIBILITY."1"'] = "not visible individually";
constants.MAGENTO_PRODUCT_VISIBILITY_CATALOG = "2";
displayLookup['MAGENTO_PRODUCT_VISIBILITY."2"'] = "catalog";
constants.MAGENTO_PRODUCT_VISIBILITY_SEARCH = "3";
displayLookup['MAGENTO_PRODUCT_VISIBILITY."3"'] = "search";
constants.MAGENTO_PRODUCT_VISIBILITY_CATALOG_AND_SEARCH = "4";
displayLookup['MAGENTO_PRODUCT_VISIBILITY."4"'] = "catalog and search";

constants.MANUFACTURE_PLAN_STATUS = {
  WAITING: { color: "#e5e5e5", label: true, value: 1 },
  PROCESSING: { color: "#ffb74d", label: true, value: 50 },
  DONE: { color: "#66bb6a", label: true, value: 100 },
  FAILED: { color: "#e57373", label: true, value: 150 }
};
constants.MANUFACTURE_PLAN_STATUS_WAITING = 1;
displayLookup['MANUFACTURE_PLAN_STATUS.1'] = "waiting";
colorLookup['MANUFACTURE_PLAN_STATUS.1'] = "#e5e5e5";
colorNameLookup['MANUFACTURE_PLAN_STATUS.1'] = "GREY";
constants.MANUFACTURE_PLAN_STATUS_PROCESSING = 50;
displayLookup['MANUFACTURE_PLAN_STATUS.50'] = "processing";
colorLookup['MANUFACTURE_PLAN_STATUS.50'] = "#ffb74d";
colorNameLookup['MANUFACTURE_PLAN_STATUS.50'] = "YELLOW";
constants.MANUFACTURE_PLAN_STATUS_DONE = 100;
displayLookup['MANUFACTURE_PLAN_STATUS.100'] = "done";
colorLookup['MANUFACTURE_PLAN_STATUS.100'] = "#66bb6a";
colorNameLookup['MANUFACTURE_PLAN_STATUS.100'] = "GREEN";
constants.MANUFACTURE_PLAN_STATUS_FAILED = 150;
displayLookup['MANUFACTURE_PLAN_STATUS.150'] = "failed";
colorLookup['MANUFACTURE_PLAN_STATUS.150'] = "#e57373";
colorNameLookup['MANUFACTURE_PLAN_STATUS.150'] = "RED";

constants.MASS_COMPLETION_MODE = {
  PER_ITEM: { color: null, label: [true], value: 1 },
  MERGED_BY_PARTNER: { color: null, label: [true], value: 2 }
};
constants.MASS_COMPLETION_MODE_PER_ITEM = 1;
displayLookup['MASS_COMPLETION_MODE.1'] = ["mass completion mode", "per item"];
constants.MASS_COMPLETION_MODE_MERGED_BY_PARTNER = 2;
displayLookup['MASS_COMPLETION_MODE.2'] = ["mass completion mode", "merged by partner"];

constants.MASS_COMPLETION_TRANSACTION_MODE = {
  PAST: { color: null, label: null, value: "past_transaction" },
  FUTURE: { color: null, label: null, value: "future_transaction" }
};
constants.MASS_COMPLETION_TRANSACTION_MODE_PAST = "past_transaction";
constants.MASS_COMPLETION_TRANSACTION_MODE_FUTURE = "future_transaction";

constants.MESSAGE_RECIPIENT_STATUS = {
  PENDING: { color: "#e5e5e5", label: true, value: 1 },
  SENT: { color: "#66bb6a", label: true, value: 100 },
  FAILED: { color: "#e57373", label: true, value: 200 },
  CANCELLED: { color: "#e57373", label: true, value: 500 }
};
constants.MESSAGE_RECIPIENT_STATUS_PENDING = 1;
displayLookup['MESSAGE_RECIPIENT_STATUS.1'] = "pending";
colorLookup['MESSAGE_RECIPIENT_STATUS.1'] = "#e5e5e5";
colorNameLookup['MESSAGE_RECIPIENT_STATUS.1'] = "GREY";
constants.MESSAGE_RECIPIENT_STATUS_SENT = 100;
displayLookup['MESSAGE_RECIPIENT_STATUS.100'] = "sent";
colorLookup['MESSAGE_RECIPIENT_STATUS.100'] = "#66bb6a";
colorNameLookup['MESSAGE_RECIPIENT_STATUS.100'] = "GREEN";
constants.MESSAGE_RECIPIENT_STATUS_FAILED = 200;
displayLookup['MESSAGE_RECIPIENT_STATUS.200'] = "failed";
colorLookup['MESSAGE_RECIPIENT_STATUS.200'] = "#e57373";
colorNameLookup['MESSAGE_RECIPIENT_STATUS.200'] = "RED";
constants.MESSAGE_RECIPIENT_STATUS_CANCELLED = 500;
displayLookup['MESSAGE_RECIPIENT_STATUS.500'] = "cancelled";
colorLookup['MESSAGE_RECIPIENT_STATUS.500'] = "#e57373";
colorNameLookup['MESSAGE_RECIPIENT_STATUS.500'] = "RED";

constants.MESSAGE_TYPE = {
  EMAIL: { color: null, label: true, value: 1 },
  WEBHOOK: { color: null, label: true, value: 2 },
  NOTIFICATION: { color: null, label: true, value: 3 }
};
constants.MESSAGE_TYPE_EMAIL = 1;
displayLookup['MESSAGE_TYPE.1'] = "email";
constants.MESSAGE_TYPE_WEBHOOK = 2;
displayLookup['MESSAGE_TYPE.2'] = "webhook";
constants.MESSAGE_TYPE_NOTIFICATION = 3;
displayLookup['MESSAGE_TYPE.3'] = "notification";

constants.MONTH_SELECT = {
  JANUARY: { color: null, label: "january", value: 1 },
  FEBRUARY: { color: null, label: "february", value: 2 },
  MARCH: { color: null, label: "march", value: 3 },
  APRIL: { color: null, label: "april", value: 4 },
  MAY: { color: null, label: "may", value: 5 },
  JUNE: { color: null, label: "june", value: 6 },
  JULY: { color: null, label: "july", value: 7 },
  AUGUST: { color: null, label: "august", value: 8 },
  SEPTEMBER: { color: null, label: "september", value: 9 },
  OCTOBER: { color: null, label: "october", value: 10 },
  NOVEMBER: { color: null, label: "november", value: 11 },
  DECEMBER: { color: null, label: "december", value: 12 }
};
constants.MONTH_SELECT_JANUARY = 1;
displayLookup['MONTH_SELECT.1'] = "january";
constants.MONTH_SELECT_FEBRUARY = 2;
displayLookup['MONTH_SELECT.2'] = "february";
constants.MONTH_SELECT_MARCH = 3;
displayLookup['MONTH_SELECT.3'] = "march";
constants.MONTH_SELECT_APRIL = 4;
displayLookup['MONTH_SELECT.4'] = "april";
constants.MONTH_SELECT_MAY = 5;
displayLookup['MONTH_SELECT.5'] = "may";
constants.MONTH_SELECT_JUNE = 6;
displayLookup['MONTH_SELECT.6'] = "june";
constants.MONTH_SELECT_JULY = 7;
displayLookup['MONTH_SELECT.7'] = "july";
constants.MONTH_SELECT_AUGUST = 8;
displayLookup['MONTH_SELECT.8'] = "august";
constants.MONTH_SELECT_SEPTEMBER = 9;
displayLookup['MONTH_SELECT.9'] = "september";
constants.MONTH_SELECT_OCTOBER = 10;
displayLookup['MONTH_SELECT.10'] = "october";
constants.MONTH_SELECT_NOVEMBER = 11;
displayLookup['MONTH_SELECT.11'] = "november";
constants.MONTH_SELECT_DECEMBER = 12;
displayLookup['MONTH_SELECT.12'] = "december";

constants.MPL_BASIC_SERVICE = {
  BUSINESS: { color: null, label: true, value: "A_175_UZL" },
  POST: { color: null, label: true, value: "A_177_MPC" }
};
constants.MPL_BASIC_SERVICE_BUSINESS = "A_175_UZL";
displayLookup['MPL_BASIC_SERVICE."A_175_UZL"'] = "business";
constants.MPL_BASIC_SERVICE_POST = "A_177_MPC";
displayLookup['MPL_BASIC_SERVICE."A_177_MPC"'] = "post";

constants.MPL_DELIVERY_MODE = {
  POST_DELIVERY: { color: null, label: "PostDelivery", value: "PM" },
  HOME_DELIVERY: { color: null, label: "HomeDelivery", value: "HA" },
  PALLET_DELIVERY: { color: null, label: "PalletDelivery", value: "RA" },
  POST_POINT: { color: null, label: "PostPoint", value: "PP" },
  PARCEL_POINT: { color: null, label: "ParcelPoint", value: "CS" }
};
constants.MPL_DELIVERY_MODE_POST_DELIVERY = "PM";
displayLookup['MPL_DELIVERY_MODE."PM"'] = "PostDelivery";
constants.MPL_DELIVERY_MODE_HOME_DELIVERY = "HA";
displayLookup['MPL_DELIVERY_MODE."HA"'] = "HomeDelivery";
constants.MPL_DELIVERY_MODE_PALLET_DELIVERY = "RA";
displayLookup['MPL_DELIVERY_MODE."RA"'] = "PalletDelivery";
constants.MPL_DELIVERY_MODE_POST_POINT = "PP";
displayLookup['MPL_DELIVERY_MODE."PP"'] = "PostPoint";
constants.MPL_DELIVERY_MODE_PARCEL_POINT = "CS";
displayLookup['MPL_DELIVERY_MODE."CS"'] = "ParcelPoint";

constants.MPL_EXTRA_SERVICE = {
  DECLARATION_OF_VALUE: { color: null, label: true, value: "K_ENY" },
  BULKY: { color: null, label: true, value: "K_TER" },
  PAYMENT_FOR_GOODS: { color: null, label: true, value: "K_UVT" },
  FRAGILE: { color: null, label: true, value: "K_TOR" },
  GUARDING_TIME: { color: null, label: true, value: "K_ORZ" },
  ONE_WORKING_DAY_GUARANTEE: { color: null, label: true, value: "K_IDO" },
  PALLET_REPLACEMENT: { color: null, label: true, value: "K_RLC" }
};
constants.MPL_EXTRA_SERVICE_DECLARATION_OF_VALUE = "K_ENY";
displayLookup['MPL_EXTRA_SERVICE."K_ENY"'] = "declaration of value";
constants.MPL_EXTRA_SERVICE_BULKY = "K_TER";
displayLookup['MPL_EXTRA_SERVICE."K_TER"'] = "bulky";
constants.MPL_EXTRA_SERVICE_PAYMENT_FOR_GOODS = "K_UVT";
displayLookup['MPL_EXTRA_SERVICE."K_UVT"'] = "payment for goods";
constants.MPL_EXTRA_SERVICE_FRAGILE = "K_TOR";
displayLookup['MPL_EXTRA_SERVICE."K_TOR"'] = "fragile";
constants.MPL_EXTRA_SERVICE_GUARDING_TIME = "K_ORZ";
displayLookup['MPL_EXTRA_SERVICE."K_ORZ"'] = "guarding time";
constants.MPL_EXTRA_SERVICE_ONE_WORKING_DAY_GUARANTEE = "K_IDO";
displayLookup['MPL_EXTRA_SERVICE."K_IDO"'] = "one working day guarantee";
constants.MPL_EXTRA_SERVICE_PALLET_REPLACEMENT = "K_RLC";
displayLookup['MPL_EXTRA_SERVICE."K_RLC"'] = "pallet replacement";

constants.MPL_LABEL_TYPE = {
  A4: { color: null, label: true, value: "A4" },
  A5: { color: null, label: true, value: "A5" },
  A5_in_A4: { color: null, label: true, value: "A5inA4" },
  A5E: { color: null, label: true, value: "A5E" },
  A5E_EXTRA: { color: null, label: true, value: "A5E_EXTRA" },
  A5E_STAND: { color: null, label: true, value: "A5E_STAND" },
  A6: { color: null, label: true, value: "A6" },
  A6_in_A4: { color: null, label: true, value: "A6inA4" },
  T_10X10: { color: null, label: true, value: "T_10x10" },
  N_10X10_IN_A4: { color: null, label: true, value: "N_10x10inA4" },
  A4ONE: { color: null, label: true, value: "A4ONE" }
};
constants.MPL_LABEL_TYPE_A4 = "A4";
displayLookup['MPL_LABEL_TYPE."A4"'] = "a4";
constants.MPL_LABEL_TYPE_A5 = "A5";
displayLookup['MPL_LABEL_TYPE."A5"'] = "a5";
constants.MPL_LABEL_TYPE_A5_in_A4 = "A5inA4";
displayLookup['MPL_LABEL_TYPE."A5inA4"'] = "a5 in a4";
constants.MPL_LABEL_TYPE_A5E = "A5E";
displayLookup['MPL_LABEL_TYPE."A5E"'] = "a5e";
constants.MPL_LABEL_TYPE_A5E_EXTRA = "A5E_EXTRA";
displayLookup['MPL_LABEL_TYPE."A5E_EXTRA"'] = "a5e extra";
constants.MPL_LABEL_TYPE_A5E_STAND = "A5E_STAND";
displayLookup['MPL_LABEL_TYPE."A5E_STAND"'] = "a5e stand";
constants.MPL_LABEL_TYPE_A6 = "A6";
displayLookup['MPL_LABEL_TYPE."A6"'] = "a6";
constants.MPL_LABEL_TYPE_A6_in_A4 = "A6inA4";
displayLookup['MPL_LABEL_TYPE."A6inA4"'] = "a6 in a4";
constants.MPL_LABEL_TYPE_T_10X10 = "T_10x10";
displayLookup['MPL_LABEL_TYPE."T_10x10"'] = "t 10x10";
constants.MPL_LABEL_TYPE_N_10X10_IN_A4 = "N_10x10inA4";
displayLookup['MPL_LABEL_TYPE."N_10x10inA4"'] = "n 10x10 in a4";
constants.MPL_LABEL_TYPE_A4ONE = "A4ONE";
displayLookup['MPL_LABEL_TYPE."A4ONE"'] = "a4one";

constants.MPL_PACKAGE_RETENTION_DAYS = {
  ZERO: { color: null, label: true, value: "0" },
  FIVE: { color: null, label: true, value: "5" },
  TEN: { color: null, label: true, value: "10" }
};
constants.MPL_PACKAGE_RETENTION_DAYS_ZERO = "0";
displayLookup['MPL_PACKAGE_RETENTION_DAYS."0"'] = "zero";
constants.MPL_PACKAGE_RETENTION_DAYS_FIVE = "5";
displayLookup['MPL_PACKAGE_RETENTION_DAYS."5"'] = "five";
constants.MPL_PACKAGE_RETENTION_DAYS_TEN = "10";
displayLookup['MPL_PACKAGE_RETENTION_DAYS."10"'] = "ten";

constants.MPL_PACKAGE_SIZE = {
  SMALL: { color: null, label: "S (31 cm x 25 cm x 7 cm)", value: "S" },
  MEDIUM: { color: null, label: "M (50 cm x 31 cm x 16 cm)", value: "M" },
  LARGE: { color: null, label: "L (50 cm x 31 cm x 35 cm)", value: "L" }
};
constants.MPL_PACKAGE_SIZE_SMALL = "S";
displayLookup['MPL_PACKAGE_SIZE."S"'] = "S (31 cm x 25 cm x 7 cm)";
constants.MPL_PACKAGE_SIZE_MEDIUM = "M";
displayLookup['MPL_PACKAGE_SIZE."M"'] = "M (50 cm x 31 cm x 16 cm)";
constants.MPL_PACKAGE_SIZE_LARGE = "L";
displayLookup['MPL_PACKAGE_SIZE."L"'] = "L (50 cm x 31 cm x 35 cm)";

constants.MPL_PAYMENT_MODE = {
  TRANSFER: { color: null, label: true, value: "UV_AT" },
  CASH: { color: null, label: true, value: "UV_KP" }
};
constants.MPL_PAYMENT_MODE_TRANSFER = "UV_AT";
displayLookup['MPL_PAYMENT_MODE."UV_AT"'] = "transfer";
constants.MPL_PAYMENT_MODE_CASH = "UV_KP";
displayLookup['MPL_PAYMENT_MODE."UV_KP"'] = "cash";

constants.NAV_ITEM_TYPE = {
  INVOICE: { color: null, label: true, value: 1 },
  INVOICE_REVERSE: { color: null, label: true, value: 2 },
  INBOUND_INVOICE_REVERSE: { color: null, label: true, value: 3 },
  OUTBOUND_INVOICE_REVERSE: { color: null, label: true, value: 4 }
};
constants.NAV_ITEM_TYPE_INVOICE = 1;
displayLookup['NAV_ITEM_TYPE.1'] = "invoice";
constants.NAV_ITEM_TYPE_INVOICE_REVERSE = 2;
displayLookup['NAV_ITEM_TYPE.2'] = "invoice reverse";
constants.NAV_ITEM_TYPE_INBOUND_INVOICE_REVERSE = 3;
displayLookup['NAV_ITEM_TYPE.3'] = "inbound invoice reverse";
constants.NAV_ITEM_TYPE_OUTBOUND_INVOICE_REVERSE = 4;
displayLookup['NAV_ITEM_TYPE.4'] = "outbound invoice reverse";

constants.NEGATED_ITEM = {
  PRICE: { color: null, label: true, value: 1 },
  QUANTITY: { color: null, label: true, value: 2 }
};
constants.NEGATED_ITEM_PRICE = 1;
displayLookup['NEGATED_ITEM.1'] = "price";
constants.NEGATED_ITEM_QUANTITY = 2;
displayLookup['NEGATED_ITEM.2'] = "quantity";

constants.NOTIFICATION_CATEGORY = {
  SUPPLIER_INVOICE_EXPIRATION: { color: null, label: [true], value: 1 },
  PERMISSION_REQUESTED: { color: null, label: [true], value: 2 },
  ORDER_TASK_CREATED: { color: null, label: [true], value: 3 },
  MANUAL_WEBSHOP_SYNC: { color: null, label: [true], value: 4 },
  ORDER_TAKEOVER_EXPIRED: { color: null, label: ["notification category", "Takeover expired"], value: 5 },
  ORDER_DEADLINE_EXPIRED: { color: null, label: ["notification category", "Deadline expired"], value: 6 },
  DOUBLE_ORDER: { color: null, label: [true], value: 7 },
  BLACKLISTED_ORDER: { color: null, label: ["notification category", "Blacklisted"], value: 8 },
  ORDER_GLS_COD_DEADLINE_EXPIRED: { color: null, label: ["notification category", "GLS cod deadline expired"], value: 9 },
  ORDER_GLS_PARCEL_DELIVERY_DEADLINE_EXPIRED: { color: null, label: ["notification category", "GLS parcel delivery deadline expired"], value: 10 },
  REJECTED_ORDER: { color: null, label: ["notification category", "Rejected"], value: 11 },
  GLS_TRACKING_FAILED: { color: null, label: [true], value: 12 },
  NEW_VERSION: { color: null, label: [true], value: 13 },
  ORDER_FAILED_PAYMENT: { color: null, label: ["notification category", "Failed payment"], value: 14 },
  ORGANIZATION_CONFIGURATION_ISSUE: { color: null, label: [true], value: 15 },
  GLS_COD_DIFFERENCE: { color: null, label: [true], value: 16 },
  NO_USERS_ASSIGNED: { color: null, label: ["notification category", "no user assigned"], value: 17 },
  NEW_NOTIFICATION_CATEGORY_AVAILABLE: { color: null, label: [true], value: 18 },
  WEBSHOP_SYNC_WAREHOUSE_ALLOWED_PRODUCT_CREATION: { color: null, label: ["notification category", "Newly created warehouse allowed product"], value: 19 },
  FAILED_WEBSHOP_ORDER: { color: null, label: [true], value: 20 },
  CONFIRMED_WEBSHOP_ORDER: { color: null, label: [true], value: 21 },
  ORDER_SYNCED_AS_COMPLETED: { color: null, label: [true], value: 22 },
  ORDER_FAILED_INVOICE_GENERATION: { color: null, label: ["notification category", "Failed invoice generation"], value: 23 },
  ORGANIZATION_UPGRADE_SCHEDULED: { color: null, label: [true], value: 24 },
  MISSING_INVOICE_CAN_NOT_BE_GENERATED: { color: null, label: [true], value: 25 },
  THIRD_PARTY_LOGISTICS_SYNC_ERROR: { color: null, label: [true], value: 26 },
  VIRTUAL_ORDER_WITH_NOT_VIRTUAL_PRODUCT: { color: null, label: [true], value: 27 },
  AUTOMATISM: { color: null, label: [true], value: 28 },
  PRODUCT_TASK_CREATED: { color: null, label: [true], value: 29 },
  PRODUCT_NUMBER_TASK_CREATED: { color: null, label: [true], value: 30 },
  QUOTE_TASK_CREATED: { color: null, label: [true], value: 31 },
  SUPPLIER_TASK_CREATED: { color: null, label: [true], value: 32 },
  PURCHASE_ORDER_TASK_CREATED: { color: null, label: [true], value: 33 },
  SHIPMENT_TASK_CREATED: { color: null, label: [true], value: 34 },
  CUSTOMER_TASK_CREATED: { color: null, label: [true], value: 35 },
  INVOICE_TASK_CREATED: { color: null, label: [true], value: 36 },
  TRANSACTION_TASK_CREATED: { color: null, label: [true], value: 37 }
};
constants.NOTIFICATION_CATEGORY_SUPPLIER_INVOICE_EXPIRATION = 1;
displayLookup['NOTIFICATION_CATEGORY.1'] = ["notification category", "supplier invoice expiration"];
constants.NOTIFICATION_CATEGORY_PERMISSION_REQUESTED = 2;
displayLookup['NOTIFICATION_CATEGORY.2'] = ["notification category", "permission requested"];
constants.NOTIFICATION_CATEGORY_ORDER_TASK_CREATED = 3;
displayLookup['NOTIFICATION_CATEGORY.3'] = ["notification category", "order task created"];
constants.NOTIFICATION_CATEGORY_MANUAL_WEBSHOP_SYNC = 4;
displayLookup['NOTIFICATION_CATEGORY.4'] = ["notification category", "manual webshop sync"];
constants.NOTIFICATION_CATEGORY_ORDER_TAKEOVER_EXPIRED = 5;
displayLookup['NOTIFICATION_CATEGORY.5'] = ["notification category", "Takeover expired"];
constants.NOTIFICATION_CATEGORY_ORDER_DEADLINE_EXPIRED = 6;
displayLookup['NOTIFICATION_CATEGORY.6'] = ["notification category", "Deadline expired"];
constants.NOTIFICATION_CATEGORY_DOUBLE_ORDER = 7;
displayLookup['NOTIFICATION_CATEGORY.7'] = ["notification category", "double order"];
constants.NOTIFICATION_CATEGORY_BLACKLISTED_ORDER = 8;
displayLookup['NOTIFICATION_CATEGORY.8'] = ["notification category", "Blacklisted"];
constants.NOTIFICATION_CATEGORY_ORDER_GLS_COD_DEADLINE_EXPIRED = 9;
displayLookup['NOTIFICATION_CATEGORY.9'] = ["notification category", "GLS cod deadline expired"];
constants.NOTIFICATION_CATEGORY_ORDER_GLS_PARCEL_DELIVERY_DEADLINE_EXPIRED = 10;
displayLookup['NOTIFICATION_CATEGORY.10'] = ["notification category", "GLS parcel delivery deadline expired"];
constants.NOTIFICATION_CATEGORY_REJECTED_ORDER = 11;
displayLookup['NOTIFICATION_CATEGORY.11'] = ["notification category", "Rejected"];
constants.NOTIFICATION_CATEGORY_GLS_TRACKING_FAILED = 12;
displayLookup['NOTIFICATION_CATEGORY.12'] = ["notification category", "gls tracking failed"];
constants.NOTIFICATION_CATEGORY_NEW_VERSION = 13;
displayLookup['NOTIFICATION_CATEGORY.13'] = ["notification category", "new version"];
constants.NOTIFICATION_CATEGORY_ORDER_FAILED_PAYMENT = 14;
displayLookup['NOTIFICATION_CATEGORY.14'] = ["notification category", "Failed payment"];
constants.NOTIFICATION_CATEGORY_ORGANIZATION_CONFIGURATION_ISSUE = 15;
displayLookup['NOTIFICATION_CATEGORY.15'] = ["notification category", "organization configuration issue"];
constants.NOTIFICATION_CATEGORY_GLS_COD_DIFFERENCE = 16;
displayLookup['NOTIFICATION_CATEGORY.16'] = ["notification category", "gls cod difference"];
constants.NOTIFICATION_CATEGORY_NO_USERS_ASSIGNED = 17;
displayLookup['NOTIFICATION_CATEGORY.17'] = ["notification category", "no user assigned"];
constants.NOTIFICATION_CATEGORY_NEW_NOTIFICATION_CATEGORY_AVAILABLE = 18;
displayLookup['NOTIFICATION_CATEGORY.18'] = ["notification category", "new notification category available"];
constants.NOTIFICATION_CATEGORY_WEBSHOP_SYNC_WAREHOUSE_ALLOWED_PRODUCT_CREATION = 19;
displayLookup['NOTIFICATION_CATEGORY.19'] = ["notification category", "Newly created warehouse allowed product"];
constants.NOTIFICATION_CATEGORY_FAILED_WEBSHOP_ORDER = 20;
displayLookup['NOTIFICATION_CATEGORY.20'] = ["notification category", "failed webshop order"];
constants.NOTIFICATION_CATEGORY_CONFIRMED_WEBSHOP_ORDER = 21;
displayLookup['NOTIFICATION_CATEGORY.21'] = ["notification category", "confirmed webshop order"];
constants.NOTIFICATION_CATEGORY_ORDER_SYNCED_AS_COMPLETED = 22;
displayLookup['NOTIFICATION_CATEGORY.22'] = ["notification category", "order synced as completed"];
constants.NOTIFICATION_CATEGORY_ORDER_FAILED_INVOICE_GENERATION = 23;
displayLookup['NOTIFICATION_CATEGORY.23'] = ["notification category", "Failed invoice generation"];
constants.NOTIFICATION_CATEGORY_ORGANIZATION_UPGRADE_SCHEDULED = 24;
displayLookup['NOTIFICATION_CATEGORY.24'] = ["notification category", "organization upgrade scheduled"];
constants.NOTIFICATION_CATEGORY_MISSING_INVOICE_CAN_NOT_BE_GENERATED = 25;
displayLookup['NOTIFICATION_CATEGORY.25'] = ["notification category", "missing invoice can not be generated"];
constants.NOTIFICATION_CATEGORY_THIRD_PARTY_LOGISTICS_SYNC_ERROR = 26;
displayLookup['NOTIFICATION_CATEGORY.26'] = ["notification category", "third party logistics sync error"];
constants.NOTIFICATION_CATEGORY_VIRTUAL_ORDER_WITH_NOT_VIRTUAL_PRODUCT = 27;
displayLookup['NOTIFICATION_CATEGORY.27'] = ["notification category", "virtual order with not virtual product"];
constants.NOTIFICATION_CATEGORY_AUTOMATISM = 28;
displayLookup['NOTIFICATION_CATEGORY.28'] = ["notification category", "automatism"];
constants.NOTIFICATION_CATEGORY_PRODUCT_TASK_CREATED = 29;
displayLookup['NOTIFICATION_CATEGORY.29'] = ["notification category", "product task created"];
constants.NOTIFICATION_CATEGORY_PRODUCT_NUMBER_TASK_CREATED = 30;
displayLookup['NOTIFICATION_CATEGORY.30'] = ["notification category", "product number task created"];
constants.NOTIFICATION_CATEGORY_QUOTE_TASK_CREATED = 31;
displayLookup['NOTIFICATION_CATEGORY.31'] = ["notification category", "quote task created"];
constants.NOTIFICATION_CATEGORY_SUPPLIER_TASK_CREATED = 32;
displayLookup['NOTIFICATION_CATEGORY.32'] = ["notification category", "supplier task created"];
constants.NOTIFICATION_CATEGORY_PURCHASE_ORDER_TASK_CREATED = 33;
displayLookup['NOTIFICATION_CATEGORY.33'] = ["notification category", "purchase order task created"];
constants.NOTIFICATION_CATEGORY_SHIPMENT_TASK_CREATED = 34;
displayLookup['NOTIFICATION_CATEGORY.34'] = ["notification category", "shipment task created"];
constants.NOTIFICATION_CATEGORY_CUSTOMER_TASK_CREATED = 35;
displayLookup['NOTIFICATION_CATEGORY.35'] = ["notification category", "customer task created"];
constants.NOTIFICATION_CATEGORY_INVOICE_TASK_CREATED = 36;
displayLookup['NOTIFICATION_CATEGORY.36'] = ["notification category", "invoice task created"];
constants.NOTIFICATION_CATEGORY_TRANSACTION_TASK_CREATED = 37;
displayLookup['NOTIFICATION_CATEGORY.37'] = ["notification category", "transaction task created"];

constants.NOTIFICATION_TYPE = {
  INFO: { color: null, label: [true], value: 1 },
  SUCCESS: { color: null, label: [true], value: 10 },
  WARNING: { color: null, label: [true], value: 20 },
  ERROR: { color: null, label: [true], value: 30 }
};
constants.NOTIFICATION_TYPE_INFO = 1;
displayLookup['NOTIFICATION_TYPE.1'] = ["notification type", "info"];
constants.NOTIFICATION_TYPE_SUCCESS = 10;
displayLookup['NOTIFICATION_TYPE.10'] = ["notification type", "success"];
constants.NOTIFICATION_TYPE_WARNING = 20;
displayLookup['NOTIFICATION_TYPE.20'] = ["notification type", "warning"];
constants.NOTIFICATION_TYPE_ERROR = 30;
displayLookup['NOTIFICATION_TYPE.30'] = ["notification type", "error"];

constants.OPERATION_ITEM_TABLE_SHOW_COLUMN = {
  DEFAULT_SUPPLIER: { color: null, label: "Default supplier", value: 1 },
  NOTES: { color: null, label: "Notes", value: 2 },
  SECONDARY_UNIT: { color: null, label: "Secondary unit", value: 3 },
  ON_STOCK: { color: null, label: "On stock", value: 4 },
  AVAILABLE: { color: null, label: "Available", value: 5 },
  INCOMING: { color: null, label: "Incoming", value: 6 },
  OUTGOING: { color: null, label: "Outgoing", value: 7 }
};
constants.OPERATION_ITEM_TABLE_SHOW_COLUMN_DEFAULT_SUPPLIER = 1;
displayLookup['OPERATION_ITEM_TABLE_SHOW_COLUMN.1'] = "Default supplier";
constants.OPERATION_ITEM_TABLE_SHOW_COLUMN_NOTES = 2;
displayLookup['OPERATION_ITEM_TABLE_SHOW_COLUMN.2'] = "Notes";
constants.OPERATION_ITEM_TABLE_SHOW_COLUMN_SECONDARY_UNIT = 3;
displayLookup['OPERATION_ITEM_TABLE_SHOW_COLUMN.3'] = "Secondary unit";
constants.OPERATION_ITEM_TABLE_SHOW_COLUMN_ON_STOCK = 4;
displayLookup['OPERATION_ITEM_TABLE_SHOW_COLUMN.4'] = "On stock";
constants.OPERATION_ITEM_TABLE_SHOW_COLUMN_AVAILABLE = 5;
displayLookup['OPERATION_ITEM_TABLE_SHOW_COLUMN.5'] = "Available";
constants.OPERATION_ITEM_TABLE_SHOW_COLUMN_INCOMING = 6;
displayLookup['OPERATION_ITEM_TABLE_SHOW_COLUMN.6'] = "Incoming";
constants.OPERATION_ITEM_TABLE_SHOW_COLUMN_OUTGOING = 7;
displayLookup['OPERATION_ITEM_TABLE_SHOW_COLUMN.7'] = "Outgoing";

constants.ORDER_ACTUAL_STATUS_TYPE = {
  DEFAULT: { color: null, label: true, value: 1 },
  SHIPPING: { color: null, label: true, value: 50 },
  NOT_READY: { color: null, label: true, value: 100 }
};
constants.ORDER_ACTUAL_STATUS_TYPE_DEFAULT = 1;
displayLookup['ORDER_ACTUAL_STATUS_TYPE.1'] = "default";
constants.ORDER_ACTUAL_STATUS_TYPE_SHIPPING = 50;
displayLookup['ORDER_ACTUAL_STATUS_TYPE.50'] = "shipping";
constants.ORDER_ACTUAL_STATUS_TYPE_NOT_READY = 100;
displayLookup['ORDER_ACTUAL_STATUS_TYPE.100'] = "not ready";

constants.ORDER_CANCELLED_EVENT_TYPE = {
  GLS_TRACK: { color: null, label: "Cancelled via gls track", value: 1 },
  SPRINTER_TRACK: { color: null, label: "Cancelled via sprinter track", value: 2 },
  PACKETA_TRACK: { color: null, label: "Cancelled via packeta track", value: 3 },
  MPL_TRACK: { color: null, label: "Cancelled via mpl track", value: 4 },
  FOXPOST_TRACK: { color: null, label: "Cancelled via foxpost track", value: 5 },
  DPD_TRACK: { color: null, label: "Cancelled via dpd track", value: 6 },
  EXPRESS_ONE_TRACK: { color: null, label: "Cancelled via ExpressOne track", value: 7 },
  PACTIC_TRACK: { color: null, label: "Cancelled via Pactic track", value: 8 },
  EMAG_TRACK: { color: null, label: "Cancelled via Emag track", value: 9 },
  KUMI_TRACK: { color: null, label: "Cancelled via Kumi track", value: 10 },
  KOVA_TRANS_TRACK: { color: null, label: "Cancelled via KovaTrans track", value: 11 },
  PANNONXP_TRACK: { color: null, label: "Cancelled via PannonXP track", value: 12 }
};
constants.ORDER_CANCELLED_EVENT_TYPE_GLS_TRACK = 1;
displayLookup['ORDER_CANCELLED_EVENT_TYPE.1'] = "Cancelled via gls track";
constants.ORDER_CANCELLED_EVENT_TYPE_SPRINTER_TRACK = 2;
displayLookup['ORDER_CANCELLED_EVENT_TYPE.2'] = "Cancelled via sprinter track";
constants.ORDER_CANCELLED_EVENT_TYPE_PACKETA_TRACK = 3;
displayLookup['ORDER_CANCELLED_EVENT_TYPE.3'] = "Cancelled via packeta track";
constants.ORDER_CANCELLED_EVENT_TYPE_MPL_TRACK = 4;
displayLookup['ORDER_CANCELLED_EVENT_TYPE.4'] = "Cancelled via mpl track";
constants.ORDER_CANCELLED_EVENT_TYPE_FOXPOST_TRACK = 5;
displayLookup['ORDER_CANCELLED_EVENT_TYPE.5'] = "Cancelled via foxpost track";
constants.ORDER_CANCELLED_EVENT_TYPE_DPD_TRACK = 6;
displayLookup['ORDER_CANCELLED_EVENT_TYPE.6'] = "Cancelled via dpd track";
constants.ORDER_CANCELLED_EVENT_TYPE_EXPRESS_ONE_TRACK = 7;
displayLookup['ORDER_CANCELLED_EVENT_TYPE.7'] = "Cancelled via ExpressOne track";
constants.ORDER_CANCELLED_EVENT_TYPE_PACTIC_TRACK = 8;
displayLookup['ORDER_CANCELLED_EVENT_TYPE.8'] = "Cancelled via Pactic track";
constants.ORDER_CANCELLED_EVENT_TYPE_EMAG_TRACK = 9;
displayLookup['ORDER_CANCELLED_EVENT_TYPE.9'] = "Cancelled via Emag track";
constants.ORDER_CANCELLED_EVENT_TYPE_KUMI_TRACK = 10;
displayLookup['ORDER_CANCELLED_EVENT_TYPE.10'] = "Cancelled via Kumi track";
constants.ORDER_CANCELLED_EVENT_TYPE_KOVA_TRANS_TRACK = 11;
displayLookup['ORDER_CANCELLED_EVENT_TYPE.11'] = "Cancelled via KovaTrans track";
constants.ORDER_CANCELLED_EVENT_TYPE_PANNONXP_TRACK = 12;
displayLookup['ORDER_CANCELLED_EVENT_TYPE.12'] = "Cancelled via PannonXP track";

constants.ORDER_CHECK_ITEM_STATUS = {
  MISSING: { color: "#ffb74d", label: [true], value: -1 },
  UNCHECKED: { color: "#e5e5e5", label: [true], value: 0 },
  CHECKED: { color: "#66bb6a", label: [true], value: 1 },
  EXTRA: { color: "#e57373", label: [true], value: 2 }
};
constants.ORDER_CHECK_ITEM_STATUS_MISSING = -1;
displayLookup['ORDER_CHECK_ITEM_STATUS.-1'] = ["order check item status", "missing"];
colorLookup['ORDER_CHECK_ITEM_STATUS.-1'] = "#ffb74d";
colorNameLookup['ORDER_CHECK_ITEM_STATUS.-1'] = "YELLOW";
constants.ORDER_CHECK_ITEM_STATUS_UNCHECKED = 0;
displayLookup['ORDER_CHECK_ITEM_STATUS.0'] = ["order check item status", "unchecked"];
colorLookup['ORDER_CHECK_ITEM_STATUS.0'] = "#e5e5e5";
colorNameLookup['ORDER_CHECK_ITEM_STATUS.0'] = "GREY";
constants.ORDER_CHECK_ITEM_STATUS_CHECKED = 1;
displayLookup['ORDER_CHECK_ITEM_STATUS.1'] = ["order check item status", "checked"];
colorLookup['ORDER_CHECK_ITEM_STATUS.1'] = "#66bb6a";
colorNameLookup['ORDER_CHECK_ITEM_STATUS.1'] = "GREEN";
constants.ORDER_CHECK_ITEM_STATUS_EXTRA = 2;
displayLookup['ORDER_CHECK_ITEM_STATUS.2'] = ["order check item status", "extra"];
colorLookup['ORDER_CHECK_ITEM_STATUS.2'] = "#e57373";
colorNameLookup['ORDER_CHECK_ITEM_STATUS.2'] = "RED";

constants.ORDER_CHECK_ITEM_TYPE = {
  NORMAL: { color: "#66bb6a", label: [true], value: "normal" },
  BUNDLE: { color: "#e57373", label: [true], value: "bundle" },
  BUNDLE_COMPONENT: { color: "#64b5f6", label: [true], value: "bundle_component" }
};
constants.ORDER_CHECK_ITEM_TYPE_NORMAL = "normal";
displayLookup['ORDER_CHECK_ITEM_TYPE."normal"'] = ["order check item type", "normal"];
colorLookup['ORDER_CHECK_ITEM_TYPE."normal"'] = "#66bb6a";
colorNameLookup['ORDER_CHECK_ITEM_TYPE."normal"'] = "GREEN";
constants.ORDER_CHECK_ITEM_TYPE_BUNDLE = "bundle";
displayLookup['ORDER_CHECK_ITEM_TYPE."bundle"'] = ["order check item type", "bundle"];
colorLookup['ORDER_CHECK_ITEM_TYPE."bundle"'] = "#e57373";
colorNameLookup['ORDER_CHECK_ITEM_TYPE."bundle"'] = "RED";
constants.ORDER_CHECK_ITEM_TYPE_BUNDLE_COMPONENT = "bundle_component";
displayLookup['ORDER_CHECK_ITEM_TYPE."bundle_component"'] = ["order check item type", "bundle component"];
colorLookup['ORDER_CHECK_ITEM_TYPE."bundle_component"'] = "#64b5f6";
colorNameLookup['ORDER_CHECK_ITEM_TYPE."bundle_component"'] = "BLUE";

constants.ORDER_COMPLETED_EVENT_TYPE = {
  MANUAL: { color: null, label: "Manual completion", value: 1 },
  TRANSACTION: { color: null, label: "Completed by transaction", value: 2 },
  WAREHOUSE_OPERATION: { color: null, label: "Completed by warehouse operation", value: 3 },
  GLS_TRACK: { color: null, label: "Completed by gls track", value: 4 },
  IMPORT: { color: null, label: "Imported as completed", value: 5 },
  SHOP_SALE: { color: null, label: "Shop sale order", value: 6 },
  SPRINTER_TRACK: { color: null, label: "Completed by sprinter track", value: 7 },
  PACKETA_TRACK: { color: null, label: "Completed by packeta track", value: 8 },
  MPL_TRACK: { color: null, label: "Completed by mpl track", value: 9 },
  FOXPOST_TRACK: { color: null, label: "Completed by foxpost track", value: 10 },
  AUTOMATISM: { color: null, label: true, value: 11 },
  MANUAL_TRACKING_PAGE: { color: null, label: "manually on tracking page", value: 12 },
  DPD_TRACK: { color: null, label: "Completed by dpd track", value: 13 },
  EXPRESS_ONE_TRACK: { color: null, label: "Completed by ExpressOne track", value: 14 },
  PACTIC_TRACK: { color: null, label: "Completed by Pactic track", value: 15 },
  EMAG_TRACK: { color: null, label: "Completed by Emag track", value: 16 },
  KUMI_TRACK: { color: null, label: "Completed by Kumi track", value: 17 },
  KOVA_TRANS_TRACK: { color: null, label: "Completed by KovaTrans track", value: 18 },
  PANNONXP_TRACK: { color: null, label: "Completed by PannonXP track", value: 19 }
};
constants.ORDER_COMPLETED_EVENT_TYPE_MANUAL = 1;
displayLookup['ORDER_COMPLETED_EVENT_TYPE.1'] = "Manual completion";
constants.ORDER_COMPLETED_EVENT_TYPE_TRANSACTION = 2;
displayLookup['ORDER_COMPLETED_EVENT_TYPE.2'] = "Completed by transaction";
constants.ORDER_COMPLETED_EVENT_TYPE_WAREHOUSE_OPERATION = 3;
displayLookup['ORDER_COMPLETED_EVENT_TYPE.3'] = "Completed by warehouse operation";
constants.ORDER_COMPLETED_EVENT_TYPE_GLS_TRACK = 4;
displayLookup['ORDER_COMPLETED_EVENT_TYPE.4'] = "Completed by gls track";
constants.ORDER_COMPLETED_EVENT_TYPE_IMPORT = 5;
displayLookup['ORDER_COMPLETED_EVENT_TYPE.5'] = "Imported as completed";
constants.ORDER_COMPLETED_EVENT_TYPE_SHOP_SALE = 6;
displayLookup['ORDER_COMPLETED_EVENT_TYPE.6'] = "Shop sale order";
constants.ORDER_COMPLETED_EVENT_TYPE_SPRINTER_TRACK = 7;
displayLookup['ORDER_COMPLETED_EVENT_TYPE.7'] = "Completed by sprinter track";
constants.ORDER_COMPLETED_EVENT_TYPE_PACKETA_TRACK = 8;
displayLookup['ORDER_COMPLETED_EVENT_TYPE.8'] = "Completed by packeta track";
constants.ORDER_COMPLETED_EVENT_TYPE_MPL_TRACK = 9;
displayLookup['ORDER_COMPLETED_EVENT_TYPE.9'] = "Completed by mpl track";
constants.ORDER_COMPLETED_EVENT_TYPE_FOXPOST_TRACK = 10;
displayLookup['ORDER_COMPLETED_EVENT_TYPE.10'] = "Completed by foxpost track";
constants.ORDER_COMPLETED_EVENT_TYPE_AUTOMATISM = 11;
displayLookup['ORDER_COMPLETED_EVENT_TYPE.11'] = "automatism";
constants.ORDER_COMPLETED_EVENT_TYPE_MANUAL_TRACKING_PAGE = 12;
displayLookup['ORDER_COMPLETED_EVENT_TYPE.12'] = "manually on tracking page";
constants.ORDER_COMPLETED_EVENT_TYPE_DPD_TRACK = 13;
displayLookup['ORDER_COMPLETED_EVENT_TYPE.13'] = "Completed by dpd track";
constants.ORDER_COMPLETED_EVENT_TYPE_EXPRESS_ONE_TRACK = 14;
displayLookup['ORDER_COMPLETED_EVENT_TYPE.14'] = "Completed by ExpressOne track";
constants.ORDER_COMPLETED_EVENT_TYPE_PACTIC_TRACK = 15;
displayLookup['ORDER_COMPLETED_EVENT_TYPE.15'] = "Completed by Pactic track";
constants.ORDER_COMPLETED_EVENT_TYPE_EMAG_TRACK = 16;
displayLookup['ORDER_COMPLETED_EVENT_TYPE.16'] = "Completed by Emag track";
constants.ORDER_COMPLETED_EVENT_TYPE_KUMI_TRACK = 17;
displayLookup['ORDER_COMPLETED_EVENT_TYPE.17'] = "Completed by Kumi track";
constants.ORDER_COMPLETED_EVENT_TYPE_KOVA_TRANS_TRACK = 18;
displayLookup['ORDER_COMPLETED_EVENT_TYPE.18'] = "Completed by KovaTrans track";
constants.ORDER_COMPLETED_EVENT_TYPE_PANNONXP_TRACK = 19;
displayLookup['ORDER_COMPLETED_EVENT_TYPE.19'] = "Completed by PannonXP track";

constants.ORDER_DATA_SHEET_SHOW_PRICES = {
  NOT_SET: { color: null, label: true, value: 1 },
  DONT_SHOW: { color: null, label: true, value: 2 },
  SHOW: { color: null, label: true, value: 3 }
};
constants.ORDER_DATA_SHEET_SHOW_PRICES_NOT_SET = 1;
displayLookup['ORDER_DATA_SHEET_SHOW_PRICES.1'] = "not set";
constants.ORDER_DATA_SHEET_SHOW_PRICES_DONT_SHOW = 2;
displayLookup['ORDER_DATA_SHEET_SHOW_PRICES.2'] = "dont show";
constants.ORDER_DATA_SHEET_SHOW_PRICES_SHOW = 3;
displayLookup['ORDER_DATA_SHEET_SHOW_PRICES.3'] = "show";

constants.ORDER_EVENT_TYPE = {
  DEVELOPER_ACTION: { color: null, label: true, value: -1 },
  CREATED: { color: null, label: true, value: 1 },
  IMPORTED: { color: null, label: true, value: 2 },
  TRANSACTION_CREATED: { color: null, label: true, value: 3 },
  TRANSACTION_CANCELLED: { color: null, label: true, value: 4 },
  TO_CONFIRM: { color: null, label: true, value: 5 },
  CONFIRMED: { color: null, label: true, value: 6 },
  EDITED: { color: null, label: true, value: 7 },
  WAREHOUSE_OPERATION_CREATED: { color: null, label: true, value: 8 },
  WAREHOUSE_OPERATION_CANCELLED: { color: null, label: true, value: 9 },
  CHECKED: { color: null, label: true, value: 10 },
  UNCHECKED: { color: null, label: true, value: 11 },
  LOCAL_PICKUP: { color: null, label: true, value: 12 },
  INVOICE_GENERATED: { color: null, label: true, value: 13 },
  READY_TO_PACK: { color: null, label: true, value: 14 },
  COMPLETED: { color: null, label: true, value: 15 },
  DELIVERY: { color: null, label: true, value: 16 },
  DELIVERED: { color: null, label: true, value: 17 },
  CANCELLED: { color: null, label: true, value: 18 },
  DELETED: { color: null, label: true, value: 19 },
  MERGED: { color: null, label: true, value: 20 },
  LABEL_PRINTED: { color: null, label: true, value: 21 },
  PACKAGING_ADDED: { color: null, label: true, value: 22 },
  RETURN_STARTED: { color: null, label: true, value: 23 },
  DISASSEMBLED: { color: null, label: true, value: 24 },
  INVOICE_PRINTED: { color: null, label: true, value: 25 },
  EXPECTED_ARRIVAL_DATE_UPDATED: { color: null, label: true, value: 26 },
  ON_STOCK_QUANTITY_UPDATED: { color: null, label: "has stock updated", value: 27 },
  LABEL_DELETED: { color: null, label: true, value: 28 },
  INVOICE_GENERATION_FAILED: { color: null, label: true, value: 29 },
  TAG_CREATED: { color: null, label: true, value: 30 },
  TAG_DELETED: { color: null, label: true, value: 31 },
  TASK_CREATED: { color: null, label: true, value: 32 },
  TASK_COMPLETED: { color: null, label: true, value: 33 },
  TASK_DELETED: { color: null, label: true, value: 34 },
  FIELDS_UPDATED: { color: null, label: true, value: 35 },
  GLS_COD_PROCESSED: { color: null, label: true, value: 36 },
  CHILD_ORDER_DELETED: { color: null, label: true, value: 37 },
  PAYMENT_METHOD_CHANGED: { color: null, label: true, value: 38 },
  COPIED: { color: null, label: true, value: 39 },
  WAREHOUSE_OPERATION_PICKED: { color: null, label: true, value: 40 },
  INCOMING_QUANTITY_UPDATED: { color: null, label: "incoming updated", value: 41 },
  EDI_ORDER_RESPONSE_SEND_SUCCESS: { color: null, label: "edi order response sent successfully", value: 42 },
  EDI_ORDER_RESPONSE_SEND_FAILED: { color: null, label: "edi order response sent failed", value: 43 },
  EDI_INVOICE_SEND_SUCCESS: { color: null, label: "edi invoice sent successfully", value: 44 },
  EDI_INVOICE_SEND_FAILED: { color: null, label: "edi invoice sent failed", value: 45 },
  MESSAGE_CREATED: { color: null, label: true, value: 46 },
  MESSAGE_SEND_SUCCESS: { color: null, label: true, value: 47 },
  MESSAGE_SEND_FAILED: { color: null, label: true, value: 48 },
  FEE_CREATED: { color: null, label: true, value: 49 },
  INITIAL_STOCK_STATUS_CALCULATED: { color: null, label: true, value: 50 },
  FAILED_AT_WEBSHOP: { color: null, label: true, value: 51 },
  CONFIRMED_AT_WEBSHOP: { color: null, label: true, value: 52 },
  INVOICE_CHANGED: { color: null, label: true, value: 53 },
  WAREHOUSE_CHANGED: { color: null, label: true, value: 54 },
  PAID_SYNC_SUCCESS: { color: null, label: true, value: 55 },
  PAID_SYNC_FAILED: { color: null, label: true, value: 56 },
  WAITING_FOR_LOCAL_PICKUP: { color: null, label: true, value: 57 },
  BACK_TO_PICKED: { color: null, label: true, value: 58 },
  PRICE_LIST_CHANGED: { color: null, label: true, value: 59 },
  CASH_REGISTER_SUBMIT: { color: null, label: true, value: 60 },
  CONFIRM_BY_DUE_DATE: { color: null, label: true, value: 61 },
  WAREHOUSE_OPERATION_DELETED: { color: null, label: true, value: 62 },
  INVOICE_DELETED: { color: null, label: true, value: 63 },
  SENT_TO_3PL: { color: null, label: true, value: 64 },
  DAMAGED_DURING_SHIPPING: { color: null, label: true, value: 65 },
  INVOICE_SYNC_SUCCESS: { color: null, label: true, value: 66 },
  INVOICE_SYNC_FAILED: { color: null, label: true, value: 67 },
  POS_INVOICE_CREATE_STARTED: { color: null, label: true, value: 68 },
  CANCELLATION_UNDONE: { color: null, label: true, value: 69 },
  MESSAGE_SEND_CANCELLED: { color: null, label: true, value: 70 },
  CUSTOMER_CREDIT_LIMIT_EXCEEDED: { color: null, label: true, value: 71 },
  CUSTOMER_CREDIT_LIMIT_RESTORED: { color: null, label: true, value: 72 },
  EDI_DESPATCH_ADVICE_SEND_SUCCESS: { color: null, label: "edi despatch advice sent successfully", value: 73 },
  EDI_DESPATCH_ADVICE_SEND_FAILED: { color: null, label: "edi despatch advice sent failed", value: 74 },
  KOVA_TRANS_COD_PROCESSED: { color: null, label: true, value: 75 },
  EXPRESS_ONE_COD_PROCESSED: { color: null, label: true, value: 76 },
  BALANCE_CHANGED: { color: null, label: true, value: 77 },
  MPL_COD_PROCESSED: { color: null, label: true, value: 78 }
};
constants.ORDER_EVENT_TYPE_DEVELOPER_ACTION = -1;
displayLookup['ORDER_EVENT_TYPE.-1'] = "developer action";
constants.ORDER_EVENT_TYPE_CREATED = 1;
displayLookup['ORDER_EVENT_TYPE.1'] = "created";
constants.ORDER_EVENT_TYPE_IMPORTED = 2;
displayLookup['ORDER_EVENT_TYPE.2'] = "imported";
constants.ORDER_EVENT_TYPE_TRANSACTION_CREATED = 3;
displayLookup['ORDER_EVENT_TYPE.3'] = "transaction created";
constants.ORDER_EVENT_TYPE_TRANSACTION_CANCELLED = 4;
displayLookup['ORDER_EVENT_TYPE.4'] = "transaction cancelled";
constants.ORDER_EVENT_TYPE_TO_CONFIRM = 5;
displayLookup['ORDER_EVENT_TYPE.5'] = "to confirm";
constants.ORDER_EVENT_TYPE_CONFIRMED = 6;
displayLookup['ORDER_EVENT_TYPE.6'] = "confirmed";
constants.ORDER_EVENT_TYPE_EDITED = 7;
displayLookup['ORDER_EVENT_TYPE.7'] = "edited";
constants.ORDER_EVENT_TYPE_WAREHOUSE_OPERATION_CREATED = 8;
displayLookup['ORDER_EVENT_TYPE.8'] = "warehouse operation created";
constants.ORDER_EVENT_TYPE_WAREHOUSE_OPERATION_CANCELLED = 9;
displayLookup['ORDER_EVENT_TYPE.9'] = "warehouse operation cancelled";
constants.ORDER_EVENT_TYPE_CHECKED = 10;
displayLookup['ORDER_EVENT_TYPE.10'] = "checked";
constants.ORDER_EVENT_TYPE_UNCHECKED = 11;
displayLookup['ORDER_EVENT_TYPE.11'] = "unchecked";
constants.ORDER_EVENT_TYPE_LOCAL_PICKUP = 12;
displayLookup['ORDER_EVENT_TYPE.12'] = "local pickup";
constants.ORDER_EVENT_TYPE_INVOICE_GENERATED = 13;
displayLookup['ORDER_EVENT_TYPE.13'] = "invoice generated";
constants.ORDER_EVENT_TYPE_READY_TO_PACK = 14;
displayLookup['ORDER_EVENT_TYPE.14'] = "ready to pack";
constants.ORDER_EVENT_TYPE_COMPLETED = 15;
displayLookup['ORDER_EVENT_TYPE.15'] = "completed";
constants.ORDER_EVENT_TYPE_DELIVERY = 16;
displayLookup['ORDER_EVENT_TYPE.16'] = "delivery";
constants.ORDER_EVENT_TYPE_DELIVERED = 17;
displayLookup['ORDER_EVENT_TYPE.17'] = "delivered";
constants.ORDER_EVENT_TYPE_CANCELLED = 18;
displayLookup['ORDER_EVENT_TYPE.18'] = "cancelled";
constants.ORDER_EVENT_TYPE_DELETED = 19;
displayLookup['ORDER_EVENT_TYPE.19'] = "deleted";
constants.ORDER_EVENT_TYPE_MERGED = 20;
displayLookup['ORDER_EVENT_TYPE.20'] = "merged";
constants.ORDER_EVENT_TYPE_LABEL_PRINTED = 21;
displayLookup['ORDER_EVENT_TYPE.21'] = "label printed";
constants.ORDER_EVENT_TYPE_PACKAGING_ADDED = 22;
displayLookup['ORDER_EVENT_TYPE.22'] = "packaging added";
constants.ORDER_EVENT_TYPE_RETURN_STARTED = 23;
displayLookup['ORDER_EVENT_TYPE.23'] = "return started";
constants.ORDER_EVENT_TYPE_DISASSEMBLED = 24;
displayLookup['ORDER_EVENT_TYPE.24'] = "disassembled";
constants.ORDER_EVENT_TYPE_INVOICE_PRINTED = 25;
displayLookup['ORDER_EVENT_TYPE.25'] = "invoice printed";
constants.ORDER_EVENT_TYPE_EXPECTED_ARRIVAL_DATE_UPDATED = 26;
displayLookup['ORDER_EVENT_TYPE.26'] = "expected arrival date updated";
constants.ORDER_EVENT_TYPE_ON_STOCK_QUANTITY_UPDATED = 27;
displayLookup['ORDER_EVENT_TYPE.27'] = "has stock updated";
constants.ORDER_EVENT_TYPE_LABEL_DELETED = 28;
displayLookup['ORDER_EVENT_TYPE.28'] = "label deleted";
constants.ORDER_EVENT_TYPE_INVOICE_GENERATION_FAILED = 29;
displayLookup['ORDER_EVENT_TYPE.29'] = "invoice generation failed";
constants.ORDER_EVENT_TYPE_TAG_CREATED = 30;
displayLookup['ORDER_EVENT_TYPE.30'] = "tag created";
constants.ORDER_EVENT_TYPE_TAG_DELETED = 31;
displayLookup['ORDER_EVENT_TYPE.31'] = "tag deleted";
constants.ORDER_EVENT_TYPE_TASK_CREATED = 32;
displayLookup['ORDER_EVENT_TYPE.32'] = "task created";
constants.ORDER_EVENT_TYPE_TASK_COMPLETED = 33;
displayLookup['ORDER_EVENT_TYPE.33'] = "task completed";
constants.ORDER_EVENT_TYPE_TASK_DELETED = 34;
displayLookup['ORDER_EVENT_TYPE.34'] = "task deleted";
constants.ORDER_EVENT_TYPE_FIELDS_UPDATED = 35;
displayLookup['ORDER_EVENT_TYPE.35'] = "fields updated";
constants.ORDER_EVENT_TYPE_GLS_COD_PROCESSED = 36;
displayLookup['ORDER_EVENT_TYPE.36'] = "gls cod processed";
constants.ORDER_EVENT_TYPE_CHILD_ORDER_DELETED = 37;
displayLookup['ORDER_EVENT_TYPE.37'] = "child order deleted";
constants.ORDER_EVENT_TYPE_PAYMENT_METHOD_CHANGED = 38;
displayLookup['ORDER_EVENT_TYPE.38'] = "payment method changed";
constants.ORDER_EVENT_TYPE_COPIED = 39;
displayLookup['ORDER_EVENT_TYPE.39'] = "copied";
constants.ORDER_EVENT_TYPE_WAREHOUSE_OPERATION_PICKED = 40;
displayLookup['ORDER_EVENT_TYPE.40'] = "warehouse operation picked";
constants.ORDER_EVENT_TYPE_INCOMING_QUANTITY_UPDATED = 41;
displayLookup['ORDER_EVENT_TYPE.41'] = "incoming updated";
constants.ORDER_EVENT_TYPE_EDI_ORDER_RESPONSE_SEND_SUCCESS = 42;
displayLookup['ORDER_EVENT_TYPE.42'] = "edi order response sent successfully";
constants.ORDER_EVENT_TYPE_EDI_ORDER_RESPONSE_SEND_FAILED = 43;
displayLookup['ORDER_EVENT_TYPE.43'] = "edi order response sent failed";
constants.ORDER_EVENT_TYPE_EDI_INVOICE_SEND_SUCCESS = 44;
displayLookup['ORDER_EVENT_TYPE.44'] = "edi invoice sent successfully";
constants.ORDER_EVENT_TYPE_EDI_INVOICE_SEND_FAILED = 45;
displayLookup['ORDER_EVENT_TYPE.45'] = "edi invoice sent failed";
constants.ORDER_EVENT_TYPE_MESSAGE_CREATED = 46;
displayLookup['ORDER_EVENT_TYPE.46'] = "message created";
constants.ORDER_EVENT_TYPE_MESSAGE_SEND_SUCCESS = 47;
displayLookup['ORDER_EVENT_TYPE.47'] = "message send success";
constants.ORDER_EVENT_TYPE_MESSAGE_SEND_FAILED = 48;
displayLookup['ORDER_EVENT_TYPE.48'] = "message send failed";
constants.ORDER_EVENT_TYPE_FEE_CREATED = 49;
displayLookup['ORDER_EVENT_TYPE.49'] = "fee created";
constants.ORDER_EVENT_TYPE_INITIAL_STOCK_STATUS_CALCULATED = 50;
displayLookup['ORDER_EVENT_TYPE.50'] = "initial stock status calculated";
constants.ORDER_EVENT_TYPE_FAILED_AT_WEBSHOP = 51;
displayLookup['ORDER_EVENT_TYPE.51'] = "failed at webshop";
constants.ORDER_EVENT_TYPE_CONFIRMED_AT_WEBSHOP = 52;
displayLookup['ORDER_EVENT_TYPE.52'] = "confirmed at webshop";
constants.ORDER_EVENT_TYPE_INVOICE_CHANGED = 53;
displayLookup['ORDER_EVENT_TYPE.53'] = "invoice changed";
constants.ORDER_EVENT_TYPE_WAREHOUSE_CHANGED = 54;
displayLookup['ORDER_EVENT_TYPE.54'] = "warehouse changed";
constants.ORDER_EVENT_TYPE_PAID_SYNC_SUCCESS = 55;
displayLookup['ORDER_EVENT_TYPE.55'] = "paid sync success";
constants.ORDER_EVENT_TYPE_PAID_SYNC_FAILED = 56;
displayLookup['ORDER_EVENT_TYPE.56'] = "paid sync failed";
constants.ORDER_EVENT_TYPE_WAITING_FOR_LOCAL_PICKUP = 57;
displayLookup['ORDER_EVENT_TYPE.57'] = "waiting for local pickup";
constants.ORDER_EVENT_TYPE_BACK_TO_PICKED = 58;
displayLookup['ORDER_EVENT_TYPE.58'] = "back to picked";
constants.ORDER_EVENT_TYPE_PRICE_LIST_CHANGED = 59;
displayLookup['ORDER_EVENT_TYPE.59'] = "price list changed";
constants.ORDER_EVENT_TYPE_CASH_REGISTER_SUBMIT = 60;
displayLookup['ORDER_EVENT_TYPE.60'] = "cash register submit";
constants.ORDER_EVENT_TYPE_CONFIRM_BY_DUE_DATE = 61;
displayLookup['ORDER_EVENT_TYPE.61'] = "confirm by due date";
constants.ORDER_EVENT_TYPE_WAREHOUSE_OPERATION_DELETED = 62;
displayLookup['ORDER_EVENT_TYPE.62'] = "warehouse operation deleted";
constants.ORDER_EVENT_TYPE_INVOICE_DELETED = 63;
displayLookup['ORDER_EVENT_TYPE.63'] = "invoice deleted";
constants.ORDER_EVENT_TYPE_SENT_TO_3PL = 64;
displayLookup['ORDER_EVENT_TYPE.64'] = "sent to 3pl";
constants.ORDER_EVENT_TYPE_DAMAGED_DURING_SHIPPING = 65;
displayLookup['ORDER_EVENT_TYPE.65'] = "damaged during shipping";
constants.ORDER_EVENT_TYPE_INVOICE_SYNC_SUCCESS = 66;
displayLookup['ORDER_EVENT_TYPE.66'] = "invoice sync success";
constants.ORDER_EVENT_TYPE_INVOICE_SYNC_FAILED = 67;
displayLookup['ORDER_EVENT_TYPE.67'] = "invoice sync failed";
constants.ORDER_EVENT_TYPE_POS_INVOICE_CREATE_STARTED = 68;
displayLookup['ORDER_EVENT_TYPE.68'] = "pos invoice create started";
constants.ORDER_EVENT_TYPE_CANCELLATION_UNDONE = 69;
displayLookup['ORDER_EVENT_TYPE.69'] = "cancellation undone";
constants.ORDER_EVENT_TYPE_MESSAGE_SEND_CANCELLED = 70;
displayLookup['ORDER_EVENT_TYPE.70'] = "message send cancelled";
constants.ORDER_EVENT_TYPE_CUSTOMER_CREDIT_LIMIT_EXCEEDED = 71;
displayLookup['ORDER_EVENT_TYPE.71'] = "customer credit limit exceeded";
constants.ORDER_EVENT_TYPE_CUSTOMER_CREDIT_LIMIT_RESTORED = 72;
displayLookup['ORDER_EVENT_TYPE.72'] = "customer credit limit restored";
constants.ORDER_EVENT_TYPE_EDI_DESPATCH_ADVICE_SEND_SUCCESS = 73;
displayLookup['ORDER_EVENT_TYPE.73'] = "edi despatch advice sent successfully";
constants.ORDER_EVENT_TYPE_EDI_DESPATCH_ADVICE_SEND_FAILED = 74;
displayLookup['ORDER_EVENT_TYPE.74'] = "edi despatch advice sent failed";
constants.ORDER_EVENT_TYPE_KOVA_TRANS_COD_PROCESSED = 75;
displayLookup['ORDER_EVENT_TYPE.75'] = "kova trans cod processed";
constants.ORDER_EVENT_TYPE_EXPRESS_ONE_COD_PROCESSED = 76;
displayLookup['ORDER_EVENT_TYPE.76'] = "express one cod processed";
constants.ORDER_EVENT_TYPE_BALANCE_CHANGED = 77;
displayLookup['ORDER_EVENT_TYPE.77'] = "balance changed";
constants.ORDER_EVENT_TYPE_MPL_COD_PROCESSED = 78;
displayLookup['ORDER_EVENT_TYPE.78'] = "mpl cod processed";

constants.ORDER_FEE_TYPE = {
  SHIPPING: { color: null, label: true, value: 1 },
  OTHER: { color: null, label: true, value: 2 },
  PRODUCT_EXTRA_SERVICE: { color: null, label: true, value: 3 }
};
constants.ORDER_FEE_TYPE_SHIPPING = 1;
displayLookup['ORDER_FEE_TYPE.1'] = "shipping";
constants.ORDER_FEE_TYPE_OTHER = 2;
displayLookup['ORDER_FEE_TYPE.2'] = "other";
constants.ORDER_FEE_TYPE_PRODUCT_EXTRA_SERVICE = 3;
displayLookup['ORDER_FEE_TYPE.3'] = "product extra service";

constants.ORDER_FEE_TYPE_PLUS_SERVICE_BEHAVIOR = {
  DEFAULT: { color: null, label: "default", value: 1 },
  NOT_REQUIRED: { color: null, label: "not required", value: 2 },
  REQUIRED_REDIRECT: { color: null, label: "mandatory to choose, directing the customer from the list page to the details page", value: 3 },
  REQUIRED_FIRST_OPTION: { color: null, label: "mandatory to choose, by default the first service is added to the basket", value: 4 }
};
constants.ORDER_FEE_TYPE_PLUS_SERVICE_BEHAVIOR_DEFAULT = 1;
displayLookup['ORDER_FEE_TYPE_PLUS_SERVICE_BEHAVIOR.1'] = "default";
constants.ORDER_FEE_TYPE_PLUS_SERVICE_BEHAVIOR_NOT_REQUIRED = 2;
displayLookup['ORDER_FEE_TYPE_PLUS_SERVICE_BEHAVIOR.2'] = "not required";
constants.ORDER_FEE_TYPE_PLUS_SERVICE_BEHAVIOR_REQUIRED_REDIRECT = 3;
displayLookup['ORDER_FEE_TYPE_PLUS_SERVICE_BEHAVIOR.3'] = "mandatory to choose, directing the customer from the list page to the details page";
constants.ORDER_FEE_TYPE_PLUS_SERVICE_BEHAVIOR_REQUIRED_FIRST_OPTION = 4;
displayLookup['ORDER_FEE_TYPE_PLUS_SERVICE_BEHAVIOR.4'] = "mandatory to choose, by default the first service is added to the basket";

constants.ORDER_INVOICE_CREATION_POINT = {
  TO_CONFIRM: { color: null, label: true, value: 1 },
  COMPLETED: { color: null, label: true, value: 2 },
  PRINTED: { color: null, label: "label printed", value: 3 },
  PAYMENT_COMPLETED: { color: null, label: true, value: 4 },
  CANCELLED: { color: null, label: true, value: 5 },
  PICKED: { color: null, label: true, value: 6 },
  PRINTED_OR_LOCAL_PICKUP: { color: null, label: "label printed or local pickup", value: 7 },
  READY_TO_PACK: { color: null, label: true, value: 8 },
  PREPAYMENT_COMPLETED: { color: null, label: true, value: 9 },
  COMPLETED_AND_PAID: { color: null, label: true, value: 10 },
  PREPAYMENT_OR_PAYMENT_COMPLETED: { color: null, label: true, value: 11 }
};
constants.ORDER_INVOICE_CREATION_POINT_TO_CONFIRM = 1;
displayLookup['ORDER_INVOICE_CREATION_POINT.1'] = "to confirm";
constants.ORDER_INVOICE_CREATION_POINT_COMPLETED = 2;
displayLookup['ORDER_INVOICE_CREATION_POINT.2'] = "completed";
constants.ORDER_INVOICE_CREATION_POINT_PRINTED = 3;
displayLookup['ORDER_INVOICE_CREATION_POINT.3'] = "label printed";
constants.ORDER_INVOICE_CREATION_POINT_PAYMENT_COMPLETED = 4;
displayLookup['ORDER_INVOICE_CREATION_POINT.4'] = "payment completed";
constants.ORDER_INVOICE_CREATION_POINT_CANCELLED = 5;
displayLookup['ORDER_INVOICE_CREATION_POINT.5'] = "cancelled";
constants.ORDER_INVOICE_CREATION_POINT_PICKED = 6;
displayLookup['ORDER_INVOICE_CREATION_POINT.6'] = "picked";
constants.ORDER_INVOICE_CREATION_POINT_PRINTED_OR_LOCAL_PICKUP = 7;
displayLookup['ORDER_INVOICE_CREATION_POINT.7'] = "label printed or local pickup";
constants.ORDER_INVOICE_CREATION_POINT_READY_TO_PACK = 8;
displayLookup['ORDER_INVOICE_CREATION_POINT.8'] = "ready to pack";
constants.ORDER_INVOICE_CREATION_POINT_PREPAYMENT_COMPLETED = 9;
displayLookup['ORDER_INVOICE_CREATION_POINT.9'] = "prepayment completed";
constants.ORDER_INVOICE_CREATION_POINT_COMPLETED_AND_PAID = 10;
displayLookup['ORDER_INVOICE_CREATION_POINT.10'] = "completed and paid";
constants.ORDER_INVOICE_CREATION_POINT_PREPAYMENT_OR_PAYMENT_COMPLETED = 11;
displayLookup['ORDER_INVOICE_CREATION_POINT.11'] = "prepayment or payment completed";

constants.ORDER_INVOICE_FULFILLMENT_DATE_KEY = {
  TO_CONFIRM: { color: null, label: true, value: "created_timestamp" },
  COMPLETED: { color: null, label: true, value: "completed_timestamp" },
  BEFORE_DELIVERY: { color: null, label: true, value: "delivery_timestamp" },
  PAYMENT_COMPLETED: { color: null, label: true, value: "paid_timestamp" },
  CANCELLED: { color: null, label: "Reverse", value: "cancelled_timestamp" },
  PREPAYMENT_COMPLETED: { color: null, label: true, value: "prepaid_timestamp" },
  DATA_SHEET_PRINTED: { color: null, label: true, value: "data_sheet_print_timestamp" },
  ORIGINAL_INVOICE: { color: null, label: "original invoice", value: "invoice_fulfillment_date" },
  DELIVERY_DATE_OR_NEXT_WORKDAY: { color: null, label: true, value: "customer_requested_delivery_date" }
};
constants.ORDER_INVOICE_FULFILLMENT_DATE_KEY_TO_CONFIRM = "created_timestamp";
displayLookup['ORDER_INVOICE_FULFILLMENT_DATE_KEY."created_timestamp"'] = "to confirm";
constants.ORDER_INVOICE_FULFILLMENT_DATE_KEY_COMPLETED = "completed_timestamp";
displayLookup['ORDER_INVOICE_FULFILLMENT_DATE_KEY."completed_timestamp"'] = "completed";
constants.ORDER_INVOICE_FULFILLMENT_DATE_KEY_BEFORE_DELIVERY = "delivery_timestamp";
displayLookup['ORDER_INVOICE_FULFILLMENT_DATE_KEY."delivery_timestamp"'] = "before delivery";
constants.ORDER_INVOICE_FULFILLMENT_DATE_KEY_PAYMENT_COMPLETED = "paid_timestamp";
displayLookup['ORDER_INVOICE_FULFILLMENT_DATE_KEY."paid_timestamp"'] = "payment completed";
constants.ORDER_INVOICE_FULFILLMENT_DATE_KEY_CANCELLED = "cancelled_timestamp";
displayLookup['ORDER_INVOICE_FULFILLMENT_DATE_KEY."cancelled_timestamp"'] = "Reverse";
constants.ORDER_INVOICE_FULFILLMENT_DATE_KEY_PREPAYMENT_COMPLETED = "prepaid_timestamp";
displayLookup['ORDER_INVOICE_FULFILLMENT_DATE_KEY."prepaid_timestamp"'] = "prepayment completed";
constants.ORDER_INVOICE_FULFILLMENT_DATE_KEY_DATA_SHEET_PRINTED = "data_sheet_print_timestamp";
displayLookup['ORDER_INVOICE_FULFILLMENT_DATE_KEY."data_sheet_print_timestamp"'] = "data sheet printed";
constants.ORDER_INVOICE_FULFILLMENT_DATE_KEY_ORIGINAL_INVOICE = "invoice_fulfillment_date";
displayLookup['ORDER_INVOICE_FULFILLMENT_DATE_KEY."invoice_fulfillment_date"'] = "original invoice";
constants.ORDER_INVOICE_FULFILLMENT_DATE_KEY_DELIVERY_DATE_OR_NEXT_WORKDAY = "customer_requested_delivery_date";
displayLookup['ORDER_INVOICE_FULFILLMENT_DATE_KEY."customer_requested_delivery_date"'] = "delivery date or next workday";

constants.ORDER_INVOICE_TYPE = {
  PROFORMA: { color: null, label: true, value: 1 },
  PREPAYMENT: { color: null, label: true, value: 2 },
  PROFORMA_2: { color: null, label: "2nd Proforma", value: 3 },
  STANDARD: { color: null, label: [true], value: 4 },
  CORRECTING: { color: null, label: true, value: 5 },
  REVERSE: { color: null, label: true, value: 6 },
  PREPAYMENT_REVERSE: { color: null, label: true, value: 7 }
};
constants.ORDER_INVOICE_TYPE_PROFORMA = 1;
displayLookup['ORDER_INVOICE_TYPE.1'] = "proforma";
constants.ORDER_INVOICE_TYPE_PREPAYMENT = 2;
displayLookup['ORDER_INVOICE_TYPE.2'] = "prepayment";
constants.ORDER_INVOICE_TYPE_PROFORMA_2 = 3;
displayLookup['ORDER_INVOICE_TYPE.3'] = "2nd Proforma";
constants.ORDER_INVOICE_TYPE_STANDARD = 4;
displayLookup['ORDER_INVOICE_TYPE.4'] = ["order invoice type", "standard"];
constants.ORDER_INVOICE_TYPE_CORRECTING = 5;
displayLookup['ORDER_INVOICE_TYPE.5'] = "correcting";
constants.ORDER_INVOICE_TYPE_REVERSE = 6;
displayLookup['ORDER_INVOICE_TYPE.6'] = "reverse";
constants.ORDER_INVOICE_TYPE_PREPAYMENT_REVERSE = 7;
displayLookup['ORDER_INVOICE_TYPE.7'] = "prepayment reverse";

constants.ORDER_IN_PURCHASE_ORDER_STOCK_STATUS = {
  FULLY_COVERED: { color: "#66bb6a", label: true, value: 1 },
  PARTIALLY_COVERED: { color: "#ffb74d", label: true, value: 2 },
  NOT_COVERED: { color: "#e57373", label: true, value: 3 }
};
constants.ORDER_IN_PURCHASE_ORDER_STOCK_STATUS_FULLY_COVERED = 1;
displayLookup['ORDER_IN_PURCHASE_ORDER_STOCK_STATUS.1'] = "fully covered";
colorLookup['ORDER_IN_PURCHASE_ORDER_STOCK_STATUS.1'] = "#66bb6a";
colorNameLookup['ORDER_IN_PURCHASE_ORDER_STOCK_STATUS.1'] = "GREEN";
constants.ORDER_IN_PURCHASE_ORDER_STOCK_STATUS_PARTIALLY_COVERED = 2;
displayLookup['ORDER_IN_PURCHASE_ORDER_STOCK_STATUS.2'] = "partially covered";
colorLookup['ORDER_IN_PURCHASE_ORDER_STOCK_STATUS.2'] = "#ffb74d";
colorNameLookup['ORDER_IN_PURCHASE_ORDER_STOCK_STATUS.2'] = "YELLOW";
constants.ORDER_IN_PURCHASE_ORDER_STOCK_STATUS_NOT_COVERED = 3;
displayLookup['ORDER_IN_PURCHASE_ORDER_STOCK_STATUS.3'] = "not covered";
colorLookup['ORDER_IN_PURCHASE_ORDER_STOCK_STATUS.3'] = "#e57373";
colorNameLookup['ORDER_IN_PURCHASE_ORDER_STOCK_STATUS.3'] = "RED";

constants.ORDER_IN_WAREHOUSE_STOCK_STATUS = {
  ON_STOCK: { color: "#66bb6a", label: true, value: 1 },
  IN_WAREHOUSE: { color: "#ffb74d", label: true, value: 2 },
  SHORTAGE: { color: "#e57373", label: true, value: 3 }
};
constants.ORDER_IN_WAREHOUSE_STOCK_STATUS_ON_STOCK = 1;
displayLookup['ORDER_IN_WAREHOUSE_STOCK_STATUS.1'] = "on stock";
colorLookup['ORDER_IN_WAREHOUSE_STOCK_STATUS.1'] = "#66bb6a";
colorNameLookup['ORDER_IN_WAREHOUSE_STOCK_STATUS.1'] = "GREEN";
constants.ORDER_IN_WAREHOUSE_STOCK_STATUS_IN_WAREHOUSE = 2;
displayLookup['ORDER_IN_WAREHOUSE_STOCK_STATUS.2'] = "in warehouse";
colorLookup['ORDER_IN_WAREHOUSE_STOCK_STATUS.2'] = "#ffb74d";
colorNameLookup['ORDER_IN_WAREHOUSE_STOCK_STATUS.2'] = "YELLOW";
constants.ORDER_IN_WAREHOUSE_STOCK_STATUS_SHORTAGE = 3;
displayLookup['ORDER_IN_WAREHOUSE_STOCK_STATUS.3'] = "shortage";
colorLookup['ORDER_IN_WAREHOUSE_STOCK_STATUS.3'] = "#e57373";
colorNameLookup['ORDER_IN_WAREHOUSE_STOCK_STATUS.3'] = "RED";

constants.ORDER_ITEM_AVAILABILITY_STATUS = {
  RESERVED: { color: null, label: "Reserved", value: 1 },
  IN_PROCUREMENT: { color: null, label: "In procurement", value: 2 },
  OUT_OF_STOCK: { color: null, label: "Out of stock", value: 3 }
};
constants.ORDER_ITEM_AVAILABILITY_STATUS_RESERVED = 1;
displayLookup['ORDER_ITEM_AVAILABILITY_STATUS.1'] = "Reserved";
constants.ORDER_ITEM_AVAILABILITY_STATUS_IN_PROCUREMENT = 2;
displayLookup['ORDER_ITEM_AVAILABILITY_STATUS.2'] = "In procurement";
constants.ORDER_ITEM_AVAILABILITY_STATUS_OUT_OF_STOCK = 3;
displayLookup['ORDER_ITEM_AVAILABILITY_STATUS.3'] = "Out of stock";

constants.ORDER_ITEM_DISCOUNT_VIEW_TYPE = {
  NONE: { color: null, label: true, value: 1 },
  ORIGINAL_PRICE: { color: null, label: true, value: 2 },
  DISCOUNT: { color: null, label: true, value: 3 },
  DISCOUNT_AND_ORIGINAL_PRICE: { color: null, label: true, value: 4 },
  NEW_ITEM: { color: null, label: true, value: 5 }
};
constants.ORDER_ITEM_DISCOUNT_VIEW_TYPE_NONE = 1;
displayLookup['ORDER_ITEM_DISCOUNT_VIEW_TYPE.1'] = "none";
constants.ORDER_ITEM_DISCOUNT_VIEW_TYPE_ORIGINAL_PRICE = 2;
displayLookup['ORDER_ITEM_DISCOUNT_VIEW_TYPE.2'] = "original price";
constants.ORDER_ITEM_DISCOUNT_VIEW_TYPE_DISCOUNT = 3;
displayLookup['ORDER_ITEM_DISCOUNT_VIEW_TYPE.3'] = "discount";
constants.ORDER_ITEM_DISCOUNT_VIEW_TYPE_DISCOUNT_AND_ORIGINAL_PRICE = 4;
displayLookup['ORDER_ITEM_DISCOUNT_VIEW_TYPE.4'] = "discount and original price";
constants.ORDER_ITEM_DISCOUNT_VIEW_TYPE_NEW_ITEM = 5;
displayLookup['ORDER_ITEM_DISCOUNT_VIEW_TYPE.5'] = "new item";

constants.ORDER_ITEM_LIST_SHOW_COLUMN = {
  SKU: { color: null, label: true, value: 1 },
  AVAILABLE: { color: null, label: true, value: 2 },
  GROSS_TOTAL_DISCOUNT: { color: null, label: true, value: 3 },
  NET_SUBTOTAL: { color: null, label: true, value: 4 },
  VAT_SUBTOTAL: { color: null, label: true, value: 5 },
  GROSS_SUBTOTAL: { color: null, label: true, value: 6 },
  WEIGHT: { color: null, label: true, value: 7 },
  MARGIN_PERCENT: { color: null, label: true, value: 8 },
  DEFAULT_SUPPLIER_NET_PRICE: { color: null, label: true, value: 9 },
  LAST_LANDED_COST: { color: null, label: true, value: 10 },
  VOLUME: { color: null, label: true, value: 11 },
  SECONDARY_UNIT: { color: null, label: true, value: 12 },
  SECONDARY_UNIT_NET_PRICE: { color: null, label: true, value: 13 },
  SECONDARY_UNIT_GROSS_PRICE: { color: null, label: true, value: 14 }
};
constants.ORDER_ITEM_LIST_SHOW_COLUMN_SKU = 1;
displayLookup['ORDER_ITEM_LIST_SHOW_COLUMN.1'] = "sku";
constants.ORDER_ITEM_LIST_SHOW_COLUMN_AVAILABLE = 2;
displayLookup['ORDER_ITEM_LIST_SHOW_COLUMN.2'] = "available";
constants.ORDER_ITEM_LIST_SHOW_COLUMN_GROSS_TOTAL_DISCOUNT = 3;
displayLookup['ORDER_ITEM_LIST_SHOW_COLUMN.3'] = "gross total discount";
constants.ORDER_ITEM_LIST_SHOW_COLUMN_NET_SUBTOTAL = 4;
displayLookup['ORDER_ITEM_LIST_SHOW_COLUMN.4'] = "net subtotal";
constants.ORDER_ITEM_LIST_SHOW_COLUMN_VAT_SUBTOTAL = 5;
displayLookup['ORDER_ITEM_LIST_SHOW_COLUMN.5'] = "vat subtotal";
constants.ORDER_ITEM_LIST_SHOW_COLUMN_GROSS_SUBTOTAL = 6;
displayLookup['ORDER_ITEM_LIST_SHOW_COLUMN.6'] = "gross subtotal";
constants.ORDER_ITEM_LIST_SHOW_COLUMN_WEIGHT = 7;
displayLookup['ORDER_ITEM_LIST_SHOW_COLUMN.7'] = "weight";
constants.ORDER_ITEM_LIST_SHOW_COLUMN_MARGIN_PERCENT = 8;
displayLookup['ORDER_ITEM_LIST_SHOW_COLUMN.8'] = "margin percent";
constants.ORDER_ITEM_LIST_SHOW_COLUMN_DEFAULT_SUPPLIER_NET_PRICE = 9;
displayLookup['ORDER_ITEM_LIST_SHOW_COLUMN.9'] = "default supplier net price";
constants.ORDER_ITEM_LIST_SHOW_COLUMN_LAST_LANDED_COST = 10;
displayLookup['ORDER_ITEM_LIST_SHOW_COLUMN.10'] = "last landed cost";
constants.ORDER_ITEM_LIST_SHOW_COLUMN_VOLUME = 11;
displayLookup['ORDER_ITEM_LIST_SHOW_COLUMN.11'] = "volume";
constants.ORDER_ITEM_LIST_SHOW_COLUMN_SECONDARY_UNIT = 12;
displayLookup['ORDER_ITEM_LIST_SHOW_COLUMN.12'] = "secondary unit";
constants.ORDER_ITEM_LIST_SHOW_COLUMN_SECONDARY_UNIT_NET_PRICE = 13;
displayLookup['ORDER_ITEM_LIST_SHOW_COLUMN.13'] = "secondary unit net price";
constants.ORDER_ITEM_LIST_SHOW_COLUMN_SECONDARY_UNIT_GROSS_PRICE = 14;
displayLookup['ORDER_ITEM_LIST_SHOW_COLUMN.14'] = "secondary unit gross price";

constants.ORDER_ITEM_PRICE_TYPE = {
  CUSTOM: { color: null, label: "custom price", value: 1 },
  CUSTOM_VAT: { color: null, label: "custom vat", value: 5 },
  PRICE_LIST: { color: null, label: "price list price", value: 50 },
  SALE: { color: null, label: "sale price", value: 100 },
  QUANTITY_DISCOUNT: { color: null, label: true, value: 150 },
  NORMAL: { color: null, label: "normal price", value: 200 }
};
constants.ORDER_ITEM_PRICE_TYPE_CUSTOM = 1;
displayLookup['ORDER_ITEM_PRICE_TYPE.1'] = "custom price";
constants.ORDER_ITEM_PRICE_TYPE_CUSTOM_VAT = 5;
displayLookup['ORDER_ITEM_PRICE_TYPE.5'] = "custom vat";
constants.ORDER_ITEM_PRICE_TYPE_PRICE_LIST = 50;
displayLookup['ORDER_ITEM_PRICE_TYPE.50'] = "price list price";
constants.ORDER_ITEM_PRICE_TYPE_SALE = 100;
displayLookup['ORDER_ITEM_PRICE_TYPE.100'] = "sale price";
constants.ORDER_ITEM_PRICE_TYPE_QUANTITY_DISCOUNT = 150;
displayLookup['ORDER_ITEM_PRICE_TYPE.150'] = "quantity discount";
constants.ORDER_ITEM_PRICE_TYPE_NORMAL = 200;
displayLookup['ORDER_ITEM_PRICE_TYPE.200'] = "normal price";

constants.ORDER_ITEM_TYPE = {
  NORMAL: { color: null, label: true, value: 1 },
  RETURN: { color: null, label: true, value: 50 }
};
constants.ORDER_ITEM_TYPE_NORMAL = 1;
displayLookup['ORDER_ITEM_TYPE.1'] = "normal";
constants.ORDER_ITEM_TYPE_RETURN = 50;
displayLookup['ORDER_ITEM_TYPE.50'] = "return";

constants.ORDER_LINE_ITEM_TYPE = {
  NORMAL: { color: null, label: [true], value: 1 },
  RETURN: { color: null, label: [true], value: 2 },
  FEE: { color: null, label: [true], value: 3 },
  SHIPPING_FEE: { color: null, label: [true], value: 4 },
  DISCOUNT: { color: null, label: [true], value: 5 },
  PACKAGING: { color: null, label: [true], value: 6 }
};
constants.ORDER_LINE_ITEM_TYPE_NORMAL = 1;
displayLookup['ORDER_LINE_ITEM_TYPE.1'] = ["order line item type", "normal"];
constants.ORDER_LINE_ITEM_TYPE_RETURN = 2;
displayLookup['ORDER_LINE_ITEM_TYPE.2'] = ["order line item type", "return"];
constants.ORDER_LINE_ITEM_TYPE_FEE = 3;
displayLookup['ORDER_LINE_ITEM_TYPE.3'] = ["order line item type", "fee"];
constants.ORDER_LINE_ITEM_TYPE_SHIPPING_FEE = 4;
displayLookup['ORDER_LINE_ITEM_TYPE.4'] = ["order line item type", "shipping fee"];
constants.ORDER_LINE_ITEM_TYPE_DISCOUNT = 5;
displayLookup['ORDER_LINE_ITEM_TYPE.5'] = ["order line item type", "discount"];
constants.ORDER_LINE_ITEM_TYPE_PACKAGING = 6;
displayLookup['ORDER_LINE_ITEM_TYPE.6'] = ["order line item type", "packaging"];

constants.ORDER_MANUAL_INVOICE_GENERATION = {
  INHERIT_PROFILE_ACCOUNT: { color: null, label: "Inherit from profile account", value: 1 },
  ENABLED: { color: null, label: true, value: 2 },
  DISABLED: { color: null, label: true, value: 3 }
};
constants.ORDER_MANUAL_INVOICE_GENERATION_INHERIT_PROFILE_ACCOUNT = 1;
displayLookup['ORDER_MANUAL_INVOICE_GENERATION.1'] = "Inherit from profile account";
constants.ORDER_MANUAL_INVOICE_GENERATION_ENABLED = 2;
displayLookup['ORDER_MANUAL_INVOICE_GENERATION.2'] = "enabled";
constants.ORDER_MANUAL_INVOICE_GENERATION_DISABLED = 3;
displayLookup['ORDER_MANUAL_INVOICE_GENERATION.3'] = "disabled";

constants.ORDER_PAYMENT_METHOD = {
  CASH_ON_DELIVERY: { color: "#f57c00", label: true, value: 1 },
  TRANSFER: { color: "#e57373", label: true, value: 50 },
  ELECTRONIC: { color: "#64b5f6", label: true, value: 100 },
  CASH: { color: "#66bb6a", label: true, value: 150 },
  OTHER: { color: "#e5e5e5", label: true, value: 200 }
};
constants.ORDER_PAYMENT_METHOD_CASH_ON_DELIVERY = 1;
displayLookup['ORDER_PAYMENT_METHOD.1'] = "cash on delivery";
colorLookup['ORDER_PAYMENT_METHOD.1'] = "#f57c00";
colorNameLookup['ORDER_PAYMENT_METHOD.1'] = "ORANGE";
constants.ORDER_PAYMENT_METHOD_TRANSFER = 50;
displayLookup['ORDER_PAYMENT_METHOD.50'] = "transfer";
colorLookup['ORDER_PAYMENT_METHOD.50'] = "#e57373";
colorNameLookup['ORDER_PAYMENT_METHOD.50'] = "RED";
constants.ORDER_PAYMENT_METHOD_ELECTRONIC = 100;
displayLookup['ORDER_PAYMENT_METHOD.100'] = "electronic";
colorLookup['ORDER_PAYMENT_METHOD.100'] = "#64b5f6";
colorNameLookup['ORDER_PAYMENT_METHOD.100'] = "BLUE";
constants.ORDER_PAYMENT_METHOD_CASH = 150;
displayLookup['ORDER_PAYMENT_METHOD.150'] = "cash";
colorLookup['ORDER_PAYMENT_METHOD.150'] = "#66bb6a";
colorNameLookup['ORDER_PAYMENT_METHOD.150'] = "GREEN";
constants.ORDER_PAYMENT_METHOD_OTHER = 200;
displayLookup['ORDER_PAYMENT_METHOD.200'] = "other";
colorLookup['ORDER_PAYMENT_METHOD.200'] = "#e5e5e5";
colorNameLookup['ORDER_PAYMENT_METHOD.200'] = "GREY";

constants.ORDER_SHIPPING_METHOD = {
  DELIVERY: { color: "#66bb6a", label: true, value: 1 },
  LOCAL_PICKUP: { color: "#66bb6a", label: true, value: 150 },
  GLS_DELIVERY: { color: "#64b5f6", label: true, value: 50 },
  GLS_PARCEL_TERMINAL_DELIVERY: { color: "#64b5f6", label: true, value: 100 },
  GLS_XXL: { color: "#64b5f6", label: true, value: 101 },
  GLS_PICK_AND_RETURN: { color: "#64b5f6", label: "gls pick & return", value: 200 },
  GLS_PICK_AND_SHIP: { color: "#64b5f6", label: "gls pick & ship", value: 201 },
  GLS_EXCHANGE: { color: "#64b5f6", label: true, value: 250 },
  GLS_OPENNETWORK_PICKUP: { color: "#64b5f6", label: "GLS OpenNetwork pickup", value: 260 },
  SPRINTER_HOME_DELIVER: { color: "#e57373", label: true, value: 300 },
  SPRINTER_HOME_DELIVER_AND_RETURN: { color: "#e57373", label: true, value: 350 },
  SPRINTER_HOME_DELIVER_ONLY_RETURN: { color: "#e57373", label: true, value: 400 },
  SPRINTER_PICK_PACK_POINT: { color: "#e57373", label: true, value: 450 },
  SPRINTER_PICK_PACK_POINT_POS2POS: { color: "#e57373", label: true, value: 500 },
  SPRINTER_PICK_PACK_POINT_DIRECT: { color: "#e57373", label: true, value: 550 },
  SPRINTER_PICK_PACK_POINT_RETURN: { color: "#e57373", label: true, value: 600 },
  PACKETA_HOME_DELIVERY: { color: "#e57373", label: true, value: 650 },
  PACKETA_DPD_HOME_DELIVERY: { color: "#e57373", label: true, value: 660 },
  PACKETA_EXPRESS_ONE_HOME_DELIVERY: { color: "#e57373", label: true, value: 670 },
  PACKETA_HUNGARIAN_POST_HOME_DELIVERY: { color: "#e57373", label: true, value: 680 },
  PACKETA_PICK_UP_POINT: { color: "#e57373", label: true, value: 730 },
  MPL_POST_DELIVERY: { color: "#66bb6a", label: true, value: 750 },
  MPL_HOME_DELIVERY: { color: "#66bb6a", label: true, value: 760 },
  MPL_PALLET_DELIVERY: { color: "#66bb6a", label: true, value: 770 },
  MPL_POST_POINT: { color: "#66bb6a", label: true, value: 780 },
  MPL_PARCEL_POINT: { color: "#66bb6a", label: true, value: 790 },
  MPL_HOME_DELIVERY_RETURN: { color: "#66bb6a", label: true, value: 761 },
  MPL_PARCEL_POINT_RETURN: { color: "#66bb6a", label: true, value: 791 },
  MPL_HOME_DELIVERY_REPLACEMENT: { color: "#66bb6a", label: true, value: 762 },
  PARCEL_24H_24_HOUR_SHIPPING: { color: "#66bb6a", label: "24H shipping", value: 800 },
  PARCEL_24H_NIGHTLY_EXPRESS: { color: "#66bb6a", label: "24H nightly express", value: 810 },
  PARCEL_24H_24_HOUR_SHIPPING_RETURN: { color: "#66bb6a", label: "24H shipping return", value: 820 },
  PARCEL_24H_NIGHTLY_EXPRESS_RETURN: { color: "#66bb6a", label: "24H nightly express return", value: 830 },
  PARCEL_24H_PALLET_24_HOUR_SHIPPING: { color: "#66bb6a", label: "24H pallet shipping", value: 840 },
  PARCEL_24H_PALLET_NIGHTLY_EXPRESS: { color: "#66bb6a", label: "24H pallet nightly express", value: 850 },
  PARCEL_24H_PALLET_24_HOUR_SHIPPING_RETURN: { color: "#66bb6a", label: "24H pallet shipping return", value: 860 },
  PARCEL_24H_PALLET_NIGHTLY_EXPRESS_RETURN: { color: "#66bb6a", label: "24H pallet nightly express return", value: 870 },
  FOXPOST_HOME_DELIVERY: { color: "#e57373", label: true, value: 900 },
  FOXPOST_PARCEL_POINT: { color: "#e57373", label: true, value: 910 },
  DPD_CLASSIC_DELIVERY: { color: "#e57373", label: "dpd delivery", value: 950 },
  DPD_PARCEL_SHOP_DELIVERY: { color: "#e57373", label: "dpd parcel shop delivery", value: 960 },
  EXPRESS_ONE_24H_DELIVERY: { color: "#ffb74d", label: "ExpressOne 24H", value: 1000 },
  EXPRESS_ONE_08H_DELIVERY: { color: "#ffb74d", label: "ExpressOne 8H", value: 1010 },
  EXPRESS_ONE_10H_DELIVERY: { color: "#ffb74d", label: "ExpressOne 10H", value: 1020 },
  EXPRESS_ONE_12H_DELIVERY: { color: "#ffb74d", label: "ExpressOne 12H", value: 1030 },
  EXPRESS_ONE_EXP_DELIVERY: { color: "#ffb74d", label: "ExpressOne Export", value: 1040 },
  EXPRESS_ONE_D2S_DELIVERY: { color: "#ffb74d", label: "ExpressOne tofShop", value: 1050 },
  EXPRESS_ONE_EST_DELIVERY: { color: "#ffb74d", label: "ExpressOne Night Delivery", value: 1060 },
  EXPRESS_ONE_24H_DELIVERY_AND_RETURN: { color: "#ffb74d", label: "ExpressOne 24H & return", value: 1061 },
  EXPRESS_ONE_08H_DELIVERY_AND_RETURN: { color: "#ffb74d", label: "ExpressOne 8H & return", value: 1062 },
  EXPRESS_ONE_10H_DELIVERY_AND_RETURN: { color: "#ffb74d", label: "ExpressOne 10H & return", value: 1063 },
  EXPRESS_ONE_12H_DELIVERY_AND_RETURN: { color: "#ffb74d", label: "ExpressOne 12H & return", value: 1064 },
  EXPRESS_ONE_EXP_DELIVERY_AND_RETURN: { color: "#ffb74d", label: "ExpressOne Export & return", value: 1065 },
  EXPRESS_ONE_D2S_DELIVERY_AND_RETURN: { color: "#ffb74d", label: "ExpressOne tofShop & return", value: 1066 },
  EXPRESS_ONE_EST_DELIVERY_AND_RETURN: { color: "#ffb74d", label: "ExpressOne Night Delivery & return", value: 1067 },
  EXPRESS_ONE_ARU: { color: "#ffb74d", label: "ExpressOne Next Working Day Pickup", value: 1070 },
  EXPRESS_ONE_AR3: { color: "#ffb74d", label: "ExpressOne Pickup - Third Party Pay", value: 1080 },
  ILOGISTIC_PARCEL_POINT: { color: "#64b5f6", label: "Ilogistic parcel point", value: 1100 },
  PACTIC_DPD_BUSINESS_HOME_DELIVERY: { color: "#106d3b", label: "Pactic - Pactic - DPD Business Home Delivery", value: 1110 },
  PACTIC_DPD_ROMANIA_CROSS_BORDER: { color: "#106d3b", label: "Pactic - DPD Romania Cross-border", value: 1111 },
  PACTIC_DPD_ROMANIA_CROSS_BORDER_DIRECT_INJECTION: { color: "#106d3b", label: "Pactic - DPD Romania Cross-border Direct inj.", value: 1112 },
  PACTIC_DPD_AUSTRIA_CROSS_BORDER: { color: "#106d3b", label: "Pactic - DPD Austria Cross-border", value: 1113 },
  PACTIC_DPD_AUSTRIA_CROSS_BORDER_DIRECT_INJECTION: { color: "#106d3b", label: "Pactic - DPD Austria Cross-border Direct Injection", value: 1114 },
  PACTIC_ACS_GREECE_CROSS_BORDER: { color: "#106d3b", label: "Pactic - ACS Greece Cross-border", value: 1115 },
  PACTIC_ECONT_BULGARIA_CROSS_BORDER: { color: "#106d3b", label: "Pactic - Econt Bulgaria Cross-border", value: 1116 },
  PACTIC_ECONT_BULGARIA_CROSS_BORDER_DIRECT_INJECTION: { color: "#106d3b", label: "Pactic - Econt Bulgaria Cross-border Direct Injection", value: 1117 },
  PACTIC_ACS_GREECE_CROSS_BORDER_DIRECT_INJECTION: { color: "#106d3b", label: "Pactic - ACS Greece Cross-border Direct Injection", value: 1118 },
  PACTIC_ECONT_BULGARIA_PARCELSHOP_CROSS_BORDER: { color: "#106d3b", label: "Pactic - Econt Bulgaria ParcelShop Cross-border", value: 1119 },
  PACTIC_ECONT_BULGARIA_PUDO_CROSS_BORDER_DIRECT_INJECTION: { color: "#106d3b", label: "Pactic - Econt Bulgaria PUDO Cross-border Direct Injection", value: 1120 },
  PACTIC_SPEEDEX_GREECE_CROSS_BORDER: { color: "#106d3b", label: "Pactic - Speedex Greece Cross-border", value: 1121 },
  PACTIC_SPEEDEX_GREECE_CROSS_BORDER_DIRECT_INJECTION: { color: "#106d3b", label: "Pactic - Speedex Greece Cross-border Direct Injection", value: 1122 },
  PACTIC_GENIKI_GREECE_CROSS_BORDER: { color: "#106d3b", label: "Pactic - Geniki Greece Cross-border", value: 1123 },
  PACTIC_GENIKI_GREECE_CROSS_BORDER_DIRECT_INJECTION: { color: "#106d3b", label: "Pactic - Geniki Greece Cross-border Direct Injection", value: 1124 },
  PACTIC_BIZ_GREECE_CROSS_BORDER: { color: "#106d3b", label: "Pactic - BIZ Greece Cross-border", value: 1125 },
  PACTIC_INPOST_POLAND_CROSS_BORDER_DIRECT_INJECTION: { color: "#106d3b", label: "Pactic - InPost Poland Cross-border Direct Injection", value: 1126 },
  PACTIC_INPOST_POLAND_CROSS_BORDER: { color: "#106d3b", label: "Pactic - InPost Poland Cross-border", value: 1127 },
  PACTIC_INPOST_POLAND_LOCKER_CROSS_BORDER: { color: "#106d3b", label: "Pactic - InPost Poland Locker Cross-border", value: 1128 },
  PACTIC_INPOST_POLAND_LOCKER_CROSS_BORDER_INJECTION: { color: "#106d3b", label: "Pactic - InPost Poland Locker Cross-border injection", value: 1129 },
  PACTIC_URGENTCARGUS_CROSS_BORDER: { color: "#106d3b", label: "Pactic - UrgentCargus Cross-border", value: 1130 },
  PACTIC_URGENTCARGUS_CROSS_BORDER_DIRECT_INJECTION: { color: "#106d3b", label: "Pactic - UrgentCargus Cross-border Direct Injection", value: 1131 },
  PACTIC_WEDO_CZECH_REPUBLIC_CROSS_BORDER: { color: "#106d3b", label: "Pactic - WE|DO Czech Republic Cross-border", value: 1132 },
  PACTIC_WEDO_CZECH_REPUBLIC_CROSS_BORDER_DIRECT_INJECTION: { color: "#106d3b", label: "Pactic - WE|DO Czech Republic Cross-border Direct Injection", value: 1133 },
  PACTIC_SLOVAK_POST_CROSS_BORDER: { color: "#106d3b", label: "Pactic - Slovak Post Cross-border", value: 1134 },
  PACTIC_SLOVAK_POST_CROSS_BORDER_PUDO: { color: "#106d3b", label: "Pactic - Slovak Post Cross-border PuDo", value: 1135 },
  PACTIC_MPL_BUSINESS_POST_POINT: { color: "#106d3b", label: "Pactic - Pactic - MPL Post Point", value: 1136 },
  PACTIC_B2C_EUROPE_CROSS_BORDER: { color: "#106d3b", label: "Pactic - B2C Europe Cross-border", value: 1137 },
  PACTIC_B2C_EUROPE_CROSS_BORDER_DIRECT_INJECTION: { color: "#106d3b", label: "Pactic - B2C Europe Cross-border direct injection", value: 1138 },
  PACTIC_DHL_GERMANY_CROSS_BORDER: { color: "#106d3b", label: "Pactic - DHL Germany Cross-border", value: 1139 },
  PACTIC_DHL_GERMANY_CROSS_BORDER_PAKETSHOP: { color: "#106d3b", label: "Pactic - DHL Germany Cross-border paketshop", value: 1140 },
  PACTIC_PPL_CZECH_CROSS_BORDER: { color: "#106d3b", label: "Pactic - PPL Czech Cross-border", value: 1141 },
  PACTIC_PPL_CZECH_CROSS_BORDER_DIRECT_INJECTION: { color: "#106d3b", label: "Pactic - PPL Czech Cross-border direct Injection", value: 1142 },
  PACTIC_PPL_CZECH_CROSS_BORDER_PUDO: { color: "#106d3b", label: "Pactic - PPL Czech Cross-border PuDo", value: 1143 },
  PACTIC_PPL_CZECH_CROSS_BORDER_PUDO_DIRECT_INJECTION: { color: "#106d3b", label: "Pactic - PPL Czech Cross-border PuDo Direct Injection", value: 1144 },
  PACTIC_PPL_CZECH_PUDO_RETURN: { color: "#106d3b", label: "Pactic - PPL Czech PuDo Return", value: 1145 },
  PACTIC_HERMES_GERMANY_CROSS_BORDER: { color: "#106d3b", label: "Pactic - Hermes Germany Cross-border", value: 1146 },
  PACTIC_SPRING_CROSS_BORDER_EU_DESTINATIONS: { color: "#106d3b", label: "Pactic - Spring Cross-border EU destinations", value: 1147 },
  PACTIC_BPOST_BELGIUM_CROSS_BORDER: { color: "#106d3b", label: "Pactic - Bpost Belgium Cross-border", value: 1148 },
  PACTIC_BRING_DENMARK_CROSS_BORDER: { color: "#106d3b", label: "Pactic - Bring Denmark Cross-border", value: 1149 },
  PACTIC_POST_ESTONIA_CROSS_BORDER: { color: "#106d3b", label: "Pactic - Post Estonia Cross-border", value: 1150 },
  PACTIC_POST_FINLAND_CROSS_BORDER: { color: "#106d3b", label: "Pactic - Post Finland Cross-border", value: 1151 },
  PACTIC_COLIS_PRIVE_FRANCE_CROSS_BORDER: { color: "#106d3b", label: "Pactic - Colis Prive France Cross-border", value: 1152 },
  PACTIC_FASTWAY_IRELAND_CROSS_BORDER: { color: "#106d3b", label: "Pactic - Fastway Ireland Cross-border", value: 1153 },
  PACTIC_POST_LATVIA_CROSS_BORDER: { color: "#106d3b", label: "Pactic - Post Latvia Cross-border", value: 1154 },
  PACTIC_POST_LITHUANIA_CROSS_BORDER: { color: "#106d3b", label: "Pactic - Post Lithuania Cross-border", value: 1155 },
  PACTIC_POST_LUXEMBOURG_CROSS_BORDER: { color: "#106d3b", label: "Pactic - Post Luxembourg Cross-border", value: 1156 },
  PACTIC_POST_NL_NETHERLANDS_CROSS_BORDER: { color: "#106d3b", label: "Pactic - Post NL Netherlands Cross-border", value: 1157 },
  PACTIC_CTT_EXPRESS_PORTUGAL_CROSS_BORDER: { color: "#106d3b", label: "Pactic - CTT Express Portugal Cross-border", value: 1158 },
  PACTIC_CTT_EXPRESS_SPAIN_CROSS_BORDER: { color: "#106d3b", label: "Pactic - CTT Express Spain Cross-border", value: 1159 },
  PACTIC_BRING_SWEDEN_CROSS_BORDER: { color: "#106d3b", label: "Pactic - Bring Sweden Cross-border", value: 1160 },
  PACTIC_CROATIA_POST_CROSS_BORDER: { color: "#106d3b", label: "Pactic - Croatia Post Cross-border", value: 1161 },
  PACTIC_CROATIA_POST_CROSS_BORDER_PUDO: { color: "#106d3b", label: "Pactic - Croatia Post Cross-border PUDO", value: 1162 },
  PACTIC_CROATIA_POST_CROSS_BORDER_DIRECT_INJECTION: { color: "#106d3b", label: "Pactic - Croatia Post Cross-border Direct inj.", value: 1163 },
  PACTIC_CROATIA_POST_CROSS_BORDER_PUDO_DIRECT_INJECTION: { color: "#106d3b", label: "Pactic - Croatia Post Cross-border PUDO D. inj.", value: 1164 },
  PACTIC_CZECH_POST_CROSS_BORDER: { color: "#106d3b", label: "Pactic - Czech Post Cross-border", value: 1165 },
  PACTIC_CZECH_POST_CROSS_BORDER_DIRECT_INJECTION: { color: "#106d3b", label: "Pactic - Czech Post Cross-border Dir. Inj.", value: 1166 },
  PACTIC_GLS_BUSINESS_HOME_DELIVERY: { color: "#106d3b", label: "Pactic - GLS Business Home Delivery", value: 1200 },
  PACTIC_GLS_BUSINESS_PICKUP_POINT: { color: "#106d3b", label: "Pactic - GLS Business PickUp Point", value: 1210 },
  PACTIC_GLS_HUNGARY_PICK_AND_SHIP_DOMESTIC: { color: "#106d3b", label: "Pactic - GLS Hungary Pick & Ship Domestic", value: 1220 },
  PACTIC_GLS_HUNGARY_EXCHANGE_SERVICE: { color: "#106d3b", label: "Pactic - GLS Hungary Exchange Service", value: 1230 },
  PACTIC_GLS_HUNGARY_CROSS_BORDER_PUDO_DIRECT_INJECTION: { color: "#106d3b", label: "Pactic - GLS Hungary Cross-border PUDO Direct injection", value: 1231 },
  PACTIC_GLS_HUNGARY_CROSS_BORDER_PUDO: { color: "#106d3b", label: "Pactic - GLS Hungary Cross-border PUDO", value: 1232 },
  PACTIC_GLS_HUNGARY_CROSS_BORDER: { color: "#106d3b", label: "Pactic - GLS Hungary Cross-border", value: 1233 },
  PACTIC_GLS_ROMANIA_CROSS_BORDER_DIRECT_INJECTION: { color: "#106d3b", label: "Pactic - GLS Romania Cross-border Direct Injection", value: 1234 },
  PACTIC_GLS_ROMANIA_CROSS_BORDER: { color: "#106d3b", label: "Pactic - GLS Romania Cross-border", value: 1235 },
  PACTIC_GLS_ROMANIA_PICK_AND_SHIP_DOMESTIC: { color: "#106d3b", label: "Pactic - GLS Romania Pick & Ship Domestic", value: 1236 },
  PACTIC_GLS_ROMANIA_EXCHANGE_SERVICE: { color: "#106d3b", label: "Pactic - GLS Romania Exchange Service", value: 1237 },
  PACTIC_GLS_CROSS_BORDER_DIRECT: { color: "#106d3b", label: "Pactic - Pactic - GLS Cross-border Direct", value: 1238 },
  PACTIC_GLS_SLOVENIA_CROSS_BORDER: { color: "#106d3b", label: "Pactic - GLS Slovenia Cross-border", value: 1239 },
  PACTIC_GLS_CZECH_REPUBLIC_CROSS_BORDER: { color: "#106d3b", label: "Pactic - GLS Czech Republic Cross-border", value: 1240 },
  PACTIC_GLS_SLOVENIA_DIRECT_INJECTION: { color: "#106d3b", label: "Pactic - GLS Slovenia Direct Injection", value: 1241 },
  PACTIC_GLS_CROATIA_CROSS_BORDER: { color: "#106d3b", label: "Pactic - GLS Croatia Cross-border", value: 1242 },
  PACTIC_GLS_CROATIA_CROSS_BORDER_DIRECT_INJECTION: { color: "#106d3b", label: "Pactic - GLS Croatia Cross-border Direct Injection", value: 1243 },
  PACTIC_GLS_CROATIA_PICK_AND_RETURN: { color: "#106d3b", label: "Pactic - GLS Croatia Pick and Return", value: 1244 },
  PACTIC_GLS_SLOVENIA_PICK_AND_RETURN: { color: "#106d3b", label: "Pactic - GLS Slovenia Pick and Return", value: 1245 },
  PACTIC_GLS_SLOVENIA_PUDO: { color: "#106d3b", label: "Pactic - GLS Slovenia PUDO", value: 1246 },
  PACTIC_GLS_SLOVENIA_PUDO_DIRECT_INJECTION: { color: "#106d3b", label: "Pactic - GLS Slovenia PUDO Direct Injection", value: 1247 },
  PACTIC_GLS_SLOVAKIA_CROSS_BORDER: { color: "#106d3b", label: "Pactic - GLS Slovakia Cross-border", value: 1248 },
  PACTIC_GLS_SLOVAKIA_CROSS_BORDER_DIRECT_INJECTION: { color: "#106d3b", label: "Pactic - GLS Slovakia Cross-border Direct Injection", value: 1249 },
  PACTIC_GLS_SLOVAKIA_CROSS_BORDER_PUDO: { color: "#106d3b", label: "Pactic - GLS Slovakia Cross-border PUDO", value: 1250 },
  PACTIC_GLS_SLOVAKIA_CROSS_BORDER_PUDO_DIRECT_INJECTION: { color: "#106d3b", label: "Pactic - GLS Slovakia Cross-border PUDO Direct Injection", value: 1251 },
  PACTIC_GLS_SLOVAKIA_EXCHANGE_SERVICE: { color: "#106d3b", label: "Pactic - GLS Slovakia Exchange Service", value: 1252 },
  PACTIC_GLS_SLOVAKIA_PICK_RETURN: { color: "#106d3b", label: "Pactic - GLS Slovakia Pick & Return", value: 1253 },
  PACTIC_GLS_CROATIA_PUDO: { color: "#106d3b", label: "Pactic - GLS Croatia PUDO", value: 1254 },
  PACTIC_GLS_CROATIA_PUDO_DIRECT_INJECTION: { color: "#106d3b", label: "Pactic - GLS Croatia PUDO Direct Injection", value: 1255 },
  PACTIC_GLS_AUSTRIA_CROSS_BORDER: { color: "#106d3b", label: "Pactic - GLS Austria Cross-border", value: 1256 },
  PACTIC_GLS_AUSTRIA_PUDO_CROSS_BORDER: { color: "#106d3b", label: "Pactic - GLS Austria PuDo Cross-border", value: 1257 },
  PACTIC_GLS_ITALY_CROSS_BORDER: { color: "#106d3b", label: "Pactic - GLS Italy Cross-border", value: 1258 },
  PACTIC_GLS_ITALY_PUDO_CROSS_BORDER: { color: "#106d3b", label: "Pactic - GLS Italy Cross-border PuDo", value: 1259 },
  PACTIC_GLS_ITALY_PICK_AND_RETURN: { color: "#106d3b", label: "Pactic - GLS Italy Pick and Return", value: 1260 },
  PACTIC_GLS_POLAND_CROSS_BORDER: { color: "#106d3b", label: "Pactic - GLS Poland Cross-border", value: 1261 },
  PACTIC_GLS_POLAND_CROSS_BORDER_DIRECT_INJECTION: { color: "#106d3b", label: "Pactic - GLS Poland Cross-border Direct Injection", value: 1262 },
  PACTIC_GLS_POLAND_CROSS_BORDER_PUDO: { color: "#106d3b", label: "Pactic - GLS Poland Cross-border PuDo", value: 1263 },
  PACTIC_GLS_POLAND_CROSS_BORDER_PUDO_DIRECT_INJECTION: { color: "#106d3b", label: "Pactic - GLS Poland Cross-border PuDo Direct Injection", value: 1264 },
  PACTIC_GLS_POLAND_PICK_RETURN: { color: "#106d3b", label: "Pactic - GLS Poland Pick & Return", value: 1265 },
  PACTIC_SAMEDAY_HUNGARY_CROSS_BORDER_DIRECT_INJECTION: { color: "#106d3b", label: "Pactic - Sameday Hungary Cross-border Direct Injection", value: 1266 },
  PACTIC_SAMEDAY_HUNGARY_EASYBOX_DIRECT_INJECTION: { color: "#106d3b", label: "Pactic - Sameday Hungary Easybox Direct Injection", value: 1267 },
  PACTIC_SAMEDAY_HUNGARY_CROSS_BORDER: { color: "#106d3b", label: "Pactic - Sameday Hungary Cross-border", value: 1268 },
  PACTIC_SAMEDAY_HUNGARY_CROSS_BORDER_EASYBOX: { color: "#106d3b", label: "Pactic - Sameday Hungary Cross-border Easybox", value: 1269 },
  PACTIC_PACKETA_HUNGARY_PUDO: { color: "#106d3b", label: "Pactic - Packeta Hungary PuDo", value: 1270 },
  PACTIC_SAMEDAY_ROMANIA_CROSS_BORDER: { color: "#106d3b", label: "Pactic - SameDay Romania Cross-border", value: 1271 },
  PACTIC_SAMEDAY_ROMANIA_CROSS_BORDER_DIRECT_INJECTION: { color: "#106d3b", label: "Pactic - SameDay Romania Cross-border Direct Injection", value: 1272 },
  PACTIC_SAMEDAY_ROMANIA_PUDO_BUSINESS: { color: "#106d3b", label: "Pactic - SameDay Romania PuDo Business", value: 1273 },
  PACTIC_SAMEDAY_ROMANIA_PUDO_CROSS_BORDER: { color: "#106d3b", label: "Pactic - SameDay Romania PuDo Cross-border", value: 1274 },
  PACTIC_SAMEDAY_ROMANIA_PUDO_DIRECT_INJECTION: { color: "#106d3b", label: "Pactic - SameDay Romania PuDo Direct Injection", value: 1275 },
  PACTIC_SAMEDAY_BULGARIA_CROSS_BORDER: { color: "#106d3b", label: "Pactic - Sameday Bulgaria Cross-border", value: 1276 },
  PACTIC_SAMEDAY_BULGARIA_CROSS_BORDER_DIRECT_INJECTION: { color: "#106d3b", label: "Pactic - Sameday Bulgaria Cross-border Direct Injection", value: 1277 },
  PACTIC_EXPRESSONE_CROSS_BORDER_DOMESTIC: { color: "#106d3b", label: "Pactic - ExpressOne Cross-border Domestic", value: 1278 },
  PACTIC_EXPRESSONE_CROSS_BORDER_DIRECT_INJECTION: { color: "#106d3b", label: "Pactic - ExpressOne Cross-border Direct Injection", value: 1279 },
  PACTIC_MPL_BUSINESS_PICKUP_POINT: { color: "#106d3b", label: "Pactic - Pactic - MPL PickUp Point", value: 1280 },
  PACTIC_MPL_HUNGARY_CROSS_BORDER: { color: "#106d3b", label: "Pactic - MPL Hungary Cross-border", value: 1281 },
  PACTIC_MPL_HUNGARY_CROSS_BORDER_PUDO_DIR_INJ: { color: "#106d3b", label: "Pactic - MPL Hungary Cross-border PUDO Dir. Inj.", value: 1282 },
  PACTIC_MPL_HUNGARY_CROSS_BORDER_PUDO: { color: "#106d3b", label: "Pactic - MPL Hungary Cross-border PUDO", value: 1283 },
  PACTIC_MPL_BUSINESS_MANIFEST: { color: "#106d3b", label: "Pactic - MPL Business Manifest", value: 1284 },
  PACTIC_MPL_BUSINESS_PUDO_MANIFEST: { color: "#106d3b", label: "Pactic - MPL Business PuDo Manifest", value: 1285 },
  PACTIC_MPL_HUNGARY_CROSS_BORDER_MANIFEST: { color: "#106d3b", label: "Pactic - MPL Hungary Cross-border Manifest", value: 1286 },
  PACTIC_MPL_HUNGARY_CROSS_BORDER_PUDO_DIR_INJ_MANIFEST: { color: "#106d3b", label: "Pactic - MPL Hungary Cross-border PUDO Dir Inj Manifest", value: 1287 },
  PACTIC_MPL_HUNGARY_CROSS_BORDER_PUDO_MANIFEST: { color: "#106d3b", label: "Pactic - MPL Hungary Cross-border PUDO Manifest", value: 1288 },
  PACTIC_DPD_ROMANIA_CLASSIC_BUSINESS_DOMESTIC: { color: "#106d3b", label: "Pactic - DPD Romania Classic Business Domestic", value: 1289 },
  EMAG_COURIER: { color: "#64b5f6", label: "Emag courier", value: 1300 },
  SAMEDAY: { color: "#64b5f6", label: "Sameday", value: 1310 },
  KUMI_DELIVERY: { color: "#f57c00", label: true, value: 1400 },
  KUMI_RETURN: { color: "#f57c00", label: true, value: 1410 },
  KUMI_REPLACEMENT: { color: "#f57c00", label: true, value: 1420 },
  KOVA_TRANS_DELIVERY: { color: "#64b5f6", label: true, value: 1500 },
  KOVA_TRANS_PICKUP: { color: "#64b5f6", label: true, value: 1510 },
  PANNONXP_DELIVERY: { color: "#f57c00", label: "PannonXP delivery", value: 1600 },
  PANNONXP_PICKUP_POINT: { color: "#f57c00", label: "PannonXP pickup point", value: 1610 },
  PANNONXP_RETURN: { color: "#f57c00", label: "PannonXP return", value: 1620 },
  VIRTUAL: { color: "#66bb6a", label: true, value: 32767 }
};
constants.ORDER_SHIPPING_METHOD_DELIVERY = 1;
displayLookup['ORDER_SHIPPING_METHOD.1'] = "delivery";
colorLookup['ORDER_SHIPPING_METHOD.1'] = "#66bb6a";
colorNameLookup['ORDER_SHIPPING_METHOD.1'] = "GREEN";
constants.ORDER_SHIPPING_METHOD_LOCAL_PICKUP = 150;
displayLookup['ORDER_SHIPPING_METHOD.150'] = "local pickup";
colorLookup['ORDER_SHIPPING_METHOD.150'] = "#66bb6a";
colorNameLookup['ORDER_SHIPPING_METHOD.150'] = "GREEN";
constants.ORDER_SHIPPING_METHOD_GLS_DELIVERY = 50;
displayLookup['ORDER_SHIPPING_METHOD.50'] = "gls delivery";
colorLookup['ORDER_SHIPPING_METHOD.50'] = "#64b5f6";
colorNameLookup['ORDER_SHIPPING_METHOD.50'] = "BLUE";
constants.ORDER_SHIPPING_METHOD_GLS_PARCEL_TERMINAL_DELIVERY = 100;
displayLookup['ORDER_SHIPPING_METHOD.100'] = "gls parcel terminal delivery";
colorLookup['ORDER_SHIPPING_METHOD.100'] = "#64b5f6";
colorNameLookup['ORDER_SHIPPING_METHOD.100'] = "BLUE";
constants.ORDER_SHIPPING_METHOD_GLS_XXL = 101;
displayLookup['ORDER_SHIPPING_METHOD.101'] = "gls xxl";
colorLookup['ORDER_SHIPPING_METHOD.101'] = "#64b5f6";
colorNameLookup['ORDER_SHIPPING_METHOD.101'] = "BLUE";
constants.ORDER_SHIPPING_METHOD_GLS_PICK_AND_RETURN = 200;
displayLookup['ORDER_SHIPPING_METHOD.200'] = "gls pick & return";
colorLookup['ORDER_SHIPPING_METHOD.200'] = "#64b5f6";
colorNameLookup['ORDER_SHIPPING_METHOD.200'] = "BLUE";
constants.ORDER_SHIPPING_METHOD_GLS_PICK_AND_SHIP = 201;
displayLookup['ORDER_SHIPPING_METHOD.201'] = "gls pick & ship";
colorLookup['ORDER_SHIPPING_METHOD.201'] = "#64b5f6";
colorNameLookup['ORDER_SHIPPING_METHOD.201'] = "BLUE";
constants.ORDER_SHIPPING_METHOD_GLS_EXCHANGE = 250;
displayLookup['ORDER_SHIPPING_METHOD.250'] = "gls exchange";
colorLookup['ORDER_SHIPPING_METHOD.250'] = "#64b5f6";
colorNameLookup['ORDER_SHIPPING_METHOD.250'] = "BLUE";
constants.ORDER_SHIPPING_METHOD_GLS_OPENNETWORK_PICKUP = 260;
displayLookup['ORDER_SHIPPING_METHOD.260'] = "GLS OpenNetwork pickup";
colorLookup['ORDER_SHIPPING_METHOD.260'] = "#64b5f6";
colorNameLookup['ORDER_SHIPPING_METHOD.260'] = "BLUE";
constants.ORDER_SHIPPING_METHOD_SPRINTER_HOME_DELIVER = 300;
displayLookup['ORDER_SHIPPING_METHOD.300'] = "sprinter home deliver";
colorLookup['ORDER_SHIPPING_METHOD.300'] = "#e57373";
colorNameLookup['ORDER_SHIPPING_METHOD.300'] = "RED";
constants.ORDER_SHIPPING_METHOD_SPRINTER_HOME_DELIVER_AND_RETURN = 350;
displayLookup['ORDER_SHIPPING_METHOD.350'] = "sprinter home deliver and return";
colorLookup['ORDER_SHIPPING_METHOD.350'] = "#e57373";
colorNameLookup['ORDER_SHIPPING_METHOD.350'] = "RED";
constants.ORDER_SHIPPING_METHOD_SPRINTER_HOME_DELIVER_ONLY_RETURN = 400;
displayLookup['ORDER_SHIPPING_METHOD.400'] = "sprinter home deliver only return";
colorLookup['ORDER_SHIPPING_METHOD.400'] = "#e57373";
colorNameLookup['ORDER_SHIPPING_METHOD.400'] = "RED";
constants.ORDER_SHIPPING_METHOD_SPRINTER_PICK_PACK_POINT = 450;
displayLookup['ORDER_SHIPPING_METHOD.450'] = "sprinter pick pack point";
colorLookup['ORDER_SHIPPING_METHOD.450'] = "#e57373";
colorNameLookup['ORDER_SHIPPING_METHOD.450'] = "RED";
constants.ORDER_SHIPPING_METHOD_SPRINTER_PICK_PACK_POINT_POS2POS = 500;
displayLookup['ORDER_SHIPPING_METHOD.500'] = "sprinter pick pack point pos2pos";
colorLookup['ORDER_SHIPPING_METHOD.500'] = "#e57373";
colorNameLookup['ORDER_SHIPPING_METHOD.500'] = "RED";
constants.ORDER_SHIPPING_METHOD_SPRINTER_PICK_PACK_POINT_DIRECT = 550;
displayLookup['ORDER_SHIPPING_METHOD.550'] = "sprinter pick pack point direct";
colorLookup['ORDER_SHIPPING_METHOD.550'] = "#e57373";
colorNameLookup['ORDER_SHIPPING_METHOD.550'] = "RED";
constants.ORDER_SHIPPING_METHOD_SPRINTER_PICK_PACK_POINT_RETURN = 600;
displayLookup['ORDER_SHIPPING_METHOD.600'] = "sprinter pick pack point return";
colorLookup['ORDER_SHIPPING_METHOD.600'] = "#e57373";
colorNameLookup['ORDER_SHIPPING_METHOD.600'] = "RED";
constants.ORDER_SHIPPING_METHOD_PACKETA_HOME_DELIVERY = 650;
displayLookup['ORDER_SHIPPING_METHOD.650'] = "packeta home delivery";
colorLookup['ORDER_SHIPPING_METHOD.650'] = "#e57373";
colorNameLookup['ORDER_SHIPPING_METHOD.650'] = "RED";
constants.ORDER_SHIPPING_METHOD_PACKETA_DPD_HOME_DELIVERY = 660;
displayLookup['ORDER_SHIPPING_METHOD.660'] = "packeta dpd home delivery";
colorLookup['ORDER_SHIPPING_METHOD.660'] = "#e57373";
colorNameLookup['ORDER_SHIPPING_METHOD.660'] = "RED";
constants.ORDER_SHIPPING_METHOD_PACKETA_EXPRESS_ONE_HOME_DELIVERY = 670;
displayLookup['ORDER_SHIPPING_METHOD.670'] = "packeta express one home delivery";
colorLookup['ORDER_SHIPPING_METHOD.670'] = "#e57373";
colorNameLookup['ORDER_SHIPPING_METHOD.670'] = "RED";
constants.ORDER_SHIPPING_METHOD_PACKETA_HUNGARIAN_POST_HOME_DELIVERY = 680;
displayLookup['ORDER_SHIPPING_METHOD.680'] = "packeta hungarian post home delivery";
colorLookup['ORDER_SHIPPING_METHOD.680'] = "#e57373";
colorNameLookup['ORDER_SHIPPING_METHOD.680'] = "RED";
constants.ORDER_SHIPPING_METHOD_PACKETA_PICK_UP_POINT = 730;
displayLookup['ORDER_SHIPPING_METHOD.730'] = "packeta pick up point";
colorLookup['ORDER_SHIPPING_METHOD.730'] = "#e57373";
colorNameLookup['ORDER_SHIPPING_METHOD.730'] = "RED";
constants.ORDER_SHIPPING_METHOD_MPL_POST_DELIVERY = 750;
displayLookup['ORDER_SHIPPING_METHOD.750'] = "mpl post delivery";
colorLookup['ORDER_SHIPPING_METHOD.750'] = "#66bb6a";
colorNameLookup['ORDER_SHIPPING_METHOD.750'] = "GREEN";
constants.ORDER_SHIPPING_METHOD_MPL_HOME_DELIVERY = 760;
displayLookup['ORDER_SHIPPING_METHOD.760'] = "mpl home delivery";
colorLookup['ORDER_SHIPPING_METHOD.760'] = "#66bb6a";
colorNameLookup['ORDER_SHIPPING_METHOD.760'] = "GREEN";
constants.ORDER_SHIPPING_METHOD_MPL_PALLET_DELIVERY = 770;
displayLookup['ORDER_SHIPPING_METHOD.770'] = "mpl pallet delivery";
colorLookup['ORDER_SHIPPING_METHOD.770'] = "#66bb6a";
colorNameLookup['ORDER_SHIPPING_METHOD.770'] = "GREEN";
constants.ORDER_SHIPPING_METHOD_MPL_POST_POINT = 780;
displayLookup['ORDER_SHIPPING_METHOD.780'] = "mpl post point";
colorLookup['ORDER_SHIPPING_METHOD.780'] = "#66bb6a";
colorNameLookup['ORDER_SHIPPING_METHOD.780'] = "GREEN";
constants.ORDER_SHIPPING_METHOD_MPL_PARCEL_POINT = 790;
displayLookup['ORDER_SHIPPING_METHOD.790'] = "mpl parcel point";
colorLookup['ORDER_SHIPPING_METHOD.790'] = "#66bb6a";
colorNameLookup['ORDER_SHIPPING_METHOD.790'] = "GREEN";
constants.ORDER_SHIPPING_METHOD_MPL_HOME_DELIVERY_RETURN = 761;
displayLookup['ORDER_SHIPPING_METHOD.761'] = "mpl home delivery return";
colorLookup['ORDER_SHIPPING_METHOD.761'] = "#66bb6a";
colorNameLookup['ORDER_SHIPPING_METHOD.761'] = "GREEN";
constants.ORDER_SHIPPING_METHOD_MPL_PARCEL_POINT_RETURN = 791;
displayLookup['ORDER_SHIPPING_METHOD.791'] = "mpl parcel point return";
colorLookup['ORDER_SHIPPING_METHOD.791'] = "#66bb6a";
colorNameLookup['ORDER_SHIPPING_METHOD.791'] = "GREEN";
constants.ORDER_SHIPPING_METHOD_MPL_HOME_DELIVERY_REPLACEMENT = 762;
displayLookup['ORDER_SHIPPING_METHOD.762'] = "mpl home delivery replacement";
colorLookup['ORDER_SHIPPING_METHOD.762'] = "#66bb6a";
colorNameLookup['ORDER_SHIPPING_METHOD.762'] = "GREEN";
constants.ORDER_SHIPPING_METHOD_PARCEL_24H_24_HOUR_SHIPPING = 800;
displayLookup['ORDER_SHIPPING_METHOD.800'] = "24H shipping";
colorLookup['ORDER_SHIPPING_METHOD.800'] = "#66bb6a";
colorNameLookup['ORDER_SHIPPING_METHOD.800'] = "GREEN";
constants.ORDER_SHIPPING_METHOD_PARCEL_24H_NIGHTLY_EXPRESS = 810;
displayLookup['ORDER_SHIPPING_METHOD.810'] = "24H nightly express";
colorLookup['ORDER_SHIPPING_METHOD.810'] = "#66bb6a";
colorNameLookup['ORDER_SHIPPING_METHOD.810'] = "GREEN";
constants.ORDER_SHIPPING_METHOD_PARCEL_24H_24_HOUR_SHIPPING_RETURN = 820;
displayLookup['ORDER_SHIPPING_METHOD.820'] = "24H shipping return";
colorLookup['ORDER_SHIPPING_METHOD.820'] = "#66bb6a";
colorNameLookup['ORDER_SHIPPING_METHOD.820'] = "GREEN";
constants.ORDER_SHIPPING_METHOD_PARCEL_24H_NIGHTLY_EXPRESS_RETURN = 830;
displayLookup['ORDER_SHIPPING_METHOD.830'] = "24H nightly express return";
colorLookup['ORDER_SHIPPING_METHOD.830'] = "#66bb6a";
colorNameLookup['ORDER_SHIPPING_METHOD.830'] = "GREEN";
constants.ORDER_SHIPPING_METHOD_PARCEL_24H_PALLET_24_HOUR_SHIPPING = 840;
displayLookup['ORDER_SHIPPING_METHOD.840'] = "24H pallet shipping";
colorLookup['ORDER_SHIPPING_METHOD.840'] = "#66bb6a";
colorNameLookup['ORDER_SHIPPING_METHOD.840'] = "GREEN";
constants.ORDER_SHIPPING_METHOD_PARCEL_24H_PALLET_NIGHTLY_EXPRESS = 850;
displayLookup['ORDER_SHIPPING_METHOD.850'] = "24H pallet nightly express";
colorLookup['ORDER_SHIPPING_METHOD.850'] = "#66bb6a";
colorNameLookup['ORDER_SHIPPING_METHOD.850'] = "GREEN";
constants.ORDER_SHIPPING_METHOD_PARCEL_24H_PALLET_24_HOUR_SHIPPING_RETURN = 860;
displayLookup['ORDER_SHIPPING_METHOD.860'] = "24H pallet shipping return";
colorLookup['ORDER_SHIPPING_METHOD.860'] = "#66bb6a";
colorNameLookup['ORDER_SHIPPING_METHOD.860'] = "GREEN";
constants.ORDER_SHIPPING_METHOD_PARCEL_24H_PALLET_NIGHTLY_EXPRESS_RETURN = 870;
displayLookup['ORDER_SHIPPING_METHOD.870'] = "24H pallet nightly express return";
colorLookup['ORDER_SHIPPING_METHOD.870'] = "#66bb6a";
colorNameLookup['ORDER_SHIPPING_METHOD.870'] = "GREEN";
constants.ORDER_SHIPPING_METHOD_FOXPOST_HOME_DELIVERY = 900;
displayLookup['ORDER_SHIPPING_METHOD.900'] = "foxpost home delivery";
colorLookup['ORDER_SHIPPING_METHOD.900'] = "#e57373";
colorNameLookup['ORDER_SHIPPING_METHOD.900'] = "RED";
constants.ORDER_SHIPPING_METHOD_FOXPOST_PARCEL_POINT = 910;
displayLookup['ORDER_SHIPPING_METHOD.910'] = "foxpost parcel point";
colorLookup['ORDER_SHIPPING_METHOD.910'] = "#e57373";
colorNameLookup['ORDER_SHIPPING_METHOD.910'] = "RED";
constants.ORDER_SHIPPING_METHOD_DPD_CLASSIC_DELIVERY = 950;
displayLookup['ORDER_SHIPPING_METHOD.950'] = "dpd delivery";
colorLookup['ORDER_SHIPPING_METHOD.950'] = "#e57373";
colorNameLookup['ORDER_SHIPPING_METHOD.950'] = "RED";
constants.ORDER_SHIPPING_METHOD_DPD_PARCEL_SHOP_DELIVERY = 960;
displayLookup['ORDER_SHIPPING_METHOD.960'] = "dpd parcel shop delivery";
colorLookup['ORDER_SHIPPING_METHOD.960'] = "#e57373";
colorNameLookup['ORDER_SHIPPING_METHOD.960'] = "RED";
constants.ORDER_SHIPPING_METHOD_EXPRESS_ONE_24H_DELIVERY = 1000;
displayLookup['ORDER_SHIPPING_METHOD.1000'] = "ExpressOne 24H";
colorLookup['ORDER_SHIPPING_METHOD.1000'] = "#ffb74d";
colorNameLookup['ORDER_SHIPPING_METHOD.1000'] = "YELLOW";
constants.ORDER_SHIPPING_METHOD_EXPRESS_ONE_08H_DELIVERY = 1010;
displayLookup['ORDER_SHIPPING_METHOD.1010'] = "ExpressOne 8H";
colorLookup['ORDER_SHIPPING_METHOD.1010'] = "#ffb74d";
colorNameLookup['ORDER_SHIPPING_METHOD.1010'] = "YELLOW";
constants.ORDER_SHIPPING_METHOD_EXPRESS_ONE_10H_DELIVERY = 1020;
displayLookup['ORDER_SHIPPING_METHOD.1020'] = "ExpressOne 10H";
colorLookup['ORDER_SHIPPING_METHOD.1020'] = "#ffb74d";
colorNameLookup['ORDER_SHIPPING_METHOD.1020'] = "YELLOW";
constants.ORDER_SHIPPING_METHOD_EXPRESS_ONE_12H_DELIVERY = 1030;
displayLookup['ORDER_SHIPPING_METHOD.1030'] = "ExpressOne 12H";
colorLookup['ORDER_SHIPPING_METHOD.1030'] = "#ffb74d";
colorNameLookup['ORDER_SHIPPING_METHOD.1030'] = "YELLOW";
constants.ORDER_SHIPPING_METHOD_EXPRESS_ONE_EXP_DELIVERY = 1040;
displayLookup['ORDER_SHIPPING_METHOD.1040'] = "ExpressOne Export";
colorLookup['ORDER_SHIPPING_METHOD.1040'] = "#ffb74d";
colorNameLookup['ORDER_SHIPPING_METHOD.1040'] = "YELLOW";
constants.ORDER_SHIPPING_METHOD_EXPRESS_ONE_D2S_DELIVERY = 1050;
displayLookup['ORDER_SHIPPING_METHOD.1050'] = "ExpressOne tofShop";
colorLookup['ORDER_SHIPPING_METHOD.1050'] = "#ffb74d";
colorNameLookup['ORDER_SHIPPING_METHOD.1050'] = "YELLOW";
constants.ORDER_SHIPPING_METHOD_EXPRESS_ONE_EST_DELIVERY = 1060;
displayLookup['ORDER_SHIPPING_METHOD.1060'] = "ExpressOne Night Delivery";
colorLookup['ORDER_SHIPPING_METHOD.1060'] = "#ffb74d";
colorNameLookup['ORDER_SHIPPING_METHOD.1060'] = "YELLOW";
constants.ORDER_SHIPPING_METHOD_EXPRESS_ONE_24H_DELIVERY_AND_RETURN = 1061;
displayLookup['ORDER_SHIPPING_METHOD.1061'] = "ExpressOne 24H & return";
colorLookup['ORDER_SHIPPING_METHOD.1061'] = "#ffb74d";
colorNameLookup['ORDER_SHIPPING_METHOD.1061'] = "YELLOW";
constants.ORDER_SHIPPING_METHOD_EXPRESS_ONE_08H_DELIVERY_AND_RETURN = 1062;
displayLookup['ORDER_SHIPPING_METHOD.1062'] = "ExpressOne 8H & return";
colorLookup['ORDER_SHIPPING_METHOD.1062'] = "#ffb74d";
colorNameLookup['ORDER_SHIPPING_METHOD.1062'] = "YELLOW";
constants.ORDER_SHIPPING_METHOD_EXPRESS_ONE_10H_DELIVERY_AND_RETURN = 1063;
displayLookup['ORDER_SHIPPING_METHOD.1063'] = "ExpressOne 10H & return";
colorLookup['ORDER_SHIPPING_METHOD.1063'] = "#ffb74d";
colorNameLookup['ORDER_SHIPPING_METHOD.1063'] = "YELLOW";
constants.ORDER_SHIPPING_METHOD_EXPRESS_ONE_12H_DELIVERY_AND_RETURN = 1064;
displayLookup['ORDER_SHIPPING_METHOD.1064'] = "ExpressOne 12H & return";
colorLookup['ORDER_SHIPPING_METHOD.1064'] = "#ffb74d";
colorNameLookup['ORDER_SHIPPING_METHOD.1064'] = "YELLOW";
constants.ORDER_SHIPPING_METHOD_EXPRESS_ONE_EXP_DELIVERY_AND_RETURN = 1065;
displayLookup['ORDER_SHIPPING_METHOD.1065'] = "ExpressOne Export & return";
colorLookup['ORDER_SHIPPING_METHOD.1065'] = "#ffb74d";
colorNameLookup['ORDER_SHIPPING_METHOD.1065'] = "YELLOW";
constants.ORDER_SHIPPING_METHOD_EXPRESS_ONE_D2S_DELIVERY_AND_RETURN = 1066;
displayLookup['ORDER_SHIPPING_METHOD.1066'] = "ExpressOne tofShop & return";
colorLookup['ORDER_SHIPPING_METHOD.1066'] = "#ffb74d";
colorNameLookup['ORDER_SHIPPING_METHOD.1066'] = "YELLOW";
constants.ORDER_SHIPPING_METHOD_EXPRESS_ONE_EST_DELIVERY_AND_RETURN = 1067;
displayLookup['ORDER_SHIPPING_METHOD.1067'] = "ExpressOne Night Delivery & return";
colorLookup['ORDER_SHIPPING_METHOD.1067'] = "#ffb74d";
colorNameLookup['ORDER_SHIPPING_METHOD.1067'] = "YELLOW";
constants.ORDER_SHIPPING_METHOD_EXPRESS_ONE_ARU = 1070;
displayLookup['ORDER_SHIPPING_METHOD.1070'] = "ExpressOne Next Working Day Pickup";
colorLookup['ORDER_SHIPPING_METHOD.1070'] = "#ffb74d";
colorNameLookup['ORDER_SHIPPING_METHOD.1070'] = "YELLOW";
constants.ORDER_SHIPPING_METHOD_EXPRESS_ONE_AR3 = 1080;
displayLookup['ORDER_SHIPPING_METHOD.1080'] = "ExpressOne Pickup - Third Party Pay";
colorLookup['ORDER_SHIPPING_METHOD.1080'] = "#ffb74d";
colorNameLookup['ORDER_SHIPPING_METHOD.1080'] = "YELLOW";
constants.ORDER_SHIPPING_METHOD_ILOGISTIC_PARCEL_POINT = 1100;
displayLookup['ORDER_SHIPPING_METHOD.1100'] = "Ilogistic parcel point";
colorLookup['ORDER_SHIPPING_METHOD.1100'] = "#64b5f6";
colorNameLookup['ORDER_SHIPPING_METHOD.1100'] = "BLUE";
constants.ORDER_SHIPPING_METHOD_PACTIC_DPD_BUSINESS_HOME_DELIVERY = 1110;
displayLookup['ORDER_SHIPPING_METHOD.1110'] = "Pactic - Pactic - DPD Business Home Delivery";
colorLookup['ORDER_SHIPPING_METHOD.1110'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1110'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_DPD_ROMANIA_CROSS_BORDER = 1111;
displayLookup['ORDER_SHIPPING_METHOD.1111'] = "Pactic - DPD Romania Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1111'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1111'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_DPD_ROMANIA_CROSS_BORDER_DIRECT_INJECTION = 1112;
displayLookup['ORDER_SHIPPING_METHOD.1112'] = "Pactic - DPD Romania Cross-border Direct inj.";
colorLookup['ORDER_SHIPPING_METHOD.1112'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1112'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_DPD_AUSTRIA_CROSS_BORDER = 1113;
displayLookup['ORDER_SHIPPING_METHOD.1113'] = "Pactic - DPD Austria Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1113'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1113'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_DPD_AUSTRIA_CROSS_BORDER_DIRECT_INJECTION = 1114;
displayLookup['ORDER_SHIPPING_METHOD.1114'] = "Pactic - DPD Austria Cross-border Direct Injection";
colorLookup['ORDER_SHIPPING_METHOD.1114'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1114'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_ACS_GREECE_CROSS_BORDER = 1115;
displayLookup['ORDER_SHIPPING_METHOD.1115'] = "Pactic - ACS Greece Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1115'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1115'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_ECONT_BULGARIA_CROSS_BORDER = 1116;
displayLookup['ORDER_SHIPPING_METHOD.1116'] = "Pactic - Econt Bulgaria Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1116'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1116'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_ECONT_BULGARIA_CROSS_BORDER_DIRECT_INJECTION = 1117;
displayLookup['ORDER_SHIPPING_METHOD.1117'] = "Pactic - Econt Bulgaria Cross-border Direct Injection";
colorLookup['ORDER_SHIPPING_METHOD.1117'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1117'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_ACS_GREECE_CROSS_BORDER_DIRECT_INJECTION = 1118;
displayLookup['ORDER_SHIPPING_METHOD.1118'] = "Pactic - ACS Greece Cross-border Direct Injection";
colorLookup['ORDER_SHIPPING_METHOD.1118'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1118'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_ECONT_BULGARIA_PARCELSHOP_CROSS_BORDER = 1119;
displayLookup['ORDER_SHIPPING_METHOD.1119'] = "Pactic - Econt Bulgaria ParcelShop Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1119'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1119'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_ECONT_BULGARIA_PUDO_CROSS_BORDER_DIRECT_INJECTION = 1120;
displayLookup['ORDER_SHIPPING_METHOD.1120'] = "Pactic - Econt Bulgaria PUDO Cross-border Direct Injection";
colorLookup['ORDER_SHIPPING_METHOD.1120'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1120'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_SPEEDEX_GREECE_CROSS_BORDER = 1121;
displayLookup['ORDER_SHIPPING_METHOD.1121'] = "Pactic - Speedex Greece Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1121'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1121'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_SPEEDEX_GREECE_CROSS_BORDER_DIRECT_INJECTION = 1122;
displayLookup['ORDER_SHIPPING_METHOD.1122'] = "Pactic - Speedex Greece Cross-border Direct Injection";
colorLookup['ORDER_SHIPPING_METHOD.1122'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1122'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GENIKI_GREECE_CROSS_BORDER = 1123;
displayLookup['ORDER_SHIPPING_METHOD.1123'] = "Pactic - Geniki Greece Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1123'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1123'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GENIKI_GREECE_CROSS_BORDER_DIRECT_INJECTION = 1124;
displayLookup['ORDER_SHIPPING_METHOD.1124'] = "Pactic - Geniki Greece Cross-border Direct Injection";
colorLookup['ORDER_SHIPPING_METHOD.1124'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1124'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_BIZ_GREECE_CROSS_BORDER = 1125;
displayLookup['ORDER_SHIPPING_METHOD.1125'] = "Pactic - BIZ Greece Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1125'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1125'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_INPOST_POLAND_CROSS_BORDER_DIRECT_INJECTION = 1126;
displayLookup['ORDER_SHIPPING_METHOD.1126'] = "Pactic - InPost Poland Cross-border Direct Injection";
colorLookup['ORDER_SHIPPING_METHOD.1126'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1126'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_INPOST_POLAND_CROSS_BORDER = 1127;
displayLookup['ORDER_SHIPPING_METHOD.1127'] = "Pactic - InPost Poland Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1127'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1127'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_INPOST_POLAND_LOCKER_CROSS_BORDER = 1128;
displayLookup['ORDER_SHIPPING_METHOD.1128'] = "Pactic - InPost Poland Locker Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1128'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1128'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_INPOST_POLAND_LOCKER_CROSS_BORDER_INJECTION = 1129;
displayLookup['ORDER_SHIPPING_METHOD.1129'] = "Pactic - InPost Poland Locker Cross-border injection";
colorLookup['ORDER_SHIPPING_METHOD.1129'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1129'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_URGENTCARGUS_CROSS_BORDER = 1130;
displayLookup['ORDER_SHIPPING_METHOD.1130'] = "Pactic - UrgentCargus Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1130'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1130'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_URGENTCARGUS_CROSS_BORDER_DIRECT_INJECTION = 1131;
displayLookup['ORDER_SHIPPING_METHOD.1131'] = "Pactic - UrgentCargus Cross-border Direct Injection";
colorLookup['ORDER_SHIPPING_METHOD.1131'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1131'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_WEDO_CZECH_REPUBLIC_CROSS_BORDER = 1132;
displayLookup['ORDER_SHIPPING_METHOD.1132'] = "Pactic - WE|DO Czech Republic Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1132'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1132'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_WEDO_CZECH_REPUBLIC_CROSS_BORDER_DIRECT_INJECTION = 1133;
displayLookup['ORDER_SHIPPING_METHOD.1133'] = "Pactic - WE|DO Czech Republic Cross-border Direct Injection";
colorLookup['ORDER_SHIPPING_METHOD.1133'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1133'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_SLOVAK_POST_CROSS_BORDER = 1134;
displayLookup['ORDER_SHIPPING_METHOD.1134'] = "Pactic - Slovak Post Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1134'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1134'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_SLOVAK_POST_CROSS_BORDER_PUDO = 1135;
displayLookup['ORDER_SHIPPING_METHOD.1135'] = "Pactic - Slovak Post Cross-border PuDo";
colorLookup['ORDER_SHIPPING_METHOD.1135'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1135'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_MPL_BUSINESS_POST_POINT = 1136;
displayLookup['ORDER_SHIPPING_METHOD.1136'] = "Pactic - Pactic - MPL Post Point";
colorLookup['ORDER_SHIPPING_METHOD.1136'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1136'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_B2C_EUROPE_CROSS_BORDER = 1137;
displayLookup['ORDER_SHIPPING_METHOD.1137'] = "Pactic - B2C Europe Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1137'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1137'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_B2C_EUROPE_CROSS_BORDER_DIRECT_INJECTION = 1138;
displayLookup['ORDER_SHIPPING_METHOD.1138'] = "Pactic - B2C Europe Cross-border direct injection";
colorLookup['ORDER_SHIPPING_METHOD.1138'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1138'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_DHL_GERMANY_CROSS_BORDER = 1139;
displayLookup['ORDER_SHIPPING_METHOD.1139'] = "Pactic - DHL Germany Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1139'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1139'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_DHL_GERMANY_CROSS_BORDER_PAKETSHOP = 1140;
displayLookup['ORDER_SHIPPING_METHOD.1140'] = "Pactic - DHL Germany Cross-border paketshop";
colorLookup['ORDER_SHIPPING_METHOD.1140'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1140'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_PPL_CZECH_CROSS_BORDER = 1141;
displayLookup['ORDER_SHIPPING_METHOD.1141'] = "Pactic - PPL Czech Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1141'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1141'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_PPL_CZECH_CROSS_BORDER_DIRECT_INJECTION = 1142;
displayLookup['ORDER_SHIPPING_METHOD.1142'] = "Pactic - PPL Czech Cross-border direct Injection";
colorLookup['ORDER_SHIPPING_METHOD.1142'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1142'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_PPL_CZECH_CROSS_BORDER_PUDO = 1143;
displayLookup['ORDER_SHIPPING_METHOD.1143'] = "Pactic - PPL Czech Cross-border PuDo";
colorLookup['ORDER_SHIPPING_METHOD.1143'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1143'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_PPL_CZECH_CROSS_BORDER_PUDO_DIRECT_INJECTION = 1144;
displayLookup['ORDER_SHIPPING_METHOD.1144'] = "Pactic - PPL Czech Cross-border PuDo Direct Injection";
colorLookup['ORDER_SHIPPING_METHOD.1144'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1144'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_PPL_CZECH_PUDO_RETURN = 1145;
displayLookup['ORDER_SHIPPING_METHOD.1145'] = "Pactic - PPL Czech PuDo Return";
colorLookup['ORDER_SHIPPING_METHOD.1145'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1145'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_HERMES_GERMANY_CROSS_BORDER = 1146;
displayLookup['ORDER_SHIPPING_METHOD.1146'] = "Pactic - Hermes Germany Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1146'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1146'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_SPRING_CROSS_BORDER_EU_DESTINATIONS = 1147;
displayLookup['ORDER_SHIPPING_METHOD.1147'] = "Pactic - Spring Cross-border EU destinations";
colorLookup['ORDER_SHIPPING_METHOD.1147'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1147'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_BPOST_BELGIUM_CROSS_BORDER = 1148;
displayLookup['ORDER_SHIPPING_METHOD.1148'] = "Pactic - Bpost Belgium Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1148'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1148'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_BRING_DENMARK_CROSS_BORDER = 1149;
displayLookup['ORDER_SHIPPING_METHOD.1149'] = "Pactic - Bring Denmark Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1149'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1149'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_POST_ESTONIA_CROSS_BORDER = 1150;
displayLookup['ORDER_SHIPPING_METHOD.1150'] = "Pactic - Post Estonia Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1150'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1150'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_POST_FINLAND_CROSS_BORDER = 1151;
displayLookup['ORDER_SHIPPING_METHOD.1151'] = "Pactic - Post Finland Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1151'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1151'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_COLIS_PRIVE_FRANCE_CROSS_BORDER = 1152;
displayLookup['ORDER_SHIPPING_METHOD.1152'] = "Pactic - Colis Prive France Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1152'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1152'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_FASTWAY_IRELAND_CROSS_BORDER = 1153;
displayLookup['ORDER_SHIPPING_METHOD.1153'] = "Pactic - Fastway Ireland Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1153'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1153'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_POST_LATVIA_CROSS_BORDER = 1154;
displayLookup['ORDER_SHIPPING_METHOD.1154'] = "Pactic - Post Latvia Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1154'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1154'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_POST_LITHUANIA_CROSS_BORDER = 1155;
displayLookup['ORDER_SHIPPING_METHOD.1155'] = "Pactic - Post Lithuania Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1155'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1155'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_POST_LUXEMBOURG_CROSS_BORDER = 1156;
displayLookup['ORDER_SHIPPING_METHOD.1156'] = "Pactic - Post Luxembourg Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1156'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1156'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_POST_NL_NETHERLANDS_CROSS_BORDER = 1157;
displayLookup['ORDER_SHIPPING_METHOD.1157'] = "Pactic - Post NL Netherlands Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1157'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1157'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_CTT_EXPRESS_PORTUGAL_CROSS_BORDER = 1158;
displayLookup['ORDER_SHIPPING_METHOD.1158'] = "Pactic - CTT Express Portugal Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1158'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1158'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_CTT_EXPRESS_SPAIN_CROSS_BORDER = 1159;
displayLookup['ORDER_SHIPPING_METHOD.1159'] = "Pactic - CTT Express Spain Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1159'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1159'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_BRING_SWEDEN_CROSS_BORDER = 1160;
displayLookup['ORDER_SHIPPING_METHOD.1160'] = "Pactic - Bring Sweden Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1160'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1160'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_CROATIA_POST_CROSS_BORDER = 1161;
displayLookup['ORDER_SHIPPING_METHOD.1161'] = "Pactic - Croatia Post Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1161'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1161'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_CROATIA_POST_CROSS_BORDER_PUDO = 1162;
displayLookup['ORDER_SHIPPING_METHOD.1162'] = "Pactic - Croatia Post Cross-border PUDO";
colorLookup['ORDER_SHIPPING_METHOD.1162'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1162'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_CROATIA_POST_CROSS_BORDER_DIRECT_INJECTION = 1163;
displayLookup['ORDER_SHIPPING_METHOD.1163'] = "Pactic - Croatia Post Cross-border Direct inj.";
colorLookup['ORDER_SHIPPING_METHOD.1163'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1163'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_CROATIA_POST_CROSS_BORDER_PUDO_DIRECT_INJECTION = 1164;
displayLookup['ORDER_SHIPPING_METHOD.1164'] = "Pactic - Croatia Post Cross-border PUDO D. inj.";
colorLookup['ORDER_SHIPPING_METHOD.1164'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1164'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_CZECH_POST_CROSS_BORDER = 1165;
displayLookup['ORDER_SHIPPING_METHOD.1165'] = "Pactic - Czech Post Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1165'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1165'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_CZECH_POST_CROSS_BORDER_DIRECT_INJECTION = 1166;
displayLookup['ORDER_SHIPPING_METHOD.1166'] = "Pactic - Czech Post Cross-border Dir. Inj.";
colorLookup['ORDER_SHIPPING_METHOD.1166'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1166'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GLS_BUSINESS_HOME_DELIVERY = 1200;
displayLookup['ORDER_SHIPPING_METHOD.1200'] = "Pactic - GLS Business Home Delivery";
colorLookup['ORDER_SHIPPING_METHOD.1200'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1200'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GLS_BUSINESS_PICKUP_POINT = 1210;
displayLookup['ORDER_SHIPPING_METHOD.1210'] = "Pactic - GLS Business PickUp Point";
colorLookup['ORDER_SHIPPING_METHOD.1210'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1210'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GLS_HUNGARY_PICK_AND_SHIP_DOMESTIC = 1220;
displayLookup['ORDER_SHIPPING_METHOD.1220'] = "Pactic - GLS Hungary Pick & Ship Domestic";
colorLookup['ORDER_SHIPPING_METHOD.1220'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1220'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GLS_HUNGARY_EXCHANGE_SERVICE = 1230;
displayLookup['ORDER_SHIPPING_METHOD.1230'] = "Pactic - GLS Hungary Exchange Service";
colorLookup['ORDER_SHIPPING_METHOD.1230'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1230'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GLS_HUNGARY_CROSS_BORDER_PUDO_DIRECT_INJECTION = 1231;
displayLookup['ORDER_SHIPPING_METHOD.1231'] = "Pactic - GLS Hungary Cross-border PUDO Direct injection";
colorLookup['ORDER_SHIPPING_METHOD.1231'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1231'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GLS_HUNGARY_CROSS_BORDER_PUDO = 1232;
displayLookup['ORDER_SHIPPING_METHOD.1232'] = "Pactic - GLS Hungary Cross-border PUDO";
colorLookup['ORDER_SHIPPING_METHOD.1232'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1232'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GLS_HUNGARY_CROSS_BORDER = 1233;
displayLookup['ORDER_SHIPPING_METHOD.1233'] = "Pactic - GLS Hungary Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1233'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1233'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GLS_ROMANIA_CROSS_BORDER_DIRECT_INJECTION = 1234;
displayLookup['ORDER_SHIPPING_METHOD.1234'] = "Pactic - GLS Romania Cross-border Direct Injection";
colorLookup['ORDER_SHIPPING_METHOD.1234'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1234'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GLS_ROMANIA_CROSS_BORDER = 1235;
displayLookup['ORDER_SHIPPING_METHOD.1235'] = "Pactic - GLS Romania Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1235'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1235'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GLS_ROMANIA_PICK_AND_SHIP_DOMESTIC = 1236;
displayLookup['ORDER_SHIPPING_METHOD.1236'] = "Pactic - GLS Romania Pick & Ship Domestic";
colorLookup['ORDER_SHIPPING_METHOD.1236'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1236'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GLS_ROMANIA_EXCHANGE_SERVICE = 1237;
displayLookup['ORDER_SHIPPING_METHOD.1237'] = "Pactic - GLS Romania Exchange Service";
colorLookup['ORDER_SHIPPING_METHOD.1237'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1237'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GLS_CROSS_BORDER_DIRECT = 1238;
displayLookup['ORDER_SHIPPING_METHOD.1238'] = "Pactic - Pactic - GLS Cross-border Direct";
colorLookup['ORDER_SHIPPING_METHOD.1238'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1238'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GLS_SLOVENIA_CROSS_BORDER = 1239;
displayLookup['ORDER_SHIPPING_METHOD.1239'] = "Pactic - GLS Slovenia Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1239'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1239'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GLS_CZECH_REPUBLIC_CROSS_BORDER = 1240;
displayLookup['ORDER_SHIPPING_METHOD.1240'] = "Pactic - GLS Czech Republic Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1240'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1240'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GLS_SLOVENIA_DIRECT_INJECTION = 1241;
displayLookup['ORDER_SHIPPING_METHOD.1241'] = "Pactic - GLS Slovenia Direct Injection";
colorLookup['ORDER_SHIPPING_METHOD.1241'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1241'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GLS_CROATIA_CROSS_BORDER = 1242;
displayLookup['ORDER_SHIPPING_METHOD.1242'] = "Pactic - GLS Croatia Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1242'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1242'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GLS_CROATIA_CROSS_BORDER_DIRECT_INJECTION = 1243;
displayLookup['ORDER_SHIPPING_METHOD.1243'] = "Pactic - GLS Croatia Cross-border Direct Injection";
colorLookup['ORDER_SHIPPING_METHOD.1243'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1243'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GLS_CROATIA_PICK_AND_RETURN = 1244;
displayLookup['ORDER_SHIPPING_METHOD.1244'] = "Pactic - GLS Croatia Pick and Return";
colorLookup['ORDER_SHIPPING_METHOD.1244'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1244'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GLS_SLOVENIA_PICK_AND_RETURN = 1245;
displayLookup['ORDER_SHIPPING_METHOD.1245'] = "Pactic - GLS Slovenia Pick and Return";
colorLookup['ORDER_SHIPPING_METHOD.1245'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1245'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GLS_SLOVENIA_PUDO = 1246;
displayLookup['ORDER_SHIPPING_METHOD.1246'] = "Pactic - GLS Slovenia PUDO";
colorLookup['ORDER_SHIPPING_METHOD.1246'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1246'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GLS_SLOVENIA_PUDO_DIRECT_INJECTION = 1247;
displayLookup['ORDER_SHIPPING_METHOD.1247'] = "Pactic - GLS Slovenia PUDO Direct Injection";
colorLookup['ORDER_SHIPPING_METHOD.1247'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1247'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GLS_SLOVAKIA_CROSS_BORDER = 1248;
displayLookup['ORDER_SHIPPING_METHOD.1248'] = "Pactic - GLS Slovakia Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1248'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1248'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GLS_SLOVAKIA_CROSS_BORDER_DIRECT_INJECTION = 1249;
displayLookup['ORDER_SHIPPING_METHOD.1249'] = "Pactic - GLS Slovakia Cross-border Direct Injection";
colorLookup['ORDER_SHIPPING_METHOD.1249'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1249'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GLS_SLOVAKIA_CROSS_BORDER_PUDO = 1250;
displayLookup['ORDER_SHIPPING_METHOD.1250'] = "Pactic - GLS Slovakia Cross-border PUDO";
colorLookup['ORDER_SHIPPING_METHOD.1250'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1250'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GLS_SLOVAKIA_CROSS_BORDER_PUDO_DIRECT_INJECTION = 1251;
displayLookup['ORDER_SHIPPING_METHOD.1251'] = "Pactic - GLS Slovakia Cross-border PUDO Direct Injection";
colorLookup['ORDER_SHIPPING_METHOD.1251'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1251'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GLS_SLOVAKIA_EXCHANGE_SERVICE = 1252;
displayLookup['ORDER_SHIPPING_METHOD.1252'] = "Pactic - GLS Slovakia Exchange Service";
colorLookup['ORDER_SHIPPING_METHOD.1252'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1252'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GLS_SLOVAKIA_PICK_RETURN = 1253;
displayLookup['ORDER_SHIPPING_METHOD.1253'] = "Pactic - GLS Slovakia Pick & Return";
colorLookup['ORDER_SHIPPING_METHOD.1253'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1253'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GLS_CROATIA_PUDO = 1254;
displayLookup['ORDER_SHIPPING_METHOD.1254'] = "Pactic - GLS Croatia PUDO";
colorLookup['ORDER_SHIPPING_METHOD.1254'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1254'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GLS_CROATIA_PUDO_DIRECT_INJECTION = 1255;
displayLookup['ORDER_SHIPPING_METHOD.1255'] = "Pactic - GLS Croatia PUDO Direct Injection";
colorLookup['ORDER_SHIPPING_METHOD.1255'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1255'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GLS_AUSTRIA_CROSS_BORDER = 1256;
displayLookup['ORDER_SHIPPING_METHOD.1256'] = "Pactic - GLS Austria Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1256'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1256'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GLS_AUSTRIA_PUDO_CROSS_BORDER = 1257;
displayLookup['ORDER_SHIPPING_METHOD.1257'] = "Pactic - GLS Austria PuDo Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1257'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1257'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GLS_ITALY_CROSS_BORDER = 1258;
displayLookup['ORDER_SHIPPING_METHOD.1258'] = "Pactic - GLS Italy Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1258'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1258'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GLS_ITALY_PUDO_CROSS_BORDER = 1259;
displayLookup['ORDER_SHIPPING_METHOD.1259'] = "Pactic - GLS Italy Cross-border PuDo";
colorLookup['ORDER_SHIPPING_METHOD.1259'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1259'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GLS_ITALY_PICK_AND_RETURN = 1260;
displayLookup['ORDER_SHIPPING_METHOD.1260'] = "Pactic - GLS Italy Pick and Return";
colorLookup['ORDER_SHIPPING_METHOD.1260'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1260'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GLS_POLAND_CROSS_BORDER = 1261;
displayLookup['ORDER_SHIPPING_METHOD.1261'] = "Pactic - GLS Poland Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1261'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1261'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GLS_POLAND_CROSS_BORDER_DIRECT_INJECTION = 1262;
displayLookup['ORDER_SHIPPING_METHOD.1262'] = "Pactic - GLS Poland Cross-border Direct Injection";
colorLookup['ORDER_SHIPPING_METHOD.1262'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1262'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GLS_POLAND_CROSS_BORDER_PUDO = 1263;
displayLookup['ORDER_SHIPPING_METHOD.1263'] = "Pactic - GLS Poland Cross-border PuDo";
colorLookup['ORDER_SHIPPING_METHOD.1263'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1263'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GLS_POLAND_CROSS_BORDER_PUDO_DIRECT_INJECTION = 1264;
displayLookup['ORDER_SHIPPING_METHOD.1264'] = "Pactic - GLS Poland Cross-border PuDo Direct Injection";
colorLookup['ORDER_SHIPPING_METHOD.1264'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1264'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_GLS_POLAND_PICK_RETURN = 1265;
displayLookup['ORDER_SHIPPING_METHOD.1265'] = "Pactic - GLS Poland Pick & Return";
colorLookup['ORDER_SHIPPING_METHOD.1265'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1265'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_SAMEDAY_HUNGARY_CROSS_BORDER_DIRECT_INJECTION = 1266;
displayLookup['ORDER_SHIPPING_METHOD.1266'] = "Pactic - Sameday Hungary Cross-border Direct Injection";
colorLookup['ORDER_SHIPPING_METHOD.1266'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1266'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_SAMEDAY_HUNGARY_EASYBOX_DIRECT_INJECTION = 1267;
displayLookup['ORDER_SHIPPING_METHOD.1267'] = "Pactic - Sameday Hungary Easybox Direct Injection";
colorLookup['ORDER_SHIPPING_METHOD.1267'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1267'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_SAMEDAY_HUNGARY_CROSS_BORDER = 1268;
displayLookup['ORDER_SHIPPING_METHOD.1268'] = "Pactic - Sameday Hungary Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1268'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1268'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_SAMEDAY_HUNGARY_CROSS_BORDER_EASYBOX = 1269;
displayLookup['ORDER_SHIPPING_METHOD.1269'] = "Pactic - Sameday Hungary Cross-border Easybox";
colorLookup['ORDER_SHIPPING_METHOD.1269'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1269'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_PACKETA_HUNGARY_PUDO = 1270;
displayLookup['ORDER_SHIPPING_METHOD.1270'] = "Pactic - Packeta Hungary PuDo";
colorLookup['ORDER_SHIPPING_METHOD.1270'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1270'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_SAMEDAY_ROMANIA_CROSS_BORDER = 1271;
displayLookup['ORDER_SHIPPING_METHOD.1271'] = "Pactic - SameDay Romania Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1271'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1271'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_SAMEDAY_ROMANIA_CROSS_BORDER_DIRECT_INJECTION = 1272;
displayLookup['ORDER_SHIPPING_METHOD.1272'] = "Pactic - SameDay Romania Cross-border Direct Injection";
colorLookup['ORDER_SHIPPING_METHOD.1272'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1272'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_SAMEDAY_ROMANIA_PUDO_BUSINESS = 1273;
displayLookup['ORDER_SHIPPING_METHOD.1273'] = "Pactic - SameDay Romania PuDo Business";
colorLookup['ORDER_SHIPPING_METHOD.1273'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1273'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_SAMEDAY_ROMANIA_PUDO_CROSS_BORDER = 1274;
displayLookup['ORDER_SHIPPING_METHOD.1274'] = "Pactic - SameDay Romania PuDo Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1274'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1274'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_SAMEDAY_ROMANIA_PUDO_DIRECT_INJECTION = 1275;
displayLookup['ORDER_SHIPPING_METHOD.1275'] = "Pactic - SameDay Romania PuDo Direct Injection";
colorLookup['ORDER_SHIPPING_METHOD.1275'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1275'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_SAMEDAY_BULGARIA_CROSS_BORDER = 1276;
displayLookup['ORDER_SHIPPING_METHOD.1276'] = "Pactic - Sameday Bulgaria Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1276'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1276'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_SAMEDAY_BULGARIA_CROSS_BORDER_DIRECT_INJECTION = 1277;
displayLookup['ORDER_SHIPPING_METHOD.1277'] = "Pactic - Sameday Bulgaria Cross-border Direct Injection";
colorLookup['ORDER_SHIPPING_METHOD.1277'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1277'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_EXPRESSONE_CROSS_BORDER_DOMESTIC = 1278;
displayLookup['ORDER_SHIPPING_METHOD.1278'] = "Pactic - ExpressOne Cross-border Domestic";
colorLookup['ORDER_SHIPPING_METHOD.1278'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1278'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_EXPRESSONE_CROSS_BORDER_DIRECT_INJECTION = 1279;
displayLookup['ORDER_SHIPPING_METHOD.1279'] = "Pactic - ExpressOne Cross-border Direct Injection";
colorLookup['ORDER_SHIPPING_METHOD.1279'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1279'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_MPL_BUSINESS_PICKUP_POINT = 1280;
displayLookup['ORDER_SHIPPING_METHOD.1280'] = "Pactic - Pactic - MPL PickUp Point";
colorLookup['ORDER_SHIPPING_METHOD.1280'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1280'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_MPL_HUNGARY_CROSS_BORDER = 1281;
displayLookup['ORDER_SHIPPING_METHOD.1281'] = "Pactic - MPL Hungary Cross-border";
colorLookup['ORDER_SHIPPING_METHOD.1281'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1281'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_MPL_HUNGARY_CROSS_BORDER_PUDO_DIR_INJ = 1282;
displayLookup['ORDER_SHIPPING_METHOD.1282'] = "Pactic - MPL Hungary Cross-border PUDO Dir. Inj.";
colorLookup['ORDER_SHIPPING_METHOD.1282'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1282'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_MPL_HUNGARY_CROSS_BORDER_PUDO = 1283;
displayLookup['ORDER_SHIPPING_METHOD.1283'] = "Pactic - MPL Hungary Cross-border PUDO";
colorLookup['ORDER_SHIPPING_METHOD.1283'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1283'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_MPL_BUSINESS_MANIFEST = 1284;
displayLookup['ORDER_SHIPPING_METHOD.1284'] = "Pactic - MPL Business Manifest";
colorLookup['ORDER_SHIPPING_METHOD.1284'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1284'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_MPL_BUSINESS_PUDO_MANIFEST = 1285;
displayLookup['ORDER_SHIPPING_METHOD.1285'] = "Pactic - MPL Business PuDo Manifest";
colorLookup['ORDER_SHIPPING_METHOD.1285'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1285'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_MPL_HUNGARY_CROSS_BORDER_MANIFEST = 1286;
displayLookup['ORDER_SHIPPING_METHOD.1286'] = "Pactic - MPL Hungary Cross-border Manifest";
colorLookup['ORDER_SHIPPING_METHOD.1286'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1286'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_MPL_HUNGARY_CROSS_BORDER_PUDO_DIR_INJ_MANIFEST = 1287;
displayLookup['ORDER_SHIPPING_METHOD.1287'] = "Pactic - MPL Hungary Cross-border PUDO Dir Inj Manifest";
colorLookup['ORDER_SHIPPING_METHOD.1287'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1287'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_MPL_HUNGARY_CROSS_BORDER_PUDO_MANIFEST = 1288;
displayLookup['ORDER_SHIPPING_METHOD.1288'] = "Pactic - MPL Hungary Cross-border PUDO Manifest";
colorLookup['ORDER_SHIPPING_METHOD.1288'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1288'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_PACTIC_DPD_ROMANIA_CLASSIC_BUSINESS_DOMESTIC = 1289;
displayLookup['ORDER_SHIPPING_METHOD.1289'] = "Pactic - DPD Romania Classic Business Domestic";
colorLookup['ORDER_SHIPPING_METHOD.1289'] = "#106d3b";
colorNameLookup['ORDER_SHIPPING_METHOD.1289'] = "DARK_GREEN";
constants.ORDER_SHIPPING_METHOD_EMAG_COURIER = 1300;
displayLookup['ORDER_SHIPPING_METHOD.1300'] = "Emag courier";
colorLookup['ORDER_SHIPPING_METHOD.1300'] = "#64b5f6";
colorNameLookup['ORDER_SHIPPING_METHOD.1300'] = "BLUE";
constants.ORDER_SHIPPING_METHOD_SAMEDAY = 1310;
displayLookup['ORDER_SHIPPING_METHOD.1310'] = "Sameday";
colorLookup['ORDER_SHIPPING_METHOD.1310'] = "#64b5f6";
colorNameLookup['ORDER_SHIPPING_METHOD.1310'] = "BLUE";
constants.ORDER_SHIPPING_METHOD_KUMI_DELIVERY = 1400;
displayLookup['ORDER_SHIPPING_METHOD.1400'] = "kumi delivery";
colorLookup['ORDER_SHIPPING_METHOD.1400'] = "#f57c00";
colorNameLookup['ORDER_SHIPPING_METHOD.1400'] = "ORANGE";
constants.ORDER_SHIPPING_METHOD_KUMI_RETURN = 1410;
displayLookup['ORDER_SHIPPING_METHOD.1410'] = "kumi return";
colorLookup['ORDER_SHIPPING_METHOD.1410'] = "#f57c00";
colorNameLookup['ORDER_SHIPPING_METHOD.1410'] = "ORANGE";
constants.ORDER_SHIPPING_METHOD_KUMI_REPLACEMENT = 1420;
displayLookup['ORDER_SHIPPING_METHOD.1420'] = "kumi replacement";
colorLookup['ORDER_SHIPPING_METHOD.1420'] = "#f57c00";
colorNameLookup['ORDER_SHIPPING_METHOD.1420'] = "ORANGE";
constants.ORDER_SHIPPING_METHOD_KOVA_TRANS_DELIVERY = 1500;
displayLookup['ORDER_SHIPPING_METHOD.1500'] = "kova trans delivery";
colorLookup['ORDER_SHIPPING_METHOD.1500'] = "#64b5f6";
colorNameLookup['ORDER_SHIPPING_METHOD.1500'] = "BLUE";
constants.ORDER_SHIPPING_METHOD_KOVA_TRANS_PICKUP = 1510;
displayLookup['ORDER_SHIPPING_METHOD.1510'] = "kova trans pickup";
colorLookup['ORDER_SHIPPING_METHOD.1510'] = "#64b5f6";
colorNameLookup['ORDER_SHIPPING_METHOD.1510'] = "BLUE";
constants.ORDER_SHIPPING_METHOD_PANNONXP_DELIVERY = 1600;
displayLookup['ORDER_SHIPPING_METHOD.1600'] = "PannonXP delivery";
colorLookup['ORDER_SHIPPING_METHOD.1600'] = "#f57c00";
colorNameLookup['ORDER_SHIPPING_METHOD.1600'] = "ORANGE";
constants.ORDER_SHIPPING_METHOD_PANNONXP_PICKUP_POINT = 1610;
displayLookup['ORDER_SHIPPING_METHOD.1610'] = "PannonXP pickup point";
colorLookup['ORDER_SHIPPING_METHOD.1610'] = "#f57c00";
colorNameLookup['ORDER_SHIPPING_METHOD.1610'] = "ORANGE";
constants.ORDER_SHIPPING_METHOD_PANNONXP_RETURN = 1620;
displayLookup['ORDER_SHIPPING_METHOD.1620'] = "PannonXP return";
colorLookup['ORDER_SHIPPING_METHOD.1620'] = "#f57c00";
colorNameLookup['ORDER_SHIPPING_METHOD.1620'] = "ORANGE";
constants.ORDER_SHIPPING_METHOD_VIRTUAL = 32767;
displayLookup['ORDER_SHIPPING_METHOD.32767'] = "virtual";
colorLookup['ORDER_SHIPPING_METHOD.32767'] = "#66bb6a";
colorNameLookup['ORDER_SHIPPING_METHOD.32767'] = "GREEN";

constants.ORDER_SOURCE = {
  LOCAL: { color: "#64b5f6", label: true, value: 1 },
  WEBSHOP: { color: "#64b5f6", label: true, value: 50 },
  SHOP: { color: "#66bb6a", label: true, value: 100 },
  EDI: { color: "#64b5f6", label: true, value: 150 }
};
constants.ORDER_SOURCE_LOCAL = 1;
displayLookup['ORDER_SOURCE.1'] = "local";
colorLookup['ORDER_SOURCE.1'] = "#64b5f6";
colorNameLookup['ORDER_SOURCE.1'] = "BLUE";
constants.ORDER_SOURCE_WEBSHOP = 50;
displayLookup['ORDER_SOURCE.50'] = "webshop";
colorLookup['ORDER_SOURCE.50'] = "#64b5f6";
colorNameLookup['ORDER_SOURCE.50'] = "BLUE";
constants.ORDER_SOURCE_SHOP = 100;
displayLookup['ORDER_SOURCE.100'] = "shop";
colorLookup['ORDER_SOURCE.100'] = "#66bb6a";
colorNameLookup['ORDER_SOURCE.100'] = "GREEN";
constants.ORDER_SOURCE_EDI = 150;
displayLookup['ORDER_SOURCE.150'] = "edi";
colorLookup['ORDER_SOURCE.150'] = "#64b5f6";
colorNameLookup['ORDER_SOURCE.150'] = "BLUE";

constants.ORDER_STATUS = {
  TO_CONFIRM: { color: "#e57373", label: true, value: 1 },
  CONFIRMED: { color: "#e57373", label: true, value: 40 },
  READY_TO_PACK: { color: "#64b5f6", label: true, value: 50 },
  PICKING: { color: "#64b5f6", label: "picking in progress", value: 60 },
  PICKED: { color: "#162256", label: true, value: 70 },
  WAITING_FOR_LOCAL_PICKUP: { color: "#ffb74d", label: true, value: 80 },
  DURING_DELIVERY: { color: "#ffb74d", label: true, value: 100 },
  DELIVERED: { color: "#ffb74d", label: true, value: 110 },
  RETURN_REQUESTED: { color: "#e57373", label: true, value: 150 },
  COMPLETED: { color: "#66bb6a", label: true, value: 200 },
  CANCELLED: { color: "#e57373", label: true, value: 500 }
};
constants.ORDER_STATUS_TO_CONFIRM = 1;
displayLookup['ORDER_STATUS.1'] = "to confirm";
colorLookup['ORDER_STATUS.1'] = "#e57373";
colorNameLookup['ORDER_STATUS.1'] = "RED";
constants.ORDER_STATUS_CONFIRMED = 40;
displayLookup['ORDER_STATUS.40'] = "confirmed";
colorLookup['ORDER_STATUS.40'] = "#e57373";
colorNameLookup['ORDER_STATUS.40'] = "RED";
constants.ORDER_STATUS_READY_TO_PACK = 50;
displayLookup['ORDER_STATUS.50'] = "ready to pack";
colorLookup['ORDER_STATUS.50'] = "#64b5f6";
colorNameLookup['ORDER_STATUS.50'] = "BLUE";
constants.ORDER_STATUS_PICKING = 60;
displayLookup['ORDER_STATUS.60'] = "picking in progress";
colorLookup['ORDER_STATUS.60'] = "#64b5f6";
colorNameLookup['ORDER_STATUS.60'] = "BLUE";
constants.ORDER_STATUS_PICKED = 70;
displayLookup['ORDER_STATUS.70'] = "picked";
colorLookup['ORDER_STATUS.70'] = "#162256";
colorNameLookup['ORDER_STATUS.70'] = "DARK_BLUE";
constants.ORDER_STATUS_WAITING_FOR_LOCAL_PICKUP = 80;
displayLookup['ORDER_STATUS.80'] = "waiting for local pickup";
colorLookup['ORDER_STATUS.80'] = "#ffb74d";
colorNameLookup['ORDER_STATUS.80'] = "YELLOW";
constants.ORDER_STATUS_DURING_DELIVERY = 100;
displayLookup['ORDER_STATUS.100'] = "during delivery";
colorLookup['ORDER_STATUS.100'] = "#ffb74d";
colorNameLookup['ORDER_STATUS.100'] = "YELLOW";
constants.ORDER_STATUS_DELIVERED = 110;
displayLookup['ORDER_STATUS.110'] = "delivered";
colorLookup['ORDER_STATUS.110'] = "#ffb74d";
colorNameLookup['ORDER_STATUS.110'] = "YELLOW";
constants.ORDER_STATUS_RETURN_REQUESTED = 150;
displayLookup['ORDER_STATUS.150'] = "return requested";
colorLookup['ORDER_STATUS.150'] = "#e57373";
colorNameLookup['ORDER_STATUS.150'] = "RED";
constants.ORDER_STATUS_COMPLETED = 200;
displayLookup['ORDER_STATUS.200'] = "completed";
colorLookup['ORDER_STATUS.200'] = "#66bb6a";
colorNameLookup['ORDER_STATUS.200'] = "GREEN";
constants.ORDER_STATUS_CANCELLED = 500;
displayLookup['ORDER_STATUS.500'] = "cancelled";
colorLookup['ORDER_STATUS.500'] = "#e57373";
colorNameLookup['ORDER_STATUS.500'] = "RED";

constants.ORDER_STOCK_TRANSFER_MODE = {
  ALL_PRODUCTS: { color: null, label: true, value: 1 },
  MISSING_PRODUCTS: { color: null, label: true, value: 2 }
};
constants.ORDER_STOCK_TRANSFER_MODE_ALL_PRODUCTS = 1;
displayLookup['ORDER_STOCK_TRANSFER_MODE.1'] = "all products";
constants.ORDER_STOCK_TRANSFER_MODE_MISSING_PRODUCTS = 2;
displayLookup['ORDER_STOCK_TRANSFER_MODE.2'] = "missing products";

constants.ORDER_SYNC_TYPE = {
  NORMAL: { color: null, label: "Normal sync", value: 1 },
  REVERSE: { color: null, label: "Reverse sync", value: 2 },
  LAST_MODIFIED: { color: null, label: true, value: 3 }
};
constants.ORDER_SYNC_TYPE_NORMAL = 1;
displayLookup['ORDER_SYNC_TYPE.1'] = "Normal sync";
constants.ORDER_SYNC_TYPE_REVERSE = 2;
displayLookup['ORDER_SYNC_TYPE.2'] = "Reverse sync";
constants.ORDER_SYNC_TYPE_LAST_MODIFIED = 3;
displayLookup['ORDER_SYNC_TYPE.3'] = "last modified";

constants.ORDER_TYPE = {
  NORMAL: { color: null, label: true, value: 1 },
  CORRECTION: { color: null, label: true, value: 50 },
  RETURN: { color: null, label: true, value: 100 },
  REPLACEMENT: { color: null, label: true, value: 150 }
};
constants.ORDER_TYPE_NORMAL = 1;
displayLookup['ORDER_TYPE.1'] = "normal";
constants.ORDER_TYPE_CORRECTION = 50;
displayLookup['ORDER_TYPE.50'] = "correction";
constants.ORDER_TYPE_RETURN = 100;
displayLookup['ORDER_TYPE.100'] = "return";
constants.ORDER_TYPE_REPLACEMENT = 150;
displayLookup['ORDER_TYPE.150'] = "replacement";

constants.ORGANIZATION_CONFIGURATION_ISSUE_CODE = {
  MISSING_INITIAL_INVENTORY_VALUE: { color: null, label: true, value: 1 },
  MISSING_WEBSHOP: { color: null, label: true, value: 2 },
  MISSING_WORKDAYS: { color: null, label: true, value: 3 },
  MISSING_DEFAULT_PRICE_LIST: { color: null, label: true, value: 4 },
  MISSING_DEFAULT_SALE_PRICE_LIST: { color: null, label: true, value: 5 },
  MISSING_MINI_CRM_CONFIG: { color: null, label: "missing miniCRM config", value: 6 },
  MISSING_INVENTORY_PLANNER_CONFIG: { color: null, label: true, value: 7 },
  MISSING_WEBSHOP_CREDENTIALS: { color: null, label: true, value: 8 },
  CURRENCY_EXCHANGE_RATES: { color: null, label: "Make sure that you configure the exchange rate of each currency", value: 9 },
  SHOPRENTER_MAPPINGS: { color: null, label: "Please check django admin to configure (and set active status) for new mappings!", value: 10 },
  INVALID_WAREHOUSE_OPERATION_SUGGESTION_MODE: { color: null, label: "Please check django admin to configure a valid suggestion mode!", value: 11 },
  INVALID_FORMULA_DEPS: { color: null, label: "Your price lists and formulas contains cyclical dependencies", value: 12 },
  INVALID_MESSAGE_RULE_XPRESSION: { color: null, label: "Message sending rules are not configured properly", value: 13 },
  INVALID_ORDER_TASK_TYPE_TO_CREATE_FOR_WRONG_TAX_NUMBER: { color: null, label: "No task type found with the given id", value: 14 },
  INVALID_ORDER_TASK_TYPE_TO_CREATE_FOR_WRONG_PHONE_NUMBER: { color: null, label: "No task type found with the given id", value: 15 }
};
constants.ORGANIZATION_CONFIGURATION_ISSUE_CODE_MISSING_INITIAL_INVENTORY_VALUE = 1;
displayLookup['ORGANIZATION_CONFIGURATION_ISSUE_CODE.1'] = "missing initial inventory value";
constants.ORGANIZATION_CONFIGURATION_ISSUE_CODE_MISSING_WEBSHOP = 2;
displayLookup['ORGANIZATION_CONFIGURATION_ISSUE_CODE.2'] = "missing webshop";
constants.ORGANIZATION_CONFIGURATION_ISSUE_CODE_MISSING_WORKDAYS = 3;
displayLookup['ORGANIZATION_CONFIGURATION_ISSUE_CODE.3'] = "missing workdays";
constants.ORGANIZATION_CONFIGURATION_ISSUE_CODE_MISSING_DEFAULT_PRICE_LIST = 4;
displayLookup['ORGANIZATION_CONFIGURATION_ISSUE_CODE.4'] = "missing default price list";
constants.ORGANIZATION_CONFIGURATION_ISSUE_CODE_MISSING_DEFAULT_SALE_PRICE_LIST = 5;
displayLookup['ORGANIZATION_CONFIGURATION_ISSUE_CODE.5'] = "missing default sale price list";
constants.ORGANIZATION_CONFIGURATION_ISSUE_CODE_MISSING_MINI_CRM_CONFIG = 6;
displayLookup['ORGANIZATION_CONFIGURATION_ISSUE_CODE.6'] = "missing miniCRM config";
constants.ORGANIZATION_CONFIGURATION_ISSUE_CODE_MISSING_INVENTORY_PLANNER_CONFIG = 7;
displayLookup['ORGANIZATION_CONFIGURATION_ISSUE_CODE.7'] = "missing inventory planner config";
constants.ORGANIZATION_CONFIGURATION_ISSUE_CODE_MISSING_WEBSHOP_CREDENTIALS = 8;
displayLookup['ORGANIZATION_CONFIGURATION_ISSUE_CODE.8'] = "missing webshop credentials";
constants.ORGANIZATION_CONFIGURATION_ISSUE_CODE_CURRENCY_EXCHANGE_RATES = 9;
displayLookup['ORGANIZATION_CONFIGURATION_ISSUE_CODE.9'] = "Make sure that you configure the exchange rate of each currency";
constants.ORGANIZATION_CONFIGURATION_ISSUE_CODE_SHOPRENTER_MAPPINGS = 10;
displayLookup['ORGANIZATION_CONFIGURATION_ISSUE_CODE.10'] = "Please check django admin to configure (and set active status) for new mappings!";
constants.ORGANIZATION_CONFIGURATION_ISSUE_CODE_INVALID_WAREHOUSE_OPERATION_SUGGESTION_MODE = 11;
displayLookup['ORGANIZATION_CONFIGURATION_ISSUE_CODE.11'] = "Please check django admin to configure a valid suggestion mode!";
constants.ORGANIZATION_CONFIGURATION_ISSUE_CODE_INVALID_FORMULA_DEPS = 12;
displayLookup['ORGANIZATION_CONFIGURATION_ISSUE_CODE.12'] = "Your price lists and formulas contains cyclical dependencies";
constants.ORGANIZATION_CONFIGURATION_ISSUE_CODE_INVALID_MESSAGE_RULE_XPRESSION = 13;
displayLookup['ORGANIZATION_CONFIGURATION_ISSUE_CODE.13'] = "Message sending rules are not configured properly";
constants.ORGANIZATION_CONFIGURATION_ISSUE_CODE_INVALID_ORDER_TASK_TYPE_TO_CREATE_FOR_WRONG_TAX_NUMBER = 14;
displayLookup['ORGANIZATION_CONFIGURATION_ISSUE_CODE.14'] = "No task type found with the given id";
constants.ORGANIZATION_CONFIGURATION_ISSUE_CODE_INVALID_ORDER_TASK_TYPE_TO_CREATE_FOR_WRONG_PHONE_NUMBER = 15;
displayLookup['ORGANIZATION_CONFIGURATION_ISSUE_CODE.15'] = "No task type found with the given id";

constants.ORGANIZATION_FILE_STORAGE = {
  FILE_SYSTEM: { color: null, label: [true], value: "file_system" },
  AWS_S3: { color: null, label: [true], value: "aws_s3" },
  VSHOSTING_MINIO: { color: null, label: [true], value: "vshosting_minio" }
};
constants.ORGANIZATION_FILE_STORAGE_FILE_SYSTEM = "file_system";
displayLookup['ORGANIZATION_FILE_STORAGE."file_system"'] = ["organization file storage", "file system"];
constants.ORGANIZATION_FILE_STORAGE_AWS_S3 = "aws_s3";
displayLookup['ORGANIZATION_FILE_STORAGE."aws_s3"'] = ["organization file storage", "aws s3"];
constants.ORGANIZATION_FILE_STORAGE_VSHOSTING_MINIO = "vshosting_minio";
displayLookup['ORGANIZATION_FILE_STORAGE."vshosting_minio"'] = ["organization file storage", "vshosting minio"];

constants.ORGANIZATION_FULFILLMENT_COMPANY = {
  WEBSHOPIRODA: { color: null, label: true, value: "webshopiroda" },
  ECOLOG: { color: null, label: true, value: "ecolog" }
};
constants.ORGANIZATION_FULFILLMENT_COMPANY_WEBSHOPIRODA = "webshopiroda";
displayLookup['ORGANIZATION_FULFILLMENT_COMPANY."webshopiroda"'] = "webshopiroda";
constants.ORGANIZATION_FULFILLMENT_COMPANY_ECOLOG = "ecolog";
displayLookup['ORGANIZATION_FULFILLMENT_COMPANY."ecolog"'] = "ecolog";

constants.ORGANIZATION_PRODUCT = {
  CLOUDERP: { color: null, label: true, value: "clouderp" },
  PROFITDRIVE: { color: null, label: true, value: "profitdrive" }
};
constants.ORGANIZATION_PRODUCT_CLOUDERP = "clouderp";
displayLookup['ORGANIZATION_PRODUCT."clouderp"'] = "clouderp";
constants.ORGANIZATION_PRODUCT_PROFITDRIVE = "profitdrive";
displayLookup['ORGANIZATION_PRODUCT."profitdrive"'] = "profitdrive";

constants.ORGANIZATION_STATUS = {
  SALES: { color: null, label: [true], value: "sales" },
  UNDER_IMPLEMENTATION: { color: null, label: [true], value: "under_implementation" },
  ACTIVE: { color: null, label: [true], value: "active" },
  CHURNED: { color: null, label: [true], value: "churned" }
};
constants.ORGANIZATION_STATUS_SALES = "sales";
displayLookup['ORGANIZATION_STATUS."sales"'] = ["organization status", "sales"];
constants.ORGANIZATION_STATUS_UNDER_IMPLEMENTATION = "under_implementation";
displayLookup['ORGANIZATION_STATUS."under_implementation"'] = ["organization status", "under implementation"];
constants.ORGANIZATION_STATUS_ACTIVE = "active";
displayLookup['ORGANIZATION_STATUS."active"'] = ["organization status", "active"];
constants.ORGANIZATION_STATUS_CHURNED = "churned";
displayLookup['ORGANIZATION_STATUS."churned"'] = ["organization status", "churned"];

constants.ORGANIZATION_VERSION_UPGRADE_STATUS = {
  PENDING: { color: "#e5e5e5", label: [true], value: 1 },
  IN_PROGRESS: { color: "#ffb74d", label: [true], value: 50 },
  SUCCESS: { color: "#66bb6a", label: [true], value: 200 },
  DEADLINE_EXCEEDED: { color: "#e57373", label: [true], value: 500 },
  MAX_RETRIES_EXCEEDED: { color: "#e57373", label: [true], value: 501 },
  MAX_DEADLOCK_RETRIES_EXCEEDED: { color: "#e57373", label: [true], value: 502 }
};
constants.ORGANIZATION_VERSION_UPGRADE_STATUS_PENDING = 1;
displayLookup['ORGANIZATION_VERSION_UPGRADE_STATUS.1'] = ["organization version upgrade status", "pending"];
colorLookup['ORGANIZATION_VERSION_UPGRADE_STATUS.1'] = "#e5e5e5";
colorNameLookup['ORGANIZATION_VERSION_UPGRADE_STATUS.1'] = "GREY";
constants.ORGANIZATION_VERSION_UPGRADE_STATUS_IN_PROGRESS = 50;
displayLookup['ORGANIZATION_VERSION_UPGRADE_STATUS.50'] = ["organization version upgrade status", "in progress"];
colorLookup['ORGANIZATION_VERSION_UPGRADE_STATUS.50'] = "#ffb74d";
colorNameLookup['ORGANIZATION_VERSION_UPGRADE_STATUS.50'] = "YELLOW";
constants.ORGANIZATION_VERSION_UPGRADE_STATUS_SUCCESS = 200;
displayLookup['ORGANIZATION_VERSION_UPGRADE_STATUS.200'] = ["organization version upgrade status", "success"];
colorLookup['ORGANIZATION_VERSION_UPGRADE_STATUS.200'] = "#66bb6a";
colorNameLookup['ORGANIZATION_VERSION_UPGRADE_STATUS.200'] = "GREEN";
constants.ORGANIZATION_VERSION_UPGRADE_STATUS_DEADLINE_EXCEEDED = 500;
displayLookup['ORGANIZATION_VERSION_UPGRADE_STATUS.500'] = ["organization version upgrade status", "deadline exceeded"];
colorLookup['ORGANIZATION_VERSION_UPGRADE_STATUS.500'] = "#e57373";
colorNameLookup['ORGANIZATION_VERSION_UPGRADE_STATUS.500'] = "RED";
constants.ORGANIZATION_VERSION_UPGRADE_STATUS_MAX_RETRIES_EXCEEDED = 501;
displayLookup['ORGANIZATION_VERSION_UPGRADE_STATUS.501'] = ["organization version upgrade status", "max retries exceeded"];
colorLookup['ORGANIZATION_VERSION_UPGRADE_STATUS.501'] = "#e57373";
colorNameLookup['ORGANIZATION_VERSION_UPGRADE_STATUS.501'] = "RED";
constants.ORGANIZATION_VERSION_UPGRADE_STATUS_MAX_DEADLOCK_RETRIES_EXCEEDED = 502;
displayLookup['ORGANIZATION_VERSION_UPGRADE_STATUS.502'] = ["organization version upgrade status", "max deadlock retries exceeded"];
colorLookup['ORGANIZATION_VERSION_UPGRADE_STATUS.502'] = "#e57373";
colorNameLookup['ORGANIZATION_VERSION_UPGRADE_STATUS.502'] = "RED";

constants.PACKETA_COURIER_IDENTIFIER = {
  HOME_DELIVERY: { color: null, label: true, value: 4159 },
  DPD: { color: null, label: true, value: 805 },
  EXPRESS_ONE: { color: null, label: true, value: 151 },
  HUNGARIAN_POST: { color: null, label: true, value: 763 }
};
constants.PACKETA_COURIER_IDENTIFIER_HOME_DELIVERY = 4159;
displayLookup['PACKETA_COURIER_IDENTIFIER.4159'] = "home delivery";
constants.PACKETA_COURIER_IDENTIFIER_DPD = 805;
displayLookup['PACKETA_COURIER_IDENTIFIER.805'] = "dpd";
constants.PACKETA_COURIER_IDENTIFIER_EXPRESS_ONE = 151;
displayLookup['PACKETA_COURIER_IDENTIFIER.151'] = "express one";
constants.PACKETA_COURIER_IDENTIFIER_HUNGARIAN_POST = 763;
displayLookup['PACKETA_COURIER_IDENTIFIER.763'] = "hungarian post";

constants.PACKETA_LABEL_FORMAT = {
  A6_ON_A6: { color: null, label: true, value: "A6 on A6" },
  A7_ON_A7: { color: null, label: true, value: "A7 on A7" },
  A6_ON_A4: { color: null, label: true, value: "A6 on A4" },
  A7_ON_A4: { color: null, label: true, value: "A7 on A4" },
  X105_X_35_MM_ON_A4: { color: null, label: "105x35mm on A4", value: "105x35mm on A4" },
  A8_ON_A8: { color: null, label: true, value: "A8 on A8" }
};
constants.PACKETA_LABEL_FORMAT_A6_ON_A6 = "A6 on A6";
displayLookup['PACKETA_LABEL_FORMAT."A6 on A6"'] = "a6 on a6";
constants.PACKETA_LABEL_FORMAT_A7_ON_A7 = "A7 on A7";
displayLookup['PACKETA_LABEL_FORMAT."A7 on A7"'] = "a7 on a7";
constants.PACKETA_LABEL_FORMAT_A6_ON_A4 = "A6 on A4";
displayLookup['PACKETA_LABEL_FORMAT."A6 on A4"'] = "a6 on a4";
constants.PACKETA_LABEL_FORMAT_A7_ON_A4 = "A7 on A4";
displayLookup['PACKETA_LABEL_FORMAT."A7 on A4"'] = "a7 on a4";
constants.PACKETA_LABEL_FORMAT_X105_X_35_MM_ON_A4 = "105x35mm on A4";
displayLookup['PACKETA_LABEL_FORMAT."105x35mm on A4"'] = "105x35mm on A4";
constants.PACKETA_LABEL_FORMAT_A8_ON_A8 = "A8 on A8";
displayLookup['PACKETA_LABEL_FORMAT."A8 on A8"'] = "a8 on a8";

constants.PACTIC_PACKAGE_TYPE = {
  PARCEL: { color: null, label: true, value: "PARCEL" },
  DOCUMENT: { color: null, label: true, value: "DOCUMENT" },
  PALLET: { color: null, label: true, value: "PALLET" }
};
constants.PACTIC_PACKAGE_TYPE_PARCEL = "PARCEL";
displayLookup['PACTIC_PACKAGE_TYPE."PARCEL"'] = "parcel";
constants.PACTIC_PACKAGE_TYPE_DOCUMENT = "DOCUMENT";
displayLookup['PACTIC_PACKAGE_TYPE."DOCUMENT"'] = "document";
constants.PACTIC_PACKAGE_TYPE_PALLET = "PALLET";
displayLookup['PACTIC_PACKAGE_TYPE."PALLET"'] = "pallet";

constants.PACTIC_SERVICE_TYPE = {
  DPD_BUSINESS_HOME_DELIVERY: { color: null, label: "Pactic - DPD Business Home Delivery", value: "9-6" },
  DPD_ROMANIA_CROSS_BORDER: { color: null, label: "DPD Romania Cross-border", value: "9-9" },
  DPD_ROMANIA_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "DPD Romania Cross-border Direct inj.", value: "9-10" },
  DPD_AUSTRIA_CROSS_BORDER: { color: null, label: "DPD Austria Cross-border", value: "16-1" },
  DPD_AUSTRIA_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "DPD Austria Cross-border Direct Injection", value: "16-7" },
  ACS_GREECE_CROSS_BORDER: { color: null, label: "ACS Greece Cross-border", value: "17-3" },
  ECONT_BULGARIA_CROSS_BORDER: { color: null, label: "Econt Bulgaria Cross-border", value: "17-5" },
  ECONT_BULGARIA_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "Econt Bulgaria Cross-border Direct Injection", value: "17-6" },
  ACS_GREECE_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "ACS Greece Cross-border Direct Injection", value: "17-11" },
  ECONT_BULGARIA_PARCELSHOP_CROSS_BORDER: { color: null, label: "Econt Bulgaria ParcelShop Cross-border", value: "17-13" },
  ECONT_BULGARIA_PUDO_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "Econt Bulgaria PUDO Cross-border Direct Injection", value: "17-15" },
  SPEEDEX_GREECE_CROSS_BORDER: { color: null, label: "Speedex Greece Cross-border", value: "17-16" },
  SPEEDEX_GREECE_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "Speedex Greece Cross-border Direct Injection", value: "17-17" },
  GENIKI_GREECE_CROSS_BORDER: { color: null, label: "Geniki Greece Cross-border", value: "17-18" },
  GENIKI_GREECE_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "Geniki Greece Cross-border Direct Injection", value: "17-20" },
  BIZ_GREECE_CROSS_BORDER: { color: null, label: "BIZ Greece Cross-border", value: "18-1" },
  INPOST_POLAND_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "InPost Poland Cross-border Direct Injection", value: "20-1" },
  INPOST_POLAND_CROSS_BORDER: { color: null, label: "InPost Poland Cross-border", value: "20-2" },
  INPOST_POLAND_LOCKER_CROSS_BORDER: { color: null, label: "InPost Poland Locker Cross-border", value: "20-4" },
  INPOST_POLAND_LOCKER_CROSS_BORDER_INJECTION: { color: null, label: "InPost Poland Locker Cross-border injection", value: "20-5" },
  URGENTCARGUS_CROSS_BORDER: { color: null, label: "UrgentCargus Cross-border", value: "23-3" },
  URGENTCARGUS_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "UrgentCargus Cross-border Direct Injection", value: "23-4" },
  WEDO_CZECH_REPUBLIC_CROSS_BORDER: { color: null, label: "WE|DO Czech Republic Cross-border", value: "28-1" },
  WEDO_CZECH_REPUBLIC_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "WE|DO Czech Republic Cross-border Direct Injection", value: "28-2" },
  SLOVAK_POST_CROSS_BORDER: { color: null, label: "Slovak Post Cross-border", value: "30-1" },
  SLOVAK_POST_CROSS_BORDER_PUDO: { color: null, label: "Slovak Post Cross-border PuDo", value: "30-3" },
  MPL_BUSINESS_POST_POINT: { color: null, label: "Pactic - MPL Post Point", value: "31-2" },
  B2C_EUROPE_CROSS_BORDER: { color: null, label: "B2C Europe Cross-border", value: "32-1" },
  B2C_EUROPE_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "B2C Europe Cross-border direct injection", value: "32-2" },
  DHL_GERMANY_CROSS_BORDER: { color: null, label: "DHL Germany Cross-border", value: "33-1" },
  DHL_GERMANY_CROSS_BORDER_PAKETSHOP: { color: null, label: "DHL Germany Cross-border paketshop", value: "33-2" },
  PPL_CZECH_CROSS_BORDER: { color: null, label: "PPL Czech Cross-border", value: "35-1" },
  PPL_CZECH_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "PPL Czech Cross-border direct Injection", value: "35-2" },
  PPL_CZECH_CROSS_BORDER_PUDO: { color: null, label: "PPL Czech Cross-border PuDo", value: "35-3" },
  PPL_CZECH_CROSS_BORDER_PUDO_DIRECT_INJECTION: { color: null, label: "PPL Czech Cross-border PuDo Direct Injection", value: "35-4" },
  PPL_CZECH_PUDO_RETURN: { color: null, label: "PPL Czech PuDo Return", value: "35-5" },
  HERMES_GERMANY_CROSS_BORDER: { color: null, label: "Hermes Germany Cross-border", value: "37-1" },
  SPRING_CROSS_BORDER_EU_DESTINATIONS: { color: null, label: "Spring Cross-border EU destinations", value: "37-2" },
  CROATIA_POST_CROSS_BORDER: { color: null, label: "Croatia Post Cross-border", value: "39-1" },
  CROATIA_POST_CROSS_BORDER_PUDO: { color: null, label: "Croatia Post Cross-border PUDO", value: "39-2" },
  CROATIA_POST_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "Croatia Post Cross-border Direct inj.", value: "39-3" },
  CROATIA_POST_CROSS_BORDER_PUDO_DIRECT_INJECTION: { color: null, label: "Croatia Post Cross-border PUDO D. inj.", value: "39-4" },
  CZECH_POST_CROSS_BORDER: { color: null, label: "Czech Post Cross-border", value: "40-1" },
  CZECH_POST_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "Czech Post Cross-border Dir. Inj.", value: "40-3" },
  GLS_HUNGARY_PICK_AND_SHIP_DOMESTIC: { color: null, label: "Pactic - GLS Hungary Pick & Ship Domestic", value: "2-1" },
  GLS_HUNGARY_CROSS_BORDER_PUDO_DIRECT_INJECTION: { color: null, label: "GLS Hungary Cross-border PUDO Direct injection", value: "2-8" },
  GLS_HUNGARY_CROSS_BORDER_PUDO: { color: null, label: "GLS Hungary Cross-border PUDO", value: "2-10" },
  GLS_HUNGARY_CROSS_BORDER: { color: null, label: "GLS Hungary Cross-border", value: "2-23" },
  GLS_HUNGARY_EXCHANGE: { color: null, label: "Pactic - GLS Hungary Exchange Service", value: "2-27" },
  GLS_ROMANIA_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "GLS Romania Cross-border Direct Injection", value: "2-9" },
  GLS_ROMANIA_CROSS_BORDER: { color: null, label: "GLS Romania Cross-border", value: "2-7" },
  GLS_ROMANIA_EXCHANGE_SERVICE: { color: null, label: "GLS Romania Exchange Service", value: "2-11" },
  GLS_CROSS_BORDER_DIRECT: { color: null, label: "Pactic - GLS Cross-border Direct", value: "2-12" },
  GLS_BUSINESS_HOME_DELIVERY: { color: null, label: "Pactic - GLS Business Home Delivery", value: "2-13" },
  GLS_BUSINESS_PICKUP_POINT: { color: null, label: "Pactic - GLS Business PickUp Point", value: "2-14" },
  GLS_SLOVENIA_CROSS_BORDER: { color: null, label: "GLS Slovenia Cross-border", value: "2-22" },
  GLS_CZECH_REPUBLIC_CROSS_BORDER: { color: null, label: "GLS Czech Republic Cross-border", value: "2-26" },
  GLS_SLOVENIA_DIRECT_INJECTION: { color: null, label: "GLS Slovenia Direct Injection", value: "2-28" },
  GLS_CROATIA_CROSS_BORDER: { color: null, label: "GLS Croatia Cross-border", value: "2-34" },
  GLS_CROATIA_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "GLS Croatia Cross-border Direct Injection", value: "2-35" },
  GLS_CROATIA_PICK_AND_RETURN: { color: null, label: "GLS Croatia Pick and Return", value: "2-37" },
  GLS_SLOVENIA_PICK_AND_RETURN: { color: null, label: "GLS Slovenia Pick and Return", value: "2-38" },
  GLS_SLOVENIA_PUDO: { color: null, label: "GLS Slovenia PUDO", value: "2-39" },
  GLS_SLOVENIA_PUDO_DIRECT_INJECTION: { color: null, label: "GLS Slovenia PUDO Direct Injection", value: "2-40" },
  GLS_SLOVAKIA_CROSS_BORDER: { color: null, label: "GLS Slovakia Cross-border", value: "2-41" },
  GLS_SLOVAKIA_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "GLS Slovakia Cross-border Direct Injection", value: "2-42" },
  GLS_SLOVAKIA_CROSS_BORDER_PUDO: { color: null, label: "GLS Slovakia Cross-border PUDO", value: "2-43" },
  GLS_SLOVAKIA_CROSS_BORDER_PUDO_DIRECT_INJECTION: { color: null, label: "GLS Slovakia Cross-border PUDO Direct Injection", value: "2-44" },
  GLS_SLOVAKIA_EXCHANGE_SERVICE: { color: null, label: "GLS Slovakia Exchange Service", value: "2-45" },
  GLS_SLOVAKIA_PICK_RETURN: { color: null, label: "GLS Slovakia Pick & Return", value: "2-46" },
  GLS_CROATIA_PUDO: { color: null, label: "GLS Croatia PUDO", value: "2-47" },
  GLS_CROATIA_PUDO_DIRECT_INJECTION: { color: null, label: "GLS Croatia PUDO Direct Injection", value: "2-48" },
  GLS_AUSTRIA_CROSS_BORDER: { color: null, label: "GLS Austria Cross-border", value: "29-1" },
  GLS_AUSTRIA_PUDO_CROSS_BORDER: { color: null, label: "GLS Austria PuDo Cross-border", value: "29-2" },
  GLS_ITALY_CROSS_BORDER: { color: null, label: "GLS Italy Cross-border", value: "34-1" },
  GLS_ITALY_PUDO_CROSS_BORDER: { color: null, label: "GLS Italy Cross-border PuDo", value: "34-2" },
  GLS_ITALY_PICK_AND_RETURN: { color: null, label: "GLS Italy Pick and Return", value: "34-4" },
  GLS_POLAND_CROSS_BORDER: { color: null, label: "GLS Poland Cross-border", value: "36-1" },
  GLS_POLAND_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "GLS Poland Cross-border Direct Injection", value: "36-2" },
  GLS_POLAND_CROSS_BORDER_PUDO: { color: null, label: "GLS Poland Cross-border PuDo", value: "36-3" },
  GLS_POLAND_CROSS_BORDER_PUDO_DIRECT_INJECTION: { color: null, label: "GLS Poland Cross-border PuDo Direct Injection", value: "36-4" },
  GLS_POLAND_PICK_RETURN: { color: null, label: "GLS Poland Pick & Return", value: "36-5" },
  SAMEDAY_HUNGARY_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "Sameday Hungary Cross-border Direct Injection", value: "24-3" },
  SAMEDAY_HUNGARY_EASYBOX_DIRECT_INJECTION: { color: null, label: "Sameday Hungary Easybox Direct Injection", value: "24-4" },
  SAMEDAY_HUNGARY_CROSS_BORDER: { color: null, label: "Sameday Hungary Cross-border", value: "24-5" },
  SAMEDAY_HUNGARY_CROSS_BORDER_EASYBOX: { color: null, label: "Sameday Hungary Cross-border Easybox", value: "24-6" },
  PACKETA_HUNGARY_PUDO: { color: null, label: "Packeta Hungary PuDo", value: "26-2" },
  SAMEDAY_ROMANIA_PUDO_DIRECT_INJECTION: { color: null, label: "SameDay Romania PuDo Direct Injection", value: "24-7" },
  SAMEDAY_BULGARIA_CROSS_BORDER: { color: null, label: "Sameday Bulgaria Cross-border", value: "17-7" },
  SAMEDAY_BULGARIA_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "Sameday Bulgaria Cross-border Direct Injection", value: "17-8" },
  EXPRESSONE_CROSS_BORDER_DOMESTIC: { color: null, label: "ExpressOne Cross-border Domestic", value: "27-1" },
  EXPRESSONE_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "ExpressOne Cross-border Direct Injection", value: "27-2" },
  MPL_BUSINESS_PICKUP_POINT: { color: null, label: "Pactic - MPL PickUp Point", value: "31-4" },
  MPL_HUNGARY_CROSS_BORDER: { color: null, label: "MPL Hungary Cross-border", value: "31-6" },
  MPL_HUNGARY_CROSS_BORDER_PUDO_DIR_INJ: { color: null, label: "MPL Hungary Cross-border PUDO Dir. Inj.", value: "31-7" },
  MPL_HUNGARY_CROSS_BORDER_PUDO: { color: null, label: "MPL Hungary Cross-border PUDO", value: "31-8" },
  MPL_BUSINESS_MANIFEST: { color: null, label: "MPL Business Manifest", value: "31-52" },
  MPL_BUSINESS_PUDO_MANIFEST: { color: null, label: "MPL Business PuDo Manifest", value: "31-54" },
  MPL_HUNGARY_CROSS_BORDER_MANIFEST: { color: null, label: "MPL Hungary Cross-border Manifest", value: "31-56" },
  MPL_HUNGARY_CROSS_BORDER_PUDO_DIR_INJ_MANIFEST: { color: null, label: "MPL Hungary Cross-border PUDO Dir Inj Manifest", value: "31-57" },
  MPL_HUNGARY_CROSS_BORDER_PUDO_MANIFEST: { color: null, label: "MPL Hungary Cross-border PUDO Manifest", value: "31-58" },
  DPD_ROMANIA_CLASSIC_BUSINESS_DOMESTIC: { color: null, label: "DPD Romania Classic Business Domestic", value: "9-4" }
};
constants.PACTIC_SERVICE_TYPE_DPD_BUSINESS_HOME_DELIVERY = "9-6";
displayLookup['PACTIC_SERVICE_TYPE."9-6"'] = "Pactic - DPD Business Home Delivery";
constants.PACTIC_SERVICE_TYPE_DPD_ROMANIA_CROSS_BORDER = "9-9";
displayLookup['PACTIC_SERVICE_TYPE."9-9"'] = "DPD Romania Cross-border";
constants.PACTIC_SERVICE_TYPE_DPD_ROMANIA_CROSS_BORDER_DIRECT_INJECTION = "9-10";
displayLookup['PACTIC_SERVICE_TYPE."9-10"'] = "DPD Romania Cross-border Direct inj.";
constants.PACTIC_SERVICE_TYPE_DPD_AUSTRIA_CROSS_BORDER = "16-1";
displayLookup['PACTIC_SERVICE_TYPE."16-1"'] = "DPD Austria Cross-border";
constants.PACTIC_SERVICE_TYPE_DPD_AUSTRIA_CROSS_BORDER_DIRECT_INJECTION = "16-7";
displayLookup['PACTIC_SERVICE_TYPE."16-7"'] = "DPD Austria Cross-border Direct Injection";
constants.PACTIC_SERVICE_TYPE_ACS_GREECE_CROSS_BORDER = "17-3";
displayLookup['PACTIC_SERVICE_TYPE."17-3"'] = "ACS Greece Cross-border";
constants.PACTIC_SERVICE_TYPE_ECONT_BULGARIA_CROSS_BORDER = "17-5";
displayLookup['PACTIC_SERVICE_TYPE."17-5"'] = "Econt Bulgaria Cross-border";
constants.PACTIC_SERVICE_TYPE_ECONT_BULGARIA_CROSS_BORDER_DIRECT_INJECTION = "17-6";
displayLookup['PACTIC_SERVICE_TYPE."17-6"'] = "Econt Bulgaria Cross-border Direct Injection";
constants.PACTIC_SERVICE_TYPE_ACS_GREECE_CROSS_BORDER_DIRECT_INJECTION = "17-11";
displayLookup['PACTIC_SERVICE_TYPE."17-11"'] = "ACS Greece Cross-border Direct Injection";
constants.PACTIC_SERVICE_TYPE_ECONT_BULGARIA_PARCELSHOP_CROSS_BORDER = "17-13";
displayLookup['PACTIC_SERVICE_TYPE."17-13"'] = "Econt Bulgaria ParcelShop Cross-border";
constants.PACTIC_SERVICE_TYPE_ECONT_BULGARIA_PUDO_CROSS_BORDER_DIRECT_INJECTION = "17-15";
displayLookup['PACTIC_SERVICE_TYPE."17-15"'] = "Econt Bulgaria PUDO Cross-border Direct Injection";
constants.PACTIC_SERVICE_TYPE_SPEEDEX_GREECE_CROSS_BORDER = "17-16";
displayLookup['PACTIC_SERVICE_TYPE."17-16"'] = "Speedex Greece Cross-border";
constants.PACTIC_SERVICE_TYPE_SPEEDEX_GREECE_CROSS_BORDER_DIRECT_INJECTION = "17-17";
displayLookup['PACTIC_SERVICE_TYPE."17-17"'] = "Speedex Greece Cross-border Direct Injection";
constants.PACTIC_SERVICE_TYPE_GENIKI_GREECE_CROSS_BORDER = "17-18";
displayLookup['PACTIC_SERVICE_TYPE."17-18"'] = "Geniki Greece Cross-border";
constants.PACTIC_SERVICE_TYPE_GENIKI_GREECE_CROSS_BORDER_DIRECT_INJECTION = "17-20";
displayLookup['PACTIC_SERVICE_TYPE."17-20"'] = "Geniki Greece Cross-border Direct Injection";
constants.PACTIC_SERVICE_TYPE_BIZ_GREECE_CROSS_BORDER = "18-1";
displayLookup['PACTIC_SERVICE_TYPE."18-1"'] = "BIZ Greece Cross-border";
constants.PACTIC_SERVICE_TYPE_INPOST_POLAND_CROSS_BORDER_DIRECT_INJECTION = "20-1";
displayLookup['PACTIC_SERVICE_TYPE."20-1"'] = "InPost Poland Cross-border Direct Injection";
constants.PACTIC_SERVICE_TYPE_INPOST_POLAND_CROSS_BORDER = "20-2";
displayLookup['PACTIC_SERVICE_TYPE."20-2"'] = "InPost Poland Cross-border";
constants.PACTIC_SERVICE_TYPE_INPOST_POLAND_LOCKER_CROSS_BORDER = "20-4";
displayLookup['PACTIC_SERVICE_TYPE."20-4"'] = "InPost Poland Locker Cross-border";
constants.PACTIC_SERVICE_TYPE_INPOST_POLAND_LOCKER_CROSS_BORDER_INJECTION = "20-5";
displayLookup['PACTIC_SERVICE_TYPE."20-5"'] = "InPost Poland Locker Cross-border injection";
constants.PACTIC_SERVICE_TYPE_URGENTCARGUS_CROSS_BORDER = "23-3";
displayLookup['PACTIC_SERVICE_TYPE."23-3"'] = "UrgentCargus Cross-border";
constants.PACTIC_SERVICE_TYPE_URGENTCARGUS_CROSS_BORDER_DIRECT_INJECTION = "23-4";
displayLookup['PACTIC_SERVICE_TYPE."23-4"'] = "UrgentCargus Cross-border Direct Injection";
constants.PACTIC_SERVICE_TYPE_WEDO_CZECH_REPUBLIC_CROSS_BORDER = "28-1";
displayLookup['PACTIC_SERVICE_TYPE."28-1"'] = "WE|DO Czech Republic Cross-border";
constants.PACTIC_SERVICE_TYPE_WEDO_CZECH_REPUBLIC_CROSS_BORDER_DIRECT_INJECTION = "28-2";
displayLookup['PACTIC_SERVICE_TYPE."28-2"'] = "WE|DO Czech Republic Cross-border Direct Injection";
constants.PACTIC_SERVICE_TYPE_SLOVAK_POST_CROSS_BORDER = "30-1";
displayLookup['PACTIC_SERVICE_TYPE."30-1"'] = "Slovak Post Cross-border";
constants.PACTIC_SERVICE_TYPE_SLOVAK_POST_CROSS_BORDER_PUDO = "30-3";
displayLookup['PACTIC_SERVICE_TYPE."30-3"'] = "Slovak Post Cross-border PuDo";
constants.PACTIC_SERVICE_TYPE_MPL_BUSINESS_POST_POINT = "31-2";
displayLookup['PACTIC_SERVICE_TYPE."31-2"'] = "Pactic - MPL Post Point";
constants.PACTIC_SERVICE_TYPE_B2C_EUROPE_CROSS_BORDER = "32-1";
displayLookup['PACTIC_SERVICE_TYPE."32-1"'] = "B2C Europe Cross-border";
constants.PACTIC_SERVICE_TYPE_B2C_EUROPE_CROSS_BORDER_DIRECT_INJECTION = "32-2";
displayLookup['PACTIC_SERVICE_TYPE."32-2"'] = "B2C Europe Cross-border direct injection";
constants.PACTIC_SERVICE_TYPE_DHL_GERMANY_CROSS_BORDER = "33-1";
displayLookup['PACTIC_SERVICE_TYPE."33-1"'] = "DHL Germany Cross-border";
constants.PACTIC_SERVICE_TYPE_DHL_GERMANY_CROSS_BORDER_PAKETSHOP = "33-2";
displayLookup['PACTIC_SERVICE_TYPE."33-2"'] = "DHL Germany Cross-border paketshop";
constants.PACTIC_SERVICE_TYPE_PPL_CZECH_CROSS_BORDER = "35-1";
displayLookup['PACTIC_SERVICE_TYPE."35-1"'] = "PPL Czech Cross-border";
constants.PACTIC_SERVICE_TYPE_PPL_CZECH_CROSS_BORDER_DIRECT_INJECTION = "35-2";
displayLookup['PACTIC_SERVICE_TYPE."35-2"'] = "PPL Czech Cross-border direct Injection";
constants.PACTIC_SERVICE_TYPE_PPL_CZECH_CROSS_BORDER_PUDO = "35-3";
displayLookup['PACTIC_SERVICE_TYPE."35-3"'] = "PPL Czech Cross-border PuDo";
constants.PACTIC_SERVICE_TYPE_PPL_CZECH_CROSS_BORDER_PUDO_DIRECT_INJECTION = "35-4";
displayLookup['PACTIC_SERVICE_TYPE."35-4"'] = "PPL Czech Cross-border PuDo Direct Injection";
constants.PACTIC_SERVICE_TYPE_PPL_CZECH_PUDO_RETURN = "35-5";
displayLookup['PACTIC_SERVICE_TYPE."35-5"'] = "PPL Czech PuDo Return";
constants.PACTIC_SERVICE_TYPE_HERMES_GERMANY_CROSS_BORDER = "37-1";
displayLookup['PACTIC_SERVICE_TYPE."37-1"'] = "Hermes Germany Cross-border";
constants.PACTIC_SERVICE_TYPE_SPRING_CROSS_BORDER_EU_DESTINATIONS = "37-2";
displayLookup['PACTIC_SERVICE_TYPE."37-2"'] = "Spring Cross-border EU destinations";
constants.PACTIC_SERVICE_TYPE_CROATIA_POST_CROSS_BORDER = "39-1";
displayLookup['PACTIC_SERVICE_TYPE."39-1"'] = "Croatia Post Cross-border";
constants.PACTIC_SERVICE_TYPE_CROATIA_POST_CROSS_BORDER_PUDO = "39-2";
displayLookup['PACTIC_SERVICE_TYPE."39-2"'] = "Croatia Post Cross-border PUDO";
constants.PACTIC_SERVICE_TYPE_CROATIA_POST_CROSS_BORDER_DIRECT_INJECTION = "39-3";
displayLookup['PACTIC_SERVICE_TYPE."39-3"'] = "Croatia Post Cross-border Direct inj.";
constants.PACTIC_SERVICE_TYPE_CROATIA_POST_CROSS_BORDER_PUDO_DIRECT_INJECTION = "39-4";
displayLookup['PACTIC_SERVICE_TYPE."39-4"'] = "Croatia Post Cross-border PUDO D. inj.";
constants.PACTIC_SERVICE_TYPE_CZECH_POST_CROSS_BORDER = "40-1";
displayLookup['PACTIC_SERVICE_TYPE."40-1"'] = "Czech Post Cross-border";
constants.PACTIC_SERVICE_TYPE_CZECH_POST_CROSS_BORDER_DIRECT_INJECTION = "40-3";
displayLookup['PACTIC_SERVICE_TYPE."40-3"'] = "Czech Post Cross-border Dir. Inj.";
constants.PACTIC_SERVICE_TYPE_GLS_HUNGARY_PICK_AND_SHIP_DOMESTIC = "2-1";
displayLookup['PACTIC_SERVICE_TYPE."2-1"'] = "Pactic - GLS Hungary Pick & Ship Domestic";
constants.PACTIC_SERVICE_TYPE_GLS_HUNGARY_CROSS_BORDER_PUDO_DIRECT_INJECTION = "2-8";
displayLookup['PACTIC_SERVICE_TYPE."2-8"'] = "GLS Hungary Cross-border PUDO Direct injection";
constants.PACTIC_SERVICE_TYPE_GLS_HUNGARY_CROSS_BORDER_PUDO = "2-10";
displayLookup['PACTIC_SERVICE_TYPE."2-10"'] = "GLS Hungary Cross-border PUDO";
constants.PACTIC_SERVICE_TYPE_GLS_HUNGARY_CROSS_BORDER = "2-23";
displayLookup['PACTIC_SERVICE_TYPE."2-23"'] = "GLS Hungary Cross-border";
constants.PACTIC_SERVICE_TYPE_GLS_HUNGARY_EXCHANGE = "2-27";
displayLookup['PACTIC_SERVICE_TYPE."2-27"'] = "Pactic - GLS Hungary Exchange Service";
constants.PACTIC_SERVICE_TYPE_GLS_ROMANIA_CROSS_BORDER_DIRECT_INJECTION = "2-9";
displayLookup['PACTIC_SERVICE_TYPE."2-9"'] = "GLS Romania Cross-border Direct Injection";
constants.PACTIC_SERVICE_TYPE_GLS_ROMANIA_CROSS_BORDER = "2-7";
displayLookup['PACTIC_SERVICE_TYPE."2-7"'] = "GLS Romania Cross-border";
constants.PACTIC_SERVICE_TYPE_GLS_ROMANIA_EXCHANGE_SERVICE = "2-11";
displayLookup['PACTIC_SERVICE_TYPE."2-11"'] = "GLS Romania Exchange Service";
constants.PACTIC_SERVICE_TYPE_GLS_CROSS_BORDER_DIRECT = "2-12";
displayLookup['PACTIC_SERVICE_TYPE."2-12"'] = "Pactic - GLS Cross-border Direct";
constants.PACTIC_SERVICE_TYPE_GLS_BUSINESS_HOME_DELIVERY = "2-13";
displayLookup['PACTIC_SERVICE_TYPE."2-13"'] = "Pactic - GLS Business Home Delivery";
constants.PACTIC_SERVICE_TYPE_GLS_BUSINESS_PICKUP_POINT = "2-14";
displayLookup['PACTIC_SERVICE_TYPE."2-14"'] = "Pactic - GLS Business PickUp Point";
constants.PACTIC_SERVICE_TYPE_GLS_SLOVENIA_CROSS_BORDER = "2-22";
displayLookup['PACTIC_SERVICE_TYPE."2-22"'] = "GLS Slovenia Cross-border";
constants.PACTIC_SERVICE_TYPE_GLS_CZECH_REPUBLIC_CROSS_BORDER = "2-26";
displayLookup['PACTIC_SERVICE_TYPE."2-26"'] = "GLS Czech Republic Cross-border";
constants.PACTIC_SERVICE_TYPE_GLS_SLOVENIA_DIRECT_INJECTION = "2-28";
displayLookup['PACTIC_SERVICE_TYPE."2-28"'] = "GLS Slovenia Direct Injection";
constants.PACTIC_SERVICE_TYPE_GLS_CROATIA_CROSS_BORDER = "2-34";
displayLookup['PACTIC_SERVICE_TYPE."2-34"'] = "GLS Croatia Cross-border";
constants.PACTIC_SERVICE_TYPE_GLS_CROATIA_CROSS_BORDER_DIRECT_INJECTION = "2-35";
displayLookup['PACTIC_SERVICE_TYPE."2-35"'] = "GLS Croatia Cross-border Direct Injection";
constants.PACTIC_SERVICE_TYPE_GLS_CROATIA_PICK_AND_RETURN = "2-37";
displayLookup['PACTIC_SERVICE_TYPE."2-37"'] = "GLS Croatia Pick and Return";
constants.PACTIC_SERVICE_TYPE_GLS_SLOVENIA_PICK_AND_RETURN = "2-38";
displayLookup['PACTIC_SERVICE_TYPE."2-38"'] = "GLS Slovenia Pick and Return";
constants.PACTIC_SERVICE_TYPE_GLS_SLOVENIA_PUDO = "2-39";
displayLookup['PACTIC_SERVICE_TYPE."2-39"'] = "GLS Slovenia PUDO";
constants.PACTIC_SERVICE_TYPE_GLS_SLOVENIA_PUDO_DIRECT_INJECTION = "2-40";
displayLookup['PACTIC_SERVICE_TYPE."2-40"'] = "GLS Slovenia PUDO Direct Injection";
constants.PACTIC_SERVICE_TYPE_GLS_SLOVAKIA_CROSS_BORDER = "2-41";
displayLookup['PACTIC_SERVICE_TYPE."2-41"'] = "GLS Slovakia Cross-border";
constants.PACTIC_SERVICE_TYPE_GLS_SLOVAKIA_CROSS_BORDER_DIRECT_INJECTION = "2-42";
displayLookup['PACTIC_SERVICE_TYPE."2-42"'] = "GLS Slovakia Cross-border Direct Injection";
constants.PACTIC_SERVICE_TYPE_GLS_SLOVAKIA_CROSS_BORDER_PUDO = "2-43";
displayLookup['PACTIC_SERVICE_TYPE."2-43"'] = "GLS Slovakia Cross-border PUDO";
constants.PACTIC_SERVICE_TYPE_GLS_SLOVAKIA_CROSS_BORDER_PUDO_DIRECT_INJECTION = "2-44";
displayLookup['PACTIC_SERVICE_TYPE."2-44"'] = "GLS Slovakia Cross-border PUDO Direct Injection";
constants.PACTIC_SERVICE_TYPE_GLS_SLOVAKIA_EXCHANGE_SERVICE = "2-45";
displayLookup['PACTIC_SERVICE_TYPE."2-45"'] = "GLS Slovakia Exchange Service";
constants.PACTIC_SERVICE_TYPE_GLS_SLOVAKIA_PICK_RETURN = "2-46";
displayLookup['PACTIC_SERVICE_TYPE."2-46"'] = "GLS Slovakia Pick & Return";
constants.PACTIC_SERVICE_TYPE_GLS_CROATIA_PUDO = "2-47";
displayLookup['PACTIC_SERVICE_TYPE."2-47"'] = "GLS Croatia PUDO";
constants.PACTIC_SERVICE_TYPE_GLS_CROATIA_PUDO_DIRECT_INJECTION = "2-48";
displayLookup['PACTIC_SERVICE_TYPE."2-48"'] = "GLS Croatia PUDO Direct Injection";
constants.PACTIC_SERVICE_TYPE_GLS_AUSTRIA_CROSS_BORDER = "29-1";
displayLookup['PACTIC_SERVICE_TYPE."29-1"'] = "GLS Austria Cross-border";
constants.PACTIC_SERVICE_TYPE_GLS_AUSTRIA_PUDO_CROSS_BORDER = "29-2";
displayLookup['PACTIC_SERVICE_TYPE."29-2"'] = "GLS Austria PuDo Cross-border";
constants.PACTIC_SERVICE_TYPE_GLS_ITALY_CROSS_BORDER = "34-1";
displayLookup['PACTIC_SERVICE_TYPE."34-1"'] = "GLS Italy Cross-border";
constants.PACTIC_SERVICE_TYPE_GLS_ITALY_PUDO_CROSS_BORDER = "34-2";
displayLookup['PACTIC_SERVICE_TYPE."34-2"'] = "GLS Italy Cross-border PuDo";
constants.PACTIC_SERVICE_TYPE_GLS_ITALY_PICK_AND_RETURN = "34-4";
displayLookup['PACTIC_SERVICE_TYPE."34-4"'] = "GLS Italy Pick and Return";
constants.PACTIC_SERVICE_TYPE_GLS_POLAND_CROSS_BORDER = "36-1";
displayLookup['PACTIC_SERVICE_TYPE."36-1"'] = "GLS Poland Cross-border";
constants.PACTIC_SERVICE_TYPE_GLS_POLAND_CROSS_BORDER_DIRECT_INJECTION = "36-2";
displayLookup['PACTIC_SERVICE_TYPE."36-2"'] = "GLS Poland Cross-border Direct Injection";
constants.PACTIC_SERVICE_TYPE_GLS_POLAND_CROSS_BORDER_PUDO = "36-3";
displayLookup['PACTIC_SERVICE_TYPE."36-3"'] = "GLS Poland Cross-border PuDo";
constants.PACTIC_SERVICE_TYPE_GLS_POLAND_CROSS_BORDER_PUDO_DIRECT_INJECTION = "36-4";
displayLookup['PACTIC_SERVICE_TYPE."36-4"'] = "GLS Poland Cross-border PuDo Direct Injection";
constants.PACTIC_SERVICE_TYPE_GLS_POLAND_PICK_RETURN = "36-5";
displayLookup['PACTIC_SERVICE_TYPE."36-5"'] = "GLS Poland Pick & Return";
constants.PACTIC_SERVICE_TYPE_SAMEDAY_HUNGARY_CROSS_BORDER_DIRECT_INJECTION = "24-3";
displayLookup['PACTIC_SERVICE_TYPE."24-3"'] = "Sameday Hungary Cross-border Direct Injection";
constants.PACTIC_SERVICE_TYPE_SAMEDAY_HUNGARY_EASYBOX_DIRECT_INJECTION = "24-4";
displayLookup['PACTIC_SERVICE_TYPE."24-4"'] = "Sameday Hungary Easybox Direct Injection";
constants.PACTIC_SERVICE_TYPE_SAMEDAY_HUNGARY_CROSS_BORDER = "24-5";
displayLookup['PACTIC_SERVICE_TYPE."24-5"'] = "Sameday Hungary Cross-border";
constants.PACTIC_SERVICE_TYPE_SAMEDAY_HUNGARY_CROSS_BORDER_EASYBOX = "24-6";
displayLookup['PACTIC_SERVICE_TYPE."24-6"'] = "Sameday Hungary Cross-border Easybox";
constants.PACTIC_SERVICE_TYPE_PACKETA_HUNGARY_PUDO = "26-2";
displayLookup['PACTIC_SERVICE_TYPE."26-2"'] = "Packeta Hungary PuDo";
constants.PACTIC_SERVICE_TYPE_SAMEDAY_ROMANIA_PUDO_DIRECT_INJECTION = "24-7";
displayLookup['PACTIC_SERVICE_TYPE."24-7"'] = "SameDay Romania PuDo Direct Injection";
constants.PACTIC_SERVICE_TYPE_SAMEDAY_BULGARIA_CROSS_BORDER = "17-7";
displayLookup['PACTIC_SERVICE_TYPE."17-7"'] = "Sameday Bulgaria Cross-border";
constants.PACTIC_SERVICE_TYPE_SAMEDAY_BULGARIA_CROSS_BORDER_DIRECT_INJECTION = "17-8";
displayLookup['PACTIC_SERVICE_TYPE."17-8"'] = "Sameday Bulgaria Cross-border Direct Injection";
constants.PACTIC_SERVICE_TYPE_EXPRESSONE_CROSS_BORDER_DOMESTIC = "27-1";
displayLookup['PACTIC_SERVICE_TYPE."27-1"'] = "ExpressOne Cross-border Domestic";
constants.PACTIC_SERVICE_TYPE_EXPRESSONE_CROSS_BORDER_DIRECT_INJECTION = "27-2";
displayLookup['PACTIC_SERVICE_TYPE."27-2"'] = "ExpressOne Cross-border Direct Injection";
constants.PACTIC_SERVICE_TYPE_MPL_BUSINESS_PICKUP_POINT = "31-4";
displayLookup['PACTIC_SERVICE_TYPE."31-4"'] = "Pactic - MPL PickUp Point";
constants.PACTIC_SERVICE_TYPE_MPL_HUNGARY_CROSS_BORDER = "31-6";
displayLookup['PACTIC_SERVICE_TYPE."31-6"'] = "MPL Hungary Cross-border";
constants.PACTIC_SERVICE_TYPE_MPL_HUNGARY_CROSS_BORDER_PUDO_DIR_INJ = "31-7";
displayLookup['PACTIC_SERVICE_TYPE."31-7"'] = "MPL Hungary Cross-border PUDO Dir. Inj.";
constants.PACTIC_SERVICE_TYPE_MPL_HUNGARY_CROSS_BORDER_PUDO = "31-8";
displayLookup['PACTIC_SERVICE_TYPE."31-8"'] = "MPL Hungary Cross-border PUDO";
constants.PACTIC_SERVICE_TYPE_MPL_BUSINESS_MANIFEST = "31-52";
displayLookup['PACTIC_SERVICE_TYPE."31-52"'] = "MPL Business Manifest";
constants.PACTIC_SERVICE_TYPE_MPL_BUSINESS_PUDO_MANIFEST = "31-54";
displayLookup['PACTIC_SERVICE_TYPE."31-54"'] = "MPL Business PuDo Manifest";
constants.PACTIC_SERVICE_TYPE_MPL_HUNGARY_CROSS_BORDER_MANIFEST = "31-56";
displayLookup['PACTIC_SERVICE_TYPE."31-56"'] = "MPL Hungary Cross-border Manifest";
constants.PACTIC_SERVICE_TYPE_MPL_HUNGARY_CROSS_BORDER_PUDO_DIR_INJ_MANIFEST = "31-57";
displayLookup['PACTIC_SERVICE_TYPE."31-57"'] = "MPL Hungary Cross-border PUDO Dir Inj Manifest";
constants.PACTIC_SERVICE_TYPE_MPL_HUNGARY_CROSS_BORDER_PUDO_MANIFEST = "31-58";
displayLookup['PACTIC_SERVICE_TYPE."31-58"'] = "MPL Hungary Cross-border PUDO Manifest";
constants.PACTIC_SERVICE_TYPE_DPD_ROMANIA_CLASSIC_BUSINESS_DOMESTIC = "9-4";
displayLookup['PACTIC_SERVICE_TYPE."9-4"'] = "DPD Romania Classic Business Domestic";

constants.PAID_SYNC = {
  SUCCESS: { color: null, label: true, value: 1 },
  FAILED: { color: null, label: true, value: 2 },
  NO_SYNC: { color: null, label: true, value: 3 }
};
constants.PAID_SYNC_SUCCESS = 1;
displayLookup['PAID_SYNC.1'] = "success";
constants.PAID_SYNC_FAILED = 2;
displayLookup['PAID_SYNC.2'] = "failed";
constants.PAID_SYNC_NO_SYNC = 3;
displayLookup['PAID_SYNC.3'] = "no sync";

constants.PANNONXP_PACKAGE_TYPE = {
  BOX: { color: null, label: "box", value: "doboz" }
};
constants.PANNONXP_PACKAGE_TYPE_BOX = "doboz";
displayLookup['PANNONXP_PACKAGE_TYPE."doboz"'] = "box";

constants.PANNONXP_SERVICE_CODE = {
  DELIVERY_24H: { color: null, label: "24H delivery", value: "24H" },
  PICKUP_POINT: { color: null, label: "pickup point", value: "D2S" }
};
constants.PANNONXP_SERVICE_CODE_DELIVERY_24H = "24H";
displayLookup['PANNONXP_SERVICE_CODE."24H"'] = "24H delivery";
constants.PANNONXP_SERVICE_CODE_PICKUP_POINT = "D2S";
displayLookup['PANNONXP_SERVICE_CODE."D2S"'] = "pickup point";

constants.PANNONXP_STICKER_SIZE = {
  A4_4: { color: null, label: "A4 4 labels", value: "4dbA4" },
  LABEL_PRINTER: { color: null, label: "101.6x152.4 label printer", value: "1c101,6x152,4" }
};
constants.PANNONXP_STICKER_SIZE_A4_4 = "4dbA4";
displayLookup['PANNONXP_STICKER_SIZE."4dbA4"'] = "A4 4 labels";
constants.PANNONXP_STICKER_SIZE_LABEL_PRINTER = "1c101,6x152,4";
displayLookup['PANNONXP_STICKER_SIZE."1c101,6x152,4"'] = "101.6x152.4 label printer";

constants.PANNONXP_TRACKING_STATUS = {
  DELIVERED: { color: null, label: "delivered", value: "delivered" },
  CANCELLED: { color: null, label: "cancelled", value: "cancelled" },
  RETURNED: { color: null, label: "returned", value: "returned" }
};
constants.PANNONXP_TRACKING_STATUS_DELIVERED = "delivered";
displayLookup['PANNONXP_TRACKING_STATUS."delivered"'] = "delivered";
constants.PANNONXP_TRACKING_STATUS_CANCELLED = "cancelled";
displayLookup['PANNONXP_TRACKING_STATUS."cancelled"'] = "cancelled";
constants.PANNONXP_TRACKING_STATUS_RETURNED = "returned";
displayLookup['PANNONXP_TRACKING_STATUS."returned"'] = "returned";

constants.PARCEL_24H_COST_BEARER = {
  CONSIGNER: { color: null, label: true, value: "consigner" },
  SENDER: { color: null, label: true, value: "sender" },
  RECIPIENT: { color: null, label: true, value: "recipient" }
};
constants.PARCEL_24H_COST_BEARER_CONSIGNER = "consigner";
displayLookup['PARCEL_24H_COST_BEARER."consigner"'] = "consigner";
constants.PARCEL_24H_COST_BEARER_SENDER = "sender";
displayLookup['PARCEL_24H_COST_BEARER."sender"'] = "sender";
constants.PARCEL_24H_COST_BEARER_RECIPIENT = "recipient";
displayLookup['PARCEL_24H_COST_BEARER."recipient"'] = "recipient";

constants.PARCEL_24H_PACKING_TYPE = {
  PACKAGE: { color: null, label: true, value: "PACKAGE" },
  ENVELOPE: { color: null, label: true, value: "ENVELOPE" },
  WITHOUT_PACKING: { color: null, label: true, value: "WITHOUT_PACKING" },
  PLASTIC_BOX: { color: null, label: true, value: "PLASTIC_BOX" },
  FOIL: { color: null, label: true, value: "FOIL" },
  BUBBLE_FOIL: { color: null, label: true, value: "BUBBLE_FOIL" },
  BOX: { color: null, label: true, value: "BOX" }
};
constants.PARCEL_24H_PACKING_TYPE_PACKAGE = "PACKAGE";
displayLookup['PARCEL_24H_PACKING_TYPE."PACKAGE"'] = "package";
constants.PARCEL_24H_PACKING_TYPE_ENVELOPE = "ENVELOPE";
displayLookup['PARCEL_24H_PACKING_TYPE."ENVELOPE"'] = "envelope";
constants.PARCEL_24H_PACKING_TYPE_WITHOUT_PACKING = "WITHOUT_PACKING";
displayLookup['PARCEL_24H_PACKING_TYPE."WITHOUT_PACKING"'] = "without packing";
constants.PARCEL_24H_PACKING_TYPE_PLASTIC_BOX = "PLASTIC_BOX";
displayLookup['PARCEL_24H_PACKING_TYPE."PLASTIC_BOX"'] = "plastic box";
constants.PARCEL_24H_PACKING_TYPE_FOIL = "FOIL";
displayLookup['PARCEL_24H_PACKING_TYPE."FOIL"'] = "foil";
constants.PARCEL_24H_PACKING_TYPE_BUBBLE_FOIL = "BUBBLE_FOIL";
displayLookup['PARCEL_24H_PACKING_TYPE."BUBBLE_FOIL"'] = "bubble foil";
constants.PARCEL_24H_PACKING_TYPE_BOX = "BOX";
displayLookup['PARCEL_24H_PACKING_TYPE."BOX"'] = "box";

constants.PARCEL_24H_PALLET_PACKING_TYPE = {
  X80120: { color: null, label: "80x120cm pallet", value: "80120" },
  X80PLUS: { color: null, label: "80x120cm pallet plus", value: "80PLUS" },
  X120120: { color: null, label: "120x120cm pallet", value: "120120" },
  X80300: { color: null, label: "80x max 300cm pallet", value: "80300" }
};
constants.PARCEL_24H_PALLET_PACKING_TYPE_X80120 = "80120";
displayLookup['PARCEL_24H_PALLET_PACKING_TYPE."80120"'] = "80x120cm pallet";
constants.PARCEL_24H_PALLET_PACKING_TYPE_X80PLUS = "80PLUS";
displayLookup['PARCEL_24H_PALLET_PACKING_TYPE."80PLUS"'] = "80x120cm pallet plus";
constants.PARCEL_24H_PALLET_PACKING_TYPE_X120120 = "120120";
displayLookup['PARCEL_24H_PALLET_PACKING_TYPE."120120"'] = "120x120cm pallet";
constants.PARCEL_24H_PALLET_PACKING_TYPE_X80300 = "80300";
displayLookup['PARCEL_24H_PALLET_PACKING_TYPE."80300"'] = "80x max 300cm pallet";

constants.PARCEL_24H_PAPER_SIZE = {
  A4: { color: null, label: true, value: "A4" },
  A6: { color: null, label: true, value: "A6" }
};
constants.PARCEL_24H_PAPER_SIZE_A4 = "A4";
displayLookup['PARCEL_24H_PAPER_SIZE."A4"'] = "a4";
constants.PARCEL_24H_PAPER_SIZE_A6 = "A6";
displayLookup['PARCEL_24H_PAPER_SIZE."A6"'] = "a6";

constants.PARCEL_24H_PAYMENT_TYPE = {
  TRANSFER: { color: null, label: true, value: "TRANSFER" },
  CASH: { color: null, label: true, value: "CASH" }
};
constants.PARCEL_24H_PAYMENT_TYPE_TRANSFER = "TRANSFER";
displayLookup['PARCEL_24H_PAYMENT_TYPE."TRANSFER"'] = "transfer";
constants.PARCEL_24H_PAYMENT_TYPE_CASH = "CASH";
displayLookup['PARCEL_24H_PAYMENT_TYPE."CASH"'] = "cash";

constants.PARCEL_24H_SERVICE_TYPE = {
  X24_HOUR_SHIPPING: { color: null, label: true, value: "24_HOUR_SHIPPING" },
  NIGHTLY_EXPRESS: { color: null, label: true, value: "NIGHTLY_EXPRESS" }
};
constants.PARCEL_24H_SERVICE_TYPE_X24_HOUR_SHIPPING = "24_HOUR_SHIPPING";
displayLookup['PARCEL_24H_SERVICE_TYPE."24_HOUR_SHIPPING"'] = "x24 hour shipping";
constants.PARCEL_24H_SERVICE_TYPE_NIGHTLY_EXPRESS = "NIGHTLY_EXPRESS";
displayLookup['PARCEL_24H_SERVICE_TYPE."NIGHTLY_EXPRESS"'] = "nightly express";

constants.PAYMENT_STATUS = {
  UNPAID: { color: "#e57373", label: ["payment status", "unpaid"], value: 1 },
  PLANNED: { color: "#e5e5e5", label: ["payment status", "planned"], value: 10 },
  PENDING: { color: "#64b5f6", label: ["payment status", "pending"], value: 15 },
  CONFIRMATION_REQUIRED: { color: "#ffb74d", label: ["payment status", "confirmation required"], value: 20 },
  PARTIALLY_PAID: { color: "#f57c00", label: ["payment status", "partially paid"], value: 50 },
  PAID: { color: "#66bb6a", label: ["payment status", "paid"], value: 100 },
  OVERPAID: { color: "#e57373", label: ["payment status", "overpaid"], value: 200 },
  WONT_BE_PAID: { color: "#e5e5e5", label: ["payment status", "wont be paid"], value: 300 },
  CANNOT_BE_DETERMINED: { color: "#e57373", label: ["payment status", "cannot be determined"], value: 500 }
};
constants.PAYMENT_STATUS_UNPAID = 1;
displayLookup['PAYMENT_STATUS.1'] = ["payment status", "unpaid"];
colorLookup['PAYMENT_STATUS.1'] = "#e57373";
colorNameLookup['PAYMENT_STATUS.1'] = "RED";
constants.PAYMENT_STATUS_PLANNED = 10;
displayLookup['PAYMENT_STATUS.10'] = ["payment status", "planned"];
colorLookup['PAYMENT_STATUS.10'] = "#e5e5e5";
colorNameLookup['PAYMENT_STATUS.10'] = "GREY";
constants.PAYMENT_STATUS_PENDING = 15;
displayLookup['PAYMENT_STATUS.15'] = ["payment status", "pending"];
colorLookup['PAYMENT_STATUS.15'] = "#64b5f6";
colorNameLookup['PAYMENT_STATUS.15'] = "BLUE";
constants.PAYMENT_STATUS_CONFIRMATION_REQUIRED = 20;
displayLookup['PAYMENT_STATUS.20'] = ["payment status", "confirmation required"];
colorLookup['PAYMENT_STATUS.20'] = "#ffb74d";
colorNameLookup['PAYMENT_STATUS.20'] = "YELLOW";
constants.PAYMENT_STATUS_PARTIALLY_PAID = 50;
displayLookup['PAYMENT_STATUS.50'] = ["payment status", "partially paid"];
colorLookup['PAYMENT_STATUS.50'] = "#f57c00";
colorNameLookup['PAYMENT_STATUS.50'] = "ORANGE";
constants.PAYMENT_STATUS_PAID = 100;
displayLookup['PAYMENT_STATUS.100'] = ["payment status", "paid"];
colorLookup['PAYMENT_STATUS.100'] = "#66bb6a";
colorNameLookup['PAYMENT_STATUS.100'] = "GREEN";
constants.PAYMENT_STATUS_OVERPAID = 200;
displayLookup['PAYMENT_STATUS.200'] = ["payment status", "overpaid"];
colorLookup['PAYMENT_STATUS.200'] = "#e57373";
colorNameLookup['PAYMENT_STATUS.200'] = "RED";
constants.PAYMENT_STATUS_WONT_BE_PAID = 300;
displayLookup['PAYMENT_STATUS.300'] = ["payment status", "wont be paid"];
colorLookup['PAYMENT_STATUS.300'] = "#e5e5e5";
colorNameLookup['PAYMENT_STATUS.300'] = "GREY";
constants.PAYMENT_STATUS_CANNOT_BE_DETERMINED = 500;
displayLookup['PAYMENT_STATUS.500'] = ["payment status", "cannot be determined"];
colorLookup['PAYMENT_STATUS.500'] = "#e57373";
colorNameLookup['PAYMENT_STATUS.500'] = "RED";

constants.PREPAYMENT_AMOUNT_TYPE = {
  PERCENT: { color: null, label: true, value: 1 },
  PRICE: { color: null, label: true, value: 2 }
};
constants.PREPAYMENT_AMOUNT_TYPE_PERCENT = 1;
displayLookup['PREPAYMENT_AMOUNT_TYPE.1'] = "percent";
constants.PREPAYMENT_AMOUNT_TYPE_PRICE = 2;
displayLookup['PREPAYMENT_AMOUNT_TYPE.2'] = "price";

constants.PRESET_TYPE = {
  PRODUCT_EXPORT: { color: null, label: true, value: 1 },
  PURCHASE_ORDER_IMPORT: { color: null, label: true, value: 2 },
  SHIPMENT_IMPORT: { color: null, label: true, value: 3 },
  PURCHASE_ORDER_PLAN_PARAMS: { color: null, label: true, value: 4 },
  V2_IMPORT: { color: null, label: true, value: 5 },
  ORDER_EXPORT: { color: null, label: true, value: 6 },
  OPERATION_ITEM_EXPORT: { color: null, label: true, value: 7 },
  CUSTOMER_EXPORT: { color: null, label: true, value: 8 },
  FORMULA_EXPORT: { color: null, label: true, value: 9 },
  ORDER_ITEM_IMPORT: { color: null, label: true, value: 10 },
  QUOTE_ITEM_IMPORT: { color: null, label: true, value: 11 },
  OPERATION_EXPORT: { color: null, label: true, value: 12 },
  STOCK_TRANSFER_IMPORT: { color: null, label: true, value: 13 },
  CREATE_WAREHOUSE_PICKING: { color: null, label: true, value: 14 },
  PRODUCT_PRINT: { color: null, label: true, value: 15 },
  INTRASTAT_EXPORT: { color: null, label: true, value: 16 },
  MASS_BALANCE_BASE_COMPLETION: { color: null, label: true, value: 17 }
};
constants.PRESET_TYPE_PRODUCT_EXPORT = 1;
displayLookup['PRESET_TYPE.1'] = "product export";
constants.PRESET_TYPE_PURCHASE_ORDER_IMPORT = 2;
displayLookup['PRESET_TYPE.2'] = "purchase order import";
constants.PRESET_TYPE_SHIPMENT_IMPORT = 3;
displayLookup['PRESET_TYPE.3'] = "shipment import";
constants.PRESET_TYPE_PURCHASE_ORDER_PLAN_PARAMS = 4;
displayLookup['PRESET_TYPE.4'] = "purchase order plan params";
constants.PRESET_TYPE_V2_IMPORT = 5;
displayLookup['PRESET_TYPE.5'] = "v2 import";
constants.PRESET_TYPE_ORDER_EXPORT = 6;
displayLookup['PRESET_TYPE.6'] = "order export";
constants.PRESET_TYPE_OPERATION_ITEM_EXPORT = 7;
displayLookup['PRESET_TYPE.7'] = "operation item export";
constants.PRESET_TYPE_CUSTOMER_EXPORT = 8;
displayLookup['PRESET_TYPE.8'] = "customer export";
constants.PRESET_TYPE_FORMULA_EXPORT = 9;
displayLookup['PRESET_TYPE.9'] = "formula export";
constants.PRESET_TYPE_ORDER_ITEM_IMPORT = 10;
displayLookup['PRESET_TYPE.10'] = "order item import";
constants.PRESET_TYPE_QUOTE_ITEM_IMPORT = 11;
displayLookup['PRESET_TYPE.11'] = "quote item import";
constants.PRESET_TYPE_OPERATION_EXPORT = 12;
displayLookup['PRESET_TYPE.12'] = "operation export";
constants.PRESET_TYPE_STOCK_TRANSFER_IMPORT = 13;
displayLookup['PRESET_TYPE.13'] = "stock transfer import";
constants.PRESET_TYPE_CREATE_WAREHOUSE_PICKING = 14;
displayLookup['PRESET_TYPE.14'] = "create warehouse picking";
constants.PRESET_TYPE_PRODUCT_PRINT = 15;
displayLookup['PRESET_TYPE.15'] = "product print";
constants.PRESET_TYPE_INTRASTAT_EXPORT = 16;
displayLookup['PRESET_TYPE.16'] = "intrastat export";
constants.PRESET_TYPE_MASS_BALANCE_BASE_COMPLETION = 17;
displayLookup['PRESET_TYPE.17'] = "mass balance base completion";

constants.PRICE_LIST_ITEM_PRICE_TYPE = {
  FIX: { color: null, label: true, value: 1 },
  CALCULATED: { color: null, label: true, value: 2 }
};
constants.PRICE_LIST_ITEM_PRICE_TYPE_FIX = 1;
displayLookup['PRICE_LIST_ITEM_PRICE_TYPE.1'] = "fix";
constants.PRICE_LIST_ITEM_PRICE_TYPE_CALCULATED = 2;
displayLookup['PRICE_LIST_ITEM_PRICE_TYPE.2'] = "calculated";

constants.PROCESS_TYPE = {
  CREATE_WAREHOUSE_OPERATION_FROM_PURCHASE_ORDER: { color: null, label: "operation from purchase order", value: 1 },
  PRINT_PURCHASE_ORDER: { color: null, label: "print purchase orders", value: 2 },
  PRINT_ORDERS: { color: null, label: true, value: 3 },
  EXPORT_PRODUCTS: { color: null, label: true, value: 4 },
  IMPORT_PRODUCTS: { color: null, label: true, value: 5 },
  EXPORT_CUSTOMERS: { color: null, label: true, value: 6 },
  IMPORT_CUSTOMERS: { color: null, label: true, value: 7 },
  EXPORT_SUPPLIERS: { color: null, label: true, value: 8 },
  IMPORT_SUPPLIERS: { color: null, label: true, value: 9 },
  SEND_PURCHASE_ORDERS: { color: null, label: true, value: 10 },
  CREATE_WAREHOUSE_PICKING: { color: null, label: true, value: 11 },
  WAREHOUSE_OPERATION_EXECUTE_ACTION: { color: null, label: "execute warehouse operation action", value: 12 },
  PRINT_SHIPMENT: { color: null, label: "print shipments", value: 13 },
  SHIPMENT_READ_BARCODE: { color: null, label: "read shipment barcode", value: 14 },
  WAREHOUSE_OPERATIONS_AUTO_EXECUTE: { color: null, label: "execute warehouse operations automatically", value: 15 },
  MASS_INVOICE_GENERATION: { color: null, label: true, value: 16 },
  PRINT_ORDER_INVOICES: { color: null, label: "print order invoice", value: 17 },
  SHIPMENT_IMPORT: { color: null, label: "import shipment", value: 18 },
  SHIPMENT_EXPORT: { color: null, label: "export shipment", value: 19 },
  UPDATE_PRICE_LIST_PRICES_WITH_FORMULA: { color: null, label: true, value: 20 },
  GENERATE_QUOTE_PDFS: { color: null, label: true, value: 21 },
  SEND_QUOTE_EMAIL: { color: null, label: true, value: 22 },
  GENERATE_ORDER_FROM_QUOTE: { color: null, label: true, value: 23 },
  CREATE_PURCHASE_ORDERS_FROM_PRODUCTS: { color: null, label: true, value: 24 },
  PAIR_IMAGES_WITH_PRODUCTS: { color: null, label: true, value: 25 },
  SEND_SELECTED_MESSAGES: { color: null, label: true, value: 26 },
  MASS_PRODUCT_PRICE_LIST: { color: null, label: true, value: 27 },
  EXPORT_PRICE_LIST: { color: null, label: true, value: 28 },
  WAREHOUSE_OPERATION_EXPORT: { color: null, label: "export warehouse operation", value: 29 },
  WAREHOUSE_OPERATION_IMPORT: { color: null, label: "import warehouse operation", value: 30 },
  PURCHASE_ORDER_EXPORT: { color: null, label: "export purchase order", value: 31 },
  PURCHASE_ORDER_IMPORT: { color: null, label: "import purchase order", value: 32 },
  CLOSE_MPL_SHIPMENT: { color: null, label: true, value: 33 },
  ORDERS_EXPORT_CSV: { color: null, label: "export orders", value: 34 },
  CREATE_ORGANIZATION: { color: null, label: true, value: 35 },
  UPDATE_WEBSHOP_MAPPINGS: { color: null, label: true, value: 36 },
  TRANSACTION_IMPORT_CSV: { color: null, label: "import transaction csv", value: 37 },
  CREATE_INVENTORY_COUNT: { color: null, label: true, value: 38 },
  COMPLETE_INVENTORY_COUNT: { color: null, label: true, value: 39 },
  PRINT_INVENTORY_COUNT: { color: null, label: true, value: 40 },
  EXPORT_INVENTORY_REPORT: { color: null, label: true, value: 41 },
  EXPORT_STOCK_TRANSACTION_REPORT: { color: null, label: true, value: 42 },
  EXPORT_STOCK_REPORT: { color: null, label: true, value: 43 },
  COMPLETE_MANUFACTURE_PLAN: { color: null, label: true, value: 44 },
  ADD_PRODUCTS_TO_WAREHOUSE: { color: null, label: true, value: 45 },
  INITIALIZE_WEBSHOP: { color: null, label: "initialize webshop after create", value: 46 },
  EXPORT_ORDER_MATERIAL: { color: null, label: true, value: 47 },
  SYNC_WEBSHOP: { color: null, label: true, value: 48 },
  PRINT_ORDER_SHIPPING_LABEL: { color: null, label: true, value: 49 },
  DELETE_ORDER_SHIPPING_LABEL: { color: null, label: true, value: 50 },
  PRINT_PICKLIST: { color: null, label: true, value: 51 },
  EXPORT_REVENUES: { color: null, label: true, value: 52 },
  EXPORT_EXPENSES: { color: null, label: true, value: 53 },
  EXPORT_INVOICES: { color: null, label: true, value: 54 },
  IMPORT_QUOTE_CSV: { color: null, label: true, value: 55 },
  WEBSHOP_HEALTH_CHECK: { color: null, label: true, value: 56 },
  SEND_EDI_ORDER_RESPONSE: { color: null, label: true, value: 57 },
  PRINT_WAREHOUSE_LOCATION_LABELS: { color: null, label: true, value: 58 },
  MANUALLY_RUN_AUTOMATISM: { color: null, label: true, value: 59 },
  PRINT_WAREHOUSE_OPERATIONS: { color: null, label: true, value: 60 },
  EXPORT_VNY: { color: null, label: "export vny file", value: 61 },
  EDI_INVOICE_GENERATION: { color: null, label: true, value: 62 },
  EXPORT_INTRASTAT: { color: null, label: true, value: 63 },
  RECALCULATE_PRODUCT_STATISTICS: { color: null, label: true, value: 64 },
  PRINT_ORDER_SHIPPING_LABELS: { color: null, label: true, value: 65 },
  GET_ORDER_SHIPPING_LABELS: { color: null, label: true, value: 66 },
  CREATE_ORDER_STOCK_TRANSFER: { color: null, label: true, value: 67 },
  CREATE_WAREHOUSE_OPERATION_STOCK_TRANSFER: { color: null, label: true, value: 68 },
  PRINT_ORDER_TEMPLATES: { color: null, label: true, value: 69 },
  PRINT_PRODUCTS: { color: null, label: true, value: 70 },
  SYNC_PRODUCT_STOCKS_TO_WEBSHOP: { color: null, label: true, value: 71 },
  RUN_SELENIUM_TESTS: { color: null, label: "run ui tests", value: 72 },
  CREATE_STOCK_TRANSFER_FROM_PRODUCTS: { color: null, label: true, value: 73 },
  EXPORT_EPR: { color: null, label: "export excise product record file", value: 74 },
  WAREHOUSE_LOCATION_EXPORT: { color: null, label: true, value: 75 },
  WAREHOUSE_LOCATION_IMPORT: { color: null, label: true, value: 76 },
  WAREHOUSE_OPERATION_ITEM_REPORT_EXPORT: { color: null, label: true, value: 77 },
  CREATE_PURCHASE_ORDERS_FROM_PLAN: { color: null, label: true, value: 78 },
  REDUCE_WAREHOUSE_OPERATION: { color: null, label: true, value: 79 },
  BANK_STATEMENT_IMPORT: { color: null, label: true, value: 80 },
  CREATE_SHIPMENT_FROM_PURCHASE_ORDERS: { color: null, label: true, value: 81 },
  ORDER_TAG_BULK_CREATE: { color: null, label: "bulk create order tags", value: 82 },
  ORDER_TAG_BULK_DELETE: { color: null, label: "bulk delete order tags", value: 83 },
  CUSTOMER_TAG_BULK_CREATE: { color: null, label: "bulk create customer tags", value: 84 },
  CUSTOMER_TAG_BULK_DELETE: { color: null, label: "bulk delete customer tags", value: 85 },
  EXPENSE_TAG_BULK_CREATE: { color: null, label: "bulk create expense tags", value: 86 },
  EXPENSE_TAG_BULK_DELETE: { color: null, label: "bulk delete expense tags", value: 87 },
  REVENUE_TAG_BULK_CREATE: { color: null, label: "bulk create revenue tags", value: 88 },
  REVENUE_TAG_BULK_DELETE: { color: null, label: "bulk delete revenue tags", value: 89 },
  QUOTE_TAG_BULK_CREATE: { color: null, label: "bulk create quote tags", value: 90 },
  QUOTE_TAG_BULK_DELETE: { color: null, label: "bulk delete quote tags", value: 91 },
  INVOICE_TAG_BULK_CREATE: { color: null, label: "bulk create invoice tags", value: 92 },
  INVOICE_TAG_BULK_DELETE: { color: null, label: "bulk delete invoice tags", value: 93 },
  PRODUCT_TAG_BULK_CREATE: { color: null, label: "bulk create product tags", value: 94 },
  PRODUCT_TAG_BULK_DELETE: { color: null, label: "bulk delete product tags", value: 95 },
  WAREHOUSE_OPERATION_TAG_BULK_CREATE: { color: null, label: "bulk create warehouse operation tags", value: 96 },
  WAREHOUSE_OPERATION_TAG_BULK_DELETE: { color: null, label: "bulk delete warehouse operation tags", value: 97 },
  PURCHASE_ORDER_TAG_BULK_CREATE: { color: null, label: "bulk create purchase order tags", value: 98 },
  PURCHASE_ORDER_TAG_BULK_DELETE: { color: null, label: "bulk delete purchase order tags", value: 99 },
  SHIPMENT_TAG_BULK_CREATE: { color: null, label: "bulk create shipment tags", value: 100 },
  SHIPMENT_TAG_BULK_DELETE: { color: null, label: "bulk delete shipment tags", value: 101 },
  SUPPLIER_TAG_BULK_CREATE: { color: null, label: "bulk create supplier tags", value: 102 },
  SUPPLIER_TAG_BULK_DELETE: { color: null, label: "bulk delete supplier tags", value: 103 },
  ARCHIVE_PRODUCTS: { color: null, label: true, value: 104 },
  TRANSFORM_SIMPLE_PRODUCTS_TO_CONFIGURABLE: { color: null, label: true, value: 105 },
  TRANSFORM_CONFIGURABLE_PRODUCTS_TO_SIMPLE: { color: null, label: true, value: 106 },
  TRANSFORM_SIMPLE_PRODUCTS_TO_BUNDLE: { color: null, label: true, value: 107 },
  LIST_PRODUCTS_TO_WEBSHOP: { color: null, label: "list products", value: 108 },
  DPD_TRANSFER_DATA: { color: null, label: "transfer DPD data", value: 109 },
  MASS_ORDER_PRICE_LIST_CHANGE: { color: null, label: true, value: 110 },
  UPDATE_WEBSHOP_CONFIGURATION: { color: null, label: "update webshop product sync configuration", value: 111 },
  EXPORT_MATERIAL_CODE_REPORT: { color: null, label: true, value: 112 },
  DELETE_ZERO_STOCKS_FROM_COLLECTOR: { color: null, label: "delete collector zero stocks", value: 113 },
  DELETE_ZERO_STOCKS_FROM_LOCATIONS: { color: null, label: "delete locations zero stocks", value: 114 },
  CASH_REGISTER_EFT_TRANSACTION: { color: null, label: true, value: 115 },
  MASS_TRANSACTION_GENERATION: { color: null, label: true, value: 116 },
  RECALCULATE_CASHREGISTER_FORMULAS: { color: null, label: "recalculate cash register formulas", value: 117 },
  PRINT_REVENUE_TEMPLATES: { color: null, label: true, value: 118 },
  PRINT_EXPENSE_TEMPLATES: { color: null, label: true, value: 119 },
  MASS_CONFIRM_PURCHASE_ORDER: { color: null, label: true, value: 120 },
  PRINT_LOCAL_PICKUP_LABEL: { color: null, label: true, value: 121 },
  WAREHOUSE_OPERATION_PARTIALLY_DONE: { color: null, label: true, value: 122 },
  EXPORT_FORMULAS: { color: null, label: true, value: 123 },
  IMPORT_FORMULAS: { color: null, label: true, value: 124 },
  DYNAMIC_WAREHOUSE_OPERATION_EXECUTE_ACTION: { color: null, label: "execute dynamic warehouse operation action", value: 125 },
  SYNC_3PL: { color: null, label: "sync third-party logistics", value: 126 },
  MASS_ORDER_CUSTOMER_CHANGE: { color: null, label: true, value: 127 },
  POST_PROCESS_POS_ORDER: { color: null, label: true, value: 128 },
  IMPORT_ORDER_ITEMS: { color: null, label: true, value: 129 },
  PRINT_STOCK_TRANSFER: { color: null, label: true, value: 130 },
  COPY_PROFILES_BETWEEN_GROUPS: { color: null, label: true, value: 131 },
  GENERIC_DATA_RETRIEVE: { color: null, label: true, value: 132 },
  CREATE_MANUFACTURE_PLAN: { color: null, label: true, value: 133 },
  DOWNLOAD_WEBSHOP_LOCALITIES: { color: null, label: true, value: 134 },
  PRODUCT_NUMBER_TAG_BULK_CREATE: { color: null, label: true, value: 135 },
  PRODUCT_NUMBER_TAG_BULK_DELETE: { color: null, label: true, value: 136 },
  COPY_PRICES_FROM_PRODUCT: { color: null, label: true, value: 137 },
  IMPORT_STOCK_TRANSFER_ITEMS: { color: null, label: true, value: 138 },
  GENERATE_WAREHOUSE_OPERATION_FROM_QUOTE: { color: null, label: true, value: 139 },
  EXPORT_DEMO_TEMPLATES: { color: null, label: true, value: 140 },
  STOCK_SYNC_RECOVERY_FOR_WEBSHOP: { color: null, label: true, value: 141 },
  ORDER_STATUS_SYNC_RECOVERY_FOR_WEBSHOP: { color: null, label: true, value: 142 },
  GENERIC_DATA_WRITE: { color: null, label: true, value: 143 },
  V1_INVOICE_DOWNLOAD: { color: null, label: true, value: 144 },
  EXECUTE_SIMPLE_STOCK_TRANSFER_ACTION: { color: null, label: "execute simple stock transfer action", value: 145 },
  DOWNLOAD_WEBSHOP_PRODUCT_EXTRA_SERVICES: { color: null, label: true, value: 146 },
  CREATE_TASK: { color: null, label: true, value: 147 },
  COMPLETE_TASK: { color: null, label: true, value: 148 },
  DELETE_TASK: { color: null, label: true, value: 149 },
  CREATE_ORDER_TASK: { color: null, label: true, value: 150 },
  COMPLETE_ORDER_TASK: { color: null, label: true, value: 151 },
  DELETE_ORDER_TASK: { color: null, label: true, value: 152 },
  CREATE_PRODUCT_NUMBER_TASK: { color: null, label: true, value: 153 },
  COMPLETE_PRODUCT_NUMBER_TASK: { color: null, label: true, value: 154 },
  DELETE_PRODUCT_NUMBER_TASK: { color: null, label: true, value: 155 },
  ORDER_CHECK_ACTION: { color: null, label: true, value: 156 },
  SEND_EDI_DESPATCH_ADVICE: { color: null, label: true, value: 157 },
  REPROCESS_EDI_ORDER: { color: null, label: true, value: 158 },
  PRINT_STOCK_TRANSFER_SHIPPING_LABEL: { color: null, label: true, value: 159 },
  GLS_DISPATCH_XXL: { color: null, label: true, value: 160 },
  CREATE_PRODUCT_TASK: { color: null, label: true, value: 161 },
  COMPLETE_PRODUCT_TASK: { color: null, label: true, value: 162 },
  DELETE_PRODUCT_TASK: { color: null, label: true, value: 163 },
  MANAGE_PRODUCT_TASK: { color: null, label: true, value: 164 },
  MANAGE_ORDER_TASK: { color: null, label: true, value: 165 },
  CREATE_QUOTE_TASK: { color: null, label: true, value: 166 },
  COMPLETE_QUOTE_TASK: { color: null, label: true, value: 167 },
  DELETE_QUOTE_TASK: { color: null, label: true, value: 168 },
  MANAGE_QUOTE_TASK: { color: null, label: true, value: 169 },
  CREATE_SUPPLIER_TASK: { color: null, label: true, value: 170 },
  COMPLETE_SUPPLIER_TASK: { color: null, label: true, value: 171 },
  DELETE_SUPPLIER_TASK: { color: null, label: true, value: 172 },
  MANAGE_SUPPLIER_TASK: { color: null, label: true, value: 173 },
  CREATE_PURCHASE_ORDER_TASK: { color: null, label: true, value: 174 },
  COMPLETE_PURCHASE_ORDER_TASK: { color: null, label: true, value: 175 },
  DELETE_PURCHASE_ORDER_TASK: { color: null, label: true, value: 176 },
  MANAGE_PURCHASE_ORDER_TASK: { color: null, label: true, value: 177 },
  CREATE_SHIPMENT_TASK: { color: null, label: true, value: 178 },
  COMPLETE_SHIPMENT_TASK: { color: null, label: true, value: 179 },
  DELETE_SHIPMENT_TASK: { color: null, label: true, value: 180 },
  MANAGE_SHIPMENT_TASK: { color: null, label: true, value: 181 },
  CREATE_CUSTOMER_TASK: { color: null, label: true, value: 182 },
  COMPLETE_CUSTOMER_TASK: { color: null, label: true, value: 183 },
  DELETE_CUSTOMER_TASK: { color: null, label: true, value: 184 },
  MANAGE_CUSTOMER_TASK: { color: null, label: true, value: 185 },
  CREATE_INVOICE_TASK: { color: null, label: true, value: 186 },
  COMPLETE_INVOICE_TASK: { color: null, label: true, value: 187 },
  DELETE_INVOICE_TASK: { color: null, label: true, value: 188 },
  MANAGE_INVOICE_TASK: { color: null, label: true, value: 189 },
  CREATE_VIEW_CONFIG_TASK: { color: null, label: true, value: 190 },
  COMPLETE_VIEW_CONFIG_TASK: { color: null, label: true, value: 191 },
  DELETE_VIEW_CONFIG_TASK: { color: null, label: true, value: 192 },
  MANAGE_VIEW_CONFIG_TASK: { color: null, label: true, value: 193 },
  MANAGE_PRODUCT_NUMBER_TASK: { color: null, label: true, value: 194 },
  DELETE_PRODUCTS: { color: null, label: "permanently delete products", value: 195 },
  SYNC_NAV: { color: null, label: true, value: 196 },
  CREATE_TRANSACTION_TASK: { color: null, label: true, value: 197 },
  COMPLETE_TRANSACTION_TASK: { color: null, label: true, value: 198 },
  DELETE_TRANSACTION_TASK: { color: null, label: true, value: 199 },
  MANAGE_TRANSACTION_TASK: { color: null, label: true, value: 200 },
  INVOICE_IMPORT_AUTOMATIC_PROCESSING: { color: null, label: true, value: 201 },
  ADD_TO_TRANSACTION_BATCH: { color: null, label: true, value: 202 },
  EXPORT_TRANSACTION_BATCH: { color: null, label: true, value: 203 },
  IMPORT_AGGREG8_TRANSACTIONS: { color: null, label: true, value: 204 },
  RECALCULATE_TRANSACTION_STATISTICS: { color: null, label: true, value: 205 },
  MASS_BALANCE_BASE_COMPLETION: { color: null, label: true, value: 206 },
  WAREHOUSE_PICKING_TAG_BULK_CREATE: { color: null, label: "bulk create warehouse picking tags", value: 207 },
  WAREHOUSE_PICKING_TAG_BULK_DELETE: { color: null, label: "bulk delete warehouse picking tags", value: 208 },
  CLOSE_PANNONXP_SHIPMENT: { color: null, label: "close PannonXP shipment", value: 209 },
  GENERIC_BULK_EDIT: { color: null, label: "bulk edit", value: 210 },
  VALIDATE_TAX_DATA: { color: null, label: true, value: 211 },
  TRANSACTION_CATEGORY_MIGRATION: { color: null, label: true, value: 212 },
  EXECUTE_FINANCIAL_CATEGORY_AUDIT: { color: null, label: true, value: 213 }
};
constants.PROCESS_TYPE_CREATE_WAREHOUSE_OPERATION_FROM_PURCHASE_ORDER = 1;
displayLookup['PROCESS_TYPE.1'] = "operation from purchase order";
constants.PROCESS_TYPE_PRINT_PURCHASE_ORDER = 2;
displayLookup['PROCESS_TYPE.2'] = "print purchase orders";
constants.PROCESS_TYPE_PRINT_ORDERS = 3;
displayLookup['PROCESS_TYPE.3'] = "print orders";
constants.PROCESS_TYPE_EXPORT_PRODUCTS = 4;
displayLookup['PROCESS_TYPE.4'] = "export products";
constants.PROCESS_TYPE_IMPORT_PRODUCTS = 5;
displayLookup['PROCESS_TYPE.5'] = "import products";
constants.PROCESS_TYPE_EXPORT_CUSTOMERS = 6;
displayLookup['PROCESS_TYPE.6'] = "export customers";
constants.PROCESS_TYPE_IMPORT_CUSTOMERS = 7;
displayLookup['PROCESS_TYPE.7'] = "import customers";
constants.PROCESS_TYPE_EXPORT_SUPPLIERS = 8;
displayLookup['PROCESS_TYPE.8'] = "export suppliers";
constants.PROCESS_TYPE_IMPORT_SUPPLIERS = 9;
displayLookup['PROCESS_TYPE.9'] = "import suppliers";
constants.PROCESS_TYPE_SEND_PURCHASE_ORDERS = 10;
displayLookup['PROCESS_TYPE.10'] = "send purchase orders";
constants.PROCESS_TYPE_CREATE_WAREHOUSE_PICKING = 11;
displayLookup['PROCESS_TYPE.11'] = "create warehouse picking";
constants.PROCESS_TYPE_WAREHOUSE_OPERATION_EXECUTE_ACTION = 12;
displayLookup['PROCESS_TYPE.12'] = "execute warehouse operation action";
constants.PROCESS_TYPE_PRINT_SHIPMENT = 13;
displayLookup['PROCESS_TYPE.13'] = "print shipments";
constants.PROCESS_TYPE_SHIPMENT_READ_BARCODE = 14;
displayLookup['PROCESS_TYPE.14'] = "read shipment barcode";
constants.PROCESS_TYPE_WAREHOUSE_OPERATIONS_AUTO_EXECUTE = 15;
displayLookup['PROCESS_TYPE.15'] = "execute warehouse operations automatically";
constants.PROCESS_TYPE_MASS_INVOICE_GENERATION = 16;
displayLookup['PROCESS_TYPE.16'] = "mass invoice generation";
constants.PROCESS_TYPE_PRINT_ORDER_INVOICES = 17;
displayLookup['PROCESS_TYPE.17'] = "print order invoice";
constants.PROCESS_TYPE_SHIPMENT_IMPORT = 18;
displayLookup['PROCESS_TYPE.18'] = "import shipment";
constants.PROCESS_TYPE_SHIPMENT_EXPORT = 19;
displayLookup['PROCESS_TYPE.19'] = "export shipment";
constants.PROCESS_TYPE_UPDATE_PRICE_LIST_PRICES_WITH_FORMULA = 20;
displayLookup['PROCESS_TYPE.20'] = "update price list prices with formula";
constants.PROCESS_TYPE_GENERATE_QUOTE_PDFS = 21;
displayLookup['PROCESS_TYPE.21'] = "generate quote pdfs";
constants.PROCESS_TYPE_SEND_QUOTE_EMAIL = 22;
displayLookup['PROCESS_TYPE.22'] = "send quote email";
constants.PROCESS_TYPE_GENERATE_ORDER_FROM_QUOTE = 23;
displayLookup['PROCESS_TYPE.23'] = "generate order from quote";
constants.PROCESS_TYPE_CREATE_PURCHASE_ORDERS_FROM_PRODUCTS = 24;
displayLookup['PROCESS_TYPE.24'] = "create purchase orders from products";
constants.PROCESS_TYPE_PAIR_IMAGES_WITH_PRODUCTS = 25;
displayLookup['PROCESS_TYPE.25'] = "pair images with products";
constants.PROCESS_TYPE_SEND_SELECTED_MESSAGES = 26;
displayLookup['PROCESS_TYPE.26'] = "send selected messages";
constants.PROCESS_TYPE_MASS_PRODUCT_PRICE_LIST = 27;
displayLookup['PROCESS_TYPE.27'] = "mass product price list";
constants.PROCESS_TYPE_EXPORT_PRICE_LIST = 28;
displayLookup['PROCESS_TYPE.28'] = "export price list";
constants.PROCESS_TYPE_WAREHOUSE_OPERATION_EXPORT = 29;
displayLookup['PROCESS_TYPE.29'] = "export warehouse operation";
constants.PROCESS_TYPE_WAREHOUSE_OPERATION_IMPORT = 30;
displayLookup['PROCESS_TYPE.30'] = "import warehouse operation";
constants.PROCESS_TYPE_PURCHASE_ORDER_EXPORT = 31;
displayLookup['PROCESS_TYPE.31'] = "export purchase order";
constants.PROCESS_TYPE_PURCHASE_ORDER_IMPORT = 32;
displayLookup['PROCESS_TYPE.32'] = "import purchase order";
constants.PROCESS_TYPE_CLOSE_MPL_SHIPMENT = 33;
displayLookup['PROCESS_TYPE.33'] = "close mpl shipment";
constants.PROCESS_TYPE_ORDERS_EXPORT_CSV = 34;
displayLookup['PROCESS_TYPE.34'] = "export orders";
constants.PROCESS_TYPE_CREATE_ORGANIZATION = 35;
displayLookup['PROCESS_TYPE.35'] = "create organization";
constants.PROCESS_TYPE_UPDATE_WEBSHOP_MAPPINGS = 36;
displayLookup['PROCESS_TYPE.36'] = "update webshop mappings";
constants.PROCESS_TYPE_TRANSACTION_IMPORT_CSV = 37;
displayLookup['PROCESS_TYPE.37'] = "import transaction csv";
constants.PROCESS_TYPE_CREATE_INVENTORY_COUNT = 38;
displayLookup['PROCESS_TYPE.38'] = "create inventory count";
constants.PROCESS_TYPE_COMPLETE_INVENTORY_COUNT = 39;
displayLookup['PROCESS_TYPE.39'] = "complete inventory count";
constants.PROCESS_TYPE_PRINT_INVENTORY_COUNT = 40;
displayLookup['PROCESS_TYPE.40'] = "print inventory count";
constants.PROCESS_TYPE_EXPORT_INVENTORY_REPORT = 41;
displayLookup['PROCESS_TYPE.41'] = "export inventory report";
constants.PROCESS_TYPE_EXPORT_STOCK_TRANSACTION_REPORT = 42;
displayLookup['PROCESS_TYPE.42'] = "export stock transaction report";
constants.PROCESS_TYPE_EXPORT_STOCK_REPORT = 43;
displayLookup['PROCESS_TYPE.43'] = "export stock report";
constants.PROCESS_TYPE_COMPLETE_MANUFACTURE_PLAN = 44;
displayLookup['PROCESS_TYPE.44'] = "complete manufacture plan";
constants.PROCESS_TYPE_ADD_PRODUCTS_TO_WAREHOUSE = 45;
displayLookup['PROCESS_TYPE.45'] = "add products to warehouse";
constants.PROCESS_TYPE_INITIALIZE_WEBSHOP = 46;
displayLookup['PROCESS_TYPE.46'] = "initialize webshop after create";
constants.PROCESS_TYPE_EXPORT_ORDER_MATERIAL = 47;
displayLookup['PROCESS_TYPE.47'] = "export order material";
constants.PROCESS_TYPE_SYNC_WEBSHOP = 48;
displayLookup['PROCESS_TYPE.48'] = "sync webshop";
constants.PROCESS_TYPE_PRINT_ORDER_SHIPPING_LABEL = 49;
displayLookup['PROCESS_TYPE.49'] = "print order shipping label";
constants.PROCESS_TYPE_DELETE_ORDER_SHIPPING_LABEL = 50;
displayLookup['PROCESS_TYPE.50'] = "delete order shipping label";
constants.PROCESS_TYPE_PRINT_PICKLIST = 51;
displayLookup['PROCESS_TYPE.51'] = "print picklist";
constants.PROCESS_TYPE_EXPORT_REVENUES = 52;
displayLookup['PROCESS_TYPE.52'] = "export revenues";
constants.PROCESS_TYPE_EXPORT_EXPENSES = 53;
displayLookup['PROCESS_TYPE.53'] = "export expenses";
constants.PROCESS_TYPE_EXPORT_INVOICES = 54;
displayLookup['PROCESS_TYPE.54'] = "export invoices";
constants.PROCESS_TYPE_IMPORT_QUOTE_CSV = 55;
displayLookup['PROCESS_TYPE.55'] = "import quote csv";
constants.PROCESS_TYPE_WEBSHOP_HEALTH_CHECK = 56;
displayLookup['PROCESS_TYPE.56'] = "webshop health check";
constants.PROCESS_TYPE_SEND_EDI_ORDER_RESPONSE = 57;
displayLookup['PROCESS_TYPE.57'] = "send edi order response";
constants.PROCESS_TYPE_PRINT_WAREHOUSE_LOCATION_LABELS = 58;
displayLookup['PROCESS_TYPE.58'] = "print warehouse location labels";
constants.PROCESS_TYPE_MANUALLY_RUN_AUTOMATISM = 59;
displayLookup['PROCESS_TYPE.59'] = "manually run automatism";
constants.PROCESS_TYPE_PRINT_WAREHOUSE_OPERATIONS = 60;
displayLookup['PROCESS_TYPE.60'] = "print warehouse operations";
constants.PROCESS_TYPE_EXPORT_VNY = 61;
displayLookup['PROCESS_TYPE.61'] = "export vny file";
constants.PROCESS_TYPE_EDI_INVOICE_GENERATION = 62;
displayLookup['PROCESS_TYPE.62'] = "edi invoice generation";
constants.PROCESS_TYPE_EXPORT_INTRASTAT = 63;
displayLookup['PROCESS_TYPE.63'] = "export intrastat";
constants.PROCESS_TYPE_RECALCULATE_PRODUCT_STATISTICS = 64;
displayLookup['PROCESS_TYPE.64'] = "recalculate product statistics";
constants.PROCESS_TYPE_PRINT_ORDER_SHIPPING_LABELS = 65;
displayLookup['PROCESS_TYPE.65'] = "print order shipping labels";
constants.PROCESS_TYPE_GET_ORDER_SHIPPING_LABELS = 66;
displayLookup['PROCESS_TYPE.66'] = "get order shipping labels";
constants.PROCESS_TYPE_CREATE_ORDER_STOCK_TRANSFER = 67;
displayLookup['PROCESS_TYPE.67'] = "create order stock transfer";
constants.PROCESS_TYPE_CREATE_WAREHOUSE_OPERATION_STOCK_TRANSFER = 68;
displayLookup['PROCESS_TYPE.68'] = "create warehouse operation stock transfer";
constants.PROCESS_TYPE_PRINT_ORDER_TEMPLATES = 69;
displayLookup['PROCESS_TYPE.69'] = "print order templates";
constants.PROCESS_TYPE_PRINT_PRODUCTS = 70;
displayLookup['PROCESS_TYPE.70'] = "print products";
constants.PROCESS_TYPE_SYNC_PRODUCT_STOCKS_TO_WEBSHOP = 71;
displayLookup['PROCESS_TYPE.71'] = "sync product stocks to webshop";
constants.PROCESS_TYPE_RUN_SELENIUM_TESTS = 72;
displayLookup['PROCESS_TYPE.72'] = "run ui tests";
constants.PROCESS_TYPE_CREATE_STOCK_TRANSFER_FROM_PRODUCTS = 73;
displayLookup['PROCESS_TYPE.73'] = "create stock transfer from products";
constants.PROCESS_TYPE_EXPORT_EPR = 74;
displayLookup['PROCESS_TYPE.74'] = "export excise product record file";
constants.PROCESS_TYPE_WAREHOUSE_LOCATION_EXPORT = 75;
displayLookup['PROCESS_TYPE.75'] = "warehouse location export";
constants.PROCESS_TYPE_WAREHOUSE_LOCATION_IMPORT = 76;
displayLookup['PROCESS_TYPE.76'] = "warehouse location import";
constants.PROCESS_TYPE_WAREHOUSE_OPERATION_ITEM_REPORT_EXPORT = 77;
displayLookup['PROCESS_TYPE.77'] = "warehouse operation item report export";
constants.PROCESS_TYPE_CREATE_PURCHASE_ORDERS_FROM_PLAN = 78;
displayLookup['PROCESS_TYPE.78'] = "create purchase orders from plan";
constants.PROCESS_TYPE_REDUCE_WAREHOUSE_OPERATION = 79;
displayLookup['PROCESS_TYPE.79'] = "reduce warehouse operation";
constants.PROCESS_TYPE_BANK_STATEMENT_IMPORT = 80;
displayLookup['PROCESS_TYPE.80'] = "bank statement import";
constants.PROCESS_TYPE_CREATE_SHIPMENT_FROM_PURCHASE_ORDERS = 81;
displayLookup['PROCESS_TYPE.81'] = "create shipment from purchase orders";
constants.PROCESS_TYPE_ORDER_TAG_BULK_CREATE = 82;
displayLookup['PROCESS_TYPE.82'] = "bulk create order tags";
constants.PROCESS_TYPE_ORDER_TAG_BULK_DELETE = 83;
displayLookup['PROCESS_TYPE.83'] = "bulk delete order tags";
constants.PROCESS_TYPE_CUSTOMER_TAG_BULK_CREATE = 84;
displayLookup['PROCESS_TYPE.84'] = "bulk create customer tags";
constants.PROCESS_TYPE_CUSTOMER_TAG_BULK_DELETE = 85;
displayLookup['PROCESS_TYPE.85'] = "bulk delete customer tags";
constants.PROCESS_TYPE_EXPENSE_TAG_BULK_CREATE = 86;
displayLookup['PROCESS_TYPE.86'] = "bulk create expense tags";
constants.PROCESS_TYPE_EXPENSE_TAG_BULK_DELETE = 87;
displayLookup['PROCESS_TYPE.87'] = "bulk delete expense tags";
constants.PROCESS_TYPE_REVENUE_TAG_BULK_CREATE = 88;
displayLookup['PROCESS_TYPE.88'] = "bulk create revenue tags";
constants.PROCESS_TYPE_REVENUE_TAG_BULK_DELETE = 89;
displayLookup['PROCESS_TYPE.89'] = "bulk delete revenue tags";
constants.PROCESS_TYPE_QUOTE_TAG_BULK_CREATE = 90;
displayLookup['PROCESS_TYPE.90'] = "bulk create quote tags";
constants.PROCESS_TYPE_QUOTE_TAG_BULK_DELETE = 91;
displayLookup['PROCESS_TYPE.91'] = "bulk delete quote tags";
constants.PROCESS_TYPE_INVOICE_TAG_BULK_CREATE = 92;
displayLookup['PROCESS_TYPE.92'] = "bulk create invoice tags";
constants.PROCESS_TYPE_INVOICE_TAG_BULK_DELETE = 93;
displayLookup['PROCESS_TYPE.93'] = "bulk delete invoice tags";
constants.PROCESS_TYPE_PRODUCT_TAG_BULK_CREATE = 94;
displayLookup['PROCESS_TYPE.94'] = "bulk create product tags";
constants.PROCESS_TYPE_PRODUCT_TAG_BULK_DELETE = 95;
displayLookup['PROCESS_TYPE.95'] = "bulk delete product tags";
constants.PROCESS_TYPE_WAREHOUSE_OPERATION_TAG_BULK_CREATE = 96;
displayLookup['PROCESS_TYPE.96'] = "bulk create warehouse operation tags";
constants.PROCESS_TYPE_WAREHOUSE_OPERATION_TAG_BULK_DELETE = 97;
displayLookup['PROCESS_TYPE.97'] = "bulk delete warehouse operation tags";
constants.PROCESS_TYPE_PURCHASE_ORDER_TAG_BULK_CREATE = 98;
displayLookup['PROCESS_TYPE.98'] = "bulk create purchase order tags";
constants.PROCESS_TYPE_PURCHASE_ORDER_TAG_BULK_DELETE = 99;
displayLookup['PROCESS_TYPE.99'] = "bulk delete purchase order tags";
constants.PROCESS_TYPE_SHIPMENT_TAG_BULK_CREATE = 100;
displayLookup['PROCESS_TYPE.100'] = "bulk create shipment tags";
constants.PROCESS_TYPE_SHIPMENT_TAG_BULK_DELETE = 101;
displayLookup['PROCESS_TYPE.101'] = "bulk delete shipment tags";
constants.PROCESS_TYPE_SUPPLIER_TAG_BULK_CREATE = 102;
displayLookup['PROCESS_TYPE.102'] = "bulk create supplier tags";
constants.PROCESS_TYPE_SUPPLIER_TAG_BULK_DELETE = 103;
displayLookup['PROCESS_TYPE.103'] = "bulk delete supplier tags";
constants.PROCESS_TYPE_ARCHIVE_PRODUCTS = 104;
displayLookup['PROCESS_TYPE.104'] = "archive products";
constants.PROCESS_TYPE_TRANSFORM_SIMPLE_PRODUCTS_TO_CONFIGURABLE = 105;
displayLookup['PROCESS_TYPE.105'] = "transform simple products to configurable";
constants.PROCESS_TYPE_TRANSFORM_CONFIGURABLE_PRODUCTS_TO_SIMPLE = 106;
displayLookup['PROCESS_TYPE.106'] = "transform configurable products to simple";
constants.PROCESS_TYPE_TRANSFORM_SIMPLE_PRODUCTS_TO_BUNDLE = 107;
displayLookup['PROCESS_TYPE.107'] = "transform simple products to bundle";
constants.PROCESS_TYPE_LIST_PRODUCTS_TO_WEBSHOP = 108;
displayLookup['PROCESS_TYPE.108'] = "list products";
constants.PROCESS_TYPE_DPD_TRANSFER_DATA = 109;
displayLookup['PROCESS_TYPE.109'] = "transfer DPD data";
constants.PROCESS_TYPE_MASS_ORDER_PRICE_LIST_CHANGE = 110;
displayLookup['PROCESS_TYPE.110'] = "mass order price list change";
constants.PROCESS_TYPE_UPDATE_WEBSHOP_CONFIGURATION = 111;
displayLookup['PROCESS_TYPE.111'] = "update webshop product sync configuration";
constants.PROCESS_TYPE_EXPORT_MATERIAL_CODE_REPORT = 112;
displayLookup['PROCESS_TYPE.112'] = "export material code report";
constants.PROCESS_TYPE_DELETE_ZERO_STOCKS_FROM_COLLECTOR = 113;
displayLookup['PROCESS_TYPE.113'] = "delete collector zero stocks";
constants.PROCESS_TYPE_DELETE_ZERO_STOCKS_FROM_LOCATIONS = 114;
displayLookup['PROCESS_TYPE.114'] = "delete locations zero stocks";
constants.PROCESS_TYPE_CASH_REGISTER_EFT_TRANSACTION = 115;
displayLookup['PROCESS_TYPE.115'] = "cash register eft transaction";
constants.PROCESS_TYPE_MASS_TRANSACTION_GENERATION = 116;
displayLookup['PROCESS_TYPE.116'] = "mass transaction generation";
constants.PROCESS_TYPE_RECALCULATE_CASHREGISTER_FORMULAS = 117;
displayLookup['PROCESS_TYPE.117'] = "recalculate cash register formulas";
constants.PROCESS_TYPE_PRINT_REVENUE_TEMPLATES = 118;
displayLookup['PROCESS_TYPE.118'] = "print revenue templates";
constants.PROCESS_TYPE_PRINT_EXPENSE_TEMPLATES = 119;
displayLookup['PROCESS_TYPE.119'] = "print expense templates";
constants.PROCESS_TYPE_MASS_CONFIRM_PURCHASE_ORDER = 120;
displayLookup['PROCESS_TYPE.120'] = "mass confirm purchase order";
constants.PROCESS_TYPE_PRINT_LOCAL_PICKUP_LABEL = 121;
displayLookup['PROCESS_TYPE.121'] = "print local pickup label";
constants.PROCESS_TYPE_WAREHOUSE_OPERATION_PARTIALLY_DONE = 122;
displayLookup['PROCESS_TYPE.122'] = "warehouse operation partially done";
constants.PROCESS_TYPE_EXPORT_FORMULAS = 123;
displayLookup['PROCESS_TYPE.123'] = "export formulas";
constants.PROCESS_TYPE_IMPORT_FORMULAS = 124;
displayLookup['PROCESS_TYPE.124'] = "import formulas";
constants.PROCESS_TYPE_DYNAMIC_WAREHOUSE_OPERATION_EXECUTE_ACTION = 125;
displayLookup['PROCESS_TYPE.125'] = "execute dynamic warehouse operation action";
constants.PROCESS_TYPE_SYNC_3PL = 126;
displayLookup['PROCESS_TYPE.126'] = "sync third-party logistics";
constants.PROCESS_TYPE_MASS_ORDER_CUSTOMER_CHANGE = 127;
displayLookup['PROCESS_TYPE.127'] = "mass order customer change";
constants.PROCESS_TYPE_POST_PROCESS_POS_ORDER = 128;
displayLookup['PROCESS_TYPE.128'] = "post process pos order";
constants.PROCESS_TYPE_IMPORT_ORDER_ITEMS = 129;
displayLookup['PROCESS_TYPE.129'] = "import order items";
constants.PROCESS_TYPE_PRINT_STOCK_TRANSFER = 130;
displayLookup['PROCESS_TYPE.130'] = "print stock transfer";
constants.PROCESS_TYPE_COPY_PROFILES_BETWEEN_GROUPS = 131;
displayLookup['PROCESS_TYPE.131'] = "copy profiles between groups";
constants.PROCESS_TYPE_GENERIC_DATA_RETRIEVE = 132;
displayLookup['PROCESS_TYPE.132'] = "generic data retrieve";
constants.PROCESS_TYPE_CREATE_MANUFACTURE_PLAN = 133;
displayLookup['PROCESS_TYPE.133'] = "create manufacture plan";
constants.PROCESS_TYPE_DOWNLOAD_WEBSHOP_LOCALITIES = 134;
displayLookup['PROCESS_TYPE.134'] = "download webshop localities";
constants.PROCESS_TYPE_PRODUCT_NUMBER_TAG_BULK_CREATE = 135;
displayLookup['PROCESS_TYPE.135'] = "product number tag bulk create";
constants.PROCESS_TYPE_PRODUCT_NUMBER_TAG_BULK_DELETE = 136;
displayLookup['PROCESS_TYPE.136'] = "product number tag bulk delete";
constants.PROCESS_TYPE_COPY_PRICES_FROM_PRODUCT = 137;
displayLookup['PROCESS_TYPE.137'] = "copy prices from product";
constants.PROCESS_TYPE_IMPORT_STOCK_TRANSFER_ITEMS = 138;
displayLookup['PROCESS_TYPE.138'] = "import stock transfer items";
constants.PROCESS_TYPE_GENERATE_WAREHOUSE_OPERATION_FROM_QUOTE = 139;
displayLookup['PROCESS_TYPE.139'] = "generate warehouse operation from quote";
constants.PROCESS_TYPE_EXPORT_DEMO_TEMPLATES = 140;
displayLookup['PROCESS_TYPE.140'] = "export demo templates";
constants.PROCESS_TYPE_STOCK_SYNC_RECOVERY_FOR_WEBSHOP = 141;
displayLookup['PROCESS_TYPE.141'] = "stock sync recovery for webshop";
constants.PROCESS_TYPE_ORDER_STATUS_SYNC_RECOVERY_FOR_WEBSHOP = 142;
displayLookup['PROCESS_TYPE.142'] = "order status sync recovery for webshop";
constants.PROCESS_TYPE_GENERIC_DATA_WRITE = 143;
displayLookup['PROCESS_TYPE.143'] = "generic data write";
constants.PROCESS_TYPE_V1_INVOICE_DOWNLOAD = 144;
displayLookup['PROCESS_TYPE.144'] = "v1 invoice download";
constants.PROCESS_TYPE_EXECUTE_SIMPLE_STOCK_TRANSFER_ACTION = 145;
displayLookup['PROCESS_TYPE.145'] = "execute simple stock transfer action";
constants.PROCESS_TYPE_DOWNLOAD_WEBSHOP_PRODUCT_EXTRA_SERVICES = 146;
displayLookup['PROCESS_TYPE.146'] = "download webshop product extra services";
constants.PROCESS_TYPE_CREATE_TASK = 147;
displayLookup['PROCESS_TYPE.147'] = "create task";
constants.PROCESS_TYPE_COMPLETE_TASK = 148;
displayLookup['PROCESS_TYPE.148'] = "complete task";
constants.PROCESS_TYPE_DELETE_TASK = 149;
displayLookup['PROCESS_TYPE.149'] = "delete task";
constants.PROCESS_TYPE_CREATE_ORDER_TASK = 150;
displayLookup['PROCESS_TYPE.150'] = "create order task";
constants.PROCESS_TYPE_COMPLETE_ORDER_TASK = 151;
displayLookup['PROCESS_TYPE.151'] = "complete order task";
constants.PROCESS_TYPE_DELETE_ORDER_TASK = 152;
displayLookup['PROCESS_TYPE.152'] = "delete order task";
constants.PROCESS_TYPE_CREATE_PRODUCT_NUMBER_TASK = 153;
displayLookup['PROCESS_TYPE.153'] = "create product number task";
constants.PROCESS_TYPE_COMPLETE_PRODUCT_NUMBER_TASK = 154;
displayLookup['PROCESS_TYPE.154'] = "complete product number task";
constants.PROCESS_TYPE_DELETE_PRODUCT_NUMBER_TASK = 155;
displayLookup['PROCESS_TYPE.155'] = "delete product number task";
constants.PROCESS_TYPE_ORDER_CHECK_ACTION = 156;
displayLookup['PROCESS_TYPE.156'] = "order check action";
constants.PROCESS_TYPE_SEND_EDI_DESPATCH_ADVICE = 157;
displayLookup['PROCESS_TYPE.157'] = "send edi despatch advice";
constants.PROCESS_TYPE_REPROCESS_EDI_ORDER = 158;
displayLookup['PROCESS_TYPE.158'] = "reprocess edi order";
constants.PROCESS_TYPE_PRINT_STOCK_TRANSFER_SHIPPING_LABEL = 159;
displayLookup['PROCESS_TYPE.159'] = "print stock transfer shipping label";
constants.PROCESS_TYPE_GLS_DISPATCH_XXL = 160;
displayLookup['PROCESS_TYPE.160'] = "gls dispatch xxl";
constants.PROCESS_TYPE_CREATE_PRODUCT_TASK = 161;
displayLookup['PROCESS_TYPE.161'] = "create product task";
constants.PROCESS_TYPE_COMPLETE_PRODUCT_TASK = 162;
displayLookup['PROCESS_TYPE.162'] = "complete product task";
constants.PROCESS_TYPE_DELETE_PRODUCT_TASK = 163;
displayLookup['PROCESS_TYPE.163'] = "delete product task";
constants.PROCESS_TYPE_MANAGE_PRODUCT_TASK = 164;
displayLookup['PROCESS_TYPE.164'] = "manage product task";
constants.PROCESS_TYPE_MANAGE_ORDER_TASK = 165;
displayLookup['PROCESS_TYPE.165'] = "manage order task";
constants.PROCESS_TYPE_CREATE_QUOTE_TASK = 166;
displayLookup['PROCESS_TYPE.166'] = "create quote task";
constants.PROCESS_TYPE_COMPLETE_QUOTE_TASK = 167;
displayLookup['PROCESS_TYPE.167'] = "complete quote task";
constants.PROCESS_TYPE_DELETE_QUOTE_TASK = 168;
displayLookup['PROCESS_TYPE.168'] = "delete quote task";
constants.PROCESS_TYPE_MANAGE_QUOTE_TASK = 169;
displayLookup['PROCESS_TYPE.169'] = "manage quote task";
constants.PROCESS_TYPE_CREATE_SUPPLIER_TASK = 170;
displayLookup['PROCESS_TYPE.170'] = "create supplier task";
constants.PROCESS_TYPE_COMPLETE_SUPPLIER_TASK = 171;
displayLookup['PROCESS_TYPE.171'] = "complete supplier task";
constants.PROCESS_TYPE_DELETE_SUPPLIER_TASK = 172;
displayLookup['PROCESS_TYPE.172'] = "delete supplier task";
constants.PROCESS_TYPE_MANAGE_SUPPLIER_TASK = 173;
displayLookup['PROCESS_TYPE.173'] = "manage supplier task";
constants.PROCESS_TYPE_CREATE_PURCHASE_ORDER_TASK = 174;
displayLookup['PROCESS_TYPE.174'] = "create purchase order task";
constants.PROCESS_TYPE_COMPLETE_PURCHASE_ORDER_TASK = 175;
displayLookup['PROCESS_TYPE.175'] = "complete purchase order task";
constants.PROCESS_TYPE_DELETE_PURCHASE_ORDER_TASK = 176;
displayLookup['PROCESS_TYPE.176'] = "delete purchase order task";
constants.PROCESS_TYPE_MANAGE_PURCHASE_ORDER_TASK = 177;
displayLookup['PROCESS_TYPE.177'] = "manage purchase order task";
constants.PROCESS_TYPE_CREATE_SHIPMENT_TASK = 178;
displayLookup['PROCESS_TYPE.178'] = "create shipment task";
constants.PROCESS_TYPE_COMPLETE_SHIPMENT_TASK = 179;
displayLookup['PROCESS_TYPE.179'] = "complete shipment task";
constants.PROCESS_TYPE_DELETE_SHIPMENT_TASK = 180;
displayLookup['PROCESS_TYPE.180'] = "delete shipment task";
constants.PROCESS_TYPE_MANAGE_SHIPMENT_TASK = 181;
displayLookup['PROCESS_TYPE.181'] = "manage shipment task";
constants.PROCESS_TYPE_CREATE_CUSTOMER_TASK = 182;
displayLookup['PROCESS_TYPE.182'] = "create customer task";
constants.PROCESS_TYPE_COMPLETE_CUSTOMER_TASK = 183;
displayLookup['PROCESS_TYPE.183'] = "complete customer task";
constants.PROCESS_TYPE_DELETE_CUSTOMER_TASK = 184;
displayLookup['PROCESS_TYPE.184'] = "delete customer task";
constants.PROCESS_TYPE_MANAGE_CUSTOMER_TASK = 185;
displayLookup['PROCESS_TYPE.185'] = "manage customer task";
constants.PROCESS_TYPE_CREATE_INVOICE_TASK = 186;
displayLookup['PROCESS_TYPE.186'] = "create invoice task";
constants.PROCESS_TYPE_COMPLETE_INVOICE_TASK = 187;
displayLookup['PROCESS_TYPE.187'] = "complete invoice task";
constants.PROCESS_TYPE_DELETE_INVOICE_TASK = 188;
displayLookup['PROCESS_TYPE.188'] = "delete invoice task";
constants.PROCESS_TYPE_MANAGE_INVOICE_TASK = 189;
displayLookup['PROCESS_TYPE.189'] = "manage invoice task";
constants.PROCESS_TYPE_CREATE_VIEW_CONFIG_TASK = 190;
displayLookup['PROCESS_TYPE.190'] = "create view config task";
constants.PROCESS_TYPE_COMPLETE_VIEW_CONFIG_TASK = 191;
displayLookup['PROCESS_TYPE.191'] = "complete view config task";
constants.PROCESS_TYPE_DELETE_VIEW_CONFIG_TASK = 192;
displayLookup['PROCESS_TYPE.192'] = "delete view config task";
constants.PROCESS_TYPE_MANAGE_VIEW_CONFIG_TASK = 193;
displayLookup['PROCESS_TYPE.193'] = "manage view config task";
constants.PROCESS_TYPE_MANAGE_PRODUCT_NUMBER_TASK = 194;
displayLookup['PROCESS_TYPE.194'] = "manage product number task";
constants.PROCESS_TYPE_DELETE_PRODUCTS = 195;
displayLookup['PROCESS_TYPE.195'] = "permanently delete products";
constants.PROCESS_TYPE_SYNC_NAV = 196;
displayLookup['PROCESS_TYPE.196'] = "sync nav";
constants.PROCESS_TYPE_CREATE_TRANSACTION_TASK = 197;
displayLookup['PROCESS_TYPE.197'] = "create transaction task";
constants.PROCESS_TYPE_COMPLETE_TRANSACTION_TASK = 198;
displayLookup['PROCESS_TYPE.198'] = "complete transaction task";
constants.PROCESS_TYPE_DELETE_TRANSACTION_TASK = 199;
displayLookup['PROCESS_TYPE.199'] = "delete transaction task";
constants.PROCESS_TYPE_MANAGE_TRANSACTION_TASK = 200;
displayLookup['PROCESS_TYPE.200'] = "manage transaction task";
constants.PROCESS_TYPE_INVOICE_IMPORT_AUTOMATIC_PROCESSING = 201;
displayLookup['PROCESS_TYPE.201'] = "invoice import automatic processing";
constants.PROCESS_TYPE_ADD_TO_TRANSACTION_BATCH = 202;
displayLookup['PROCESS_TYPE.202'] = "add to transaction batch";
constants.PROCESS_TYPE_EXPORT_TRANSACTION_BATCH = 203;
displayLookup['PROCESS_TYPE.203'] = "export transaction batch";
constants.PROCESS_TYPE_IMPORT_AGGREG8_TRANSACTIONS = 204;
displayLookup['PROCESS_TYPE.204'] = "import aggreg8 transactions";
constants.PROCESS_TYPE_RECALCULATE_TRANSACTION_STATISTICS = 205;
displayLookup['PROCESS_TYPE.205'] = "recalculate transaction statistics";
constants.PROCESS_TYPE_MASS_BALANCE_BASE_COMPLETION = 206;
displayLookup['PROCESS_TYPE.206'] = "mass balance base completion";
constants.PROCESS_TYPE_WAREHOUSE_PICKING_TAG_BULK_CREATE = 207;
displayLookup['PROCESS_TYPE.207'] = "bulk create warehouse picking tags";
constants.PROCESS_TYPE_WAREHOUSE_PICKING_TAG_BULK_DELETE = 208;
displayLookup['PROCESS_TYPE.208'] = "bulk delete warehouse picking tags";
constants.PROCESS_TYPE_CLOSE_PANNONXP_SHIPMENT = 209;
displayLookup['PROCESS_TYPE.209'] = "close PannonXP shipment";
constants.PROCESS_TYPE_GENERIC_BULK_EDIT = 210;
displayLookup['PROCESS_TYPE.210'] = "bulk edit";
constants.PROCESS_TYPE_VALIDATE_TAX_DATA = 211;
displayLookup['PROCESS_TYPE.211'] = "validate tax data";
constants.PROCESS_TYPE_TRANSACTION_CATEGORY_MIGRATION = 212;
displayLookup['PROCESS_TYPE.212'] = "transaction category migration";
constants.PROCESS_TYPE_EXECUTE_FINANCIAL_CATEGORY_AUDIT = 213;
displayLookup['PROCESS_TYPE.213'] = "execute financial category audit";

constants.PRODUCT_ATTRIBUTE_TYPE = {
  LIST: { color: null, label: "textmore or enummore", value: 1 },
  TEXT: { color: null, label: "text or enum", value: 2 },
  HTML: { color: null, label: true, value: 3 }
};
constants.PRODUCT_ATTRIBUTE_TYPE_LIST = 1;
displayLookup['PRODUCT_ATTRIBUTE_TYPE.1'] = "textmore or enummore";
constants.PRODUCT_ATTRIBUTE_TYPE_TEXT = 2;
displayLookup['PRODUCT_ATTRIBUTE_TYPE.2'] = "text or enum";
constants.PRODUCT_ATTRIBUTE_TYPE_HTML = 3;
displayLookup['PRODUCT_ATTRIBUTE_TYPE.3'] = "html";

constants.PRODUCT_ENVIRONMENT_TAXABLE_METHOD = {
  EVERY_PRODUCT: { color: null, label: true, value: 1 },
  SERIAL_NUMBER: { color: null, label: "product number", value: 2 }
};
constants.PRODUCT_ENVIRONMENT_TAXABLE_METHOD_EVERY_PRODUCT = 1;
displayLookup['PRODUCT_ENVIRONMENT_TAXABLE_METHOD.1'] = "every product";
constants.PRODUCT_ENVIRONMENT_TAXABLE_METHOD_SERIAL_NUMBER = 2;
displayLookup['PRODUCT_ENVIRONMENT_TAXABLE_METHOD.2'] = "product number";

constants.PRODUCT_EXPORT_TYPE = {
  EDIT: { color: null, label: true, value: 1 },
  STOCK_TRANSACTION_REPORT: { color: null, label: true, value: 5 },
  STOCK_REPORT: { color: null, label: true, value: 6 },
  INVENTORY_REPORT: { color: null, label: true, value: 7 },
  PRODUCT_SUPPLIER: { color: null, label: true, value: 8 },
  PRODUCT_NUMBER: { color: null, label: true, value: 9 },
  CUSTOMER_PRODUCT: { color: null, label: true, value: 10 },
  MATERIAL_CODE: { color: null, label: true, value: 11 }
};
constants.PRODUCT_EXPORT_TYPE_EDIT = 1;
displayLookup['PRODUCT_EXPORT_TYPE.1'] = "edit";
constants.PRODUCT_EXPORT_TYPE_STOCK_TRANSACTION_REPORT = 5;
displayLookup['PRODUCT_EXPORT_TYPE.5'] = "stock transaction report";
constants.PRODUCT_EXPORT_TYPE_STOCK_REPORT = 6;
displayLookup['PRODUCT_EXPORT_TYPE.6'] = "stock report";
constants.PRODUCT_EXPORT_TYPE_INVENTORY_REPORT = 7;
displayLookup['PRODUCT_EXPORT_TYPE.7'] = "inventory report";
constants.PRODUCT_EXPORT_TYPE_PRODUCT_SUPPLIER = 8;
displayLookup['PRODUCT_EXPORT_TYPE.8'] = "product supplier";
constants.PRODUCT_EXPORT_TYPE_PRODUCT_NUMBER = 9;
displayLookup['PRODUCT_EXPORT_TYPE.9'] = "product number";
constants.PRODUCT_EXPORT_TYPE_CUSTOMER_PRODUCT = 10;
displayLookup['PRODUCT_EXPORT_TYPE.10'] = "customer product";
constants.PRODUCT_EXPORT_TYPE_MATERIAL_CODE = 11;
displayLookup['PRODUCT_EXPORT_TYPE.11'] = "material code";

constants.PRODUCT_IMPORT_MODE = {
  APPEND: { color: null, label: true, value: 1 },
  OVERWRITE: { color: null, label: true, value: 2 }
};
constants.PRODUCT_IMPORT_MODE_APPEND = 1;
displayLookup['PRODUCT_IMPORT_MODE.1'] = "append";
constants.PRODUCT_IMPORT_MODE_OVERWRITE = 2;
displayLookup['PRODUCT_IMPORT_MODE.2'] = "overwrite";

constants.PRODUCT_INVENTORY_VALUE_CALCULATION_METHOD = {
  FIFO: { color: null, label: true, value: 1 },
  PRODUCT_NUMBER: { color: null, label: true, value: 2 }
};
constants.PRODUCT_INVENTORY_VALUE_CALCULATION_METHOD_FIFO = 1;
displayLookup['PRODUCT_INVENTORY_VALUE_CALCULATION_METHOD.1'] = "fifo";
constants.PRODUCT_INVENTORY_VALUE_CALCULATION_METHOD_PRODUCT_NUMBER = 2;
displayLookup['PRODUCT_INVENTORY_VALUE_CALCULATION_METHOD.2'] = "product number";

constants.PRODUCT_LISTING_STATUS = {
  LISTED: { color: null, label: true, value: 1 },
  NOT_LISTED: { color: null, label: true, value: 100 }
};
constants.PRODUCT_LISTING_STATUS_LISTED = 1;
displayLookup['PRODUCT_LISTING_STATUS.1'] = "listed";
constants.PRODUCT_LISTING_STATUS_NOT_LISTED = 100;
displayLookup['PRODUCT_LISTING_STATUS.100'] = "not listed";

constants.PRODUCT_MATERIAL_CODE_DISPLAY_UNIT = {
  KG: { color: null, label: true, value: "kg" },
  G: { color: null, label: true, value: "g" },
  L: { color: null, label: true, value: "l" },
  ML: { color: null, label: true, value: "ml" }
};
constants.PRODUCT_MATERIAL_CODE_DISPLAY_UNIT_KG = "kg";
displayLookup['PRODUCT_MATERIAL_CODE_DISPLAY_UNIT."kg"'] = "kg";
constants.PRODUCT_MATERIAL_CODE_DISPLAY_UNIT_G = "g";
displayLookup['PRODUCT_MATERIAL_CODE_DISPLAY_UNIT."g"'] = "g";
constants.PRODUCT_MATERIAL_CODE_DISPLAY_UNIT_L = "l";
displayLookup['PRODUCT_MATERIAL_CODE_DISPLAY_UNIT."l"'] = "l";
constants.PRODUCT_MATERIAL_CODE_DISPLAY_UNIT_ML = "ml";
displayLookup['PRODUCT_MATERIAL_CODE_DISPLAY_UNIT."ml"'] = "ml";

constants.PRODUCT_MATERIAL_CODE_TYPE = {
  CSK: { color: null, label: "environmental", value: 1 },
  KF: { color: null, label: "circular", value: 2 }
};
constants.PRODUCT_MATERIAL_CODE_TYPE_CSK = 1;
displayLookup['PRODUCT_MATERIAL_CODE_TYPE.1'] = "environmental";
constants.PRODUCT_MATERIAL_CODE_TYPE_KF = 2;
displayLookup['PRODUCT_MATERIAL_CODE_TYPE.2'] = "circular";

constants.PRODUCT_MATERIAL_CODE_UNIT = {
  KG: { color: null, label: true, value: 1 },
  G: { color: null, label: true, value: 1000 }
};
constants.PRODUCT_MATERIAL_CODE_UNIT_KG = 1;
displayLookup['PRODUCT_MATERIAL_CODE_UNIT.1'] = "kg";
constants.PRODUCT_MATERIAL_CODE_UNIT_G = 1000;
displayLookup['PRODUCT_MATERIAL_CODE_UNIT.1000'] = "g";

constants.PRODUCT_MATERIAL_CODE_UNIT_TYPE = {
  KG: { color: null, label: true, value: "kg" },
  L: { color: null, label: true, value: "l" }
};
constants.PRODUCT_MATERIAL_CODE_UNIT_TYPE_KG = "kg";
displayLookup['PRODUCT_MATERIAL_CODE_UNIT_TYPE."kg"'] = "kg";
constants.PRODUCT_MATERIAL_CODE_UNIT_TYPE_L = "l";
displayLookup['PRODUCT_MATERIAL_CODE_UNIT_TYPE."l"'] = "l";

constants.PRODUCT_NAME_DISPLAY = {
  DISPLAY_NAME: { color: null, label: "name", value: 1 },
  SHORT_NAME: { color: null, label: true, value: 2 }
};
constants.PRODUCT_NAME_DISPLAY_DISPLAY_NAME = 1;
displayLookup['PRODUCT_NAME_DISPLAY.1'] = "name";
constants.PRODUCT_NAME_DISPLAY_SHORT_NAME = 2;
displayLookup['PRODUCT_NAME_DISPLAY.2'] = "short name";

constants.PRODUCT_NUMBER_EVENT_TYPE = {
  MANUAL: { color: null, label: true, value: 1 },
  EDITED: { color: null, label: true, value: 2 },
  TAG_CREATED: { color: null, label: true, value: 3 },
  TAG_DELETED: { color: null, label: true, value: 4 },
  TASK_CREATED: { color: null, label: true, value: 5 },
  TASK_COMPLETED: { color: null, label: true, value: 6 },
  TASK_DELETED: { color: null, label: true, value: 7 },
  ASSIGNED_TO_PRODUCT: { color: null, label: true, value: 8 },
  ATTACHED: { color: null, label: true, value: 9 },
  DETACHED: { color: null, label: true, value: 10 },
  ATTACHMENT_REMOVED: { color: null, label: true, value: 11 },
  DOCUMENT_ADDED: { color: null, label: true, value: 12 },
  DOCUMENT_REMOVED: { color: null, label: true, value: 13 }
};
constants.PRODUCT_NUMBER_EVENT_TYPE_MANUAL = 1;
displayLookup['PRODUCT_NUMBER_EVENT_TYPE.1'] = "manual";
constants.PRODUCT_NUMBER_EVENT_TYPE_EDITED = 2;
displayLookup['PRODUCT_NUMBER_EVENT_TYPE.2'] = "edited";
constants.PRODUCT_NUMBER_EVENT_TYPE_TAG_CREATED = 3;
displayLookup['PRODUCT_NUMBER_EVENT_TYPE.3'] = "tag created";
constants.PRODUCT_NUMBER_EVENT_TYPE_TAG_DELETED = 4;
displayLookup['PRODUCT_NUMBER_EVENT_TYPE.4'] = "tag deleted";
constants.PRODUCT_NUMBER_EVENT_TYPE_TASK_CREATED = 5;
displayLookup['PRODUCT_NUMBER_EVENT_TYPE.5'] = "task created";
constants.PRODUCT_NUMBER_EVENT_TYPE_TASK_COMPLETED = 6;
displayLookup['PRODUCT_NUMBER_EVENT_TYPE.6'] = "task completed";
constants.PRODUCT_NUMBER_EVENT_TYPE_TASK_DELETED = 7;
displayLookup['PRODUCT_NUMBER_EVENT_TYPE.7'] = "task deleted";
constants.PRODUCT_NUMBER_EVENT_TYPE_ASSIGNED_TO_PRODUCT = 8;
displayLookup['PRODUCT_NUMBER_EVENT_TYPE.8'] = "assigned to product";
constants.PRODUCT_NUMBER_EVENT_TYPE_ATTACHED = 9;
displayLookup['PRODUCT_NUMBER_EVENT_TYPE.9'] = "attached";
constants.PRODUCT_NUMBER_EVENT_TYPE_DETACHED = 10;
displayLookup['PRODUCT_NUMBER_EVENT_TYPE.10'] = "detached";
constants.PRODUCT_NUMBER_EVENT_TYPE_ATTACHMENT_REMOVED = 11;
displayLookup['PRODUCT_NUMBER_EVENT_TYPE.11'] = "attachment removed";
constants.PRODUCT_NUMBER_EVENT_TYPE_DOCUMENT_ADDED = 12;
displayLookup['PRODUCT_NUMBER_EVENT_TYPE.12'] = "document added";
constants.PRODUCT_NUMBER_EVENT_TYPE_DOCUMENT_REMOVED = 13;
displayLookup['PRODUCT_NUMBER_EVENT_TYPE.13'] = "document removed";

constants.PRODUCT_NUMBER_INVOICE_DISPLAY = {
  NOT_VISIBLE: { color: null, label: true, value: 1 },
  ITEM_DESCRIPTION: { color: null, label: true, value: 2 },
  MAIN_DESCRIPTION: { color: null, label: true, value: 3 }
};
constants.PRODUCT_NUMBER_INVOICE_DISPLAY_NOT_VISIBLE = 1;
displayLookup['PRODUCT_NUMBER_INVOICE_DISPLAY.1'] = "not visible";
constants.PRODUCT_NUMBER_INVOICE_DISPLAY_ITEM_DESCRIPTION = 2;
displayLookup['PRODUCT_NUMBER_INVOICE_DISPLAY.2'] = "item description";
constants.PRODUCT_NUMBER_INVOICE_DISPLAY_MAIN_DESCRIPTION = 3;
displayLookup['PRODUCT_NUMBER_INVOICE_DISPLAY.3'] = "main description";

constants.PRODUCT_NUMBER_INVOICE_DISPLAY_ELEMENT = {
  SERIAL_NUMBER: { color: null, label: true, value: 1 },
  LOT_NUMBER: { color: null, label: true, value: 2 },
  MANUFACTURE_DATE: { color: null, label: true, value: 3 },
  EXPIRATION_DATE: { color: null, label: true, value: 4 }
};
constants.PRODUCT_NUMBER_INVOICE_DISPLAY_ELEMENT_SERIAL_NUMBER = 1;
displayLookup['PRODUCT_NUMBER_INVOICE_DISPLAY_ELEMENT.1'] = "serial number";
constants.PRODUCT_NUMBER_INVOICE_DISPLAY_ELEMENT_LOT_NUMBER = 2;
displayLookup['PRODUCT_NUMBER_INVOICE_DISPLAY_ELEMENT.2'] = "lot number";
constants.PRODUCT_NUMBER_INVOICE_DISPLAY_ELEMENT_MANUFACTURE_DATE = 3;
displayLookup['PRODUCT_NUMBER_INVOICE_DISPLAY_ELEMENT.3'] = "manufacture date";
constants.PRODUCT_NUMBER_INVOICE_DISPLAY_ELEMENT_EXPIRATION_DATE = 4;
displayLookup['PRODUCT_NUMBER_INVOICE_DISPLAY_ELEMENT.4'] = "expiration date";

constants.PRODUCT_NUMBER_ORDER_CHECK_MODE = {
  DISABLED: { color: null, label: true, value: 1 },
  ENABLED: { color: null, label: true, value: 2 },
  MANDATORY: { color: null, label: true, value: 3 }
};
constants.PRODUCT_NUMBER_ORDER_CHECK_MODE_DISABLED = 1;
displayLookup['PRODUCT_NUMBER_ORDER_CHECK_MODE.1'] = "disabled";
constants.PRODUCT_NUMBER_ORDER_CHECK_MODE_ENABLED = 2;
displayLookup['PRODUCT_NUMBER_ORDER_CHECK_MODE.2'] = "enabled";
constants.PRODUCT_NUMBER_ORDER_CHECK_MODE_MANDATORY = 3;
displayLookup['PRODUCT_NUMBER_ORDER_CHECK_MODE.3'] = "mandatory";

constants.PRODUCT_NUMBER_RELATIONSHIP_EXPORT_QUANTITY_MODE = {
  ACTIVE: { color: null, label: true, value: 1 },
  DETACHED: { color: null, label: "executed", value: 2 },
  ALL: { color: null, label: true, value: 3 }
};
constants.PRODUCT_NUMBER_RELATIONSHIP_EXPORT_QUANTITY_MODE_ACTIVE = 1;
displayLookup['PRODUCT_NUMBER_RELATIONSHIP_EXPORT_QUANTITY_MODE.1'] = "active";
constants.PRODUCT_NUMBER_RELATIONSHIP_EXPORT_QUANTITY_MODE_DETACHED = 2;
displayLookup['PRODUCT_NUMBER_RELATIONSHIP_EXPORT_QUANTITY_MODE.2'] = "executed";
constants.PRODUCT_NUMBER_RELATIONSHIP_EXPORT_QUANTITY_MODE_ALL = 3;
displayLookup['PRODUCT_NUMBER_RELATIONSHIP_EXPORT_QUANTITY_MODE.3'] = "all";

constants.PRODUCT_NUMBER_SUGGESTION_MODE = {
  MANUAL: { color: null, label: true, value: 1 },
  FIFO: { color: null, label: true, value: 2 },
  FEFO: { color: null, label: true, value: 3 }
};
constants.PRODUCT_NUMBER_SUGGESTION_MODE_MANUAL = 1;
displayLookup['PRODUCT_NUMBER_SUGGESTION_MODE.1'] = "manual";
constants.PRODUCT_NUMBER_SUGGESTION_MODE_FIFO = 2;
displayLookup['PRODUCT_NUMBER_SUGGESTION_MODE.2'] = "fifo";
constants.PRODUCT_NUMBER_SUGGESTION_MODE_FEFO = 3;
displayLookup['PRODUCT_NUMBER_SUGGESTION_MODE.3'] = "fefo";

constants.PRODUCT_NUMBER_TYPE = {
  SERIAL_NUMBER: { color: null, label: "serial number", value: 1 },
  LOT_NUMBER: { color: null, label: "LOT number", value: 2 }
};
constants.PRODUCT_NUMBER_TYPE_SERIAL_NUMBER = 1;
displayLookup['PRODUCT_NUMBER_TYPE.1'] = "serial number";
constants.PRODUCT_NUMBER_TYPE_LOT_NUMBER = 2;
displayLookup['PRODUCT_NUMBER_TYPE.2'] = "LOT number";

constants.PRODUCT_ORDER_STOCK_AVAILABLE_STATUS = {
  NONE: { color: null, label: true, value: 1 },
  PARTIAL: { color: null, label: true, value: 2 },
  FULL: { color: null, label: true, value: 3 }
};
constants.PRODUCT_ORDER_STOCK_AVAILABLE_STATUS_NONE = 1;
displayLookup['PRODUCT_ORDER_STOCK_AVAILABLE_STATUS.1'] = "none";
constants.PRODUCT_ORDER_STOCK_AVAILABLE_STATUS_PARTIAL = 2;
displayLookup['PRODUCT_ORDER_STOCK_AVAILABLE_STATUS.2'] = "partial";
constants.PRODUCT_ORDER_STOCK_AVAILABLE_STATUS_FULL = 3;
displayLookup['PRODUCT_ORDER_STOCK_AVAILABLE_STATUS.3'] = "full";

constants.PRODUCT_ORDER_SUPPLY_STATUS = {
  NONE: { color: null, label: true, value: 1 },
  PARTIAL: { color: null, label: true, value: 2 },
  FULL: { color: null, label: true, value: 3 },
  ON_STOCK: { color: null, label: true, value: 4 }
};
constants.PRODUCT_ORDER_SUPPLY_STATUS_NONE = 1;
displayLookup['PRODUCT_ORDER_SUPPLY_STATUS.1'] = "none";
constants.PRODUCT_ORDER_SUPPLY_STATUS_PARTIAL = 2;
displayLookup['PRODUCT_ORDER_SUPPLY_STATUS.2'] = "partial";
constants.PRODUCT_ORDER_SUPPLY_STATUS_FULL = 3;
displayLookup['PRODUCT_ORDER_SUPPLY_STATUS.3'] = "full";
constants.PRODUCT_ORDER_SUPPLY_STATUS_ON_STOCK = 4;
displayLookup['PRODUCT_ORDER_SUPPLY_STATUS.4'] = "on stock";

constants.PRODUCT_ORIGIN = {
  NOT_SPECIFIED: { color: null, label: true, value: 1 },
  INLAND: { color: null, label: true, value: 2 },
  ABROAD: { color: null, label: true, value: 3 },
  CUSTOM: { color: null, label: true, value: 4 }
};
constants.PRODUCT_ORIGIN_NOT_SPECIFIED = 1;
displayLookup['PRODUCT_ORIGIN.1'] = "not specified";
constants.PRODUCT_ORIGIN_INLAND = 2;
displayLookup['PRODUCT_ORIGIN.2'] = "inland";
constants.PRODUCT_ORIGIN_ABROAD = 3;
displayLookup['PRODUCT_ORIGIN.3'] = "abroad";
constants.PRODUCT_ORIGIN_CUSTOM = 4;
displayLookup['PRODUCT_ORIGIN.4'] = "custom";

constants.PRODUCT_RECIPE_ITEM_DIRECTION = {
  INBOUND: { color: "#66bb6a", label: true, value: 1 },
  OUTBOUND: { color: "#64b5f6", label: true, value: -1 }
};
constants.PRODUCT_RECIPE_ITEM_DIRECTION_INBOUND = 1;
displayLookup['PRODUCT_RECIPE_ITEM_DIRECTION.1'] = "inbound";
colorLookup['PRODUCT_RECIPE_ITEM_DIRECTION.1'] = "#66bb6a";
colorNameLookup['PRODUCT_RECIPE_ITEM_DIRECTION.1'] = "GREEN";
constants.PRODUCT_RECIPE_ITEM_DIRECTION_OUTBOUND = -1;
displayLookup['PRODUCT_RECIPE_ITEM_DIRECTION.-1'] = "outbound";
colorLookup['PRODUCT_RECIPE_ITEM_DIRECTION.-1'] = "#64b5f6";
colorNameLookup['PRODUCT_RECIPE_ITEM_DIRECTION.-1'] = "BLUE";

constants.PRODUCT_SALE_TYPE = {
  NORMAL: { color: "#66bb6a", label: [true], value: "normal" },
  BUNDLE: { color: "#e57373", label: [true], value: "bundle" },
  BUNDLE_COMPONENT: { color: "#64b5f6", label: [true], value: "bundle_component" },
  CONFIGURABLE_PARENT: { color: "#ffb74d", label: [true], value: "configurable_parent" }
};
constants.PRODUCT_SALE_TYPE_NORMAL = "normal";
displayLookup['PRODUCT_SALE_TYPE."normal"'] = ["product sale type", "normal"];
colorLookup['PRODUCT_SALE_TYPE."normal"'] = "#66bb6a";
colorNameLookup['PRODUCT_SALE_TYPE."normal"'] = "GREEN";
constants.PRODUCT_SALE_TYPE_BUNDLE = "bundle";
displayLookup['PRODUCT_SALE_TYPE."bundle"'] = ["product sale type", "bundle"];
colorLookup['PRODUCT_SALE_TYPE."bundle"'] = "#e57373";
colorNameLookup['PRODUCT_SALE_TYPE."bundle"'] = "RED";
constants.PRODUCT_SALE_TYPE_BUNDLE_COMPONENT = "bundle_component";
displayLookup['PRODUCT_SALE_TYPE."bundle_component"'] = ["product sale type", "bundle component"];
colorLookup['PRODUCT_SALE_TYPE."bundle_component"'] = "#64b5f6";
colorNameLookup['PRODUCT_SALE_TYPE."bundle_component"'] = "BLUE";
constants.PRODUCT_SALE_TYPE_CONFIGURABLE_PARENT = "configurable_parent";
displayLookup['PRODUCT_SALE_TYPE."configurable_parent"'] = ["product sale type", "configurable parent"];
colorLookup['PRODUCT_SALE_TYPE."configurable_parent"'] = "#ffb74d";
colorNameLookup['PRODUCT_SALE_TYPE."configurable_parent"'] = "YELLOW";

constants.PRODUCT_STOCK_AGE_RANGE = {
  LESS_THAN_30_DAYS: { color: "#66bb6a", label: [true], value: 0 },
  BETWEEN_30_AND_60_DAYS: { color: "#66bb6a", label: [true], value: 30 },
  BETWEEN_60_AND_90_DAYS: { color: "#ffb74d", label: [true], value: 60 },
  BETWEEN_90_AND_120_DAYS: { color: "#ffb74d", label: [true], value: 90 },
  BETWEEN_120_AND_180_DAYS: { color: "#f57c00", label: [true], value: 120 },
  BETWEEN_180_AND_270_DAYS: { color: "#f57c00", label: [true], value: 180 },
  BETWEEN_270_AND_360_DAYS: { color: "#e57373", label: [true], value: 270 },
  MORE_THAN_360_DAYS: { color: "#e57373", label: [true], value: 360 }
};
constants.PRODUCT_STOCK_AGE_RANGE_LESS_THAN_30_DAYS = 0;
displayLookup['PRODUCT_STOCK_AGE_RANGE.0'] = ["product stock age range", "less than 30 days"];
colorLookup['PRODUCT_STOCK_AGE_RANGE.0'] = "#66bb6a";
colorNameLookup['PRODUCT_STOCK_AGE_RANGE.0'] = "GREEN";
constants.PRODUCT_STOCK_AGE_RANGE_BETWEEN_30_AND_60_DAYS = 30;
displayLookup['PRODUCT_STOCK_AGE_RANGE.30'] = ["product stock age range", "between 30 and 60 days"];
colorLookup['PRODUCT_STOCK_AGE_RANGE.30'] = "#66bb6a";
colorNameLookup['PRODUCT_STOCK_AGE_RANGE.30'] = "GREEN";
constants.PRODUCT_STOCK_AGE_RANGE_BETWEEN_60_AND_90_DAYS = 60;
displayLookup['PRODUCT_STOCK_AGE_RANGE.60'] = ["product stock age range", "between 60 and 90 days"];
colorLookup['PRODUCT_STOCK_AGE_RANGE.60'] = "#ffb74d";
colorNameLookup['PRODUCT_STOCK_AGE_RANGE.60'] = "YELLOW";
constants.PRODUCT_STOCK_AGE_RANGE_BETWEEN_90_AND_120_DAYS = 90;
displayLookup['PRODUCT_STOCK_AGE_RANGE.90'] = ["product stock age range", "between 90 and 120 days"];
colorLookup['PRODUCT_STOCK_AGE_RANGE.90'] = "#ffb74d";
colorNameLookup['PRODUCT_STOCK_AGE_RANGE.90'] = "YELLOW";
constants.PRODUCT_STOCK_AGE_RANGE_BETWEEN_120_AND_180_DAYS = 120;
displayLookup['PRODUCT_STOCK_AGE_RANGE.120'] = ["product stock age range", "between 120 and 180 days"];
colorLookup['PRODUCT_STOCK_AGE_RANGE.120'] = "#f57c00";
colorNameLookup['PRODUCT_STOCK_AGE_RANGE.120'] = "ORANGE";
constants.PRODUCT_STOCK_AGE_RANGE_BETWEEN_180_AND_270_DAYS = 180;
displayLookup['PRODUCT_STOCK_AGE_RANGE.180'] = ["product stock age range", "between 180 and 270 days"];
colorLookup['PRODUCT_STOCK_AGE_RANGE.180'] = "#f57c00";
colorNameLookup['PRODUCT_STOCK_AGE_RANGE.180'] = "ORANGE";
constants.PRODUCT_STOCK_AGE_RANGE_BETWEEN_270_AND_360_DAYS = 270;
displayLookup['PRODUCT_STOCK_AGE_RANGE.270'] = ["product stock age range", "between 270 and 360 days"];
colorLookup['PRODUCT_STOCK_AGE_RANGE.270'] = "#e57373";
colorNameLookup['PRODUCT_STOCK_AGE_RANGE.270'] = "RED";
constants.PRODUCT_STOCK_AGE_RANGE_MORE_THAN_360_DAYS = 360;
displayLookup['PRODUCT_STOCK_AGE_RANGE.360'] = ["product stock age range", "more than 360 days"];
colorLookup['PRODUCT_STOCK_AGE_RANGE.360'] = "#e57373";
colorNameLookup['PRODUCT_STOCK_AGE_RANGE.360'] = "RED";

constants.PRODUCT_STOCK_STATUS = {
  OUT_OF_STOCK: { color: "#e57373", label: true, value: 1 },
  UNDER_MINIMUM: { color: "#f57c00", label: true, value: 2 },
  SUBOPTIMAL: { color: "#ffb74d", label: true, value: 3 },
  ON_STOCK: { color: "#66bb6a", label: true, value: 4 },
  REORDER: { color: "#64b5f6", label: true, value: 5 },
  OVER_MINIMUM: { color: "#66bb6a", label: true, value: 6 },
  OPTIMAL: { color: "#66bb6a", label: true, value: 7 }
};
constants.PRODUCT_STOCK_STATUS_OUT_OF_STOCK = 1;
displayLookup['PRODUCT_STOCK_STATUS.1'] = "out of stock";
colorLookup['PRODUCT_STOCK_STATUS.1'] = "#e57373";
colorNameLookup['PRODUCT_STOCK_STATUS.1'] = "RED";
constants.PRODUCT_STOCK_STATUS_UNDER_MINIMUM = 2;
displayLookup['PRODUCT_STOCK_STATUS.2'] = "under minimum";
colorLookup['PRODUCT_STOCK_STATUS.2'] = "#f57c00";
colorNameLookup['PRODUCT_STOCK_STATUS.2'] = "ORANGE";
constants.PRODUCT_STOCK_STATUS_SUBOPTIMAL = 3;
displayLookup['PRODUCT_STOCK_STATUS.3'] = "suboptimal";
colorLookup['PRODUCT_STOCK_STATUS.3'] = "#ffb74d";
colorNameLookup['PRODUCT_STOCK_STATUS.3'] = "YELLOW";
constants.PRODUCT_STOCK_STATUS_ON_STOCK = 4;
displayLookup['PRODUCT_STOCK_STATUS.4'] = "on stock";
colorLookup['PRODUCT_STOCK_STATUS.4'] = "#66bb6a";
colorNameLookup['PRODUCT_STOCK_STATUS.4'] = "GREEN";
constants.PRODUCT_STOCK_STATUS_REORDER = 5;
displayLookup['PRODUCT_STOCK_STATUS.5'] = "reorder";
colorLookup['PRODUCT_STOCK_STATUS.5'] = "#64b5f6";
colorNameLookup['PRODUCT_STOCK_STATUS.5'] = "BLUE";
constants.PRODUCT_STOCK_STATUS_OVER_MINIMUM = 6;
displayLookup['PRODUCT_STOCK_STATUS.6'] = "over minimum";
colorLookup['PRODUCT_STOCK_STATUS.6'] = "#66bb6a";
colorNameLookup['PRODUCT_STOCK_STATUS.6'] = "GREEN";
constants.PRODUCT_STOCK_STATUS_OPTIMAL = 7;
displayLookup['PRODUCT_STOCK_STATUS.7'] = "optimal";
colorLookup['PRODUCT_STOCK_STATUS.7'] = "#66bb6a";
colorNameLookup['PRODUCT_STOCK_STATUS.7'] = "GREEN";

constants.PRODUCT_TRACKING_TYPE = {
  NOT_MANAGED: { color: null, label: true, value: 1 },
  SERIAL_NUMBER: { color: null, label: "serial number", value: 2 },
  LOT_NUMBER: { color: null, label: "LOT number", value: 3 }
};
constants.PRODUCT_TRACKING_TYPE_NOT_MANAGED = 1;
displayLookup['PRODUCT_TRACKING_TYPE.1'] = "not managed";
constants.PRODUCT_TRACKING_TYPE_SERIAL_NUMBER = 2;
displayLookup['PRODUCT_TRACKING_TYPE.2'] = "serial number";
constants.PRODUCT_TRACKING_TYPE_LOT_NUMBER = 3;
displayLookup['PRODUCT_TRACKING_TYPE.3'] = "LOT number";

constants.PRODUCT_TYPE = {
  SIMPLE: { color: "#66bb6a", label: true, value: 1 },
  PACKAGING: { color: "#e5e5e5", label: true, value: 2 },
  CONFIGURABLE_PARENT: { color: "#ffb74d", label: true, value: 50 },
  CONFIGURABLE_CHILD: { color: "#64b5f6", label: true, value: 51 },
  BUNDLE: { color: "#e57373", label: true, value: 100 }
};
constants.PRODUCT_TYPE_SIMPLE = 1;
displayLookup['PRODUCT_TYPE.1'] = "simple";
colorLookup['PRODUCT_TYPE.1'] = "#66bb6a";
colorNameLookup['PRODUCT_TYPE.1'] = "GREEN";
constants.PRODUCT_TYPE_PACKAGING = 2;
displayLookup['PRODUCT_TYPE.2'] = "packaging";
colorLookup['PRODUCT_TYPE.2'] = "#e5e5e5";
colorNameLookup['PRODUCT_TYPE.2'] = "GREY";
constants.PRODUCT_TYPE_CONFIGURABLE_PARENT = 50;
displayLookup['PRODUCT_TYPE.50'] = "configurable parent";
colorLookup['PRODUCT_TYPE.50'] = "#ffb74d";
colorNameLookup['PRODUCT_TYPE.50'] = "YELLOW";
constants.PRODUCT_TYPE_CONFIGURABLE_CHILD = 51;
displayLookup['PRODUCT_TYPE.51'] = "configurable child";
colorLookup['PRODUCT_TYPE.51'] = "#64b5f6";
colorNameLookup['PRODUCT_TYPE.51'] = "BLUE";
constants.PRODUCT_TYPE_BUNDLE = 100;
displayLookup['PRODUCT_TYPE.100'] = "bundle";
colorLookup['PRODUCT_TYPE.100'] = "#e57373";
colorNameLookup['PRODUCT_TYPE.100'] = "RED";

constants.PRODUCT_WARRANTY_PERIOD_UNIT = {
  DAY: { color: null, label: true, value: 1 },
  MONTH: { color: null, label: true, value: 30 },
  YEAR: { color: null, label: true, value: 365 }
};
constants.PRODUCT_WARRANTY_PERIOD_UNIT_DAY = 1;
displayLookup['PRODUCT_WARRANTY_PERIOD_UNIT.1'] = "day";
constants.PRODUCT_WARRANTY_PERIOD_UNIT_MONTH = 30;
displayLookup['PRODUCT_WARRANTY_PERIOD_UNIT.30'] = "month";
constants.PRODUCT_WARRANTY_PERIOD_UNIT_YEAR = 365;
displayLookup['PRODUCT_WARRANTY_PERIOD_UNIT.365'] = "year";

constants.PROFILE_TYPE = {
  INVOICE: { color: null, label: true, value: 1 },
  RECEIPT: { color: null, label: true, value: 2 }
};
constants.PROFILE_TYPE_INVOICE = 1;
displayLookup['PROFILE_TYPE.1'] = "invoice";
constants.PROFILE_TYPE_RECEIPT = 2;
displayLookup['PROFILE_TYPE.2'] = "receipt";

constants.PURCHASE_ORDER_CSV_IDENTIFIER_MODE = {
  LOCAL_SKU: { color: null, label: true, value: 1 },
  SUPPLIER_SKU: { color: null, label: true, value: 2 },
  LOCAL_BARCODE: { color: null, label: true, value: 3 },
  SUPPLIER_BARCODE: { color: null, label: true, value: 4 },
  MANUFACTURER: { color: null, label: true, value: 5 }
};
constants.PURCHASE_ORDER_CSV_IDENTIFIER_MODE_LOCAL_SKU = 1;
displayLookup['PURCHASE_ORDER_CSV_IDENTIFIER_MODE.1'] = "local sku";
constants.PURCHASE_ORDER_CSV_IDENTIFIER_MODE_SUPPLIER_SKU = 2;
displayLookup['PURCHASE_ORDER_CSV_IDENTIFIER_MODE.2'] = "supplier sku";
constants.PURCHASE_ORDER_CSV_IDENTIFIER_MODE_LOCAL_BARCODE = 3;
displayLookup['PURCHASE_ORDER_CSV_IDENTIFIER_MODE.3'] = "local barcode";
constants.PURCHASE_ORDER_CSV_IDENTIFIER_MODE_SUPPLIER_BARCODE = 4;
displayLookup['PURCHASE_ORDER_CSV_IDENTIFIER_MODE.4'] = "supplier barcode";
constants.PURCHASE_ORDER_CSV_IDENTIFIER_MODE_MANUFACTURER = 5;
displayLookup['PURCHASE_ORDER_CSV_IDENTIFIER_MODE.5'] = "manufacturer";

constants.PURCHASE_ORDER_CSV_QUANTITY_MODE = {
  REPLENISHMENT: { color: null, label: true, value: 1 },
  SUM_QUANTITY: { color: null, label: true, value: 2 }
};
constants.PURCHASE_ORDER_CSV_QUANTITY_MODE_REPLENISHMENT = 1;
displayLookup['PURCHASE_ORDER_CSV_QUANTITY_MODE.1'] = "replenishment";
constants.PURCHASE_ORDER_CSV_QUANTITY_MODE_SUM_QUANTITY = 2;
displayLookup['PURCHASE_ORDER_CSV_QUANTITY_MODE.2'] = "sum quantity";

constants.PURCHASE_ORDER_ITEM_QUANTITY_ROUNDING = {
  UP: { color: null, label: true, value: 1 },
  DOWN: { color: null, label: true, value: 2 },
  NONE: { color: null, label: true, value: 3 }
};
constants.PURCHASE_ORDER_ITEM_QUANTITY_ROUNDING_UP = 1;
displayLookup['PURCHASE_ORDER_ITEM_QUANTITY_ROUNDING.1'] = "up";
constants.PURCHASE_ORDER_ITEM_QUANTITY_ROUNDING_DOWN = 2;
displayLookup['PURCHASE_ORDER_ITEM_QUANTITY_ROUNDING.2'] = "down";
constants.PURCHASE_ORDER_ITEM_QUANTITY_ROUNDING_NONE = 3;
displayLookup['PURCHASE_ORDER_ITEM_QUANTITY_ROUNDING.3'] = "none";

constants.PURCHASE_ORDER_PLAN_STATUS = {
  OPEN: { color: null, label: true, value: 1 },
  FINISHED: { color: null, label: true, value: 2 }
};
constants.PURCHASE_ORDER_PLAN_STATUS_OPEN = 1;
displayLookup['PURCHASE_ORDER_PLAN_STATUS.1'] = "open";
constants.PURCHASE_ORDER_PLAN_STATUS_FINISHED = 2;
displayLookup['PURCHASE_ORDER_PLAN_STATUS.2'] = "finished";

constants.PURCHASE_ORDER_RECEIVED_STATUS = {
  WAITING: { color: "#e5e5e5", label: true, value: 1 },
  PARTIALLY: { color: "#ffb74d", label: true, value: 50 },
  FULLY: { color: "#66bb6a", label: true, value: 100 }
};
constants.PURCHASE_ORDER_RECEIVED_STATUS_WAITING = 1;
displayLookup['PURCHASE_ORDER_RECEIVED_STATUS.1'] = "waiting";
colorLookup['PURCHASE_ORDER_RECEIVED_STATUS.1'] = "#e5e5e5";
colorNameLookup['PURCHASE_ORDER_RECEIVED_STATUS.1'] = "GREY";
constants.PURCHASE_ORDER_RECEIVED_STATUS_PARTIALLY = 50;
displayLookup['PURCHASE_ORDER_RECEIVED_STATUS.50'] = "partially";
colorLookup['PURCHASE_ORDER_RECEIVED_STATUS.50'] = "#ffb74d";
colorNameLookup['PURCHASE_ORDER_RECEIVED_STATUS.50'] = "YELLOW";
constants.PURCHASE_ORDER_RECEIVED_STATUS_FULLY = 100;
displayLookup['PURCHASE_ORDER_RECEIVED_STATUS.100'] = "fully";
colorLookup['PURCHASE_ORDER_RECEIVED_STATUS.100'] = "#66bb6a";
colorNameLookup['PURCHASE_ORDER_RECEIVED_STATUS.100'] = "GREEN";

constants.PURCHASE_ORDER_SOURCE = {
  LOCAL: { color: null, label: true, value: 1 },
  INVENTORY_PLANNER: { color: null, label: "IP", value: 50 }
};
constants.PURCHASE_ORDER_SOURCE_LOCAL = 1;
displayLookup['PURCHASE_ORDER_SOURCE.1'] = "local";
constants.PURCHASE_ORDER_SOURCE_INVENTORY_PLANNER = 50;
displayLookup['PURCHASE_ORDER_SOURCE.50'] = "IP";

constants.PURCHASE_ORDER_STATUS = {
  WAITING: { color: "#e5e5e5", label: true, value: 1 },
  SENDING: { color: "#64b5f6", label: true, value: 2 },
  SENT: { color: "#162256", label: "email sent", value: 50 },
  CONFIRMED: { color: "#fff74d", label: true, value: 100 },
  IN_PROGRESS: { color: "#ffb74d", label: true, value: 150 },
  DONE: { color: "#66bb6a", label: true, value: 200 },
  MERGED: { color: "#a9a9a9", label: true, value: 250 }
};
constants.PURCHASE_ORDER_STATUS_WAITING = 1;
displayLookup['PURCHASE_ORDER_STATUS.1'] = "waiting";
colorLookup['PURCHASE_ORDER_STATUS.1'] = "#e5e5e5";
colorNameLookup['PURCHASE_ORDER_STATUS.1'] = "GREY";
constants.PURCHASE_ORDER_STATUS_SENDING = 2;
displayLookup['PURCHASE_ORDER_STATUS.2'] = "sending";
colorLookup['PURCHASE_ORDER_STATUS.2'] = "#64b5f6";
colorNameLookup['PURCHASE_ORDER_STATUS.2'] = "BLUE";
constants.PURCHASE_ORDER_STATUS_SENT = 50;
displayLookup['PURCHASE_ORDER_STATUS.50'] = "email sent";
colorLookup['PURCHASE_ORDER_STATUS.50'] = "#162256";
colorNameLookup['PURCHASE_ORDER_STATUS.50'] = "DARK_BLUE";
constants.PURCHASE_ORDER_STATUS_CONFIRMED = 100;
displayLookup['PURCHASE_ORDER_STATUS.100'] = "confirmed";
colorLookup['PURCHASE_ORDER_STATUS.100'] = "#fff74d";
colorNameLookup['PURCHASE_ORDER_STATUS.100'] = "LIGHT_YELLOW";
constants.PURCHASE_ORDER_STATUS_IN_PROGRESS = 150;
displayLookup['PURCHASE_ORDER_STATUS.150'] = "in progress";
colorLookup['PURCHASE_ORDER_STATUS.150'] = "#ffb74d";
colorNameLookup['PURCHASE_ORDER_STATUS.150'] = "YELLOW";
constants.PURCHASE_ORDER_STATUS_DONE = 200;
displayLookup['PURCHASE_ORDER_STATUS.200'] = "done";
colorLookup['PURCHASE_ORDER_STATUS.200'] = "#66bb6a";
colorNameLookup['PURCHASE_ORDER_STATUS.200'] = "GREEN";
constants.PURCHASE_ORDER_STATUS_MERGED = 250;
displayLookup['PURCHASE_ORDER_STATUS.250'] = "merged";
colorLookup['PURCHASE_ORDER_STATUS.250'] = "#a9a9a9";
colorNameLookup['PURCHASE_ORDER_STATUS.250'] = "DARK_GREY";

constants.QUERY_BOOLEAN_FORMAT = {
  BINARY: { color: null, label: true, value: "binary" },
  HUMAN_FRIENDLY: { color: null, label: true, value: "human_friendly" }
};
constants.QUERY_BOOLEAN_FORMAT_BINARY = "binary";
displayLookup['QUERY_BOOLEAN_FORMAT."binary"'] = "binary";
constants.QUERY_BOOLEAN_FORMAT_HUMAN_FRIENDLY = "human_friendly";
displayLookup['QUERY_BOOLEAN_FORMAT."human_friendly"'] = "human friendly";

constants.QUERY_COUNTRY_FORMAT = {
  CODE: { color: null, label: true, value: "code" },
  HUMAN_FRIENDLY: { color: null, label: true, value: "human_friendly" }
};
constants.QUERY_COUNTRY_FORMAT_CODE = "code";
displayLookup['QUERY_COUNTRY_FORMAT."code"'] = "code";
constants.QUERY_COUNTRY_FORMAT_HUMAN_FRIENDLY = "human_friendly";
displayLookup['QUERY_COUNTRY_FORMAT."human_friendly"'] = "human friendly";

constants.QUERY_CURRENCY_FORMAT = {
  SYMBOL: { color: null, label: [true], value: "symbol" },
  CODE: { color: null, label: [true], value: "code" }
};
constants.QUERY_CURRENCY_FORMAT_SYMBOL = "symbol";
displayLookup['QUERY_CURRENCY_FORMAT."symbol"'] = ["query currency format", "symbol"];
constants.QUERY_CURRENCY_FORMAT_CODE = "code";
displayLookup['QUERY_CURRENCY_FORMAT."code"'] = ["query currency format", "code"];

constants.QUERY_ENUM_FORMAT = {
  VALUE: { color: null, label: true, value: "value" },
  TECHNICAL: { color: null, label: true, value: "technical" },
  HUMAN_FRIENDLY: { color: null, label: true, value: "human_friendly" }
};
constants.QUERY_ENUM_FORMAT_VALUE = "value";
displayLookup['QUERY_ENUM_FORMAT."value"'] = "value";
constants.QUERY_ENUM_FORMAT_TECHNICAL = "technical";
displayLookup['QUERY_ENUM_FORMAT."technical"'] = "technical";
constants.QUERY_ENUM_FORMAT_HUMAN_FRIENDLY = "human_friendly";
displayLookup['QUERY_ENUM_FORMAT."human_friendly"'] = "human friendly";

constants.QUERY_LABEL_FORMAT = {
  TECHNICAL: { color: null, label: true, value: "technical" },
  HUMAN_FRIENDLY: { color: null, label: true, value: "human_friendly" }
};
constants.QUERY_LABEL_FORMAT_TECHNICAL = "technical";
displayLookup['QUERY_LABEL_FORMAT."technical"'] = "technical";
constants.QUERY_LABEL_FORMAT_HUMAN_FRIENDLY = "human_friendly";
displayLookup['QUERY_LABEL_FORMAT."human_friendly"'] = "human friendly";

constants.QUERY_MONEY_FORMAT = {
  FLOAT: { color: null, label: [true], value: "float" },
  DECIMAL: { color: null, label: [true], value: "decimal" },
  OBJECT: { color: null, label: [true], value: "object" },
  FORMATTED: { color: null, label: [true], value: "formatted" }
};
constants.QUERY_MONEY_FORMAT_FLOAT = "float";
displayLookup['QUERY_MONEY_FORMAT."float"'] = ["query money format", "float"];
constants.QUERY_MONEY_FORMAT_DECIMAL = "decimal";
displayLookup['QUERY_MONEY_FORMAT."decimal"'] = ["query money format", "decimal"];
constants.QUERY_MONEY_FORMAT_OBJECT = "object";
displayLookup['QUERY_MONEY_FORMAT."object"'] = ["query money format", "object"];
constants.QUERY_MONEY_FORMAT_FORMATTED = "formatted";
displayLookup['QUERY_MONEY_FORMAT."formatted"'] = ["query money format", "formatted"];

constants.QUERY_MONEY_ROUNDING = {
  THOUSAND: { color: null, label: [true], value: "thousand" },
  MILLION: { color: null, label: [true], value: "million" }
};
constants.QUERY_MONEY_ROUNDING_THOUSAND = "thousand";
displayLookup['QUERY_MONEY_ROUNDING."thousand"'] = ["query money rounding", "thousand"];
constants.QUERY_MONEY_ROUNDING_MILLION = "million";
displayLookup['QUERY_MONEY_ROUNDING."million"'] = ["query money rounding", "million"];

constants.QUERY_NESTED_FILTER_EXECUTION_MODE = {
  INNER: { color: null, label: true, value: "inner" },
  OUTER: { color: null, label: true, value: "outer" },
  BOTH: { color: null, label: true, value: "both" }
};
constants.QUERY_NESTED_FILTER_EXECUTION_MODE_INNER = "inner";
displayLookup['QUERY_NESTED_FILTER_EXECUTION_MODE."inner"'] = "inner";
constants.QUERY_NESTED_FILTER_EXECUTION_MODE_OUTER = "outer";
displayLookup['QUERY_NESTED_FILTER_EXECUTION_MODE."outer"'] = "outer";
constants.QUERY_NESTED_FILTER_EXECUTION_MODE_BOTH = "both";
displayLookup['QUERY_NESTED_FILTER_EXECUTION_MODE."both"'] = "both";

constants.QUERY_NUMBER_FORMAT = {
  FLOAT: { color: null, label: true, value: "float" },
  DECIMAL: { color: null, label: true, value: "decimal" },
  HUMAN_FRIENDLY: { color: null, label: true, value: "human_friendly" }
};
constants.QUERY_NUMBER_FORMAT_FLOAT = "float";
displayLookup['QUERY_NUMBER_FORMAT."float"'] = "float";
constants.QUERY_NUMBER_FORMAT_DECIMAL = "decimal";
displayLookup['QUERY_NUMBER_FORMAT."decimal"'] = "decimal";
constants.QUERY_NUMBER_FORMAT_HUMAN_FRIENDLY = "human_friendly";
displayLookup['QUERY_NUMBER_FORMAT."human_friendly"'] = "human friendly";

constants.QUOTE_EVENT_TYPE = {
  CREATED: { color: null, label: true, value: 1 },
  EDITED: { color: null, label: true, value: 2 },
  STATUS_CHANGED: { color: null, label: true, value: 3 },
  PDF_GENERATED: { color: null, label: true, value: 4 },
  EMAIL_SENT: { color: null, label: true, value: 5 },
  ORDER_CREATED: { color: null, label: true, value: 6 },
  DELETED: { color: null, label: true, value: 7 },
  WAREHOUSE_OPERATION_CREATED: { color: null, label: true, value: 8 }
};
constants.QUOTE_EVENT_TYPE_CREATED = 1;
displayLookup['QUOTE_EVENT_TYPE.1'] = "created";
constants.QUOTE_EVENT_TYPE_EDITED = 2;
displayLookup['QUOTE_EVENT_TYPE.2'] = "edited";
constants.QUOTE_EVENT_TYPE_STATUS_CHANGED = 3;
displayLookup['QUOTE_EVENT_TYPE.3'] = "status changed";
constants.QUOTE_EVENT_TYPE_PDF_GENERATED = 4;
displayLookup['QUOTE_EVENT_TYPE.4'] = "pdf generated";
constants.QUOTE_EVENT_TYPE_EMAIL_SENT = 5;
displayLookup['QUOTE_EVENT_TYPE.5'] = "email sent";
constants.QUOTE_EVENT_TYPE_ORDER_CREATED = 6;
displayLookup['QUOTE_EVENT_TYPE.6'] = "order created";
constants.QUOTE_EVENT_TYPE_DELETED = 7;
displayLookup['QUOTE_EVENT_TYPE.7'] = "deleted";
constants.QUOTE_EVENT_TYPE_WAREHOUSE_OPERATION_CREATED = 8;
displayLookup['QUOTE_EVENT_TYPE.8'] = "warehouse operation created";

constants.QUOTE_ITEM_LIST_SHOW_COLUMN = {
  SECONDARY_UNIT: { color: null, label: true, value: 1 },
  SECONDARY_UNIT_NET_PRICE: { color: null, label: true, value: 2 },
  SECONDARY_UNIT_GROSS_PRICE: { color: null, label: true, value: 3 },
  WEIGHT: { color: null, label: true, value: 4 },
  VOLUME: { color: null, label: true, value: 5 }
};
constants.QUOTE_ITEM_LIST_SHOW_COLUMN_SECONDARY_UNIT = 1;
displayLookup['QUOTE_ITEM_LIST_SHOW_COLUMN.1'] = "secondary unit";
constants.QUOTE_ITEM_LIST_SHOW_COLUMN_SECONDARY_UNIT_NET_PRICE = 2;
displayLookup['QUOTE_ITEM_LIST_SHOW_COLUMN.2'] = "secondary unit net price";
constants.QUOTE_ITEM_LIST_SHOW_COLUMN_SECONDARY_UNIT_GROSS_PRICE = 3;
displayLookup['QUOTE_ITEM_LIST_SHOW_COLUMN.3'] = "secondary unit gross price";
constants.QUOTE_ITEM_LIST_SHOW_COLUMN_WEIGHT = 4;
displayLookup['QUOTE_ITEM_LIST_SHOW_COLUMN.4'] = "weight";
constants.QUOTE_ITEM_LIST_SHOW_COLUMN_VOLUME = 5;
displayLookup['QUOTE_ITEM_LIST_SHOW_COLUMN.5'] = "volume";

constants.QUOTE_ITEM_MARKUP_BASE = {
  DEFAULT_SUPPLIER_NET_PRICE: { color: null, label: true, value: 1 },
  AVERAGE_LANDED_COST: { color: null, label: true, value: 2 },
  LAST_LANDED_COST: { color: null, label: true, value: 3 }
};
constants.QUOTE_ITEM_MARKUP_BASE_DEFAULT_SUPPLIER_NET_PRICE = 1;
displayLookup['QUOTE_ITEM_MARKUP_BASE.1'] = "default supplier net price";
constants.QUOTE_ITEM_MARKUP_BASE_AVERAGE_LANDED_COST = 2;
displayLookup['QUOTE_ITEM_MARKUP_BASE.2'] = "average landed cost";
constants.QUOTE_ITEM_MARKUP_BASE_LAST_LANDED_COST = 3;
displayLookup['QUOTE_ITEM_MARKUP_BASE.3'] = "last landed cost";

constants.QUOTE_LINE_ITEM_TYPE = {
  NORMAL: { color: null, label: [true], value: 1 },
  FEE: { color: null, label: [true], value: 3 },
  SHIPPING_FEE: { color: null, label: [true], value: 4 },
  DISCOUNT: { color: null, label: [true], value: 5 }
};
constants.QUOTE_LINE_ITEM_TYPE_NORMAL = 1;
displayLookup['QUOTE_LINE_ITEM_TYPE.1'] = ["quote line item type", "normal"];
constants.QUOTE_LINE_ITEM_TYPE_FEE = 3;
displayLookup['QUOTE_LINE_ITEM_TYPE.3'] = ["quote line item type", "fee"];
constants.QUOTE_LINE_ITEM_TYPE_SHIPPING_FEE = 4;
displayLookup['QUOTE_LINE_ITEM_TYPE.4'] = ["quote line item type", "shipping fee"];
constants.QUOTE_LINE_ITEM_TYPE_DISCOUNT = 5;
displayLookup['QUOTE_LINE_ITEM_TYPE.5'] = ["quote line item type", "discount"];

constants.QUOTE_TEMPLATE_TYPE = {
  BODY: { color: null, label: true, value: 1 },
  FOOTER: { color: null, label: true, value: 2 },
  EMAIL_BODY: { color: null, label: true, value: 3 }
};
constants.QUOTE_TEMPLATE_TYPE_BODY = 1;
displayLookup['QUOTE_TEMPLATE_TYPE.1'] = "body";
constants.QUOTE_TEMPLATE_TYPE_FOOTER = 2;
displayLookup['QUOTE_TEMPLATE_TYPE.2'] = "footer";
constants.QUOTE_TEMPLATE_TYPE_EMAIL_BODY = 3;
displayLookup['QUOTE_TEMPLATE_TYPE.3'] = "email body";

constants.RELATIVE_RANGE_UNIT = {
  MINUTE: { color: null, label: true, value: "m" },
  HOUR: { color: null, label: true, value: "h" },
  DAY: { color: null, label: true, value: "d" },
  WEEK: { color: null, label: true, value: "w" },
  MONTH: { color: null, label: true, value: "mo" },
  YEAR: { color: null, label: true, value: "y" }
};
constants.RELATIVE_RANGE_UNIT_MINUTE = "m";
displayLookup['RELATIVE_RANGE_UNIT."m"'] = "minute";
constants.RELATIVE_RANGE_UNIT_HOUR = "h";
displayLookup['RELATIVE_RANGE_UNIT."h"'] = "hour";
constants.RELATIVE_RANGE_UNIT_DAY = "d";
displayLookup['RELATIVE_RANGE_UNIT."d"'] = "day";
constants.RELATIVE_RANGE_UNIT_WEEK = "w";
displayLookup['RELATIVE_RANGE_UNIT."w"'] = "week";
constants.RELATIVE_RANGE_UNIT_MONTH = "mo";
displayLookup['RELATIVE_RANGE_UNIT."mo"'] = "month";
constants.RELATIVE_RANGE_UNIT_YEAR = "y";
displayLookup['RELATIVE_RANGE_UNIT."y"'] = "year";

constants.RESOURCE_ACTION_PRIORITY = {
  LOWEST: { color: null, label: null, value: 1 },
  LOW: { color: null, label: null, value: 2 },
  MEDIUM: { color: null, label: null, value: 3 },
  HIGH: { color: null, label: null, value: 4 },
  HIGHEST: { color: null, label: null, value: 5 }
};
constants.RESOURCE_ACTION_PRIORITY_LOWEST = 1;
constants.RESOURCE_ACTION_PRIORITY_LOW = 2;
constants.RESOURCE_ACTION_PRIORITY_MEDIUM = 3;
constants.RESOURCE_ACTION_PRIORITY_HIGH = 4;
constants.RESOURCE_ACTION_PRIORITY_HIGHEST = 5;

constants.RESOURCE_ACTION_TARGET = {
  NONE: { color: null, label: null, value: 1 },
  SINGLE: { color: null, label: null, value: 2 },
  MULTI: { color: null, label: null, value: 3 },
  ANY: { color: null, label: null, value: 4 }
};
constants.RESOURCE_ACTION_TARGET_NONE = 1;
constants.RESOURCE_ACTION_TARGET_SINGLE = 2;
constants.RESOURCE_ACTION_TARGET_MULTI = 3;
constants.RESOURCE_ACTION_TARGET_ANY = 4;

constants.RESOURCE_EVENT_TYPE = {
  CREATED: { color: null, label: null, value: "created" },
  UPDATED: { color: null, label: null, value: "updated" },
  DELETED: { color: null, label: null, value: "deleted" },
  COMPLETED: { color: null, label: null, value: "completed" },
  BALANCE_CHANGED: { color: null, label: null, value: "balance_changed" },
  IDENTIFICATION_STATUS_CHANGED: { color: null, label: null, value: "identification_status_changed" },
  SUBMITTED_TO_CASH_REGISTER: { color: null, label: null, value: "submitted_to_cash_register" },
  AI_PROCESSING_STARTED: { color: null, label: null, value: "ai_processing_started" },
  IMPORTED_FROM: { color: null, label: null, value: "imported_from" },
  IMPORT_POSTPROCESS_FAILED: { color: null, label: null, value: "import_postprocess_failed" },
  IMPORT_POSTPROCESS_SUCCESS: { color: null, label: null, value: "import_postprocess_success" },
  TRANSACTION_SYNC_SUCCESS: { color: null, label: null, value: "transaction_sync_success" }
};
constants.RESOURCE_EVENT_TYPE_CREATED = "created";
constants.RESOURCE_EVENT_TYPE_UPDATED = "updated";
constants.RESOURCE_EVENT_TYPE_DELETED = "deleted";
constants.RESOURCE_EVENT_TYPE_COMPLETED = "completed";
constants.RESOURCE_EVENT_TYPE_BALANCE_CHANGED = "balance_changed";
constants.RESOURCE_EVENT_TYPE_IDENTIFICATION_STATUS_CHANGED = "identification_status_changed";
constants.RESOURCE_EVENT_TYPE_SUBMITTED_TO_CASH_REGISTER = "submitted_to_cash_register";
constants.RESOURCE_EVENT_TYPE_AI_PROCESSING_STARTED = "ai_processing_started";
constants.RESOURCE_EVENT_TYPE_IMPORTED_FROM = "imported_from";
constants.RESOURCE_EVENT_TYPE_IMPORT_POSTPROCESS_FAILED = "import_postprocess_failed";
constants.RESOURCE_EVENT_TYPE_IMPORT_POSTPROCESS_SUCCESS = "import_postprocess_success";
constants.RESOURCE_EVENT_TYPE_TRANSACTION_SYNC_SUCCESS = "transaction_sync_success";

constants.RESOURCE_FIELD_AGGREGATION_TYPE = {
  SUM: { color: null, label: [true], value: "sum" },
  COUNT: { color: null, label: [true], value: "count" },
  MAX: { color: null, label: [true], value: "max" },
  MIN: { color: null, label: [true], value: "min" },
  AVG: { color: null, label: [true], value: "avg" }
};
constants.RESOURCE_FIELD_AGGREGATION_TYPE_SUM = "sum";
displayLookup['RESOURCE_FIELD_AGGREGATION_TYPE."sum"'] = ["resource field aggregation type", "sum"];
constants.RESOURCE_FIELD_AGGREGATION_TYPE_COUNT = "count";
displayLookup['RESOURCE_FIELD_AGGREGATION_TYPE."count"'] = ["resource field aggregation type", "count"];
constants.RESOURCE_FIELD_AGGREGATION_TYPE_MAX = "max";
displayLookup['RESOURCE_FIELD_AGGREGATION_TYPE."max"'] = ["resource field aggregation type", "max"];
constants.RESOURCE_FIELD_AGGREGATION_TYPE_MIN = "min";
displayLookup['RESOURCE_FIELD_AGGREGATION_TYPE."min"'] = ["resource field aggregation type", "min"];
constants.RESOURCE_FIELD_AGGREGATION_TYPE_AVG = "avg";
displayLookup['RESOURCE_FIELD_AGGREGATION_TYPE."avg"'] = ["resource field aggregation type", "avg"];

constants.RESOURCE_FIELD_DATA_TYPE = {
  INTEGER: { color: null, label: null, value: 1 },
  UUID: { color: null, label: null, value: 2 },
  STRING: { color: null, label: null, value: 3 },
  DATE: { color: null, label: null, value: 4 }
};
constants.RESOURCE_FIELD_DATA_TYPE_INTEGER = 1;
constants.RESOURCE_FIELD_DATA_TYPE_UUID = 2;
constants.RESOURCE_FIELD_DATA_TYPE_STRING = 3;
constants.RESOURCE_FIELD_DATA_TYPE_DATE = 4;

constants.RESOURCE_FIELD_TYPE = {
  ACTION: { color: null, label: true, value: -1 },
  SYSTEM: { color: null, label: true, value: 1 },
  ID: { color: null, label: true, value: 2 },
  HUMAN_ID: { color: null, label: true, value: 3 },
  TEXT: { color: null, label: true, value: 4 },
  LONG_TEXT: { color: null, label: true, value: 5 },
  RICH_TEXT: { color: null, label: true, value: 6 },
  EMAIL: { color: null, label: true, value: 7 },
  PHONE: { color: null, label: true, value: 8 },
  COUNTRY: { color: null, label: true, value: 9 },
  URL: { color: null, label: true, value: 10 },
  INTEGER: { color: null, label: true, value: 11 },
  DECIMAL: { color: null, label: true, value: 12 },
  MONEY: { color: null, label: true, value: 13 },
  CURRENCY: { color: null, label: true, value: 14 },
  ENUM: { color: null, label: true, value: 15 },
  REFERENCE: { color: null, label: true, value: 16 },
  REVERSE_REFERENCE: { color: null, label: true, value: 17 },
  REMOTE_REFERENCE: { color: null, label: true, value: 18 },
  DATE: { color: null, label: true, value: 19 },
  DATETIME: { color: null, label: true, value: 20 },
  BOOLEAN: { color: null, label: true, value: 21 },
  FILE: { color: null, label: true, value: 22 },
  IMAGE: { color: null, label: true, value: 23 },
  LIST: { color: null, label: true, value: 24 },
  FILTER: { color: null, label: true, value: 25 },
  USER_REFERENCE: { color: null, label: true, value: 26 },
  USER_ID: { color: null, label: true, value: 27 },
  CUSTOM_DATA: { color: null, label: true, value: 28 },
  SUPPLIER_REFERENCE: { color: null, label: true, value: 29 },
  M2M_REFERENCE: { color: null, label: true, value: 30 },
  M2M_SUPPLIER_REFERENCE: { color: null, label: true, value: 31 },
  M2M_USER_REFERENCE: { color: null, label: true, value: 32 },
  PERCENTAGE: { color: null, label: true, value: 33 }
};
constants.RESOURCE_FIELD_TYPE_ACTION = -1;
displayLookup['RESOURCE_FIELD_TYPE.-1'] = "action";
constants.RESOURCE_FIELD_TYPE_SYSTEM = 1;
displayLookup['RESOURCE_FIELD_TYPE.1'] = "system";
constants.RESOURCE_FIELD_TYPE_ID = 2;
displayLookup['RESOURCE_FIELD_TYPE.2'] = "id";
constants.RESOURCE_FIELD_TYPE_HUMAN_ID = 3;
displayLookup['RESOURCE_FIELD_TYPE.3'] = "human id";
constants.RESOURCE_FIELD_TYPE_TEXT = 4;
displayLookup['RESOURCE_FIELD_TYPE.4'] = "text";
constants.RESOURCE_FIELD_TYPE_LONG_TEXT = 5;
displayLookup['RESOURCE_FIELD_TYPE.5'] = "long text";
constants.RESOURCE_FIELD_TYPE_RICH_TEXT = 6;
displayLookup['RESOURCE_FIELD_TYPE.6'] = "rich text";
constants.RESOURCE_FIELD_TYPE_EMAIL = 7;
displayLookup['RESOURCE_FIELD_TYPE.7'] = "email";
constants.RESOURCE_FIELD_TYPE_PHONE = 8;
displayLookup['RESOURCE_FIELD_TYPE.8'] = "phone";
constants.RESOURCE_FIELD_TYPE_COUNTRY = 9;
displayLookup['RESOURCE_FIELD_TYPE.9'] = "country";
constants.RESOURCE_FIELD_TYPE_URL = 10;
displayLookup['RESOURCE_FIELD_TYPE.10'] = "url";
constants.RESOURCE_FIELD_TYPE_INTEGER = 11;
displayLookup['RESOURCE_FIELD_TYPE.11'] = "integer";
constants.RESOURCE_FIELD_TYPE_DECIMAL = 12;
displayLookup['RESOURCE_FIELD_TYPE.12'] = "decimal";
constants.RESOURCE_FIELD_TYPE_MONEY = 13;
displayLookup['RESOURCE_FIELD_TYPE.13'] = "money";
constants.RESOURCE_FIELD_TYPE_CURRENCY = 14;
displayLookup['RESOURCE_FIELD_TYPE.14'] = "currency";
constants.RESOURCE_FIELD_TYPE_ENUM = 15;
displayLookup['RESOURCE_FIELD_TYPE.15'] = "enum";
constants.RESOURCE_FIELD_TYPE_REFERENCE = 16;
displayLookup['RESOURCE_FIELD_TYPE.16'] = "reference";
constants.RESOURCE_FIELD_TYPE_REVERSE_REFERENCE = 17;
displayLookup['RESOURCE_FIELD_TYPE.17'] = "reverse reference";
constants.RESOURCE_FIELD_TYPE_REMOTE_REFERENCE = 18;
displayLookup['RESOURCE_FIELD_TYPE.18'] = "remote reference";
constants.RESOURCE_FIELD_TYPE_DATE = 19;
displayLookup['RESOURCE_FIELD_TYPE.19'] = "date";
constants.RESOURCE_FIELD_TYPE_DATETIME = 20;
displayLookup['RESOURCE_FIELD_TYPE.20'] = "datetime";
constants.RESOURCE_FIELD_TYPE_BOOLEAN = 21;
displayLookup['RESOURCE_FIELD_TYPE.21'] = "boolean";
constants.RESOURCE_FIELD_TYPE_FILE = 22;
displayLookup['RESOURCE_FIELD_TYPE.22'] = "file";
constants.RESOURCE_FIELD_TYPE_IMAGE = 23;
displayLookup['RESOURCE_FIELD_TYPE.23'] = "image";
constants.RESOURCE_FIELD_TYPE_LIST = 24;
displayLookup['RESOURCE_FIELD_TYPE.24'] = "list";
constants.RESOURCE_FIELD_TYPE_FILTER = 25;
displayLookup['RESOURCE_FIELD_TYPE.25'] = "filter";
constants.RESOURCE_FIELD_TYPE_USER_REFERENCE = 26;
displayLookup['RESOURCE_FIELD_TYPE.26'] = "user reference";
constants.RESOURCE_FIELD_TYPE_USER_ID = 27;
displayLookup['RESOURCE_FIELD_TYPE.27'] = "user id";
constants.RESOURCE_FIELD_TYPE_CUSTOM_DATA = 28;
displayLookup['RESOURCE_FIELD_TYPE.28'] = "custom data";
constants.RESOURCE_FIELD_TYPE_SUPPLIER_REFERENCE = 29;
displayLookup['RESOURCE_FIELD_TYPE.29'] = "supplier reference";
constants.RESOURCE_FIELD_TYPE_M2M_REFERENCE = 30;
displayLookup['RESOURCE_FIELD_TYPE.30'] = "m2m reference";
constants.RESOURCE_FIELD_TYPE_M2M_SUPPLIER_REFERENCE = 31;
displayLookup['RESOURCE_FIELD_TYPE.31'] = "m2m supplier reference";
constants.RESOURCE_FIELD_TYPE_M2M_USER_REFERENCE = 32;
displayLookup['RESOURCE_FIELD_TYPE.32'] = "m2m user reference";
constants.RESOURCE_FIELD_TYPE_PERCENTAGE = 33;
displayLookup['RESOURCE_FIELD_TYPE.33'] = "percentage";

constants.RESOURCE_FILTER_CONNECTOR = {
  AND: { color: null, label: null, value: "and" },
  OR: { color: null, label: null, value: "or" }
};
constants.RESOURCE_FILTER_CONNECTOR_AND = "and";
constants.RESOURCE_FILTER_CONNECTOR_OR = "or";

constants.RESOURCE_FILTER_LOOKUP = {
  DEFAULT: { color: null, label: null, value: "" },
  NOT: { color: null, label: [true], value: "not" },
  HAS_VALUE: { color: null, label: [true], value: "has_value" },
  SEARCH: { color: null, label: [true], value: "search" },
  REGEX: { color: null, label: [true], value: "regex" },
  STARTSWITH: { color: null, label: [true], value: "startswith" },
  ENDSWITH: { color: null, label: [true], value: "endswith" },
  EQ: { color: null, label: [true], value: "eq" },
  GT: { color: null, label: [true], value: "gt" },
  GTE: { color: null, label: [true], value: "gte" },
  LT: { color: null, label: [true], value: "lt" },
  LTE: { color: null, label: [true], value: "lte" },
  RANGE: { color: null, label: [true], value: "range" },
  CONTAINS_ANY: { color: null, label: [true], value: "contains_any" },
  CONTAINS_ALL: { color: null, label: [true], value: "contains_all" },
  CONTAINS_EXACT: { color: null, label: [true], value: "contains_exact" }
};
constants.RESOURCE_FILTER_LOOKUP_DEFAULT = "";
constants.RESOURCE_FILTER_LOOKUP_NOT = "not";
displayLookup['RESOURCE_FILTER_LOOKUP."not"'] = ["resource filter lookup", "not"];
constants.RESOURCE_FILTER_LOOKUP_HAS_VALUE = "has_value";
displayLookup['RESOURCE_FILTER_LOOKUP."has_value"'] = ["resource filter lookup", "has value"];
constants.RESOURCE_FILTER_LOOKUP_SEARCH = "search";
displayLookup['RESOURCE_FILTER_LOOKUP."search"'] = ["resource filter lookup", "search"];
constants.RESOURCE_FILTER_LOOKUP_REGEX = "regex";
displayLookup['RESOURCE_FILTER_LOOKUP."regex"'] = ["resource filter lookup", "regex"];
constants.RESOURCE_FILTER_LOOKUP_STARTSWITH = "startswith";
displayLookup['RESOURCE_FILTER_LOOKUP."startswith"'] = ["resource filter lookup", "startswith"];
constants.RESOURCE_FILTER_LOOKUP_ENDSWITH = "endswith";
displayLookup['RESOURCE_FILTER_LOOKUP."endswith"'] = ["resource filter lookup", "endswith"];
constants.RESOURCE_FILTER_LOOKUP_EQ = "eq";
displayLookup['RESOURCE_FILTER_LOOKUP."eq"'] = ["resource filter lookup", "eq"];
constants.RESOURCE_FILTER_LOOKUP_GT = "gt";
displayLookup['RESOURCE_FILTER_LOOKUP."gt"'] = ["resource filter lookup", "gt"];
constants.RESOURCE_FILTER_LOOKUP_GTE = "gte";
displayLookup['RESOURCE_FILTER_LOOKUP."gte"'] = ["resource filter lookup", "gte"];
constants.RESOURCE_FILTER_LOOKUP_LT = "lt";
displayLookup['RESOURCE_FILTER_LOOKUP."lt"'] = ["resource filter lookup", "lt"];
constants.RESOURCE_FILTER_LOOKUP_LTE = "lte";
displayLookup['RESOURCE_FILTER_LOOKUP."lte"'] = ["resource filter lookup", "lte"];
constants.RESOURCE_FILTER_LOOKUP_RANGE = "range";
displayLookup['RESOURCE_FILTER_LOOKUP."range"'] = ["resource filter lookup", "range"];
constants.RESOURCE_FILTER_LOOKUP_CONTAINS_ANY = "contains_any";
displayLookup['RESOURCE_FILTER_LOOKUP."contains_any"'] = ["resource filter lookup", "contains any"];
constants.RESOURCE_FILTER_LOOKUP_CONTAINS_ALL = "contains_all";
displayLookup['RESOURCE_FILTER_LOOKUP."contains_all"'] = ["resource filter lookup", "contains all"];
constants.RESOURCE_FILTER_LOOKUP_CONTAINS_EXACT = "contains_exact";
displayLookup['RESOURCE_FILTER_LOOKUP."contains_exact"'] = ["resource filter lookup", "contains exact"];

constants.RESOURCE_PERMISSION_ACCESS_LEVEL = {
  NONE: { color: "#e57373", label: true, value: 0 },
  READ: { color: "#ffb74d", label: true, value: 1 },
  INITIALIZE: { color: "#64b5f6", label: true, value: 2 },
  WRITE: { color: "#66bb6a", label: true, value: 3 }
};
constants.RESOURCE_PERMISSION_ACCESS_LEVEL_NONE = 0;
displayLookup['RESOURCE_PERMISSION_ACCESS_LEVEL.0'] = "none";
colorLookup['RESOURCE_PERMISSION_ACCESS_LEVEL.0'] = "#e57373";
colorNameLookup['RESOURCE_PERMISSION_ACCESS_LEVEL.0'] = "RED";
constants.RESOURCE_PERMISSION_ACCESS_LEVEL_READ = 1;
displayLookup['RESOURCE_PERMISSION_ACCESS_LEVEL.1'] = "read";
colorLookup['RESOURCE_PERMISSION_ACCESS_LEVEL.1'] = "#ffb74d";
colorNameLookup['RESOURCE_PERMISSION_ACCESS_LEVEL.1'] = "YELLOW";
constants.RESOURCE_PERMISSION_ACCESS_LEVEL_INITIALIZE = 2;
displayLookup['RESOURCE_PERMISSION_ACCESS_LEVEL.2'] = "initialize";
colorLookup['RESOURCE_PERMISSION_ACCESS_LEVEL.2'] = "#64b5f6";
colorNameLookup['RESOURCE_PERMISSION_ACCESS_LEVEL.2'] = "BLUE";
constants.RESOURCE_PERMISSION_ACCESS_LEVEL_WRITE = 3;
displayLookup['RESOURCE_PERMISSION_ACCESS_LEVEL.3'] = "write";
colorLookup['RESOURCE_PERMISSION_ACCESS_LEVEL.3'] = "#66bb6a";
colorNameLookup['RESOURCE_PERMISSION_ACCESS_LEVEL.3'] = "GREEN";

constants.RESULT_CATEGORY = {
  UNCATEGORIZED_REVENUE: { color: "#e5e5e5", label: ["result category", "uncategorized revenue"], value: 0 },
  REVENUE: { color: "#66bb6a", label: ["result category", "revenue"], value: 1 },
  CM0_COGS: { color: "#64b5f6", label: ["result category", "contribution margin 0 (cogs)"], value: 2 },
  CM0_EPR: { color: "#162256", label: ["result category", "contribution margin 0.5 (epr)"], value: 3 },
  CM1: { color: "#ffb74d", label: ["result category", "contribution margin 1"], value: 4 },
  CM2: { color: "#ba68c8", label: ["result category", "contribution margin 2"], value: 5 },
  CM3: { color: "#f57c00", label: ["result category", "contribution margin 3"], value: 6 },
  CM4: { color: "#26a69a", label: ["result category", "contribution margin 4"], value: 7 },
  CM5: { color: "#f06292", label: ["result category", "contribution margin 5"], value: 8 },
  OPEX: { color: "#e57373", label: ["result category", "operational expenses"], value: 9 },
  UNCATEGORIZED_EXPENSE: { color: "#e5e5e5", label: ["result category", "uncategorized expense"], value: 100 },
  FINANCIAL_RESULT: { color: "#162256", label: ["result category", "financial operations result"], value: 101 }
};
constants.RESULT_CATEGORY_UNCATEGORIZED_REVENUE = 0;
displayLookup['RESULT_CATEGORY.0'] = ["result category", "uncategorized revenue"];
colorLookup['RESULT_CATEGORY.0'] = "#e5e5e5";
colorNameLookup['RESULT_CATEGORY.0'] = "GREY";
constants.RESULT_CATEGORY_REVENUE = 1;
displayLookup['RESULT_CATEGORY.1'] = ["result category", "revenue"];
colorLookup['RESULT_CATEGORY.1'] = "#66bb6a";
colorNameLookup['RESULT_CATEGORY.1'] = "GREEN";
constants.RESULT_CATEGORY_CM0_COGS = 2;
displayLookup['RESULT_CATEGORY.2'] = ["result category", "contribution margin 0 (cogs)"];
colorLookup['RESULT_CATEGORY.2'] = "#64b5f6";
colorNameLookup['RESULT_CATEGORY.2'] = "BLUE";
constants.RESULT_CATEGORY_CM0_EPR = 3;
displayLookup['RESULT_CATEGORY.3'] = ["result category", "contribution margin 0.5 (epr)"];
colorLookup['RESULT_CATEGORY.3'] = "#162256";
colorNameLookup['RESULT_CATEGORY.3'] = "DARK_BLUE";
constants.RESULT_CATEGORY_CM1 = 4;
displayLookup['RESULT_CATEGORY.4'] = ["result category", "contribution margin 1"];
colorLookup['RESULT_CATEGORY.4'] = "#ffb74d";
colorNameLookup['RESULT_CATEGORY.4'] = "YELLOW";
constants.RESULT_CATEGORY_CM2 = 5;
displayLookup['RESULT_CATEGORY.5'] = ["result category", "contribution margin 2"];
colorLookup['RESULT_CATEGORY.5'] = "#ba68c8";
colorNameLookup['RESULT_CATEGORY.5'] = "PURPLE";
constants.RESULT_CATEGORY_CM3 = 6;
displayLookup['RESULT_CATEGORY.6'] = ["result category", "contribution margin 3"];
colorLookup['RESULT_CATEGORY.6'] = "#f57c00";
colorNameLookup['RESULT_CATEGORY.6'] = "ORANGE";
constants.RESULT_CATEGORY_CM4 = 7;
displayLookup['RESULT_CATEGORY.7'] = ["result category", "contribution margin 4"];
colorLookup['RESULT_CATEGORY.7'] = "#26a69a";
colorNameLookup['RESULT_CATEGORY.7'] = "TEAL";
constants.RESULT_CATEGORY_CM5 = 8;
displayLookup['RESULT_CATEGORY.8'] = ["result category", "contribution margin 5"];
colorLookup['RESULT_CATEGORY.8'] = "#f06292";
colorNameLookup['RESULT_CATEGORY.8'] = "PINK";
constants.RESULT_CATEGORY_OPEX = 9;
displayLookup['RESULT_CATEGORY.9'] = ["result category", "operational expenses"];
colorLookup['RESULT_CATEGORY.9'] = "#e57373";
colorNameLookup['RESULT_CATEGORY.9'] = "RED";
constants.RESULT_CATEGORY_UNCATEGORIZED_EXPENSE = 100;
displayLookup['RESULT_CATEGORY.100'] = ["result category", "uncategorized expense"];
colorLookup['RESULT_CATEGORY.100'] = "#e5e5e5";
colorNameLookup['RESULT_CATEGORY.100'] = "GREY";
constants.RESULT_CATEGORY_FINANCIAL_RESULT = 101;
displayLookup['RESULT_CATEGORY.101'] = ["result category", "financial operations result"];
colorLookup['RESULT_CATEGORY.101'] = "#162256";
colorNameLookup['RESULT_CATEGORY.101'] = "DARK_BLUE";

constants.RFM_CLASSIFICATION = {
  LOST: { color: null, label: true, value: 1 },
  HIBERNATING: { color: null, label: true, value: 2 },
  CANNOT_LOSE_THEM: { color: null, label: "can't lose them", value: 3 },
  AT_RISK: { color: null, label: true, value: 4 },
  ABOUT_TO_SLEEP: { color: null, label: true, value: 5 },
  NEED_ATTENTION: { color: null, label: true, value: 6 },
  PROMISING: { color: null, label: true, value: 7 },
  NEW_CUSTOMER: { color: null, label: true, value: 8 },
  POTENTIAL_LOYALIST: { color: null, label: true, value: 9 },
  LOYAL_CUSTOMER: { color: null, label: true, value: 10 },
  CHAMPION: { color: null, label: true, value: 11 }
};
constants.RFM_CLASSIFICATION_LOST = 1;
displayLookup['RFM_CLASSIFICATION.1'] = "lost";
constants.RFM_CLASSIFICATION_HIBERNATING = 2;
displayLookup['RFM_CLASSIFICATION.2'] = "hibernating";
constants.RFM_CLASSIFICATION_CANNOT_LOSE_THEM = 3;
displayLookup['RFM_CLASSIFICATION.3'] = "can't lose them";
constants.RFM_CLASSIFICATION_AT_RISK = 4;
displayLookup['RFM_CLASSIFICATION.4'] = "at risk";
constants.RFM_CLASSIFICATION_ABOUT_TO_SLEEP = 5;
displayLookup['RFM_CLASSIFICATION.5'] = "about to sleep";
constants.RFM_CLASSIFICATION_NEED_ATTENTION = 6;
displayLookup['RFM_CLASSIFICATION.6'] = "need attention";
constants.RFM_CLASSIFICATION_PROMISING = 7;
displayLookup['RFM_CLASSIFICATION.7'] = "promising";
constants.RFM_CLASSIFICATION_NEW_CUSTOMER = 8;
displayLookup['RFM_CLASSIFICATION.8'] = "new customer";
constants.RFM_CLASSIFICATION_POTENTIAL_LOYALIST = 9;
displayLookup['RFM_CLASSIFICATION.9'] = "potential loyalist";
constants.RFM_CLASSIFICATION_LOYAL_CUSTOMER = 10;
displayLookup['RFM_CLASSIFICATION.10'] = "loyal customer";
constants.RFM_CLASSIFICATION_CHAMPION = 11;
displayLookup['RFM_CLASSIFICATION.11'] = "champion";

constants.ROUNDING_BASE = {
  NET: { color: null, label: true, value: 1 },
  GROSS: { color: null, label: true, value: 2 }
};
constants.ROUNDING_BASE_NET = 1;
displayLookup['ROUNDING_BASE.1'] = "net";
constants.ROUNDING_BASE_GROSS = 2;
displayLookup['ROUNDING_BASE.2'] = "gross";

constants.ROUNDING_TYPE = {
  NONE: { color: null, label: true, value: 0 },
  TO_1: { color: null, label: true, value: 1 },
  TO_5: { color: null, label: true, value: 5 },
  TO_10: { color: null, label: true, value: 10 }
};
constants.ROUNDING_TYPE_NONE = 0;
displayLookup['ROUNDING_TYPE.0'] = "none";
constants.ROUNDING_TYPE_TO_1 = 1;
displayLookup['ROUNDING_TYPE.1'] = "to 1";
constants.ROUNDING_TYPE_TO_5 = 5;
displayLookup['ROUNDING_TYPE.5'] = "to 5";
constants.ROUNDING_TYPE_TO_10 = 10;
displayLookup['ROUNDING_TYPE.10'] = "to 10";

constants.SALES_CHANNELS = {
  WEBSHOP: { color: null, label: true, value: 1 }
};
constants.SALES_CHANNELS_WEBSHOP = 1;
displayLookup['SALES_CHANNELS.1'] = "webshop";

constants.SELECTED_PROFILE = {
  DEFAULT: { color: null, label: true, value: 1 },
  FOLLOW_SELECTION: { color: null, label: true, value: 2 }
};
constants.SELECTED_PROFILE_DEFAULT = 1;
displayLookup['SELECTED_PROFILE.1'] = "default";
constants.SELECTED_PROFILE_FOLLOW_SELECTION = 2;
displayLookup['SELECTED_PROFILE.2'] = "follow selection";

constants.SEPARATE_MERGED_INVOICE = {
  NO_SEPARATION: { color: null, label: "no separation", value: 1 },
  FULFILLMENT_DATE: { color: null, label: "through fulfillment date", value: 2 }
};
constants.SEPARATE_MERGED_INVOICE_NO_SEPARATION = 1;
displayLookup['SEPARATE_MERGED_INVOICE.1'] = "no separation";
constants.SEPARATE_MERGED_INVOICE_FULFILLMENT_DATE = 2;
displayLookup['SEPARATE_MERGED_INVOICE.2'] = "through fulfillment date";

constants.SHIPMENT_CHECK_BILLED_QUANTITY_STATUS = {
  MATCHING: { color: null, label: true, value: 1 },
  LESS: { color: null, label: "less than billed", value: 2 },
  GREATER: { color: null, label: "greater than billed", value: 3 }
};
constants.SHIPMENT_CHECK_BILLED_QUANTITY_STATUS_MATCHING = 1;
displayLookup['SHIPMENT_CHECK_BILLED_QUANTITY_STATUS.1'] = "matching";
constants.SHIPMENT_CHECK_BILLED_QUANTITY_STATUS_LESS = 2;
displayLookup['SHIPMENT_CHECK_BILLED_QUANTITY_STATUS.2'] = "less than billed";
constants.SHIPMENT_CHECK_BILLED_QUANTITY_STATUS_GREATER = 3;
displayLookup['SHIPMENT_CHECK_BILLED_QUANTITY_STATUS.3'] = "greater than billed";

constants.SHIPMENT_CHECK_TARGET_QUANTITY_STATUS = {
  MISSING: { color: null, label: "missing target", value: -1 },
  MATCHING: { color: null, label: true, value: 1 },
  LESS: { color: null, label: "less than target", value: 2 },
  GREATER: { color: null, label: "greater than target", value: 3 }
};
constants.SHIPMENT_CHECK_TARGET_QUANTITY_STATUS_MISSING = -1;
displayLookup['SHIPMENT_CHECK_TARGET_QUANTITY_STATUS.-1'] = "missing target";
constants.SHIPMENT_CHECK_TARGET_QUANTITY_STATUS_MATCHING = 1;
displayLookup['SHIPMENT_CHECK_TARGET_QUANTITY_STATUS.1'] = "matching";
constants.SHIPMENT_CHECK_TARGET_QUANTITY_STATUS_LESS = 2;
displayLookup['SHIPMENT_CHECK_TARGET_QUANTITY_STATUS.2'] = "less than target";
constants.SHIPMENT_CHECK_TARGET_QUANTITY_STATUS_GREATER = 3;
displayLookup['SHIPMENT_CHECK_TARGET_QUANTITY_STATUS.3'] = "greater than target";

constants.SHIPMENT_CSV_IDENTIFIER_MODE = {
  LOCAL_SKU: { color: null, label: true, value: 1 },
  SUPPLIER_SKU: { color: null, label: true, value: 2 },
  LOCAL_BARCODE: { color: null, label: true, value: 3 },
  SUPPLIER_BARCODE: { color: null, label: true, value: 4 }
};
constants.SHIPMENT_CSV_IDENTIFIER_MODE_LOCAL_SKU = 1;
displayLookup['SHIPMENT_CSV_IDENTIFIER_MODE.1'] = "local sku";
constants.SHIPMENT_CSV_IDENTIFIER_MODE_SUPPLIER_SKU = 2;
displayLookup['SHIPMENT_CSV_IDENTIFIER_MODE.2'] = "supplier sku";
constants.SHIPMENT_CSV_IDENTIFIER_MODE_LOCAL_BARCODE = 3;
displayLookup['SHIPMENT_CSV_IDENTIFIER_MODE.3'] = "local barcode";
constants.SHIPMENT_CSV_IDENTIFIER_MODE_SUPPLIER_BARCODE = 4;
displayLookup['SHIPMENT_CSV_IDENTIFIER_MODE.4'] = "supplier barcode";

constants.SHIPMENT_CSV_QUANTITY_IMPORT_MODE = {
  SHIPPED: { color: null, label: true, value: 1 },
  BILLED: { color: null, label: true, value: 2 },
  BOTH: { color: null, label: true, value: 3 }
};
constants.SHIPMENT_CSV_QUANTITY_IMPORT_MODE_SHIPPED = 1;
displayLookup['SHIPMENT_CSV_QUANTITY_IMPORT_MODE.1'] = "shipped";
constants.SHIPMENT_CSV_QUANTITY_IMPORT_MODE_BILLED = 2;
displayLookup['SHIPMENT_CSV_QUANTITY_IMPORT_MODE.2'] = "billed";
constants.SHIPMENT_CSV_QUANTITY_IMPORT_MODE_BOTH = 3;
displayLookup['SHIPMENT_CSV_QUANTITY_IMPORT_MODE.3'] = "both";

constants.SHIPMENT_FEE_PROPORTIONING_METHOD = {
  QUANTITY: { color: null, label: ["cost allocation method", "total quantity"], value: 1 },
  WEIGHT: { color: null, label: ["cost allocation method", "total weight"], value: 2 },
  PRICE: { color: null, label: ["cost allocation method", "total net price"], value: 3 },
  ITEM: { color: null, label: ["cost allocation method", "shipment item"], value: 4 },
  VOLUME: { color: null, label: ["cost allocation method", "total volume"], value: 5 }
};
constants.SHIPMENT_FEE_PROPORTIONING_METHOD_QUANTITY = 1;
displayLookup['SHIPMENT_FEE_PROPORTIONING_METHOD.1'] = ["cost allocation method", "total quantity"];
constants.SHIPMENT_FEE_PROPORTIONING_METHOD_WEIGHT = 2;
displayLookup['SHIPMENT_FEE_PROPORTIONING_METHOD.2'] = ["cost allocation method", "total weight"];
constants.SHIPMENT_FEE_PROPORTIONING_METHOD_PRICE = 3;
displayLookup['SHIPMENT_FEE_PROPORTIONING_METHOD.3'] = ["cost allocation method", "total net price"];
constants.SHIPMENT_FEE_PROPORTIONING_METHOD_ITEM = 4;
displayLookup['SHIPMENT_FEE_PROPORTIONING_METHOD.4'] = ["cost allocation method", "shipment item"];
constants.SHIPMENT_FEE_PROPORTIONING_METHOD_VOLUME = 5;
displayLookup['SHIPMENT_FEE_PROPORTIONING_METHOD.5'] = ["cost allocation method", "total volume"];

constants.SHIPMENT_ITEM_LIST_SHOW_COLUMN = {
  UNIT: { color: null, label: true, value: 1 },
  MANUFACTURER_SKU: { color: null, label: true, value: 2 },
  SECONDARY_UNIT: { color: null, label: true, value: 3 },
  SECONDARY_UNIT_NET_PRICE: { color: null, label: true, value: 4 },
  SECONDARY_UNIT_GROSS_PRICE: { color: null, label: true, value: 5 }
};
constants.SHIPMENT_ITEM_LIST_SHOW_COLUMN_UNIT = 1;
displayLookup['SHIPMENT_ITEM_LIST_SHOW_COLUMN.1'] = "unit";
constants.SHIPMENT_ITEM_LIST_SHOW_COLUMN_MANUFACTURER_SKU = 2;
displayLookup['SHIPMENT_ITEM_LIST_SHOW_COLUMN.2'] = "manufacturer sku";
constants.SHIPMENT_ITEM_LIST_SHOW_COLUMN_SECONDARY_UNIT = 3;
displayLookup['SHIPMENT_ITEM_LIST_SHOW_COLUMN.3'] = "secondary unit";
constants.SHIPMENT_ITEM_LIST_SHOW_COLUMN_SECONDARY_UNIT_NET_PRICE = 4;
displayLookup['SHIPMENT_ITEM_LIST_SHOW_COLUMN.4'] = "secondary unit net price";
constants.SHIPMENT_ITEM_LIST_SHOW_COLUMN_SECONDARY_UNIT_GROSS_PRICE = 5;
displayLookup['SHIPMENT_ITEM_LIST_SHOW_COLUMN.5'] = "secondary unit gross price";

constants.SHIPMENT_LINE_ITEM_TYPE = {
  NORMAL: { color: null, label: [true], value: 1 },
  FEE: { color: null, label: [true], value: 3 },
  ADDITIONAL_FEE: { color: null, label: [true], value: 7 }
};
constants.SHIPMENT_LINE_ITEM_TYPE_NORMAL = 1;
displayLookup['SHIPMENT_LINE_ITEM_TYPE.1'] = ["shipment line item type", "normal"];
constants.SHIPMENT_LINE_ITEM_TYPE_FEE = 3;
displayLookup['SHIPMENT_LINE_ITEM_TYPE.3'] = ["shipment line item type", "fee"];
constants.SHIPMENT_LINE_ITEM_TYPE_ADDITIONAL_FEE = 7;
displayLookup['SHIPMENT_LINE_ITEM_TYPE.7'] = ["shipment line item type", "additional fee"];

constants.SHIPMENT_PDF_TYPE = {
  WORKSHEET: { color: null, label: true, value: 1 }
};
constants.SHIPMENT_PDF_TYPE_WORKSHEET = 1;
displayLookup['SHIPMENT_PDF_TYPE.1'] = "worksheet";

constants.SHIPMENT_PRIORITY = {
  NORMAL: { color: null, label: true, value: 1 },
  URGENT: { color: null, label: true, value: 50 },
  EXPRESS: { color: null, label: true, value: 100 }
};
constants.SHIPMENT_PRIORITY_NORMAL = 1;
displayLookup['SHIPMENT_PRIORITY.1'] = "normal";
constants.SHIPMENT_PRIORITY_URGENT = 50;
displayLookup['SHIPMENT_PRIORITY.50'] = "urgent";
constants.SHIPMENT_PRIORITY_EXPRESS = 100;
displayLookup['SHIPMENT_PRIORITY.100'] = "express";

constants.SHIPMENT_PROCESSING_STATUS = {
  PROCESSING: { color: "#64b5f6", label: true, value: 1 },
  PROCESSED: { color: "#66bb6a", label: true, value: 2 }
};
constants.SHIPMENT_PROCESSING_STATUS_PROCESSING = 1;
displayLookup['SHIPMENT_PROCESSING_STATUS.1'] = "processing";
colorLookup['SHIPMENT_PROCESSING_STATUS.1'] = "#64b5f6";
colorNameLookup['SHIPMENT_PROCESSING_STATUS.1'] = "BLUE";
constants.SHIPMENT_PROCESSING_STATUS_PROCESSED = 2;
displayLookup['SHIPMENT_PROCESSING_STATUS.2'] = "processed";
colorLookup['SHIPMENT_PROCESSING_STATUS.2'] = "#66bb6a";
colorNameLookup['SHIPMENT_PROCESSING_STATUS.2'] = "GREEN";

constants.SHIPMENT_STATUS = {
  WAITING: { color: "#e5e5e5", label: true, value: 1 },
  SENT_TO_3PL: { color: "#64b5f6", label: true, value: 50 },
  RECEIVED: { color: "#162256", label: true, value: 100 },
  INBOUND_OPERATION_IN_PROGRESS: { color: "#ffb74d", label: true, value: 150 },
  PARTIALLY_DONE: { color: "#fff74d", label: true, value: 175 },
  DONE: { color: "#66bb6a", label: true, value: 200 }
};
constants.SHIPMENT_STATUS_WAITING = 1;
displayLookup['SHIPMENT_STATUS.1'] = "waiting";
colorLookup['SHIPMENT_STATUS.1'] = "#e5e5e5";
colorNameLookup['SHIPMENT_STATUS.1'] = "GREY";
constants.SHIPMENT_STATUS_SENT_TO_3PL = 50;
displayLookup['SHIPMENT_STATUS.50'] = "sent to 3pl";
colorLookup['SHIPMENT_STATUS.50'] = "#64b5f6";
colorNameLookup['SHIPMENT_STATUS.50'] = "BLUE";
constants.SHIPMENT_STATUS_RECEIVED = 100;
displayLookup['SHIPMENT_STATUS.100'] = "received";
colorLookup['SHIPMENT_STATUS.100'] = "#162256";
colorNameLookup['SHIPMENT_STATUS.100'] = "DARK_BLUE";
constants.SHIPMENT_STATUS_INBOUND_OPERATION_IN_PROGRESS = 150;
displayLookup['SHIPMENT_STATUS.150'] = "inbound operation in progress";
colorLookup['SHIPMENT_STATUS.150'] = "#ffb74d";
colorNameLookup['SHIPMENT_STATUS.150'] = "YELLOW";
constants.SHIPMENT_STATUS_PARTIALLY_DONE = 175;
displayLookup['SHIPMENT_STATUS.175'] = "partially done";
colorLookup['SHIPMENT_STATUS.175'] = "#fff74d";
colorNameLookup['SHIPMENT_STATUS.175'] = "LIGHT_YELLOW";
constants.SHIPMENT_STATUS_DONE = 200;
displayLookup['SHIPMENT_STATUS.200'] = "done";
colorLookup['SHIPMENT_STATUS.200'] = "#66bb6a";
colorNameLookup['SHIPMENT_STATUS.200'] = "GREEN";

constants.SHIPPING_ADDRESS_IN_INVOICE = {
  NONE: { color: null, label: ["shipping address in invoice", "none"], value: 1 },
  DELIVERY_ADDRESS: { color: null, label: ["shipping address in invoice", "delivery address"], value: 2 },
  NOTE: { color: null, label: ["shipping address in invoice", "note"], value: 3 }
};
constants.SHIPPING_ADDRESS_IN_INVOICE_NONE = 1;
displayLookup['SHIPPING_ADDRESS_IN_INVOICE.1'] = ["shipping address in invoice", "none"];
constants.SHIPPING_ADDRESS_IN_INVOICE_DELIVERY_ADDRESS = 2;
displayLookup['SHIPPING_ADDRESS_IN_INVOICE.2'] = ["shipping address in invoice", "delivery address"];
constants.SHIPPING_ADDRESS_IN_INVOICE_NOTE = 3;
displayLookup['SHIPPING_ADDRESS_IN_INVOICE.3'] = ["shipping address in invoice", "note"];

constants.SHIPPING_CONTENT_TYPE = {
  GLS_COD: { color: null, label: true, value: 1 }
};
constants.SHIPPING_CONTENT_TYPE_GLS_COD = 1;
displayLookup['SHIPPING_CONTENT_TYPE.1'] = "gls cod";

constants.SHIPPING_SERVICE_TYPE = {
  CUSTOM_DELIVERY: { color: null, label: true, value: "CustomDelivery" },
  GLS_FLEX_DELIVERY: { color: null, label: "GLS FlexDelivery", value: "FDS" },
  GLS_PICK_AND_RETURN: { color: null, label: "GLS Pick&Return", value: "PRS" },
  GLS_PICK_AND_SHIP: { color: null, label: "GLS Pick&Ship", value: "PSS" },
  GLS_EXCHANGE: { color: null, label: true, value: "XS" },
  GLS_SHOP_DELIVERY: { color: null, label: "GLS ShopDelivery", value: "PSD" },
  GLS_XXL: { color: null, label: "GLS XXL", value: "XXL" },
  GLS_OPENNETWORK: { color: null, label: "GLS OpenNetwork", value: "GLS_OPENNETWORK" },
  SPRINTER_HOME_DELIVER: { color: null, label: "SPRINTER HomeDeliver", value: "HomeDeliver" },
  SPRINTER_PICK_PACK_POINT: { color: null, label: "SPRINTER PickPackPoint", value: "Normal" },
  SPRINTER_HOME_DELIVER_AND_RETURN: { color: null, label: "SPRINTER HomeDeliverAndReturn", value: "HomeDeliverOnlyReturn" },
  SPRINTER_HOME_DELIVER_ONLY_RETURN: { color: null, label: "SPRINTER HomeDeliverOnlyReturn", value: "HomeDeliverAndReturn" },
  SPRINTER_PICK_PACK_POINT_DIRECT: { color: null, label: "SPRINTER PickPackPoint Direct", value: "Direct" },
  SPRINTER_PICK_PACK_POINT_POS2POS: { color: null, label: "SPRINTER PickPackPoint Pos2Pos", value: "Pos2Pos" },
  SPRINTER_PICK_PACK_POINT_RETURN: { color: null, label: "SPRINTER PickPackPoint Return", value: "Return" },
  PACKETA_HOME_DELIVERY: { color: null, label: "PACKETA HomeDelivery", value: "PacketaHomeDelivery" },
  PACKETA_DPD_HOME_DELIVERY: { color: null, label: "PACKETA DPD HomeDelivery", value: "PacketaDPDHomeDelivery" },
  PACKETA_EXPRESS_ONE_HOME_DELIVERY: { color: null, label: "PACKETA ExpressOne HomeDelivery", value: "PacketaExpressOneHomeDelivery" },
  PACKETA_HUNGARIAN_POST_HOME_DELIVERY: { color: null, label: "PACKETA HungarianPost HomeDelivery", value: "PacketaHungarianPostHomeDelivery" },
  PACKETA_PICK_UP_POINT: { color: null, label: "PACKETA PickUpPoint", value: "PacketaPickUpPoint" },
  MPL_POST_DELIVERY: { color: null, label: "MPL PostDelivery", value: "MPLPostDelivery" },
  MPL_HOME_DELIVERY: { color: null, label: "MPL HomeDelivery", value: "MPLHomeDelivery" },
  MPL_PALLET_DELIVERY: { color: null, label: "MPL PalletPoint", value: "MPLPalletPoint" },
  MPL_POST_POINT: { color: null, label: "MPL PostPoint", value: "MPLPostPoint" },
  MPL_PARCEL_POINT: { color: null, label: "MPL ParcelPoint", value: "MPLParcelPoint" },
  MPL_HOME_DELIVERY_RETURN: { color: null, label: "MPL HomeDelivery Return", value: "MPLHomeDeliveryReturn" },
  MPL_PARCEL_POINT_RETURN: { color: null, label: "MPL ParcelPoint Return", value: "MPLParcelPointReturn" },
  MPL_HOME_DELIVERY_REPLACEMENT: { color: null, label: "MPL HomeDelivery Replacement", value: "MPLHomeDeliveryReplacement" },
  PARCEL_24H_24_HOUR_SHIPPING: { color: null, label: "24H 24 Hour shipping", value: "24_HOUR_SHIPPING" },
  PARCEL_24H_NIGHTLY_EXPRESS: { color: null, label: "24H Nightly Express", value: "NIGHTLY_EXPRESS" },
  FOXPOST_HOME_DELIVERY: { color: null, label: true, value: "FOXPOST_HOME_DELIVERY" },
  FOXPOST_PARCEL_POINT: { color: null, label: true, value: "FOXPOST_PARCEL_POINT" },
  DPD_CLASSIC: { color: null, label: "DPD Classic Delivery", value: "DPD_CLASSIC" },
  DPD_PARCEL_SHOP: { color: null, label: "DPD ParcelShop Delivery", value: "DPD_PARCEL_SHOP" },
  EXPRESS_ONE_24H: { color: null, label: "ExpressOne 24h", value: "EXPRESS_ONE_24H" },
  EXPRESS_ONE_08H: { color: null, label: "ExpressOne 08h", value: "EXPRESS_ONE_08H" },
  EXPRESS_ONE_10H: { color: null, label: "ExpressOne 10h", value: "EXPRESS_ONE_10H" },
  EXPRESS_ONE_12H: { color: null, label: "ExpressOne 12h", value: "EXPRESS_ONE_12H" },
  EXPRESS_ONE_EXP: { color: null, label: "ExpressOne Export", value: "EXPRESS_ONE_EXP" },
  EXPRESS_ONE_D2S: { color: null, label: "ExpressOne tofShop", value: "EXPRESS_ONE_D2S" },
  EXPRESS_ONE_EST: { color: null, label: "ExpressOne Delivery at night", value: "EXPRESS_ONE_EST" },
  EXPRESS_ONE_24H_AND_RETURN: { color: null, label: "ExpressOne 24h & return", value: "EXPRESS_ONE_24H_AND_RETURN" },
  EXPRESS_ONE_08H_AND_RETURN: { color: null, label: "ExpressOne 08h & return", value: "EXPRESS_ONE_08H_AND_RETURN" },
  EXPRESS_ONE_10H_AND_RETURN: { color: null, label: "ExpressOne 10h & return", value: "EXPRESS_ONE_10H_AND_RETURN" },
  EXPRESS_ONE_12H_AND_RETURN: { color: null, label: "ExpressOne 12h & return", value: "EXPRESS_ONE_12H_AND_RETURN" },
  EXPRESS_ONE_EXP_AND_RETURN: { color: null, label: "ExpressOne Export & return", value: "EXPRESS_ONE_EXP_AND_RETURN" },
  EXPRESS_ONE_D2S_AND_RETURN: { color: null, label: "ExpressOne tofShop & return", value: "EXPRESS_ONE_D2S_AND_RETURN" },
  EXPRESS_ONE_EST_AND_RETURN: { color: null, label: "ExpressOne Delivery at night & return", value: "EXPRESS_ONE_EST_AND_RETURN" },
  EXPRESS_ONE_ARU: { color: null, label: "ExpressOne Next Working Day Pickup", value: "EXPRESS_ONE_ARU" },
  EXPRESS_ONE_AR3: { color: null, label: "ExpressOne Pickup - Third Party Pays", value: "EXPRESS_ONE_AR3" },
  ILOGISTIC: { color: null, label: "Ilogistic", value: "ILOGISTIC" },
  PACTIC_DPD_BUSINESS_HOME_DELIVERY: { color: null, label: "Pactic - Pactic - DPD Business Home Delivery", value: "PACTIC_DPD_BUSINESS_HOME_DELIVERY" },
  PACTIC_DPD_ROMANIA_CROSS_BORDER: { color: null, label: "Pactic - DPD Romania Cross-border", value: "PACTIC_DPD_ROMANIA_CROSS_BORDER" },
  PACTIC_DPD_ROMANIA_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "Pactic - DPD Romania Cross-border Direct inj.", value: "PACTIC_DPD_ROMANIA_CROSS_BORDER_DIRECT_INJECTION" },
  PACTIC_DPD_AUSTRIA_CROSS_BORDER: { color: null, label: "Pactic - DPD Austria Cross-border", value: "PACTIC_DPD_AUSTRIA_CROSS_BORDER" },
  PACTIC_DPD_AUSTRIA_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "Pactic - DPD Austria Cross-border Direct Injection", value: "PACTIC_DPD_AUSTRIA_CROSS_BORDER_DIRECT_INJECTION" },
  PACTIC_ACS_GREECE_CROSS_BORDER: { color: null, label: "Pactic - ACS Greece Cross-border", value: "PACTIC_ACS_GREECE_CROSS_BORDER" },
  PACTIC_ECONT_BULGARIA_CROSS_BORDER: { color: null, label: "Pactic - Econt Bulgaria Cross-border", value: "PACTIC_ECONT_BULGARIA_CROSS_BORDER" },
  PACTIC_ECONT_BULGARIA_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "Pactic - Econt Bulgaria Cross-border Direct Injection", value: "PACTIC_ECONT_BULGARIA_CROSS_BORDER_DIRECT_INJECTION" },
  PACTIC_ACS_GREECE_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "Pactic - ACS Greece Cross-border Direct Injection", value: "PACTIC_ACS_GREECE_CROSS_BORDER_DIRECT_INJECTION" },
  PACTIC_ECONT_BULGARIA_PARCELSHOP_CROSS_BORDER: { color: null, label: "Pactic - Econt Bulgaria ParcelShop Cross-border", value: "PACTIC_ECONT_BULGARIA_PARCELSHOP_CROSS_BORDER" },
  PACTIC_ECONT_BULGARIA_PUDO_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "Pactic - Econt Bulgaria PUDO Cross-border Direct Injection", value: "PACTIC_ECONT_BULGARIA_PUDO_CROSS_BORDER_DIRECT_INJECTION" },
  PACTIC_SPEEDEX_GREECE_CROSS_BORDER: { color: null, label: "Pactic - Speedex Greece Cross-border", value: "PACTIC_SPEEDEX_GREECE_CROSS_BORDER" },
  PACTIC_SPEEDEX_GREECE_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "Pactic - Speedex Greece Cross-border Direct Injection", value: "PACTIC_SPEEDEX_GREECE_CROSS_BORDER_DIRECT_INJECTION" },
  PACTIC_GENIKI_GREECE_CROSS_BORDER: { color: null, label: "Pactic - Geniki Greece Cross-border", value: "PACTIC_GENIKI_GREECE_CROSS_BORDER" },
  PACTIC_GENIKI_GREECE_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "Pactic - Geniki Greece Cross-border Direct Injection", value: "PACTIC_GENIKI_GREECE_CROSS_BORDER_DIRECT_INJECTION" },
  PACTIC_BIZ_GREECE_CROSS_BORDER: { color: null, label: "Pactic - BIZ Greece Cross-border", value: "PACTIC_BIZ_GREECE_CROSS_BORDER" },
  PACTIC_INPOST_POLAND_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "Pactic - InPost Poland Cross-border Direct Injection", value: "PACTIC_INPOST_POLAND_CROSS_BORDER_DIRECT_INJECTION" },
  PACTIC_INPOST_POLAND_CROSS_BORDER: { color: null, label: "Pactic - InPost Poland Cross-border", value: "PACTIC_INPOST_POLAND_CROSS_BORDER" },
  PACTIC_INPOST_POLAND_LOCKER_CROSS_BORDER: { color: null, label: "Pactic - InPost Poland Locker Cross-border", value: "PACTIC_INPOST_POLAND_LOCKER_CROSS_BORDER" },
  PACTIC_INPOST_POLAND_LOCKER_CROSS_BORDER_INJECTION: { color: null, label: "Pactic - InPost Poland Locker Cross-border injection", value: "PACTIC_INPOST_POLAND_LOCKER_CROSS_BORDER_INJECTION" },
  PACTIC_URGENTCARGUS_CROSS_BORDER: { color: null, label: "Pactic - UrgentCargus Cross-border", value: "PACTIC_URGENTCARGUS_CROSS_BORDER" },
  PACTIC_URGENTCARGUS_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "Pactic - UrgentCargus Cross-border Direct Injection", value: "PACTIC_URGENTCARGUS_CROSS_BORDER_DIRECT_INJECTION" },
  PACTIC_WEDO_CZECH_REPUBLIC_CROSS_BORDER: { color: null, label: "Pactic - WE|DO Czech Republic Cross-border", value: "PACTIC_WEDO_CZECH_REPUBLIC_CROSS_BORDER" },
  PACTIC_WEDO_CZECH_REPUBLIC_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "Pactic - WE|DO Czech Republic Cross-border Direct Injection", value: "PACTIC_WEDO_CZECH_REPUBLIC_CROSS_BORDER_DIRECT_INJECTION" },
  PACTIC_SLOVAK_POST_CROSS_BORDER: { color: null, label: "Pactic - Slovak Post Cross-border", value: "PACTIC_SLOVAK_POST_CROSS_BORDER" },
  PACTIC_SLOVAK_POST_CROSS_BORDER_PUDO: { color: null, label: "Pactic - Slovak Post Cross-border PuDo", value: "PACTIC_SLOVAK_POST_CROSS_BORDER_PUDO" },
  PACTIC_MPL_BUSINESS_POST_POINT: { color: null, label: "Pactic - Pactic - MPL Post Point", value: "PACTIC_MPL_BUSINESS_POST_POINT" },
  PACTIC_B2C_EUROPE_CROSS_BORDER: { color: null, label: "Pactic - B2C Europe Cross-border", value: "PACTIC_B2C_EUROPE_CROSS_BORDER" },
  PACTIC_B2C_EUROPE_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "Pactic - B2C Europe Cross-border direct injection", value: "PACTIC_B2C_EUROPE_CROSS_BORDER_DIRECT_INJECTION" },
  PACTIC_DHL_GERMANY_CROSS_BORDER: { color: null, label: "Pactic - DHL Germany Cross-border", value: "PACTIC_DHL_GERMANY_CROSS_BORDER" },
  PACTIC_DHL_GERMANY_CROSS_BORDER_PAKETSHOP: { color: null, label: "Pactic - DHL Germany Cross-border paketshop", value: "PACTIC_DHL_GERMANY_CROSS_BORDER_PAKETSHOP" },
  PACTIC_PPL_CZECH_CROSS_BORDER: { color: null, label: "Pactic - PPL Czech Cross-border", value: "PACTIC_PPL_CZECH_CROSS_BORDER" },
  PACTIC_PPL_CZECH_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "Pactic - PPL Czech Cross-border direct Injection", value: "PACTIC_PPL_CZECH_CROSS_BORDER_DIRECT_INJECTION" },
  PACTIC_PPL_CZECH_CROSS_BORDER_PUDO: { color: null, label: "Pactic - PPL Czech Cross-border PuDo", value: "PACTIC_PPL_CZECH_CROSS_BORDER_PUDO" },
  PACTIC_PPL_CZECH_CROSS_BORDER_PUDO_DIRECT_INJECTION: { color: null, label: "Pactic - PPL Czech Cross-border PuDo Direct Injection", value: "PACTIC_PPL_CZECH_CROSS_BORDER_PUDO_DIRECT_INJECTION" },
  PACTIC_PPL_CZECH_PUDO_RETURN: { color: null, label: "Pactic - PPL Czech PuDo Return", value: "PACTIC_PPL_CZECH_PUDO_RETURN" },
  PACTIC_HERMES_GERMANY_CROSS_BORDER: { color: null, label: "Pactic - Hermes Germany Cross-border", value: "PACTIC_HERMES_GERMANY_CROSS_BORDER" },
  PACTIC_SPRING_CROSS_BORDER_EU_DESTINATIONS: { color: null, label: "Pactic - Spring Cross-border EU destinations", value: "PACTIC_SPRING_CROSS_BORDER_EU_DESTINATIONS" },
  PACTIC_BPOST_BELGIUM_CROSS_BORDER: { color: null, label: "Pactic - Bpost Belgium Cross-border", value: "PACTIC_BPOST_BELGIUM_CROSS_BORDER" },
  PACTIC_BRING_DENMARK_CROSS_BORDER: { color: null, label: "Pactic - Bring Denmark Cross-border", value: "PACTIC_BRING_DENMARK_CROSS_BORDER" },
  PACTIC_POST_ESTONIA_CROSS_BORDER: { color: null, label: "Pactic - Post Estonia Cross-border", value: "PACTIC_POST_ESTONIA_CROSS_BORDER" },
  PACTIC_POST_FINLAND_CROSS_BORDER: { color: null, label: "Pactic - Post Finland Cross-border", value: "PACTIC_POST_FINLAND_CROSS_BORDER" },
  PACTIC_COLIS_PRIVE_FRANCE_CROSS_BORDER: { color: null, label: "Pactic - Colis Prive France Cross-border", value: "PACTIC_COLIS_PRIVE_FRANCE_CROSS_BORDER" },
  PACTIC_FASTWAY_IRELAND_CROSS_BORDER: { color: null, label: "Pactic - Fastway Ireland Cross-border", value: "PACTIC_FASTWAY_IRELAND_CROSS_BORDER" },
  PACTIC_POST_LATVIA_CROSS_BORDER: { color: null, label: "Pactic - Post Latvia Cross-border", value: "PACTIC_POST_LATVIA_CROSS_BORDER" },
  PACTIC_POST_LITHUANIA_CROSS_BORDER: { color: null, label: "Pactic - Post Lithuania Cross-border", value: "PACTIC_POST_LITHUANIA_CROSS_BORDER" },
  PACTIC_POST_LUXEMBOURG_CROSS_BORDER: { color: null, label: "Pactic - Post Luxembourg Cross-border", value: "PACTIC_POST_LUXEMBOURG_CROSS_BORDER" },
  PACTIC_POST_NL_NETHERLANDS_CROSS_BORDER: { color: null, label: "Pactic - Post NL Netherlands Cross-border", value: "PACTIC_POST_NL_NETHERLANDS_CROSS_BORDER" },
  PACTIC_CTT_EXPRESS_PORTUGAL_CROSS_BORDER: { color: null, label: "Pactic - CTT Express Portugal Cross-border", value: "PACTIC_CTT_EXPRESS_PORTUGAL_CROSS_BORDER" },
  PACTIC_CTT_EXPRESS_SPAIN_CROSS_BORDER: { color: null, label: "Pactic - CTT Express Spain Cross-border", value: "PACTIC_CTT_EXPRESS_SPAIN_CROSS_BORDER" },
  PACTIC_BRING_SWEDEN_CROSS_BORDER: { color: null, label: "Pactic - Bring Sweden Cross-border", value: "PACTIC_BRING_SWEDEN_CROSS_BORDER" },
  PACTIC_CROATIA_POST_CROSS_BORDER: { color: null, label: "Pactic - Croatia Post Cross-border", value: "PACTIC_CROATIA_POST_CROSS_BORDER" },
  PACTIC_CROATIA_POST_CROSS_BORDER_PUDO: { color: null, label: "Pactic - Croatia Post Cross-border PUDO", value: "PACTIC_CROATIA_POST_CROSS_BORDER_PUDO" },
  PACTIC_CROATIA_POST_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "Pactic - Croatia Post Cross-border Direct inj.", value: "PACTIC_CROATIA_POST_CROSS_BORDER_DIRECT_INJECTION" },
  PACTIC_CROATIA_POST_CROSS_BORDER_PUDO_DIRECT_INJECTION: { color: null, label: "Pactic - Croatia Post Cross-border PUDO D. inj.", value: "PACTIC_CROATIA_POST_CROSS_BORDER_PUDO_DIRECT_INJECTION" },
  PACTIC_CZECH_POST_CROSS_BORDER: { color: null, label: "Pactic - Czech Post Cross-border", value: "PACTIC_CZECH_POST_CROSS_BORDER" },
  PACTIC_CZECH_POST_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "Pactic - Czech Post Cross-border Dir. Inj.", value: "PACTIC_CZECH_POST_CROSS_BORDER_DIRECT_INJECTION" },
  PACTIC_GLS_BUSINESS_HOME_DELIVERY: { color: null, label: "Pactic - GLS Business Home Delivery", value: "PACTIC_GLS_BUSINESS_HOME_DELIVERY" },
  PACTIC_GLS_BUSINESS_PICKUP_POINT: { color: null, label: "Pactic - GLS Business PickUp Point", value: "PACTIC_GLS_BUSINESS_PICKUP_POINT" },
  PACTIC_GLS_HUNGARY_PICK_AND_SHIP_DOMESTIC: { color: null, label: "Pactic - GLS Hungary Pick & Ship Domestic", value: "PACTIC_GLS_HUNGARY_PICK_AND_SHIP_DOMESTIC" },
  PACTIC_GLS_HUNGARY_EXCHANGE_SERVICE: { color: null, label: "Pactic - GLS Hungary Exchange Service", value: "PACTIC_GLS_HUNGARY_EXCHANGE_SERVICE" },
  PACTIC_GLS_HUNGARY_CROSS_BORDER_PUDO_DIRECT_INJECTION: { color: null, label: "Pactic - GLS Hungary Cross-border PUDO Direct injection", value: "PACTIC_GLS_HUNGARY_CROSS_BORDER_PUDO_DIRECT_INJECTION" },
  PACTIC_GLS_HUNGARY_CROSS_BORDER_PUDO: { color: null, label: "Pactic - GLS Hungary Cross-border PUDO", value: "PACTIC_GLS_HUNGARY_CROSS_BORDER_PUDO" },
  PACTIC_GLS_HUNGARY_CROSS_BORDER: { color: null, label: "Pactic - GLS Hungary Cross-border", value: "PACTIC_GLS_HUNGARY_CROSS_BORDER" },
  PACTIC_GLS_ROMANIA_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "Pactic - GLS Romania Cross-border Direct Injection", value: "PACTIC_GLS_ROMANIA_CROSS_BORDER_DIRECT_INJECTION" },
  PACTIC_GLS_ROMANIA_CROSS_BORDER: { color: null, label: "Pactic - GLS Romania Cross-border", value: "PACTIC_GLS_ROMANIA_CROSS_BORDER" },
  PACTIC_GLS_ROMANIA_PICK_AND_SHIP_DOMESTIC: { color: null, label: "Pactic - GLS Romania Pick & Ship Domestic", value: "PACTIC_GLS_ROMANIA_PICK_AND_SHIP_DOMESTIC" },
  PACTIC_GLS_ROMANIA_EXCHANGE_SERVICE: { color: null, label: "Pactic - GLS Romania Exchange Service", value: "PACTIC_GLS_ROMANIA_EXCHANGE_SERVICE" },
  PACTIC_GLS_CROSS_BORDER_DIRECT: { color: null, label: "Pactic - Pactic - GLS Cross-border Direct", value: "PACTIC_GLS_CROSS_BORDER_DIRECT" },
  PACTIC_GLS_SLOVENIA_CROSS_BORDER: { color: null, label: "Pactic - GLS Slovenia Cross-border", value: "PACTIC_GLS_SLOVENIA_CROSS_BORDER" },
  PACTIC_GLS_CZECH_REPUBLIC_CROSS_BORDER: { color: null, label: "Pactic - GLS Czech Republic Cross-border", value: "PACTIC_GLS_CZECH_REPUBLIC_CROSS_BORDER" },
  PACTIC_GLS_SLOVENIA_DIRECT_INJECTION: { color: null, label: "Pactic - GLS Slovenia Direct Injection", value: "PACTIC_GLS_SLOVENIA_DIRECT_INJECTION" },
  PACTIC_GLS_CROATIA_CROSS_BORDER: { color: null, label: "Pactic - GLS Croatia Cross-border", value: "PACTIC_GLS_CROATIA_CROSS_BORDER" },
  PACTIC_GLS_CROATIA_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "Pactic - GLS Croatia Cross-border Direct Injection", value: "PACTIC_GLS_CROATIA_CROSS_BORDER_DIRECT_INJECTION" },
  PACTIC_GLS_CROATIA_PICK_AND_RETURN: { color: null, label: "Pactic - GLS Croatia Pick and Return", value: "PACTIC_GLS_CROATIA_PICK_AND_RETURN" },
  PACTIC_GLS_SLOVENIA_PICK_AND_RETURN: { color: null, label: "Pactic - GLS Slovenia Pick and Return", value: "PACTIC_GLS_SLOVENIA_PICK_AND_RETURN" },
  PACTIC_GLS_SLOVENIA_PUDO: { color: null, label: "Pactic - GLS Slovenia PUDO", value: "PACTIC_GLS_SLOVENIA_PUDO" },
  PACTIC_GLS_SLOVENIA_PUDO_DIRECT_INJECTION: { color: null, label: "Pactic - GLS Slovenia PUDO Direct Injection", value: "PACTIC_GLS_SLOVENIA_PUDO_DIRECT_INJECTION" },
  PACTIC_GLS_SLOVAKIA_CROSS_BORDER: { color: null, label: "Pactic - GLS Slovakia Cross-border", value: "PACTIC_GLS_SLOVAKIA_CROSS_BORDER" },
  PACTIC_GLS_SLOVAKIA_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "Pactic - GLS Slovakia Cross-border Direct Injection", value: "PACTIC_GLS_SLOVAKIA_CROSS_BORDER_DIRECT_INJECTION" },
  PACTIC_GLS_SLOVAKIA_CROSS_BORDER_PUDO: { color: null, label: "Pactic - GLS Slovakia Cross-border PUDO", value: "PACTIC_GLS_SLOVAKIA_CROSS_BORDER_PUDO" },
  PACTIC_GLS_SLOVAKIA_CROSS_BORDER_PUDO_DIRECT_INJECTION: { color: null, label: "Pactic - GLS Slovakia Cross-border PUDO Direct Injection", value: "PACTIC_GLS_SLOVAKIA_CROSS_BORDER_PUDO_DIRECT_INJECTION" },
  PACTIC_GLS_SLOVAKIA_EXCHANGE_SERVICE: { color: null, label: "Pactic - GLS Slovakia Exchange Service", value: "PACTIC_GLS_SLOVAKIA_EXCHANGE_SERVICE" },
  PACTIC_GLS_SLOVAKIA_PICK_RETURN: { color: null, label: "Pactic - GLS Slovakia Pick & Return", value: "PACTIC_GLS_SLOVAKIA_PICK_RETURN" },
  PACTIC_GLS_CROATIA_PUDO: { color: null, label: "Pactic - GLS Croatia PUDO", value: "PACTIC_GLS_CROATIA_PUDO" },
  PACTIC_GLS_CROATIA_PUDO_DIRECT_INJECTION: { color: null, label: "Pactic - GLS Croatia PUDO Direct Injection", value: "PACTIC_GLS_CROATIA_PUDO_DIRECT_INJECTION" },
  PACTIC_GLS_AUSTRIA_CROSS_BORDER: { color: null, label: "Pactic - GLS Austria Cross-border", value: "PACTIC_GLS_AUSTRIA_CROSS_BORDER" },
  PACTIC_GLS_AUSTRIA_PUDO_CROSS_BORDER: { color: null, label: "Pactic - GLS Austria PuDo Cross-border", value: "PACTIC_GLS_AUSTRIA_PUDO_CROSS_BORDER" },
  PACTIC_GLS_ITALY_CROSS_BORDER: { color: null, label: "Pactic - GLS Italy Cross-border", value: "PACTIC_GLS_ITALY_CROSS_BORDER" },
  PACTIC_GLS_ITALY_PUDO_CROSS_BORDER: { color: null, label: "Pactic - GLS Italy Cross-border PuDo", value: "PACTIC_GLS_ITALY_PUDO_CROSS_BORDER" },
  PACTIC_GLS_ITALY_PICK_AND_RETURN: { color: null, label: "Pactic - GLS Italy Pick and Return", value: "PACTIC_GLS_ITALY_PICK_AND_RETURN" },
  PACTIC_GLS_POLAND_CROSS_BORDER: { color: null, label: "Pactic - GLS Poland Cross-border", value: "PACTIC_GLS_POLAND_CROSS_BORDER" },
  PACTIC_GLS_POLAND_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "Pactic - GLS Poland Cross-border Direct Injection", value: "PACTIC_GLS_POLAND_CROSS_BORDER_DIRECT_INJECTION" },
  PACTIC_GLS_POLAND_CROSS_BORDER_PUDO: { color: null, label: "Pactic - GLS Poland Cross-border PuDo", value: "PACTIC_GLS_POLAND_CROSS_BORDER_PUDO" },
  PACTIC_GLS_POLAND_CROSS_BORDER_PUDO_DIRECT_INJECTION: { color: null, label: "Pactic - GLS Poland Cross-border PuDo Direct Injection", value: "PACTIC_GLS_POLAND_CROSS_BORDER_PUDO_DIRECT_INJECTION" },
  PACTIC_GLS_POLAND_PICK_RETURN: { color: null, label: "Pactic - GLS Poland Pick & Return", value: "PACTIC_GLS_POLAND_PICK_RETURN" },
  PACTIC_SAMEDAY_HUNGARY_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "Pactic - Sameday Hungary Cross-border Direct Injection", value: "PACTIC_SAMEDAY_HUNGARY_CROSS_BORDER_DIRECT_INJECTION" },
  PACTIC_SAMEDAY_HUNGARY_EASYBOX_DIRECT_INJECTION: { color: null, label: "Pactic - Sameday Hungary Easybox Direct Injection", value: "PACTIC_SAMEDAY_HUNGARY_EASYBOX_DIRECT_INJECTION" },
  PACTIC_SAMEDAY_HUNGARY_CROSS_BORDER: { color: null, label: "Pactic - Sameday Hungary Cross-border", value: "PACTIC_SAMEDAY_HUNGARY_CROSS_BORDER" },
  PACTIC_SAMEDAY_HUNGARY_CROSS_BORDER_EASYBOX: { color: null, label: "Pactic - Sameday Hungary Cross-border Easybox", value: "PACTIC_SAMEDAY_HUNGARY_CROSS_BORDER_EASYBOX" },
  PACTIC_PACKETA_HUNGARY_PUDO: { color: null, label: "Pactic - Packeta Hungary PuDo", value: "PACTIC_PACKETA_HUNGARY_PUDO" },
  PACTIC_SAMEDAY_ROMANIA_CROSS_BORDER: { color: null, label: "Pactic - SameDay Romania Cross-border", value: "PACTIC_SAMEDAY_ROMANIA_CROSS_BORDER" },
  PACTIC_SAMEDAY_ROMANIA_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "Pactic - SameDay Romania Cross-border Direct Injection", value: "PACTIC_SAMEDAY_ROMANIA_CROSS_BORDER_DIRECT_INJECTION" },
  PACTIC_SAMEDAY_ROMANIA_PUDO_BUSINESS: { color: null, label: "Pactic - SameDay Romania PuDo Business", value: "PACTIC_SAMEDAY_ROMANIA_PUDO_BUSINESS" },
  PACTIC_SAMEDAY_ROMANIA_PUDO_CROSS_BORDER: { color: null, label: "Pactic - SameDay Romania PuDo Cross-border", value: "PACTIC_SAMEDAY_ROMANIA_PUDO_CROSS_BORDER" },
  PACTIC_SAMEDAY_ROMANIA_PUDO_DIRECT_INJECTION: { color: null, label: "Pactic - SameDay Romania PuDo Direct Injection", value: "PACTIC_SAMEDAY_ROMANIA_PUDO_DIRECT_INJECTION" },
  PACTIC_SAMEDAY_BULGARIA_CROSS_BORDER: { color: null, label: "Pactic - Sameday Bulgaria Cross-border", value: "PACTIC_SAMEDAY_BULGARIA_CROSS_BORDER" },
  PACTIC_SAMEDAY_BULGARIA_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "Pactic - Sameday Bulgaria Cross-border Direct Injection", value: "PACTIC_SAMEDAY_BULGARIA_CROSS_BORDER_DIRECT_INJECTION" },
  PACTIC_EXPRESSONE_CROSS_BORDER_DOMESTIC: { color: null, label: "Pactic - ExpressOne Cross-border Domestic", value: "PACTIC_EXPRESSONE_CROSS_BORDER_DOMESTIC" },
  PACTIC_EXPRESSONE_CROSS_BORDER_DIRECT_INJECTION: { color: null, label: "Pactic - ExpressOne Cross-border Direct Injection", value: "PACTIC_EXPRESSONE_CROSS_BORDER_DIRECT_INJECTION" },
  PACTIC_MPL_BUSINESS_PICKUP_POINT: { color: null, label: "Pactic - Pactic - MPL PickUp Point", value: "PACTIC_MPL_BUSINESS_PICKUP_POINT" },
  PACTIC_MPL_HUNGARY_CROSS_BORDER: { color: null, label: "Pactic - MPL Hungary Cross-border", value: "PACTIC_MPL_HUNGARY_CROSS_BORDER" },
  PACTIC_MPL_HUNGARY_CROSS_BORDER_PUDO_DIR_INJ: { color: null, label: "Pactic - MPL Hungary Cross-border PUDO Dir. Inj.", value: "PACTIC_MPL_HUNGARY_CROSS_BORDER_PUDO_DIR_INJ" },
  PACTIC_MPL_HUNGARY_CROSS_BORDER_PUDO: { color: null, label: "Pactic - MPL Hungary Cross-border PUDO", value: "PACTIC_MPL_HUNGARY_CROSS_BORDER_PUDO" },
  PACTIC_MPL_BUSINESS_MANIFEST: { color: null, label: "Pactic - MPL Business Manifest", value: "PACTIC_MPL_BUSINESS_MANIFEST" },
  PACTIC_MPL_BUSINESS_PUDO_MANIFEST: { color: null, label: "Pactic - MPL Business PuDo Manifest", value: "PACTIC_MPL_BUSINESS_PUDO_MANIFEST" },
  PACTIC_MPL_HUNGARY_CROSS_BORDER_MANIFEST: { color: null, label: "Pactic - MPL Hungary Cross-border Manifest", value: "PACTIC_MPL_HUNGARY_CROSS_BORDER_MANIFEST" },
  PACTIC_MPL_HUNGARY_CROSS_BORDER_PUDO_DIR_INJ_MANIFEST: { color: null, label: "Pactic - MPL Hungary Cross-border PUDO Dir Inj Manifest", value: "PACTIC_MPL_HUNGARY_CROSS_BORDER_PUDO_DIR_INJ_MANIFEST" },
  PACTIC_MPL_HUNGARY_CROSS_BORDER_PUDO_MANIFEST: { color: null, label: "Pactic - MPL Hungary Cross-border PUDO Manifest", value: "PACTIC_MPL_HUNGARY_CROSS_BORDER_PUDO_MANIFEST" },
  PACTIC_DPD_ROMANIA_CLASSIC_BUSINESS_DOMESTIC: { color: null, label: "Pactic - DPD Romania Classic Business Domestic", value: "PACTIC_DPD_ROMANIA_CLASSIC_BUSINESS_DOMESTIC" },
  EMAG: { color: null, label: "EMAG", value: "EMAG" },
  SAMEDAY: { color: null, label: "SAMEDAY", value: "SAMEDAY" },
  KUMI_DELIVERY: { color: null, label: true, value: "KUMI_DELIVERY" },
  KUMI_RETURN: { color: null, label: true, value: "KUMI_RETURN" },
  KUMI_REPLACEMENT: { color: null, label: true, value: "KUMI_REPLACEMENT" },
  KOVA_TRANS_DELIVERY: { color: null, label: true, value: "KOVA_TRANS_DELIVERY" },
  KOVA_TRANS_PICKUP: { color: null, label: true, value: "KOVA_TRANS_PICKUP" },
  PANNONXP_DELIVERY: { color: null, label: "PannonXP delivery", value: "PANNONXP_DELIVERY" },
  PANNONXP_PICKUP_POINT: { color: null, label: "PannonXP pickup point", value: "PANNONXP_PICKUP_POINT" },
  PANNONXP_RETURN: { color: null, label: "PannonXP return", value: "PANNONXP_RETURN" }
};
constants.SHIPPING_SERVICE_TYPE_CUSTOM_DELIVERY = "CustomDelivery";
displayLookup['SHIPPING_SERVICE_TYPE."CustomDelivery"'] = "custom delivery";
constants.SHIPPING_SERVICE_TYPE_GLS_FLEX_DELIVERY = "FDS";
displayLookup['SHIPPING_SERVICE_TYPE."FDS"'] = "GLS FlexDelivery";
constants.SHIPPING_SERVICE_TYPE_GLS_PICK_AND_RETURN = "PRS";
displayLookup['SHIPPING_SERVICE_TYPE."PRS"'] = "GLS Pick&Return";
constants.SHIPPING_SERVICE_TYPE_GLS_PICK_AND_SHIP = "PSS";
displayLookup['SHIPPING_SERVICE_TYPE."PSS"'] = "GLS Pick&Ship";
constants.SHIPPING_SERVICE_TYPE_GLS_EXCHANGE = "XS";
displayLookup['SHIPPING_SERVICE_TYPE."XS"'] = "gls exchange";
constants.SHIPPING_SERVICE_TYPE_GLS_SHOP_DELIVERY = "PSD";
displayLookup['SHIPPING_SERVICE_TYPE."PSD"'] = "GLS ShopDelivery";
constants.SHIPPING_SERVICE_TYPE_GLS_XXL = "XXL";
displayLookup['SHIPPING_SERVICE_TYPE."XXL"'] = "GLS XXL";
constants.SHIPPING_SERVICE_TYPE_GLS_OPENNETWORK = "GLS_OPENNETWORK";
displayLookup['SHIPPING_SERVICE_TYPE."GLS_OPENNETWORK"'] = "GLS OpenNetwork";
constants.SHIPPING_SERVICE_TYPE_SPRINTER_HOME_DELIVER = "HomeDeliver";
displayLookup['SHIPPING_SERVICE_TYPE."HomeDeliver"'] = "SPRINTER HomeDeliver";
constants.SHIPPING_SERVICE_TYPE_SPRINTER_PICK_PACK_POINT = "Normal";
displayLookup['SHIPPING_SERVICE_TYPE."Normal"'] = "SPRINTER PickPackPoint";
constants.SHIPPING_SERVICE_TYPE_SPRINTER_HOME_DELIVER_AND_RETURN = "HomeDeliverOnlyReturn";
displayLookup['SHIPPING_SERVICE_TYPE."HomeDeliverOnlyReturn"'] = "SPRINTER HomeDeliverAndReturn";
constants.SHIPPING_SERVICE_TYPE_SPRINTER_HOME_DELIVER_ONLY_RETURN = "HomeDeliverAndReturn";
displayLookup['SHIPPING_SERVICE_TYPE."HomeDeliverAndReturn"'] = "SPRINTER HomeDeliverOnlyReturn";
constants.SHIPPING_SERVICE_TYPE_SPRINTER_PICK_PACK_POINT_DIRECT = "Direct";
displayLookup['SHIPPING_SERVICE_TYPE."Direct"'] = "SPRINTER PickPackPoint Direct";
constants.SHIPPING_SERVICE_TYPE_SPRINTER_PICK_PACK_POINT_POS2POS = "Pos2Pos";
displayLookup['SHIPPING_SERVICE_TYPE."Pos2Pos"'] = "SPRINTER PickPackPoint Pos2Pos";
constants.SHIPPING_SERVICE_TYPE_SPRINTER_PICK_PACK_POINT_RETURN = "Return";
displayLookup['SHIPPING_SERVICE_TYPE."Return"'] = "SPRINTER PickPackPoint Return";
constants.SHIPPING_SERVICE_TYPE_PACKETA_HOME_DELIVERY = "PacketaHomeDelivery";
displayLookup['SHIPPING_SERVICE_TYPE."PacketaHomeDelivery"'] = "PACKETA HomeDelivery";
constants.SHIPPING_SERVICE_TYPE_PACKETA_DPD_HOME_DELIVERY = "PacketaDPDHomeDelivery";
displayLookup['SHIPPING_SERVICE_TYPE."PacketaDPDHomeDelivery"'] = "PACKETA DPD HomeDelivery";
constants.SHIPPING_SERVICE_TYPE_PACKETA_EXPRESS_ONE_HOME_DELIVERY = "PacketaExpressOneHomeDelivery";
displayLookup['SHIPPING_SERVICE_TYPE."PacketaExpressOneHomeDelivery"'] = "PACKETA ExpressOne HomeDelivery";
constants.SHIPPING_SERVICE_TYPE_PACKETA_HUNGARIAN_POST_HOME_DELIVERY = "PacketaHungarianPostHomeDelivery";
displayLookup['SHIPPING_SERVICE_TYPE."PacketaHungarianPostHomeDelivery"'] = "PACKETA HungarianPost HomeDelivery";
constants.SHIPPING_SERVICE_TYPE_PACKETA_PICK_UP_POINT = "PacketaPickUpPoint";
displayLookup['SHIPPING_SERVICE_TYPE."PacketaPickUpPoint"'] = "PACKETA PickUpPoint";
constants.SHIPPING_SERVICE_TYPE_MPL_POST_DELIVERY = "MPLPostDelivery";
displayLookup['SHIPPING_SERVICE_TYPE."MPLPostDelivery"'] = "MPL PostDelivery";
constants.SHIPPING_SERVICE_TYPE_MPL_HOME_DELIVERY = "MPLHomeDelivery";
displayLookup['SHIPPING_SERVICE_TYPE."MPLHomeDelivery"'] = "MPL HomeDelivery";
constants.SHIPPING_SERVICE_TYPE_MPL_PALLET_DELIVERY = "MPLPalletPoint";
displayLookup['SHIPPING_SERVICE_TYPE."MPLPalletPoint"'] = "MPL PalletPoint";
constants.SHIPPING_SERVICE_TYPE_MPL_POST_POINT = "MPLPostPoint";
displayLookup['SHIPPING_SERVICE_TYPE."MPLPostPoint"'] = "MPL PostPoint";
constants.SHIPPING_SERVICE_TYPE_MPL_PARCEL_POINT = "MPLParcelPoint";
displayLookup['SHIPPING_SERVICE_TYPE."MPLParcelPoint"'] = "MPL ParcelPoint";
constants.SHIPPING_SERVICE_TYPE_MPL_HOME_DELIVERY_RETURN = "MPLHomeDeliveryReturn";
displayLookup['SHIPPING_SERVICE_TYPE."MPLHomeDeliveryReturn"'] = "MPL HomeDelivery Return";
constants.SHIPPING_SERVICE_TYPE_MPL_PARCEL_POINT_RETURN = "MPLParcelPointReturn";
displayLookup['SHIPPING_SERVICE_TYPE."MPLParcelPointReturn"'] = "MPL ParcelPoint Return";
constants.SHIPPING_SERVICE_TYPE_MPL_HOME_DELIVERY_REPLACEMENT = "MPLHomeDeliveryReplacement";
displayLookup['SHIPPING_SERVICE_TYPE."MPLHomeDeliveryReplacement"'] = "MPL HomeDelivery Replacement";
constants.SHIPPING_SERVICE_TYPE_PARCEL_24H_24_HOUR_SHIPPING = "24_HOUR_SHIPPING";
displayLookup['SHIPPING_SERVICE_TYPE."24_HOUR_SHIPPING"'] = "24H 24 Hour shipping";
constants.SHIPPING_SERVICE_TYPE_PARCEL_24H_NIGHTLY_EXPRESS = "NIGHTLY_EXPRESS";
displayLookup['SHIPPING_SERVICE_TYPE."NIGHTLY_EXPRESS"'] = "24H Nightly Express";
constants.SHIPPING_SERVICE_TYPE_FOXPOST_HOME_DELIVERY = "FOXPOST_HOME_DELIVERY";
displayLookup['SHIPPING_SERVICE_TYPE."FOXPOST_HOME_DELIVERY"'] = "foxpost home delivery";
constants.SHIPPING_SERVICE_TYPE_FOXPOST_PARCEL_POINT = "FOXPOST_PARCEL_POINT";
displayLookup['SHIPPING_SERVICE_TYPE."FOXPOST_PARCEL_POINT"'] = "foxpost parcel point";
constants.SHIPPING_SERVICE_TYPE_DPD_CLASSIC = "DPD_CLASSIC";
displayLookup['SHIPPING_SERVICE_TYPE."DPD_CLASSIC"'] = "DPD Classic Delivery";
constants.SHIPPING_SERVICE_TYPE_DPD_PARCEL_SHOP = "DPD_PARCEL_SHOP";
displayLookup['SHIPPING_SERVICE_TYPE."DPD_PARCEL_SHOP"'] = "DPD ParcelShop Delivery";
constants.SHIPPING_SERVICE_TYPE_EXPRESS_ONE_24H = "EXPRESS_ONE_24H";
displayLookup['SHIPPING_SERVICE_TYPE."EXPRESS_ONE_24H"'] = "ExpressOne 24h";
constants.SHIPPING_SERVICE_TYPE_EXPRESS_ONE_08H = "EXPRESS_ONE_08H";
displayLookup['SHIPPING_SERVICE_TYPE."EXPRESS_ONE_08H"'] = "ExpressOne 08h";
constants.SHIPPING_SERVICE_TYPE_EXPRESS_ONE_10H = "EXPRESS_ONE_10H";
displayLookup['SHIPPING_SERVICE_TYPE."EXPRESS_ONE_10H"'] = "ExpressOne 10h";
constants.SHIPPING_SERVICE_TYPE_EXPRESS_ONE_12H = "EXPRESS_ONE_12H";
displayLookup['SHIPPING_SERVICE_TYPE."EXPRESS_ONE_12H"'] = "ExpressOne 12h";
constants.SHIPPING_SERVICE_TYPE_EXPRESS_ONE_EXP = "EXPRESS_ONE_EXP";
displayLookup['SHIPPING_SERVICE_TYPE."EXPRESS_ONE_EXP"'] = "ExpressOne Export";
constants.SHIPPING_SERVICE_TYPE_EXPRESS_ONE_D2S = "EXPRESS_ONE_D2S";
displayLookup['SHIPPING_SERVICE_TYPE."EXPRESS_ONE_D2S"'] = "ExpressOne tofShop";
constants.SHIPPING_SERVICE_TYPE_EXPRESS_ONE_EST = "EXPRESS_ONE_EST";
displayLookup['SHIPPING_SERVICE_TYPE."EXPRESS_ONE_EST"'] = "ExpressOne Delivery at night";
constants.SHIPPING_SERVICE_TYPE_EXPRESS_ONE_24H_AND_RETURN = "EXPRESS_ONE_24H_AND_RETURN";
displayLookup['SHIPPING_SERVICE_TYPE."EXPRESS_ONE_24H_AND_RETURN"'] = "ExpressOne 24h & return";
constants.SHIPPING_SERVICE_TYPE_EXPRESS_ONE_08H_AND_RETURN = "EXPRESS_ONE_08H_AND_RETURN";
displayLookup['SHIPPING_SERVICE_TYPE."EXPRESS_ONE_08H_AND_RETURN"'] = "ExpressOne 08h & return";
constants.SHIPPING_SERVICE_TYPE_EXPRESS_ONE_10H_AND_RETURN = "EXPRESS_ONE_10H_AND_RETURN";
displayLookup['SHIPPING_SERVICE_TYPE."EXPRESS_ONE_10H_AND_RETURN"'] = "ExpressOne 10h & return";
constants.SHIPPING_SERVICE_TYPE_EXPRESS_ONE_12H_AND_RETURN = "EXPRESS_ONE_12H_AND_RETURN";
displayLookup['SHIPPING_SERVICE_TYPE."EXPRESS_ONE_12H_AND_RETURN"'] = "ExpressOne 12h & return";
constants.SHIPPING_SERVICE_TYPE_EXPRESS_ONE_EXP_AND_RETURN = "EXPRESS_ONE_EXP_AND_RETURN";
displayLookup['SHIPPING_SERVICE_TYPE."EXPRESS_ONE_EXP_AND_RETURN"'] = "ExpressOne Export & return";
constants.SHIPPING_SERVICE_TYPE_EXPRESS_ONE_D2S_AND_RETURN = "EXPRESS_ONE_D2S_AND_RETURN";
displayLookup['SHIPPING_SERVICE_TYPE."EXPRESS_ONE_D2S_AND_RETURN"'] = "ExpressOne tofShop & return";
constants.SHIPPING_SERVICE_TYPE_EXPRESS_ONE_EST_AND_RETURN = "EXPRESS_ONE_EST_AND_RETURN";
displayLookup['SHIPPING_SERVICE_TYPE."EXPRESS_ONE_EST_AND_RETURN"'] = "ExpressOne Delivery at night & return";
constants.SHIPPING_SERVICE_TYPE_EXPRESS_ONE_ARU = "EXPRESS_ONE_ARU";
displayLookup['SHIPPING_SERVICE_TYPE."EXPRESS_ONE_ARU"'] = "ExpressOne Next Working Day Pickup";
constants.SHIPPING_SERVICE_TYPE_EXPRESS_ONE_AR3 = "EXPRESS_ONE_AR3";
displayLookup['SHIPPING_SERVICE_TYPE."EXPRESS_ONE_AR3"'] = "ExpressOne Pickup - Third Party Pays";
constants.SHIPPING_SERVICE_TYPE_ILOGISTIC = "ILOGISTIC";
displayLookup['SHIPPING_SERVICE_TYPE."ILOGISTIC"'] = "Ilogistic";
constants.SHIPPING_SERVICE_TYPE_PACTIC_DPD_BUSINESS_HOME_DELIVERY = "PACTIC_DPD_BUSINESS_HOME_DELIVERY";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_DPD_BUSINESS_HOME_DELIVERY"'] = "Pactic - Pactic - DPD Business Home Delivery";
constants.SHIPPING_SERVICE_TYPE_PACTIC_DPD_ROMANIA_CROSS_BORDER = "PACTIC_DPD_ROMANIA_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_DPD_ROMANIA_CROSS_BORDER"'] = "Pactic - DPD Romania Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_DPD_ROMANIA_CROSS_BORDER_DIRECT_INJECTION = "PACTIC_DPD_ROMANIA_CROSS_BORDER_DIRECT_INJECTION";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_DPD_ROMANIA_CROSS_BORDER_DIRECT_INJECTION"'] = "Pactic - DPD Romania Cross-border Direct inj.";
constants.SHIPPING_SERVICE_TYPE_PACTIC_DPD_AUSTRIA_CROSS_BORDER = "PACTIC_DPD_AUSTRIA_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_DPD_AUSTRIA_CROSS_BORDER"'] = "Pactic - DPD Austria Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_DPD_AUSTRIA_CROSS_BORDER_DIRECT_INJECTION = "PACTIC_DPD_AUSTRIA_CROSS_BORDER_DIRECT_INJECTION";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_DPD_AUSTRIA_CROSS_BORDER_DIRECT_INJECTION"'] = "Pactic - DPD Austria Cross-border Direct Injection";
constants.SHIPPING_SERVICE_TYPE_PACTIC_ACS_GREECE_CROSS_BORDER = "PACTIC_ACS_GREECE_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_ACS_GREECE_CROSS_BORDER"'] = "Pactic - ACS Greece Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_ECONT_BULGARIA_CROSS_BORDER = "PACTIC_ECONT_BULGARIA_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_ECONT_BULGARIA_CROSS_BORDER"'] = "Pactic - Econt Bulgaria Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_ECONT_BULGARIA_CROSS_BORDER_DIRECT_INJECTION = "PACTIC_ECONT_BULGARIA_CROSS_BORDER_DIRECT_INJECTION";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_ECONT_BULGARIA_CROSS_BORDER_DIRECT_INJECTION"'] = "Pactic - Econt Bulgaria Cross-border Direct Injection";
constants.SHIPPING_SERVICE_TYPE_PACTIC_ACS_GREECE_CROSS_BORDER_DIRECT_INJECTION = "PACTIC_ACS_GREECE_CROSS_BORDER_DIRECT_INJECTION";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_ACS_GREECE_CROSS_BORDER_DIRECT_INJECTION"'] = "Pactic - ACS Greece Cross-border Direct Injection";
constants.SHIPPING_SERVICE_TYPE_PACTIC_ECONT_BULGARIA_PARCELSHOP_CROSS_BORDER = "PACTIC_ECONT_BULGARIA_PARCELSHOP_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_ECONT_BULGARIA_PARCELSHOP_CROSS_BORDER"'] = "Pactic - Econt Bulgaria ParcelShop Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_ECONT_BULGARIA_PUDO_CROSS_BORDER_DIRECT_INJECTION = "PACTIC_ECONT_BULGARIA_PUDO_CROSS_BORDER_DIRECT_INJECTION";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_ECONT_BULGARIA_PUDO_CROSS_BORDER_DIRECT_INJECTION"'] = "Pactic - Econt Bulgaria PUDO Cross-border Direct Injection";
constants.SHIPPING_SERVICE_TYPE_PACTIC_SPEEDEX_GREECE_CROSS_BORDER = "PACTIC_SPEEDEX_GREECE_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_SPEEDEX_GREECE_CROSS_BORDER"'] = "Pactic - Speedex Greece Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_SPEEDEX_GREECE_CROSS_BORDER_DIRECT_INJECTION = "PACTIC_SPEEDEX_GREECE_CROSS_BORDER_DIRECT_INJECTION";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_SPEEDEX_GREECE_CROSS_BORDER_DIRECT_INJECTION"'] = "Pactic - Speedex Greece Cross-border Direct Injection";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GENIKI_GREECE_CROSS_BORDER = "PACTIC_GENIKI_GREECE_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GENIKI_GREECE_CROSS_BORDER"'] = "Pactic - Geniki Greece Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GENIKI_GREECE_CROSS_BORDER_DIRECT_INJECTION = "PACTIC_GENIKI_GREECE_CROSS_BORDER_DIRECT_INJECTION";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GENIKI_GREECE_CROSS_BORDER_DIRECT_INJECTION"'] = "Pactic - Geniki Greece Cross-border Direct Injection";
constants.SHIPPING_SERVICE_TYPE_PACTIC_BIZ_GREECE_CROSS_BORDER = "PACTIC_BIZ_GREECE_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_BIZ_GREECE_CROSS_BORDER"'] = "Pactic - BIZ Greece Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_INPOST_POLAND_CROSS_BORDER_DIRECT_INJECTION = "PACTIC_INPOST_POLAND_CROSS_BORDER_DIRECT_INJECTION";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_INPOST_POLAND_CROSS_BORDER_DIRECT_INJECTION"'] = "Pactic - InPost Poland Cross-border Direct Injection";
constants.SHIPPING_SERVICE_TYPE_PACTIC_INPOST_POLAND_CROSS_BORDER = "PACTIC_INPOST_POLAND_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_INPOST_POLAND_CROSS_BORDER"'] = "Pactic - InPost Poland Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_INPOST_POLAND_LOCKER_CROSS_BORDER = "PACTIC_INPOST_POLAND_LOCKER_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_INPOST_POLAND_LOCKER_CROSS_BORDER"'] = "Pactic - InPost Poland Locker Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_INPOST_POLAND_LOCKER_CROSS_BORDER_INJECTION = "PACTIC_INPOST_POLAND_LOCKER_CROSS_BORDER_INJECTION";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_INPOST_POLAND_LOCKER_CROSS_BORDER_INJECTION"'] = "Pactic - InPost Poland Locker Cross-border injection";
constants.SHIPPING_SERVICE_TYPE_PACTIC_URGENTCARGUS_CROSS_BORDER = "PACTIC_URGENTCARGUS_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_URGENTCARGUS_CROSS_BORDER"'] = "Pactic - UrgentCargus Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_URGENTCARGUS_CROSS_BORDER_DIRECT_INJECTION = "PACTIC_URGENTCARGUS_CROSS_BORDER_DIRECT_INJECTION";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_URGENTCARGUS_CROSS_BORDER_DIRECT_INJECTION"'] = "Pactic - UrgentCargus Cross-border Direct Injection";
constants.SHIPPING_SERVICE_TYPE_PACTIC_WEDO_CZECH_REPUBLIC_CROSS_BORDER = "PACTIC_WEDO_CZECH_REPUBLIC_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_WEDO_CZECH_REPUBLIC_CROSS_BORDER"'] = "Pactic - WE|DO Czech Republic Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_WEDO_CZECH_REPUBLIC_CROSS_BORDER_DIRECT_INJECTION = "PACTIC_WEDO_CZECH_REPUBLIC_CROSS_BORDER_DIRECT_INJECTION";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_WEDO_CZECH_REPUBLIC_CROSS_BORDER_DIRECT_INJECTION"'] = "Pactic - WE|DO Czech Republic Cross-border Direct Injection";
constants.SHIPPING_SERVICE_TYPE_PACTIC_SLOVAK_POST_CROSS_BORDER = "PACTIC_SLOVAK_POST_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_SLOVAK_POST_CROSS_BORDER"'] = "Pactic - Slovak Post Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_SLOVAK_POST_CROSS_BORDER_PUDO = "PACTIC_SLOVAK_POST_CROSS_BORDER_PUDO";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_SLOVAK_POST_CROSS_BORDER_PUDO"'] = "Pactic - Slovak Post Cross-border PuDo";
constants.SHIPPING_SERVICE_TYPE_PACTIC_MPL_BUSINESS_POST_POINT = "PACTIC_MPL_BUSINESS_POST_POINT";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_MPL_BUSINESS_POST_POINT"'] = "Pactic - Pactic - MPL Post Point";
constants.SHIPPING_SERVICE_TYPE_PACTIC_B2C_EUROPE_CROSS_BORDER = "PACTIC_B2C_EUROPE_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_B2C_EUROPE_CROSS_BORDER"'] = "Pactic - B2C Europe Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_B2C_EUROPE_CROSS_BORDER_DIRECT_INJECTION = "PACTIC_B2C_EUROPE_CROSS_BORDER_DIRECT_INJECTION";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_B2C_EUROPE_CROSS_BORDER_DIRECT_INJECTION"'] = "Pactic - B2C Europe Cross-border direct injection";
constants.SHIPPING_SERVICE_TYPE_PACTIC_DHL_GERMANY_CROSS_BORDER = "PACTIC_DHL_GERMANY_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_DHL_GERMANY_CROSS_BORDER"'] = "Pactic - DHL Germany Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_DHL_GERMANY_CROSS_BORDER_PAKETSHOP = "PACTIC_DHL_GERMANY_CROSS_BORDER_PAKETSHOP";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_DHL_GERMANY_CROSS_BORDER_PAKETSHOP"'] = "Pactic - DHL Germany Cross-border paketshop";
constants.SHIPPING_SERVICE_TYPE_PACTIC_PPL_CZECH_CROSS_BORDER = "PACTIC_PPL_CZECH_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_PPL_CZECH_CROSS_BORDER"'] = "Pactic - PPL Czech Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_PPL_CZECH_CROSS_BORDER_DIRECT_INJECTION = "PACTIC_PPL_CZECH_CROSS_BORDER_DIRECT_INJECTION";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_PPL_CZECH_CROSS_BORDER_DIRECT_INJECTION"'] = "Pactic - PPL Czech Cross-border direct Injection";
constants.SHIPPING_SERVICE_TYPE_PACTIC_PPL_CZECH_CROSS_BORDER_PUDO = "PACTIC_PPL_CZECH_CROSS_BORDER_PUDO";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_PPL_CZECH_CROSS_BORDER_PUDO"'] = "Pactic - PPL Czech Cross-border PuDo";
constants.SHIPPING_SERVICE_TYPE_PACTIC_PPL_CZECH_CROSS_BORDER_PUDO_DIRECT_INJECTION = "PACTIC_PPL_CZECH_CROSS_BORDER_PUDO_DIRECT_INJECTION";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_PPL_CZECH_CROSS_BORDER_PUDO_DIRECT_INJECTION"'] = "Pactic - PPL Czech Cross-border PuDo Direct Injection";
constants.SHIPPING_SERVICE_TYPE_PACTIC_PPL_CZECH_PUDO_RETURN = "PACTIC_PPL_CZECH_PUDO_RETURN";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_PPL_CZECH_PUDO_RETURN"'] = "Pactic - PPL Czech PuDo Return";
constants.SHIPPING_SERVICE_TYPE_PACTIC_HERMES_GERMANY_CROSS_BORDER = "PACTIC_HERMES_GERMANY_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_HERMES_GERMANY_CROSS_BORDER"'] = "Pactic - Hermes Germany Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_SPRING_CROSS_BORDER_EU_DESTINATIONS = "PACTIC_SPRING_CROSS_BORDER_EU_DESTINATIONS";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_SPRING_CROSS_BORDER_EU_DESTINATIONS"'] = "Pactic - Spring Cross-border EU destinations";
constants.SHIPPING_SERVICE_TYPE_PACTIC_BPOST_BELGIUM_CROSS_BORDER = "PACTIC_BPOST_BELGIUM_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_BPOST_BELGIUM_CROSS_BORDER"'] = "Pactic - Bpost Belgium Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_BRING_DENMARK_CROSS_BORDER = "PACTIC_BRING_DENMARK_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_BRING_DENMARK_CROSS_BORDER"'] = "Pactic - Bring Denmark Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_POST_ESTONIA_CROSS_BORDER = "PACTIC_POST_ESTONIA_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_POST_ESTONIA_CROSS_BORDER"'] = "Pactic - Post Estonia Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_POST_FINLAND_CROSS_BORDER = "PACTIC_POST_FINLAND_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_POST_FINLAND_CROSS_BORDER"'] = "Pactic - Post Finland Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_COLIS_PRIVE_FRANCE_CROSS_BORDER = "PACTIC_COLIS_PRIVE_FRANCE_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_COLIS_PRIVE_FRANCE_CROSS_BORDER"'] = "Pactic - Colis Prive France Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_FASTWAY_IRELAND_CROSS_BORDER = "PACTIC_FASTWAY_IRELAND_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_FASTWAY_IRELAND_CROSS_BORDER"'] = "Pactic - Fastway Ireland Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_POST_LATVIA_CROSS_BORDER = "PACTIC_POST_LATVIA_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_POST_LATVIA_CROSS_BORDER"'] = "Pactic - Post Latvia Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_POST_LITHUANIA_CROSS_BORDER = "PACTIC_POST_LITHUANIA_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_POST_LITHUANIA_CROSS_BORDER"'] = "Pactic - Post Lithuania Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_POST_LUXEMBOURG_CROSS_BORDER = "PACTIC_POST_LUXEMBOURG_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_POST_LUXEMBOURG_CROSS_BORDER"'] = "Pactic - Post Luxembourg Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_POST_NL_NETHERLANDS_CROSS_BORDER = "PACTIC_POST_NL_NETHERLANDS_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_POST_NL_NETHERLANDS_CROSS_BORDER"'] = "Pactic - Post NL Netherlands Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_CTT_EXPRESS_PORTUGAL_CROSS_BORDER = "PACTIC_CTT_EXPRESS_PORTUGAL_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_CTT_EXPRESS_PORTUGAL_CROSS_BORDER"'] = "Pactic - CTT Express Portugal Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_CTT_EXPRESS_SPAIN_CROSS_BORDER = "PACTIC_CTT_EXPRESS_SPAIN_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_CTT_EXPRESS_SPAIN_CROSS_BORDER"'] = "Pactic - CTT Express Spain Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_BRING_SWEDEN_CROSS_BORDER = "PACTIC_BRING_SWEDEN_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_BRING_SWEDEN_CROSS_BORDER"'] = "Pactic - Bring Sweden Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_CROATIA_POST_CROSS_BORDER = "PACTIC_CROATIA_POST_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_CROATIA_POST_CROSS_BORDER"'] = "Pactic - Croatia Post Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_CROATIA_POST_CROSS_BORDER_PUDO = "PACTIC_CROATIA_POST_CROSS_BORDER_PUDO";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_CROATIA_POST_CROSS_BORDER_PUDO"'] = "Pactic - Croatia Post Cross-border PUDO";
constants.SHIPPING_SERVICE_TYPE_PACTIC_CROATIA_POST_CROSS_BORDER_DIRECT_INJECTION = "PACTIC_CROATIA_POST_CROSS_BORDER_DIRECT_INJECTION";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_CROATIA_POST_CROSS_BORDER_DIRECT_INJECTION"'] = "Pactic - Croatia Post Cross-border Direct inj.";
constants.SHIPPING_SERVICE_TYPE_PACTIC_CROATIA_POST_CROSS_BORDER_PUDO_DIRECT_INJECTION = "PACTIC_CROATIA_POST_CROSS_BORDER_PUDO_DIRECT_INJECTION";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_CROATIA_POST_CROSS_BORDER_PUDO_DIRECT_INJECTION"'] = "Pactic - Croatia Post Cross-border PUDO D. inj.";
constants.SHIPPING_SERVICE_TYPE_PACTIC_CZECH_POST_CROSS_BORDER = "PACTIC_CZECH_POST_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_CZECH_POST_CROSS_BORDER"'] = "Pactic - Czech Post Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_CZECH_POST_CROSS_BORDER_DIRECT_INJECTION = "PACTIC_CZECH_POST_CROSS_BORDER_DIRECT_INJECTION";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_CZECH_POST_CROSS_BORDER_DIRECT_INJECTION"'] = "Pactic - Czech Post Cross-border Dir. Inj.";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GLS_BUSINESS_HOME_DELIVERY = "PACTIC_GLS_BUSINESS_HOME_DELIVERY";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GLS_BUSINESS_HOME_DELIVERY"'] = "Pactic - GLS Business Home Delivery";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GLS_BUSINESS_PICKUP_POINT = "PACTIC_GLS_BUSINESS_PICKUP_POINT";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GLS_BUSINESS_PICKUP_POINT"'] = "Pactic - GLS Business PickUp Point";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GLS_HUNGARY_PICK_AND_SHIP_DOMESTIC = "PACTIC_GLS_HUNGARY_PICK_AND_SHIP_DOMESTIC";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GLS_HUNGARY_PICK_AND_SHIP_DOMESTIC"'] = "Pactic - GLS Hungary Pick & Ship Domestic";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GLS_HUNGARY_EXCHANGE_SERVICE = "PACTIC_GLS_HUNGARY_EXCHANGE_SERVICE";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GLS_HUNGARY_EXCHANGE_SERVICE"'] = "Pactic - GLS Hungary Exchange Service";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GLS_HUNGARY_CROSS_BORDER_PUDO_DIRECT_INJECTION = "PACTIC_GLS_HUNGARY_CROSS_BORDER_PUDO_DIRECT_INJECTION";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GLS_HUNGARY_CROSS_BORDER_PUDO_DIRECT_INJECTION"'] = "Pactic - GLS Hungary Cross-border PUDO Direct injection";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GLS_HUNGARY_CROSS_BORDER_PUDO = "PACTIC_GLS_HUNGARY_CROSS_BORDER_PUDO";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GLS_HUNGARY_CROSS_BORDER_PUDO"'] = "Pactic - GLS Hungary Cross-border PUDO";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GLS_HUNGARY_CROSS_BORDER = "PACTIC_GLS_HUNGARY_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GLS_HUNGARY_CROSS_BORDER"'] = "Pactic - GLS Hungary Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GLS_ROMANIA_CROSS_BORDER_DIRECT_INJECTION = "PACTIC_GLS_ROMANIA_CROSS_BORDER_DIRECT_INJECTION";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GLS_ROMANIA_CROSS_BORDER_DIRECT_INJECTION"'] = "Pactic - GLS Romania Cross-border Direct Injection";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GLS_ROMANIA_CROSS_BORDER = "PACTIC_GLS_ROMANIA_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GLS_ROMANIA_CROSS_BORDER"'] = "Pactic - GLS Romania Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GLS_ROMANIA_PICK_AND_SHIP_DOMESTIC = "PACTIC_GLS_ROMANIA_PICK_AND_SHIP_DOMESTIC";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GLS_ROMANIA_PICK_AND_SHIP_DOMESTIC"'] = "Pactic - GLS Romania Pick & Ship Domestic";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GLS_ROMANIA_EXCHANGE_SERVICE = "PACTIC_GLS_ROMANIA_EXCHANGE_SERVICE";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GLS_ROMANIA_EXCHANGE_SERVICE"'] = "Pactic - GLS Romania Exchange Service";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GLS_CROSS_BORDER_DIRECT = "PACTIC_GLS_CROSS_BORDER_DIRECT";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GLS_CROSS_BORDER_DIRECT"'] = "Pactic - Pactic - GLS Cross-border Direct";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GLS_SLOVENIA_CROSS_BORDER = "PACTIC_GLS_SLOVENIA_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GLS_SLOVENIA_CROSS_BORDER"'] = "Pactic - GLS Slovenia Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GLS_CZECH_REPUBLIC_CROSS_BORDER = "PACTIC_GLS_CZECH_REPUBLIC_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GLS_CZECH_REPUBLIC_CROSS_BORDER"'] = "Pactic - GLS Czech Republic Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GLS_SLOVENIA_DIRECT_INJECTION = "PACTIC_GLS_SLOVENIA_DIRECT_INJECTION";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GLS_SLOVENIA_DIRECT_INJECTION"'] = "Pactic - GLS Slovenia Direct Injection";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GLS_CROATIA_CROSS_BORDER = "PACTIC_GLS_CROATIA_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GLS_CROATIA_CROSS_BORDER"'] = "Pactic - GLS Croatia Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GLS_CROATIA_CROSS_BORDER_DIRECT_INJECTION = "PACTIC_GLS_CROATIA_CROSS_BORDER_DIRECT_INJECTION";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GLS_CROATIA_CROSS_BORDER_DIRECT_INJECTION"'] = "Pactic - GLS Croatia Cross-border Direct Injection";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GLS_CROATIA_PICK_AND_RETURN = "PACTIC_GLS_CROATIA_PICK_AND_RETURN";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GLS_CROATIA_PICK_AND_RETURN"'] = "Pactic - GLS Croatia Pick and Return";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GLS_SLOVENIA_PICK_AND_RETURN = "PACTIC_GLS_SLOVENIA_PICK_AND_RETURN";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GLS_SLOVENIA_PICK_AND_RETURN"'] = "Pactic - GLS Slovenia Pick and Return";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GLS_SLOVENIA_PUDO = "PACTIC_GLS_SLOVENIA_PUDO";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GLS_SLOVENIA_PUDO"'] = "Pactic - GLS Slovenia PUDO";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GLS_SLOVENIA_PUDO_DIRECT_INJECTION = "PACTIC_GLS_SLOVENIA_PUDO_DIRECT_INJECTION";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GLS_SLOVENIA_PUDO_DIRECT_INJECTION"'] = "Pactic - GLS Slovenia PUDO Direct Injection";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GLS_SLOVAKIA_CROSS_BORDER = "PACTIC_GLS_SLOVAKIA_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GLS_SLOVAKIA_CROSS_BORDER"'] = "Pactic - GLS Slovakia Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GLS_SLOVAKIA_CROSS_BORDER_DIRECT_INJECTION = "PACTIC_GLS_SLOVAKIA_CROSS_BORDER_DIRECT_INJECTION";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GLS_SLOVAKIA_CROSS_BORDER_DIRECT_INJECTION"'] = "Pactic - GLS Slovakia Cross-border Direct Injection";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GLS_SLOVAKIA_CROSS_BORDER_PUDO = "PACTIC_GLS_SLOVAKIA_CROSS_BORDER_PUDO";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GLS_SLOVAKIA_CROSS_BORDER_PUDO"'] = "Pactic - GLS Slovakia Cross-border PUDO";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GLS_SLOVAKIA_CROSS_BORDER_PUDO_DIRECT_INJECTION = "PACTIC_GLS_SLOVAKIA_CROSS_BORDER_PUDO_DIRECT_INJECTION";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GLS_SLOVAKIA_CROSS_BORDER_PUDO_DIRECT_INJECTION"'] = "Pactic - GLS Slovakia Cross-border PUDO Direct Injection";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GLS_SLOVAKIA_EXCHANGE_SERVICE = "PACTIC_GLS_SLOVAKIA_EXCHANGE_SERVICE";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GLS_SLOVAKIA_EXCHANGE_SERVICE"'] = "Pactic - GLS Slovakia Exchange Service";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GLS_SLOVAKIA_PICK_RETURN = "PACTIC_GLS_SLOVAKIA_PICK_RETURN";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GLS_SLOVAKIA_PICK_RETURN"'] = "Pactic - GLS Slovakia Pick & Return";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GLS_CROATIA_PUDO = "PACTIC_GLS_CROATIA_PUDO";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GLS_CROATIA_PUDO"'] = "Pactic - GLS Croatia PUDO";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GLS_CROATIA_PUDO_DIRECT_INJECTION = "PACTIC_GLS_CROATIA_PUDO_DIRECT_INJECTION";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GLS_CROATIA_PUDO_DIRECT_INJECTION"'] = "Pactic - GLS Croatia PUDO Direct Injection";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GLS_AUSTRIA_CROSS_BORDER = "PACTIC_GLS_AUSTRIA_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GLS_AUSTRIA_CROSS_BORDER"'] = "Pactic - GLS Austria Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GLS_AUSTRIA_PUDO_CROSS_BORDER = "PACTIC_GLS_AUSTRIA_PUDO_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GLS_AUSTRIA_PUDO_CROSS_BORDER"'] = "Pactic - GLS Austria PuDo Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GLS_ITALY_CROSS_BORDER = "PACTIC_GLS_ITALY_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GLS_ITALY_CROSS_BORDER"'] = "Pactic - GLS Italy Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GLS_ITALY_PUDO_CROSS_BORDER = "PACTIC_GLS_ITALY_PUDO_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GLS_ITALY_PUDO_CROSS_BORDER"'] = "Pactic - GLS Italy Cross-border PuDo";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GLS_ITALY_PICK_AND_RETURN = "PACTIC_GLS_ITALY_PICK_AND_RETURN";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GLS_ITALY_PICK_AND_RETURN"'] = "Pactic - GLS Italy Pick and Return";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GLS_POLAND_CROSS_BORDER = "PACTIC_GLS_POLAND_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GLS_POLAND_CROSS_BORDER"'] = "Pactic - GLS Poland Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GLS_POLAND_CROSS_BORDER_DIRECT_INJECTION = "PACTIC_GLS_POLAND_CROSS_BORDER_DIRECT_INJECTION";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GLS_POLAND_CROSS_BORDER_DIRECT_INJECTION"'] = "Pactic - GLS Poland Cross-border Direct Injection";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GLS_POLAND_CROSS_BORDER_PUDO = "PACTIC_GLS_POLAND_CROSS_BORDER_PUDO";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GLS_POLAND_CROSS_BORDER_PUDO"'] = "Pactic - GLS Poland Cross-border PuDo";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GLS_POLAND_CROSS_BORDER_PUDO_DIRECT_INJECTION = "PACTIC_GLS_POLAND_CROSS_BORDER_PUDO_DIRECT_INJECTION";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GLS_POLAND_CROSS_BORDER_PUDO_DIRECT_INJECTION"'] = "Pactic - GLS Poland Cross-border PuDo Direct Injection";
constants.SHIPPING_SERVICE_TYPE_PACTIC_GLS_POLAND_PICK_RETURN = "PACTIC_GLS_POLAND_PICK_RETURN";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_GLS_POLAND_PICK_RETURN"'] = "Pactic - GLS Poland Pick & Return";
constants.SHIPPING_SERVICE_TYPE_PACTIC_SAMEDAY_HUNGARY_CROSS_BORDER_DIRECT_INJECTION = "PACTIC_SAMEDAY_HUNGARY_CROSS_BORDER_DIRECT_INJECTION";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_SAMEDAY_HUNGARY_CROSS_BORDER_DIRECT_INJECTION"'] = "Pactic - Sameday Hungary Cross-border Direct Injection";
constants.SHIPPING_SERVICE_TYPE_PACTIC_SAMEDAY_HUNGARY_EASYBOX_DIRECT_INJECTION = "PACTIC_SAMEDAY_HUNGARY_EASYBOX_DIRECT_INJECTION";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_SAMEDAY_HUNGARY_EASYBOX_DIRECT_INJECTION"'] = "Pactic - Sameday Hungary Easybox Direct Injection";
constants.SHIPPING_SERVICE_TYPE_PACTIC_SAMEDAY_HUNGARY_CROSS_BORDER = "PACTIC_SAMEDAY_HUNGARY_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_SAMEDAY_HUNGARY_CROSS_BORDER"'] = "Pactic - Sameday Hungary Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_SAMEDAY_HUNGARY_CROSS_BORDER_EASYBOX = "PACTIC_SAMEDAY_HUNGARY_CROSS_BORDER_EASYBOX";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_SAMEDAY_HUNGARY_CROSS_BORDER_EASYBOX"'] = "Pactic - Sameday Hungary Cross-border Easybox";
constants.SHIPPING_SERVICE_TYPE_PACTIC_PACKETA_HUNGARY_PUDO = "PACTIC_PACKETA_HUNGARY_PUDO";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_PACKETA_HUNGARY_PUDO"'] = "Pactic - Packeta Hungary PuDo";
constants.SHIPPING_SERVICE_TYPE_PACTIC_SAMEDAY_ROMANIA_CROSS_BORDER = "PACTIC_SAMEDAY_ROMANIA_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_SAMEDAY_ROMANIA_CROSS_BORDER"'] = "Pactic - SameDay Romania Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_SAMEDAY_ROMANIA_CROSS_BORDER_DIRECT_INJECTION = "PACTIC_SAMEDAY_ROMANIA_CROSS_BORDER_DIRECT_INJECTION";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_SAMEDAY_ROMANIA_CROSS_BORDER_DIRECT_INJECTION"'] = "Pactic - SameDay Romania Cross-border Direct Injection";
constants.SHIPPING_SERVICE_TYPE_PACTIC_SAMEDAY_ROMANIA_PUDO_BUSINESS = "PACTIC_SAMEDAY_ROMANIA_PUDO_BUSINESS";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_SAMEDAY_ROMANIA_PUDO_BUSINESS"'] = "Pactic - SameDay Romania PuDo Business";
constants.SHIPPING_SERVICE_TYPE_PACTIC_SAMEDAY_ROMANIA_PUDO_CROSS_BORDER = "PACTIC_SAMEDAY_ROMANIA_PUDO_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_SAMEDAY_ROMANIA_PUDO_CROSS_BORDER"'] = "Pactic - SameDay Romania PuDo Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_SAMEDAY_ROMANIA_PUDO_DIRECT_INJECTION = "PACTIC_SAMEDAY_ROMANIA_PUDO_DIRECT_INJECTION";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_SAMEDAY_ROMANIA_PUDO_DIRECT_INJECTION"'] = "Pactic - SameDay Romania PuDo Direct Injection";
constants.SHIPPING_SERVICE_TYPE_PACTIC_SAMEDAY_BULGARIA_CROSS_BORDER = "PACTIC_SAMEDAY_BULGARIA_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_SAMEDAY_BULGARIA_CROSS_BORDER"'] = "Pactic - Sameday Bulgaria Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_SAMEDAY_BULGARIA_CROSS_BORDER_DIRECT_INJECTION = "PACTIC_SAMEDAY_BULGARIA_CROSS_BORDER_DIRECT_INJECTION";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_SAMEDAY_BULGARIA_CROSS_BORDER_DIRECT_INJECTION"'] = "Pactic - Sameday Bulgaria Cross-border Direct Injection";
constants.SHIPPING_SERVICE_TYPE_PACTIC_EXPRESSONE_CROSS_BORDER_DOMESTIC = "PACTIC_EXPRESSONE_CROSS_BORDER_DOMESTIC";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_EXPRESSONE_CROSS_BORDER_DOMESTIC"'] = "Pactic - ExpressOne Cross-border Domestic";
constants.SHIPPING_SERVICE_TYPE_PACTIC_EXPRESSONE_CROSS_BORDER_DIRECT_INJECTION = "PACTIC_EXPRESSONE_CROSS_BORDER_DIRECT_INJECTION";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_EXPRESSONE_CROSS_BORDER_DIRECT_INJECTION"'] = "Pactic - ExpressOne Cross-border Direct Injection";
constants.SHIPPING_SERVICE_TYPE_PACTIC_MPL_BUSINESS_PICKUP_POINT = "PACTIC_MPL_BUSINESS_PICKUP_POINT";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_MPL_BUSINESS_PICKUP_POINT"'] = "Pactic - Pactic - MPL PickUp Point";
constants.SHIPPING_SERVICE_TYPE_PACTIC_MPL_HUNGARY_CROSS_BORDER = "PACTIC_MPL_HUNGARY_CROSS_BORDER";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_MPL_HUNGARY_CROSS_BORDER"'] = "Pactic - MPL Hungary Cross-border";
constants.SHIPPING_SERVICE_TYPE_PACTIC_MPL_HUNGARY_CROSS_BORDER_PUDO_DIR_INJ = "PACTIC_MPL_HUNGARY_CROSS_BORDER_PUDO_DIR_INJ";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_MPL_HUNGARY_CROSS_BORDER_PUDO_DIR_INJ"'] = "Pactic - MPL Hungary Cross-border PUDO Dir. Inj.";
constants.SHIPPING_SERVICE_TYPE_PACTIC_MPL_HUNGARY_CROSS_BORDER_PUDO = "PACTIC_MPL_HUNGARY_CROSS_BORDER_PUDO";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_MPL_HUNGARY_CROSS_BORDER_PUDO"'] = "Pactic - MPL Hungary Cross-border PUDO";
constants.SHIPPING_SERVICE_TYPE_PACTIC_MPL_BUSINESS_MANIFEST = "PACTIC_MPL_BUSINESS_MANIFEST";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_MPL_BUSINESS_MANIFEST"'] = "Pactic - MPL Business Manifest";
constants.SHIPPING_SERVICE_TYPE_PACTIC_MPL_BUSINESS_PUDO_MANIFEST = "PACTIC_MPL_BUSINESS_PUDO_MANIFEST";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_MPL_BUSINESS_PUDO_MANIFEST"'] = "Pactic - MPL Business PuDo Manifest";
constants.SHIPPING_SERVICE_TYPE_PACTIC_MPL_HUNGARY_CROSS_BORDER_MANIFEST = "PACTIC_MPL_HUNGARY_CROSS_BORDER_MANIFEST";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_MPL_HUNGARY_CROSS_BORDER_MANIFEST"'] = "Pactic - MPL Hungary Cross-border Manifest";
constants.SHIPPING_SERVICE_TYPE_PACTIC_MPL_HUNGARY_CROSS_BORDER_PUDO_DIR_INJ_MANIFEST = "PACTIC_MPL_HUNGARY_CROSS_BORDER_PUDO_DIR_INJ_MANIFEST";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_MPL_HUNGARY_CROSS_BORDER_PUDO_DIR_INJ_MANIFEST"'] = "Pactic - MPL Hungary Cross-border PUDO Dir Inj Manifest";
constants.SHIPPING_SERVICE_TYPE_PACTIC_MPL_HUNGARY_CROSS_BORDER_PUDO_MANIFEST = "PACTIC_MPL_HUNGARY_CROSS_BORDER_PUDO_MANIFEST";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_MPL_HUNGARY_CROSS_BORDER_PUDO_MANIFEST"'] = "Pactic - MPL Hungary Cross-border PUDO Manifest";
constants.SHIPPING_SERVICE_TYPE_PACTIC_DPD_ROMANIA_CLASSIC_BUSINESS_DOMESTIC = "PACTIC_DPD_ROMANIA_CLASSIC_BUSINESS_DOMESTIC";
displayLookup['SHIPPING_SERVICE_TYPE."PACTIC_DPD_ROMANIA_CLASSIC_BUSINESS_DOMESTIC"'] = "Pactic - DPD Romania Classic Business Domestic";
constants.SHIPPING_SERVICE_TYPE_EMAG = "EMAG";
displayLookup['SHIPPING_SERVICE_TYPE."EMAG"'] = "EMAG";
constants.SHIPPING_SERVICE_TYPE_SAMEDAY = "SAMEDAY";
displayLookup['SHIPPING_SERVICE_TYPE."SAMEDAY"'] = "SAMEDAY";
constants.SHIPPING_SERVICE_TYPE_KUMI_DELIVERY = "KUMI_DELIVERY";
displayLookup['SHIPPING_SERVICE_TYPE."KUMI_DELIVERY"'] = "kumi delivery";
constants.SHIPPING_SERVICE_TYPE_KUMI_RETURN = "KUMI_RETURN";
displayLookup['SHIPPING_SERVICE_TYPE."KUMI_RETURN"'] = "kumi return";
constants.SHIPPING_SERVICE_TYPE_KUMI_REPLACEMENT = "KUMI_REPLACEMENT";
displayLookup['SHIPPING_SERVICE_TYPE."KUMI_REPLACEMENT"'] = "kumi replacement";
constants.SHIPPING_SERVICE_TYPE_KOVA_TRANS_DELIVERY = "KOVA_TRANS_DELIVERY";
displayLookup['SHIPPING_SERVICE_TYPE."KOVA_TRANS_DELIVERY"'] = "kova trans delivery";
constants.SHIPPING_SERVICE_TYPE_KOVA_TRANS_PICKUP = "KOVA_TRANS_PICKUP";
displayLookup['SHIPPING_SERVICE_TYPE."KOVA_TRANS_PICKUP"'] = "kova trans pickup";
constants.SHIPPING_SERVICE_TYPE_PANNONXP_DELIVERY = "PANNONXP_DELIVERY";
displayLookup['SHIPPING_SERVICE_TYPE."PANNONXP_DELIVERY"'] = "PannonXP delivery";
constants.SHIPPING_SERVICE_TYPE_PANNONXP_PICKUP_POINT = "PANNONXP_PICKUP_POINT";
displayLookup['SHIPPING_SERVICE_TYPE."PANNONXP_PICKUP_POINT"'] = "PannonXP pickup point";
constants.SHIPPING_SERVICE_TYPE_PANNONXP_RETURN = "PANNONXP_RETURN";
displayLookup['SHIPPING_SERVICE_TYPE."PANNONXP_RETURN"'] = "PannonXP return";

constants.SHOPRENTER_PRODUCT_CLASS_VARIANT_SELECT_TYPE = {
  SELECT: { color: null, label: true, value: 1 },
  ICON: { color: null, label: true, value: 2 },
  LIST: { color: null, label: true, value: 3 }
};
constants.SHOPRENTER_PRODUCT_CLASS_VARIANT_SELECT_TYPE_SELECT = 1;
displayLookup['SHOPRENTER_PRODUCT_CLASS_VARIANT_SELECT_TYPE.1'] = "select";
constants.SHOPRENTER_PRODUCT_CLASS_VARIANT_SELECT_TYPE_ICON = 2;
displayLookup['SHOPRENTER_PRODUCT_CLASS_VARIANT_SELECT_TYPE.2'] = "icon";
constants.SHOPRENTER_PRODUCT_CLASS_VARIANT_SELECT_TYPE_LIST = 3;
displayLookup['SHOPRENTER_PRODUCT_CLASS_VARIANT_SELECT_TYPE.3'] = "list";

constants.SHOPRENTER_PRODUCT_ORDERABLE = {
  YES: { color: null, label: true, value: "1" },
  NO: { color: null, label: true, value: "0" },
  QUOTATION: { color: null, label: true, value: "3" },
  INSTANT_ORDER: { color: null, label: true, value: "4" }
};
constants.SHOPRENTER_PRODUCT_ORDERABLE_YES = "1";
displayLookup['SHOPRENTER_PRODUCT_ORDERABLE."1"'] = "yes";
constants.SHOPRENTER_PRODUCT_ORDERABLE_NO = "0";
displayLookup['SHOPRENTER_PRODUCT_ORDERABLE."0"'] = "no";
constants.SHOPRENTER_PRODUCT_ORDERABLE_QUOTATION = "3";
displayLookup['SHOPRENTER_PRODUCT_ORDERABLE."3"'] = "quotation";
constants.SHOPRENTER_PRODUCT_ORDERABLE_INSTANT_ORDER = "4";
displayLookup['SHOPRENTER_PRODUCT_ORDERABLE."4"'] = "instant order";

constants.SHOPRENTER_PRODUCT_ORDERABLE_STATUS_SYNC = {
  DISABLED: { color: null, label: true, value: 0 },
  ENABLED_SYNC_NOT_AVAILABLE_STATUS: { color: null, label: true, value: 1 },
  ENABLED_DONT_SYNC_NOT_AVAILABLE_STATUS: { color: null, label: true, value: 2 }
};
constants.SHOPRENTER_PRODUCT_ORDERABLE_STATUS_SYNC_DISABLED = 0;
displayLookup['SHOPRENTER_PRODUCT_ORDERABLE_STATUS_SYNC.0'] = "disabled";
constants.SHOPRENTER_PRODUCT_ORDERABLE_STATUS_SYNC_ENABLED_SYNC_NOT_AVAILABLE_STATUS = 1;
displayLookup['SHOPRENTER_PRODUCT_ORDERABLE_STATUS_SYNC.1'] = "enabled sync not available status";
constants.SHOPRENTER_PRODUCT_ORDERABLE_STATUS_SYNC_ENABLED_DONT_SYNC_NOT_AVAILABLE_STATUS = 2;
displayLookup['SHOPRENTER_PRODUCT_ORDERABLE_STATUS_SYNC.2'] = "enabled dont sync not available status";

constants.SHOPRENTER_PRODUCT_STATUS = {
  DISABLED: { color: null, label: true, value: "0" },
  ENABLED: { color: null, label: true, value: "1" },
  END_OF_LIFE: { color: null, label: true, value: "2" }
};
constants.SHOPRENTER_PRODUCT_STATUS_DISABLED = "0";
displayLookup['SHOPRENTER_PRODUCT_STATUS."0"'] = "disabled";
constants.SHOPRENTER_PRODUCT_STATUS_ENABLED = "1";
displayLookup['SHOPRENTER_PRODUCT_STATUS."1"'] = "enabled";
constants.SHOPRENTER_PRODUCT_STATUS_END_OF_LIFE = "2";
displayLookup['SHOPRENTER_PRODUCT_STATUS."2"'] = "end of life";

constants.SPRINTER_DELIVERY_TYPE = {
  DELIVERY_AND_RETURNS: { color: null, label: "DeliveryAndReturns", value: "DeliveryAndReturns" },
  ONLY_DELIVERY: { color: null, label: "OnlyDelivery", value: "OnlyDelivery" },
  ONLY_RETURNS: { color: null, label: "OnlyReturns", value: "OnlyReturns" }
};
constants.SPRINTER_DELIVERY_TYPE_DELIVERY_AND_RETURNS = "DeliveryAndReturns";
displayLookup['SPRINTER_DELIVERY_TYPE."DeliveryAndReturns"'] = "DeliveryAndReturns";
constants.SPRINTER_DELIVERY_TYPE_ONLY_DELIVERY = "OnlyDelivery";
displayLookup['SPRINTER_DELIVERY_TYPE."OnlyDelivery"'] = "OnlyDelivery";
constants.SPRINTER_DELIVERY_TYPE_ONLY_RETURNS = "OnlyReturns";
displayLookup['SPRINTER_DELIVERY_TYPE."OnlyReturns"'] = "OnlyReturns";

constants.STOCK_TRANSFER_PICKING_MODE = {
  OPERATION: { color: null, label: "fixed operations", value: 1 },
  OPERATION_ITEM: { color: null, label: "max operation items", value: 2 },
  QUANTITY: { color: null, label: "max quantity", value: 3 }
};
constants.STOCK_TRANSFER_PICKING_MODE_OPERATION = 1;
displayLookup['STOCK_TRANSFER_PICKING_MODE.1'] = "fixed operations";
constants.STOCK_TRANSFER_PICKING_MODE_OPERATION_ITEM = 2;
displayLookup['STOCK_TRANSFER_PICKING_MODE.2'] = "max operation items";
constants.STOCK_TRANSFER_PICKING_MODE_QUANTITY = 3;
displayLookup['STOCK_TRANSFER_PICKING_MODE.3'] = "max quantity";

constants.STOCK_TRANSFER_SHIPPING_METHOD = {
  DELIVERY: { color: null, label: true, value: 1 },
  GLS_DELIVERY: { color: null, label: true, value: 50 },
  SPRINTER_DELIVERY: { color: null, label: true, value: 100 },
  PACKETA_DELIVERY: { color: null, label: true, value: 110 },
  EXPRESS_ONE_24H_DELIVERY: { color: null, label: true, value: 120 },
  EXPRESS_ONE_08H_DELIVERY: { color: null, label: true, value: 121 },
  EXPRESS_ONE_10H_DELIVERY: { color: null, label: true, value: 122 },
  EXPRESS_ONE_12H_DELIVERY: { color: null, label: true, value: 123 },
  EXPRESS_ONE_EXP_DELIVERY: { color: null, label: true, value: 124 },
  EXPRESS_ONE_D2S_DELIVERY: { color: null, label: true, value: 125 },
  EXPRESS_ONE_EST_DELIVERY: { color: null, label: true, value: 126 },
  LOCAL: { color: null, label: true, value: 150 }
};
constants.STOCK_TRANSFER_SHIPPING_METHOD_DELIVERY = 1;
displayLookup['STOCK_TRANSFER_SHIPPING_METHOD.1'] = "delivery";
constants.STOCK_TRANSFER_SHIPPING_METHOD_GLS_DELIVERY = 50;
displayLookup['STOCK_TRANSFER_SHIPPING_METHOD.50'] = "gls delivery";
constants.STOCK_TRANSFER_SHIPPING_METHOD_SPRINTER_DELIVERY = 100;
displayLookup['STOCK_TRANSFER_SHIPPING_METHOD.100'] = "sprinter delivery";
constants.STOCK_TRANSFER_SHIPPING_METHOD_PACKETA_DELIVERY = 110;
displayLookup['STOCK_TRANSFER_SHIPPING_METHOD.110'] = "packeta delivery";
constants.STOCK_TRANSFER_SHIPPING_METHOD_EXPRESS_ONE_24H_DELIVERY = 120;
displayLookup['STOCK_TRANSFER_SHIPPING_METHOD.120'] = "express one 24h delivery";
constants.STOCK_TRANSFER_SHIPPING_METHOD_EXPRESS_ONE_08H_DELIVERY = 121;
displayLookup['STOCK_TRANSFER_SHIPPING_METHOD.121'] = "express one 08h delivery";
constants.STOCK_TRANSFER_SHIPPING_METHOD_EXPRESS_ONE_10H_DELIVERY = 122;
displayLookup['STOCK_TRANSFER_SHIPPING_METHOD.122'] = "express one 10h delivery";
constants.STOCK_TRANSFER_SHIPPING_METHOD_EXPRESS_ONE_12H_DELIVERY = 123;
displayLookup['STOCK_TRANSFER_SHIPPING_METHOD.123'] = "express one 12h delivery";
constants.STOCK_TRANSFER_SHIPPING_METHOD_EXPRESS_ONE_EXP_DELIVERY = 124;
displayLookup['STOCK_TRANSFER_SHIPPING_METHOD.124'] = "express one exp delivery";
constants.STOCK_TRANSFER_SHIPPING_METHOD_EXPRESS_ONE_D2S_DELIVERY = 125;
displayLookup['STOCK_TRANSFER_SHIPPING_METHOD.125'] = "express one d2s delivery";
constants.STOCK_TRANSFER_SHIPPING_METHOD_EXPRESS_ONE_EST_DELIVERY = 126;
displayLookup['STOCK_TRANSFER_SHIPPING_METHOD.126'] = "express one est delivery";
constants.STOCK_TRANSFER_SHIPPING_METHOD_LOCAL = 150;
displayLookup['STOCK_TRANSFER_SHIPPING_METHOD.150'] = "local";

constants.STOCK_TRANSFER_STATUS = {
  WAITING: { color: "#e5e5e5", label: true, value: 1 },
  PICKING: { color: "#64b5f6", label: true, value: 20 },
  PICKED: { color: "#64b5f6", label: true, value: 21 },
  SHIPPING: { color: "#ffb74d", label: true, value: 40 },
  RECEIVED: { color: "#ffb74d", label: true, value: 60 },
  INBOUND_PICKING: { color: "#ffb74d", label: true, value: 61 },
  DONE: { color: "#66bb6a", label: true, value: 100 },
  SENT_TO_3PL: { color: "#162256", label: true, value: 110 }
};
constants.STOCK_TRANSFER_STATUS_WAITING = 1;
displayLookup['STOCK_TRANSFER_STATUS.1'] = "waiting";
colorLookup['STOCK_TRANSFER_STATUS.1'] = "#e5e5e5";
colorNameLookup['STOCK_TRANSFER_STATUS.1'] = "GREY";
constants.STOCK_TRANSFER_STATUS_PICKING = 20;
displayLookup['STOCK_TRANSFER_STATUS.20'] = "picking";
colorLookup['STOCK_TRANSFER_STATUS.20'] = "#64b5f6";
colorNameLookup['STOCK_TRANSFER_STATUS.20'] = "BLUE";
constants.STOCK_TRANSFER_STATUS_PICKED = 21;
displayLookup['STOCK_TRANSFER_STATUS.21'] = "picked";
colorLookup['STOCK_TRANSFER_STATUS.21'] = "#64b5f6";
colorNameLookup['STOCK_TRANSFER_STATUS.21'] = "BLUE";
constants.STOCK_TRANSFER_STATUS_SHIPPING = 40;
displayLookup['STOCK_TRANSFER_STATUS.40'] = "shipping";
colorLookup['STOCK_TRANSFER_STATUS.40'] = "#ffb74d";
colorNameLookup['STOCK_TRANSFER_STATUS.40'] = "YELLOW";
constants.STOCK_TRANSFER_STATUS_RECEIVED = 60;
displayLookup['STOCK_TRANSFER_STATUS.60'] = "received";
colorLookup['STOCK_TRANSFER_STATUS.60'] = "#ffb74d";
colorNameLookup['STOCK_TRANSFER_STATUS.60'] = "YELLOW";
constants.STOCK_TRANSFER_STATUS_INBOUND_PICKING = 61;
displayLookup['STOCK_TRANSFER_STATUS.61'] = "inbound picking";
colorLookup['STOCK_TRANSFER_STATUS.61'] = "#ffb74d";
colorNameLookup['STOCK_TRANSFER_STATUS.61'] = "YELLOW";
constants.STOCK_TRANSFER_STATUS_DONE = 100;
displayLookup['STOCK_TRANSFER_STATUS.100'] = "done";
colorLookup['STOCK_TRANSFER_STATUS.100'] = "#66bb6a";
colorNameLookup['STOCK_TRANSFER_STATUS.100'] = "GREEN";
constants.STOCK_TRANSFER_STATUS_SENT_TO_3PL = 110;
displayLookup['STOCK_TRANSFER_STATUS.110'] = "sent to 3pl";
colorLookup['STOCK_TRANSFER_STATUS.110'] = "#162256";
colorNameLookup['STOCK_TRANSFER_STATUS.110'] = "DARK_BLUE";

constants.STOCK_TRANSFER_TYPE = {
  NORMAL: { color: null, label: true, value: 1 },
  DYNAMIC: { color: null, label: true, value: 2 }
};
constants.STOCK_TRANSFER_TYPE_NORMAL = 1;
displayLookup['STOCK_TRANSFER_TYPE.1'] = "normal";
constants.STOCK_TRANSFER_TYPE_DYNAMIC = 2;
displayLookup['STOCK_TRANSFER_TYPE.2'] = "dynamic";

constants.SUPPLIER_TYPE = {
  VENDOR: { color: "#64b5f6", label: ["supplier type", "vendor"], value: 1 },
  SERVICE_PROVIDER: { color: "#f57c00", label: ["supplier type", "service provider"], value: 2 },
  OTHER: { color: "#66bb6a", label: ["supplier type", "other"], value: 3 }
};
constants.SUPPLIER_TYPE_VENDOR = 1;
displayLookup['SUPPLIER_TYPE.1'] = ["supplier type", "vendor"];
colorLookup['SUPPLIER_TYPE.1'] = "#64b5f6";
colorNameLookup['SUPPLIER_TYPE.1'] = "BLUE";
constants.SUPPLIER_TYPE_SERVICE_PROVIDER = 2;
displayLookup['SUPPLIER_TYPE.2'] = ["supplier type", "service provider"];
colorLookup['SUPPLIER_TYPE.2'] = "#f57c00";
colorNameLookup['SUPPLIER_TYPE.2'] = "ORANGE";
constants.SUPPLIER_TYPE_OTHER = 3;
displayLookup['SUPPLIER_TYPE.3'] = ["supplier type", "other"];
colorLookup['SUPPLIER_TYPE.3'] = "#66bb6a";
colorNameLookup['SUPPLIER_TYPE.3'] = "GREEN";

constants.SYNC_TYPE = {
  NORMAL: { color: null, label: "Normal sync", value: 1 },
  REVERSE: { color: null, label: "Reverse sync", value: 2 },
  MIXED: { color: null, label: "Mixed sync", value: 3 }
};
constants.SYNC_TYPE_NORMAL = 1;
displayLookup['SYNC_TYPE.1'] = "Normal sync";
constants.SYNC_TYPE_REVERSE = 2;
displayLookup['SYNC_TYPE.2'] = "Reverse sync";
constants.SYNC_TYPE_MIXED = 3;
displayLookup['SYNC_TYPE.3'] = "Mixed sync";

constants.SZAMLAZZ_INVOICE_TEMPLATE = {
  MOST: { color: null, label: "SzlaMost", value: "SzlaMost" },
  ALAP: { color: null, label: "SzlaAlap", value: "SzlaAlap" },
  NOENV: { color: null, label: "SzlaNoEnv", value: "SzlaNoEnv" },
  X8CM: { color: null, label: "Szla8cm", value: "Szla8cm" },
  TOMB: { color: null, label: "SzlaTomb", value: "SzlaTomb" },
  FUVARLEVELESALAP: { color: null, label: "szlafuvarlevelesalap", value: "szlafuvarlevelesalap" }
};
constants.SZAMLAZZ_INVOICE_TEMPLATE_MOST = "SzlaMost";
displayLookup['SZAMLAZZ_INVOICE_TEMPLATE."SzlaMost"'] = "SzlaMost";
constants.SZAMLAZZ_INVOICE_TEMPLATE_ALAP = "SzlaAlap";
displayLookup['SZAMLAZZ_INVOICE_TEMPLATE."SzlaAlap"'] = "SzlaAlap";
constants.SZAMLAZZ_INVOICE_TEMPLATE_NOENV = "SzlaNoEnv";
displayLookup['SZAMLAZZ_INVOICE_TEMPLATE."SzlaNoEnv"'] = "SzlaNoEnv";
constants.SZAMLAZZ_INVOICE_TEMPLATE_X8CM = "Szla8cm";
displayLookup['SZAMLAZZ_INVOICE_TEMPLATE."Szla8cm"'] = "Szla8cm";
constants.SZAMLAZZ_INVOICE_TEMPLATE_TOMB = "SzlaTomb";
displayLookup['SZAMLAZZ_INVOICE_TEMPLATE."SzlaTomb"'] = "SzlaTomb";
constants.SZAMLAZZ_INVOICE_TEMPLATE_FUVARLEVELESALAP = "szlafuvarlevelesalap";
displayLookup['SZAMLAZZ_INVOICE_TEMPLATE."szlafuvarlevelesalap"'] = "szlafuvarlevelesalap";

constants.SZAMLAZZ_RECEIPT_TEMPLATE = {
  A: { color: null, label: "A (A4)", value: "A" },
  N: { color: null, label: "N (logos 8cm)", value: "N" },
  J: { color: null, label: "J (6cm)", value: "J" },
  L: { color: null, label: "L (logos 6cm)", value: "L" }
};
constants.SZAMLAZZ_RECEIPT_TEMPLATE_A = "A";
displayLookup['SZAMLAZZ_RECEIPT_TEMPLATE."A"'] = "A (A4)";
constants.SZAMLAZZ_RECEIPT_TEMPLATE_N = "N";
displayLookup['SZAMLAZZ_RECEIPT_TEMPLATE."N"'] = "N (logos 8cm)";
constants.SZAMLAZZ_RECEIPT_TEMPLATE_J = "J";
displayLookup['SZAMLAZZ_RECEIPT_TEMPLATE."J"'] = "J (6cm)";
constants.SZAMLAZZ_RECEIPT_TEMPLATE_L = "L";
displayLookup['SZAMLAZZ_RECEIPT_TEMPLATE."L"'] = "L (logos 6cm)";

constants.TARGET_QUANTITY_CALCULATION = {
  MISSING: { color: null, label: [true], value: 1 },
  MIN_QUANTITY: { color: null, label: [true], value: 2 },
  MISSING_PLUS_MIN_QUANTITY: { color: null, label: [true], value: 3 },
  OPTIMAL_QUANTITY: { color: null, label: [true], value: 4 },
  MISSING_PLUS_OPTIMAL_QUANTITY: { color: null, label: [true], value: 5 },
  CALCULATED_MIN_QUANTITY: { color: null, label: [true], value: 6 },
  MISSING_PLUS_CALCULATED_MIN_QUANTITY: { color: null, label: [true], value: 7 },
  CALCULATED_OPTIMAL_QUANTITY: { color: null, label: [true], value: 8 },
  MISSING_PLUS_CALCULATED_OPTIMAL_QUANTITY: { color: null, label: [true], value: 9 }
};
constants.TARGET_QUANTITY_CALCULATION_MISSING = 1;
displayLookup['TARGET_QUANTITY_CALCULATION.1'] = ["target quantity calculation", "missing"];
constants.TARGET_QUANTITY_CALCULATION_MIN_QUANTITY = 2;
displayLookup['TARGET_QUANTITY_CALCULATION.2'] = ["target quantity calculation", "min quantity"];
constants.TARGET_QUANTITY_CALCULATION_MISSING_PLUS_MIN_QUANTITY = 3;
displayLookup['TARGET_QUANTITY_CALCULATION.3'] = ["target quantity calculation", "missing plus min quantity"];
constants.TARGET_QUANTITY_CALCULATION_OPTIMAL_QUANTITY = 4;
displayLookup['TARGET_QUANTITY_CALCULATION.4'] = ["target quantity calculation", "optimal quantity"];
constants.TARGET_QUANTITY_CALCULATION_MISSING_PLUS_OPTIMAL_QUANTITY = 5;
displayLookup['TARGET_QUANTITY_CALCULATION.5'] = ["target quantity calculation", "missing plus optimal quantity"];
constants.TARGET_QUANTITY_CALCULATION_CALCULATED_MIN_QUANTITY = 6;
displayLookup['TARGET_QUANTITY_CALCULATION.6'] = ["target quantity calculation", "calculated min quantity"];
constants.TARGET_QUANTITY_CALCULATION_MISSING_PLUS_CALCULATED_MIN_QUANTITY = 7;
displayLookup['TARGET_QUANTITY_CALCULATION.7'] = ["target quantity calculation", "missing plus calculated min quantity"];
constants.TARGET_QUANTITY_CALCULATION_CALCULATED_OPTIMAL_QUANTITY = 8;
displayLookup['TARGET_QUANTITY_CALCULATION.8'] = ["target quantity calculation", "calculated optimal quantity"];
constants.TARGET_QUANTITY_CALCULATION_MISSING_PLUS_CALCULATED_OPTIMAL_QUANTITY = 9;
displayLookup['TARGET_QUANTITY_CALCULATION.9'] = ["target quantity calculation", "missing plus calculated optimal quantity"];

constants.TASK_EVENT_TYPE = {
  CREATED: { color: null, label: true, value: 1 },
  EDITED: { color: null, label: true, value: 2 },
  STATUS_CHANGED: { color: null, label: true, value: 3 },
  DELETED: { color: null, label: true, value: 4 }
};
constants.TASK_EVENT_TYPE_CREATED = 1;
displayLookup['TASK_EVENT_TYPE.1'] = "created";
constants.TASK_EVENT_TYPE_EDITED = 2;
displayLookup['TASK_EVENT_TYPE.2'] = "edited";
constants.TASK_EVENT_TYPE_STATUS_CHANGED = 3;
displayLookup['TASK_EVENT_TYPE.3'] = "status changed";
constants.TASK_EVENT_TYPE_DELETED = 4;
displayLookup['TASK_EVENT_TYPE.4'] = "deleted";

constants.TASK_PRIORITY = {
  LOW: { color: "#64b5f6", label: true, value: 1 },
  MEDIUM: { color: "#f57c00", label: true, value: 50 },
  HIGH: { color: "#e57373", label: true, value: 100 }
};
constants.TASK_PRIORITY_LOW = 1;
displayLookup['TASK_PRIORITY.1'] = "low";
colorLookup['TASK_PRIORITY.1'] = "#64b5f6";
colorNameLookup['TASK_PRIORITY.1'] = "BLUE";
constants.TASK_PRIORITY_MEDIUM = 50;
displayLookup['TASK_PRIORITY.50'] = "medium";
colorLookup['TASK_PRIORITY.50'] = "#f57c00";
colorNameLookup['TASK_PRIORITY.50'] = "ORANGE";
constants.TASK_PRIORITY_HIGH = 100;
displayLookup['TASK_PRIORITY.100'] = "high";
colorLookup['TASK_PRIORITY.100'] = "#e57373";
colorNameLookup['TASK_PRIORITY.100'] = "RED";

constants.TASK_STATUS_CATEGORY = {
  TODO: { color: "#e5e5e5", label: [true], value: 1 },
  DONE: { color: "#66bb6a", label: [true], value: 100 }
};
constants.TASK_STATUS_CATEGORY_TODO = 1;
displayLookup['TASK_STATUS_CATEGORY.1'] = ["task status category", "todo"];
colorLookup['TASK_STATUS_CATEGORY.1'] = "#e5e5e5";
colorNameLookup['TASK_STATUS_CATEGORY.1'] = "GREY";
constants.TASK_STATUS_CATEGORY_DONE = 100;
displayLookup['TASK_STATUS_CATEGORY.100'] = ["task status category", "done"];
colorLookup['TASK_STATUS_CATEGORY.100'] = "#66bb6a";
colorNameLookup['TASK_STATUS_CATEGORY.100'] = "GREEN";

constants.TAX_TYPE = {
  NORMAL: { color: null, label: "belf\u00f6ldi ad\u00f3alany", value: 1 },
  NORMAL_GROUP: { color: null, label: "belf\u00f6ldi csoportos ad\u00f3alany", value: 2 },
  EU: { color: null, label: "eu-n bel\u00fcli ad\u00f3alany", value: 3 },
  THIRD_COUNTRY: { color: null, label: "eu-n k\u00edv\u00fcli ad\u00f3alany", value: 4 }
};
constants.TAX_TYPE_NORMAL = 1;
displayLookup['TAX_TYPE.1'] = "belf\u00f6ldi ad\u00f3alany";
constants.TAX_TYPE_NORMAL_GROUP = 2;
displayLookup['TAX_TYPE.2'] = "belf\u00f6ldi csoportos ad\u00f3alany";
constants.TAX_TYPE_EU = 3;
displayLookup['TAX_TYPE.3'] = "eu-n bel\u00fcli ad\u00f3alany";
constants.TAX_TYPE_THIRD_COUNTRY = 4;
displayLookup['TAX_TYPE.4'] = "eu-n k\u00edv\u00fcli ad\u00f3alany";

constants.TEMPLATE_EDITOR = {
  RICHTEXT: { color: null, label: true, value: 1 },
  TEXT: { color: null, label: "code", value: 2 }
};
constants.TEMPLATE_EDITOR_RICHTEXT = 1;
displayLookup['TEMPLATE_EDITOR.1'] = "richtext";
constants.TEMPLATE_EDITOR_TEXT = 2;
displayLookup['TEMPLATE_EDITOR.2'] = "code";

constants.TEMPLATE_ENGINE = {
  DJANGO: { color: null, label: "django templates", value: 1 },
  PYFORMAT: { color: null, label: "python format", value: 2 }
};
constants.TEMPLATE_ENGINE_DJANGO = 1;
displayLookup['TEMPLATE_ENGINE.1'] = "django templates";
constants.TEMPLATE_ENGINE_PYFORMAT = 2;
displayLookup['TEMPLATE_ENGINE.2'] = "python format";

constants.TEMPLATE_LANGUAGE_CODE = {
  HU: { color: null, label: "Hungarian", value: "hu" },
  EN: { color: null, label: "English", value: "en" },
  RO: { color: null, label: "Romanian", value: "ro" },
  CZ: { color: null, label: "Czech", value: "cz" },
  SK: { color: null, label: "Slovak", value: "sk" },
  DE: { color: null, label: "German", value: "de" },
  BG: { color: null, label: "Bulgarian", value: "bg" },
  HR: { color: null, label: "Croatian", value: "hr" },
  FR: { color: null, label: "French", value: "fr" },
  GR: { color: null, label: "Greek", value: "gr" },
  IT: { color: null, label: "Italian", value: "it" },
  PT: { color: null, label: "Portuguese", value: "pt" },
  SI: { color: null, label: "Slovenian", value: "si" },
  ES: { color: null, label: "Spanish", value: "es" },
  PL: { color: null, label: "Polish", value: "pl" }
};
constants.TEMPLATE_LANGUAGE_CODE_HU = "hu";
displayLookup['TEMPLATE_LANGUAGE_CODE."hu"'] = "Hungarian";
constants.TEMPLATE_LANGUAGE_CODE_EN = "en";
displayLookup['TEMPLATE_LANGUAGE_CODE."en"'] = "English";
constants.TEMPLATE_LANGUAGE_CODE_RO = "ro";
displayLookup['TEMPLATE_LANGUAGE_CODE."ro"'] = "Romanian";
constants.TEMPLATE_LANGUAGE_CODE_CZ = "cz";
displayLookup['TEMPLATE_LANGUAGE_CODE."cz"'] = "Czech";
constants.TEMPLATE_LANGUAGE_CODE_SK = "sk";
displayLookup['TEMPLATE_LANGUAGE_CODE."sk"'] = "Slovak";
constants.TEMPLATE_LANGUAGE_CODE_DE = "de";
displayLookup['TEMPLATE_LANGUAGE_CODE."de"'] = "German";
constants.TEMPLATE_LANGUAGE_CODE_BG = "bg";
displayLookup['TEMPLATE_LANGUAGE_CODE."bg"'] = "Bulgarian";
constants.TEMPLATE_LANGUAGE_CODE_HR = "hr";
displayLookup['TEMPLATE_LANGUAGE_CODE."hr"'] = "Croatian";
constants.TEMPLATE_LANGUAGE_CODE_FR = "fr";
displayLookup['TEMPLATE_LANGUAGE_CODE."fr"'] = "French";
constants.TEMPLATE_LANGUAGE_CODE_GR = "gr";
displayLookup['TEMPLATE_LANGUAGE_CODE."gr"'] = "Greek";
constants.TEMPLATE_LANGUAGE_CODE_IT = "it";
displayLookup['TEMPLATE_LANGUAGE_CODE."it"'] = "Italian";
constants.TEMPLATE_LANGUAGE_CODE_PT = "pt";
displayLookup['TEMPLATE_LANGUAGE_CODE."pt"'] = "Portuguese";
constants.TEMPLATE_LANGUAGE_CODE_SI = "si";
displayLookup['TEMPLATE_LANGUAGE_CODE."si"'] = "Slovenian";
constants.TEMPLATE_LANGUAGE_CODE_ES = "es";
displayLookup['TEMPLATE_LANGUAGE_CODE."es"'] = "Spanish";
constants.TEMPLATE_LANGUAGE_CODE_PL = "pl";
displayLookup['TEMPLATE_LANGUAGE_CODE."pl"'] = "Polish";

constants.TEMPLATE_OUTPUT_TYPE = {
  TEXT: { color: null, label: true, value: 1 },
  PDF: { color: null, label: true, value: 2 }
};
constants.TEMPLATE_OUTPUT_TYPE_TEXT = 1;
displayLookup['TEMPLATE_OUTPUT_TYPE.1'] = "text";
constants.TEMPLATE_OUTPUT_TYPE_PDF = 2;
displayLookup['TEMPLATE_OUTPUT_TYPE.2'] = "pdf";

constants.TEMPLATE_TYPE = {
  SKELETON: { color: null, label: true, value: -1 },
  GRID: { color: null, label: true, value: -2 },
  ORDER: { color: null, label: true, value: 1 },
  WAREHOUSE_LOCATION: { color: null, label: true, value: 2 },
  WAREHOUSE_OPERATION: { color: null, label: true, value: 3 },
  USER_INVITATION: { color: null, label: true, value: 4 },
  PURCHASE_ORDER: { color: null, label: true, value: 5 },
  SHIPMENT: { color: null, label: true, value: 6 },
  QUOTE: { color: null, label: true, value: 7 },
  PRODUCT: { color: null, label: true, value: 8 },
  DOCUMENT: { color: null, label: true, value: 9 },
  FISCAL_DAY: { color: null, label: true, value: 10 },
  EXPENSE: { color: null, label: true, value: 11 },
  REVENUE: { color: null, label: true, value: 12 },
  STOCK_TRANSFER: { color: null, label: true, value: 13 },
  VIEW_CONFIG: { color: null, label: true, value: 14 },
  INVOICE: { color: null, label: true, value: 15 }
};
constants.TEMPLATE_TYPE_SKELETON = -1;
displayLookup['TEMPLATE_TYPE.-1'] = "skeleton";
constants.TEMPLATE_TYPE_GRID = -2;
displayLookup['TEMPLATE_TYPE.-2'] = "grid";
constants.TEMPLATE_TYPE_ORDER = 1;
displayLookup['TEMPLATE_TYPE.1'] = "order";
constants.TEMPLATE_TYPE_WAREHOUSE_LOCATION = 2;
displayLookup['TEMPLATE_TYPE.2'] = "warehouse location";
constants.TEMPLATE_TYPE_WAREHOUSE_OPERATION = 3;
displayLookup['TEMPLATE_TYPE.3'] = "warehouse operation";
constants.TEMPLATE_TYPE_USER_INVITATION = 4;
displayLookup['TEMPLATE_TYPE.4'] = "user invitation";
constants.TEMPLATE_TYPE_PURCHASE_ORDER = 5;
displayLookup['TEMPLATE_TYPE.5'] = "purchase order";
constants.TEMPLATE_TYPE_SHIPMENT = 6;
displayLookup['TEMPLATE_TYPE.6'] = "shipment";
constants.TEMPLATE_TYPE_QUOTE = 7;
displayLookup['TEMPLATE_TYPE.7'] = "quote";
constants.TEMPLATE_TYPE_PRODUCT = 8;
displayLookup['TEMPLATE_TYPE.8'] = "product";
constants.TEMPLATE_TYPE_DOCUMENT = 9;
displayLookup['TEMPLATE_TYPE.9'] = "document";
constants.TEMPLATE_TYPE_FISCAL_DAY = 10;
displayLookup['TEMPLATE_TYPE.10'] = "fiscal day";
constants.TEMPLATE_TYPE_EXPENSE = 11;
displayLookup['TEMPLATE_TYPE.11'] = "expense";
constants.TEMPLATE_TYPE_REVENUE = 12;
displayLookup['TEMPLATE_TYPE.12'] = "revenue";
constants.TEMPLATE_TYPE_STOCK_TRANSFER = 13;
displayLookup['TEMPLATE_TYPE.13'] = "stock transfer";
constants.TEMPLATE_TYPE_VIEW_CONFIG = 14;
displayLookup['TEMPLATE_TYPE.14'] = "view config";
constants.TEMPLATE_TYPE_INVOICE = 15;
displayLookup['TEMPLATE_TYPE.15'] = "invoice";

constants.THIRD_PARTY_LOGISTICS_ENGINE = {
  ILOGISTIC: { color: null, label: true, value: 1 }
};
constants.THIRD_PARTY_LOGISTICS_ENGINE_ILOGISTIC = 1;
displayLookup['THIRD_PARTY_LOGISTICS_ENGINE.1'] = "ilogistic";

constants.THIRD_PARTY_LOGISTICS_ITEM_TYPE = {
  API_LOGIN: { color: null, label: true, value: 1 },
  ORDER: { color: null, label: true, value: 2 },
  ORDER_REVERSE: { color: null, label: true, value: 3 },
  PRODUCT: { color: null, label: true, value: 4 },
  PRODUCT_REVERSE: { color: null, label: true, value: 5 },
  SHIPMENT: { color: null, label: true, value: 6 },
  SHIPMENT_REVERSE: { color: null, label: true, value: 7 },
  STOCK_TRANSFER_SHIPMENT: { color: null, label: true, value: 8 },
  STOCK_TRANSFER_ORDER: { color: null, label: true, value: 9 },
  STOCK_TRANSFER_REVERSE: { color: null, label: true, value: 10 },
  STOCK_TRANSFER_SHIPMENT_REVERSE: { color: null, label: true, value: 11 },
  STOCK_TRANSFER_ORDER_REVERSE: { color: null, label: true, value: 12 },
  PRODUCT_STOCK_HEALTH: { color: null, label: true, value: 13 }
};
constants.THIRD_PARTY_LOGISTICS_ITEM_TYPE_API_LOGIN = 1;
displayLookup['THIRD_PARTY_LOGISTICS_ITEM_TYPE.1'] = "api login";
constants.THIRD_PARTY_LOGISTICS_ITEM_TYPE_ORDER = 2;
displayLookup['THIRD_PARTY_LOGISTICS_ITEM_TYPE.2'] = "order";
constants.THIRD_PARTY_LOGISTICS_ITEM_TYPE_ORDER_REVERSE = 3;
displayLookup['THIRD_PARTY_LOGISTICS_ITEM_TYPE.3'] = "order reverse";
constants.THIRD_PARTY_LOGISTICS_ITEM_TYPE_PRODUCT = 4;
displayLookup['THIRD_PARTY_LOGISTICS_ITEM_TYPE.4'] = "product";
constants.THIRD_PARTY_LOGISTICS_ITEM_TYPE_PRODUCT_REVERSE = 5;
displayLookup['THIRD_PARTY_LOGISTICS_ITEM_TYPE.5'] = "product reverse";
constants.THIRD_PARTY_LOGISTICS_ITEM_TYPE_SHIPMENT = 6;
displayLookup['THIRD_PARTY_LOGISTICS_ITEM_TYPE.6'] = "shipment";
constants.THIRD_PARTY_LOGISTICS_ITEM_TYPE_SHIPMENT_REVERSE = 7;
displayLookup['THIRD_PARTY_LOGISTICS_ITEM_TYPE.7'] = "shipment reverse";
constants.THIRD_PARTY_LOGISTICS_ITEM_TYPE_STOCK_TRANSFER_SHIPMENT = 8;
displayLookup['THIRD_PARTY_LOGISTICS_ITEM_TYPE.8'] = "stock transfer shipment";
constants.THIRD_PARTY_LOGISTICS_ITEM_TYPE_STOCK_TRANSFER_ORDER = 9;
displayLookup['THIRD_PARTY_LOGISTICS_ITEM_TYPE.9'] = "stock transfer order";
constants.THIRD_PARTY_LOGISTICS_ITEM_TYPE_STOCK_TRANSFER_REVERSE = 10;
displayLookup['THIRD_PARTY_LOGISTICS_ITEM_TYPE.10'] = "stock transfer reverse";
constants.THIRD_PARTY_LOGISTICS_ITEM_TYPE_STOCK_TRANSFER_SHIPMENT_REVERSE = 11;
displayLookup['THIRD_PARTY_LOGISTICS_ITEM_TYPE.11'] = "stock transfer shipment reverse";
constants.THIRD_PARTY_LOGISTICS_ITEM_TYPE_STOCK_TRANSFER_ORDER_REVERSE = 12;
displayLookup['THIRD_PARTY_LOGISTICS_ITEM_TYPE.12'] = "stock transfer order reverse";
constants.THIRD_PARTY_LOGISTICS_ITEM_TYPE_PRODUCT_STOCK_HEALTH = 13;
displayLookup['THIRD_PARTY_LOGISTICS_ITEM_TYPE.13'] = "product stock health";

constants.TRANSACTION_BATCH_STATUS = {
  PENDING: { color: "#e5e5e5", label: [true], value: 1 },
  COMPLETED: { color: "#66bb6a", label: [true], value: 2 }
};
constants.TRANSACTION_BATCH_STATUS_PENDING = 1;
displayLookup['TRANSACTION_BATCH_STATUS.1'] = ["transaction batch status", "pending"];
colorLookup['TRANSACTION_BATCH_STATUS.1'] = "#e5e5e5";
colorNameLookup['TRANSACTION_BATCH_STATUS.1'] = "GREY";
constants.TRANSACTION_BATCH_STATUS_COMPLETED = 2;
displayLookup['TRANSACTION_BATCH_STATUS.2'] = ["transaction batch status", "completed"];
colorLookup['TRANSACTION_BATCH_STATUS.2'] = "#66bb6a";
colorNameLookup['TRANSACTION_BATCH_STATUS.2'] = "GREEN";

constants.TRANSACTION_CATEGORY_CLASS = {
  NEGATIVE_FIXED_INVESTMENT: { color: "#e57373", label: ["transaction category class", "fixed investment"], value: -1 },
  NEGATIVE_TAX: { color: "#e57373", label: ["transaction category class", "tax"], value: -2 },
  NEGATIVE_FIXED_COST: { color: "#e57373", label: ["transaction category class", "fixed cost"], value: -3 },
  NEGATIVE_VARIABLE_COST: { color: "#e57373", label: ["transaction category class", "variable cost"], value: -4 },
  NEGATIVE_STOCK_INVESTMENT: { color: "#e57373", label: ["transaction category class", "stock investment"], value: -5 },
  NEGATIVE_VAT: { color: "#e57373", label: ["transaction category class", "negative vat"], value: -6 },
  NEGATIVE_COGS: { color: "#e57373", label: ["transaction category class", "cogs"], value: -7 },
  NEGATIVE_EPR: { color: "#e57373", label: ["transaction category class", "epr"], value: -8 },
  NEGATIVE_FINANCIAL_RESULT: { color: "#e57373", label: ["transaction category class", "financial result expense"], value: -9 },
  NEGATIVE_OTHER: { color: "#e57373", label: ["transaction category class", "other cost"], value: -100 },
  NEGATIVE_UNCATEGORIZED: { color: "#e57373", label: ["transaction category class", "uncategorized expense"], value: -1000 },
  TRANSFER: { color: "#f57c00", label: ["transaction category class", "transfer"], value: 0 },
  POSITIVE_REVENUE: { color: "#66bb6a", label: ["transaction category class", "revenue"], value: 1 },
  POSITIVE_VAT: { color: "#66bb6a", label: ["transaction category class", "positive vat"], value: 2 },
  POSITIVE_FINANCIAL_RESULT: { color: "#66bb6a", label: ["transaction category class", "financial result income"], value: 9 },
  POSITIVE_OTHER: { color: "#66bb6a", label: ["transaction category class", "other revenue"], value: 100 },
  POSITIVE_UNCATEGORIZED: { color: "#66bb6a", label: ["transaction category class", "uncategorized revenue"], value: 1000 }
};
constants.TRANSACTION_CATEGORY_CLASS_NEGATIVE_FIXED_INVESTMENT = -1;
displayLookup['TRANSACTION_CATEGORY_CLASS.-1'] = ["transaction category class", "fixed investment"];
colorLookup['TRANSACTION_CATEGORY_CLASS.-1'] = "#e57373";
colorNameLookup['TRANSACTION_CATEGORY_CLASS.-1'] = "RED";
constants.TRANSACTION_CATEGORY_CLASS_NEGATIVE_TAX = -2;
displayLookup['TRANSACTION_CATEGORY_CLASS.-2'] = ["transaction category class", "tax"];
colorLookup['TRANSACTION_CATEGORY_CLASS.-2'] = "#e57373";
colorNameLookup['TRANSACTION_CATEGORY_CLASS.-2'] = "RED";
constants.TRANSACTION_CATEGORY_CLASS_NEGATIVE_FIXED_COST = -3;
displayLookup['TRANSACTION_CATEGORY_CLASS.-3'] = ["transaction category class", "fixed cost"];
colorLookup['TRANSACTION_CATEGORY_CLASS.-3'] = "#e57373";
colorNameLookup['TRANSACTION_CATEGORY_CLASS.-3'] = "RED";
constants.TRANSACTION_CATEGORY_CLASS_NEGATIVE_VARIABLE_COST = -4;
displayLookup['TRANSACTION_CATEGORY_CLASS.-4'] = ["transaction category class", "variable cost"];
colorLookup['TRANSACTION_CATEGORY_CLASS.-4'] = "#e57373";
colorNameLookup['TRANSACTION_CATEGORY_CLASS.-4'] = "RED";
constants.TRANSACTION_CATEGORY_CLASS_NEGATIVE_STOCK_INVESTMENT = -5;
displayLookup['TRANSACTION_CATEGORY_CLASS.-5'] = ["transaction category class", "stock investment"];
colorLookup['TRANSACTION_CATEGORY_CLASS.-5'] = "#e57373";
colorNameLookup['TRANSACTION_CATEGORY_CLASS.-5'] = "RED";
constants.TRANSACTION_CATEGORY_CLASS_NEGATIVE_VAT = -6;
displayLookup['TRANSACTION_CATEGORY_CLASS.-6'] = ["transaction category class", "negative vat"];
colorLookup['TRANSACTION_CATEGORY_CLASS.-6'] = "#e57373";
colorNameLookup['TRANSACTION_CATEGORY_CLASS.-6'] = "RED";
constants.TRANSACTION_CATEGORY_CLASS_NEGATIVE_COGS = -7;
displayLookup['TRANSACTION_CATEGORY_CLASS.-7'] = ["transaction category class", "cogs"];
colorLookup['TRANSACTION_CATEGORY_CLASS.-7'] = "#e57373";
colorNameLookup['TRANSACTION_CATEGORY_CLASS.-7'] = "RED";
constants.TRANSACTION_CATEGORY_CLASS_NEGATIVE_EPR = -8;
displayLookup['TRANSACTION_CATEGORY_CLASS.-8'] = ["transaction category class", "epr"];
colorLookup['TRANSACTION_CATEGORY_CLASS.-8'] = "#e57373";
colorNameLookup['TRANSACTION_CATEGORY_CLASS.-8'] = "RED";
constants.TRANSACTION_CATEGORY_CLASS_NEGATIVE_FINANCIAL_RESULT = -9;
displayLookup['TRANSACTION_CATEGORY_CLASS.-9'] = ["transaction category class", "financial result expense"];
colorLookup['TRANSACTION_CATEGORY_CLASS.-9'] = "#e57373";
colorNameLookup['TRANSACTION_CATEGORY_CLASS.-9'] = "RED";
constants.TRANSACTION_CATEGORY_CLASS_NEGATIVE_OTHER = -100;
displayLookup['TRANSACTION_CATEGORY_CLASS.-100'] = ["transaction category class", "other cost"];
colorLookup['TRANSACTION_CATEGORY_CLASS.-100'] = "#e57373";
colorNameLookup['TRANSACTION_CATEGORY_CLASS.-100'] = "RED";
constants.TRANSACTION_CATEGORY_CLASS_NEGATIVE_UNCATEGORIZED = -1000;
displayLookup['TRANSACTION_CATEGORY_CLASS.-1000'] = ["transaction category class", "uncategorized expense"];
colorLookup['TRANSACTION_CATEGORY_CLASS.-1000'] = "#e57373";
colorNameLookup['TRANSACTION_CATEGORY_CLASS.-1000'] = "RED";
constants.TRANSACTION_CATEGORY_CLASS_TRANSFER = 0;
displayLookup['TRANSACTION_CATEGORY_CLASS.0'] = ["transaction category class", "transfer"];
colorLookup['TRANSACTION_CATEGORY_CLASS.0'] = "#f57c00";
colorNameLookup['TRANSACTION_CATEGORY_CLASS.0'] = "ORANGE";
constants.TRANSACTION_CATEGORY_CLASS_POSITIVE_REVENUE = 1;
displayLookup['TRANSACTION_CATEGORY_CLASS.1'] = ["transaction category class", "revenue"];
colorLookup['TRANSACTION_CATEGORY_CLASS.1'] = "#66bb6a";
colorNameLookup['TRANSACTION_CATEGORY_CLASS.1'] = "GREEN";
constants.TRANSACTION_CATEGORY_CLASS_POSITIVE_VAT = 2;
displayLookup['TRANSACTION_CATEGORY_CLASS.2'] = ["transaction category class", "positive vat"];
colorLookup['TRANSACTION_CATEGORY_CLASS.2'] = "#66bb6a";
colorNameLookup['TRANSACTION_CATEGORY_CLASS.2'] = "GREEN";
constants.TRANSACTION_CATEGORY_CLASS_POSITIVE_FINANCIAL_RESULT = 9;
displayLookup['TRANSACTION_CATEGORY_CLASS.9'] = ["transaction category class", "financial result income"];
colorLookup['TRANSACTION_CATEGORY_CLASS.9'] = "#66bb6a";
colorNameLookup['TRANSACTION_CATEGORY_CLASS.9'] = "GREEN";
constants.TRANSACTION_CATEGORY_CLASS_POSITIVE_OTHER = 100;
displayLookup['TRANSACTION_CATEGORY_CLASS.100'] = ["transaction category class", "other revenue"];
colorLookup['TRANSACTION_CATEGORY_CLASS.100'] = "#66bb6a";
colorNameLookup['TRANSACTION_CATEGORY_CLASS.100'] = "GREEN";
constants.TRANSACTION_CATEGORY_CLASS_POSITIVE_UNCATEGORIZED = 1000;
displayLookup['TRANSACTION_CATEGORY_CLASS.1000'] = ["transaction category class", "uncategorized revenue"];
colorLookup['TRANSACTION_CATEGORY_CLASS.1000'] = "#66bb6a";
colorNameLookup['TRANSACTION_CATEGORY_CLASS.1000'] = "GREEN";

constants.TRANSACTION_DIRECTION = {
  POSITIVE: { color: "#66bb6a", label: true, value: 1 },
  NEGATIVE: { color: "#e57373", label: true, value: -1 }
};
constants.TRANSACTION_DIRECTION_POSITIVE = 1;
displayLookup['TRANSACTION_DIRECTION.1'] = "positive";
colorLookup['TRANSACTION_DIRECTION.1'] = "#66bb6a";
colorNameLookup['TRANSACTION_DIRECTION.1'] = "GREEN";
constants.TRANSACTION_DIRECTION_NEGATIVE = -1;
displayLookup['TRANSACTION_DIRECTION.-1'] = "negative";
colorLookup['TRANSACTION_DIRECTION.-1'] = "#e57373";
colorNameLookup['TRANSACTION_DIRECTION.-1'] = "RED";

constants.TRANSACTION_IDENTIFICATION_STATUS = {
  UNIDENTIFIED: { color: "#e57373", label: ["transaction status", "unidentified"], value: 1 },
  UNLINKED_TRANSFER: { color: "#e57373", label: ["transaction status", "unlinked transfer"], value: 10 },
  UNCATEGORIZED: { color: "#e57373", label: ["transaction status", "uncategorized"], value: 2 },
  UNRECONCILED: { color: "#e57373", label: ["transaction status", "unreconciled"], value: 3 },
  PARTIALLY_CATEGORIZED: { color: "#f57c00", label: ["transaction status", "partially categorized"], value: 4 },
  PARTIALLY_RECONCILED: { color: "#f57c00", label: ["transaction status", "partially reconciled"], value: 5 },
  PARTIALLY_RECONCILED_CONFIRMATION_REQUIRED: { color: "#ffb74d", label: ["transaction status", "partially reconciled, approval required"], value: 8 },
  CATEGORIZED: { color: "#66bb6a", label: ["transaction status", "categorized"], value: 6 },
  RECONCILED: { color: "#66bb6a", label: ["transaction status", "reconciled"], value: 7 },
  RECONCILED_CONFIRMATION_REQUIRED: { color: "#ffb74d", label: ["transaction status", "reconciled, approval required"], value: 9 },
  RECONCILED_AND_CATEGORIZED_DEPRECATED: { color: "#66bb6a", label: ["transaction status", "reconciled and categorized (deprecated)"], value: 100 }
};
constants.TRANSACTION_IDENTIFICATION_STATUS_UNIDENTIFIED = 1;
displayLookup['TRANSACTION_IDENTIFICATION_STATUS.1'] = ["transaction status", "unidentified"];
colorLookup['TRANSACTION_IDENTIFICATION_STATUS.1'] = "#e57373";
colorNameLookup['TRANSACTION_IDENTIFICATION_STATUS.1'] = "RED";
constants.TRANSACTION_IDENTIFICATION_STATUS_UNLINKED_TRANSFER = 10;
displayLookup['TRANSACTION_IDENTIFICATION_STATUS.10'] = ["transaction status", "unlinked transfer"];
colorLookup['TRANSACTION_IDENTIFICATION_STATUS.10'] = "#e57373";
colorNameLookup['TRANSACTION_IDENTIFICATION_STATUS.10'] = "RED";
constants.TRANSACTION_IDENTIFICATION_STATUS_UNCATEGORIZED = 2;
displayLookup['TRANSACTION_IDENTIFICATION_STATUS.2'] = ["transaction status", "uncategorized"];
colorLookup['TRANSACTION_IDENTIFICATION_STATUS.2'] = "#e57373";
colorNameLookup['TRANSACTION_IDENTIFICATION_STATUS.2'] = "RED";
constants.TRANSACTION_IDENTIFICATION_STATUS_UNRECONCILED = 3;
displayLookup['TRANSACTION_IDENTIFICATION_STATUS.3'] = ["transaction status", "unreconciled"];
colorLookup['TRANSACTION_IDENTIFICATION_STATUS.3'] = "#e57373";
colorNameLookup['TRANSACTION_IDENTIFICATION_STATUS.3'] = "RED";
constants.TRANSACTION_IDENTIFICATION_STATUS_PARTIALLY_CATEGORIZED = 4;
displayLookup['TRANSACTION_IDENTIFICATION_STATUS.4'] = ["transaction status", "partially categorized"];
colorLookup['TRANSACTION_IDENTIFICATION_STATUS.4'] = "#f57c00";
colorNameLookup['TRANSACTION_IDENTIFICATION_STATUS.4'] = "ORANGE";
constants.TRANSACTION_IDENTIFICATION_STATUS_PARTIALLY_RECONCILED = 5;
displayLookup['TRANSACTION_IDENTIFICATION_STATUS.5'] = ["transaction status", "partially reconciled"];
colorLookup['TRANSACTION_IDENTIFICATION_STATUS.5'] = "#f57c00";
colorNameLookup['TRANSACTION_IDENTIFICATION_STATUS.5'] = "ORANGE";
constants.TRANSACTION_IDENTIFICATION_STATUS_PARTIALLY_RECONCILED_CONFIRMATION_REQUIRED = 8;
displayLookup['TRANSACTION_IDENTIFICATION_STATUS.8'] = ["transaction status", "partially reconciled, approval required"];
colorLookup['TRANSACTION_IDENTIFICATION_STATUS.8'] = "#ffb74d";
colorNameLookup['TRANSACTION_IDENTIFICATION_STATUS.8'] = "YELLOW";
constants.TRANSACTION_IDENTIFICATION_STATUS_CATEGORIZED = 6;
displayLookup['TRANSACTION_IDENTIFICATION_STATUS.6'] = ["transaction status", "categorized"];
colorLookup['TRANSACTION_IDENTIFICATION_STATUS.6'] = "#66bb6a";
colorNameLookup['TRANSACTION_IDENTIFICATION_STATUS.6'] = "GREEN";
constants.TRANSACTION_IDENTIFICATION_STATUS_RECONCILED = 7;
displayLookup['TRANSACTION_IDENTIFICATION_STATUS.7'] = ["transaction status", "reconciled"];
colorLookup['TRANSACTION_IDENTIFICATION_STATUS.7'] = "#66bb6a";
colorNameLookup['TRANSACTION_IDENTIFICATION_STATUS.7'] = "GREEN";
constants.TRANSACTION_IDENTIFICATION_STATUS_RECONCILED_CONFIRMATION_REQUIRED = 9;
displayLookup['TRANSACTION_IDENTIFICATION_STATUS.9'] = ["transaction status", "reconciled, approval required"];
colorLookup['TRANSACTION_IDENTIFICATION_STATUS.9'] = "#ffb74d";
colorNameLookup['TRANSACTION_IDENTIFICATION_STATUS.9'] = "YELLOW";
constants.TRANSACTION_IDENTIFICATION_STATUS_RECONCILED_AND_CATEGORIZED_DEPRECATED = 100;
displayLookup['TRANSACTION_IDENTIFICATION_STATUS.100'] = ["transaction status", "reconciled and categorized (deprecated)"];
colorLookup['TRANSACTION_IDENTIFICATION_STATUS.100'] = "#66bb6a";
colorNameLookup['TRANSACTION_IDENTIFICATION_STATUS.100'] = "GREEN";

constants.TRANSACTION_PROCESSING_STATUS = {
  PROCESSING: { color: "#64b5f6", label: ["transaction processing status", "processing"], value: 1 },
  PROCESSED: { color: "#66bb6a", label: ["transaction processing status", "processed"], value: 2 }
};
constants.TRANSACTION_PROCESSING_STATUS_PROCESSING = 1;
displayLookup['TRANSACTION_PROCESSING_STATUS.1'] = ["transaction processing status", "processing"];
colorLookup['TRANSACTION_PROCESSING_STATUS.1'] = "#64b5f6";
colorNameLookup['TRANSACTION_PROCESSING_STATUS.1'] = "BLUE";
constants.TRANSACTION_PROCESSING_STATUS_PROCESSED = 2;
displayLookup['TRANSACTION_PROCESSING_STATUS.2'] = ["transaction processing status", "processed"];
colorLookup['TRANSACTION_PROCESSING_STATUS.2'] = "#66bb6a";
colorNameLookup['TRANSACTION_PROCESSING_STATUS.2'] = "GREEN";

constants.TRANSACTION_SOURCE = {
  MANUAL: { color: null, label: ["transaction source", "manual"], value: 1 },
  POS: { color: null, label: ["transaction source", "pos"], value: 2 },
  DATA_IMPORT: { color: null, label: ["transaction source", "data import"], value: 3 },
  WEBSHOP: { color: null, label: ["transaction source", "webshop"], value: 4 },
  COD: { color: null, label: ["transaction source", "cod"], value: 5 },
  INVOICING_ACCOUNT: { color: null, label: ["transaction source", "invoicing account"], value: 6 },
  BANK_INTEGRATION: { color: null, label: ["transaction source", "bank integration"], value: 7 },
  AUTOMATICALLY_CREATED: { color: null, label: ["transaction source", "automatically created"], value: 8 },
  SZAMLAZZHU_TECHNICAL: { color: null, label: ["transaction source", "szamlazz.hu technical"], value: 9 }
};
constants.TRANSACTION_SOURCE_MANUAL = 1;
displayLookup['TRANSACTION_SOURCE.1'] = ["transaction source", "manual"];
constants.TRANSACTION_SOURCE_POS = 2;
displayLookup['TRANSACTION_SOURCE.2'] = ["transaction source", "pos"];
constants.TRANSACTION_SOURCE_DATA_IMPORT = 3;
displayLookup['TRANSACTION_SOURCE.3'] = ["transaction source", "data import"];
constants.TRANSACTION_SOURCE_WEBSHOP = 4;
displayLookup['TRANSACTION_SOURCE.4'] = ["transaction source", "webshop"];
constants.TRANSACTION_SOURCE_COD = 5;
displayLookup['TRANSACTION_SOURCE.5'] = ["transaction source", "cod"];
constants.TRANSACTION_SOURCE_INVOICING_ACCOUNT = 6;
displayLookup['TRANSACTION_SOURCE.6'] = ["transaction source", "invoicing account"];
constants.TRANSACTION_SOURCE_BANK_INTEGRATION = 7;
displayLookup['TRANSACTION_SOURCE.7'] = ["transaction source", "bank integration"];
constants.TRANSACTION_SOURCE_AUTOMATICALLY_CREATED = 8;
displayLookup['TRANSACTION_SOURCE.8'] = ["transaction source", "automatically created"];
constants.TRANSACTION_SOURCE_SZAMLAZZHU_TECHNICAL = 9;
displayLookup['TRANSACTION_SOURCE.9'] = ["transaction source", "szamlazz.hu technical"];

constants.TRANSACTION_STATISTIC_TYPE = {
  CASHFLOW: { color: null, label: true, value: 1 },
  RESULT: { color: null, label: true, value: 2 },
  GL: { color: null, label: true, value: 3 }
};
constants.TRANSACTION_STATISTIC_TYPE_CASHFLOW = 1;
displayLookup['TRANSACTION_STATISTIC_TYPE.1'] = "cashflow";
constants.TRANSACTION_STATISTIC_TYPE_RESULT = 2;
displayLookup['TRANSACTION_STATISTIC_TYPE.2'] = "result";
constants.TRANSACTION_STATISTIC_TYPE_GL = 3;
displayLookup['TRANSACTION_STATISTIC_TYPE.3'] = "gl";

constants.TRANSACTION_STATUS = {
  PENDING: { color: "#e5e5e5", label: ["transaction status", "pending"], value: 1 },
  COMPLETED: { color: "#66bb6a", label: ["transaction status", "completed"], value: 2 }
};
constants.TRANSACTION_STATUS_PENDING = 1;
displayLookup['TRANSACTION_STATUS.1'] = ["transaction status", "pending"];
colorLookup['TRANSACTION_STATUS.1'] = "#e5e5e5";
colorNameLookup['TRANSACTION_STATUS.1'] = "GREY";
constants.TRANSACTION_STATUS_COMPLETED = 2;
displayLookup['TRANSACTION_STATUS.2'] = ["transaction status", "completed"];
colorLookup['TRANSACTION_STATUS.2'] = "#66bb6a";
colorNameLookup['TRANSACTION_STATUS.2'] = "GREEN";

constants.TRANSACTION_TYPE = {
  EXPENSE: { color: "#e57373", label: ["transaction type", "expense"], value: -1 },
  TRANSFER: { color: "#f57c00", label: ["transaction type", "transfer"], value: 0 },
  REVENUE: { color: "#66bb6a", label: ["transaction type", "revenue"], value: 1 }
};
constants.TRANSACTION_TYPE_EXPENSE = -1;
displayLookup['TRANSACTION_TYPE.-1'] = ["transaction type", "expense"];
colorLookup['TRANSACTION_TYPE.-1'] = "#e57373";
colorNameLookup['TRANSACTION_TYPE.-1'] = "RED";
constants.TRANSACTION_TYPE_TRANSFER = 0;
displayLookup['TRANSACTION_TYPE.0'] = ["transaction type", "transfer"];
colorLookup['TRANSACTION_TYPE.0'] = "#f57c00";
colorNameLookup['TRANSACTION_TYPE.0'] = "ORANGE";
constants.TRANSACTION_TYPE_REVENUE = 1;
displayLookup['TRANSACTION_TYPE.1'] = ["transaction type", "revenue"];
colorLookup['TRANSACTION_TYPE.1'] = "#66bb6a";
colorNameLookup['TRANSACTION_TYPE.1'] = "GREEN";

constants.UNAS_PRODUCT_NEGATIVE_STOCK_ALLOWED = {
  NO: { color: null, label: true, value: "0" },
  YES: { color: null, label: true, value: "1" },
  AUTO: { color: null, label: "automatic", value: "2" }
};
constants.UNAS_PRODUCT_NEGATIVE_STOCK_ALLOWED_NO = "0";
displayLookup['UNAS_PRODUCT_NEGATIVE_STOCK_ALLOWED."0"'] = "no";
constants.UNAS_PRODUCT_NEGATIVE_STOCK_ALLOWED_YES = "1";
displayLookup['UNAS_PRODUCT_NEGATIVE_STOCK_ALLOWED."1"'] = "yes";
constants.UNAS_PRODUCT_NEGATIVE_STOCK_ALLOWED_AUTO = "2";
displayLookup['UNAS_PRODUCT_NEGATIVE_STOCK_ALLOWED."2"'] = "automatic";

constants.UNAS_PRODUCT_STATUS = {
  NOT_ACTIVE: { color: null, label: true, value: "0" },
  ACTIVE: { color: null, label: true, value: "1" },
  ACTIVE_NEW: { color: null, label: "active, new", value: "2" },
  ACTIVE_NOT_PURCHASABLE: { color: null, label: "active, not purchasable", value: "3" }
};
constants.UNAS_PRODUCT_STATUS_NOT_ACTIVE = "0";
displayLookup['UNAS_PRODUCT_STATUS."0"'] = "not active";
constants.UNAS_PRODUCT_STATUS_ACTIVE = "1";
displayLookup['UNAS_PRODUCT_STATUS."1"'] = "active";
constants.UNAS_PRODUCT_STATUS_ACTIVE_NEW = "2";
displayLookup['UNAS_PRODUCT_STATUS."2"'] = "active, new";
constants.UNAS_PRODUCT_STATUS_ACTIVE_NOT_PURCHASABLE = "3";
displayLookup['UNAS_PRODUCT_STATUS."3"'] = "active, not purchasable";

constants.UNIT_ISO = {
  CT: { color: null, label: ["iso unit", "carton"], value: "ct" },
  MTQ: { color: null, label: ["iso unit", "cubic meter"], value: "mtq" },
  DAY: { color: null, label: ["iso unit", "day"], value: "day" },
  HUR: { color: null, label: ["iso unit", "hour"], value: "hur" },
  KGM: { color: null, label: ["iso unit", "kilogram"], value: "kgm" },
  KMT: { color: null, label: ["iso unit", "kilometer"], value: "kmt" },
  KWH: { color: null, label: ["iso unit", "kilowatt-hour"], value: "kwh" },
  LTR: { color: null, label: ["iso unit", "liter"], value: "ltr" },
  MTR: { color: null, label: ["iso unit", "meter"], value: "mtr" },
  MIN: { color: null, label: ["iso unit", "minute"], value: "min" },
  MON: { color: null, label: ["iso unit", "month"], value: "mon" },
  OWN: { color: null, label: ["iso unit", "unique"], value: "own" },
  PK: { color: null, label: ["iso unit", "pack"], value: "pk" },
  PCE: { color: null, label: ["iso unit", "piece"], value: "pce" },
  TNE: { color: null, label: ["iso unit", "tonne (1000 kg)"], value: "tne" },
  X23: { color: null, label: ["iso unit", "gram/cubic centimeter"], value: "x23" },
  X28: { color: null, label: ["iso unit", "kilogram/square meter"], value: "x28" },
  X2J: { color: null, label: ["iso unit", "cubic centimeter/second"], value: "x2j" },
  X2M: { color: null, label: ["iso unit", "centimeter/second"], value: "x2m" },
  X2N: { color: null, label: ["iso unit", "decibel"], value: "x2n" },
  X2P: { color: null, label: ["iso unit", "kilobyte"], value: "x2p" },
  X2X: { color: null, label: ["iso unit", "meter/minute"], value: "x2x" },
  X2Z: { color: null, label: ["iso unit", "millivolt"], value: "x2z" },
  X3B: { color: null, label: ["iso unit", "megajoule"], value: "x3b" },
  X3H: { color: null, label: ["iso unit", "kilogram/kilogram"], value: "x3h" },
  X40: { color: null, label: ["iso unit", "milliliter/second"], value: "x40" },
  X4G: { color: null, label: ["iso unit", "microliter"], value: "x4g" },
  X4H: { color: null, label: ["iso unit", "micrometer"], value: "x4h" },
  X4K: { color: null, label: ["iso unit", "milliampere"], value: "x4k" },
  X4L: { color: null, label: ["iso unit", "megabyte"], value: "x4l" },
  X4O: { color: null, label: ["iso unit", "microfarad"], value: "x4o" },
  X4P: { color: null, label: ["iso unit", "newton/meter"], value: "x4p" },
  X4T: { color: null, label: ["iso unit", "pikofarad"], value: "x4t" },
  X59: { color: null, label: ["iso unit", "parts per million"], value: "x59" },
  X61: { color: null, label: ["iso unit", "parts per billion (US)"], value: "x61" },
  X74: { color: null, label: ["iso unit", "millipascal"], value: "x74" },
  X81: { color: null, label: ["iso unit", "henry"], value: "x81" },
  X93: { color: null, label: ["iso unit", "calorie/gram"], value: "x93" },
  A11: { color: null, label: ["iso unit", "angstrom"], value: "a11" },
  A18: { color: null, label: ["iso unit", "becquerel/kilogram"], value: "a18" },
  A53: { color: null, label: ["iso unit", "electronvolt"], value: "a53" },
  A86: { color: null, label: ["iso unit", "gigahertz"], value: "a86" },
  A87: { color: null, label: ["iso unit", "gigaohm"], value: "a87" },
  A90: { color: null, label: ["iso unit", "gigawatt"], value: "a90" },
  A93: { color: null, label: ["iso unit", "gram/cubic meter"], value: "a93" },
  A97: { color: null, label: ["iso unit", "hectopascal"], value: "a97" },
  ACR: { color: null, label: ["iso unit", "acre"], value: "acr" },
  AD: { color: null, label: ["iso unit", "byte"], value: "ad" },
  AMP: { color: null, label: ["iso unit", "ampere"], value: "amp" },
  ANN: { color: null, label: ["iso unit", "year"], value: "ann" },
  B0: { color: null, label: ["iso unit", "BTU/cubic foot"], value: "b0" },
  B11: { color: null, label: ["iso unit", "joule/(kilogram kelvin)"], value: "b11" },
  B15: { color: null, label: ["iso unit", "joule/mole"], value: "b15" },
  B22: { color: null, label: ["iso unit", "kiloampere"], value: "b22" },
  B25: { color: null, label: ["iso unit", "kilobecquerel/kilogram"], value: "b25" },
  B34: { color: null, label: ["iso unit", "kilogram/cubic decimeter"], value: "b34" },
  B42: { color: null, label: ["iso unit", "kilojoule/kilogram"], value: "b42" },
  B44: { color: null, label: ["iso unit", "kilojoule/mole"], value: "b44" },
  B45: { color: null, label: ["iso unit", "kilomol"], value: "b45" },
  B47: { color: null, label: ["iso unit", "kilonewton"], value: "b47" },
  B49: { color: null, label: ["iso unit", "kiloohm"], value: "b49" },
  B73: { color: null, label: ["iso unit", "meganewton"], value: "b73" },
  B75: { color: null, label: ["iso unit", "megohm"], value: "b75" },
  B78: { color: null, label: ["iso unit", "megavolt"], value: "b78" },
  B84: { color: null, label: ["iso unit", "microampere"], value: "b84" },
  B98: { color: null, label: ["iso unit", "microsecond"], value: "b98" },
  BAR: { color: null, label: ["iso unit", "bar"], value: "bar" },
  BD: { color: null, label: ["iso unit", "board"], value: "bd" },
  BG: { color: null, label: ["iso unit", "bag"], value: "bg" },
  BJ: { color: null, label: ["iso unit", "bucket"], value: "bj" },
  BO: { color: null, label: ["iso unit", "bottle"], value: "bo" },
  BQL: { color: null, label: ["iso unit", "becquerel"], value: "bql" },
  BX: { color: null, label: ["iso unit", "box"], value: "bx" },
  C10: { color: null, label: ["iso unit", "millifarad"], value: "c10" },
  C15: { color: null, label: ["iso unit", "millijoule"], value: "c15" },
  C16: { color: null, label: ["iso unit", "millimeter/second"], value: "c16" },
  C18: { color: null, label: ["iso unit", "millimole"], value: "c18" },
  C19: { color: null, label: ["iso unit", "mole/kilogram"], value: "c19" },
  C22: { color: null, label: ["iso unit", "millinewton/meter"], value: "c22" },
  C24: { color: null, label: ["iso unit", "millipascal seconds"], value: "c24" },
  C26: { color: null, label: ["iso unit", "millisecond"], value: "c26" },
  C29: { color: null, label: ["iso unit", "millitesla"], value: "c29" },
  C31: { color: null, label: ["iso unit", "milliwatt"], value: "c31" },
  C34: { color: null, label: ["iso unit", "mole"], value: "c34" },
  C36: { color: null, label: ["iso unit", "mol per conductability"], value: "c36" },
  C38: { color: null, label: ["iso unit", "mole per liter"], value: "c38" },
  C39: { color: null, label: ["iso unit", "nanoampere"], value: "c39" },
  C41: { color: null, label: ["iso unit", "nanofarad"], value: "c41" },
  C45: { color: null, label: ["iso unit", "nanometer"], value: "c45" },
  C47: { color: null, label: ["iso unit", "nanosecond"], value: "c47" },
  C55: { color: null, label: ["iso unit", "newton/square meter"], value: "c55" },
  C56: { color: null, label: ["iso unit", "newton/square millimeter"], value: "c56" },
  C60: { color: null, label: ["iso unit", "ohm centimeter"], value: "c60" },
  C61: { color: null, label: ["iso unit", "ohm meter"], value: "c61" },
  C62: { color: null, label: ["iso unit", "one"], value: "c62" },
  C65: { color: null, label: ["iso unit", "pascal second"], value: "c65" },
  CA: { color: null, label: ["iso unit", "canister"], value: "ca" },
  CCK: { color: null, label: ["iso unit", "ccm/kg"], value: "cck" },
  CDL: { color: null, label: ["iso unit", "candela"], value: "cdl" },
  CEL: { color: null, label: ["iso unit", "celsius"], value: "cel" },
  CH: { color: null, label: ["iso unit", "container"], value: "ch" },
  CLT: { color: null, label: ["iso unit", "centiliter"], value: "clt" },
  CMK: { color: null, label: ["iso unit", "square centimeter"], value: "cmk" },
  CMQ: { color: null, label: ["iso unit", "cubic centimeter"], value: "cmq" },
  CMT: { color: null, label: ["iso unit", "centimeter"], value: "cmt" },
  COU: { color: null, label: ["iso unit", "coulomb"], value: "cou" },
  CR: { color: null, label: ["iso unit", "crate"], value: "cr" },
  CS: { color: null, label: ["iso unit", "case"], value: "cs" },
  D10: { color: null, label: ["iso unit", "siemens per meter"], value: "d10" },
  D33: { color: null, label: ["iso unit", "tesla"], value: "d33" },
  D41: { color: null, label: ["iso unit", "ton/cubic meter"], value: "d41" },
  D46: { color: null, label: ["iso unit", "voltampere"], value: "d46" },
  D53: { color: null, label: ["iso unit", "watts per (meter kelvin)"], value: "d53" },
  D87: { color: null, label: ["iso unit", "millimole/kilogram"], value: "d87" },
  DC: { color: null, label: ["iso unit", "disc"], value: "dc" },
  DD: { color: null, label: ["iso unit", "degree"], value: "dd" },
  DMQ: { color: null, label: ["iso unit", "cubic decimeter"], value: "dmq" },
  DMT: { color: null, label: ["iso unit", "decimeter"], value: "dmt" },
  DR: { color: null, label: ["iso unit", "drum"], value: "dr" },
  DZN: { color: null, label: ["iso unit", "dozen"], value: "dzn" },
  E22: { color: null, label: ["iso unit", "twenty-foot equiv. unit"], value: "e22" },
  EA: { color: null, label: ["iso unit", "each"], value: "ea" },
  FAH: { color: null, label: ["iso unit", "fahrenheit"], value: "fah" },
  FAR: { color: null, label: ["iso unit", "farad"], value: "far" },
  FOT: { color: null, label: ["iso unit", "feet"], value: "fot" },
  FTK: { color: null, label: ["iso unit", "square foot"], value: "ftk" },
  FTQ: { color: null, label: ["iso unit", "cubic foot"], value: "ftq" },
  GE: { color: null, label: ["iso unit", "US pound/US gallon"], value: "ge" },
  GJ: { color: null, label: ["iso unit", "gram/milliliter"], value: "gj" },
  GK: { color: null, label: ["iso unit", "gram/kilogram"], value: "gk" },
  GL: { color: null, label: ["iso unit", "gram/liter"], value: "gl" },
  GLL: { color: null, label: ["iso unit", "US gallon"], value: "gll" },
  GM: { color: null, label: ["iso unit", "gram/square meter"], value: "gm" },
  GP: { color: null, label: ["iso unit", "milligram/cubic meter"], value: "gp" },
  GQ: { color: null, label: ["iso unit", "microgram/cubic meter"], value: "gq" },
  GRM: { color: null, label: ["iso unit", "gram"], value: "grm" },
  GRO: { color: null, label: ["iso unit", "gross"], value: "gro" },
  GV: { color: null, label: ["iso unit", "gigajoule"], value: "gv" },
  HAR: { color: null, label: ["iso unit", "hectare"], value: "har" },
  HLT: { color: null, label: ["iso unit", "hectoliter"], value: "hlt" },
  HTZ: { color: null, label: ["iso unit", "hertz"], value: "htz" },
  IE: { color: null, label: ["iso unit", "person"], value: "ie" },
  IM: { color: null, label: ["iso unit", "impression"], value: "im" },
  INH: { color: null, label: ["iso unit", "inch"], value: "inh" },
  INK: { color: null, label: ["iso unit", "square inch"], value: "ink" },
  INQ: { color: null, label: ["iso unit", "cubic inch"], value: "inq" },
  J2: { color: null, label: ["iso unit", "joule/kilogram"], value: "j2" },
  JOU: { color: null, label: ["iso unit", "joule"], value: "jou" },
  KEL: { color: null, label: ["iso unit", "kelvin"], value: "kel" },
  KGS: { color: null, label: ["iso unit", "kilogram per second"], value: "kgs" },
  KHZ: { color: null, label: ["iso unit", "kilohertz"], value: "khz" },
  KJO: { color: null, label: ["iso unit", "kilojoule"], value: "kjo" },
  KMH: { color: null, label: ["iso unit", "kilometer/hour"], value: "kmh" },
  KMK: { color: null, label: ["iso unit", "square kilometer"], value: "kmk" },
  KMQ: { color: null, label: ["iso unit", "kilogram per cubic meter"], value: "kmq" },
  KPA: { color: null, label: ["iso unit", "kilopascal"], value: "kpa" },
  KVA: { color: null, label: ["iso unit", "kilovoltampere"], value: "kva" },
  KVT: { color: null, label: ["iso unit", "kilovolt"], value: "kvt" },
  KWT: { color: null, label: ["iso unit", "kilowatt"], value: "kwt" },
  L2: { color: null, label: ["iso unit", "liter/minute"], value: "l2" },
  LBR: { color: null, label: ["iso unit", "US pound"], value: "lbr" },
  LR: { color: null, label: ["iso unit", "layer"], value: "lr" },
  M1: { color: null, label: ["iso unit", "milligram/liter"], value: "m1" },
  MAW: { color: null, label: ["iso unit", "megawatt"], value: "maw" },
  MBR: { color: null, label: ["iso unit", "millibar"], value: "mbr" },
  MGM: { color: null, label: ["iso unit", "milligram"], value: "mgm" },
  MHZ: { color: null, label: ["iso unit", "megahertz"], value: "mhz" },
  MIK: { color: null, label: ["iso unit", "square mile"], value: "mik" },
  MIL: { color: null, label: ["iso unit", "thousand"], value: "mil" },
  MLT: { color: null, label: ["iso unit", "milliliter"], value: "mlt" },
  MMK: { color: null, label: ["iso unit", "square millimeter"], value: "mmk" },
  MMQ: { color: null, label: ["iso unit", "cubic millimeter"], value: "mmq" },
  MMT: { color: null, label: ["iso unit", "millimeter"], value: "mmt" },
  MPA: { color: null, label: ["iso unit", "megapascal"], value: "mpa" },
  MQH: { color: null, label: ["iso unit", "cubic meter/hour"], value: "mqh" },
  MQS: { color: null, label: ["iso unit", "cubic meter per second"], value: "mqs" },
  MSK: { color: null, label: ["iso unit", "meter per second squared"], value: "msk" },
  MTK: { color: null, label: ["iso unit", "square meter"], value: "mtk" },
  MTS: { color: null, label: ["iso unit", "meters per second"], value: "mts" },
  MVA: { color: null, label: ["iso unit", "megavoltampere"], value: "mva" },
  MWH: { color: null, label: ["iso unit", "megawatt hour"], value: "mwh" },
  NA: { color: null, label: ["iso unit", "milligram/kilogram"], value: "na" },
  NEW: { color: null, label: ["iso unit", "newton"], value: "new" },
  OHM: { color: null, label: ["iso unit", "ohm"], value: "ohm" },
  ONZ: { color: null, label: ["iso unit", "ounce"], value: "onz" },
  OZA: { color: null, label: ["iso unit", "fluid ounce US"], value: "oza" },
  P1: { color: null, label: ["iso unit", "percentage"], value: "p1" },
  PA: { color: null, label: ["iso unit", "package"], value: "pa" },
  PAL: { color: null, label: ["iso unit", "pascal"], value: "pal" },
  PF: { color: null, label: ["iso unit", "pallet"], value: "pf" },
  PR: { color: null, label: ["iso unit", "pair"], value: "pr" },
  PT: { color: null, label: ["iso unit", "pint, US liquid"], value: "pt" },
  QT: { color: null, label: ["iso unit", "quart, US liquid"], value: "qt" },
  R4: { color: null, label: ["iso unit", "calorie"], value: "r4" },
  RO: { color: null, label: ["iso unit", "role"], value: "ro" },
  S4: { color: null, label: ["iso unit", "square meter/second"], value: "s4" },
  SEC: { color: null, label: ["iso unit", "second"], value: "sec" },
  SMI: { color: null, label: ["iso unit", "mile"], value: "smi" },
  STN: { color: null, label: ["iso unit", "US ton"], value: "stn" },
  T7: { color: null, label: ["iso unit", "1000 impression"], value: "t7" },
  TI: { color: null, label: ["iso unit", "tin"], value: "ti" },
  TU: { color: null, label: ["iso unit", "tube"], value: "tu" },
  VLT: { color: null, label: ["iso unit", "volt"], value: "vlt" },
  WEE: { color: null, label: ["iso unit", "week"], value: "wee" },
  WTT: { color: null, label: ["iso unit", "watt"], value: "wtt" },
  YDK: { color: null, label: ["iso unit", "square yard"], value: "ydk" },
  YDQ: { color: null, label: ["iso unit", "cubic yard"], value: "ydq" },
  YRD: { color: null, label: ["iso unit", "yards"], value: "yrd" },
  ZBD: { color: null, label: ["iso unit", "bundle"], value: "zbd" },
  ZBK: { color: null, label: ["iso unit", "book"], value: "zbk" },
  ZCD: { color: null, label: ["iso unit", "card"], value: "zcd" },
  ZCN: { color: null, label: ["iso unit", "carton"], value: "zcn" },
  ZCO: { color: null, label: ["iso unit", "coil"], value: "zco" },
  ZCW: { color: null, label: ["iso unit", "hundred weight"], value: "zcw" },
  ZGA: { color: null, label: ["iso unit", "US gallon"], value: "zga" },
  ZHU: { color: null, label: ["iso unit", "hundred"], value: "zhu" },
  ZKT: { color: null, label: ["iso unit", "kit"], value: "zkt" },
  ZLT: { color: null, label: ["iso unit", "lot"], value: "zlt" },
  ZMT: { color: null, label: ["iso unit", "meter"], value: "zmt" },
  ZPA: { color: null, label: ["iso unit", "pail"], value: "zpa" },
  ZPD: { color: null, label: ["iso unit", "pad"], value: "zpd" },
  ZRE: { color: null, label: ["iso unit", "reel"], value: "zre" },
  ZRL: { color: null, label: ["iso unit", "roll"], value: "zrl" },
  ZRM: { color: null, label: ["iso unit", "ream"], value: "zrm" },
  ZSH: { color: null, label: ["iso unit", "sheet"], value: "zsh" },
  ZSP: { color: null, label: ["iso unit", "shipper/spool"], value: "zsp" },
  ZST: { color: null, label: ["iso unit", "set"], value: "zst" },
  ZTB: { color: null, label: ["iso unit", "tube"], value: "ztb" },
  ZTH: { color: null, label: ["iso unit", "thousand"], value: "zth" },
  ZTL: { color: null, label: ["iso unit", "truckload"], value: "ztl" },
  ZTR: { color: null, label: ["iso unit", "tray"], value: "ztr" }
};
constants.UNIT_ISO_CT = "ct";
displayLookup['UNIT_ISO."ct"'] = ["iso unit", "carton"];
constants.UNIT_ISO_MTQ = "mtq";
displayLookup['UNIT_ISO."mtq"'] = ["iso unit", "cubic meter"];
constants.UNIT_ISO_DAY = "day";
displayLookup['UNIT_ISO."day"'] = ["iso unit", "day"];
constants.UNIT_ISO_HUR = "hur";
displayLookup['UNIT_ISO."hur"'] = ["iso unit", "hour"];
constants.UNIT_ISO_KGM = "kgm";
displayLookup['UNIT_ISO."kgm"'] = ["iso unit", "kilogram"];
constants.UNIT_ISO_KMT = "kmt";
displayLookup['UNIT_ISO."kmt"'] = ["iso unit", "kilometer"];
constants.UNIT_ISO_KWH = "kwh";
displayLookup['UNIT_ISO."kwh"'] = ["iso unit", "kilowatt-hour"];
constants.UNIT_ISO_LTR = "ltr";
displayLookup['UNIT_ISO."ltr"'] = ["iso unit", "liter"];
constants.UNIT_ISO_MTR = "mtr";
displayLookup['UNIT_ISO."mtr"'] = ["iso unit", "meter"];
constants.UNIT_ISO_MIN = "min";
displayLookup['UNIT_ISO."min"'] = ["iso unit", "minute"];
constants.UNIT_ISO_MON = "mon";
displayLookup['UNIT_ISO."mon"'] = ["iso unit", "month"];
constants.UNIT_ISO_OWN = "own";
displayLookup['UNIT_ISO."own"'] = ["iso unit", "unique"];
constants.UNIT_ISO_PK = "pk";
displayLookup['UNIT_ISO."pk"'] = ["iso unit", "pack"];
constants.UNIT_ISO_PCE = "pce";
displayLookup['UNIT_ISO."pce"'] = ["iso unit", "piece"];
constants.UNIT_ISO_TNE = "tne";
displayLookup['UNIT_ISO."tne"'] = ["iso unit", "tonne (1000 kg)"];
constants.UNIT_ISO_X23 = "x23";
displayLookup['UNIT_ISO."x23"'] = ["iso unit", "gram/cubic centimeter"];
constants.UNIT_ISO_X28 = "x28";
displayLookup['UNIT_ISO."x28"'] = ["iso unit", "kilogram/square meter"];
constants.UNIT_ISO_X2J = "x2j";
displayLookup['UNIT_ISO."x2j"'] = ["iso unit", "cubic centimeter/second"];
constants.UNIT_ISO_X2M = "x2m";
displayLookup['UNIT_ISO."x2m"'] = ["iso unit", "centimeter/second"];
constants.UNIT_ISO_X2N = "x2n";
displayLookup['UNIT_ISO."x2n"'] = ["iso unit", "decibel"];
constants.UNIT_ISO_X2P = "x2p";
displayLookup['UNIT_ISO."x2p"'] = ["iso unit", "kilobyte"];
constants.UNIT_ISO_X2X = "x2x";
displayLookup['UNIT_ISO."x2x"'] = ["iso unit", "meter/minute"];
constants.UNIT_ISO_X2Z = "x2z";
displayLookup['UNIT_ISO."x2z"'] = ["iso unit", "millivolt"];
constants.UNIT_ISO_X3B = "x3b";
displayLookup['UNIT_ISO."x3b"'] = ["iso unit", "megajoule"];
constants.UNIT_ISO_X3H = "x3h";
displayLookup['UNIT_ISO."x3h"'] = ["iso unit", "kilogram/kilogram"];
constants.UNIT_ISO_X40 = "x40";
displayLookup['UNIT_ISO."x40"'] = ["iso unit", "milliliter/second"];
constants.UNIT_ISO_X4G = "x4g";
displayLookup['UNIT_ISO."x4g"'] = ["iso unit", "microliter"];
constants.UNIT_ISO_X4H = "x4h";
displayLookup['UNIT_ISO."x4h"'] = ["iso unit", "micrometer"];
constants.UNIT_ISO_X4K = "x4k";
displayLookup['UNIT_ISO."x4k"'] = ["iso unit", "milliampere"];
constants.UNIT_ISO_X4L = "x4l";
displayLookup['UNIT_ISO."x4l"'] = ["iso unit", "megabyte"];
constants.UNIT_ISO_X4O = "x4o";
displayLookup['UNIT_ISO."x4o"'] = ["iso unit", "microfarad"];
constants.UNIT_ISO_X4P = "x4p";
displayLookup['UNIT_ISO."x4p"'] = ["iso unit", "newton/meter"];
constants.UNIT_ISO_X4T = "x4t";
displayLookup['UNIT_ISO."x4t"'] = ["iso unit", "pikofarad"];
constants.UNIT_ISO_X59 = "x59";
displayLookup['UNIT_ISO."x59"'] = ["iso unit", "parts per million"];
constants.UNIT_ISO_X61 = "x61";
displayLookup['UNIT_ISO."x61"'] = ["iso unit", "parts per billion (US)"];
constants.UNIT_ISO_X74 = "x74";
displayLookup['UNIT_ISO."x74"'] = ["iso unit", "millipascal"];
constants.UNIT_ISO_X81 = "x81";
displayLookup['UNIT_ISO."x81"'] = ["iso unit", "henry"];
constants.UNIT_ISO_X93 = "x93";
displayLookup['UNIT_ISO."x93"'] = ["iso unit", "calorie/gram"];
constants.UNIT_ISO_A11 = "a11";
displayLookup['UNIT_ISO."a11"'] = ["iso unit", "angstrom"];
constants.UNIT_ISO_A18 = "a18";
displayLookup['UNIT_ISO."a18"'] = ["iso unit", "becquerel/kilogram"];
constants.UNIT_ISO_A53 = "a53";
displayLookup['UNIT_ISO."a53"'] = ["iso unit", "electronvolt"];
constants.UNIT_ISO_A86 = "a86";
displayLookup['UNIT_ISO."a86"'] = ["iso unit", "gigahertz"];
constants.UNIT_ISO_A87 = "a87";
displayLookup['UNIT_ISO."a87"'] = ["iso unit", "gigaohm"];
constants.UNIT_ISO_A90 = "a90";
displayLookup['UNIT_ISO."a90"'] = ["iso unit", "gigawatt"];
constants.UNIT_ISO_A93 = "a93";
displayLookup['UNIT_ISO."a93"'] = ["iso unit", "gram/cubic meter"];
constants.UNIT_ISO_A97 = "a97";
displayLookup['UNIT_ISO."a97"'] = ["iso unit", "hectopascal"];
constants.UNIT_ISO_ACR = "acr";
displayLookup['UNIT_ISO."acr"'] = ["iso unit", "acre"];
constants.UNIT_ISO_AD = "ad";
displayLookup['UNIT_ISO."ad"'] = ["iso unit", "byte"];
constants.UNIT_ISO_AMP = "amp";
displayLookup['UNIT_ISO."amp"'] = ["iso unit", "ampere"];
constants.UNIT_ISO_ANN = "ann";
displayLookup['UNIT_ISO."ann"'] = ["iso unit", "year"];
constants.UNIT_ISO_B0 = "b0";
displayLookup['UNIT_ISO."b0"'] = ["iso unit", "BTU/cubic foot"];
constants.UNIT_ISO_B11 = "b11";
displayLookup['UNIT_ISO."b11"'] = ["iso unit", "joule/(kilogram kelvin)"];
constants.UNIT_ISO_B15 = "b15";
displayLookup['UNIT_ISO."b15"'] = ["iso unit", "joule/mole"];
constants.UNIT_ISO_B22 = "b22";
displayLookup['UNIT_ISO."b22"'] = ["iso unit", "kiloampere"];
constants.UNIT_ISO_B25 = "b25";
displayLookup['UNIT_ISO."b25"'] = ["iso unit", "kilobecquerel/kilogram"];
constants.UNIT_ISO_B34 = "b34";
displayLookup['UNIT_ISO."b34"'] = ["iso unit", "kilogram/cubic decimeter"];
constants.UNIT_ISO_B42 = "b42";
displayLookup['UNIT_ISO."b42"'] = ["iso unit", "kilojoule/kilogram"];
constants.UNIT_ISO_B44 = "b44";
displayLookup['UNIT_ISO."b44"'] = ["iso unit", "kilojoule/mole"];
constants.UNIT_ISO_B45 = "b45";
displayLookup['UNIT_ISO."b45"'] = ["iso unit", "kilomol"];
constants.UNIT_ISO_B47 = "b47";
displayLookup['UNIT_ISO."b47"'] = ["iso unit", "kilonewton"];
constants.UNIT_ISO_B49 = "b49";
displayLookup['UNIT_ISO."b49"'] = ["iso unit", "kiloohm"];
constants.UNIT_ISO_B73 = "b73";
displayLookup['UNIT_ISO."b73"'] = ["iso unit", "meganewton"];
constants.UNIT_ISO_B75 = "b75";
displayLookup['UNIT_ISO."b75"'] = ["iso unit", "megohm"];
constants.UNIT_ISO_B78 = "b78";
displayLookup['UNIT_ISO."b78"'] = ["iso unit", "megavolt"];
constants.UNIT_ISO_B84 = "b84";
displayLookup['UNIT_ISO."b84"'] = ["iso unit", "microampere"];
constants.UNIT_ISO_B98 = "b98";
displayLookup['UNIT_ISO."b98"'] = ["iso unit", "microsecond"];
constants.UNIT_ISO_BAR = "bar";
displayLookup['UNIT_ISO."bar"'] = ["iso unit", "bar"];
constants.UNIT_ISO_BD = "bd";
displayLookup['UNIT_ISO."bd"'] = ["iso unit", "board"];
constants.UNIT_ISO_BG = "bg";
displayLookup['UNIT_ISO."bg"'] = ["iso unit", "bag"];
constants.UNIT_ISO_BJ = "bj";
displayLookup['UNIT_ISO."bj"'] = ["iso unit", "bucket"];
constants.UNIT_ISO_BO = "bo";
displayLookup['UNIT_ISO."bo"'] = ["iso unit", "bottle"];
constants.UNIT_ISO_BQL = "bql";
displayLookup['UNIT_ISO."bql"'] = ["iso unit", "becquerel"];
constants.UNIT_ISO_BX = "bx";
displayLookup['UNIT_ISO."bx"'] = ["iso unit", "box"];
constants.UNIT_ISO_C10 = "c10";
displayLookup['UNIT_ISO."c10"'] = ["iso unit", "millifarad"];
constants.UNIT_ISO_C15 = "c15";
displayLookup['UNIT_ISO."c15"'] = ["iso unit", "millijoule"];
constants.UNIT_ISO_C16 = "c16";
displayLookup['UNIT_ISO."c16"'] = ["iso unit", "millimeter/second"];
constants.UNIT_ISO_C18 = "c18";
displayLookup['UNIT_ISO."c18"'] = ["iso unit", "millimole"];
constants.UNIT_ISO_C19 = "c19";
displayLookup['UNIT_ISO."c19"'] = ["iso unit", "mole/kilogram"];
constants.UNIT_ISO_C22 = "c22";
displayLookup['UNIT_ISO."c22"'] = ["iso unit", "millinewton/meter"];
constants.UNIT_ISO_C24 = "c24";
displayLookup['UNIT_ISO."c24"'] = ["iso unit", "millipascal seconds"];
constants.UNIT_ISO_C26 = "c26";
displayLookup['UNIT_ISO."c26"'] = ["iso unit", "millisecond"];
constants.UNIT_ISO_C29 = "c29";
displayLookup['UNIT_ISO."c29"'] = ["iso unit", "millitesla"];
constants.UNIT_ISO_C31 = "c31";
displayLookup['UNIT_ISO."c31"'] = ["iso unit", "milliwatt"];
constants.UNIT_ISO_C34 = "c34";
displayLookup['UNIT_ISO."c34"'] = ["iso unit", "mole"];
constants.UNIT_ISO_C36 = "c36";
displayLookup['UNIT_ISO."c36"'] = ["iso unit", "mol per conductability"];
constants.UNIT_ISO_C38 = "c38";
displayLookup['UNIT_ISO."c38"'] = ["iso unit", "mole per liter"];
constants.UNIT_ISO_C39 = "c39";
displayLookup['UNIT_ISO."c39"'] = ["iso unit", "nanoampere"];
constants.UNIT_ISO_C41 = "c41";
displayLookup['UNIT_ISO."c41"'] = ["iso unit", "nanofarad"];
constants.UNIT_ISO_C45 = "c45";
displayLookup['UNIT_ISO."c45"'] = ["iso unit", "nanometer"];
constants.UNIT_ISO_C47 = "c47";
displayLookup['UNIT_ISO."c47"'] = ["iso unit", "nanosecond"];
constants.UNIT_ISO_C55 = "c55";
displayLookup['UNIT_ISO."c55"'] = ["iso unit", "newton/square meter"];
constants.UNIT_ISO_C56 = "c56";
displayLookup['UNIT_ISO."c56"'] = ["iso unit", "newton/square millimeter"];
constants.UNIT_ISO_C60 = "c60";
displayLookup['UNIT_ISO."c60"'] = ["iso unit", "ohm centimeter"];
constants.UNIT_ISO_C61 = "c61";
displayLookup['UNIT_ISO."c61"'] = ["iso unit", "ohm meter"];
constants.UNIT_ISO_C62 = "c62";
displayLookup['UNIT_ISO."c62"'] = ["iso unit", "one"];
constants.UNIT_ISO_C65 = "c65";
displayLookup['UNIT_ISO."c65"'] = ["iso unit", "pascal second"];
constants.UNIT_ISO_CA = "ca";
displayLookup['UNIT_ISO."ca"'] = ["iso unit", "canister"];
constants.UNIT_ISO_CCK = "cck";
displayLookup['UNIT_ISO."cck"'] = ["iso unit", "ccm/kg"];
constants.UNIT_ISO_CDL = "cdl";
displayLookup['UNIT_ISO."cdl"'] = ["iso unit", "candela"];
constants.UNIT_ISO_CEL = "cel";
displayLookup['UNIT_ISO."cel"'] = ["iso unit", "celsius"];
constants.UNIT_ISO_CH = "ch";
displayLookup['UNIT_ISO."ch"'] = ["iso unit", "container"];
constants.UNIT_ISO_CLT = "clt";
displayLookup['UNIT_ISO."clt"'] = ["iso unit", "centiliter"];
constants.UNIT_ISO_CMK = "cmk";
displayLookup['UNIT_ISO."cmk"'] = ["iso unit", "square centimeter"];
constants.UNIT_ISO_CMQ = "cmq";
displayLookup['UNIT_ISO."cmq"'] = ["iso unit", "cubic centimeter"];
constants.UNIT_ISO_CMT = "cmt";
displayLookup['UNIT_ISO."cmt"'] = ["iso unit", "centimeter"];
constants.UNIT_ISO_COU = "cou";
displayLookup['UNIT_ISO."cou"'] = ["iso unit", "coulomb"];
constants.UNIT_ISO_CR = "cr";
displayLookup['UNIT_ISO."cr"'] = ["iso unit", "crate"];
constants.UNIT_ISO_CS = "cs";
displayLookup['UNIT_ISO."cs"'] = ["iso unit", "case"];
constants.UNIT_ISO_D10 = "d10";
displayLookup['UNIT_ISO."d10"'] = ["iso unit", "siemens per meter"];
constants.UNIT_ISO_D33 = "d33";
displayLookup['UNIT_ISO."d33"'] = ["iso unit", "tesla"];
constants.UNIT_ISO_D41 = "d41";
displayLookup['UNIT_ISO."d41"'] = ["iso unit", "ton/cubic meter"];
constants.UNIT_ISO_D46 = "d46";
displayLookup['UNIT_ISO."d46"'] = ["iso unit", "voltampere"];
constants.UNIT_ISO_D53 = "d53";
displayLookup['UNIT_ISO."d53"'] = ["iso unit", "watts per (meter kelvin)"];
constants.UNIT_ISO_D87 = "d87";
displayLookup['UNIT_ISO."d87"'] = ["iso unit", "millimole/kilogram"];
constants.UNIT_ISO_DC = "dc";
displayLookup['UNIT_ISO."dc"'] = ["iso unit", "disc"];
constants.UNIT_ISO_DD = "dd";
displayLookup['UNIT_ISO."dd"'] = ["iso unit", "degree"];
constants.UNIT_ISO_DMQ = "dmq";
displayLookup['UNIT_ISO."dmq"'] = ["iso unit", "cubic decimeter"];
constants.UNIT_ISO_DMT = "dmt";
displayLookup['UNIT_ISO."dmt"'] = ["iso unit", "decimeter"];
constants.UNIT_ISO_DR = "dr";
displayLookup['UNIT_ISO."dr"'] = ["iso unit", "drum"];
constants.UNIT_ISO_DZN = "dzn";
displayLookup['UNIT_ISO."dzn"'] = ["iso unit", "dozen"];
constants.UNIT_ISO_E22 = "e22";
displayLookup['UNIT_ISO."e22"'] = ["iso unit", "twenty-foot equiv. unit"];
constants.UNIT_ISO_EA = "ea";
displayLookup['UNIT_ISO."ea"'] = ["iso unit", "each"];
constants.UNIT_ISO_FAH = "fah";
displayLookup['UNIT_ISO."fah"'] = ["iso unit", "fahrenheit"];
constants.UNIT_ISO_FAR = "far";
displayLookup['UNIT_ISO."far"'] = ["iso unit", "farad"];
constants.UNIT_ISO_FOT = "fot";
displayLookup['UNIT_ISO."fot"'] = ["iso unit", "feet"];
constants.UNIT_ISO_FTK = "ftk";
displayLookup['UNIT_ISO."ftk"'] = ["iso unit", "square foot"];
constants.UNIT_ISO_FTQ = "ftq";
displayLookup['UNIT_ISO."ftq"'] = ["iso unit", "cubic foot"];
constants.UNIT_ISO_GE = "ge";
displayLookup['UNIT_ISO."ge"'] = ["iso unit", "US pound/US gallon"];
constants.UNIT_ISO_GJ = "gj";
displayLookup['UNIT_ISO."gj"'] = ["iso unit", "gram/milliliter"];
constants.UNIT_ISO_GK = "gk";
displayLookup['UNIT_ISO."gk"'] = ["iso unit", "gram/kilogram"];
constants.UNIT_ISO_GL = "gl";
displayLookup['UNIT_ISO."gl"'] = ["iso unit", "gram/liter"];
constants.UNIT_ISO_GLL = "gll";
displayLookup['UNIT_ISO."gll"'] = ["iso unit", "US gallon"];
constants.UNIT_ISO_GM = "gm";
displayLookup['UNIT_ISO."gm"'] = ["iso unit", "gram/square meter"];
constants.UNIT_ISO_GP = "gp";
displayLookup['UNIT_ISO."gp"'] = ["iso unit", "milligram/cubic meter"];
constants.UNIT_ISO_GQ = "gq";
displayLookup['UNIT_ISO."gq"'] = ["iso unit", "microgram/cubic meter"];
constants.UNIT_ISO_GRM = "grm";
displayLookup['UNIT_ISO."grm"'] = ["iso unit", "gram"];
constants.UNIT_ISO_GRO = "gro";
displayLookup['UNIT_ISO."gro"'] = ["iso unit", "gross"];
constants.UNIT_ISO_GV = "gv";
displayLookup['UNIT_ISO."gv"'] = ["iso unit", "gigajoule"];
constants.UNIT_ISO_HAR = "har";
displayLookup['UNIT_ISO."har"'] = ["iso unit", "hectare"];
constants.UNIT_ISO_HLT = "hlt";
displayLookup['UNIT_ISO."hlt"'] = ["iso unit", "hectoliter"];
constants.UNIT_ISO_HTZ = "htz";
displayLookup['UNIT_ISO."htz"'] = ["iso unit", "hertz"];
constants.UNIT_ISO_IE = "ie";
displayLookup['UNIT_ISO."ie"'] = ["iso unit", "person"];
constants.UNIT_ISO_IM = "im";
displayLookup['UNIT_ISO."im"'] = ["iso unit", "impression"];
constants.UNIT_ISO_INH = "inh";
displayLookup['UNIT_ISO."inh"'] = ["iso unit", "inch"];
constants.UNIT_ISO_INK = "ink";
displayLookup['UNIT_ISO."ink"'] = ["iso unit", "square inch"];
constants.UNIT_ISO_INQ = "inq";
displayLookup['UNIT_ISO."inq"'] = ["iso unit", "cubic inch"];
constants.UNIT_ISO_J2 = "j2";
displayLookup['UNIT_ISO."j2"'] = ["iso unit", "joule/kilogram"];
constants.UNIT_ISO_JOU = "jou";
displayLookup['UNIT_ISO."jou"'] = ["iso unit", "joule"];
constants.UNIT_ISO_KEL = "kel";
displayLookup['UNIT_ISO."kel"'] = ["iso unit", "kelvin"];
constants.UNIT_ISO_KGS = "kgs";
displayLookup['UNIT_ISO."kgs"'] = ["iso unit", "kilogram per second"];
constants.UNIT_ISO_KHZ = "khz";
displayLookup['UNIT_ISO."khz"'] = ["iso unit", "kilohertz"];
constants.UNIT_ISO_KJO = "kjo";
displayLookup['UNIT_ISO."kjo"'] = ["iso unit", "kilojoule"];
constants.UNIT_ISO_KMH = "kmh";
displayLookup['UNIT_ISO."kmh"'] = ["iso unit", "kilometer/hour"];
constants.UNIT_ISO_KMK = "kmk";
displayLookup['UNIT_ISO."kmk"'] = ["iso unit", "square kilometer"];
constants.UNIT_ISO_KMQ = "kmq";
displayLookup['UNIT_ISO."kmq"'] = ["iso unit", "kilogram per cubic meter"];
constants.UNIT_ISO_KPA = "kpa";
displayLookup['UNIT_ISO."kpa"'] = ["iso unit", "kilopascal"];
constants.UNIT_ISO_KVA = "kva";
displayLookup['UNIT_ISO."kva"'] = ["iso unit", "kilovoltampere"];
constants.UNIT_ISO_KVT = "kvt";
displayLookup['UNIT_ISO."kvt"'] = ["iso unit", "kilovolt"];
constants.UNIT_ISO_KWT = "kwt";
displayLookup['UNIT_ISO."kwt"'] = ["iso unit", "kilowatt"];
constants.UNIT_ISO_L2 = "l2";
displayLookup['UNIT_ISO."l2"'] = ["iso unit", "liter/minute"];
constants.UNIT_ISO_LBR = "lbr";
displayLookup['UNIT_ISO."lbr"'] = ["iso unit", "US pound"];
constants.UNIT_ISO_LR = "lr";
displayLookup['UNIT_ISO."lr"'] = ["iso unit", "layer"];
constants.UNIT_ISO_M1 = "m1";
displayLookup['UNIT_ISO."m1"'] = ["iso unit", "milligram/liter"];
constants.UNIT_ISO_MAW = "maw";
displayLookup['UNIT_ISO."maw"'] = ["iso unit", "megawatt"];
constants.UNIT_ISO_MBR = "mbr";
displayLookup['UNIT_ISO."mbr"'] = ["iso unit", "millibar"];
constants.UNIT_ISO_MGM = "mgm";
displayLookup['UNIT_ISO."mgm"'] = ["iso unit", "milligram"];
constants.UNIT_ISO_MHZ = "mhz";
displayLookup['UNIT_ISO."mhz"'] = ["iso unit", "megahertz"];
constants.UNIT_ISO_MIK = "mik";
displayLookup['UNIT_ISO."mik"'] = ["iso unit", "square mile"];
constants.UNIT_ISO_MIL = "mil";
displayLookup['UNIT_ISO."mil"'] = ["iso unit", "thousand"];
constants.UNIT_ISO_MLT = "mlt";
displayLookup['UNIT_ISO."mlt"'] = ["iso unit", "milliliter"];
constants.UNIT_ISO_MMK = "mmk";
displayLookup['UNIT_ISO."mmk"'] = ["iso unit", "square millimeter"];
constants.UNIT_ISO_MMQ = "mmq";
displayLookup['UNIT_ISO."mmq"'] = ["iso unit", "cubic millimeter"];
constants.UNIT_ISO_MMT = "mmt";
displayLookup['UNIT_ISO."mmt"'] = ["iso unit", "millimeter"];
constants.UNIT_ISO_MPA = "mpa";
displayLookup['UNIT_ISO."mpa"'] = ["iso unit", "megapascal"];
constants.UNIT_ISO_MQH = "mqh";
displayLookup['UNIT_ISO."mqh"'] = ["iso unit", "cubic meter/hour"];
constants.UNIT_ISO_MQS = "mqs";
displayLookup['UNIT_ISO."mqs"'] = ["iso unit", "cubic meter per second"];
constants.UNIT_ISO_MSK = "msk";
displayLookup['UNIT_ISO."msk"'] = ["iso unit", "meter per second squared"];
constants.UNIT_ISO_MTK = "mtk";
displayLookup['UNIT_ISO."mtk"'] = ["iso unit", "square meter"];
constants.UNIT_ISO_MTS = "mts";
displayLookup['UNIT_ISO."mts"'] = ["iso unit", "meters per second"];
constants.UNIT_ISO_MVA = "mva";
displayLookup['UNIT_ISO."mva"'] = ["iso unit", "megavoltampere"];
constants.UNIT_ISO_MWH = "mwh";
displayLookup['UNIT_ISO."mwh"'] = ["iso unit", "megawatt hour"];
constants.UNIT_ISO_NA = "na";
displayLookup['UNIT_ISO."na"'] = ["iso unit", "milligram/kilogram"];
constants.UNIT_ISO_NEW = "new";
displayLookup['UNIT_ISO."new"'] = ["iso unit", "newton"];
constants.UNIT_ISO_OHM = "ohm";
displayLookup['UNIT_ISO."ohm"'] = ["iso unit", "ohm"];
constants.UNIT_ISO_ONZ = "onz";
displayLookup['UNIT_ISO."onz"'] = ["iso unit", "ounce"];
constants.UNIT_ISO_OZA = "oza";
displayLookup['UNIT_ISO."oza"'] = ["iso unit", "fluid ounce US"];
constants.UNIT_ISO_P1 = "p1";
displayLookup['UNIT_ISO."p1"'] = ["iso unit", "percentage"];
constants.UNIT_ISO_PA = "pa";
displayLookup['UNIT_ISO."pa"'] = ["iso unit", "package"];
constants.UNIT_ISO_PAL = "pal";
displayLookup['UNIT_ISO."pal"'] = ["iso unit", "pascal"];
constants.UNIT_ISO_PF = "pf";
displayLookup['UNIT_ISO."pf"'] = ["iso unit", "pallet"];
constants.UNIT_ISO_PR = "pr";
displayLookup['UNIT_ISO."pr"'] = ["iso unit", "pair"];
constants.UNIT_ISO_PT = "pt";
displayLookup['UNIT_ISO."pt"'] = ["iso unit", "pint, US liquid"];
constants.UNIT_ISO_QT = "qt";
displayLookup['UNIT_ISO."qt"'] = ["iso unit", "quart, US liquid"];
constants.UNIT_ISO_R4 = "r4";
displayLookup['UNIT_ISO."r4"'] = ["iso unit", "calorie"];
constants.UNIT_ISO_RO = "ro";
displayLookup['UNIT_ISO."ro"'] = ["iso unit", "role"];
constants.UNIT_ISO_S4 = "s4";
displayLookup['UNIT_ISO."s4"'] = ["iso unit", "square meter/second"];
constants.UNIT_ISO_SEC = "sec";
displayLookup['UNIT_ISO."sec"'] = ["iso unit", "second"];
constants.UNIT_ISO_SMI = "smi";
displayLookup['UNIT_ISO."smi"'] = ["iso unit", "mile"];
constants.UNIT_ISO_STN = "stn";
displayLookup['UNIT_ISO."stn"'] = ["iso unit", "US ton"];
constants.UNIT_ISO_T7 = "t7";
displayLookup['UNIT_ISO."t7"'] = ["iso unit", "1000 impression"];
constants.UNIT_ISO_TI = "ti";
displayLookup['UNIT_ISO."ti"'] = ["iso unit", "tin"];
constants.UNIT_ISO_TU = "tu";
displayLookup['UNIT_ISO."tu"'] = ["iso unit", "tube"];
constants.UNIT_ISO_VLT = "vlt";
displayLookup['UNIT_ISO."vlt"'] = ["iso unit", "volt"];
constants.UNIT_ISO_WEE = "wee";
displayLookup['UNIT_ISO."wee"'] = ["iso unit", "week"];
constants.UNIT_ISO_WTT = "wtt";
displayLookup['UNIT_ISO."wtt"'] = ["iso unit", "watt"];
constants.UNIT_ISO_YDK = "ydk";
displayLookup['UNIT_ISO."ydk"'] = ["iso unit", "square yard"];
constants.UNIT_ISO_YDQ = "ydq";
displayLookup['UNIT_ISO."ydq"'] = ["iso unit", "cubic yard"];
constants.UNIT_ISO_YRD = "yrd";
displayLookup['UNIT_ISO."yrd"'] = ["iso unit", "yards"];
constants.UNIT_ISO_ZBD = "zbd";
displayLookup['UNIT_ISO."zbd"'] = ["iso unit", "bundle"];
constants.UNIT_ISO_ZBK = "zbk";
displayLookup['UNIT_ISO."zbk"'] = ["iso unit", "book"];
constants.UNIT_ISO_ZCD = "zcd";
displayLookup['UNIT_ISO."zcd"'] = ["iso unit", "card"];
constants.UNIT_ISO_ZCN = "zcn";
displayLookup['UNIT_ISO."zcn"'] = ["iso unit", "carton"];
constants.UNIT_ISO_ZCO = "zco";
displayLookup['UNIT_ISO."zco"'] = ["iso unit", "coil"];
constants.UNIT_ISO_ZCW = "zcw";
displayLookup['UNIT_ISO."zcw"'] = ["iso unit", "hundred weight"];
constants.UNIT_ISO_ZGA = "zga";
displayLookup['UNIT_ISO."zga"'] = ["iso unit", "US gallon"];
constants.UNIT_ISO_ZHU = "zhu";
displayLookup['UNIT_ISO."zhu"'] = ["iso unit", "hundred"];
constants.UNIT_ISO_ZKT = "zkt";
displayLookup['UNIT_ISO."zkt"'] = ["iso unit", "kit"];
constants.UNIT_ISO_ZLT = "zlt";
displayLookup['UNIT_ISO."zlt"'] = ["iso unit", "lot"];
constants.UNIT_ISO_ZMT = "zmt";
displayLookup['UNIT_ISO."zmt"'] = ["iso unit", "meter"];
constants.UNIT_ISO_ZPA = "zpa";
displayLookup['UNIT_ISO."zpa"'] = ["iso unit", "pail"];
constants.UNIT_ISO_ZPD = "zpd";
displayLookup['UNIT_ISO."zpd"'] = ["iso unit", "pad"];
constants.UNIT_ISO_ZRE = "zre";
displayLookup['UNIT_ISO."zre"'] = ["iso unit", "reel"];
constants.UNIT_ISO_ZRL = "zrl";
displayLookup['UNIT_ISO."zrl"'] = ["iso unit", "roll"];
constants.UNIT_ISO_ZRM = "zrm";
displayLookup['UNIT_ISO."zrm"'] = ["iso unit", "ream"];
constants.UNIT_ISO_ZSH = "zsh";
displayLookup['UNIT_ISO."zsh"'] = ["iso unit", "sheet"];
constants.UNIT_ISO_ZSP = "zsp";
displayLookup['UNIT_ISO."zsp"'] = ["iso unit", "shipper/spool"];
constants.UNIT_ISO_ZST = "zst";
displayLookup['UNIT_ISO."zst"'] = ["iso unit", "set"];
constants.UNIT_ISO_ZTB = "ztb";
displayLookup['UNIT_ISO."ztb"'] = ["iso unit", "tube"];
constants.UNIT_ISO_ZTH = "zth";
displayLookup['UNIT_ISO."zth"'] = ["iso unit", "thousand"];
constants.UNIT_ISO_ZTL = "ztl";
displayLookup['UNIT_ISO."ztl"'] = ["iso unit", "truckload"];
constants.UNIT_ISO_ZTR = "ztr";
displayLookup['UNIT_ISO."ztr"'] = ["iso unit", "tray"];

constants.USER_PERMISSION_ACCESS_LEVEL = {
  DENIED: { color: null, label: [true], value: -1 },
  WALLET_POS: { color: null, label: ["user permission access level", "wallet pos"], value: 1 },
  WALLET_READ: { color: null, label: ["user permission access level", "wallet read"], value: 2 },
  WALLET_WRITE: { color: null, label: ["user permission access level", "wallet write"], value: 3 },
  WAREHOUSE_READ: { color: null, label: ["user permission access level", "warehouse read"], value: 101 },
  WAREHOUSE_OPERATOR: { color: null, label: ["user permission access level", "warehouse operator"], value: 102 },
  WAREHOUSE_WRITE: { color: null, label: ["user permission access level", "warehouse write"], value: 103 },
  TASK_READ: { color: null, label: ["user permission access level", "task read"], value: 201 },
  TASK_OPERATOR: { color: null, label: ["user permission access level", "task operator"], value: 202 },
  TASK_WRITE: { color: null, label: ["user permission access level", "task write"], value: 203 },
  ALLOWED: { color: null, label: [true], value: 10000 }
};
constants.USER_PERMISSION_ACCESS_LEVEL_DENIED = -1;
displayLookup['USER_PERMISSION_ACCESS_LEVEL.-1'] = ["user permission access level", "denied"];
constants.USER_PERMISSION_ACCESS_LEVEL_WALLET_POS = 1;
displayLookup['USER_PERMISSION_ACCESS_LEVEL.1'] = ["user permission access level", "wallet pos"];
constants.USER_PERMISSION_ACCESS_LEVEL_WALLET_READ = 2;
displayLookup['USER_PERMISSION_ACCESS_LEVEL.2'] = ["user permission access level", "wallet read"];
constants.USER_PERMISSION_ACCESS_LEVEL_WALLET_WRITE = 3;
displayLookup['USER_PERMISSION_ACCESS_LEVEL.3'] = ["user permission access level", "wallet write"];
constants.USER_PERMISSION_ACCESS_LEVEL_WAREHOUSE_READ = 101;
displayLookup['USER_PERMISSION_ACCESS_LEVEL.101'] = ["user permission access level", "warehouse read"];
constants.USER_PERMISSION_ACCESS_LEVEL_WAREHOUSE_OPERATOR = 102;
displayLookup['USER_PERMISSION_ACCESS_LEVEL.102'] = ["user permission access level", "warehouse operator"];
constants.USER_PERMISSION_ACCESS_LEVEL_WAREHOUSE_WRITE = 103;
displayLookup['USER_PERMISSION_ACCESS_LEVEL.103'] = ["user permission access level", "warehouse write"];
constants.USER_PERMISSION_ACCESS_LEVEL_TASK_READ = 201;
displayLookup['USER_PERMISSION_ACCESS_LEVEL.201'] = ["user permission access level", "task read"];
constants.USER_PERMISSION_ACCESS_LEVEL_TASK_OPERATOR = 202;
displayLookup['USER_PERMISSION_ACCESS_LEVEL.202'] = ["user permission access level", "task operator"];
constants.USER_PERMISSION_ACCESS_LEVEL_TASK_WRITE = 203;
displayLookup['USER_PERMISSION_ACCESS_LEVEL.203'] = ["user permission access level", "task write"];
constants.USER_PERMISSION_ACCESS_LEVEL_ALLOWED = 10000;
displayLookup['USER_PERMISSION_ACCESS_LEVEL.10000'] = ["user permission access level", "allowed"];

constants.USER_ROLE = {
  BASIC: { color: null, label: true, value: 1 },
  SYSTEM_MANAGER: { color: null, label: true, value: 2 },
  QUOTE_MANAGER: { color: null, label: true, value: 3 },
  PRICE_MANAGER: { color: null, label: true, value: 4 },
  SUPPLEMENT_MANAGER: { color: null, label: true, value: 5 },
  DOCUMENT_MANAGER: { color: null, label: true, value: 6 },
  MANUFACTURE_MANAGER: { color: null, label: true, value: 7 },
  REPORT_MANAGER: { color: null, label: true, value: 8 },
  PARTNER_MANAGER: { color: null, label: true, value: 9 },
  FINANCE_MANAGER: { color: null, label: true, value: 10 },
  POS_MANAGER: { color: null, label: true, value: 11 },
  WAREHOUSE_MANAGER: { color: null, label: true, value: 12 },
  ORDER_PACKAGER: { color: null, label: true, value: 13 },
  ORDER_MANAGER: { color: null, label: true, value: 14 },
  PRODUCT_MANAGER: { color: null, label: true, value: 15 },
  CUSTOMER_MANAGER: { color: null, label: true, value: 16 },
  CUSTOMER_INVOICE_MANAGER: { color: null, label: true, value: 17 },
  FINANCE_ADMINISTRATOR: { color: null, label: true, value: 18 },
  POS_OPERATOR: { color: null, label: true, value: 19 },
  WAREHOUSE_OPERATOR: { color: null, label: true, value: 20 },
  USER_MANAGER: { color: null, label: true, value: 21 },
  WAREHOUSE_ADMINISTRATOR: { color: null, label: true, value: 22 },
  MESSAGING_FUNCTIONS: { color: null, label: true, value: 23 },
  ORDER_BASICS: { color: null, label: true, value: 24 },
  FINANCE_BASE_FUNCTIONS: { color: null, label: true, value: 25 }
};
constants.USER_ROLE_BASIC = 1;
displayLookup['USER_ROLE.1'] = "basic";
constants.USER_ROLE_SYSTEM_MANAGER = 2;
displayLookup['USER_ROLE.2'] = "system manager";
constants.USER_ROLE_QUOTE_MANAGER = 3;
displayLookup['USER_ROLE.3'] = "quote manager";
constants.USER_ROLE_PRICE_MANAGER = 4;
displayLookup['USER_ROLE.4'] = "price manager";
constants.USER_ROLE_SUPPLEMENT_MANAGER = 5;
displayLookup['USER_ROLE.5'] = "supplement manager";
constants.USER_ROLE_DOCUMENT_MANAGER = 6;
displayLookup['USER_ROLE.6'] = "document manager";
constants.USER_ROLE_MANUFACTURE_MANAGER = 7;
displayLookup['USER_ROLE.7'] = "manufacture manager";
constants.USER_ROLE_REPORT_MANAGER = 8;
displayLookup['USER_ROLE.8'] = "report manager";
constants.USER_ROLE_PARTNER_MANAGER = 9;
displayLookup['USER_ROLE.9'] = "partner manager";
constants.USER_ROLE_FINANCE_MANAGER = 10;
displayLookup['USER_ROLE.10'] = "finance manager";
constants.USER_ROLE_POS_MANAGER = 11;
displayLookup['USER_ROLE.11'] = "pos manager";
constants.USER_ROLE_WAREHOUSE_MANAGER = 12;
displayLookup['USER_ROLE.12'] = "warehouse manager";
constants.USER_ROLE_ORDER_PACKAGER = 13;
displayLookup['USER_ROLE.13'] = "order packager";
constants.USER_ROLE_ORDER_MANAGER = 14;
displayLookup['USER_ROLE.14'] = "order manager";
constants.USER_ROLE_PRODUCT_MANAGER = 15;
displayLookup['USER_ROLE.15'] = "product manager";
constants.USER_ROLE_CUSTOMER_MANAGER = 16;
displayLookup['USER_ROLE.16'] = "customer manager";
constants.USER_ROLE_CUSTOMER_INVOICE_MANAGER = 17;
displayLookup['USER_ROLE.17'] = "customer invoice manager";
constants.USER_ROLE_FINANCE_ADMINISTRATOR = 18;
displayLookup['USER_ROLE.18'] = "finance administrator";
constants.USER_ROLE_POS_OPERATOR = 19;
displayLookup['USER_ROLE.19'] = "pos operator";
constants.USER_ROLE_WAREHOUSE_OPERATOR = 20;
displayLookup['USER_ROLE.20'] = "warehouse operator";
constants.USER_ROLE_USER_MANAGER = 21;
displayLookup['USER_ROLE.21'] = "user manager";
constants.USER_ROLE_WAREHOUSE_ADMINISTRATOR = 22;
displayLookup['USER_ROLE.22'] = "warehouse administrator";
constants.USER_ROLE_MESSAGING_FUNCTIONS = 23;
displayLookup['USER_ROLE.23'] = "messaging functions";
constants.USER_ROLE_ORDER_BASICS = 24;
displayLookup['USER_ROLE.24'] = "order basics";
constants.USER_ROLE_FINANCE_BASE_FUNCTIONS = 25;
displayLookup['USER_ROLE.25'] = "finance base functions";

constants.VERSION_UPGRADE_STATUS = {
  PENDING: { color: "#e5e5e5", label: [true], value: 1 },
  IN_PROGRESS: { color: "#ffb74d", label: [true], value: 50 },
  SUCCESS: { color: "#66bb6a", label: [true], value: 200 },
  FAILED: { color: "#e57373", label: [true], value: 500 }
};
constants.VERSION_UPGRADE_STATUS_PENDING = 1;
displayLookup['VERSION_UPGRADE_STATUS.1'] = ["version upgrade status", "pending"];
colorLookup['VERSION_UPGRADE_STATUS.1'] = "#e5e5e5";
colorNameLookup['VERSION_UPGRADE_STATUS.1'] = "GREY";
constants.VERSION_UPGRADE_STATUS_IN_PROGRESS = 50;
displayLookup['VERSION_UPGRADE_STATUS.50'] = ["version upgrade status", "in progress"];
colorLookup['VERSION_UPGRADE_STATUS.50'] = "#ffb74d";
colorNameLookup['VERSION_UPGRADE_STATUS.50'] = "YELLOW";
constants.VERSION_UPGRADE_STATUS_SUCCESS = 200;
displayLookup['VERSION_UPGRADE_STATUS.200'] = ["version upgrade status", "success"];
colorLookup['VERSION_UPGRADE_STATUS.200'] = "#66bb6a";
colorNameLookup['VERSION_UPGRADE_STATUS.200'] = "GREEN";
constants.VERSION_UPGRADE_STATUS_FAILED = 500;
displayLookup['VERSION_UPGRADE_STATUS.500'] = ["version upgrade status", "failed"];
colorLookup['VERSION_UPGRADE_STATUS.500'] = "#e57373";
colorNameLookup['VERSION_UPGRADE_STATUS.500'] = "RED";

constants.VIEW_CONFIG_DENSITY = {
  COMPACT: { color: null, label: true, value: 1 },
  STANDARD: { color: null, label: true, value: 2 },
  COMFORTABLE: { color: null, label: true, value: 3 }
};
constants.VIEW_CONFIG_DENSITY_COMPACT = 1;
displayLookup['VIEW_CONFIG_DENSITY.1'] = "compact";
constants.VIEW_CONFIG_DENSITY_STANDARD = 2;
displayLookup['VIEW_CONFIG_DENSITY.2'] = "standard";
constants.VIEW_CONFIG_DENSITY_COMFORTABLE = 3;
displayLookup['VIEW_CONFIG_DENSITY.3'] = "comfortable";

constants.VIEW_CONFIG_EXPORT_EVENT_STATUS = {
  SUCCESS: { color: "#66bb6a", label: [true], value: 202 },
  ALREADY_RUNNING: { color: "#f57c00", label: [true], value: 200 },
  ACCESS_DENIED: { color: "#e57373", label: [true], value: 403 },
  TOO_MANY_REQUESTS: { color: "#e57373", label: [true], value: 429 },
  ERROR: { color: "#e57373", label: [true], value: 500 }
};
constants.VIEW_CONFIG_EXPORT_EVENT_STATUS_SUCCESS = 202;
displayLookup['VIEW_CONFIG_EXPORT_EVENT_STATUS.202'] = ["view config export event status", "success"];
colorLookup['VIEW_CONFIG_EXPORT_EVENT_STATUS.202'] = "#66bb6a";
colorNameLookup['VIEW_CONFIG_EXPORT_EVENT_STATUS.202'] = "GREEN";
constants.VIEW_CONFIG_EXPORT_EVENT_STATUS_ALREADY_RUNNING = 200;
displayLookup['VIEW_CONFIG_EXPORT_EVENT_STATUS.200'] = ["view config export event status", "already running"];
colorLookup['VIEW_CONFIG_EXPORT_EVENT_STATUS.200'] = "#f57c00";
colorNameLookup['VIEW_CONFIG_EXPORT_EVENT_STATUS.200'] = "ORANGE";
constants.VIEW_CONFIG_EXPORT_EVENT_STATUS_ACCESS_DENIED = 403;
displayLookup['VIEW_CONFIG_EXPORT_EVENT_STATUS.403'] = ["view config export event status", "access denied"];
colorLookup['VIEW_CONFIG_EXPORT_EVENT_STATUS.403'] = "#e57373";
colorNameLookup['VIEW_CONFIG_EXPORT_EVENT_STATUS.403'] = "RED";
constants.VIEW_CONFIG_EXPORT_EVENT_STATUS_TOO_MANY_REQUESTS = 429;
displayLookup['VIEW_CONFIG_EXPORT_EVENT_STATUS.429'] = ["view config export event status", "too many requests"];
colorLookup['VIEW_CONFIG_EXPORT_EVENT_STATUS.429'] = "#e57373";
colorNameLookup['VIEW_CONFIG_EXPORT_EVENT_STATUS.429'] = "RED";
constants.VIEW_CONFIG_EXPORT_EVENT_STATUS_ERROR = 500;
displayLookup['VIEW_CONFIG_EXPORT_EVENT_STATUS.500'] = ["view config export event status", "error"];
colorLookup['VIEW_CONFIG_EXPORT_EVENT_STATUS.500'] = "#e57373";
colorNameLookup['VIEW_CONFIG_EXPORT_EVENT_STATUS.500'] = "RED";

constants.VIEW_CONFIG_EXPORT_EVENT_TYPE = {
  HEAD_REQUEST: { color: "#106d3b", label: [true], value: 1 },
  DATA_REQUEST: { color: "#66bb6a", label: [true], value: 2 },
  REFRESH_REQUEST: { color: "#64b5f6", label: [true], value: 3 },
  REFRESH_FINISHED: { color: "#162256", label: [true], value: 4 }
};
constants.VIEW_CONFIG_EXPORT_EVENT_TYPE_HEAD_REQUEST = 1;
displayLookup['VIEW_CONFIG_EXPORT_EVENT_TYPE.1'] = ["view config export event type", "head request"];
colorLookup['VIEW_CONFIG_EXPORT_EVENT_TYPE.1'] = "#106d3b";
colorNameLookup['VIEW_CONFIG_EXPORT_EVENT_TYPE.1'] = "DARK_GREEN";
constants.VIEW_CONFIG_EXPORT_EVENT_TYPE_DATA_REQUEST = 2;
displayLookup['VIEW_CONFIG_EXPORT_EVENT_TYPE.2'] = ["view config export event type", "data request"];
colorLookup['VIEW_CONFIG_EXPORT_EVENT_TYPE.2'] = "#66bb6a";
colorNameLookup['VIEW_CONFIG_EXPORT_EVENT_TYPE.2'] = "GREEN";
constants.VIEW_CONFIG_EXPORT_EVENT_TYPE_REFRESH_REQUEST = 3;
displayLookup['VIEW_CONFIG_EXPORT_EVENT_TYPE.3'] = ["view config export event type", "refresh request"];
colorLookup['VIEW_CONFIG_EXPORT_EVENT_TYPE.3'] = "#64b5f6";
colorNameLookup['VIEW_CONFIG_EXPORT_EVENT_TYPE.3'] = "BLUE";
constants.VIEW_CONFIG_EXPORT_EVENT_TYPE_REFRESH_FINISHED = 4;
displayLookup['VIEW_CONFIG_EXPORT_EVENT_TYPE.4'] = ["view config export event type", "refresh finished"];
colorLookup['VIEW_CONFIG_EXPORT_EVENT_TYPE.4'] = "#162256";
colorNameLookup['VIEW_CONFIG_EXPORT_EVENT_TYPE.4'] = "DARK_BLUE";

constants.VIEW_CONFIG_EXPORT_SHARE_LEVEL = {
  READ_ONLY: { color: null, label: [true], value: 1 },
  CAN_REFRESH: { color: null, label: [true], value: 2 }
};
constants.VIEW_CONFIG_EXPORT_SHARE_LEVEL_READ_ONLY = 1;
displayLookup['VIEW_CONFIG_EXPORT_SHARE_LEVEL.1'] = ["view config export share level", "read only"];
constants.VIEW_CONFIG_EXPORT_SHARE_LEVEL_CAN_REFRESH = 2;
displayLookup['VIEW_CONFIG_EXPORT_SHARE_LEVEL.2'] = ["view config export share level", "can refresh"];

constants.VIEW_CONFIG_EXPORT_STATUS = {
  OK: { color: "#66bb6a", label: [true], value: 1 },
  WARNING: { color: "#f57c00", label: [true], value: 2 },
  ERROR: { color: "#e57373", label: [true], value: 3 }
};
constants.VIEW_CONFIG_EXPORT_STATUS_OK = 1;
displayLookup['VIEW_CONFIG_EXPORT_STATUS.1'] = ["view config export status", "ok"];
colorLookup['VIEW_CONFIG_EXPORT_STATUS.1'] = "#66bb6a";
colorNameLookup['VIEW_CONFIG_EXPORT_STATUS.1'] = "GREEN";
constants.VIEW_CONFIG_EXPORT_STATUS_WARNING = 2;
displayLookup['VIEW_CONFIG_EXPORT_STATUS.2'] = ["view config export status", "warning"];
colorLookup['VIEW_CONFIG_EXPORT_STATUS.2'] = "#f57c00";
colorNameLookup['VIEW_CONFIG_EXPORT_STATUS.2'] = "ORANGE";
constants.VIEW_CONFIG_EXPORT_STATUS_ERROR = 3;
displayLookup['VIEW_CONFIG_EXPORT_STATUS.3'] = ["view config export status", "error"];
colorLookup['VIEW_CONFIG_EXPORT_STATUS.3'] = "#e57373";
colorNameLookup['VIEW_CONFIG_EXPORT_STATUS.3'] = "RED";

constants.VIEW_CONFIG_FILTER_BASED_KANBAN_COLUMNS = {
  SINGLE_COLUMN_MULTIPLE_GROUPS: { color: null, label: true, value: 1 },
  MULTIPLE_COLUMNS_SINGLE_GROUP: { color: null, label: true, value: 2 }
};
constants.VIEW_CONFIG_FILTER_BASED_KANBAN_COLUMNS_SINGLE_COLUMN_MULTIPLE_GROUPS = 1;
displayLookup['VIEW_CONFIG_FILTER_BASED_KANBAN_COLUMNS.1'] = "single column multiple groups";
constants.VIEW_CONFIG_FILTER_BASED_KANBAN_COLUMNS_MULTIPLE_COLUMNS_SINGLE_GROUP = 2;
displayLookup['VIEW_CONFIG_FILTER_BASED_KANBAN_COLUMNS.2'] = "multiple columns single group";

constants.VIEW_CONFIG_KANBAN_COLUMN_ACTION_SEPARATOR = {
  ARROW: { color: null, label: true, value: 1 },
  PIPE: { color: null, label: true, value: 2 },
  NONE: { color: null, label: true, value: 3 }
};
constants.VIEW_CONFIG_KANBAN_COLUMN_ACTION_SEPARATOR_ARROW = 1;
displayLookup['VIEW_CONFIG_KANBAN_COLUMN_ACTION_SEPARATOR.1'] = "arrow";
constants.VIEW_CONFIG_KANBAN_COLUMN_ACTION_SEPARATOR_PIPE = 2;
displayLookup['VIEW_CONFIG_KANBAN_COLUMN_ACTION_SEPARATOR.2'] = "pipe";
constants.VIEW_CONFIG_KANBAN_COLUMN_ACTION_SEPARATOR_NONE = 3;
displayLookup['VIEW_CONFIG_KANBAN_COLUMN_ACTION_SEPARATOR.3'] = "none";

constants.VIEW_CONFIG_SHARE_LEVEL = {
  RESTRICTED: { color: null, label: true, value: 1 },
  VIEWER: { color: null, label: true, value: 2 },
  EDITOR: { color: null, label: true, value: 3 },
  OWNER: { color: null, label: true, value: 4 }
};
constants.VIEW_CONFIG_SHARE_LEVEL_RESTRICTED = 1;
displayLookup['VIEW_CONFIG_SHARE_LEVEL.1'] = "restricted";
constants.VIEW_CONFIG_SHARE_LEVEL_VIEWER = 2;
displayLookup['VIEW_CONFIG_SHARE_LEVEL.2'] = "viewer";
constants.VIEW_CONFIG_SHARE_LEVEL_EDITOR = 3;
displayLookup['VIEW_CONFIG_SHARE_LEVEL.3'] = "editor";
constants.VIEW_CONFIG_SHARE_LEVEL_OWNER = 4;
displayLookup['VIEW_CONFIG_SHARE_LEVEL.4'] = "owner";

constants.VIEW_CONFIG_TABLE_BORDERS = {
  ROWS: { color: null, label: true, value: "rows" },
  ROWS_AND_COLUMNS: { color: null, label: true, value: "all" }
};
constants.VIEW_CONFIG_TABLE_BORDERS_ROWS = "rows";
displayLookup['VIEW_CONFIG_TABLE_BORDERS."rows"'] = "rows";
constants.VIEW_CONFIG_TABLE_BORDERS_ROWS_AND_COLUMNS = "all";
displayLookup['VIEW_CONFIG_TABLE_BORDERS."all"'] = "rows and columns";

constants.VIEW_CONFIG_TABLE_COLUMN_ALIGN = {
  LEFT: { color: null, label: true, value: "left" },
  CENTER: { color: null, label: true, value: "center" },
  RIGHT: { color: null, label: true, value: "right" }
};
constants.VIEW_CONFIG_TABLE_COLUMN_ALIGN_LEFT = "left";
displayLookup['VIEW_CONFIG_TABLE_COLUMN_ALIGN."left"'] = "left";
constants.VIEW_CONFIG_TABLE_COLUMN_ALIGN_CENTER = "center";
displayLookup['VIEW_CONFIG_TABLE_COLUMN_ALIGN."center"'] = "center";
constants.VIEW_CONFIG_TABLE_COLUMN_ALIGN_RIGHT = "right";
displayLookup['VIEW_CONFIG_TABLE_COLUMN_ALIGN."right"'] = "right";

constants.VIEW_CONFIG_TABLE_COLUMN_PIN = {
  LEFT: { color: null, label: true, value: 1 },
  RIGHT: { color: null, label: true, value: 2 }
};
constants.VIEW_CONFIG_TABLE_COLUMN_PIN_LEFT = 1;
displayLookup['VIEW_CONFIG_TABLE_COLUMN_PIN.1'] = "left";
constants.VIEW_CONFIG_TABLE_COLUMN_PIN_RIGHT = 2;
displayLookup['VIEW_CONFIG_TABLE_COLUMN_PIN.2'] = "right";

constants.VIEW_CONFIG_VIEW_MODE = {
  LIST: { color: null, label: [true], value: 1 },
  KANBAN: { color: null, label: [true], value: 2 }
};
constants.VIEW_CONFIG_VIEW_MODE_LIST = 1;
displayLookup['VIEW_CONFIG_VIEW_MODE.1'] = ["view config view mode", "list"];
constants.VIEW_CONFIG_VIEW_MODE_KANBAN = 2;
displayLookup['VIEW_CONFIG_VIEW_MODE.2'] = ["view config view mode", "kanban"];

constants.WALLET_TRANSACTION_TYPE = {
  WALLET_INCOMING: { color: null, label: "Incoming wallet transaction", value: 1 },
  WALLET_OUTGOING: { color: null, label: "Outgoing wallet transaction", value: 2 },
  REVENUE: { color: null, label: true, value: 3 },
  EXPENSE: { color: null, label: true, value: 4 },
  WALLET_OPENING_BALANCE: { color: null, label: true, value: 5 }
};
constants.WALLET_TRANSACTION_TYPE_WALLET_INCOMING = 1;
displayLookup['WALLET_TRANSACTION_TYPE.1'] = "Incoming wallet transaction";
constants.WALLET_TRANSACTION_TYPE_WALLET_OUTGOING = 2;
displayLookup['WALLET_TRANSACTION_TYPE.2'] = "Outgoing wallet transaction";
constants.WALLET_TRANSACTION_TYPE_REVENUE = 3;
displayLookup['WALLET_TRANSACTION_TYPE.3'] = "revenue";
constants.WALLET_TRANSACTION_TYPE_EXPENSE = 4;
displayLookup['WALLET_TRANSACTION_TYPE.4'] = "expense";
constants.WALLET_TRANSACTION_TYPE_WALLET_OPENING_BALANCE = 5;
displayLookup['WALLET_TRANSACTION_TYPE.5'] = "wallet opening balance";

constants.WALLET_TYPE = {
  CASH_REGISTER: { color: "#64b5f6", label: ["wallet type", "cash register"], value: 1 },
  CASH: { color: "#66bb6a", label: ["wallet type", "cash"], value: 2 },
  BANK_ACCOUNT: { color: "#ffb74d", label: ["wallet type", "bank account"], value: 3 },
  REMOTE_ACCOUNT: { color: "#e57373", label: ["wallet type", "remote account"], value: 4 }
};
constants.WALLET_TYPE_CASH_REGISTER = 1;
displayLookup['WALLET_TYPE.1'] = ["wallet type", "cash register"];
colorLookup['WALLET_TYPE.1'] = "#64b5f6";
colorNameLookup['WALLET_TYPE.1'] = "BLUE";
constants.WALLET_TYPE_CASH = 2;
displayLookup['WALLET_TYPE.2'] = ["wallet type", "cash"];
colorLookup['WALLET_TYPE.2'] = "#66bb6a";
colorNameLookup['WALLET_TYPE.2'] = "GREEN";
constants.WALLET_TYPE_BANK_ACCOUNT = 3;
displayLookup['WALLET_TYPE.3'] = ["wallet type", "bank account"];
colorLookup['WALLET_TYPE.3'] = "#ffb74d";
colorNameLookup['WALLET_TYPE.3'] = "YELLOW";
constants.WALLET_TYPE_REMOTE_ACCOUNT = 4;
displayLookup['WALLET_TYPE.4'] = ["wallet type", "remote account"];
colorLookup['WALLET_TYPE.4'] = "#e57373";
colorNameLookup['WALLET_TYPE.4'] = "RED";

constants.WAREHOUSE_ACTIVE_LOCATION_PRIORITY_SCOPE = {
  OPERATION: { color: null, label: "warehouse operation", value: 1 },
  PICKING: { color: null, label: "warehouse picking", value: 2 },
  BOTH: { color: null, label: "warehouse operation and picking", value: 3 }
};
constants.WAREHOUSE_ACTIVE_LOCATION_PRIORITY_SCOPE_OPERATION = 1;
displayLookup['WAREHOUSE_ACTIVE_LOCATION_PRIORITY_SCOPE.1'] = "warehouse operation";
constants.WAREHOUSE_ACTIVE_LOCATION_PRIORITY_SCOPE_PICKING = 2;
displayLookup['WAREHOUSE_ACTIVE_LOCATION_PRIORITY_SCOPE.2'] = "warehouse picking";
constants.WAREHOUSE_ACTIVE_LOCATION_PRIORITY_SCOPE_BOTH = 3;
displayLookup['WAREHOUSE_ACTIVE_LOCATION_PRIORITY_SCOPE.3'] = "warehouse operation and picking";

constants.WAREHOUSE_CART_ORDER_DETACH_STATUS = {
  CHECKED: { color: null, label: true, value: 1 },
  LABEL_PRINTED: { color: null, label: true, value: 2 },
  COMPLETED: { color: null, label: true, value: 3 }
};
constants.WAREHOUSE_CART_ORDER_DETACH_STATUS_CHECKED = 1;
displayLookup['WAREHOUSE_CART_ORDER_DETACH_STATUS.1'] = "checked";
constants.WAREHOUSE_CART_ORDER_DETACH_STATUS_LABEL_PRINTED = 2;
displayLookup['WAREHOUSE_CART_ORDER_DETACH_STATUS.2'] = "label printed";
constants.WAREHOUSE_CART_ORDER_DETACH_STATUS_COMPLETED = 3;
displayLookup['WAREHOUSE_CART_ORDER_DETACH_STATUS.3'] = "completed";

constants.WAREHOUSE_ENFORCE_ORDER_CHECK = {
  INHERIT_ORG_CONFIG: { color: null, label: "Inherit from organization config", value: 1 },
  ENABLED: { color: null, label: true, value: 2 },
  DISABLED: { color: null, label: true, value: 3 }
};
constants.WAREHOUSE_ENFORCE_ORDER_CHECK_INHERIT_ORG_CONFIG = 1;
displayLookup['WAREHOUSE_ENFORCE_ORDER_CHECK.1'] = "Inherit from organization config";
constants.WAREHOUSE_ENFORCE_ORDER_CHECK_ENABLED = 2;
displayLookup['WAREHOUSE_ENFORCE_ORDER_CHECK.2'] = "enabled";
constants.WAREHOUSE_ENFORCE_ORDER_CHECK_DISABLED = 3;
displayLookup['WAREHOUSE_ENFORCE_ORDER_CHECK.3'] = "disabled";

constants.WAREHOUSE_OPERATION_CART_LOCATION_ASSIGN = {
  DISABLED: { color: null, label: true, value: 1 },
  POPUP: { color: null, label: true, value: 2 },
  AUTOMATIC: { color: null, label: true, value: 3 }
};
constants.WAREHOUSE_OPERATION_CART_LOCATION_ASSIGN_DISABLED = 1;
displayLookup['WAREHOUSE_OPERATION_CART_LOCATION_ASSIGN.1'] = "disabled";
constants.WAREHOUSE_OPERATION_CART_LOCATION_ASSIGN_POPUP = 2;
displayLookup['WAREHOUSE_OPERATION_CART_LOCATION_ASSIGN.2'] = "popup";
constants.WAREHOUSE_OPERATION_CART_LOCATION_ASSIGN_AUTOMATIC = 3;
displayLookup['WAREHOUSE_OPERATION_CART_LOCATION_ASSIGN.3'] = "automatic";

constants.WAREHOUSE_OPERATION_CSV_UNIT_COST_MODE = {
  NET_UNIT: { color: null, label: true, value: 1 },
  NET_TOTAL: { color: null, label: true, value: 2 }
};
constants.WAREHOUSE_OPERATION_CSV_UNIT_COST_MODE_NET_UNIT = 1;
displayLookup['WAREHOUSE_OPERATION_CSV_UNIT_COST_MODE.1'] = "net unit";
constants.WAREHOUSE_OPERATION_CSV_UNIT_COST_MODE_NET_TOTAL = 2;
displayLookup['WAREHOUSE_OPERATION_CSV_UNIT_COST_MODE.2'] = "net total";

constants.WAREHOUSE_OPERATION_DIRECTION = {
  INBOUND: { color: "#66bb6a", label: true, value: 1 },
  OUTBOUND: { color: "#64b5f6", label: true, value: -1 }
};
constants.WAREHOUSE_OPERATION_DIRECTION_INBOUND = 1;
displayLookup['WAREHOUSE_OPERATION_DIRECTION.1'] = "inbound";
colorLookup['WAREHOUSE_OPERATION_DIRECTION.1'] = "#66bb6a";
colorNameLookup['WAREHOUSE_OPERATION_DIRECTION.1'] = "GREEN";
constants.WAREHOUSE_OPERATION_DIRECTION_OUTBOUND = -1;
displayLookup['WAREHOUSE_OPERATION_DIRECTION.-1'] = "outbound";
colorLookup['WAREHOUSE_OPERATION_DIRECTION.-1'] = "#64b5f6";
colorNameLookup['WAREHOUSE_OPERATION_DIRECTION.-1'] = "BLUE";

constants.WAREHOUSE_OPERATION_EVENT_TYPE = {
  DEVELOPER_ACTION: { color: null, label: true, value: -1 },
  CREATED: { color: null, label: true, value: 1 },
  EDITED: { color: null, label: true, value: 2 },
  COMPLETED: { color: null, label: true, value: 3 },
  TAG_CREATED: { color: null, label: true, value: 4 },
  TAG_DELETED: { color: null, label: true, value: 5 },
  STOCK_TRANSFER_CREATED: { color: null, label: true, value: 6 }
};
constants.WAREHOUSE_OPERATION_EVENT_TYPE_DEVELOPER_ACTION = -1;
displayLookup['WAREHOUSE_OPERATION_EVENT_TYPE.-1'] = "developer action";
constants.WAREHOUSE_OPERATION_EVENT_TYPE_CREATED = 1;
displayLookup['WAREHOUSE_OPERATION_EVENT_TYPE.1'] = "created";
constants.WAREHOUSE_OPERATION_EVENT_TYPE_EDITED = 2;
displayLookup['WAREHOUSE_OPERATION_EVENT_TYPE.2'] = "edited";
constants.WAREHOUSE_OPERATION_EVENT_TYPE_COMPLETED = 3;
displayLookup['WAREHOUSE_OPERATION_EVENT_TYPE.3'] = "completed";
constants.WAREHOUSE_OPERATION_EVENT_TYPE_TAG_CREATED = 4;
displayLookup['WAREHOUSE_OPERATION_EVENT_TYPE.4'] = "tag created";
constants.WAREHOUSE_OPERATION_EVENT_TYPE_TAG_DELETED = 5;
displayLookup['WAREHOUSE_OPERATION_EVENT_TYPE.5'] = "tag deleted";
constants.WAREHOUSE_OPERATION_EVENT_TYPE_STOCK_TRANSFER_CREATED = 6;
displayLookup['WAREHOUSE_OPERATION_EVENT_TYPE.6'] = "stock transfer created";

constants.WAREHOUSE_OPERATION_EXECUTION_MODE = {
  SIMPLE: { color: null, label: true, value: 1 },
  MASS: { color: null, label: true, value: 2 }
};
constants.WAREHOUSE_OPERATION_EXECUTION_MODE_SIMPLE = 1;
displayLookup['WAREHOUSE_OPERATION_EXECUTION_MODE.1'] = "simple";
constants.WAREHOUSE_OPERATION_EXECUTION_MODE_MASS = 2;
displayLookup['WAREHOUSE_OPERATION_EXECUTION_MODE.2'] = "mass";

constants.WAREHOUSE_OPERATION_ITEM_STATUS = {
  WAITING: { color: "#e5e5e5", label: true, value: 1 },
  IN_PROGRESS: { color: "#64b5f6", label: true, value: 50 },
  PARTIALLY_DONE: { color: "#ffb74d", label: true, value: 75 },
  DONE: { color: "#66bb6a", label: true, value: 100 },
  CANCELLED: { color: "#e57373", label: true, value: 200 }
};
constants.WAREHOUSE_OPERATION_ITEM_STATUS_WAITING = 1;
displayLookup['WAREHOUSE_OPERATION_ITEM_STATUS.1'] = "waiting";
colorLookup['WAREHOUSE_OPERATION_ITEM_STATUS.1'] = "#e5e5e5";
colorNameLookup['WAREHOUSE_OPERATION_ITEM_STATUS.1'] = "GREY";
constants.WAREHOUSE_OPERATION_ITEM_STATUS_IN_PROGRESS = 50;
displayLookup['WAREHOUSE_OPERATION_ITEM_STATUS.50'] = "in progress";
colorLookup['WAREHOUSE_OPERATION_ITEM_STATUS.50'] = "#64b5f6";
colorNameLookup['WAREHOUSE_OPERATION_ITEM_STATUS.50'] = "BLUE";
constants.WAREHOUSE_OPERATION_ITEM_STATUS_PARTIALLY_DONE = 75;
displayLookup['WAREHOUSE_OPERATION_ITEM_STATUS.75'] = "partially done";
colorLookup['WAREHOUSE_OPERATION_ITEM_STATUS.75'] = "#ffb74d";
colorNameLookup['WAREHOUSE_OPERATION_ITEM_STATUS.75'] = "YELLOW";
constants.WAREHOUSE_OPERATION_ITEM_STATUS_DONE = 100;
displayLookup['WAREHOUSE_OPERATION_ITEM_STATUS.100'] = "done";
colorLookup['WAREHOUSE_OPERATION_ITEM_STATUS.100'] = "#66bb6a";
colorNameLookup['WAREHOUSE_OPERATION_ITEM_STATUS.100'] = "GREEN";
constants.WAREHOUSE_OPERATION_ITEM_STATUS_CANCELLED = 200;
displayLookup['WAREHOUSE_OPERATION_ITEM_STATUS.200'] = "cancelled";
colorLookup['WAREHOUSE_OPERATION_ITEM_STATUS.200'] = "#e57373";
colorNameLookup['WAREHOUSE_OPERATION_ITEM_STATUS.200'] = "RED";

constants.WAREHOUSE_OPERATION_REASON_FILTER = {
  INVENTORY_COUNT: { color: null, label: "inventory count", value: -1 },
  STOCK_TRANSFER: { color: null, label: "stock transfer", value: -2 },
  DYNAMIC_STOCK_TRANSFER: { color: null, label: "dynamic stock transfer", value: -3 },
  ORDER: { color: null, label: true, value: -4 },
  PURCHASE_ORDER: { color: null, label: "purchase order", value: -5 },
  OPERATION_CORRECTION: { color: null, label: "correction operation", value: -6 },
  OPERATION_CANCELLATION: { color: null, label: "cancellation", value: -7 },
  SHIPMENT: { color: null, label: "shipment", value: -8 },
  STATISTICAL_ORDER: { color: null, label: "statistical order", value: -9 },
  STATISTICAL_ORDER_CORRECTION: { color: null, label: "statistical order correction", value: -10 }
};
constants.WAREHOUSE_OPERATION_REASON_FILTER_INVENTORY_COUNT = -1;
displayLookup['WAREHOUSE_OPERATION_REASON_FILTER.-1'] = "inventory count";
constants.WAREHOUSE_OPERATION_REASON_FILTER_STOCK_TRANSFER = -2;
displayLookup['WAREHOUSE_OPERATION_REASON_FILTER.-2'] = "stock transfer";
constants.WAREHOUSE_OPERATION_REASON_FILTER_DYNAMIC_STOCK_TRANSFER = -3;
displayLookup['WAREHOUSE_OPERATION_REASON_FILTER.-3'] = "dynamic stock transfer";
constants.WAREHOUSE_OPERATION_REASON_FILTER_ORDER = -4;
displayLookup['WAREHOUSE_OPERATION_REASON_FILTER.-4'] = "order";
constants.WAREHOUSE_OPERATION_REASON_FILTER_PURCHASE_ORDER = -5;
displayLookup['WAREHOUSE_OPERATION_REASON_FILTER.-5'] = "purchase order";
constants.WAREHOUSE_OPERATION_REASON_FILTER_OPERATION_CORRECTION = -6;
displayLookup['WAREHOUSE_OPERATION_REASON_FILTER.-6'] = "correction operation";
constants.WAREHOUSE_OPERATION_REASON_FILTER_OPERATION_CANCELLATION = -7;
displayLookup['WAREHOUSE_OPERATION_REASON_FILTER.-7'] = "cancellation";
constants.WAREHOUSE_OPERATION_REASON_FILTER_SHIPMENT = -8;
displayLookup['WAREHOUSE_OPERATION_REASON_FILTER.-8'] = "shipment";
constants.WAREHOUSE_OPERATION_REASON_FILTER_STATISTICAL_ORDER = -9;
displayLookup['WAREHOUSE_OPERATION_REASON_FILTER.-9'] = "statistical order";
constants.WAREHOUSE_OPERATION_REASON_FILTER_STATISTICAL_ORDER_CORRECTION = -10;
displayLookup['WAREHOUSE_OPERATION_REASON_FILTER.-10'] = "statistical order correction";

constants.WAREHOUSE_OPERATION_REDUCE_MODE = {
  TO_COMPLETE: { color: null, label: true, value: 1 },
  REMOVE_NOT_AVAILABLE: { color: null, label: true, value: 2 }
};
constants.WAREHOUSE_OPERATION_REDUCE_MODE_TO_COMPLETE = 1;
displayLookup['WAREHOUSE_OPERATION_REDUCE_MODE.1'] = "to complete";
constants.WAREHOUSE_OPERATION_REDUCE_MODE_REMOVE_NOT_AVAILABLE = 2;
displayLookup['WAREHOUSE_OPERATION_REDUCE_MODE.2'] = "remove not available";

constants.WAREHOUSE_OPERATION_STATUS = {
  WAITING: { color: "#e5e5e5", label: true, value: 1 },
  IN_PROGRESS: { color: "#64b5f6", label: true, value: 50 },
  PARTIALLY_DONE: { color: "#ffb74d", label: true, value: 75 },
  DONE: { color: "#66bb6a", label: true, value: 100 },
  CANCELLED: { color: "#e57373", label: true, value: 200 }
};
constants.WAREHOUSE_OPERATION_STATUS_WAITING = 1;
displayLookup['WAREHOUSE_OPERATION_STATUS.1'] = "waiting";
colorLookup['WAREHOUSE_OPERATION_STATUS.1'] = "#e5e5e5";
colorNameLookup['WAREHOUSE_OPERATION_STATUS.1'] = "GREY";
constants.WAREHOUSE_OPERATION_STATUS_IN_PROGRESS = 50;
displayLookup['WAREHOUSE_OPERATION_STATUS.50'] = "in progress";
colorLookup['WAREHOUSE_OPERATION_STATUS.50'] = "#64b5f6";
colorNameLookup['WAREHOUSE_OPERATION_STATUS.50'] = "BLUE";
constants.WAREHOUSE_OPERATION_STATUS_PARTIALLY_DONE = 75;
displayLookup['WAREHOUSE_OPERATION_STATUS.75'] = "partially done";
colorLookup['WAREHOUSE_OPERATION_STATUS.75'] = "#ffb74d";
colorNameLookup['WAREHOUSE_OPERATION_STATUS.75'] = "YELLOW";
constants.WAREHOUSE_OPERATION_STATUS_DONE = 100;
displayLookup['WAREHOUSE_OPERATION_STATUS.100'] = "done";
colorLookup['WAREHOUSE_OPERATION_STATUS.100'] = "#66bb6a";
colorNameLookup['WAREHOUSE_OPERATION_STATUS.100'] = "GREEN";
constants.WAREHOUSE_OPERATION_STATUS_CANCELLED = 200;
displayLookup['WAREHOUSE_OPERATION_STATUS.200'] = "cancelled";
colorLookup['WAREHOUSE_OPERATION_STATUS.200'] = "#e57373";
colorNameLookup['WAREHOUSE_OPERATION_STATUS.200'] = "RED";

constants.WAREHOUSE_ORDER_NOTE_DISPLAY_ELEMENT = {
  CUSTOMER_NOTE: { color: null, label: true, value: 1 },
  NOTE: { color: null, label: true, value: 2 }
};
constants.WAREHOUSE_ORDER_NOTE_DISPLAY_ELEMENT_CUSTOMER_NOTE = 1;
displayLookup['WAREHOUSE_ORDER_NOTE_DISPLAY_ELEMENT.1'] = "customer note";
constants.WAREHOUSE_ORDER_NOTE_DISPLAY_ELEMENT_NOTE = 2;
displayLookup['WAREHOUSE_ORDER_NOTE_DISPLAY_ELEMENT.2'] = "note";

constants.WAREHOUSE_ORDER_RESERVATION_BASE = {
  CREATED_TIMESTAMP: { color: null, label: true, value: 1 },
  CUSTOMER_REQUESTED_DELIVERY_DATE: { color: null, label: true, value: 2 }
};
constants.WAREHOUSE_ORDER_RESERVATION_BASE_CREATED_TIMESTAMP = 1;
displayLookup['WAREHOUSE_ORDER_RESERVATION_BASE.1'] = "created timestamp";
constants.WAREHOUSE_ORDER_RESERVATION_BASE_CUSTOMER_REQUESTED_DELIVERY_DATE = 2;
displayLookup['WAREHOUSE_ORDER_RESERVATION_BASE.2'] = "customer requested delivery date";

constants.WAREHOUSE_ORDER_RESERVATION_METHOD = {
  FREE: { color: null, label: true, value: 1 },
  FIFO: { color: null, label: true, value: 2 }
};
constants.WAREHOUSE_ORDER_RESERVATION_METHOD_FREE = 1;
displayLookup['WAREHOUSE_ORDER_RESERVATION_METHOD.1'] = "free";
constants.WAREHOUSE_ORDER_RESERVATION_METHOD_FIFO = 2;
displayLookup['WAREHOUSE_ORDER_RESERVATION_METHOD.2'] = "fifo";

constants.WAREHOUSE_ORDER_RESERVATION_SUPPLIER_LEAD_TIME_METHOD = {
  BEST_CASE: { color: null, label: true, value: 1 },
  WORST_CASE: { color: null, label: true, value: 2 },
  DEFAULT_SUPPLIER: { color: null, label: true, value: 3 }
};
constants.WAREHOUSE_ORDER_RESERVATION_SUPPLIER_LEAD_TIME_METHOD_BEST_CASE = 1;
displayLookup['WAREHOUSE_ORDER_RESERVATION_SUPPLIER_LEAD_TIME_METHOD.1'] = "best case";
constants.WAREHOUSE_ORDER_RESERVATION_SUPPLIER_LEAD_TIME_METHOD_WORST_CASE = 2;
displayLookup['WAREHOUSE_ORDER_RESERVATION_SUPPLIER_LEAD_TIME_METHOD.2'] = "worst case";
constants.WAREHOUSE_ORDER_RESERVATION_SUPPLIER_LEAD_TIME_METHOD_DEFAULT_SUPPLIER = 3;
displayLookup['WAREHOUSE_ORDER_RESERVATION_SUPPLIER_LEAD_TIME_METHOD.3'] = "default supplier";

constants.WAREHOUSE_PICKING_EXECUTION_MODE = {
  NORMAL: { color: null, label: true, value: 1 },
  PRODUCT_DRIVEN: { color: null, label: true, value: 2 }
};
constants.WAREHOUSE_PICKING_EXECUTION_MODE_NORMAL = 1;
displayLookup['WAREHOUSE_PICKING_EXECUTION_MODE.1'] = "normal";
constants.WAREHOUSE_PICKING_EXECUTION_MODE_PRODUCT_DRIVEN = 2;
displayLookup['WAREHOUSE_PICKING_EXECUTION_MODE.2'] = "product driven";

constants.WAREHOUSE_PICKING_PRODUCT_NUMBER_DISPLAY_ELEMENT = {
  MANUFACTURE_DATE: { color: null, label: true, value: 1 },
  EXPIRATION_DATE: { color: null, label: true, value: 2 }
};
constants.WAREHOUSE_PICKING_PRODUCT_NUMBER_DISPLAY_ELEMENT_MANUFACTURE_DATE = 1;
displayLookup['WAREHOUSE_PICKING_PRODUCT_NUMBER_DISPLAY_ELEMENT.1'] = "manufacture date";
constants.WAREHOUSE_PICKING_PRODUCT_NUMBER_DISPLAY_ELEMENT_EXPIRATION_DATE = 2;
displayLookup['WAREHOUSE_PICKING_PRODUCT_NUMBER_DISPLAY_ELEMENT.2'] = "expiration date";

constants.WAREHOUSE_PICKING_PRODUCT_SKU_TYPE = {
  PRODUCT_SKU: { color: null, label: true, value: 1 },
  MANUFACTURER_SKU: { color: null, label: true, value: 2 }
};
constants.WAREHOUSE_PICKING_PRODUCT_SKU_TYPE_PRODUCT_SKU = 1;
displayLookup['WAREHOUSE_PICKING_PRODUCT_SKU_TYPE.1'] = "product sku";
constants.WAREHOUSE_PICKING_PRODUCT_SKU_TYPE_MANUFACTURER_SKU = 2;
displayLookup['WAREHOUSE_PICKING_PRODUCT_SKU_TYPE.2'] = "manufacturer sku";

constants.WAREHOUSE_PICKING_RELATION_TYPE = {
  ORDER: { color: null, label: true, value: 1 },
  WAREHOUSE_OPERATION: { color: null, label: true, value: 2 },
  STOCK_TRANSFER: { color: null, label: true, value: 3 }
};
constants.WAREHOUSE_PICKING_RELATION_TYPE_ORDER = 1;
displayLookup['WAREHOUSE_PICKING_RELATION_TYPE.1'] = "order";
constants.WAREHOUSE_PICKING_RELATION_TYPE_WAREHOUSE_OPERATION = 2;
displayLookup['WAREHOUSE_PICKING_RELATION_TYPE.2'] = "warehouse operation";
constants.WAREHOUSE_PICKING_RELATION_TYPE_STOCK_TRANSFER = 3;
displayLookup['WAREHOUSE_PICKING_RELATION_TYPE.3'] = "stock transfer";

constants.WAREHOUSE_PICKING_TYPE = {
  BATCH: { color: null, label: true, value: 1 }
};
constants.WAREHOUSE_PICKING_TYPE_BATCH = 1;
displayLookup['WAREHOUSE_PICKING_TYPE.1'] = "batch";

constants.WAREHOUSE_TRAVERSAL_ORDER = {
  LOCATION: { color: null, label: true, value: 1 },
  PRODUCT_SKU: { color: null, label: true, value: 2 },
  PRODUCT_NAME: { color: null, label: true, value: 3 }
};
constants.WAREHOUSE_TRAVERSAL_ORDER_LOCATION = 1;
displayLookup['WAREHOUSE_TRAVERSAL_ORDER.1'] = "location";
constants.WAREHOUSE_TRAVERSAL_ORDER_PRODUCT_SKU = 2;
displayLookup['WAREHOUSE_TRAVERSAL_ORDER.2'] = "product sku";
constants.WAREHOUSE_TRAVERSAL_ORDER_PRODUCT_NAME = 3;
displayLookup['WAREHOUSE_TRAVERSAL_ORDER.3'] = "product name";

constants.WAREHOUSE_TYPE = {
  LOCAL: { color: null, label: true, value: 1 },
  SUPPLIER: { color: null, label: true, value: 2 },
  WASTE: { color: null, label: true, value: 3 },
  THIRD_PARTY_LOGISTICS: { color: null, label: "third-party logistics", value: 4 }
};
constants.WAREHOUSE_TYPE_LOCAL = 1;
displayLookup['WAREHOUSE_TYPE.1'] = "local";
constants.WAREHOUSE_TYPE_SUPPLIER = 2;
displayLookup['WAREHOUSE_TYPE.2'] = "supplier";
constants.WAREHOUSE_TYPE_WASTE = 3;
displayLookup['WAREHOUSE_TYPE.3'] = "waste";
constants.WAREHOUSE_TYPE_THIRD_PARTY_LOGISTICS = 4;
displayLookup['WAREHOUSE_TYPE.4'] = "third-party logistics";

constants.WEBSHOP_ENGINE = {
  WOO_COMMERCE: { color: null, label: "WooCommerce", value: 1 },
  SHOPRENTER: { color: null, label: true, value: 2 },
  UNAS: { color: null, label: true, value: 3 },
  MAGENTO: { color: null, label: true, value: 4 },
  EMAG: { color: null, label: true, value: 5 }
};
constants.WEBSHOP_ENGINE_WOO_COMMERCE = 1;
displayLookup['WEBSHOP_ENGINE.1'] = "WooCommerce";
constants.WEBSHOP_ENGINE_SHOPRENTER = 2;
displayLookup['WEBSHOP_ENGINE.2'] = "shoprenter";
constants.WEBSHOP_ENGINE_UNAS = 3;
displayLookup['WEBSHOP_ENGINE.3'] = "unas";
constants.WEBSHOP_ENGINE_MAGENTO = 4;
displayLookup['WEBSHOP_ENGINE.4'] = "magento";
constants.WEBSHOP_ENGINE_EMAG = 5;
displayLookup['WEBSHOP_ENGINE.5'] = "emag";

constants.WEBSHOP_ERP_MAPPING_TYPE = {
  SHIPPING_METHOD: { color: null, label: true, value: 1 },
  PAYMENT_METHOD: { color: null, label: true, value: 2 },
  ORDER_STATUS: { color: null, label: true, value: 3 }
};
constants.WEBSHOP_ERP_MAPPING_TYPE_SHIPPING_METHOD = 1;
displayLookup['WEBSHOP_ERP_MAPPING_TYPE.1'] = "shipping method";
constants.WEBSHOP_ERP_MAPPING_TYPE_PAYMENT_METHOD = 2;
displayLookup['WEBSHOP_ERP_MAPPING_TYPE.2'] = "payment method";
constants.WEBSHOP_ERP_MAPPING_TYPE_ORDER_STATUS = 3;
displayLookup['WEBSHOP_ERP_MAPPING_TYPE.3'] = "order status";

constants.WEBSHOP_HOOK_EVENT_TYPE = {
  CREATED: { color: null, label: true, value: 1 },
  ADMIN_CREATED: { color: null, label: true, value: 2 },
  THIRD_PARTY_CREATED: { color: null, label: true, value: 3 },
  UPDATED: { color: null, label: true, value: 4 },
  DELETED: { color: null, label: true, value: 5 },
  SUCCESFUL_PAYMENT: { color: null, label: true, value: 6 }
};
constants.WEBSHOP_HOOK_EVENT_TYPE_CREATED = 1;
displayLookup['WEBSHOP_HOOK_EVENT_TYPE.1'] = "created";
constants.WEBSHOP_HOOK_EVENT_TYPE_ADMIN_CREATED = 2;
displayLookup['WEBSHOP_HOOK_EVENT_TYPE.2'] = "admin created";
constants.WEBSHOP_HOOK_EVENT_TYPE_THIRD_PARTY_CREATED = 3;
displayLookup['WEBSHOP_HOOK_EVENT_TYPE.3'] = "third party created";
constants.WEBSHOP_HOOK_EVENT_TYPE_UPDATED = 4;
displayLookup['WEBSHOP_HOOK_EVENT_TYPE.4'] = "updated";
constants.WEBSHOP_HOOK_EVENT_TYPE_DELETED = 5;
displayLookup['WEBSHOP_HOOK_EVENT_TYPE.5'] = "deleted";
constants.WEBSHOP_HOOK_EVENT_TYPE_SUCCESFUL_PAYMENT = 6;
displayLookup['WEBSHOP_HOOK_EVENT_TYPE.6'] = "succesful payment";

constants.WEBSHOP_IDENTIFIER_UNIQUE_PART_POSITION = {
  PREFIX: { color: null, label: true, value: 1 },
  SUFFIX: { color: null, label: true, value: 2 }
};
constants.WEBSHOP_IDENTIFIER_UNIQUE_PART_POSITION_PREFIX = 1;
displayLookup['WEBSHOP_IDENTIFIER_UNIQUE_PART_POSITION.1'] = "prefix";
constants.WEBSHOP_IDENTIFIER_UNIQUE_PART_POSITION_SUFFIX = 2;
displayLookup['WEBSHOP_IDENTIFIER_UNIQUE_PART_POSITION.2'] = "suffix";

constants.WEBSHOP_ITEM_TYPE = {
  CATEGORY: { color: null, label: true, value: 1 },
  CATEGORY_DESCRIPTION: { color: null, label: true, value: 2 },
  PRODUCT_CLASS: { color: null, label: true, value: 9 },
  PRODUCT: { color: null, label: true, value: 10 },
  PRODUCT_VARIATION: { color: null, label: true, value: 11 },
  PRODUCT_ATTRIBUTE: { color: null, label: true, value: 12 },
  PRODUCT_ATTRIBUTE_TERM: { color: null, label: true, value: 13 },
  PRODUCT_ATTRIBUTE_TERM_DESCRIPTION: { color: null, label: true, value: 14 },
  PRODUCT_ATTRIBUTE_CLASS_RELATIONSHIP: { color: null, label: true, value: 15 },
  PRODUCT_ATTRIBUTE_RELATIONSHIP_OPTION: { color: null, label: true, value: 16 },
  PRODUCT_ATTRIBUTE_DESCRIPTION: { color: null, label: true, value: 17 },
  PRODUCT_IMAGE: { color: null, label: true, value: 18 },
  PRODUCT_CATEGORY_IMAGE: { color: null, label: "Category Image", value: 19 },
  IMAGE: { color: null, label: true, value: 20 },
  PRODUCT_DESCRIPTION: { color: null, label: true, value: 21 },
  PRODUCT_EXTEND: { color: null, label: true, value: 22 },
  PRODUCT_VARIATION_EXTEND: { color: null, label: true, value: 23 },
  PRODUCT_COMBINE: { color: null, label: "Unas Product Combine", value: 24 },
  PRODUCT_RELATED_PRODUCTS_UNAS: { color: null, label: "Unas Product Related Products", value: 25 },
  PRODUCT_SALE_PRICE: { color: null, label: true, value: 26 },
  PRODUCT_QUANTITY_DISCOUNTS_UNAS: { color: null, label: "Unas Product Quantity Discounts", value: 27 },
  PRODUCT_IMAGES_UNAS: { color: null, label: "Unas Product Images", value: 28 },
  PRODUCT_VARIATION_IMAGES_UNAS: { color: null, label: "Unas Product Variation Images", value: 29 },
  CUSTOMER_CLASS_RELATIONSHIP: { color: null, label: true, value: 30 },
  CUSTOMER_CLASS: { color: null, label: true, value: 31 },
  CUSTOMER_REVERSE: { color: null, label: true, value: 32 },
  CUSTOMER_CLASS_REVERSE: { color: null, label: true, value: 33 },
  CUSTOMER: { color: null, label: true, value: 34 },
  PRODUCT_ATTRIBUTE_REVERSE: { color: null, label: true, value: 35 },
  PRODUCT_CLASS_REVERSE: { color: null, label: true, value: 36 },
  PRODUCT_ATTRIBUTE_CLASS_RELATIONSHIP_REVERSE: { color: null, label: true, value: 37 },
  PRODUCT_EXTRA_SERVICE: { color: null, label: true, value: 38 },
  PRODUCT_EXTRA_SERVICE_REVERSE: { color: null, label: true, value: 39 },
  ORDER_STATUS: { color: null, label: true, value: 40 },
  ORDER_ITEM: { color: null, label: true, value: 41 },
  ORDER_SHIPPING_FEE: { color: null, label: true, value: 42 },
  ORDER_FEE: { color: null, label: true, value: 43 },
  ORDER_DISCOUNT_PERCENT: { color: null, label: true, value: 44 },
  ORDER_DISCOUNT_AMOUNT: { color: null, label: true, value: 45 },
  ORDER: { color: null, label: true, value: 46 },
  ORDER_REVERSE: { color: null, label: true, value: 49 },
  VAT: { color: null, label: true, value: 50 },
  BUNDLE_PRODUCT_CREATE: { color: null, label: true, value: 51 },
  BUNDLE_PRODUCT_UPDATE: { color: null, label: true, value: 52 },
  BUNDLE_PRODUCT_IMAGES_UNAS: { color: null, label: "Unas Bundle Product Images", value: 53 },
  BUNDLE_PRODUCT: { color: null, label: true, value: 54 },
  BUNDLE_PRODUCT_UPDATE_ELEMENTS: { color: null, label: true, value: 55 },
  CATEGORY_REVERSE: { color: null, label: true, value: 60 },
  PRODUCT_REVERSE: { color: null, label: true, value: 61 },
  PRODUCT_IMAGE_REVERSE: { color: null, label: "Image reverse", value: 62 },
  VAT_REVERSE: { color: null, label: true, value: 63 },
  PRODUCT_PRICES: { color: null, label: true, value: 64 },
  PRODUCT_VARIATION_PRICES: { color: null, label: true, value: 65 },
  BUNDLE_PRODUCT_PRICES: { color: null, label: true, value: 66 },
  MANUFACTURER: { color: null, label: true, value: 67 },
  MANUFACTURER_REVERSE: { color: null, label: true, value: 68 },
  PRODUCT_IMAGE_REVERSE_PRODUCT_IDS: { color: null, label: true, value: 69 },
  PRODUCT_VARIATION_STOCK: { color: null, label: true, value: 97 },
  PRODUCT_BUNDLE_STOCK: { color: null, label: true, value: 98 },
  PRODUCT_STOCK: { color: null, label: true, value: 99 },
  PRODUCT_STOCK_HEALTH: { color: null, label: true, value: 1000 },
  PRODUCT_STATUS_HEALTH: { color: null, label: true, value: 1001 },
  PRODUCT_PRICE_HEALTH: { color: null, label: true, value: 1003 },
  API_LOGIN: { color: null, label: true, value: 1002 },
  PRODUCT_DELETE_HEALTH: { color: null, label: true, value: 1004 },
  PRODUCT_SPECIAL_ATTRIBUTES: { color: null, label: true, value: 1005 },
  PRODUCT_VARIATION_SPECIAL_ATTRIBUTES: { color: null, label: true, value: 1006 },
  BUNDLE_PRODUCT_SPECIAL_ATTRIBUTES: { color: null, label: true, value: 1007 },
  TAX_CLASS: { color: null, label: true, value: 1010 },
  TAX_CLASS_REVERSE: { color: null, label: true, value: 1011 },
  TAX_RULE_REVERSE: { color: null, label: true, value: 1012 },
  PRODUCT_HOOK: { color: null, label: true, value: 1100 },
  PRODUCT_CATEGORY_HOOK: { color: null, label: true, value: 1101 },
  PRODUCT_ATTRIBUTE_HOOK: { color: null, label: true, value: 1102 },
  PRODUCT_ATTRIBUTE_TERM_HOOK: { color: null, label: true, value: 1103 },
  CUSTOMER_HOOK: { color: null, label: true, value: 1104 },
  ORDER_HOOK: { color: null, label: true, value: 1105 },
  WAREHOUSE: { color: null, label: true, value: 1106 },
  PRODUCT_VARIATION_STOCK_RECOVERY: { color: null, label: true, value: 1107 },
  PRODUCT_BUNDLE_STOCK_RECOVERY: { color: null, label: true, value: 1108 },
  PRODUCT_STOCK_RECOVERY: { color: null, label: true, value: 1109 },
  ORDER_STATUS_RECOVERY: { color: null, label: true, value: 1110 },
  ORDER_TYPE: { color: null, label: true, value: 1111 },
  ORDER_TYPE_REVERSE: { color: null, label: true, value: 1112 }
};
constants.WEBSHOP_ITEM_TYPE_CATEGORY = 1;
displayLookup['WEBSHOP_ITEM_TYPE.1'] = "category";
constants.WEBSHOP_ITEM_TYPE_CATEGORY_DESCRIPTION = 2;
displayLookup['WEBSHOP_ITEM_TYPE.2'] = "category description";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_CLASS = 9;
displayLookup['WEBSHOP_ITEM_TYPE.9'] = "product class";
constants.WEBSHOP_ITEM_TYPE_PRODUCT = 10;
displayLookup['WEBSHOP_ITEM_TYPE.10'] = "product";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_VARIATION = 11;
displayLookup['WEBSHOP_ITEM_TYPE.11'] = "product variation";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_ATTRIBUTE = 12;
displayLookup['WEBSHOP_ITEM_TYPE.12'] = "product attribute";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_ATTRIBUTE_TERM = 13;
displayLookup['WEBSHOP_ITEM_TYPE.13'] = "product attribute term";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_ATTRIBUTE_TERM_DESCRIPTION = 14;
displayLookup['WEBSHOP_ITEM_TYPE.14'] = "product attribute term description";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_ATTRIBUTE_CLASS_RELATIONSHIP = 15;
displayLookup['WEBSHOP_ITEM_TYPE.15'] = "product attribute class relationship";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_ATTRIBUTE_RELATIONSHIP_OPTION = 16;
displayLookup['WEBSHOP_ITEM_TYPE.16'] = "product attribute relationship option";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_ATTRIBUTE_DESCRIPTION = 17;
displayLookup['WEBSHOP_ITEM_TYPE.17'] = "product attribute description";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_IMAGE = 18;
displayLookup['WEBSHOP_ITEM_TYPE.18'] = "product image";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_CATEGORY_IMAGE = 19;
displayLookup['WEBSHOP_ITEM_TYPE.19'] = "Category Image";
constants.WEBSHOP_ITEM_TYPE_IMAGE = 20;
displayLookup['WEBSHOP_ITEM_TYPE.20'] = "image";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_DESCRIPTION = 21;
displayLookup['WEBSHOP_ITEM_TYPE.21'] = "product description";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_EXTEND = 22;
displayLookup['WEBSHOP_ITEM_TYPE.22'] = "product extend";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_VARIATION_EXTEND = 23;
displayLookup['WEBSHOP_ITEM_TYPE.23'] = "product variation extend";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_COMBINE = 24;
displayLookup['WEBSHOP_ITEM_TYPE.24'] = "Unas Product Combine";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_RELATED_PRODUCTS_UNAS = 25;
displayLookup['WEBSHOP_ITEM_TYPE.25'] = "Unas Product Related Products";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_SALE_PRICE = 26;
displayLookup['WEBSHOP_ITEM_TYPE.26'] = "product sale price";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_QUANTITY_DISCOUNTS_UNAS = 27;
displayLookup['WEBSHOP_ITEM_TYPE.27'] = "Unas Product Quantity Discounts";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_IMAGES_UNAS = 28;
displayLookup['WEBSHOP_ITEM_TYPE.28'] = "Unas Product Images";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_VARIATION_IMAGES_UNAS = 29;
displayLookup['WEBSHOP_ITEM_TYPE.29'] = "Unas Product Variation Images";
constants.WEBSHOP_ITEM_TYPE_CUSTOMER_CLASS_RELATIONSHIP = 30;
displayLookup['WEBSHOP_ITEM_TYPE.30'] = "customer class relationship";
constants.WEBSHOP_ITEM_TYPE_CUSTOMER_CLASS = 31;
displayLookup['WEBSHOP_ITEM_TYPE.31'] = "customer class";
constants.WEBSHOP_ITEM_TYPE_CUSTOMER_REVERSE = 32;
displayLookup['WEBSHOP_ITEM_TYPE.32'] = "customer reverse";
constants.WEBSHOP_ITEM_TYPE_CUSTOMER_CLASS_REVERSE = 33;
displayLookup['WEBSHOP_ITEM_TYPE.33'] = "customer class reverse";
constants.WEBSHOP_ITEM_TYPE_CUSTOMER = 34;
displayLookup['WEBSHOP_ITEM_TYPE.34'] = "customer";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_ATTRIBUTE_REVERSE = 35;
displayLookup['WEBSHOP_ITEM_TYPE.35'] = "product attribute reverse";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_CLASS_REVERSE = 36;
displayLookup['WEBSHOP_ITEM_TYPE.36'] = "product class reverse";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_ATTRIBUTE_CLASS_RELATIONSHIP_REVERSE = 37;
displayLookup['WEBSHOP_ITEM_TYPE.37'] = "product attribute class relationship reverse";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_EXTRA_SERVICE = 38;
displayLookup['WEBSHOP_ITEM_TYPE.38'] = "product extra service";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_EXTRA_SERVICE_REVERSE = 39;
displayLookup['WEBSHOP_ITEM_TYPE.39'] = "product extra service reverse";
constants.WEBSHOP_ITEM_TYPE_ORDER_STATUS = 40;
displayLookup['WEBSHOP_ITEM_TYPE.40'] = "order status";
constants.WEBSHOP_ITEM_TYPE_ORDER_ITEM = 41;
displayLookup['WEBSHOP_ITEM_TYPE.41'] = "order item";
constants.WEBSHOP_ITEM_TYPE_ORDER_SHIPPING_FEE = 42;
displayLookup['WEBSHOP_ITEM_TYPE.42'] = "order shipping fee";
constants.WEBSHOP_ITEM_TYPE_ORDER_FEE = 43;
displayLookup['WEBSHOP_ITEM_TYPE.43'] = "order fee";
constants.WEBSHOP_ITEM_TYPE_ORDER_DISCOUNT_PERCENT = 44;
displayLookup['WEBSHOP_ITEM_TYPE.44'] = "order discount percent";
constants.WEBSHOP_ITEM_TYPE_ORDER_DISCOUNT_AMOUNT = 45;
displayLookup['WEBSHOP_ITEM_TYPE.45'] = "order discount amount";
constants.WEBSHOP_ITEM_TYPE_ORDER = 46;
displayLookup['WEBSHOP_ITEM_TYPE.46'] = "order";
constants.WEBSHOP_ITEM_TYPE_ORDER_REVERSE = 49;
displayLookup['WEBSHOP_ITEM_TYPE.49'] = "order reverse";
constants.WEBSHOP_ITEM_TYPE_VAT = 50;
displayLookup['WEBSHOP_ITEM_TYPE.50'] = "vat";
constants.WEBSHOP_ITEM_TYPE_BUNDLE_PRODUCT_CREATE = 51;
displayLookup['WEBSHOP_ITEM_TYPE.51'] = "bundle product create";
constants.WEBSHOP_ITEM_TYPE_BUNDLE_PRODUCT_UPDATE = 52;
displayLookup['WEBSHOP_ITEM_TYPE.52'] = "bundle product update";
constants.WEBSHOP_ITEM_TYPE_BUNDLE_PRODUCT_IMAGES_UNAS = 53;
displayLookup['WEBSHOP_ITEM_TYPE.53'] = "Unas Bundle Product Images";
constants.WEBSHOP_ITEM_TYPE_BUNDLE_PRODUCT = 54;
displayLookup['WEBSHOP_ITEM_TYPE.54'] = "bundle product";
constants.WEBSHOP_ITEM_TYPE_BUNDLE_PRODUCT_UPDATE_ELEMENTS = 55;
displayLookup['WEBSHOP_ITEM_TYPE.55'] = "bundle product update elements";
constants.WEBSHOP_ITEM_TYPE_CATEGORY_REVERSE = 60;
displayLookup['WEBSHOP_ITEM_TYPE.60'] = "category reverse";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_REVERSE = 61;
displayLookup['WEBSHOP_ITEM_TYPE.61'] = "product reverse";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_IMAGE_REVERSE = 62;
displayLookup['WEBSHOP_ITEM_TYPE.62'] = "Image reverse";
constants.WEBSHOP_ITEM_TYPE_VAT_REVERSE = 63;
displayLookup['WEBSHOP_ITEM_TYPE.63'] = "vat reverse";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_PRICES = 64;
displayLookup['WEBSHOP_ITEM_TYPE.64'] = "product prices";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_VARIATION_PRICES = 65;
displayLookup['WEBSHOP_ITEM_TYPE.65'] = "product variation prices";
constants.WEBSHOP_ITEM_TYPE_BUNDLE_PRODUCT_PRICES = 66;
displayLookup['WEBSHOP_ITEM_TYPE.66'] = "bundle product prices";
constants.WEBSHOP_ITEM_TYPE_MANUFACTURER = 67;
displayLookup['WEBSHOP_ITEM_TYPE.67'] = "manufacturer";
constants.WEBSHOP_ITEM_TYPE_MANUFACTURER_REVERSE = 68;
displayLookup['WEBSHOP_ITEM_TYPE.68'] = "manufacturer reverse";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_IMAGE_REVERSE_PRODUCT_IDS = 69;
displayLookup['WEBSHOP_ITEM_TYPE.69'] = "product image reverse product ids";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_VARIATION_STOCK = 97;
displayLookup['WEBSHOP_ITEM_TYPE.97'] = "product variation stock";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_BUNDLE_STOCK = 98;
displayLookup['WEBSHOP_ITEM_TYPE.98'] = "product bundle stock";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_STOCK = 99;
displayLookup['WEBSHOP_ITEM_TYPE.99'] = "product stock";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_STOCK_HEALTH = 1000;
displayLookup['WEBSHOP_ITEM_TYPE.1000'] = "product stock health";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_STATUS_HEALTH = 1001;
displayLookup['WEBSHOP_ITEM_TYPE.1001'] = "product status health";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_PRICE_HEALTH = 1003;
displayLookup['WEBSHOP_ITEM_TYPE.1003'] = "product price health";
constants.WEBSHOP_ITEM_TYPE_API_LOGIN = 1002;
displayLookup['WEBSHOP_ITEM_TYPE.1002'] = "api login";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_DELETE_HEALTH = 1004;
displayLookup['WEBSHOP_ITEM_TYPE.1004'] = "product delete health";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_SPECIAL_ATTRIBUTES = 1005;
displayLookup['WEBSHOP_ITEM_TYPE.1005'] = "product special attributes";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_VARIATION_SPECIAL_ATTRIBUTES = 1006;
displayLookup['WEBSHOP_ITEM_TYPE.1006'] = "product variation special attributes";
constants.WEBSHOP_ITEM_TYPE_BUNDLE_PRODUCT_SPECIAL_ATTRIBUTES = 1007;
displayLookup['WEBSHOP_ITEM_TYPE.1007'] = "bundle product special attributes";
constants.WEBSHOP_ITEM_TYPE_TAX_CLASS = 1010;
displayLookup['WEBSHOP_ITEM_TYPE.1010'] = "tax class";
constants.WEBSHOP_ITEM_TYPE_TAX_CLASS_REVERSE = 1011;
displayLookup['WEBSHOP_ITEM_TYPE.1011'] = "tax class reverse";
constants.WEBSHOP_ITEM_TYPE_TAX_RULE_REVERSE = 1012;
displayLookup['WEBSHOP_ITEM_TYPE.1012'] = "tax rule reverse";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_HOOK = 1100;
displayLookup['WEBSHOP_ITEM_TYPE.1100'] = "product hook";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_CATEGORY_HOOK = 1101;
displayLookup['WEBSHOP_ITEM_TYPE.1101'] = "product category hook";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_ATTRIBUTE_HOOK = 1102;
displayLookup['WEBSHOP_ITEM_TYPE.1102'] = "product attribute hook";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_ATTRIBUTE_TERM_HOOK = 1103;
displayLookup['WEBSHOP_ITEM_TYPE.1103'] = "product attribute term hook";
constants.WEBSHOP_ITEM_TYPE_CUSTOMER_HOOK = 1104;
displayLookup['WEBSHOP_ITEM_TYPE.1104'] = "customer hook";
constants.WEBSHOP_ITEM_TYPE_ORDER_HOOK = 1105;
displayLookup['WEBSHOP_ITEM_TYPE.1105'] = "order hook";
constants.WEBSHOP_ITEM_TYPE_WAREHOUSE = 1106;
displayLookup['WEBSHOP_ITEM_TYPE.1106'] = "warehouse";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_VARIATION_STOCK_RECOVERY = 1107;
displayLookup['WEBSHOP_ITEM_TYPE.1107'] = "product variation stock recovery";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_BUNDLE_STOCK_RECOVERY = 1108;
displayLookup['WEBSHOP_ITEM_TYPE.1108'] = "product bundle stock recovery";
constants.WEBSHOP_ITEM_TYPE_PRODUCT_STOCK_RECOVERY = 1109;
displayLookup['WEBSHOP_ITEM_TYPE.1109'] = "product stock recovery";
constants.WEBSHOP_ITEM_TYPE_ORDER_STATUS_RECOVERY = 1110;
displayLookup['WEBSHOP_ITEM_TYPE.1110'] = "order status recovery";
constants.WEBSHOP_ITEM_TYPE_ORDER_TYPE = 1111;
displayLookup['WEBSHOP_ITEM_TYPE.1111'] = "order type";
constants.WEBSHOP_ITEM_TYPE_ORDER_TYPE_REVERSE = 1112;
displayLookup['WEBSHOP_ITEM_TYPE.1112'] = "order type reverse";

constants.WEBSHOP_LISTING_OPTIONS = {
  SHOPRENTER_PRODUCT_STATUS: { color: null, label: "status", value: 1 },
  SHOPRENTER_PRODUCT_ORDERABLE: { color: null, label: "orderable", value: 2 },
  WOOCOMMERCE_PRODUCT_STATUS: { color: null, label: "status", value: 3 },
  UNAS_PRODUCT_STATUS: { color: null, label: "status", value: 4 },
  UNAS_PRODUCT_EXPORT_STATUS: { color: null, label: "export status", value: 5 },
  UNAS_PRODUCT_EXPLICIT: { color: null, label: "explicit", value: 6 },
  UNAS_PRODUCT_NOLIST: { color: null, label: "do not list product", value: 7 },
  UNAS_PRODUCT_INQUIRE: { color: null, label: "inquiry", value: 8 },
  UNAS_PRODUCT_CUST_DISCOUNT_DISABLE: { color: null, label: "disable discount", value: 9 },
  UNAS_PRODUCT_NEGATIVE_STOCK_ALLOWED: { color: null, label: "negative stock allowed", value: 10 },
  MAGENTO_PRODUCT_STATUS: { color: null, label: "status", value: 11 },
  MAGENTO_PRODUCT_VISIBILITY: { color: null, label: "visibility", value: 12 },
  WOOCOMMERCE_PRODUCT_BACKORDERS_STATUS: { color: null, label: "status", value: 13 }
};
constants.WEBSHOP_LISTING_OPTIONS_SHOPRENTER_PRODUCT_STATUS = 1;
displayLookup['WEBSHOP_LISTING_OPTIONS.1'] = "status";
constants.WEBSHOP_LISTING_OPTIONS_SHOPRENTER_PRODUCT_ORDERABLE = 2;
displayLookup['WEBSHOP_LISTING_OPTIONS.2'] = "orderable";
constants.WEBSHOP_LISTING_OPTIONS_WOOCOMMERCE_PRODUCT_STATUS = 3;
displayLookup['WEBSHOP_LISTING_OPTIONS.3'] = "status";
constants.WEBSHOP_LISTING_OPTIONS_UNAS_PRODUCT_STATUS = 4;
displayLookup['WEBSHOP_LISTING_OPTIONS.4'] = "status";
constants.WEBSHOP_LISTING_OPTIONS_UNAS_PRODUCT_EXPORT_STATUS = 5;
displayLookup['WEBSHOP_LISTING_OPTIONS.5'] = "export status";
constants.WEBSHOP_LISTING_OPTIONS_UNAS_PRODUCT_EXPLICIT = 6;
displayLookup['WEBSHOP_LISTING_OPTIONS.6'] = "explicit";
constants.WEBSHOP_LISTING_OPTIONS_UNAS_PRODUCT_NOLIST = 7;
displayLookup['WEBSHOP_LISTING_OPTIONS.7'] = "do not list product";
constants.WEBSHOP_LISTING_OPTIONS_UNAS_PRODUCT_INQUIRE = 8;
displayLookup['WEBSHOP_LISTING_OPTIONS.8'] = "inquiry";
constants.WEBSHOP_LISTING_OPTIONS_UNAS_PRODUCT_CUST_DISCOUNT_DISABLE = 9;
displayLookup['WEBSHOP_LISTING_OPTIONS.9'] = "disable discount";
constants.WEBSHOP_LISTING_OPTIONS_UNAS_PRODUCT_NEGATIVE_STOCK_ALLOWED = 10;
displayLookup['WEBSHOP_LISTING_OPTIONS.10'] = "negative stock allowed";
constants.WEBSHOP_LISTING_OPTIONS_MAGENTO_PRODUCT_STATUS = 11;
displayLookup['WEBSHOP_LISTING_OPTIONS.11'] = "status";
constants.WEBSHOP_LISTING_OPTIONS_MAGENTO_PRODUCT_VISIBILITY = 12;
displayLookup['WEBSHOP_LISTING_OPTIONS.12'] = "visibility";
constants.WEBSHOP_LISTING_OPTIONS_WOOCOMMERCE_PRODUCT_BACKORDERS_STATUS = 13;
displayLookup['WEBSHOP_LISTING_OPTIONS.13'] = "status";

constants.WEBSHOP_STATUS = {
  INIT: { color: null, label: "initialising", value: 1 },
  FAILED_INIT: { color: null, label: "initialising failed", value: 2 },
  SYNCING: { color: null, label: true, value: 3 }
};
constants.WEBSHOP_STATUS_INIT = 1;
displayLookup['WEBSHOP_STATUS.1'] = "initialising";
constants.WEBSHOP_STATUS_FAILED_INIT = 2;
displayLookup['WEBSHOP_STATUS.2'] = "initialising failed";
constants.WEBSHOP_STATUS_SYNCING = 3;
displayLookup['WEBSHOP_STATUS.3'] = "syncing";

constants.WOOCOMMERCE_PRODUCT_BACKORDERS_STATUS = {
  YES: { color: null, label: true, value: "yes" },
  NOTIFY: { color: null, label: true, value: "notify" },
  NO: { color: null, label: true, value: "no" }
};
constants.WOOCOMMERCE_PRODUCT_BACKORDERS_STATUS_YES = "yes";
displayLookup['WOOCOMMERCE_PRODUCT_BACKORDERS_STATUS."yes"'] = "yes";
constants.WOOCOMMERCE_PRODUCT_BACKORDERS_STATUS_NOTIFY = "notify";
displayLookup['WOOCOMMERCE_PRODUCT_BACKORDERS_STATUS."notify"'] = "notify";
constants.WOOCOMMERCE_PRODUCT_BACKORDERS_STATUS_NO = "no";
displayLookup['WOOCOMMERCE_PRODUCT_BACKORDERS_STATUS."no"'] = "no";

constants.WOOCOMMERCE_PRODUCT_STATUS = {
  PUBLISH: { color: null, label: true, value: "publish" },
  DRAFT: { color: null, label: true, value: "draft" },
  PENDING: { color: null, label: true, value: "pending" },
  PRIVATE: { color: null, label: true, value: "private" }
};
constants.WOOCOMMERCE_PRODUCT_STATUS_PUBLISH = "publish";
displayLookup['WOOCOMMERCE_PRODUCT_STATUS."publish"'] = "publish";
constants.WOOCOMMERCE_PRODUCT_STATUS_DRAFT = "draft";
displayLookup['WOOCOMMERCE_PRODUCT_STATUS."draft"'] = "draft";
constants.WOOCOMMERCE_PRODUCT_STATUS_PENDING = "pending";
displayLookup['WOOCOMMERCE_PRODUCT_STATUS."pending"'] = "pending";
constants.WOOCOMMERCE_PRODUCT_STATUS_PRIVATE = "private";
displayLookup['WOOCOMMERCE_PRODUCT_STATUS."private"'] = "private";

constants.XYZ_CLASS = {
  X: { color: "#66bb6a", label: null, value: "X" },
  Y: { color: "#ffb74d", label: null, value: "Y" },
  Z: { color: "#e57373", label: null, value: "Z" }
};
constants.XYZ_CLASS_X = "X";
colorLookup['XYZ_CLASS."X"'] = "#66bb6a";
colorNameLookup['XYZ_CLASS."X"'] = "GREEN";
constants.XYZ_CLASS_Y = "Y";
colorLookup['XYZ_CLASS."Y"'] = "#ffb74d";
colorNameLookup['XYZ_CLASS."Y"'] = "YELLOW";
constants.XYZ_CLASS_Z = "Z";
colorLookup['XYZ_CLASS."Z"'] = "#e57373";
colorNameLookup['XYZ_CLASS."Z"'] = "RED";

constants.YEAR_SELECT = {
  Y2020: { color: null, label: "2020", value: 2020 },
  Y2021: { color: null, label: "2021", value: 2021 },
  Y2022: { color: null, label: "2022", value: 2022 },
  Y2023: { color: null, label: "2023", value: 2023 },
  Y2024: { color: null, label: "2024", value: 2024 },
  Y2025: { color: null, label: "2025", value: 2025 },
  Y2026: { color: null, label: "2026", value: 2026 },
  Y2027: { color: null, label: "2027", value: 2027 },
  Y2028: { color: null, label: "2028", value: 2028 },
  Y2029: { color: null, label: "2029", value: 2029 },
  Y2030: { color: null, label: "2030", value: 2030 },
  Y2031: { color: null, label: "2031", value: 2031 },
  Y2032: { color: null, label: "2032", value: 2032 },
  Y2033: { color: null, label: "2033", value: 2033 },
  Y2034: { color: null, label: "2034", value: 2034 },
  Y2035: { color: null, label: "2035", value: 2035 },
  Y2036: { color: null, label: "2036", value: 2036 },
  Y2037: { color: null, label: "2037", value: 2037 },
  Y2038: { color: null, label: "2038", value: 2038 },
  Y2040: { color: null, label: "2040", value: 2040 },
  Y2041: { color: null, label: "2041", value: 2041 },
  Y2042: { color: null, label: "2042", value: 2042 },
  Y2043: { color: null, label: "2043", value: 2043 },
  Y2044: { color: null, label: "2044", value: 2044 },
  Y2045: { color: null, label: "2045", value: 2045 },
  Y2046: { color: null, label: "2046", value: 2046 },
  Y2047: { color: null, label: "2047", value: 2047 },
  Y2048: { color: null, label: "2048", value: 2048 },
  Y2049: { color: null, label: "2049", value: 2049 }
};
constants.YEAR_SELECT_Y2020 = 2020;
displayLookup['YEAR_SELECT.2020'] = "2020";
constants.YEAR_SELECT_Y2021 = 2021;
displayLookup['YEAR_SELECT.2021'] = "2021";
constants.YEAR_SELECT_Y2022 = 2022;
displayLookup['YEAR_SELECT.2022'] = "2022";
constants.YEAR_SELECT_Y2023 = 2023;
displayLookup['YEAR_SELECT.2023'] = "2023";
constants.YEAR_SELECT_Y2024 = 2024;
displayLookup['YEAR_SELECT.2024'] = "2024";
constants.YEAR_SELECT_Y2025 = 2025;
displayLookup['YEAR_SELECT.2025'] = "2025";
constants.YEAR_SELECT_Y2026 = 2026;
displayLookup['YEAR_SELECT.2026'] = "2026";
constants.YEAR_SELECT_Y2027 = 2027;
displayLookup['YEAR_SELECT.2027'] = "2027";
constants.YEAR_SELECT_Y2028 = 2028;
displayLookup['YEAR_SELECT.2028'] = "2028";
constants.YEAR_SELECT_Y2029 = 2029;
displayLookup['YEAR_SELECT.2029'] = "2029";
constants.YEAR_SELECT_Y2030 = 2030;
displayLookup['YEAR_SELECT.2030'] = "2030";
constants.YEAR_SELECT_Y2031 = 2031;
displayLookup['YEAR_SELECT.2031'] = "2031";
constants.YEAR_SELECT_Y2032 = 2032;
displayLookup['YEAR_SELECT.2032'] = "2032";
constants.YEAR_SELECT_Y2033 = 2033;
displayLookup['YEAR_SELECT.2033'] = "2033";
constants.YEAR_SELECT_Y2034 = 2034;
displayLookup['YEAR_SELECT.2034'] = "2034";
constants.YEAR_SELECT_Y2035 = 2035;
displayLookup['YEAR_SELECT.2035'] = "2035";
constants.YEAR_SELECT_Y2036 = 2036;
displayLookup['YEAR_SELECT.2036'] = "2036";
constants.YEAR_SELECT_Y2037 = 2037;
displayLookup['YEAR_SELECT.2037'] = "2037";
constants.YEAR_SELECT_Y2038 = 2038;
displayLookup['YEAR_SELECT.2038'] = "2038";
constants.YEAR_SELECT_Y2040 = 2040;
displayLookup['YEAR_SELECT.2040'] = "2040";
constants.YEAR_SELECT_Y2041 = 2041;
displayLookup['YEAR_SELECT.2041'] = "2041";
constants.YEAR_SELECT_Y2042 = 2042;
displayLookup['YEAR_SELECT.2042'] = "2042";
constants.YEAR_SELECT_Y2043 = 2043;
displayLookup['YEAR_SELECT.2043'] = "2043";
constants.YEAR_SELECT_Y2044 = 2044;
displayLookup['YEAR_SELECT.2044'] = "2044";
constants.YEAR_SELECT_Y2045 = 2045;
displayLookup['YEAR_SELECT.2045'] = "2045";
constants.YEAR_SELECT_Y2046 = 2046;
displayLookup['YEAR_SELECT.2046'] = "2046";
constants.YEAR_SELECT_Y2047 = 2047;
displayLookup['YEAR_SELECT.2047'] = "2047";
constants.YEAR_SELECT_Y2048 = 2048;
displayLookup['YEAR_SELECT.2048'] = "2048";
constants.YEAR_SELECT_Y2049 = 2049;
displayLookup['YEAR_SELECT.2049'] = "2049";

